import _toArray from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _get2 from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _defineProperty from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _assertThisInitialized from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

var _Df, _Em, _Tm, _Bm;

var ef = Object.defineProperty,
    tf = Object.defineProperties;
var nf = Object.getOwnPropertyDescriptors;
var On = Object.getOwnPropertySymbols,
    rf = Object.getPrototypeOf,
    Lo = Object.prototype.hasOwnProperty,
    $o = Object.prototype.propertyIsEnumerable,
    sf = Reflect.get;

var Uo = Math.pow,
    _s = function _s(t, e, i) {
  return e in t ? ef(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : t[e] = i;
},
    O = function O(t, e) {
  for (var i in e || (e = {})) {
    Lo.call(e, i) && _s(t, i, e[i]);
  }

  if (On) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = On(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var i = _step.value;
        $o.call(e, i) && _s(t, i, e[i]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return t;
},
    $ = function $(t, e) {
  return tf(t, nf(e));
};

var An = function An(t, e) {
  var i = {};

  for (var n in t) {
    Lo.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
  }

  if (t != null && On) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = On(t)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var n = _step2.value;
        e.indexOf(n) < 0 && $o.call(t, n) && (i[n] = t[n]);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return i;
};

var s = function s(t, e, i) {
  return _s(t, typeof e != "symbol" ? e + "" : e, i), i;
};

var Wt = function Wt(t, e, i) {
  return sf(rf(t), i, e);
};

var u = function u(t, e, i) {
  return new Promise(function (n, r) {
    var a = function a(c) {
      try {
        l(i.next(c));
      } catch (d) {
        r(d);
      }
    },
        o = function o(c) {
      try {
        l(i.throw(c));
      } catch (d) {
        r(d);
      }
    },
        l = function l(c) {
      return c.done ? n(c.value) : Promise.resolve(c.value).then(a, o);
    };

    l((i = i.apply(t, e)).next());
  });
};

import * as ve from "react";
import Zt, { createContext as Rr, useState as K, useEffect as He, forwardRef as Pr, createElement as qi, useReducer as af, useRef as Te, isValidElement as _i, cloneElement as ea, useLayoutEffect as Oi, useContext as Lt, useCallback as ke, useMemo as mt, Component as of, Fragment as ta } from "react";
import lf, { unstable_batchedUpdates as cf, createPortal as uf } from "react-dom";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var zc = function zc(t) {
  var e = [];
  var i = 0;

  for (var n = 0; n < t.length; n++) {
    var r = t.charCodeAt(n);
    r < 128 ? e[i++] = r : r < 2048 ? (e[i++] = r >> 6 | 192, e[i++] = r & 63 | 128) : (r & 64512) === 55296 && n + 1 < t.length && (t.charCodeAt(n + 1) & 64512) === 56320 ? (r = 65536 + ((r & 1023) << 10) + (t.charCodeAt(++n) & 1023), e[i++] = r >> 18 | 240, e[i++] = r >> 12 & 63 | 128, e[i++] = r >> 6 & 63 | 128, e[i++] = r & 63 | 128) : (e[i++] = r >> 12 | 224, e[i++] = r >> 6 & 63 | 128, e[i++] = r & 63 | 128);
  }

  return e;
},
    df = function df(t) {
  var e = [];
  var i = 0,
      n = 0;

  for (; i < t.length;) {
    var r = t[i++];
    if (r < 128) e[n++] = String.fromCharCode(r);else if (r > 191 && r < 224) {
      var a = t[i++];
      e[n++] = String.fromCharCode((r & 31) << 6 | a & 63);
    } else if (r > 239 && r < 365) {
      var _a2 = t[i++],
          o = t[i++],
          l = t[i++],
          c = ((r & 7) << 18 | (_a2 & 63) << 12 | (o & 63) << 6 | l & 63) - 65536;
      e[n++] = String.fromCharCode(55296 + (c >> 10)), e[n++] = String.fromCharCode(56320 + (c & 1023));
    } else {
      var _a3 = t[i++],
          _o2 = t[i++];
      e[n++] = String.fromCharCode((r & 15) << 12 | (_a3 & 63) << 6 | _o2 & 63);
    }
  }

  return e.join("");
},
    qc = {
  byteToCharMap_: null,
  charToByteMap_: null,
  byteToCharMapWebSafe_: null,
  charToByteMapWebSafe_: null,
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",

  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },

  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },

  HAS_NATIVE_SUPPORT: typeof atob == "function",
  encodeByteArray: function encodeByteArray(t, e) {
    if (!Array.isArray(t)) throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    var i = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_,
        n = [];

    for (var r = 0; r < t.length; r += 3) {
      var a = t[r],
          o = r + 1 < t.length,
          l = o ? t[r + 1] : 0,
          c = r + 2 < t.length,
          d = c ? t[r + 2] : 0,
          h = a >> 2,
          p = (a & 3) << 4 | l >> 4;
      var g = (l & 15) << 2 | d >> 6,
          f = d & 63;
      c || (f = 64, o || (g = 64)), n.push(i[h], i[p], i[g], i[f]);
    }

    return n.join("");
  },
  encodeString: function encodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? btoa(t) : this.encodeByteArray(zc(t), e);
  },
  decodeString: function decodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? atob(t) : df(this.decodeStringToByteArray(t, e));
  },
  decodeStringToByteArray: function decodeStringToByteArray(t, e) {
    this.init_();
    var i = e ? this.charToByteMapWebSafe_ : this.charToByteMap_,
        n = [];

    for (var r = 0; r < t.length;) {
      var a = i[t.charAt(r++)],
          l = r < t.length ? i[t.charAt(r)] : 0;
      ++r;
      var d = r < t.length ? i[t.charAt(r)] : 64;
      ++r;
      var p = r < t.length ? i[t.charAt(r)] : 64;
      if (++r, a == null || l == null || d == null || p == null) throw new hf();
      var g = a << 2 | l >> 4;

      if (n.push(g), d !== 64) {
        var f = l << 4 & 240 | d >> 2;

        if (n.push(f), p !== 64) {
          var v = d << 6 & 192 | p;
          n.push(v);
        }
      }
    }

    return n;
  },
  init_: function init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};

      for (var t = 0; t < this.ENCODED_VALS.length; t++) {
        this.byteToCharMap_[t] = this.ENCODED_VALS.charAt(t), this.charToByteMap_[this.byteToCharMap_[t]] = t, this.byteToCharMapWebSafe_[t] = this.ENCODED_VALS_WEBSAFE.charAt(t), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[t]] = t, t >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(t)] = t, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(t)] = t);
      }
    }
  }
};

var hf =
/*#__PURE__*/
function (_Error) {
  _inherits(hf, _Error);

  function hf() {
    var _this;

    _classCallCheck(this, hf);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(hf).apply(this, arguments)), _this.name = "DecodeBase64StringError";
    return _this;
  }

  return hf;
}(_wrapNativeSuper(Error));

var pf = function pf(t) {
  var e = zc(t);
  return qc.encodeByteArray(e, !0);
},
    Qc = function Qc(t) {
  return pf(t).replace(/\./g, "");
},
    Yc = function Yc(t) {
  try {
    return qc.decodeString(t, !0);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }

  return null;
};

function ir(t, e) {
  if (!(e instanceof Object)) return e;

  switch (e.constructor) {
    case Date:
      var i = e;
      return new Date(i.getTime());

    case Object:
      t === void 0 && (t = {});
      break;

    case Array:
      t = [];
      break;

    default:
      return e;
  }

  for (var _i2 in e) {
    !e.hasOwnProperty(_i2) || !ff(_i2) || (t[_i2] = ir(t[_i2], e[_i2]));
  }

  return t;
}

function ff(t) {
  return t !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function mf() {
  if (typeof self != "undefined") return self;
  if (typeof window != "undefined") return window;
  if (typeof global != "undefined") return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var gf = function gf() {
  return mf().__FIREBASE_DEFAULTS__;
},
    yf = function yf() {
  if (typeof process == "undefined" || typeof process.env == "undefined") return;
  var t = process.env.__FIREBASE_DEFAULTS__;
  if (t) return JSON.parse(t);
},
    vf = function vf() {
  if (typeof document == "undefined") return;
  var t;

  try {
    t = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch (i) {
    return;
  }

  var e = t && Yc(t[1]);
  return e && JSON.parse(e);
},
    Or = function Or() {
  try {
    return gf() || yf() || vf();
  } catch (t) {
    console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(t));
    return;
  }
},
    wf = function wf(t) {
  var e, i;
  return (i = (e = Or()) === null || e === void 0 ? void 0 : e.emulatorHosts) === null || i === void 0 ? void 0 : i[t];
},
    Kc = function Kc() {
  var t;
  return (t = Or()) === null || t === void 0 ? void 0 : t.config;
},
    Jc = function Jc(t) {
  var e;
  return (e = Or()) === null || e === void 0 ? void 0 : e["_".concat(t)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var bf =
/*#__PURE__*/
function () {
  function bf() {
    var _this2 = this;

    _classCallCheck(this, bf);

    this.reject = function () {}, this.resolve = function () {}, this.promise = new Promise(function (e, i) {
      _this2.resolve = e, _this2.reject = i;
    });
  }

  _createClass(bf, [{
    key: "wrapCallback",
    value: function wrapCallback(e) {
      var _this3 = this;

      return function (i, n) {
        i ? _this3.reject(i) : _this3.resolve(n), typeof e == "function" && (_this3.promise.catch(function () {}), e.length === 1 ? e(i) : e(i, n));
      };
    }
  }]);

  return bf;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function we() {
  return typeof navigator != "undefined" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}

function If() {
  return typeof window != "undefined" && !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(we());
}

function Xc() {
  var t;
  var e = (t = Or()) === null || t === void 0 ? void 0 : t.forceEnvironment;
  if (e === "node") return !0;
  if (e === "browser") return !1;

  try {
    return Object.prototype.toString.call(global.process) === "[object process]";
  } catch (i) {
    return !1;
  }
}

function _f() {
  return typeof self == "object" && self.self === self;
}

function Zc() {
  var t = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof t == "object" && t.id !== void 0;
}

function Da() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}

function eu() {
  var t = we();
  return t.indexOf("MSIE ") >= 0 || t.indexOf("Trident/") >= 0;
}

function nr() {
  try {
    return typeof indexedDB == "object";
  } catch (t) {
    return !1;
  }
}

function Ef() {
  return new Promise(function (t, e) {
    try {
      var i = !0;
      var n = "validate-browser-context-for-indexeddb-analytics-module",
          r = self.indexedDB.open(n);
      r.onsuccess = function () {
        r.result.close(), i || self.indexedDB.deleteDatabase(n), t(!0);
      }, r.onupgradeneeded = function () {
        i = !1;
      }, r.onerror = function () {
        var a;
        e(((a = r.error) === null || a === void 0 ? void 0 : a.message) || "");
      };
    } catch (i) {
      e(i);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Cf = "FirebaseError";

var Ve =
/*#__PURE__*/
function (_Error2) {
  _inherits(Ve, _Error2);

  function Ve(e, i, n) {
    var _this4;

    _classCallCheck(this, Ve);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Ve).call(this, i)), _this4.code = e, _this4.customData = n, _this4.name = Cf, Object.setPrototypeOf(_assertThisInitialized(_this4), Ve.prototype), Error.captureStackTrace && Error.captureStackTrace(_assertThisInitialized(_this4), si.prototype.create);
    return _this4;
  }

  return Ve;
}(_wrapNativeSuper(Error));

var si =
/*#__PURE__*/
function () {
  function si(e, i, n) {
    _classCallCheck(this, si);

    this.service = e, this.serviceName = i, this.errors = n;
  }

  _createClass(si, [{
    key: "create",
    value: function create(e) {
      var n = (arguments.length <= 1 ? undefined : arguments[1]) || {},
          r = "".concat(this.service, "/").concat(e),
          a = this.errors[e],
          o = a ? Sf(a, n) : "Error",
          l = "".concat(this.serviceName, ": ").concat(o, " (").concat(r, ").");
      return new Ve(r, l, n);
    }
  }]);

  return si;
}();

function Sf(t, e) {
  return t.replace(Tf, function (i, n) {
    var r = e[n];
    return r != null ? String(r) : "<".concat(n, "?>");
  });
}

var Tf = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function Bo(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}

function Rf(t) {
  for (var e in t) {
    if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
  }

  return !0;
}

function rr(t, e) {
  if (t === e) return !0;
  var i = Object.keys(t),
      n = Object.keys(e);

  for (var _i4 = 0, _i3 = i; _i4 < _i3.length; _i4++) {
    var r = _i3[_i4];
    if (!n.includes(r)) return !1;
    var a = t[r],
        o = e[r];

    if (Ho(a) && Ho(o)) {
      if (!rr(a, o)) return !1;
    } else if (a !== o) return !1;
  }

  for (var _i5 = 0, _n2 = n; _i5 < _n2.length; _i5++) {
    var _r2 = _n2[_i5];
    if (!i.includes(_r2)) return !1;
  }

  return !0;
}

function Ho(t) {
  return t !== null && typeof t == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Ai(t) {
  var e = [];

  var _loop = function _loop() {
    var _ref = _Object$entries[_i6];
    _ref2 = _slicedToArray(_ref, 2);
    var i = _ref2[0];
    var n = _ref2[1];
    Array.isArray(n) ? n.forEach(function (r) {
      e.push(encodeURIComponent(i) + "=" + encodeURIComponent(r));
    }) : e.push(encodeURIComponent(i) + "=" + encodeURIComponent(n));
  };

  for (var _i6 = 0, _Object$entries = Object.entries(t); _i6 < _Object$entries.length; _i6++) {
    var _ref2;

    _loop();
  }

  return e.length ? "&" + e.join("&") : "";
}

function fi(t) {
  var e = {};
  return t.replace(/^\?/, "").split("&").forEach(function (n) {
    if (n) {
      var _n$split = n.split("="),
          _n$split2 = _slicedToArray(_n$split, 2),
          r = _n$split2[0],
          a = _n$split2[1];

      e[decodeURIComponent(r)] = decodeURIComponent(a);
    }
  }), e;
}

function Qi(t) {
  var e = t.indexOf("?");
  if (!e) return "";
  var i = t.indexOf("#", e);
  return t.substring(e, i > 0 ? i : void 0);
}

function tu(t, e) {
  var i = new Pf(t, e);
  return i.subscribe.bind(i);
}

var Pf =
/*#__PURE__*/
function () {
  function Pf(e, i) {
    var _this5 = this;

    _classCallCheck(this, Pf);

    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = i, this.task.then(function () {
      e(_this5);
    }).catch(function (n) {
      _this5.error(n);
    });
  }

  _createClass(Pf, [{
    key: "next",
    value: function next(e) {
      this.forEachObserver(function (i) {
        i.next(e);
      });
    }
  }, {
    key: "error",
    value: function error(e) {
      this.forEachObserver(function (i) {
        i.error(e);
      }), this.close(e);
    }
  }, {
    key: "complete",
    value: function complete() {
      this.forEachObserver(function (e) {
        e.complete();
      }), this.close();
    }
  }, {
    key: "subscribe",
    value: function subscribe(e, i, n) {
      var _this6 = this;

      var r;
      if (e === void 0 && i === void 0 && n === void 0) throw new Error("Missing Observer.");
      Of(e, ["next", "error", "complete"]) ? r = e : r = {
        next: e,
        error: i,
        complete: n
      }, r.next === void 0 && (r.next = Es), r.error === void 0 && (r.error = Es), r.complete === void 0 && (r.complete = Es);
      var a = this.unsubscribeOne.bind(this, this.observers.length);
      return this.finalized && this.task.then(function () {
        try {
          _this6.finalError ? r.error(_this6.finalError) : r.complete();
        } catch (o) {}
      }), this.observers.push(r), a;
    }
  }, {
    key: "unsubscribeOne",
    value: function unsubscribeOne(e) {
      this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(e) {
      if (!this.finalized) for (var i = 0; i < this.observers.length; i++) {
        this.sendOne(i, e);
      }
    }
  }, {
    key: "sendOne",
    value: function sendOne(e, i) {
      var _this7 = this;

      this.task.then(function () {
        if (_this7.observers !== void 0 && _this7.observers[e] !== void 0) try {
          i(_this7.observers[e]);
        } catch (n) {
          typeof console != "undefined" && console.error && console.error(n);
        }
      });
    }
  }, {
    key: "close",
    value: function close(e) {
      var _this8 = this;

      this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(function () {
        _this8.observers = void 0, _this8.onNoObservers = void 0;
      }));
    }
  }]);

  return Pf;
}();

function Of(t, e) {
  if (typeof t != "object" || t === null) return !1;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = e[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var i = _step3.value;
      if (i in t && typeof t[i] == "function") return !0;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return !1;
}

function Es() {}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function te(t) {
  return t && t._delegate ? t._delegate : t;
}

var $t =
/*#__PURE__*/
function () {
  function $t(e, i, n) {
    _classCallCheck(this, $t);

    this.name = e, this.instanceFactory = i, this.type = n, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }

  _createClass($t, [{
    key: "setInstantiationMode",
    value: function setInstantiationMode(e) {
      return this.instantiationMode = e, this;
    }
  }, {
    key: "setMultipleInstances",
    value: function setMultipleInstances(e) {
      return this.multipleInstances = e, this;
    }
  }, {
    key: "setServiceProps",
    value: function setServiceProps(e) {
      return this.serviceProps = e, this;
    }
  }, {
    key: "setInstanceCreatedCallback",
    value: function setInstanceCreatedCallback(e) {
      return this.onInstanceCreated = e, this;
    }
  }]);

  return $t;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Gt = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Af =
/*#__PURE__*/
function () {
  function Af(e, i) {
    _classCallCheck(this, Af);

    this.name = e, this.container = i, this.component = null, this.instances =
    /* @__PURE__ */
    new Map(), this.instancesDeferred =
    /* @__PURE__ */
    new Map(), this.instancesOptions =
    /* @__PURE__ */
    new Map(), this.onInitCallbacks =
    /* @__PURE__ */
    new Map();
  }

  _createClass(Af, [{
    key: "get",
    value: function get(e) {
      var i = this.normalizeInstanceIdentifier(e);

      if (!this.instancesDeferred.has(i)) {
        var n = new bf();
        if (this.instancesDeferred.set(i, n), this.isInitialized(i) || this.shouldAutoInitialize()) try {
          var r = this.getOrInitializeService({
            instanceIdentifier: i
          });
          r && n.resolve(r);
        } catch (r) {}
      }

      return this.instancesDeferred.get(i).promise;
    }
  }, {
    key: "getImmediate",
    value: function getImmediate(e) {
      var i;
      var n = this.normalizeInstanceIdentifier(e == null ? void 0 : e.identifier),
          r = (i = e == null ? void 0 : e.optional) !== null && i !== void 0 ? i : !1;
      if (this.isInitialized(n) || this.shouldAutoInitialize()) try {
        return this.getOrInitializeService({
          instanceIdentifier: n
        });
      } catch (a) {
        if (r) return null;
        throw a;
      } else {
        if (r) return null;
        throw Error("Service ".concat(this.name, " is not available"));
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }, {
    key: "setComponent",
    value: function setComponent(e) {
      if (e.name !== this.name) throw Error("Mismatching Component ".concat(e.name, " for Provider ").concat(this.name, "."));
      if (this.component) throw Error("Component for ".concat(this.name, " has already been provided"));

      if (this.component = e, !!this.shouldAutoInitialize()) {
        if (Ff(e)) try {
          this.getOrInitializeService({
            instanceIdentifier: Gt
          });
        } catch (i) {}
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = this.instancesDeferred.entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _ref5 = _step4.value;

            var _ref4 = _slicedToArray(_ref5, 2);

            var i = _ref4[0];
            var n = _ref4[1];
            var r = this.normalizeInstanceIdentifier(i);

            try {
              var a = this.getOrInitializeService({
                instanceIdentifier: r
              });
              n.resolve(a);
            } catch (a) {}
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    }
  }, {
    key: "clearInstance",
    value: function clearInstance() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Gt;
      this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
    }
  }, {
    key: "delete",
    value: function _delete() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var e;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e = Array.from(this.instances.values());
                _context.next = 3;
                return Promise.all([].concat(_toConsumableArray(e.filter(function (i) {
                  return "INTERNAL" in i;
                }).map(function (i) {
                  return i.INTERNAL.delete();
                })), _toConsumableArray(e.filter(function (i) {
                  return "_delete" in i;
                }).map(function (i) {
                  return i._delete();
                }))));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "isComponentSet",
    value: function isComponentSet() {
      return this.component != null;
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Gt;
      return this.instances.has(e);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Gt;
      return this.instancesOptions.get(e) || {};
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _e$options = e.options,
          i = _e$options === void 0 ? {} : _e$options,
          n = this.normalizeInstanceIdentifier(e.instanceIdentifier);
      if (this.isInitialized(n)) throw Error("".concat(this.name, "(").concat(n, ") has already been initialized"));
      if (!this.isComponentSet()) throw Error("Component ".concat(this.name, " has not been registered yet"));
      var r = this.getOrInitializeService({
        instanceIdentifier: n,
        options: i
      });
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.instancesDeferred.entries()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _ref8 = _step5.value;

          var _ref7 = _slicedToArray(_ref8, 2);

          var a = _ref7[0];
          var o = _ref7[1];
          var l = this.normalizeInstanceIdentifier(a);
          n === l && o.resolve(r);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return r;
    }
  }, {
    key: "onInit",
    value: function onInit(e, i) {
      var n;
      var r = this.normalizeInstanceIdentifier(i),
          a = (n = this.onInitCallbacks.get(r)) !== null && n !== void 0 ? n :
      /* @__PURE__ */
      new Set();
      a.add(e), this.onInitCallbacks.set(r, a);
      var o = this.instances.get(r);
      return o && e(o, r), function () {
        a.delete(e);
      };
    }
  }, {
    key: "invokeOnInitCallbacks",
    value: function invokeOnInitCallbacks(e, i) {
      var n = this.onInitCallbacks.get(i);

      if (!!n) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = n[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var r = _step6.value;

            try {
              r(e, i);
            } catch (a) {}
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }
    }
  }, {
    key: "getOrInitializeService",
    value: function getOrInitializeService(_ref9) {
      var e = _ref9.instanceIdentifier,
          _ref9$options = _ref9.options,
          i = _ref9$options === void 0 ? {} : _ref9$options;
      var n = this.instances.get(e);
      if (!n && this.component && (n = this.component.instanceFactory(this.container, {
        instanceIdentifier: Mf(e),
        options: i
      }), this.instances.set(e, n), this.instancesOptions.set(e, i), this.invokeOnInitCallbacks(n, e), this.component.onInstanceCreated)) try {
        this.component.onInstanceCreated(this.container, e, n);
      } catch (r) {}
      return n || null;
    }
  }, {
    key: "normalizeInstanceIdentifier",
    value: function normalizeInstanceIdentifier() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Gt;
      return this.component ? this.component.multipleInstances ? e : Gt : e;
    }
  }, {
    key: "shouldAutoInitialize",
    value: function shouldAutoInitialize() {
      return !!this.component && this.component.instantiationMode !== "EXPLICIT";
    }
  }]);

  return Af;
}();

function Mf(t) {
  return t === Gt ? void 0 : t;
}

function Ff(t) {
  return t.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var kf =
/*#__PURE__*/
function () {
  function kf(e) {
    _classCallCheck(this, kf);

    this.name = e, this.providers =
    /* @__PURE__ */
    new Map();
  }

  _createClass(kf, [{
    key: "addComponent",
    value: function addComponent(e) {
      var i = this.getProvider(e.name);
      if (i.isComponentSet()) throw new Error("Component ".concat(e.name, " has already been registered with ").concat(this.name));
      i.setComponent(e);
    }
  }, {
    key: "addOrOverwriteComponent",
    value: function addOrOverwriteComponent(e) {
      this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
    }
  }, {
    key: "getProvider",
    value: function getProvider(e) {
      if (this.providers.has(e)) return this.providers.get(e);
      var i = new Af(e, this);
      return this.providers.set(e, i), i;
    }
  }, {
    key: "getProviders",
    value: function getProviders() {
      return Array.from(this.providers.values());
    }
  }]);

  return kf;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Na = [];
var le;

(function (t) {
  t[t.DEBUG = 0] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT";
})(le || (le = {}));

var iu = {
  debug: le.DEBUG,
  verbose: le.VERBOSE,
  info: le.INFO,
  warn: le.WARN,
  error: le.ERROR,
  silent: le.SILENT
},
    xf = le.INFO,
    Df = (_Df = {}, _defineProperty(_Df, le.DEBUG, "log"), _defineProperty(_Df, le.VERBOSE, "log"), _defineProperty(_Df, le.INFO, "info"), _defineProperty(_Df, le.WARN, "warn"), _defineProperty(_Df, le.ERROR, "error"), _Df),
    Nf = function Nf(t, e) {
  var _console;

  if (e < t.logLevel) return;
  var n = new Date().toISOString(),
      r = Df[e];

  for (var _len = arguments.length, i = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    i[_key - 2] = arguments[_key];
  }

  if (r) (_console = console)[r].apply(_console, ["[".concat(n, "]  ").concat(t.name, ":")].concat(i));else throw new Error("Attempted to log a message with an invalid logType (value: ".concat(e, ")"));
};

var La =
/*#__PURE__*/
function () {
  function La(e) {
    _classCallCheck(this, La);

    this.name = e, this._logLevel = xf, this._logHandler = Nf, this._userLogHandler = null, Na.push(this);
  }

  _createClass(La, [{
    key: "setLogLevel",
    value: function setLogLevel(e) {
      this._logLevel = typeof e == "string" ? iu[e] : e;
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, le.DEBUG].concat(e)), this._logHandler.apply(this, [this, le.DEBUG].concat(e));
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        e[_key3] = arguments[_key3];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, le.VERBOSE].concat(e)), this._logHandler.apply(this, [this, le.VERBOSE].concat(e));
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, le.INFO].concat(e)), this._logHandler.apply(this, [this, le.INFO].concat(e));
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        e[_key5] = arguments[_key5];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, le.WARN].concat(e)), this._logHandler.apply(this, [this, le.WARN].concat(e));
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        e[_key6] = arguments[_key6];
      }

      this._userLogHandler && this._userLogHandler.apply(this, [this, le.ERROR].concat(e)), this._logHandler.apply(this, [this, le.ERROR].concat(e));
    }
  }, {
    key: "logLevel",
    get: function get() {
      return this._logLevel;
    },
    set: function set(e) {
      if (!(e in le)) throw new TypeError("Invalid value \"".concat(e, "\" assigned to `logLevel`"));
      this._logLevel = e;
    }
  }, {
    key: "logHandler",
    get: function get() {
      return this._logHandler;
    },
    set: function set(e) {
      if (typeof e != "function") throw new TypeError("Value assigned to `logHandler` must be a function");
      this._logHandler = e;
    }
  }, {
    key: "userLogHandler",
    get: function get() {
      return this._userLogHandler;
    },
    set: function set(e) {
      this._userLogHandler = e;
    }
  }]);

  return La;
}();

function Lf(t) {
  Na.forEach(function (e) {
    e.setLogLevel(t);
  });
}

function $f(t, e) {
  var _loop2 = function _loop2() {
    var i = _Na[_i7];
    var n = null;
    e && e.level && (n = iu[e.level]), t === null ? i.userLogHandler = null : i.userLogHandler = function (r, a) {
      for (var _len7 = arguments.length, o = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        o[_key7 - 2] = arguments[_key7];
      }

      var l = o.map(function (c) {
        if (c == null) return null;
        if (typeof c == "string") return c;
        if (typeof c == "number" || typeof c == "boolean") return c.toString();
        if (c instanceof Error) return c.message;

        try {
          return JSON.stringify(c);
        } catch (d) {
          return null;
        }
      }).filter(function (c) {
        return c;
      }).join(" ");
      a >= (n != null ? n : r.logLevel) && t({
        level: le[a].toLowerCase(),
        message: l,
        args: o,
        type: r.name
      });
    };
  };

  for (var _i7 = 0, _Na = Na; _i7 < _Na.length; _i7++) {
    _loop2();
  }
}

var Uf = function Uf(t, e) {
  return e.some(function (i) {
    return t instanceof i;
  });
};

var Vo, jo;

function Bf() {
  return Vo || (Vo = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}

function Hf() {
  return jo || (jo = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey]);
}

var nu =
/* @__PURE__ */
new WeakMap(),
    ia =
/* @__PURE__ */
new WeakMap(),
    ru =
/* @__PURE__ */
new WeakMap(),
    Cs =
/* @__PURE__ */
new WeakMap(),
    $a =
/* @__PURE__ */
new WeakMap();

function Vf(t) {
  var e = new Promise(function (i, n) {
    var r = function r() {
      t.removeEventListener("success", a), t.removeEventListener("error", o);
    },
        a = function a() {
      i(xt(t.result)), r();
    },
        o = function o() {
      n(t.error), r();
    };

    t.addEventListener("success", a), t.addEventListener("error", o);
  });
  return e.then(function (i) {
    i instanceof IDBCursor && nu.set(i, t);
  }).catch(function () {}), $a.set(e, t), e;
}

function jf(t) {
  if (ia.has(t)) return;
  var e = new Promise(function (i, n) {
    var r = function r() {
      t.removeEventListener("complete", a), t.removeEventListener("error", o), t.removeEventListener("abort", o);
    },
        a = function a() {
      i(), r();
    },
        o = function o() {
      n(t.error || new DOMException("AbortError", "AbortError")), r();
    };

    t.addEventListener("complete", a), t.addEventListener("error", o), t.addEventListener("abort", o);
  });
  ia.set(t, e);
}

var na = {
  get: function get(t, e, i) {
    if (t instanceof IDBTransaction) {
      if (e === "done") return ia.get(t);
      if (e === "objectStoreNames") return t.objectStoreNames || ru.get(t);
      if (e === "store") return i.objectStoreNames[1] ? void 0 : i.objectStore(i.objectStoreNames[0]);
    }

    return xt(t[e]);
  },
  set: function set(t, e, i) {
    return t[e] = i, !0;
  },
  has: function has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};

function Wf(t) {
  na = t(na);
}

function Gf(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function (e) {
    for (var _len8 = arguments.length, i = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
      i[_key8 - 1] = arguments[_key8];
    }

    var n = t.call.apply(t, [Ss(this), e].concat(i));
    return ru.set(n, e.sort ? e.sort() : [e]), xt(n);
  } : Hf().includes(t) ? function () {
    for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      e[_key9] = arguments[_key9];
    }

    return t.apply(Ss(this), e), xt(nu.get(this));
  } : function () {
    for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      e[_key10] = arguments[_key10];
    }

    return xt(t.apply(Ss(this), e));
  };
}

function zf(t) {
  return typeof t == "function" ? Gf(t) : (t instanceof IDBTransaction && jf(t), Uf(t, Bf()) ? new Proxy(t, na) : t);
}

function xt(t) {
  if (t instanceof IDBRequest) return Vf(t);
  if (Cs.has(t)) return Cs.get(t);
  var e = zf(t);
  return e !== t && (Cs.set(t, e), $a.set(e, t)), e;
}

var Ss = function Ss(t) {
  return $a.get(t);
};

function qf(t, e) {
  var _ref10 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      i = _ref10.blocked,
      n = _ref10.upgrade,
      r = _ref10.blocking,
      a = _ref10.terminated;

  var o = indexedDB.open(t, e),
      l = xt(o);
  return n && o.addEventListener("upgradeneeded", function (c) {
    n(xt(o.result), c.oldVersion, c.newVersion, xt(o.transaction), c);
  }), i && o.addEventListener("blocked", function (c) {
    return i(c.oldVersion, c.newVersion, c);
  }), l.then(function (c) {
    a && c.addEventListener("close", function () {
      return a();
    }), r && c.addEventListener("versionchange", function (d) {
      return r(d.oldVersion, d.newVersion, d);
    });
  }).catch(function () {}), l;
}

var Qf = ["get", "getKey", "getAll", "getAllKeys", "count"],
    Yf = ["put", "add", "delete", "clear"],
    Ts =
/* @__PURE__ */
new Map();

function Wo(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string")) return;
  if (Ts.get(e)) return Ts.get(e);
  var i = e.replace(/FromIndex$/, ""),
      n = e !== i,
      r = Yf.includes(i);
  if (!(i in (n ? IDBIndex : IDBObjectStore).prototype) || !(r || Qf.includes(i))) return;

  var a = function a(o) {
    for (var _len11 = arguments.length, l = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
      l[_key11 - 1] = arguments[_key11];
    }

    return u(this, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _d2;

      var c, d;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              c = this.transaction(o, r ? "readwrite" : "readonly");
              d = c.store;
              n && (d = d.index(l.shift()));
              _context2.next = 5;
              return Promise.all([(_d2 = d)[i].apply(_d2, l), r && c.done]);

            case 5:
              return _context2.abrupt("return", _context2.sent[0]);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };

  return Ts.set(e, a), a;
}

Wf(function (t) {
  return $(O({}, t), {
    get: function get(e, i, n) {
      return Wo(e, i) || t.get(e, i, n);
    },
    has: function has(e, i) {
      return !!Wo(e, i) || t.has(e, i);
    }
  });
});
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Kf =
/*#__PURE__*/
function () {
  function Kf(e) {
    _classCallCheck(this, Kf);

    this.container = e;
  }

  _createClass(Kf, [{
    key: "getPlatformInfoString",
    value: function getPlatformInfoString() {
      return this.container.getProviders().map(function (i) {
        if (Jf(i)) {
          var n = i.getImmediate();
          return "".concat(n.library, "/").concat(n.version);
        } else return null;
      }).filter(function (i) {
        return i;
      }).join(" ");
    }
  }]);

  return Kf;
}();

function Jf(t) {
  var e = t.getComponent();
  return (e == null ? void 0 : e.type) === "VERSION";
}

var ra = "@firebase/app",
    Go = "0.9.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var ei = new La("@firebase/app"),
    Xf = "@firebase/app-compat",
    Zf = "@firebase/analytics-compat",
    em = "@firebase/analytics",
    tm = "@firebase/app-check-compat",
    im = "@firebase/app-check",
    nm = "@firebase/auth",
    rm = "@firebase/auth-compat",
    sm = "@firebase/database",
    am = "@firebase/database-compat",
    om = "@firebase/functions",
    lm = "@firebase/functions-compat",
    cm = "@firebase/installations",
    um = "@firebase/installations-compat",
    dm = "@firebase/messaging",
    hm = "@firebase/messaging-compat",
    pm = "@firebase/performance",
    fm = "@firebase/performance-compat",
    mm = "@firebase/remote-config",
    gm = "@firebase/remote-config-compat",
    ym = "@firebase/storage",
    vm = "@firebase/storage-compat",
    wm = "@firebase/firestore",
    bm = "@firebase/firestore-compat",
    Im = "firebase",
    _m = "9.23.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Ut = "[DEFAULT]",
    Em = (_Em = {}, _defineProperty(_Em, ra, "fire-core"), _defineProperty(_Em, Xf, "fire-core-compat"), _defineProperty(_Em, em, "fire-analytics"), _defineProperty(_Em, Zf, "fire-analytics-compat"), _defineProperty(_Em, im, "fire-app-check"), _defineProperty(_Em, tm, "fire-app-check-compat"), _defineProperty(_Em, nm, "fire-auth"), _defineProperty(_Em, rm, "fire-auth-compat"), _defineProperty(_Em, sm, "fire-rtdb"), _defineProperty(_Em, am, "fire-rtdb-compat"), _defineProperty(_Em, om, "fire-fn"), _defineProperty(_Em, lm, "fire-fn-compat"), _defineProperty(_Em, cm, "fire-iid"), _defineProperty(_Em, um, "fire-iid-compat"), _defineProperty(_Em, dm, "fire-fcm"), _defineProperty(_Em, hm, "fire-fcm-compat"), _defineProperty(_Em, pm, "fire-perf"), _defineProperty(_Em, fm, "fire-perf-compat"), _defineProperty(_Em, mm, "fire-rc"), _defineProperty(_Em, gm, "fire-rc-compat"), _defineProperty(_Em, ym, "fire-gcs"), _defineProperty(_Em, vm, "fire-gcs-compat"), _defineProperty(_Em, wm, "fire-fst"), _defineProperty(_Em, bm, "fire-fst-compat"), _defineProperty(_Em, "fire-js", "fire-js"), _defineProperty(_Em, Im, "fire-js-all"), _Em);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Bt =
/* @__PURE__ */
new Map(),
    on =
/* @__PURE__ */
new Map();

function sr(t, e) {
  try {
    t.container.addComponent(e);
  } catch (i) {
    ei.debug("Component ".concat(e.name, " failed to register with FirebaseApp ").concat(t.name), i);
  }
}

function su(t, e) {
  t.container.addOrOverwriteComponent(e);
}

function ti(t) {
  var e = t.name;
  if (on.has(e)) return ei.debug("There were multiple attempts to register component ".concat(e, ".")), !1;
  on.set(e, t);
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = Bt.values()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var i = _step7.value;
      sr(i, t);
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return !0;
}

function Ar(t, e) {
  var i = t.container.getProvider("heartbeat").getImmediate({
    optional: !0
  });
  return i && i.triggerHeartbeat(), t.container.getProvider(e);
}

function Cm(t, e) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Ut;
  Ar(t, e).clearInstance(i);
}

function Sm() {
  on.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Tm = (_Tm = {}, _defineProperty(_Tm, "no-app", "No Firebase App '{$appName}' has been created - call initializeApp() first"), _defineProperty(_Tm, "bad-app-name", "Illegal App name: '{$appName}"), _defineProperty(_Tm, "duplicate-app", "Firebase App named '{$appName}' already exists with different options or config"), _defineProperty(_Tm, "app-deleted", "Firebase App named '{$appName}' already deleted"), _defineProperty(_Tm, "no-options", "Need to provide options, when not being deployed to hosting via source."), _defineProperty(_Tm, "invalid-app-argument", "firebase.{$appName}() takes either no argument or a Firebase App instance."), _defineProperty(_Tm, "invalid-log-argument", "First argument to `onLog` must be null or a function."), _defineProperty(_Tm, "idb-open", "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}."), _defineProperty(_Tm, "idb-get", "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}."), _defineProperty(_Tm, "idb-set", "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}."), _defineProperty(_Tm, "idb-delete", "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."), _Tm),
    wt = new si("app", "Firebase", Tm);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Rm =
/*#__PURE__*/
function () {
  function Rm(e, i, n) {
    var _this9 = this;

    _classCallCheck(this, Rm);

    this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, i), this._name = i.name, this._automaticDataCollectionEnabled = i.automaticDataCollectionEnabled, this._container = n, this.container.addComponent(new $t("app", function () {
      return _this9;
    }, "PUBLIC"));
  }

  _createClass(Rm, [{
    key: "checkDestroyed",
    value: function checkDestroyed() {
      if (this.isDeleted) throw wt.create("app-deleted", {
        appName: this._name
      });
    }
  }, {
    key: "automaticDataCollectionEnabled",
    get: function get() {
      return this.checkDestroyed(), this._automaticDataCollectionEnabled;
    },
    set: function set(e) {
      this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
    }
  }, {
    key: "name",
    get: function get() {
      return this.checkDestroyed(), this._name;
    }
  }, {
    key: "options",
    get: function get() {
      return this.checkDestroyed(), this._options;
    }
  }, {
    key: "config",
    get: function get() {
      return this.checkDestroyed(), this._config;
    }
  }, {
    key: "container",
    get: function get() {
      return this._container;
    }
  }, {
    key: "isDeleted",
    get: function get() {
      return this._isDeleted;
    },
    set: function set(e) {
      this._isDeleted = e;
    }
  }]);

  return Rm;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ai = _m;

function Ua(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i = t;
  typeof e != "object" && (e = {
    name: e
  });
  var n = Object.assign({
    name: Ut,
    automaticDataCollectionEnabled: !1
  }, e),
      r = n.name;
  if (typeof r != "string" || !r) throw wt.create("bad-app-name", {
    appName: String(r)
  });
  if (i || (i = Kc()), !i) throw wt.create("no-options");
  var a = Bt.get(r);

  if (a) {
    if (rr(i, a.options) && rr(n, a.config)) return a;
    throw wt.create("duplicate-app", {
      appName: r
    });
  }

  var o = new kf(r);
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = on.values()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var c = _step8.value;
      o.addComponent(c);
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  var l = new Rm(i, n, o);
  return Bt.set(r, l), l;
}

function au() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Ut;
  var e = Bt.get(t);
  if (!e && t === Ut && Kc()) return Ua();
  if (!e) throw wt.create("no-app", {
    appName: t
  });
  return e;
}

function Pm() {
  return Array.from(Bt.values());
}

function ou(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var e;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            e = t.name;
            _context3.t0 = Bt.has(e);

            if (!_context3.t0) {
              _context3.next = 7;
              break;
            }

            Bt.delete(e);
            _context3.next = 6;
            return Promise.all(t.container.getProviders().map(function (i) {
              return i.delete();
            }));

          case 6:
            t.isDeleted = !0;

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

function Dt(t, e, i) {
  var n;
  var r = (n = Em[t]) !== null && n !== void 0 ? n : t;
  i && (r += "-".concat(i));
  var a = r.match(/\s|\//),
      o = e.match(/\s|\//);

  if (a || o) {
    var l = ["Unable to register library \"".concat(r, "\" with version \"").concat(e, "\":")];
    a && l.push("library name \"".concat(r, "\" contains illegal characters (whitespace or \"/\")")), a && o && l.push("and"), o && l.push("version name \"".concat(e, "\" contains illegal characters (whitespace or \"/\")")), ei.warn(l.join(" "));
    return;
  }

  ti(new $t("".concat(r, "-version"), function () {
    return {
      library: r,
      version: e
    };
  }, "VERSION"));
}

function lu(t, e) {
  if (t !== null && typeof t != "function") throw wt.create("invalid-log-argument");
  $f(t, e);
}

function cu(t) {
  Lf(t);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Om = "firebase-heartbeat-database",
    Am = 1,
    ln = "firebase-heartbeat-store";
var Rs = null;

function uu() {
  return Rs || (Rs = qf(Om, Am, {
    upgrade: function upgrade(t, e) {
      switch (e) {
        case 0:
          t.createObjectStore(ln);
      }
    }
  }).catch(function (t) {
    throw wt.create("idb-open", {
      originalErrorMessage: t.message
    });
  })), Rs;
}

function Mm(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var i;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return uu();

          case 3:
            _context4.t0 = ln;
            _context4.t1 = ln;
            _context4.t2 = du(t);
            _context4.next = 8;
            return _context4.sent.transaction(_context4.t0).objectStore(_context4.t1).get(_context4.t2);

          case 8:
            return _context4.abrupt("return", _context4.sent);

          case 11:
            _context4.prev = 11;
            _context4.t3 = _context4["catch"](0);
            if (_context4.t3 instanceof Ve) ei.warn(_context4.t3.message);else {
              i = wt.create("idb-get", {
                originalErrorMessage: _context4.t3 == null ? void 0 : _context4.t3.message
              });
              ei.warn(i.message);
            }

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 11]]);
  }));
}

function zo(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var n, _n3;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return uu();

          case 3:
            _context5.t0 = ln;
            n = _context5.sent.transaction(_context5.t0, "readwrite");
            _context5.next = 7;
            return n.objectStore(ln).put(e, du(t));

          case 7:
            _context5.next = 9;
            return n.done;

          case 9:
            _context5.next = 14;
            break;

          case 11:
            _context5.prev = 11;
            _context5.t1 = _context5["catch"](0);
            if (_context5.t1 instanceof Ve) ei.warn(_context5.t1.message);else {
              _n3 = wt.create("idb-set", {
                originalErrorMessage: _context5.t1 == null ? void 0 : _context5.t1.message
              });
              ei.warn(_n3.message);
            }

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 11]]);
  }));
}

function du(t) {
  return "".concat(t.name, "!").concat(t.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Fm = 1024,
    km = 30 * 24 * 60 * 60 * 1e3;

var xm =
/*#__PURE__*/
function () {
  function xm(e) {
    var _this10 = this;

    _classCallCheck(this, xm);

    this.container = e, this._heartbeatsCache = null;
    var i = this.container.getProvider("app").getImmediate();
    this._storage = new Nm(i), this._heartbeatsCachePromise = this._storage.read().then(function (n) {
      return _this10._heartbeatsCache = n, n;
    });
  }

  _createClass(xm, [{
    key: "triggerHeartbeat",
    value: function triggerHeartbeat() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var i, n;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                i = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), n = qo();
                _context6.t0 = this._heartbeatsCache === null;

                if (!_context6.t0) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 5;
                return this._heartbeatsCachePromise;

              case 5:
                this._heartbeatsCache = _context6.sent;

              case 6:
                if (this._heartbeatsCache.lastSentHeartbeatDate === n || this._heartbeatsCache.heartbeats.some(function (r) {
                  return r.date === n;
                })) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", (this._heartbeatsCache.heartbeats.push({
                  date: n,
                  agent: i
                }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(function (r) {
                  var a = new Date(r.date).valueOf();
                  return Date.now() - a <= km;
                }), this._storage.overwrite(this._heartbeatsCache)));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getHeartbeatsHeader",
    value: function getHeartbeatsHeader() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var e, _Dm, i, n, r;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.t0 = this._heartbeatsCache === null;

                if (!_context7.t0) {
                  _context7.next = 4;
                  break;
                }

                _context7.next = 4;
                return this._heartbeatsCachePromise;

              case 4:
                if (!(this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0)) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt("return", "");

              case 6:
                e = qo(), _Dm = Dm(this._heartbeatsCache.heartbeats), i = _Dm.heartbeatsToSend, n = _Dm.unsentEntries, r = Qc(JSON.stringify({
                  version: 2,
                  heartbeats: i
                }));
                this._heartbeatsCache.lastSentHeartbeatDate = e;

                if (!(n.length > 0)) {
                  _context7.next = 14;
                  break;
                }

                this._heartbeatsCache.heartbeats = n;
                _context7.next = 12;
                return this._storage.overwrite(this._heartbeatsCache);

              case 12:
                _context7.next = 15;
                break;

              case 14:
                this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache);

              case 15:
                return _context7.abrupt("return", r);

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }]);

  return xm;
}();

function qo() {
  return new Date().toISOString().substring(0, 10);
}

function Dm(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Fm;
  var i = [];
  var n = t.slice();
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    var _loop3 = function _loop3() {
      var r = _step9.value;
      var a = i.find(function (o) {
        return o.agent === r.agent;
      });

      if (a) {
        if (a.dates.push(r.date), Qo(i) > e) {
          a.dates.pop();
          return "break";
        }
      } else if (i.push({
        agent: r.agent,
        dates: [r.date]
      }), Qo(i) > e) {
        i.pop();
        return "break";
      }

      n = n.slice(1);
    };

    for (var _iterator9 = t[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var _ret = _loop3();

      if (_ret === "break") break;
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  return {
    heartbeatsToSend: i,
    unsentEntries: n
  };
}

var Nm =
/*#__PURE__*/
function () {
  function Nm(e) {
    _classCallCheck(this, Nm);

    this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }

  _createClass(Nm, [{
    key: "runIndexedDBEnvironmentCheck",
    value: function runIndexedDBEnvironmentCheck() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", nr() ? Ef().then(function () {
                  return !0;
                }).catch(function () {
                  return !1;
                }) : !1);

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }, {
    key: "read",
    value: function read() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                if (!_context9.sent) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 5;
                return Mm(this.app);

              case 5:
                _context9.t1 = _context9.sent;

                if (_context9.t1) {
                  _context9.next = 8;
                  break;
                }

                _context9.t1 = {
                  heartbeats: []
                };

              case 8:
                _context9.t0 = _context9.t1;
                _context9.next = 12;
                break;

              case 11:
                _context9.t0 = {
                  heartbeats: []
                };

              case 12:
                return _context9.abrupt("return", _context9.t0);

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "overwrite",
    value: function overwrite(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var i, r;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                if (!_context10.sent) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 5;
                return this.read();

              case 5:
                r = _context10.sent;
                return _context10.abrupt("return", zo(this.app, {
                  lastSentHeartbeatDate: (i = e.lastSentHeartbeatDate) !== null && i !== void 0 ? i : r.lastSentHeartbeatDate,
                  heartbeats: e.heartbeats
                }));

              case 9:
                return _context10.abrupt("return");

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "add",
    value: function add(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var i, r;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._canUseIndexedDBPromise;

              case 2:
                if (!_context11.sent) {
                  _context11.next = 9;
                  break;
                }

                _context11.next = 5;
                return this.read();

              case 5:
                r = _context11.sent;
                return _context11.abrupt("return", zo(this.app, {
                  lastSentHeartbeatDate: (i = e.lastSentHeartbeatDate) !== null && i !== void 0 ? i : r.lastSentHeartbeatDate,
                  heartbeats: [].concat(_toConsumableArray(r.heartbeats), _toConsumableArray(e.heartbeats))
                }));

              case 9:
                return _context11.abrupt("return");

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }]);

  return Nm;
}();

function Qo(t) {
  return Qc(JSON.stringify({
    version: 2,
    heartbeats: t
  })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Lm(t) {
  ti(new $t("platform-logger", function (e) {
    return new Kf(e);
  }, "PRIVATE")), ti(new $t("heartbeat", function (e) {
    return new xm(e);
  }, "PRIVATE")), Dt(ra, Go, t), Dt(ra, Go, "esm2017"), Dt("fire-js", "");
}

Lm("");
var $m =
/* @__PURE__ */
Object.freeze(
/* @__PURE__ */
Object.defineProperty({
  __proto__: null,
  SDK_VERSION: ai,
  _DEFAULT_ENTRY_NAME: Ut,
  _addComponent: sr,
  _addOrOverwriteComponent: su,
  _apps: Bt,
  _clearComponents: Sm,
  _components: on,
  _getProvider: Ar,
  _registerComponent: ti,
  _removeServiceInstance: Cm,
  deleteApp: ou,
  getApp: au,
  getApps: Pm,
  initializeApp: Ua,
  onLog: lu,
  registerVersion: Dt,
  setLogLevel: cu,
  FirebaseError: Ve
}, Symbol.toStringTag, {
  value: "Module"
}));
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Um =
/*#__PURE__*/
function () {
  function Um(e, i) {
    var _this11 = this;

    _classCallCheck(this, Um);

    this._delegate = e, this.firebase = i, sr(e, new $t("app-compat", function () {
      return _this11;
    }, "PUBLIC")), this.container = e.container;
  }

  _createClass(Um, [{
    key: "delete",
    value: function _delete() {
      var _this12 = this;

      return new Promise(function (e) {
        _this12._delegate.checkDestroyed(), e();
      }).then(function () {
        return _this12.firebase.INTERNAL.removeApp(_this12.name), ou(_this12._delegate);
      });
    }
  }, {
    key: "_getService",
    value: function _getService(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Ut;
      var n;

      this._delegate.checkDestroyed();

      var r = this._delegate.container.getProvider(e);

      return !r.isInitialized() && ((n = r.getComponent()) === null || n === void 0 ? void 0 : n.instantiationMode) === "EXPLICIT" && r.initialize(), r.getImmediate({
        identifier: i
      });
    }
  }, {
    key: "_removeServiceInstance",
    value: function _removeServiceInstance(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Ut;

      this._delegate.container.getProvider(e).clearInstance(i);
    }
  }, {
    key: "_addComponent",
    value: function _addComponent(e) {
      sr(this._delegate, e);
    }
  }, {
    key: "_addOrOverwriteComponent",
    value: function _addOrOverwriteComponent(e) {
      su(this._delegate, e);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        automaticDataCollectionEnabled: this.automaticDataCollectionEnabled,
        options: this.options
      };
    }
  }, {
    key: "automaticDataCollectionEnabled",
    get: function get() {
      return this._delegate.automaticDataCollectionEnabled;
    },
    set: function set(e) {
      this._delegate.automaticDataCollectionEnabled = e;
    }
  }, {
    key: "name",
    get: function get() {
      return this._delegate.name;
    }
  }, {
    key: "options",
    get: function get() {
      return this._delegate.options;
    }
  }]);

  return Um;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Bm = (_Bm = {}, _defineProperty(_Bm, "no-app", "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()"), _defineProperty(_Bm, "invalid-app-argument", "firebase.{$appName}() takes either no argument or a Firebase App instance."), _Bm),
    Yo = new si("app-compat", "Firebase", Bm);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function Hm(t) {
  var e = {},
      i = {
    __esModule: !0,
    initializeApp: a,
    app: r,
    registerVersion: Dt,
    setLogLevel: cu,
    onLog: lu,
    apps: null,
    SDK_VERSION: ai,
    INTERNAL: {
      registerComponent: l,
      removeApp: n,
      useAsService: c,
      modularAPIs: $m
    }
  };
  i.default = i, Object.defineProperty(i, "apps", {
    get: o
  });

  function n(d) {
    delete e[d];
  }

  function r(d) {
    if (d = d || Ut, !Bo(e, d)) throw Yo.create("no-app", {
      appName: d
    });
    return e[d];
  }

  r.App = t;

  function a(d) {
    var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var p = Ua(d, h);
    if (Bo(e, p.name)) return e[p.name];
    var g = new t(p, i);
    return e[p.name] = g, g;
  }

  function o() {
    return Object.keys(e).map(function (d) {
      return e[d];
    });
  }

  function l(d) {
    var h = d.name,
        p = h.replace("-compat", "");

    if (ti(d) && d.type === "PUBLIC") {
      var g = function g() {
        var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : r();
        if (typeof f[p] != "function") throw Yo.create("invalid-app-argument", {
          appName: h
        });
        return f[p]();
      };

      d.serviceProps !== void 0 && ir(g, d.serviceProps), i[p] = g, t.prototype[p] = function () {
        for (var _len12 = arguments.length, f = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          f[_key12] = arguments[_key12];
        }

        return this._getService.bind(this, h).apply(this, d.multipleInstances ? f : []);
      };
    }

    return d.type === "PUBLIC" ? i[p] : null;
  }

  function c(d, h) {
    return h === "serverAuth" ? null : h;
  }

  return i;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function hu() {
  var t = Hm(Um);
  t.INTERNAL = Object.assign(Object.assign({}, t.INTERNAL), {
    createFirebaseNamespace: hu,
    extendNamespace: e,
    createSubscribe: tu,
    ErrorFactory: si,
    deepExtend: ir
  });

  function e(i) {
    ir(t, i);
  }

  return t;
}

var Vm = hu();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Ko = new La("@firebase/app-compat"),
    jm = "@firebase/app-compat",
    Wm = "0.2.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function Gm(t) {
  Dt(jm, Wm, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


if (_f() && self.firebase !== void 0) {
  Ko.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
  var t = self.firebase.SDK_VERSION;
  t && t.indexOf("LITE") >= 0 && Ko.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
}

var gt = Vm;
Gm();
var zm = "firebase",
    qm = "9.23.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

gt.registerVersion(zm, qm, "app-compat");

function Ba(t, e) {
  var i = {};

  for (var n in t) {
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
  }

  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var r = 0, n = Object.getOwnPropertySymbols(t); r < n.length; r++) {
    e.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[r]) && (i[n[r]] = t[n[r]]);
  }
  return i;
}

var Bi = {
  FACEBOOK: "facebook.com",
  GITHUB: "github.com",
  GOOGLE: "google.com",
  PASSWORD: "password",
  PHONE: "phone",
  TWITTER: "twitter.com"
},
    ui = {
  EMAIL_SIGNIN: "EMAIL_SIGNIN",
  PASSWORD_RESET: "PASSWORD_RESET",
  RECOVER_EMAIL: "RECOVER_EMAIL",
  REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
  VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
  VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function Qm() {
  var _ref11;

  return _ref11 = {}, _defineProperty(_ref11, "admin-restricted-operation", "This operation is restricted to administrators only."), _defineProperty(_ref11, "argument-error", ""), _defineProperty(_ref11, "app-not-authorized", "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console."), _defineProperty(_ref11, "app-not-installed", "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device."), _defineProperty(_ref11, "captcha-check-failed", "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains."), _defineProperty(_ref11, "code-expired", "The SMS code has expired. Please re-send the verification code to try again."), _defineProperty(_ref11, "cordova-not-ready", "Cordova framework is not ready."), _defineProperty(_ref11, "cors-unsupported", "This browser is not supported."), _defineProperty(_ref11, "credential-already-in-use", "This credential is already associated with a different user account."), _defineProperty(_ref11, "custom-token-mismatch", "The custom token corresponds to a different audience."), _defineProperty(_ref11, "requires-recent-login", "This operation is sensitive and requires recent authentication. Log in again before retrying this request."), _defineProperty(_ref11, "dependent-sdk-initialized-before-auth", "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."), _defineProperty(_ref11, "dynamic-link-not-activated", "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions."), _defineProperty(_ref11, "email-change-needs-verification", "Multi-factor users must always have a verified email."), _defineProperty(_ref11, "email-already-in-use", "The email address is already in use by another account."), _defineProperty(_ref11, "emulator-config-failed", 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.'), _defineProperty(_ref11, "expired-action-code", "The action code has expired."), _defineProperty(_ref11, "cancelled-popup-request", "This operation has been cancelled due to another conflicting popup being opened."), _defineProperty(_ref11, "internal-error", "An internal AuthError has occurred."), _defineProperty(_ref11, "invalid-app-credential", "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired."), _defineProperty(_ref11, "invalid-app-id", "The mobile app identifier is not registed for the current project."), _defineProperty(_ref11, "invalid-user-token", "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key."), _defineProperty(_ref11, "invalid-auth-event", "An internal AuthError has occurred."), _defineProperty(_ref11, "invalid-verification-code", "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user."), _defineProperty(_ref11, "invalid-continue-uri", "The continue URL provided in the request is invalid."), _defineProperty(_ref11, "invalid-cordova-configuration", "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme."), _defineProperty(_ref11, "invalid-custom-token", "The custom token format is incorrect. Please check the documentation."), _defineProperty(_ref11, "invalid-dynamic-link-domain", "The provided dynamic link domain is not configured or authorized for the current project."), _defineProperty(_ref11, "invalid-email", "The email address is badly formatted."), _defineProperty(_ref11, "invalid-emulator-scheme", "Emulator URL must start with a valid scheme (http:// or https://)."), _defineProperty(_ref11, "invalid-api-key", "Your API key is invalid, please check you have copied it correctly."), _defineProperty(_ref11, "invalid-cert-hash", "The SHA-1 certificate hash provided is invalid."), _defineProperty(_ref11, "invalid-credential", "The supplied auth credential is malformed or has expired."), _defineProperty(_ref11, "invalid-message-payload", "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console."), _defineProperty(_ref11, "invalid-multi-factor-session", "The request does not contain a valid proof of first factor successful sign-in."), _defineProperty(_ref11, "invalid-oauth-provider", "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers."), _defineProperty(_ref11, "invalid-oauth-client-id", "The OAuth client ID provided is either invalid or does not match the specified API key."), _defineProperty(_ref11, "unauthorized-domain", "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console."), _defineProperty(_ref11, "invalid-action-code", "The action code is invalid. This can happen if the code is malformed, expired, or has already been used."), _defineProperty(_ref11, "wrong-password", "The password is invalid or the user does not have a password."), _defineProperty(_ref11, "invalid-persistence-type", "The specified persistence type is invalid. It can only be local, session or none."), _defineProperty(_ref11, "invalid-phone-number", "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code]."), _defineProperty(_ref11, "invalid-provider-id", "The specified provider ID is invalid."), _defineProperty(_ref11, "invalid-recipient-email", "The email corresponding to this action failed to send as the provided recipient email address is invalid."), _defineProperty(_ref11, "invalid-sender", "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console."), _defineProperty(_ref11, "invalid-verification-id", "The verification ID used to create the phone auth credential is invalid."), _defineProperty(_ref11, "invalid-tenant-id", "The Auth instance's tenant ID is invalid."), _defineProperty(_ref11, "login-blocked", "Login blocked by user-provided method: {$originalMessage}"), _defineProperty(_ref11, "missing-android-pkg-name", "An Android Package Name must be provided if the Android App is required to be installed."), _defineProperty(_ref11, "auth-domain-config-required", "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console."), _defineProperty(_ref11, "missing-app-credential", "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided."), _defineProperty(_ref11, "missing-verification-code", "The phone auth credential was created with an empty SMS verification code."), _defineProperty(_ref11, "missing-continue-uri", "A continue URL must be provided in the request."), _defineProperty(_ref11, "missing-iframe-start", "An internal AuthError has occurred."), _defineProperty(_ref11, "missing-ios-bundle-id", "An iOS Bundle ID must be provided if an App Store ID is provided."), _defineProperty(_ref11, "missing-or-invalid-nonce", "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload."), _defineProperty(_ref11, "missing-password", "A non-empty password must be provided"), _defineProperty(_ref11, "missing-multi-factor-info", "No second factor identifier is provided."), _defineProperty(_ref11, "missing-multi-factor-session", "The request is missing proof of first factor successful sign-in."), _defineProperty(_ref11, "missing-phone-number", "To send verification codes, provide a phone number for the recipient."), _defineProperty(_ref11, "missing-verification-id", "The phone auth credential was created with an empty verification ID."), _defineProperty(_ref11, "app-deleted", "This instance of FirebaseApp has been deleted."), _defineProperty(_ref11, "multi-factor-info-not-found", "The user does not have a second factor matching the identifier provided."), _defineProperty(_ref11, "multi-factor-auth-required", "Proof of ownership of a second factor is required to complete sign-in."), _defineProperty(_ref11, "account-exists-with-different-credential", "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address."), _defineProperty(_ref11, "network-request-failed", "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred."), _defineProperty(_ref11, "no-auth-event", "An internal AuthError has occurred."), _defineProperty(_ref11, "no-such-provider", "User was not linked to an account with the given provider."), _defineProperty(_ref11, "null-user", "A null user object was provided as the argument for an operation which requires a non-null user object."), _defineProperty(_ref11, "operation-not-allowed", "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section."), _defineProperty(_ref11, "operation-not-supported-in-this-environment", 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.'), _defineProperty(_ref11, "popup-blocked", "Unable to establish a connection with the popup. It may have been blocked by the browser."), _defineProperty(_ref11, "popup-closed-by-user", "The popup has been closed by the user before finalizing the operation."), _defineProperty(_ref11, "provider-already-linked", "User can only be linked to one identity for the given provider."), _defineProperty(_ref11, "quota-exceeded", "The project's quota for this operation has been exceeded."), _defineProperty(_ref11, "redirect-cancelled-by-user", "The redirect operation has been cancelled by the user before finalizing."), _defineProperty(_ref11, "redirect-operation-pending", "A redirect sign-in operation is already pending."), _defineProperty(_ref11, "rejected-credential", "The request contains malformed or mismatching credentials."), _defineProperty(_ref11, "second-factor-already-in-use", "The second factor is already enrolled on this account."), _defineProperty(_ref11, "maximum-second-factor-count-exceeded", "The maximum allowed number of second factors on a user has been exceeded."), _defineProperty(_ref11, "tenant-id-mismatch", "The provided tenant ID does not match the Auth instance's tenant ID"), _defineProperty(_ref11, "timeout", "The operation has timed out."), _defineProperty(_ref11, "user-token-expired", "The user's credential is no longer valid. The user must sign in again."), _defineProperty(_ref11, "too-many-requests", "We have blocked all requests from this device due to unusual activity. Try again later."), _defineProperty(_ref11, "unauthorized-continue-uri", "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console."), _defineProperty(_ref11, "unsupported-first-factor", "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor."), _defineProperty(_ref11, "unsupported-persistence-type", "The current environment does not support the specified persistence type."), _defineProperty(_ref11, "unsupported-tenant-operation", "This operation is not supported in a multi-tenant context."), _defineProperty(_ref11, "unverified-email", "The operation requires a verified email."), _defineProperty(_ref11, "user-cancelled", "The user did not grant your application the permissions it requested."), _defineProperty(_ref11, "user-not-found", "There is no user record corresponding to this identifier. The user may have been deleted."), _defineProperty(_ref11, "user-disabled", "The user account has been disabled by an administrator."), _defineProperty(_ref11, "user-mismatch", "The supplied credentials do not correspond to the previously signed in user."), _defineProperty(_ref11, "user-signed-out", ""), _defineProperty(_ref11, "weak-password", "The password must be 6 characters long or more."), _defineProperty(_ref11, "web-storage-unsupported", "This browser is not supported or 3rd party cookies and data may be disabled."), _defineProperty(_ref11, "already-initialized", "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."), _defineProperty(_ref11, "missing-recaptcha-token", "The reCAPTCHA token is missing when sending request to the backend."), _defineProperty(_ref11, "invalid-recaptcha-token", "The reCAPTCHA token is invalid when sending request to the backend."), _defineProperty(_ref11, "invalid-recaptcha-action", "The reCAPTCHA action is invalid when sending request to the backend."), _defineProperty(_ref11, "recaptcha-not-enabled", "reCAPTCHA Enterprise integration is not enabled for this project."), _defineProperty(_ref11, "missing-client-type", "The reCAPTCHA client type is missing when sending request to the backend."), _defineProperty(_ref11, "missing-recaptcha-version", "The reCAPTCHA version is missing when sending request to the backend."), _defineProperty(_ref11, "invalid-req-type", "Invalid request parameters."), _defineProperty(_ref11, "invalid-recaptcha-version", "The reCAPTCHA version is invalid when sending request to the backend."), _ref11;
}

function pu() {
  return _defineProperty({}, "dependent-sdk-initialized-before-auth", "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.");
}

var Ym = Qm,
    Km = pu,
    fu = new si("auth", "Firebase", pu());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var ar = new La("@firebase/auth");

function Jm(t) {
  for (var _len13 = arguments.length, e = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
    e[_key13 - 1] = arguments[_key13];
  }

  ar.logLevel <= le.WARN && ar.warn.apply(ar, ["Auth (".concat(ai, "): ").concat(t)].concat(e));
}

function Vn(t) {
  for (var _len14 = arguments.length, e = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
    e[_key14 - 1] = arguments[_key14];
  }

  ar.logLevel <= le.ERROR && ar.error.apply(ar, ["Auth (".concat(ai, "): ").concat(t)].concat(e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Ae(t) {
  for (var _len15 = arguments.length, e = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
    e[_key15 - 1] = arguments[_key15];
  }

  throw Ha.apply(void 0, [t].concat(e));
}

function xe(t) {
  for (var _len16 = arguments.length, e = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
    e[_key16 - 1] = arguments[_key16];
  }

  return Ha.apply(void 0, [t].concat(e));
}

function mu(t, e, i) {
  var n = Object.assign(Object.assign({}, Km()), _defineProperty({}, e, i));
  return new si("auth", "Firebase", n).create(e, {
    appName: t.name
  });
}

function Mi(t, e, i) {
  var n = i;
  if (!(e instanceof n)) throw n.name !== e.constructor.name && Ae(t, "argument-error"), mu(t, "argument-error", "Type of ".concat(e.constructor.name, " does not match expected instance.Did you pass a reference from a different Auth SDK?"));
}

function Ha(t) {
  for (var _len17 = arguments.length, e = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
    e[_key17 - 1] = arguments[_key17];
  }

  if (typeof t != "string") {
    var _t$_errorFactory;

    var i = e[0],
        n = _toConsumableArray(e.slice(1));

    return n[0] && (n[0].appName = t.name), (_t$_errorFactory = t._errorFactory).create.apply(_t$_errorFactory, [i].concat(_toConsumableArray(n)));
  }

  return fu.create.apply(fu, [t].concat(e));
}

function B(t, e) {
  for (var _len18 = arguments.length, i = new Array(_len18 > 2 ? _len18 - 2 : 0), _key18 = 2; _key18 < _len18; _key18++) {
    i[_key18 - 2] = arguments[_key18];
  }

  if (!t) throw Ha.apply(void 0, [e].concat(i));
}

function dt(t) {
  var e = "INTERNAL ASSERTION FAILED: " + t;
  throw Vn(e), new Error(e);
}

function it(t, e) {
  t || dt(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function cn() {
  var t;
  return typeof self != "undefined" && ((t = self.location) === null || t === void 0 ? void 0 : t.href) || "";
}

function Va() {
  return Jo() === "http:" || Jo() === "https:";
}

function Jo() {
  var t;
  return typeof self != "undefined" && ((t = self.location) === null || t === void 0 ? void 0 : t.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Xm() {
  return typeof navigator != "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && (Va() || Zc() || "connection" in navigator) ? navigator.onLine : !0;
}

function Zm() {
  if (typeof navigator == "undefined") return null;
  var t = navigator;
  return t.languages && t.languages[0] || t.language || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var yn =
/*#__PURE__*/
function () {
  function yn(e, i) {
    _classCallCheck(this, yn);

    this.shortDelay = e, this.longDelay = i, it(i > e, "Short delay should be less than long delay!"), this.isMobile = If() || Da();
  }

  _createClass(yn, [{
    key: "get",
    value: function get() {
      return Xm() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
    }
  }]);

  return yn;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ja(t, e) {
  it(t.emulator, "Emulator should always be set here");
  var i = t.emulator.url;
  return e ? "".concat(i).concat(e.startsWith("/") ? e.slice(1) : e) : i;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var gu =
/*#__PURE__*/
function () {
  function gu() {
    _classCallCheck(this, gu);
  }

  _createClass(gu, null, [{
    key: "initialize",
    value: function initialize(e, i, n) {
      this.fetchImpl = e, i && (this.headersImpl = i), n && (this.responseImpl = n);
    }
  }, {
    key: "fetch",
    value: function fetch() {
      if (this.fetchImpl) return this.fetchImpl;
      if (typeof self != "undefined" && "fetch" in self) return self.fetch;
      dt("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
  }, {
    key: "headers",
    value: function headers() {
      if (this.headersImpl) return this.headersImpl;
      if (typeof self != "undefined" && "Headers" in self) return self.Headers;
      dt("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
  }, {
    key: "response",
    value: function response() {
      if (this.responseImpl) return this.responseImpl;
      if (typeof self != "undefined" && "Response" in self) return self.Response;
      dt("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
  }]);

  return gu;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var eg = {
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  MISSING_CUSTOM_TOKEN: "internal-error",
  INVALID_IDENTIFIER: "invalid-email",
  MISSING_CONTINUE_URI: "internal-error",
  INVALID_PASSWORD: "wrong-password",
  MISSING_PASSWORD: "missing-password",
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  MISSING_REQ_TYPE: "internal-error",
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  MISSING_OOB_CODE: "internal-error",
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
  RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
  MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
  INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
  INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
  MISSING_CLIENT_TYPE: "missing-client-type",
  MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
  INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
  INVALID_REQ_TYPE: "invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var tg = new yn(3e4, 6e4);

function be(t, e) {
  return t.tenantId && !e.tenantId ? Object.assign(Object.assign({}, e), {
    tenantId: t.tenantId
  }) : e;
}

function Re(a, o, l, c) {
  return u(this, arguments,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee13(t, e, i, n) {
    var _this13 = this;

    var r,
        _args13 = arguments;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            r = _args13.length > 4 && _args13[4] !== undefined ? _args13[4] : {};
            return _context13.abrupt("return", yu(t, r, function () {
              return u(_this13, null,
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee12() {
                var d, h, p, g;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        d = {}, h = {};
                        n && (e === "GET" ? h = n : d = {
                          body: JSON.stringify(n)
                        });
                        p = Ai(Object.assign({
                          key: t.config.apiKey
                        }, h)).slice(1);
                        _context12.next = 5;
                        return t._getAdditionalHeaders();

                      case 5:
                        g = _context12.sent;
                        return _context12.abrupt("return", (g["Content-Type"] = "application/json", t.languageCode && (g["X-Firebase-Locale"] = t.languageCode), gu.fetch()(vu(t, t.config.apiHost, i, p), Object.assign({
                          method: e,
                          headers: g,
                          referrerPolicy: "no-referrer"
                        }, d))));

                      case 7:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12);
              }));
            }));

          case 2:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
}

function yu(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee14() {
    var n, r, a, o, l, _l$split, _l$split2, c, d, h;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            t._canInitEmulator = !1;
            n = Object.assign(Object.assign({}, eg), e);
            _context14.prev = 2;
            r = new ig(t);
            _context14.next = 6;
            return Promise.race([i(), r.promise]);

          case 6:
            a = _context14.sent;
            r.clearNetworkTimeout();
            _context14.next = 10;
            return a.json();

          case 10:
            o = _context14.sent;

            if (!("needConfirmation" in o)) {
              _context14.next = 13;
              break;
            }

            throw Yi(t, "account-exists-with-different-credential", o);

          case 13:
            if (!(a.ok && !("errorMessage" in o))) {
              _context14.next = 15;
              break;
            }

            return _context14.abrupt("return", o);

          case 15:
            l = a.ok ? o.errorMessage : o.error.message, _l$split = l.split(" : "), _l$split2 = _slicedToArray(_l$split, 2), c = _l$split2[0], d = _l$split2[1];

            if (!(c === "FEDERATED_USER_ID_ALREADY_LINKED")) {
              _context14.next = 18;
              break;
            }

            throw Yi(t, "credential-already-in-use", o);

          case 18:
            if (!(c === "EMAIL_EXISTS")) {
              _context14.next = 20;
              break;
            }

            throw Yi(t, "email-already-in-use", o);

          case 20:
            if (!(c === "USER_DISABLED")) {
              _context14.next = 22;
              break;
            }

            throw Yi(t, "user-disabled", o);

          case 22:
            h = n[c] || c.toLowerCase().replace(/[_\s]+/g, "-");

            if (!d) {
              _context14.next = 25;
              break;
            }

            throw mu(t, h, d);

          case 25:
            Ae(t, h);
            _context14.next = 33;
            break;

          case 28:
            _context14.prev = 28;
            _context14.t0 = _context14["catch"](2);

            if (!(_context14.t0 instanceof Ve)) {
              _context14.next = 32;
              break;
            }

            throw _context14.t0;

          case 32:
            Ae(t, "network-request-failed", {
              message: String(_context14.t0)
            });

          case 33:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[2, 28]]);
  }));
}

function _t(a, o, l, c) {
  return u(this, arguments,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee15(t, e, i, n) {
    var r,
        d,
        _args15 = arguments;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            r = _args15.length > 4 && _args15[4] !== undefined ? _args15[4] : {};
            _context15.next = 3;
            return Re(t, e, i, n, r);

          case 3:
            d = _context15.sent;
            return _context15.abrupt("return", ("mfaPendingCredential" in d && Ae(t, "multi-factor-auth-required", {
              _serverResponse: d
            }), d));

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
}

function vu(t, e, i, n) {
  var r = "".concat(e).concat(i, "?").concat(n);
  return t.config.emulator ? ja(t.config, r) : "".concat(t.config.apiScheme, "://").concat(r);
}

var ig =
/*#__PURE__*/
function () {
  function ig(e) {
    var _this14 = this;

    _classCallCheck(this, ig);

    this.auth = e, this.timer = null, this.promise = new Promise(function (i, n) {
      _this14.timer = setTimeout(function () {
        return n(xe(_this14.auth, "network-request-failed"));
      }, tg.get());
    });
  }

  _createClass(ig, [{
    key: "clearNetworkTimeout",
    value: function clearNetworkTimeout() {
      clearTimeout(this.timer);
    }
  }]);

  return ig;
}();

function Yi(t, e, i) {
  var n = {
    appName: t.name
  };
  i.email && (n.email = i.email), i.phoneNumber && (n.phoneNumber = i.phoneNumber);
  var r = xe(t, e, n);
  return r.customData._tokenResponse = i, r;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ng(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee16() {
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", Re(t, "POST", "/v1/accounts:delete", e));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
}

function rg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee17() {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", Re(t, "POST", "/v1/accounts:update", e));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
}

function sg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee18() {
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt("return", Re(t, "POST", "/v1/accounts:lookup", e));

          case 1:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function en(t) {
  if (!!t) try {
    var e = new Date(Number(t));
    if (!isNaN(e.getTime())) return e.toUTCString();
  } catch (e) {}
}

function ag(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee19() {
    var i, n, r, a, o;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            i = te(t);
            _context19.next = 3;
            return i.getIdToken(e);

          case 3:
            n = _context19.sent;
            r = Mr(n);
            B(r && r.exp && r.auth_time && r.iat, i.auth, "internal-error");
            a = typeof r.firebase == "object" ? r.firebase : void 0, o = a == null ? void 0 : a.sign_in_provider;
            return _context19.abrupt("return", {
              claims: r,
              token: n,
              authTime: en(Ps(r.auth_time)),
              issuedAtTime: en(Ps(r.iat)),
              expirationTime: en(Ps(r.exp)),
              signInProvider: o || null,
              signInSecondFactor: (a == null ? void 0 : a.sign_in_second_factor) || null
            });

          case 8:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
}

function Ps(t) {
  return Number(t) * 1e3;
}

function Mr(t) {
  var _t$split = t.split("."),
      _t$split2 = _slicedToArray(_t$split, 3),
      e = _t$split2[0],
      i = _t$split2[1],
      n = _t$split2[2];

  if (e === void 0 || i === void 0 || n === void 0) return Vn("JWT malformed, contained fewer than 3 sections"), null;

  try {
    var r = Yc(i);
    return r ? JSON.parse(r) : (Vn("Failed to decode base64 JWT payload"), null);
  } catch (r) {
    return Vn("Caught error parsing JWT payload as JSON", r == null ? void 0 : r.toString()), null;
  }
}

function og(t) {
  var e = Mr(t);
  return B(e, "internal-error"), B(typeof e.exp != "undefined", "internal-error"), B(typeof e.iat != "undefined", "internal-error"), Number(e.exp) - Number(e.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function It(t, e) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee20() {
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            if (!i) {
              _context20.next = 2;
              break;
            }

            return _context20.abrupt("return", e);

          case 2:
            _context20.prev = 2;
            _context20.next = 5;
            return e;

          case 5:
            return _context20.abrupt("return", _context20.sent);

          case 8:
            _context20.prev = 8;
            _context20.t0 = _context20["catch"](2);
            _context20.t1 = _context20.t0 instanceof Ve && lg(_context20.t0) && t.auth.currentUser === t;

            if (!_context20.t1) {
              _context20.next = 14;
              break;
            }

            _context20.next = 14;
            return t.auth.signOut();

          case 14:
            throw _context20.t0;

          case 15:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[2, 8]]);
  }));
}

function lg(_ref13) {
  var t = _ref13.code;
  return t === "auth/user-disabled" || t === "auth/user-token-expired";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var cg =
/*#__PURE__*/
function () {
  function cg(e) {
    _classCallCheck(this, cg);

    this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }

  _createClass(cg, [{
    key: "_start",
    value: function _start() {
      this.isRunning || (this.isRunning = !0, this.schedule());
    }
  }, {
    key: "_stop",
    value: function _stop() {
      !this.isRunning || (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
    }
  }, {
    key: "getInterval",
    value: function getInterval(e) {
      var i;

      if (e) {
        var n = this.errorBackoff;
        return this.errorBackoff = Math.min(this.errorBackoff * 2, 96e4), n;
      } else {
        this.errorBackoff = 3e4;
        var r = ((i = this.user.stsTokenManager.expirationTime) !== null && i !== void 0 ? i : 0) - Date.now() - 3e5;
        return Math.max(0, r);
      }
    }
  }, {
    key: "schedule",
    value: function schedule() {
      var _this15 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      if (!this.isRunning) return;
      var i = this.getInterval(e);
      this.timerId = setTimeout(function () {
        return u(_this15, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee21() {
          return _regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  _context21.next = 2;
                  return this.iteration();

                case 2:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21, this);
        }));
      }, i);
    }
  }, {
    key: "iteration",
    value: function iteration() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                _context22.next = 3;
                return this.user.getIdToken(!0);

              case 3:
                _context22.next = 9;
                break;

              case 5:
                _context22.prev = 5;
                _context22.t0 = _context22["catch"](0);
                (_context22.t0 == null ? void 0 : _context22.t0.code) === "auth/network-request-failed" && this.schedule(!0);
                return _context22.abrupt("return");

              case 9:
                this.schedule();

              case 10:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 5]]);
      }));
    }
  }]);

  return cg;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var wu =
/*#__PURE__*/
function () {
  function wu(e, i) {
    _classCallCheck(this, wu);

    this.createdAt = e, this.lastLoginAt = i, this._initializeTime();
  }

  _createClass(wu, [{
    key: "_initializeTime",
    value: function _initializeTime() {
      this.lastSignInTime = en(this.lastLoginAt), this.creationTime = en(this.createdAt);
    }
  }, {
    key: "_copy",
    value: function _copy(e) {
      this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        createdAt: this.createdAt,
        lastLoginAt: this.lastLoginAt
      };
    }
  }]);

  return wu;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function un(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee23() {
    var e, i, n, r, a, o, l, c, d, h, p;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            i = t.auth;
            _context23.next = 3;
            return t.getIdToken();

          case 3:
            n = _context23.sent;
            _context23.next = 6;
            return It(t, sg(i, {
              idToken: n
            }));

          case 6:
            r = _context23.sent;
            B(r == null ? void 0 : r.users.length, i, "internal-error");
            a = r.users[0];

            t._notifyReloadListener(a);

            o = !((e = a.providerUserInfo) === null || e === void 0) && e.length ? hg(a.providerUserInfo) : [], l = dg(t.providerData, o), c = t.isAnonymous, d = !(t.email && a.passwordHash) && !(l != null && l.length), h = c ? d : !1, p = {
              uid: a.localId,
              displayName: a.displayName || null,
              photoURL: a.photoUrl || null,
              email: a.email || null,
              emailVerified: a.emailVerified || !1,
              phoneNumber: a.phoneNumber || null,
              tenantId: a.tenantId || null,
              providerData: l,
              metadata: new wu(a.createdAt, a.lastLoginAt),
              isAnonymous: h
            };
            Object.assign(t, p);

          case 12:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
}

function ug(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee24() {
    var e;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            e = te(t);
            _context24.next = 3;
            return un(e);

          case 3:
            _context24.next = 5;
            return e.auth._persistUserIfCurrent(e);

          case 5:
            e.auth._notifyListenersIfCurrent(e);

          case 6:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
}

function dg(t, e) {
  return [].concat(_toConsumableArray(t.filter(function (n) {
    return !e.some(function (r) {
      return r.providerId === n.providerId;
    });
  })), _toConsumableArray(e));
}

function hg(t) {
  return t.map(function (e) {
    var i = e.providerId,
        n = Ba(e, ["providerId"]);
    return {
      providerId: i,
      uid: n.rawId || "",
      displayName: n.displayName || null,
      email: n.email || null,
      phoneNumber: n.phoneNumber || null,
      photoURL: n.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function pg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee26() {
    var _this16 = this;

    var i;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.next = 2;
            return yu(t, {}, function () {
              return u(_this16, null,
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee25() {
                var n, _t$config, r, a, o, l;

                return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                  while (1) {
                    switch (_context25.prev = _context25.next) {
                      case 0:
                        n = Ai({
                          grant_type: "refresh_token",
                          refresh_token: e
                        }).slice(1);
                        _t$config = t.config;
                        r = _t$config.tokenApiHost;
                        a = _t$config.apiKey;
                        o = vu(t, r, "/v1/token", "key=".concat(a));
                        _context25.next = 7;
                        return t._getAdditionalHeaders();

                      case 7:
                        l = _context25.sent;
                        return _context25.abrupt("return", (l["Content-Type"] = "application/x-www-form-urlencoded", gu.fetch()(o, {
                          method: "POST",
                          headers: l,
                          body: n
                        })));

                      case 9:
                      case "end":
                        return _context25.stop();
                    }
                  }
                }, _callee25);
              }));
            });

          case 2:
            i = _context26.sent;
            return _context26.abrupt("return", {
              accessToken: i.access_token,
              expiresIn: i.expires_in,
              refreshToken: i.refresh_token
            });

          case 4:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var dn =
/*#__PURE__*/
function () {
  function dn() {
    _classCallCheck(this, dn);

    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }

  _createClass(dn, [{
    key: "updateFromServerResponse",
    value: function updateFromServerResponse(e) {
      B(e.idToken, "internal-error"), B(typeof e.idToken != "undefined", "internal-error"), B(typeof e.refreshToken != "undefined", "internal-error");
      var i = "expiresIn" in e && typeof e.expiresIn != "undefined" ? Number(e.expiresIn) : og(e.idToken);
      this.updateTokensAndExpiration(e.idToken, e.refreshToken, i);
    }
  }, {
    key: "getToken",
    value: function getToken(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                B(!this.accessToken || this.refreshToken, e, "user-token-expired");

                if (!(!i && this.accessToken && !this.isExpired)) {
                  _context27.next = 5;
                  break;
                }

                _context27.t0 = this.accessToken;
                _context27.next = 13;
                break;

              case 5:
                if (!this.refreshToken) {
                  _context27.next = 11;
                  break;
                }

                _context27.next = 8;
                return this.refresh(e, this.refreshToken);

              case 8:
                _context27.t1 = this.accessToken;
                _context27.next = 12;
                break;

              case 11:
                _context27.t1 = null;

              case 12:
                _context27.t0 = _context27.t1;

              case 13:
                return _context27.abrupt("return", _context27.t0);

              case 14:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    }
  }, {
    key: "clearRefreshToken",
    value: function clearRefreshToken() {
      this.refreshToken = null;
    }
  }, {
    key: "refresh",
    value: function refresh(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        var _ref14, n, r, a;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return pg(e, i);

              case 2:
                _ref14 = _context28.sent;
                n = _ref14.accessToken;
                r = _ref14.refreshToken;
                a = _ref14.expiresIn;
                this.updateTokensAndExpiration(n, r, Number(a));

              case 7:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
  }, {
    key: "updateTokensAndExpiration",
    value: function updateTokensAndExpiration(e, i, n) {
      this.refreshToken = i || null, this.accessToken = e || null, this.expirationTime = Date.now() + n * 1e3;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        refreshToken: this.refreshToken,
        accessToken: this.accessToken,
        expirationTime: this.expirationTime
      };
    }
  }, {
    key: "_assign",
    value: function _assign(e) {
      this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
    }
  }, {
    key: "_clone",
    value: function _clone() {
      return Object.assign(new dn(), this.toJSON());
    }
  }, {
    key: "_performRefresh",
    value: function _performRefresh() {
      return dt("not implemented");
    }
  }, {
    key: "isExpired",
    get: function get() {
      return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(e, i) {
      var n = i.refreshToken,
          r = i.accessToken,
          a = i.expirationTime,
          o = new dn();
      return n && (B(typeof n == "string", "internal-error", {
        appName: e
      }), o.refreshToken = n), r && (B(typeof r == "string", "internal-error", {
        appName: e
      }), o.accessToken = r), a && (B(typeof a == "number", "internal-error", {
        appName: e
      }), o.expirationTime = a), o;
    }
  }]);

  return dn;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function At(t, e) {
  B(typeof t == "string" || typeof t == "undefined", "internal-error", {
    appName: e
  });
}

var Kt =
/*#__PURE__*/
function () {
  function Kt(e) {
    _classCallCheck(this, Kt);

    var i = e.uid,
        n = e.auth,
        r = e.stsTokenManager,
        a = Ba(e, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase", this.proactiveRefresh = new cg(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = i, this.auth = n, this.stsTokenManager = r, this.accessToken = r.accessToken, this.displayName = a.displayName || null, this.email = a.email || null, this.emailVerified = a.emailVerified || !1, this.phoneNumber = a.phoneNumber || null, this.photoURL = a.photoURL || null, this.isAnonymous = a.isAnonymous || !1, this.tenantId = a.tenantId || null, this.providerData = a.providerData ? _toConsumableArray(a.providerData) : [], this.metadata = new wu(a.createdAt || void 0, a.lastLoginAt || void 0);
  }

  _createClass(Kt, [{
    key: "getIdToken",
    value: function getIdToken(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee29() {
        var i;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return It(this, this.stsTokenManager.getToken(this.auth, e));

              case 2:
                i = _context29.sent;
                B(i, this.auth, "internal-error");
                _context29.t0 = this.accessToken !== i;

                if (!_context29.t0) {
                  _context29.next = 10;
                  break;
                }

                this.accessToken = i;
                _context29.next = 9;
                return this.auth._persistUserIfCurrent(this);

              case 9:
                this.auth._notifyListenersIfCurrent(this);

              case 10:
                return _context29.abrupt("return", i);

              case 11:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
  }, {
    key: "getIdTokenResult",
    value: function getIdTokenResult(e) {
      return ag(this, e);
    }
  }, {
    key: "reload",
    value: function reload() {
      return ug(this);
    }
  }, {
    key: "_assign",
    value: function _assign(e) {
      this !== e && (B(this.uid === e.uid, this.auth, "internal-error"), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map(function (i) {
        return Object.assign({}, i);
      }), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
    }
  }, {
    key: "_clone",
    value: function _clone(e) {
      var i = new Kt(Object.assign(Object.assign({}, this), {
        auth: e,
        stsTokenManager: this.stsTokenManager._clone()
      }));
      return i.metadata._copy(this.metadata), i;
    }
  }, {
    key: "_onReload",
    value: function _onReload(e) {
      B(!this.reloadListener, this.auth, "internal-error"), this.reloadListener = e, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
    }
  }, {
    key: "_notifyReloadListener",
    value: function _notifyReloadListener(e) {
      this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
    }
  }, {
    key: "_startProactiveRefresh",
    value: function _startProactiveRefresh() {
      this.proactiveRefresh._start();
    }
  }, {
    key: "_stopProactiveRefresh",
    value: function _stopProactiveRefresh() {
      this.proactiveRefresh._stop();
    }
  }, {
    key: "_updateTokensIfNecessary",
    value: function _updateTokensIfNecessary(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30() {
        var n;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                n = !1;
                e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), n = !0);
                _context30.t0 = i;

                if (!_context30.t0) {
                  _context30.next = 6;
                  break;
                }

                _context30.next = 6;
                return un(this);

              case 6:
                _context30.next = 8;
                return this.auth._persistUserIfCurrent(this);

              case 8:
                n && this.auth._notifyListenersIfCurrent(this);

              case 9:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
  }, {
    key: "delete",
    value: function _delete() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee31() {
        var e;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.getIdToken();

              case 2:
                e = _context31.sent;
                _context31.next = 5;
                return It(this, ng(this.auth, {
                  idToken: e
                }));

              case 5:
                this.stsTokenManager.clearRefreshToken();
                return _context31.abrupt("return", this.auth.signOut());

              case 7:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return Object.assign(Object.assign({
        uid: this.uid,
        email: this.email || void 0,
        emailVerified: this.emailVerified,
        displayName: this.displayName || void 0,
        isAnonymous: this.isAnonymous,
        photoURL: this.photoURL || void 0,
        phoneNumber: this.phoneNumber || void 0,
        tenantId: this.tenantId || void 0,
        providerData: this.providerData.map(function (e) {
          return Object.assign({}, e);
        }),
        stsTokenManager: this.stsTokenManager.toJSON(),
        _redirectEventId: this._redirectEventId
      }, this.metadata.toJSON()), {
        apiKey: this.auth.config.apiKey,
        appName: this.auth.name
      });
    }
  }, {
    key: "refreshToken",
    get: function get() {
      return this.stsTokenManager.refreshToken || "";
    }
  }], [{
    key: "_fromJSON",
    value: function _fromJSON(e, i) {
      var n, r, a, o, l, c, d, h;
      var p = (n = i.displayName) !== null && n !== void 0 ? n : void 0,
          g = (r = i.email) !== null && r !== void 0 ? r : void 0,
          f = (a = i.phoneNumber) !== null && a !== void 0 ? a : void 0,
          v = (o = i.photoURL) !== null && o !== void 0 ? o : void 0,
          E = (l = i.tenantId) !== null && l !== void 0 ? l : void 0,
          y = (c = i._redirectEventId) !== null && c !== void 0 ? c : void 0,
          b = (d = i.createdAt) !== null && d !== void 0 ? d : void 0,
          C = (h = i.lastLoginAt) !== null && h !== void 0 ? h : void 0,
          R = i.uid,
          M = i.emailVerified,
          F = i.isAnonymous,
          m = i.providerData,
          I = i.stsTokenManager;
      B(R && I, e, "internal-error");
      var w = dn.fromJSON(this.name, I);
      B(typeof R == "string", e, "internal-error"), At(p, e.name), At(g, e.name), B(typeof M == "boolean", e, "internal-error"), B(typeof F == "boolean", e, "internal-error"), At(f, e.name), At(v, e.name), At(E, e.name), At(y, e.name), At(b, e.name), At(C, e.name);
      var P = new Kt({
        uid: R,
        auth: e,
        email: g,
        emailVerified: M,
        displayName: p,
        isAnonymous: F,
        photoURL: v,
        phoneNumber: f,
        tenantId: E,
        stsTokenManager: w,
        createdAt: b,
        lastLoginAt: C
      });
      return m && Array.isArray(m) && (P.providerData = m.map(function (k) {
        return Object.assign({}, k);
      })), y && (P._redirectEventId = y), P;
    }
  }, {
    key: "_fromIdTokenResponse",
    value: function _fromIdTokenResponse(e, i) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32() {
        var r, a;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                r = new dn();
                r.updateFromServerResponse(i);
                a = new Kt({
                  uid: i.localId,
                  auth: e,
                  stsTokenManager: r,
                  isAnonymous: n
                });
                _context32.next = 5;
                return un(a);

              case 5:
                return _context32.abrupt("return", a);

              case 6:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));
    }
  }]);

  return Kt;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Xo =
/* @__PURE__ */
new Map();

function ze(t) {
  it(t instanceof Function, "Expected a class definition");
  var e = Xo.get(t);
  return e ? (it(e instanceof t, "Instance stored in cache mismatched with class"), e) : (e = new t(), Xo.set(t, e), e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var bu =
/*#__PURE__*/
function () {
  function bu() {
    _classCallCheck(this, bu);

    this.type = "NONE", this.storage = {};
  }

  _createClass(bu, [{
    key: "_isAvailable",
    value: function _isAvailable() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee33() {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                return _context33.abrupt("return", !0);

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));
    }
  }, {
    key: "_set",
    value: function _set(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34() {
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                this.storage[e] = i;

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "_get",
    value: function _get(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35() {
        var i;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                i = this.storage[e];
                return _context35.abrupt("return", i === void 0 ? null : i);

              case 2:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "_remove",
    value: function _remove(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36() {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                delete this.storage[e];

              case 1:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));
    }
  }, {
    key: "_addListener",
    value: function _addListener(e, i) {}
  }, {
    key: "_removeListener",
    value: function _removeListener(e, i) {}
  }]);

  return bu;
}();

bu.type = "NONE";
var Ei = bu;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function Jt(t, e, i) {
  return "firebase:".concat(t, ":").concat(e, ":").concat(i);
}

var gi =
/*#__PURE__*/
function () {
  function gi(e, i, n) {
    _classCallCheck(this, gi);

    this.persistence = e, this.auth = i, this.userKey = n;
    var _this$auth = this.auth,
        r = _this$auth.config,
        a = _this$auth.name;
    this.fullUserKey = Jt(this.userKey, r.apiKey, a), this.fullPersistenceKey = Jt("persistence", r.apiKey, a), this.boundEventHandler = i._onStorageEvent.bind(i), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }

  _createClass(gi, [{
    key: "setCurrentUser",
    value: function setCurrentUser(e) {
      return this.persistence._set(this.fullUserKey, e.toJSON());
    }
  }, {
    key: "getCurrentUser",
    value: function getCurrentUser() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37() {
        var e;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this.persistence._get(this.fullUserKey);

              case 2:
                e = _context37.sent;
                return _context37.abrupt("return", e ? Kt._fromJSON(this.auth, e) : null);

              case 4:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "removeCurrentUser",
    value: function removeCurrentUser() {
      return this.persistence._remove(this.fullUserKey);
    }
  }, {
    key: "savePersistenceForRedirect",
    value: function savePersistenceForRedirect() {
      return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
  }, {
    key: "setPersistence",
    value: function setPersistence(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38() {
        var i;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (!(this.persistence === e)) {
                  _context38.next = 2;
                  break;
                }

                return _context38.abrupt("return");

              case 2:
                _context38.next = 4;
                return this.getCurrentUser();

              case 4:
                i = _context38.sent;
                _context38.next = 7;
                return this.removeCurrentUser();

              case 7:
                this.persistence = e;

                if (!i) {
                  _context38.next = 10;
                  break;
                }

                return _context38.abrupt("return", this.setCurrentUser(i));

              case 10:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    }
  }, {
    key: "delete",
    value: function _delete() {
      this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
  }], [{
    key: "create",
    value: function create(e, i) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "authUser";
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41() {
        var _this17 = this;

        var r, a, o, l, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, d, h, p, c;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (i.length) {
                  _context41.next = 2;
                  break;
                }

                return _context41.abrupt("return", new gi(ze(Ei), e, n));

              case 2:
                _context41.next = 4;
                return Promise.all(i.map(function (d) {
                  return u(_this17, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee39() {
                    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                      while (1) {
                        switch (_context39.prev = _context39.next) {
                          case 0:
                            _context39.next = 2;
                            return d._isAvailable();

                          case 2:
                            if (!_context39.sent) {
                              _context39.next = 4;
                              break;
                            }

                            return _context39.abrupt("return", d);

                          case 4:
                          case "end":
                            return _context39.stop();
                        }
                      }
                    }, _callee39);
                  }));
                }));

              case 4:
                _context41.t0 = function (d) {
                  return d;
                };

                r = _context41.sent.filter(_context41.t0);
                a = r[0] || ze(Ei);
                o = Jt(n, e.config.apiKey, e.name);
                l = null;
                _iteratorNormalCompletion10 = true;
                _didIteratorError10 = false;
                _iteratorError10 = undefined;
                _context41.prev = 12;
                _iterator10 = i[Symbol.iterator]();

              case 14:
                if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                  _context41.next = 31;
                  break;
                }

                d = _step10.value;
                _context41.prev = 16;
                _context41.next = 19;
                return d._get(o);

              case 19:
                h = _context41.sent;

                if (!h) {
                  _context41.next = 24;
                  break;
                }

                p = Kt._fromJSON(e, h);
                d !== a && (l = p), a = d;
                return _context41.abrupt("break", 31);

              case 24:
                _context41.next = 28;
                break;

              case 26:
                _context41.prev = 26;
                _context41.t1 = _context41["catch"](16);

              case 28:
                _iteratorNormalCompletion10 = true;
                _context41.next = 14;
                break;

              case 31:
                _context41.next = 37;
                break;

              case 33:
                _context41.prev = 33;
                _context41.t2 = _context41["catch"](12);
                _didIteratorError10 = true;
                _iteratorError10 = _context41.t2;

              case 37:
                _context41.prev = 37;
                _context41.prev = 38;

                if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
                  _iterator10.return();
                }

              case 40:
                _context41.prev = 40;

                if (!_didIteratorError10) {
                  _context41.next = 43;
                  break;
                }

                throw _iteratorError10;

              case 43:
                return _context41.finish(40);

              case 44:
                return _context41.finish(37);

              case 45:
                c = r.filter(function (d) {
                  return d._shouldAllowMigration;
                });

                if (!(!a._shouldAllowMigration || !c.length)) {
                  _context41.next = 50;
                  break;
                }

                _context41.t3 = new gi(a, e, n);
                _context41.next = 58;
                break;

              case 50:
                a = c[0];
                _context41.t4 = l;

                if (!_context41.t4) {
                  _context41.next = 55;
                  break;
                }

                _context41.next = 55;
                return a._set(o, l.toJSON());

              case 55:
                _context41.next = 57;
                return Promise.all(i.map(function (d) {
                  return u(_this17, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee40() {
                    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
                      while (1) {
                        switch (_context40.prev = _context40.next) {
                          case 0:
                            if (!(d !== a)) {
                              _context40.next = 8;
                              break;
                            }

                            _context40.prev = 1;
                            _context40.next = 4;
                            return d._remove(o);

                          case 4:
                            _context40.next = 8;
                            break;

                          case 6:
                            _context40.prev = 6;
                            _context40.t0 = _context40["catch"](1);

                          case 8:
                          case "end":
                            return _context40.stop();
                        }
                      }
                    }, _callee40, null, [[1, 6]]);
                  }));
                }));

              case 57:
                _context41.t3 = new gi(a, e, n);

              case 58:
                return _context41.abrupt("return", _context41.t3);

              case 59:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, null, [[12, 33, 37, 45], [16, 26], [38,, 40, 44]]);
      }));
    }
  }]);

  return gi;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Zo(t) {
  var e = t.toLowerCase();
  if (e.includes("opera/") || e.includes("opr/") || e.includes("opios/")) return "Opera";
  if (Eu(e)) return "IEMobile";
  if (e.includes("msie") || e.includes("trident/")) return "IE";
  if (e.includes("edge/")) return "Edge";
  if (Iu(e)) return "Firefox";
  if (e.includes("silk/")) return "Silk";
  if (Cu(e)) return "Blackberry";
  if (Su(e)) return "Webos";
  if (Wa(e)) return "Safari";
  if ((e.includes("chrome/") || _u(e)) && !e.includes("edge/")) return "Chrome";
  if (vn(e)) return "Android";
  {
    var i = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/,
        n = t.match(i);
    if ((n == null ? void 0 : n.length) === 2) return n[1];
  }
  return "Other";
}

function Iu() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /firefox\//i.test(t);
}

function Wa() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  var e = t.toLowerCase();
  return e.includes("safari/") && !e.includes("chrome/") && !e.includes("crios/") && !e.includes("android");
}

function _u() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /crios\//i.test(t);
}

function Eu() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /iemobile/i.test(t);
}

function vn() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /android/i.test(t);
}

function Cu() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /blackberry/i.test(t);
}

function Su() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /webos/i.test(t);
}

function Fi() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /iphone|ipad|ipod/i.test(t) || /macintosh/i.test(t) && /mobile/i.test(t);
}

function fg() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /(iPad|iPhone|iPod).*OS 7_\d/i.test(t) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(t);
}

function mg() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  var e;
  return Fi(t) && !!(!((e = window.navigator) === null || e === void 0) && e.standalone);
}

function gg() {
  return eu() && document.documentMode === 10;
}

function Tu() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return Fi(t) || vn(t) || Su(t) || Cu(t) || /windows phone/i.test(t) || Eu(t);
}

function yg() {
  try {
    return !!(window && window !== window.top);
  } catch (t) {
    return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Ru(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var i;

  switch (t) {
    case "Browser":
      i = Zo(we());
      break;

    case "Worker":
      i = "".concat(Zo(we()), "-").concat(t);
      break;

    default:
      i = t;
  }

  var n = e.length ? e.join(",") : "FirebaseCore-web";
  return "".concat(i, "/JsCore/").concat(ai, "/").concat(n);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function vg(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee42() {
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.next = 2;
            return Re(t, "GET", "/v1/recaptchaParams");

          case 2:
            _context42.t0 = _context42.sent.recaptchaSiteKey;

            if (_context42.t0) {
              _context42.next = 5;
              break;
            }

            _context42.t0 = "";

          case 5:
            return _context42.abrupt("return", _context42.t0);

          case 6:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));
}

function Pu(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee43() {
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            return _context43.abrupt("return", Re(t, "GET", "/v2/recaptchaConfig", be(t, e)));

          case 1:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function el(t) {
  return t !== void 0 && t.getResponse !== void 0;
}

function tl(t) {
  return t !== void 0 && t.enterprise !== void 0;
}

var Ou = function Ou(e) {
  _classCallCheck(this, Ou);

  if (this.siteKey = "", this.emailPasswordEnabled = !1, e.recaptchaKey === void 0) throw new Error("recaptchaKey undefined");
  this.siteKey = e.recaptchaKey.split("/")[3], this.emailPasswordEnabled = e.recaptchaEnforcementState.some(function (i) {
    return i.provider === "EMAIL_PASSWORD_PROVIDER" && i.enforcementState !== "OFF";
  });
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function wg() {
  var t, e;
  return (e = (t = document.getElementsByTagName("head")) === null || t === void 0 ? void 0 : t[0]) !== null && e !== void 0 ? e : document;
}

function Ga(t) {
  return new Promise(function (e, i) {
    var n = document.createElement("script");
    n.setAttribute("src", t), n.onload = e, n.onerror = function (r) {
      var a = xe("internal-error");
      a.customData = r, i(a);
    }, n.type = "text/javascript", n.charset = "UTF-8", wg().appendChild(n);
  });
}

function Au(t) {
  return "__".concat(t).concat(Math.floor(Math.random() * 1e6));
}

var bg = "https://www.google.com/recaptcha/enterprise.js?render=",
    Ig = "recaptcha-enterprise",
    _g = "NO_RECAPTCHA";

var Mu =
/*#__PURE__*/
function () {
  function Mu(e) {
    _classCallCheck(this, Mu);

    this.type = Ig, this.auth = fe(e);
  }

  _createClass(Mu, [{
    key: "verify",
    value: function verify() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "verify";
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46() {
        var _this19 = this;

        var n, r;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                r = function _ref16(a, o, l) {
                  var c = window.grecaptcha;
                  tl(c) ? c.enterprise.ready(function () {
                    c.enterprise.execute(a, {
                      action: e
                    }).then(function (d) {
                      o(d);
                    }).catch(function () {
                      o(_g);
                    });
                  }) : l(Error("No reCAPTCHA enterprise script loaded."));
                };

                n = function _ref15(a) {
                  return u(this, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee45() {
                    var _this18 = this;

                    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
                      while (1) {
                        switch (_context45.prev = _context45.next) {
                          case 0:
                            if (i) {
                              _context45.next = 5;
                              break;
                            }

                            if (!(a.tenantId == null && a._agentRecaptchaConfig != null)) {
                              _context45.next = 3;
                              break;
                            }

                            return _context45.abrupt("return", a._agentRecaptchaConfig.siteKey);

                          case 3:
                            if (!(a.tenantId != null && a._tenantRecaptchaConfigs[a.tenantId] !== void 0)) {
                              _context45.next = 5;
                              break;
                            }

                            return _context45.abrupt("return", a._tenantRecaptchaConfigs[a.tenantId].siteKey);

                          case 5:
                            return _context45.abrupt("return", new Promise(function (o, l) {
                              return u(_this18, null,
                              /*#__PURE__*/
                              _regeneratorRuntime.mark(function _callee44() {
                                return _regeneratorRuntime.wrap(function _callee44$(_context44) {
                                  while (1) {
                                    switch (_context44.prev = _context44.next) {
                                      case 0:
                                        Pu(a, {
                                          clientType: "CLIENT_TYPE_WEB",
                                          version: "RECAPTCHA_ENTERPRISE"
                                        }).then(function (c) {
                                          if (c.recaptchaKey === void 0) l(new Error("recaptcha Enterprise site key undefined"));else {
                                            var d = new Ou(c);
                                            return a.tenantId == null ? a._agentRecaptchaConfig = d : a._tenantRecaptchaConfigs[a.tenantId] = d, o(d.siteKey);
                                          }
                                        }).catch(function (c) {
                                          l(c);
                                        });

                                      case 1:
                                      case "end":
                                        return _context44.stop();
                                    }
                                  }
                                }, _callee44);
                              }));
                            }));

                          case 6:
                          case "end":
                            return _context45.stop();
                        }
                      }
                    }, _callee45);
                  }));
                };

                return _context46.abrupt("return", new Promise(function (a, o) {
                  n(_this19.auth).then(function (l) {
                    if (!i && tl(window.grecaptcha)) r(l, a, o);else {
                      if (typeof window == "undefined") {
                        o(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                      }

                      Ga(bg + l).then(function () {
                        r(l, a, o);
                      }).catch(function (c) {
                        o(c);
                      });
                    }
                  }).catch(function (l) {
                    o(l);
                  });
                }));

              case 3:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }));
    }
  }]);

  return Mu;
}();

function Ht(t, e, i) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee47() {
    var r, a, o;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            r = new Mu(t);
            _context47.prev = 1;
            _context47.next = 4;
            return r.verify(i);

          case 4:
            a = _context47.sent;
            _context47.next = 12;
            break;

          case 7:
            _context47.prev = 7;
            _context47.t0 = _context47["catch"](1);
            _context47.next = 11;
            return r.verify(i, !0);

          case 11:
            a = _context47.sent;

          case 12:
            o = Object.assign({}, e);
            return _context47.abrupt("return", (n ? Object.assign(o, {
              captchaResp: a
            }) : Object.assign(o, {
              captchaResponse: a
            }), Object.assign(o, {
              clientType: "CLIENT_TYPE_WEB"
            }), Object.assign(o, {
              recaptchaVersion: "RECAPTCHA_ENTERPRISE"
            }), o));

          case 14:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47, null, [[1, 7]]);
  }));
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Eg =
/*#__PURE__*/
function () {
  function Eg(e) {
    _classCallCheck(this, Eg);

    this.auth = e, this.queue = [];
  }

  _createClass(Eg, [{
    key: "pushCallback",
    value: function pushCallback(e, i) {
      var _this20 = this;

      var n = function n(a) {
        return new Promise(function (o, l) {
          try {
            var c = e(a);
            o(c);
          } catch (c) {
            l(c);
          }
        });
      };

      n.onAbort = i, this.queue.push(n);
      var r = this.queue.length - 1;
      return function () {
        _this20.queue[r] = function () {
          return Promise.resolve();
        };
      };
    }
  }, {
    key: "runMiddleware",
    value: function runMiddleware(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48() {
        var i, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, n, _i9, _i8, r;

        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                if (!(this.auth.currentUser === e)) {
                  _context48.next = 2;
                  break;
                }

                return _context48.abrupt("return");

              case 2:
                i = [];
                _context48.prev = 3;
                _iteratorNormalCompletion11 = true;
                _didIteratorError11 = false;
                _iteratorError11 = undefined;
                _context48.prev = 7;
                _iterator11 = this.queue[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                  _context48.next = 17;
                  break;
                }

                n = _step11.value;
                _context48.next = 13;
                return n(e);

              case 13:
                n.onAbort && i.push(n.onAbort);

              case 14:
                _iteratorNormalCompletion11 = true;
                _context48.next = 9;
                break;

              case 17:
                _context48.next = 23;
                break;

              case 19:
                _context48.prev = 19;
                _context48.t0 = _context48["catch"](7);
                _didIteratorError11 = true;
                _iteratorError11 = _context48.t0;

              case 23:
                _context48.prev = 23;
                _context48.prev = 24;

                if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                  _iterator11.return();
                }

              case 26:
                _context48.prev = 26;

                if (!_didIteratorError11) {
                  _context48.next = 29;
                  break;
                }

                throw _iteratorError11;

              case 29:
                return _context48.finish(26);

              case 30:
                return _context48.finish(23);

              case 31:
                _context48.next = 38;
                break;

              case 33:
                _context48.prev = 33;
                _context48.t1 = _context48["catch"](3);
                i.reverse();

                for (_i9 = 0, _i8 = i; _i9 < _i8.length; _i9++) {
                  r = _i8[_i9];

                  try {
                    r();
                  } catch (a) {}
                }

                throw this.auth._errorFactory.create("login-blocked", {
                  originalMessage: _context48.t1 == null ? void 0 : _context48.t1.message
                });

              case 38:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this, [[3, 33], [7, 19, 23, 31], [24,, 26, 30]]);
      }));
    }
  }]);

  return Eg;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Cg =
/*#__PURE__*/
function () {
  function Cg(e, i, n, r) {
    _classCallCheck(this, Cg);

    this.app = e, this.heartbeatServiceProvider = i, this.appCheckServiceProvider = n, this.config = r, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new il(this), this.idTokenSubscription = new il(this), this.beforeStateQueue = new Eg(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = fu, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = {
      appVerificationDisabledForTesting: !1
    }, this.frameworks = [], this.name = e.name, this.clientVersion = r.sdkClientVersion;
  }

  _createClass(Cg, [{
    key: "_initializeWithPersistence",
    value: function _initializeWithPersistence(e, i) {
      var _this21 = this;

      return i && (this._popupRedirectResolver = ze(i)), this._initializationPromise = this.queue(function () {
        return u(_this21, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee49() {
          var n, r;
          return _regeneratorRuntime.wrap(function _callee49$(_context49) {
            while (1) {
              switch (_context49.prev = _context49.next) {
                case 0:
                  _context49.t0 = !this._deleted;

                  if (!_context49.t0) {
                    _context49.next = 6;
                    break;
                  }

                  _context49.next = 4;
                  return gi.create(this, e);

                case 4:
                  this.persistenceManager = _context49.sent;
                  _context49.t0 = !this._deleted;

                case 6:
                  if (!_context49.t0) {
                    _context49.next = 19;
                    break;
                  }

                  if (!(!((n = this._popupRedirectResolver) === null || n === void 0) && n._shouldInitProactively)) {
                    _context49.next = 15;
                    break;
                  }

                  _context49.prev = 8;
                  _context49.next = 11;
                  return this._popupRedirectResolver._initialize(this);

                case 11:
                  _context49.next = 15;
                  break;

                case 13:
                  _context49.prev = 13;
                  _context49.t1 = _context49["catch"](8);

                case 15:
                  _context49.next = 17;
                  return this.initializeCurrentUser(i);

                case 17:
                  this.lastNotifiedUid = ((r = this.currentUser) === null || r === void 0 ? void 0 : r.uid) || null;
                  !this._deleted && (this._isInitialized = !0);

                case 19:
                case "end":
                  return _context49.stop();
              }
            }
          }, _callee49, this, [[8, 13]]);
        }));
      }), this._initializationPromise;
    }
  }, {
    key: "_onStorageEvent",
    value: function _onStorageEvent() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee50() {
        var e;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                if (!this._deleted) {
                  _context50.next = 2;
                  break;
                }

                return _context50.abrupt("return");

              case 2:
                _context50.next = 4;
                return this.assertedPersistence.getCurrentUser();

              case 4:
                e = _context50.sent;

                if (!this.currentUser && !e) {
                  _context50.next = 13;
                  break;
                }

                if (!(this.currentUser && e && this.currentUser.uid === e.uid)) {
                  _context50.next = 11;
                  break;
                }

                this._currentUser._assign(e);

                _context50.next = 10;
                return this.currentUser.getIdToken();

              case 10:
                return _context50.abrupt("return");

              case 11:
                _context50.next = 13;
                return this._updateCurrentUser(e, !0);

              case 13:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));
    }
  }, {
    key: "initializeCurrentUser",
    value: function initializeCurrentUser(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee51() {
        var i, n, r, a, o, l, c;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return this.assertedPersistence.getCurrentUser();

              case 2:
                n = _context51.sent;
                r = n, a = !1;

                if (!(e && this.config.authDomain)) {
                  _context51.next = 13;
                  break;
                }

                _context51.next = 7;
                return this.getOrInitRedirectPersistenceManager();

              case 7:
                o = (i = this.redirectUser) === null || i === void 0 ? void 0 : i._redirectEventId;
                l = r == null ? void 0 : r._redirectEventId;
                _context51.next = 11;
                return this.tryRedirectSignIn(e);

              case 11:
                c = _context51.sent;
                (!o || o === l) && (c == null ? void 0 : c.user) && (r = c.user, a = !0);

              case 13:
                if (r) {
                  _context51.next = 15;
                  break;
                }

                return _context51.abrupt("return", this.directlySetCurrentUser(null));

              case 15:
                if (r._redirectEventId) {
                  _context51.next = 26;
                  break;
                }

                if (!a) {
                  _context51.next = 25;
                  break;
                }

                _context51.prev = 17;
                _context51.next = 20;
                return this.beforeStateQueue.runMiddleware(r);

              case 20:
                _context51.next = 25;
                break;

              case 22:
                _context51.prev = 22;
                _context51.t0 = _context51["catch"](17);
                r = n, this._popupRedirectResolver._overrideRedirectResult(this, function () {
                  return Promise.reject(_context51.t0);
                });

              case 25:
                return _context51.abrupt("return", r ? this.reloadAndSetCurrentUserOrClear(r) : this.directlySetCurrentUser(null));

              case 26:
                B(this._popupRedirectResolver, this, "argument-error");
                _context51.next = 29;
                return this.getOrInitRedirectPersistenceManager();

              case 29:
                return _context51.abrupt("return", this.redirectUser && this.redirectUser._redirectEventId === r._redirectEventId ? this.directlySetCurrentUser(r) : this.reloadAndSetCurrentUserOrClear(r));

              case 30:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this, [[17, 22]]);
      }));
    }
  }, {
    key: "tryRedirectSignIn",
    value: function tryRedirectSignIn(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee52() {
        var i;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                i = null;
                _context52.prev = 1;
                _context52.next = 4;
                return this._popupRedirectResolver._completeRedirectFn(this, e, !0);

              case 4:
                i = _context52.sent;
                _context52.next = 11;
                break;

              case 7:
                _context52.prev = 7;
                _context52.t0 = _context52["catch"](1);
                _context52.next = 11;
                return this._setRedirectUser(null);

              case 11:
                return _context52.abrupt("return", i);

              case 12:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this, [[1, 7]]);
      }));
    }
  }, {
    key: "reloadAndSetCurrentUserOrClear",
    value: function reloadAndSetCurrentUserOrClear(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee53() {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.prev = 0;
                _context53.next = 3;
                return un(e);

              case 3:
                _context53.next = 9;
                break;

              case 5:
                _context53.prev = 5;
                _context53.t0 = _context53["catch"](0);

                if (!((_context53.t0 == null ? void 0 : _context53.t0.code) !== "auth/network-request-failed")) {
                  _context53.next = 9;
                  break;
                }

                return _context53.abrupt("return", this.directlySetCurrentUser(null));

              case 9:
                return _context53.abrupt("return", this.directlySetCurrentUser(e));

              case 10:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this, [[0, 5]]);
      }));
    }
  }, {
    key: "useDeviceLanguage",
    value: function useDeviceLanguage() {
      this.languageCode = Zm();
    }
  }, {
    key: "_delete",
    value: function _delete() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                this._deleted = !0;

              case 1:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
    }
  }, {
    key: "updateCurrentUser",
    value: function updateCurrentUser(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee55() {
        var i;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                i = e ? te(e) : null;
                return _context55.abrupt("return", (i && B(i.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token"), this._updateCurrentUser(i && i._clone(this))));

              case 2:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));
    }
  }, {
    key: "_updateCurrentUser",
    value: function _updateCurrentUser(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee57() {
        var _this22 = this;

        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                if (this._deleted) {
                  _context57.next = 7;
                  break;
                }

                e && B(this.tenantId === e.tenantId, this, "tenant-id-mismatch");
                _context57.t0 = i;

                if (_context57.t0) {
                  _context57.next = 6;
                  break;
                }

                _context57.next = 6;
                return this.beforeStateQueue.runMiddleware(e);

              case 6:
                return _context57.abrupt("return", this.queue(function () {
                  return u(_this22, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee56() {
                    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
                      while (1) {
                        switch (_context56.prev = _context56.next) {
                          case 0:
                            _context56.next = 2;
                            return this.directlySetCurrentUser(e);

                          case 2:
                            this.notifyAuthListeners();

                          case 3:
                          case "end":
                            return _context56.stop();
                        }
                      }
                    }, _callee56, this);
                  }));
                }));

              case 7:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));
    }
  }, {
    key: "signOut",
    value: function signOut() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee58() {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return this.beforeStateQueue.runMiddleware(null);

              case 2:
                _context58.t0 = this.redirectPersistenceManager || this._popupRedirectResolver;

                if (!_context58.t0) {
                  _context58.next = 6;
                  break;
                }

                _context58.next = 6;
                return this._setRedirectUser(null);

              case 6:
                return _context58.abrupt("return", this._updateCurrentUser(null, !0));

              case 7:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));
    }
  }, {
    key: "setPersistence",
    value: function setPersistence(e) {
      var _this23 = this;

      return this.queue(function () {
        return u(_this23, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee59() {
          return _regeneratorRuntime.wrap(function _callee59$(_context59) {
            while (1) {
              switch (_context59.prev = _context59.next) {
                case 0:
                  _context59.next = 2;
                  return this.assertedPersistence.setPersistence(ze(e));

                case 2:
                case "end":
                  return _context59.stop();
              }
            }
          }, _callee59, this);
        }));
      });
    }
  }, {
    key: "initializeRecaptchaConfig",
    value: function initializeRecaptchaConfig() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee60() {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return Pu(this, {
                  clientType: "CLIENT_TYPE_WEB",
                  version: "RECAPTCHA_ENTERPRISE"
                });

              case 2:
                e = _context60.sent;
                i = new Ou(e);
                this.tenantId == null ? this._agentRecaptchaConfig = i : this._tenantRecaptchaConfigs[this.tenantId] = i, i.emailPasswordEnabled && new Mu(this).verify();

              case 5:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));
    }
  }, {
    key: "_getRecaptchaConfig",
    value: function _getRecaptchaConfig() {
      return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
    }
  }, {
    key: "_getPersistence",
    value: function _getPersistence() {
      return this.assertedPersistence.persistence.type;
    }
  }, {
    key: "_updateErrorMap",
    value: function _updateErrorMap(e) {
      this._errorFactory = new si("auth", "Firebase", e());
    }
  }, {
    key: "onAuthStateChanged",
    value: function onAuthStateChanged(e, i, n) {
      return this.registerStateListener(this.authStateSubscription, e, i, n);
    }
  }, {
    key: "beforeAuthStateChanged",
    value: function beforeAuthStateChanged(e, i) {
      return this.beforeStateQueue.pushCallback(e, i);
    }
  }, {
    key: "onIdTokenChanged",
    value: function onIdTokenChanged(e, i, n) {
      return this.registerStateListener(this.idTokenSubscription, e, i, n);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e;
      return {
        apiKey: this.config.apiKey,
        authDomain: this.config.authDomain,
        appName: this.name,
        currentUser: (e = this._currentUser) === null || e === void 0 ? void 0 : e.toJSON()
      };
    }
  }, {
    key: "_setRedirectUser",
    value: function _setRedirectUser(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee61() {
        var n;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.next = 2;
                return this.getOrInitRedirectPersistenceManager(i);

              case 2:
                n = _context61.sent;
                return _context61.abrupt("return", e === null ? n.removeCurrentUser() : n.setCurrentUser(e));

              case 4:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));
    }
  }, {
    key: "getOrInitRedirectPersistenceManager",
    value: function getOrInitRedirectPersistenceManager(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee62() {
        var i;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                if (this.redirectPersistenceManager) {
                  _context62.next = 9;
                  break;
                }

                i = e && ze(e) || this._popupRedirectResolver;
                B(i, this, "argument-error");
                _context62.next = 5;
                return gi.create(this, [ze(i._redirectPersistence)], "redirectUser");

              case 5:
                this.redirectPersistenceManager = _context62.sent;
                _context62.next = 8;
                return this.redirectPersistenceManager.getCurrentUser();

              case 8:
                this.redirectUser = _context62.sent;

              case 9:
                return _context62.abrupt("return", this.redirectPersistenceManager);

              case 10:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));
    }
  }, {
    key: "_redirectUserForId",
    value: function _redirectUserForId(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee64() {
        var _this24 = this;

        var i, n;
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.t0 = this._isInitialized;

                if (!_context64.t0) {
                  _context64.next = 4;
                  break;
                }

                _context64.next = 4;
                return this.queue(function () {
                  return u(_this24, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee63() {
                    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
                      while (1) {
                        switch (_context63.prev = _context63.next) {
                          case 0:
                          case "end":
                            return _context63.stop();
                        }
                      }
                    }, _callee63);
                  }));
                });

              case 4:
                return _context64.abrupt("return", ((i = this._currentUser) === null || i === void 0 ? void 0 : i._redirectEventId) === e ? this._currentUser : ((n = this.redirectUser) === null || n === void 0 ? void 0 : n._redirectEventId) === e ? this.redirectUser : null);

              case 5:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));
    }
  }, {
    key: "_persistUserIfCurrent",
    value: function _persistUserIfCurrent(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee66() {
        var _this25 = this;

        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                if (!(e === this.currentUser)) {
                  _context66.next = 2;
                  break;
                }

                return _context66.abrupt("return", this.queue(function () {
                  return u(_this25, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee65() {
                    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
                      while (1) {
                        switch (_context65.prev = _context65.next) {
                          case 0:
                            return _context65.abrupt("return", this.directlySetCurrentUser(e));

                          case 1:
                          case "end":
                            return _context65.stop();
                        }
                      }
                    }, _callee65, this);
                  }));
                }));

              case 2:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));
    }
  }, {
    key: "_notifyListenersIfCurrent",
    value: function _notifyListenersIfCurrent(e) {
      e === this.currentUser && this.notifyAuthListeners();
    }
  }, {
    key: "_key",
    value: function _key() {
      return "".concat(this.config.authDomain, ":").concat(this.config.apiKey, ":").concat(this.name);
    }
  }, {
    key: "_startProactiveRefresh",
    value: function _startProactiveRefresh() {
      this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
    }
  }, {
    key: "_stopProactiveRefresh",
    value: function _stopProactiveRefresh() {
      this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
    }
  }, {
    key: "notifyAuthListeners",
    value: function notifyAuthListeners() {
      var e, i;
      if (!this._isInitialized) return;
      this.idTokenSubscription.next(this.currentUser);
      var n = (i = (e = this.currentUser) === null || e === void 0 ? void 0 : e.uid) !== null && i !== void 0 ? i : null;
      this.lastNotifiedUid !== n && (this.lastNotifiedUid = n, this.authStateSubscription.next(this.currentUser));
    }
  }, {
    key: "registerStateListener",
    value: function registerStateListener(e, i, n, r) {
      var _this26 = this;

      if (this._deleted) return function () {};
      var a = typeof i == "function" ? i : i.next.bind(i),
          o = this._isInitialized ? Promise.resolve() : this._initializationPromise;
      return B(o, this, "internal-error"), o.then(function () {
        return a(_this26.currentUser);
      }), typeof i == "function" ? e.addObserver(i, n, r) : e.addObserver(i);
    }
  }, {
    key: "directlySetCurrentUser",
    value: function directlySetCurrentUser(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee67() {
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                this.currentUser && this.currentUser !== e && this._currentUser._stopProactiveRefresh();
                e && this.isProactiveRefreshEnabled && e._startProactiveRefresh();
                this.currentUser = e;

                if (!e) {
                  _context67.next = 8;
                  break;
                }

                _context67.next = 6;
                return this.assertedPersistence.setCurrentUser(e);

              case 6:
                _context67.next = 10;
                break;

              case 8:
                _context67.next = 10;
                return this.assertedPersistence.removeCurrentUser();

              case 10:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));
    }
  }, {
    key: "queue",
    value: function queue(e) {
      return this.operations = this.operations.then(e, e), this.operations;
    }
  }, {
    key: "_logFramework",
    value: function _logFramework(e) {
      !e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = Ru(this.config.clientPlatform, this._getFrameworks()));
    }
  }, {
    key: "_getFrameworks",
    value: function _getFrameworks() {
      return this.frameworks;
    }
  }, {
    key: "_getAdditionalHeaders",
    value: function _getAdditionalHeaders() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee68() {
        var e, i, n, r;
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                i = _defineProperty({}, "X-Client-Version", this.clientVersion);
                this.app.options.appId && (i["X-Firebase-gmpid"] = this.app.options.appId);
                _context68.next = 4;
                return (e = this.heartbeatServiceProvider.getImmediate({
                  optional: !0
                })) === null || e === void 0 ? void 0 : e.getHeartbeatsHeader();

              case 4:
                n = _context68.sent;
                n && (i["X-Firebase-Client"] = n);
                _context68.next = 8;
                return this._getAppCheckToken();

              case 8:
                r = _context68.sent;
                return _context68.abrupt("return", (r && (i["X-Firebase-AppCheck"] = r), i));

              case 10:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));
    }
  }, {
    key: "_getAppCheckToken",
    value: function _getAppCheckToken() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee69() {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                _context69.next = 2;
                return (e = this.appCheckServiceProvider.getImmediate({
                  optional: !0
                })) === null || e === void 0 ? void 0 : e.getToken();

              case 2:
                i = _context69.sent;
                return _context69.abrupt("return", (i != null && i.error && Jm("Error while retrieving App Check token: ".concat(i.error)), i == null ? void 0 : i.token));

              case 4:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));
    }
  }, {
    key: "_currentUser",
    get: function get() {
      return this.currentUser;
    }
  }, {
    key: "assertedPersistence",
    get: function get() {
      return B(this.persistenceManager, this, "internal-error"), this.persistenceManager;
    }
  }]);

  return Cg;
}();

function fe(t) {
  return te(t);
}

var il =
/*#__PURE__*/
function () {
  function il(e) {
    var _this27 = this;

    _classCallCheck(this, il);

    this.auth = e, this.observer = null, this.addObserver = tu(function (i) {
      return _this27.observer = i;
    });
  }

  _createClass(il, [{
    key: "next",
    get: function get() {
      return B(this.observer, this.auth, "internal-error"), this.observer.next.bind(this.observer);
    }
  }]);

  return il;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Sg(t, e) {
  var i = Ar(t, "auth");

  if (i.isInitialized()) {
    var r = i.getImmediate(),
        a = i.getOptions();
    if (rr(a, e != null ? e : {})) return r;
    Ae(r, "already-initialized");
  }

  return i.initialize({
    options: e
  });
}

function Tg(t, e) {
  var i = (e == null ? void 0 : e.persistence) || [],
      n = (Array.isArray(i) ? i : [i]).map(ze);
  e != null && e.errorMap && t._updateErrorMap(e.errorMap), t._initializeWithPersistence(n, e == null ? void 0 : e.popupRedirectResolver);
}

function za(t, e, i) {
  var n = fe(t);
  B(n._canInitEmulator, n, "emulator-config-failed"), B(/^https?:\/\//.test(e), n, "invalid-emulator-scheme");

  var r = !!(i != null && i.disableWarnings),
      a = Fu(e),
      _Rg = Rg(e),
      o = _Rg.host,
      l = _Rg.port,
      c = l === null ? "" : ":".concat(l);

  n.config.emulator = {
    url: "".concat(a, "//").concat(o).concat(c, "/")
  }, n.settings.appVerificationDisabledForTesting = !0, n.emulatorConfig = Object.freeze({
    host: o,
    port: l,
    protocol: a.replace(":", ""),
    options: Object.freeze({
      disableWarnings: r
    })
  }), r || Pg();
}

function Fu(t) {
  var e = t.indexOf(":");
  return e < 0 ? "" : t.substr(0, e + 1);
}

function Rg(t) {
  var e = Fu(t),
      i = /(\/\/)?([^?#/]+)/.exec(t.substr(e.length));
  if (!i) return {
    host: "",
    port: null
  };
  var n = i[2].split("@").pop() || "",
      r = /^(\[[^\]]+\])(:|$)/.exec(n);

  if (r) {
    var a = r[1];
    return {
      host: a,
      port: nl(n.substr(a.length + 1))
    };
  } else {
    var _n$split3 = n.split(":"),
        _n$split4 = _slicedToArray(_n$split3, 2),
        _a4 = _n$split4[0],
        o = _n$split4[1];

    return {
      host: _a4,
      port: nl(o)
    };
  }
}

function nl(t) {
  if (!t) return null;
  var e = Number(t);
  return isNaN(e) ? null : e;
}

function Pg() {
  function t() {
    var e = document.createElement("p"),
        i = e.style;
    e.innerText = "Running in emulator mode. Do not use with production credentials.", i.position = "fixed", i.width = "100%", i.backgroundColor = "#ffffff", i.border = ".1em solid #000000", i.color = "#b50000", i.bottom = "0px", i.left = "0px", i.margin = "0px", i.zIndex = "10000", i.textAlign = "center", e.classList.add("firebase-emulator-warning"), document.body.appendChild(e);
  }

  typeof console != "undefined" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window != "undefined" && typeof document != "undefined" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", t) : t());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ki =
/*#__PURE__*/
function () {
  function ki(e, i) {
    _classCallCheck(this, ki);

    this.providerId = e, this.signInMethod = i;
  }

  _createClass(ki, [{
    key: "toJSON",
    value: function toJSON() {
      return dt("not implemented");
    }
  }, {
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(e) {
      return dt("not implemented");
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(e, i) {
      return dt("not implemented");
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(e) {
      return dt("not implemented");
    }
  }]);

  return ki;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ku(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee70() {
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) {
        switch (_context70.prev = _context70.next) {
          case 0:
            return _context70.abrupt("return", Re(t, "POST", "/v1/accounts:resetPassword", be(t, e)));

          case 1:
          case "end":
            return _context70.stop();
        }
      }
    }, _callee70);
  }));
}

function xu(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee71() {
    return _regeneratorRuntime.wrap(function _callee71$(_context71) {
      while (1) {
        switch (_context71.prev = _context71.next) {
          case 0:
            return _context71.abrupt("return", Re(t, "POST", "/v1/accounts:update", e));

          case 1:
          case "end":
            return _context71.stop();
        }
      }
    }, _callee71);
  }));
}

function Og(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee72() {
    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            return _context72.abrupt("return", Re(t, "POST", "/v1/accounts:update", be(t, e)));

          case 1:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Os(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee73() {
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            return _context73.abrupt("return", _t(t, "POST", "/v1/accounts:signInWithPassword", be(t, e)));

          case 1:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee73);
  }));
}

function Fr(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee74() {
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) {
        switch (_context74.prev = _context74.next) {
          case 0:
            return _context74.abrupt("return", Re(t, "POST", "/v1/accounts:sendOobCode", be(t, e)));

          case 1:
          case "end":
            return _context74.stop();
        }
      }
    }, _callee74);
  }));
}

function Ag(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee75() {
    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) {
        switch (_context75.prev = _context75.next) {
          case 0:
            return _context75.abrupt("return", Fr(t, e));

          case 1:
          case "end":
            return _context75.stop();
        }
      }
    }, _callee75);
  }));
}

function As(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee76() {
    return _regeneratorRuntime.wrap(function _callee76$(_context76) {
      while (1) {
        switch (_context76.prev = _context76.next) {
          case 0:
            return _context76.abrupt("return", Fr(t, e));

          case 1:
          case "end":
            return _context76.stop();
        }
      }
    }, _callee76);
  }));
}

function Ms(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee77() {
    return _regeneratorRuntime.wrap(function _callee77$(_context77) {
      while (1) {
        switch (_context77.prev = _context77.next) {
          case 0:
            return _context77.abrupt("return", Fr(t, e));

          case 1:
          case "end":
            return _context77.stop();
        }
      }
    }, _callee77);
  }));
}

function Mg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee78() {
    return _regeneratorRuntime.wrap(function _callee78$(_context78) {
      while (1) {
        switch (_context78.prev = _context78.next) {
          case 0:
            return _context78.abrupt("return", Fr(t, e));

          case 1:
          case "end":
            return _context78.stop();
        }
      }
    }, _callee78);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Fg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee79() {
    return _regeneratorRuntime.wrap(function _callee79$(_context79) {
      while (1) {
        switch (_context79.prev = _context79.next) {
          case 0:
            return _context79.abrupt("return", _t(t, "POST", "/v1/accounts:signInWithEmailLink", be(t, e)));

          case 1:
          case "end":
            return _context79.stop();
        }
      }
    }, _callee79);
  }));
}

function kg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee80() {
    return _regeneratorRuntime.wrap(function _callee80$(_context80) {
      while (1) {
        switch (_context80.prev = _context80.next) {
          case 0:
            return _context80.abrupt("return", _t(t, "POST", "/v1/accounts:signInWithEmailLink", be(t, e)));

          case 1:
          case "end":
            return _context80.stop();
        }
      }
    }, _callee80);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var hn =
/*#__PURE__*/
function (_ki) {
  _inherits(hn, _ki);

  function hn(e, i, n) {
    var _this28;

    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, hn);

    _this28 = _possibleConstructorReturn(this, _getPrototypeOf(hn).call(this, "password", n)), _this28._email = e, _this28._password = i, _this28._tenantId = r;
    return _this28;
  }

  _createClass(hn, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        email: this._email,
        password: this._password,
        signInMethod: this.signInMethod,
        tenantId: this._tenantId
      };
    }
  }, {
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee82() {
        var _this29 = this;

        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                _context82.t0 = this.signInMethod;
                _context82.next = _context82.t0 === "password" ? 3 : _context82.t0 === "emailLink" ? 12 : 13;
                break;

              case 3:
                n = {
                  returnSecureToken: !0,
                  email: this._email,
                  password: this._password,
                  clientType: "CLIENT_TYPE_WEB"
                };

                if (!(!((i = e._getRecaptchaConfig()) === null || i === void 0) && i.emailPasswordEnabled)) {
                  _context82.next = 11;
                  break;
                }

                _context82.next = 7;
                return Ht(e, n, "signInWithPassword");

              case 7:
                r = _context82.sent;
                return _context82.abrupt("return", Os(e, r));

              case 11:
                return _context82.abrupt("return", Os(e, n).catch(function (r) {
                  return u(_this29, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee81() {
                    var a;
                    return _regeneratorRuntime.wrap(function _callee81$(_context81) {
                      while (1) {
                        switch (_context81.prev = _context81.next) {
                          case 0:
                            if (!(r.code === "auth/missing-recaptcha-token")) {
                              _context81.next = 8;
                              break;
                            }

                            console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                            _context81.next = 4;
                            return Ht(e, n, "signInWithPassword");

                          case 4:
                            a = _context81.sent;
                            return _context81.abrupt("return", Os(e, a));

                          case 8:
                            return _context81.abrupt("return", Promise.reject(r));

                          case 9:
                          case "end":
                            return _context81.stop();
                        }
                      }
                    }, _callee81);
                  }));
                }));

              case 12:
                return _context82.abrupt("return", Fg(e, {
                  email: this._email,
                  oobCode: this._password
                }));

              case 13:
                Ae(e, "internal-error");

              case 14:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, this);
      }));
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee83() {
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                _context83.t0 = this.signInMethod;
                _context83.next = _context83.t0 === "password" ? 3 : _context83.t0 === "emailLink" ? 4 : 5;
                break;

              case 3:
                return _context83.abrupt("return", xu(e, {
                  idToken: i,
                  returnSecureToken: !0,
                  email: this._email,
                  password: this._password
                }));

              case 4:
                return _context83.abrupt("return", kg(e, {
                  idToken: i,
                  email: this._email,
                  oobCode: this._password
                }));

              case 5:
                Ae(e, "internal-error");

              case 6:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, this);
      }));
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(e) {
      return this._getIdTokenResponse(e);
    }
  }], [{
    key: "_fromEmailAndPassword",
    value: function _fromEmailAndPassword(e, i) {
      return new hn(e, i, "password");
    }
  }, {
    key: "_fromEmailAndCode",
    value: function _fromEmailAndCode(e, i) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new hn(e, i, "emailLink", n);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e) {
      var i = typeof e == "string" ? JSON.parse(e) : e;

      if ((i == null ? void 0 : i.email) && (i == null ? void 0 : i.password)) {
        if (i.signInMethod === "password") return this._fromEmailAndPassword(i.email, i.password);
        if (i.signInMethod === "emailLink") return this._fromEmailAndCode(i.email, i.password, i.tenantId);
      }

      return null;
    }
  }]);

  return hn;
}(ki);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function bt(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee84() {
    return _regeneratorRuntime.wrap(function _callee84$(_context84) {
      while (1) {
        switch (_context84.prev = _context84.next) {
          case 0:
            return _context84.abrupt("return", _t(t, "POST", "/v1/accounts:signInWithIdp", be(t, e)));

          case 1:
          case "end":
            return _context84.stop();
        }
      }
    }, _callee84);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var xg = "http://localhost";

var pt =
/*#__PURE__*/
function (_ki2) {
  _inherits(pt, _ki2);

  function pt() {
    var _this30;

    _classCallCheck(this, pt);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(pt).apply(this, arguments)), _this30.pendingToken = null;
    return _this30;
  }

  _createClass(pt, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        idToken: this.idToken,
        accessToken: this.accessToken,
        secret: this.secret,
        nonce: this.nonce,
        pendingToken: this.pendingToken,
        providerId: this.providerId,
        signInMethod: this.signInMethod
      };
    }
  }, {
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(e) {
      var i = this.buildRequest();
      return bt(e, i);
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(e, i) {
      var n = this.buildRequest();
      return n.idToken = i, bt(e, n);
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(e) {
      var i = this.buildRequest();
      return i.autoCreate = !1, bt(e, i);
    }
  }, {
    key: "buildRequest",
    value: function buildRequest() {
      var e = {
        requestUri: xg,
        returnSecureToken: !0
      };
      if (this.pendingToken) e.pendingToken = this.pendingToken;else {
        var i = {};
        this.idToken && (i.id_token = this.idToken), this.accessToken && (i.access_token = this.accessToken), this.secret && (i.oauth_token_secret = this.secret), i.providerId = this.providerId, this.nonce && !this.pendingToken && (i.nonce = this.nonce), e.postBody = Ai(i);
      }
      return e;
    }
  }], [{
    key: "_fromParams",
    value: function _fromParams(e) {
      var i = new pt(e.providerId, e.signInMethod);
      return e.idToken || e.accessToken ? (e.idToken && (i.idToken = e.idToken), e.accessToken && (i.accessToken = e.accessToken), e.nonce && !e.pendingToken && (i.nonce = e.nonce), e.pendingToken && (i.pendingToken = e.pendingToken)) : e.oauthToken && e.oauthTokenSecret ? (i.accessToken = e.oauthToken, i.secret = e.oauthTokenSecret) : Ae("argument-error"), i;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e) {
      var i = typeof e == "string" ? JSON.parse(e) : e,
          n = i.providerId,
          r = i.signInMethod,
          a = Ba(i, ["providerId", "signInMethod"]);
      if (!n || !r) return null;
      var o = new pt(n, r);
      return o.idToken = a.idToken || void 0, o.accessToken = a.accessToken || void 0, o.secret = a.secret, o.nonce = a.nonce, o.pendingToken = a.pendingToken || null, o;
    }
  }]);

  return pt;
}(ki);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Dg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee85() {
    return _regeneratorRuntime.wrap(function _callee85$(_context85) {
      while (1) {
        switch (_context85.prev = _context85.next) {
          case 0:
            return _context85.abrupt("return", Re(t, "POST", "/v1/accounts:sendVerificationCode", be(t, e)));

          case 1:
          case "end":
            return _context85.stop();
        }
      }
    }, _callee85);
  }));
}

function Ng(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee86() {
    return _regeneratorRuntime.wrap(function _callee86$(_context86) {
      while (1) {
        switch (_context86.prev = _context86.next) {
          case 0:
            return _context86.abrupt("return", _t(t, "POST", "/v1/accounts:signInWithPhoneNumber", be(t, e)));

          case 1:
          case "end":
            return _context86.stop();
        }
      }
    }, _callee86);
  }));
}

function Lg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee87() {
    var i;
    return _regeneratorRuntime.wrap(function _callee87$(_context87) {
      while (1) {
        switch (_context87.prev = _context87.next) {
          case 0:
            _context87.next = 2;
            return _t(t, "POST", "/v1/accounts:signInWithPhoneNumber", be(t, e));

          case 2:
            i = _context87.sent;

            if (!i.temporaryProof) {
              _context87.next = 5;
              break;
            }

            throw Yi(t, "account-exists-with-different-credential", i);

          case 5:
            return _context87.abrupt("return", i);

          case 6:
          case "end":
            return _context87.stop();
        }
      }
    }, _callee87);
  }));
}

var $g = {
  USER_NOT_FOUND: "user-not-found"
};

function Ug(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee88() {
    var i;
    return _regeneratorRuntime.wrap(function _callee88$(_context88) {
      while (1) {
        switch (_context88.prev = _context88.next) {
          case 0:
            i = Object.assign(Object.assign({}, e), {
              operation: "REAUTH"
            });
            return _context88.abrupt("return", _t(t, "POST", "/v1/accounts:signInWithPhoneNumber", be(t, i), $g));

          case 2:
          case "end":
            return _context88.stop();
        }
      }
    }, _callee88);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Xt =
/*#__PURE__*/
function (_ki3) {
  _inherits(Xt, _ki3);

  function Xt(e) {
    var _this31;

    _classCallCheck(this, Xt);

    _this31 = _possibleConstructorReturn(this, _getPrototypeOf(Xt).call(this, "phone", "phone")), _this31.params = e;
    return _this31;
  }

  _createClass(Xt, [{
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(e) {
      return Ng(e, this._makeVerificationRequest());
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(e, i) {
      return Lg(e, Object.assign({
        idToken: i
      }, this._makeVerificationRequest()));
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(e) {
      return Ug(e, this._makeVerificationRequest());
    }
  }, {
    key: "_makeVerificationRequest",
    value: function _makeVerificationRequest() {
      var _this$params = this.params,
          e = _this$params.temporaryProof,
          i = _this$params.phoneNumber,
          n = _this$params.verificationId,
          r = _this$params.verificationCode;
      return e && i ? {
        temporaryProof: e,
        phoneNumber: i
      } : {
        sessionInfo: n,
        code: r
      };
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = {
        providerId: this.providerId
      };
      return this.params.phoneNumber && (e.phoneNumber = this.params.phoneNumber), this.params.temporaryProof && (e.temporaryProof = this.params.temporaryProof), this.params.verificationCode && (e.verificationCode = this.params.verificationCode), this.params.verificationId && (e.verificationId = this.params.verificationId), e;
    }
  }], [{
    key: "_fromVerification",
    value: function _fromVerification(e, i) {
      return new Xt({
        verificationId: e,
        verificationCode: i
      });
    }
  }, {
    key: "_fromTokenResponse",
    value: function _fromTokenResponse(e, i) {
      return new Xt({
        phoneNumber: e,
        temporaryProof: i
      });
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e) {
      typeof e == "string" && (e = JSON.parse(e));
      var _e2 = e,
          i = _e2.verificationId,
          n = _e2.verificationCode,
          r = _e2.phoneNumber,
          a = _e2.temporaryProof;
      return !n && !i && !r && !a ? null : new Xt({
        verificationId: i,
        verificationCode: n,
        phoneNumber: r,
        temporaryProof: a
      });
    }
  }]);

  return Xt;
}(ki);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Bg(t) {
  switch (t) {
    case "recoverEmail":
      return "RECOVER_EMAIL";

    case "resetPassword":
      return "PASSWORD_RESET";

    case "signIn":
      return "EMAIL_SIGNIN";

    case "verifyEmail":
      return "VERIFY_EMAIL";

    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";

    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";

    default:
      return null;
  }
}

function Hg(t) {
  var e = fi(Qi(t)).link,
      i = e ? fi(Qi(e)).deep_link_id : null,
      n = fi(Qi(t)).deep_link_id;
  return (n ? fi(Qi(n)).link : null) || n || i || e || t;
}

var kr =
/*#__PURE__*/
function () {
  function kr(e) {
    _classCallCheck(this, kr);

    var i, n, r, a, o, l;
    var c = fi(Qi(e)),
        d = (i = c.apiKey) !== null && i !== void 0 ? i : null,
        h = (n = c.oobCode) !== null && n !== void 0 ? n : null,
        p = Bg((r = c.mode) !== null && r !== void 0 ? r : null);
    B(d && h && p, "argument-error"), this.apiKey = d, this.operation = p, this.code = h, this.continueUrl = (a = c.continueUrl) !== null && a !== void 0 ? a : null, this.languageCode = (o = c.languageCode) !== null && o !== void 0 ? o : null, this.tenantId = (l = c.tenantId) !== null && l !== void 0 ? l : null;
  }

  _createClass(kr, null, [{
    key: "parseLink",
    value: function parseLink(e) {
      var i = Hg(e);

      try {
        return new kr(i);
      } catch (n) {
        return null;
      }
    }
  }]);

  return kr;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var jt =
/*#__PURE__*/
function () {
  function jt() {
    _classCallCheck(this, jt);

    this.providerId = jt.PROVIDER_ID;
  }

  _createClass(jt, null, [{
    key: "credential",
    value: function credential(e, i) {
      return hn._fromEmailAndPassword(e, i);
    }
  }, {
    key: "credentialWithLink",
    value: function credentialWithLink(e, i) {
      var n = kr.parseLink(i);
      return B(n, "argument-error"), hn._fromEmailAndCode(e, n.code, n.tenantId);
    }
  }]);

  return jt;
}();

jt.PROVIDER_ID = "password";
jt.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
jt.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Et =
/*#__PURE__*/
function () {
  function Et(e) {
    _classCallCheck(this, Et);

    this.providerId = e, this.defaultLanguageCode = null, this.customParameters = {};
  }

  _createClass(Et, [{
    key: "setDefaultLanguage",
    value: function setDefaultLanguage(e) {
      this.defaultLanguageCode = e;
    }
  }, {
    key: "setCustomParameters",
    value: function setCustomParameters(e) {
      return this.customParameters = e, this;
    }
  }, {
    key: "getCustomParameters",
    value: function getCustomParameters() {
      return this.customParameters;
    }
  }]);

  return Et;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var xi =
/*#__PURE__*/
function (_Et) {
  _inherits(xi, _Et);

  function xi() {
    var _this32;

    _classCallCheck(this, xi);

    _this32 = _possibleConstructorReturn(this, _getPrototypeOf(xi).apply(this, arguments)), _this32.scopes = [];
    return _this32;
  }

  _createClass(xi, [{
    key: "addScope",
    value: function addScope(e) {
      return this.scopes.includes(e) || this.scopes.push(e), this;
    }
  }, {
    key: "getScopes",
    value: function getScopes() {
      return _toConsumableArray(this.scopes);
    }
  }]);

  return xi;
}(Et);

var yi =
/*#__PURE__*/
function (_xi) {
  _inherits(yi, _xi);

  function yi() {
    _classCallCheck(this, yi);

    return _possibleConstructorReturn(this, _getPrototypeOf(yi).apply(this, arguments));
  }

  _createClass(yi, [{
    key: "credential",
    value: function credential(e) {
      return this._credential(Object.assign(Object.assign({}, e), {
        nonce: e.rawNonce
      }));
    }
  }, {
    key: "_credential",
    value: function _credential(e) {
      return B(e.idToken || e.accessToken, "argument-error"), pt._fromParams(Object.assign(Object.assign({}, e), {
        providerId: this.providerId,
        signInMethod: this.providerId
      }));
    }
  }], [{
    key: "credentialFromJSON",
    value: function credentialFromJSON(e) {
      var i = typeof e == "string" ? JSON.parse(e) : e;
      return B("providerId" in i && "signInMethod" in i, "argument-error"), pt._fromParams(i);
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(e) {
      return yi.oauthCredentialFromTaggedObject(e);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(e) {
      return yi.oauthCredentialFromTaggedObject(e.customData || {});
    }
  }, {
    key: "oauthCredentialFromTaggedObject",
    value: function oauthCredentialFromTaggedObject(_ref17) {
      var e = _ref17._tokenResponse;
      if (!e) return null;
      var i = e.oauthIdToken,
          n = e.oauthAccessToken,
          r = e.oauthTokenSecret,
          a = e.pendingToken,
          o = e.nonce,
          l = e.providerId;
      if (!n && !r && !i && !a || !l) return null;

      try {
        return new yi(l)._credential({
          idToken: i,
          accessToken: n,
          nonce: o,
          pendingToken: a
        });
      } catch (c) {
        return null;
      }
    }
  }]);

  return yi;
}(xi);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ot =
/*#__PURE__*/
function (_xi2) {
  _inherits(ot, _xi2);

  function ot() {
    _classCallCheck(this, ot);

    return _possibleConstructorReturn(this, _getPrototypeOf(ot).call(this, "facebook.com"));
  }

  _createClass(ot, null, [{
    key: "credential",
    value: function credential(e) {
      return pt._fromParams({
        providerId: ot.PROVIDER_ID,
        signInMethod: ot.FACEBOOK_SIGN_IN_METHOD,
        accessToken: e
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(e) {
      return ot.credentialFromTaggedObject(e);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(e) {
      return ot.credentialFromTaggedObject(e.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref18) {
      var e = _ref18._tokenResponse;
      if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken) return null;

      try {
        return ot.credential(e.oauthAccessToken);
      } catch (i) {
        return null;
      }
    }
  }]);

  return ot;
}(xi);

ot.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
ot.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var lt =
/*#__PURE__*/
function (_xi3) {
  _inherits(lt, _xi3);

  function lt() {
    var _this33;

    _classCallCheck(this, lt);

    _this33 = _possibleConstructorReturn(this, _getPrototypeOf(lt).call(this, "google.com")), _this33.addScope("profile");
    return _this33;
  }

  _createClass(lt, null, [{
    key: "credential",
    value: function credential(e, i) {
      return pt._fromParams({
        providerId: lt.PROVIDER_ID,
        signInMethod: lt.GOOGLE_SIGN_IN_METHOD,
        idToken: e,
        accessToken: i
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(e) {
      return lt.credentialFromTaggedObject(e);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(e) {
      return lt.credentialFromTaggedObject(e.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref19) {
      var e = _ref19._tokenResponse;
      if (!e) return null;
      var i = e.oauthIdToken,
          n = e.oauthAccessToken;
      if (!i && !n) return null;

      try {
        return lt.credential(i, n);
      } catch (r) {
        return null;
      }
    }
  }]);

  return lt;
}(xi);

lt.GOOGLE_SIGN_IN_METHOD = "google.com";
lt.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var ct =
/*#__PURE__*/
function (_xi4) {
  _inherits(ct, _xi4);

  function ct() {
    _classCallCheck(this, ct);

    return _possibleConstructorReturn(this, _getPrototypeOf(ct).call(this, "github.com"));
  }

  _createClass(ct, null, [{
    key: "credential",
    value: function credential(e) {
      return pt._fromParams({
        providerId: ct.PROVIDER_ID,
        signInMethod: ct.GITHUB_SIGN_IN_METHOD,
        accessToken: e
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(e) {
      return ct.credentialFromTaggedObject(e);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(e) {
      return ct.credentialFromTaggedObject(e.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref20) {
      var e = _ref20._tokenResponse;
      if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken) return null;

      try {
        return ct.credential(e.oauthAccessToken);
      } catch (i) {
        return null;
      }
    }
  }]);

  return ct;
}(xi);

ct.GITHUB_SIGN_IN_METHOD = "github.com";
ct.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Vg = "http://localhost";

var Ci =
/*#__PURE__*/
function (_ki4) {
  _inherits(Ci, _ki4);

  function Ci(e, i) {
    var _this34;

    _classCallCheck(this, Ci);

    _this34 = _possibleConstructorReturn(this, _getPrototypeOf(Ci).call(this, e, e)), _this34.pendingToken = i;
    return _this34;
  }

  _createClass(Ci, [{
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(e) {
      var i = this.buildRequest();
      return bt(e, i);
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(e, i) {
      var n = this.buildRequest();
      return n.idToken = i, bt(e, n);
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(e) {
      var i = this.buildRequest();
      return i.autoCreate = !1, bt(e, i);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        signInMethod: this.signInMethod,
        providerId: this.providerId,
        pendingToken: this.pendingToken
      };
    }
  }, {
    key: "buildRequest",
    value: function buildRequest() {
      return {
        requestUri: Vg,
        returnSecureToken: !0,
        pendingToken: this.pendingToken
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(e) {
      var i = typeof e == "string" ? JSON.parse(e) : e,
          n = i.providerId,
          r = i.signInMethod,
          a = i.pendingToken;
      return !n || !r || !a || n !== r ? null : new Ci(n, a);
    }
  }, {
    key: "_create",
    value: function _create(e, i) {
      return new Ci(e, i);
    }
  }]);

  return Ci;
}(ki);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var jg = "saml.";

var or =
/*#__PURE__*/
function (_Et2) {
  _inherits(or, _Et2);

  function or(e) {
    var _this35;

    _classCallCheck(this, or);

    B(e.startsWith(jg), "argument-error"), _this35 = _possibleConstructorReturn(this, _getPrototypeOf(or).call(this, e));
    return _this35;
  }

  _createClass(or, null, [{
    key: "credentialFromResult",
    value: function credentialFromResult(e) {
      return or.samlCredentialFromTaggedObject(e);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(e) {
      return or.samlCredentialFromTaggedObject(e.customData || {});
    }
  }, {
    key: "credentialFromJSON",
    value: function credentialFromJSON(e) {
      var i = Ci.fromJSON(e);
      return B(i, "argument-error"), i;
    }
  }, {
    key: "samlCredentialFromTaggedObject",
    value: function samlCredentialFromTaggedObject(_ref21) {
      var e = _ref21._tokenResponse;
      if (!e) return null;
      var i = e.pendingToken,
          n = e.providerId;
      if (!i || !n) return null;

      try {
        return Ci._create(n, i);
      } catch (r) {
        return null;
      }
    }
  }]);

  return or;
}(Et);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ut =
/*#__PURE__*/
function (_xi5) {
  _inherits(ut, _xi5);

  function ut() {
    _classCallCheck(this, ut);

    return _possibleConstructorReturn(this, _getPrototypeOf(ut).call(this, "twitter.com"));
  }

  _createClass(ut, null, [{
    key: "credential",
    value: function credential(e, i) {
      return pt._fromParams({
        providerId: ut.PROVIDER_ID,
        signInMethod: ut.TWITTER_SIGN_IN_METHOD,
        oauthToken: e,
        oauthTokenSecret: i
      });
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(e) {
      return ut.credentialFromTaggedObject(e);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(e) {
      return ut.credentialFromTaggedObject(e.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref22) {
      var e = _ref22._tokenResponse;
      if (!e) return null;
      var i = e.oauthAccessToken,
          n = e.oauthTokenSecret;
      if (!i || !n) return null;

      try {
        return ut.credential(i, n);
      } catch (r) {
        return null;
      }
    }
  }]);

  return ut;
}(xi);

ut.TWITTER_SIGN_IN_METHOD = "twitter.com";
ut.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function jn(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee89() {
    return _regeneratorRuntime.wrap(function _callee89$(_context89) {
      while (1) {
        switch (_context89.prev = _context89.next) {
          case 0:
            return _context89.abrupt("return", _t(t, "POST", "/v1/accounts:signUp", be(t, e)));

          case 1:
          case "end":
            return _context89.stop();
        }
      }
    }, _callee89);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Xe =
/*#__PURE__*/
function () {
  function Xe(e) {
    _classCallCheck(this, Xe);

    this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
  }

  _createClass(Xe, null, [{
    key: "_fromIdTokenResponse",
    value: function _fromIdTokenResponse(e, i, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee90() {
        var a, o;
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                _context90.next = 2;
                return Kt._fromIdTokenResponse(e, n, r);

              case 2:
                a = _context90.sent;
                o = rl(n);
                return _context90.abrupt("return", new Xe({
                  user: a,
                  providerId: o,
                  _tokenResponse: n,
                  operationType: i
                }));

              case 5:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90);
      }));
    }
  }, {
    key: "_forOperation",
    value: function _forOperation(e, i, n) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee91() {
        var r;
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                _context91.next = 2;
                return e._updateTokensIfNecessary(n, !0);

              case 2:
                r = rl(n);
                return _context91.abrupt("return", new Xe({
                  user: e,
                  providerId: r,
                  _tokenResponse: n,
                  operationType: i
                }));

              case 4:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91);
      }));
    }
  }]);

  return Xe;
}();

function rl(t) {
  return t.providerId ? t.providerId : "phoneNumber" in t ? "phone" : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Wg(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee92() {
    var e, i, n, r;
    return _regeneratorRuntime.wrap(function _callee92$(_context92) {
      while (1) {
        switch (_context92.prev = _context92.next) {
          case 0:
            i = fe(t);
            _context92.next = 3;
            return i._initializationPromise;

          case 3:
            if (!(!((e = i.currentUser) === null || e === void 0) && e.isAnonymous)) {
              _context92.next = 5;
              break;
            }

            return _context92.abrupt("return", new Xe({
              user: i.currentUser,
              providerId: null,
              operationType: "signIn"
            }));

          case 5:
            _context92.next = 7;
            return jn(i, {
              returnSecureToken: !0
            });

          case 7:
            n = _context92.sent;
            _context92.next = 10;
            return Xe._fromIdTokenResponse(i, "signIn", n, !0);

          case 10:
            r = _context92.sent;
            _context92.next = 13;
            return i._updateCurrentUser(r.user);

          case 13:
            return _context92.abrupt("return", r);

          case 14:
          case "end":
            return _context92.stop();
        }
      }
    }, _callee92);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var lr =
/*#__PURE__*/
function (_Ve) {
  _inherits(lr, _Ve);

  function lr(e, i, n, r) {
    var _this36;

    _classCallCheck(this, lr);

    var a;
    _this36 = _possibleConstructorReturn(this, _getPrototypeOf(lr).call(this, i.code, i.message)), _this36.operationType = n, _this36.user = r, Object.setPrototypeOf(_assertThisInitialized(_this36), lr.prototype), _this36.customData = {
      appName: e.name,
      tenantId: (a = e.tenantId) !== null && a !== void 0 ? a : void 0,
      _serverResponse: i.customData._serverResponse,
      operationType: n
    };
    return _this36;
  }

  _createClass(lr, null, [{
    key: "_fromErrorAndOperation",
    value: function _fromErrorAndOperation(e, i, n, r) {
      return new lr(e, i, n, r);
    }
  }]);

  return lr;
}(Ve);

function Du(t, e, i, n) {
  return (e === "reauthenticate" ? i._getReauthenticationResolver(t) : i._getIdTokenResponse(t)).catch(function (a) {
    throw a.code === "auth/multi-factor-auth-required" ? lr._fromErrorAndOperation(t, a, e, n) : a;
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Nu(t) {
  return new Set(t.map(function (_ref23) {
    var e = _ref23.providerId;
    return e;
  }).filter(function (e) {
    return !!e;
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Gg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee93() {
    var i, _ref24, n, r;

    return _regeneratorRuntime.wrap(function _callee93$(_context93) {
      while (1) {
        switch (_context93.prev = _context93.next) {
          case 0:
            i = te(t);
            _context93.next = 3;
            return xr(!0, i, e);

          case 3:
            _context93.t0 = rg;
            _context93.t1 = i.auth;
            _context93.next = 7;
            return i.getIdToken();

          case 7:
            _context93.t2 = _context93.sent;
            _context93.t3 = [e];
            _context93.t4 = {
              idToken: _context93.t2,
              deleteProvider: _context93.t3
            };
            _context93.next = 12;
            return (0, _context93.t0)(_context93.t1, _context93.t4);

          case 12:
            _ref24 = _context93.sent;
            n = _ref24.providerUserInfo;
            r = Nu(n || []);
            i.providerData = i.providerData.filter(function (a) {
              return r.has(a.providerId);
            });
            r.has("phone") || (i.phoneNumber = null);
            _context93.next = 19;
            return i.auth._persistUserIfCurrent(i);

          case 19:
            return _context93.abrupt("return", i);

          case 20:
          case "end":
            return _context93.stop();
        }
      }
    }, _callee93);
  }));
}

function qa(t, e) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee94() {
    var n;
    return _regeneratorRuntime.wrap(function _callee94$(_context94) {
      while (1) {
        switch (_context94.prev = _context94.next) {
          case 0:
            _context94.t0 = It;
            _context94.t1 = t;
            _context94.t2 = e;
            _context94.t3 = t.auth;
            _context94.next = 6;
            return t.getIdToken();

          case 6:
            _context94.t4 = _context94.sent;
            _context94.t5 = _context94.t2._linkToIdToken.call(_context94.t2, _context94.t3, _context94.t4);
            _context94.t6 = i;
            _context94.next = 11;
            return (0, _context94.t0)(_context94.t1, _context94.t5, _context94.t6);

          case 11:
            n = _context94.sent;
            return _context94.abrupt("return", Xe._forOperation(t, "link", n));

          case 13:
          case "end":
            return _context94.stop();
        }
      }
    }, _callee94);
  }));
}

function xr(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee95() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee95$(_context95) {
      while (1) {
        switch (_context95.prev = _context95.next) {
          case 0:
            _context95.next = 2;
            return un(e);

          case 2:
            n = Nu(e.providerData), r = t === !1 ? "provider-already-linked" : "no-such-provider";
            B(n.has(i) === t, e.auth, r);

          case 4:
          case "end":
            return _context95.stop();
        }
      }
    }, _callee95);
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Lu(t, e) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee96() {
    var n, r, a, o, l;
    return _regeneratorRuntime.wrap(function _callee96$(_context96) {
      while (1) {
        switch (_context96.prev = _context96.next) {
          case 0:
            n = t.auth, r = "reauthenticate";
            _context96.prev = 1;
            _context96.next = 4;
            return It(t, Du(n, r, e, t), i);

          case 4:
            a = _context96.sent;
            B(a.idToken, n, "internal-error");
            o = Mr(a.idToken);
            B(o, n, "internal-error");
            l = o.sub;
            return _context96.abrupt("return", (B(t.uid === l, n, "user-mismatch"), Xe._forOperation(t, r, a)));

          case 12:
            _context96.prev = 12;
            _context96.t0 = _context96["catch"](1);
            throw (_context96.t0 == null ? void 0 : _context96.t0.code) === "auth/user-not-found" && Ae(n, "user-mismatch"), _context96.t0;

          case 15:
          case "end":
            return _context96.stop();
        }
      }
    }, _callee96, null, [[1, 12]]);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function $u(t, e) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee97() {
    var n, r, a;
    return _regeneratorRuntime.wrap(function _callee97$(_context97) {
      while (1) {
        switch (_context97.prev = _context97.next) {
          case 0:
            n = "signIn";
            _context97.next = 3;
            return Du(t, n, e);

          case 3:
            r = _context97.sent;
            _context97.next = 6;
            return Xe._fromIdTokenResponse(t, n, r);

          case 6:
            a = _context97.sent;
            _context97.t0 = i;

            if (_context97.t0) {
              _context97.next = 11;
              break;
            }

            _context97.next = 11;
            return t._updateCurrentUser(a.user);

          case 11:
            return _context97.abrupt("return", a);

          case 12:
          case "end":
            return _context97.stop();
        }
      }
    }, _callee97);
  }));
}

function Dr(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee98() {
    return _regeneratorRuntime.wrap(function _callee98$(_context98) {
      while (1) {
        switch (_context98.prev = _context98.next) {
          case 0:
            return _context98.abrupt("return", $u(fe(t), e));

          case 1:
          case "end":
            return _context98.stop();
        }
      }
    }, _callee98);
  }));
}

function Uu(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee99() {
    var i;
    return _regeneratorRuntime.wrap(function _callee99$(_context99) {
      while (1) {
        switch (_context99.prev = _context99.next) {
          case 0:
            i = te(t);
            _context99.next = 3;
            return xr(!1, i, e.providerId);

          case 3:
            return _context99.abrupt("return", qa(i, e));

          case 4:
          case "end":
            return _context99.stop();
        }
      }
    }, _callee99);
  }));
}

function Bu(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee100() {
    return _regeneratorRuntime.wrap(function _callee100$(_context100) {
      while (1) {
        switch (_context100.prev = _context100.next) {
          case 0:
            return _context100.abrupt("return", Lu(te(t), e));

          case 1:
          case "end":
            return _context100.stop();
        }
      }
    }, _callee100);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function zg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee101() {
    return _regeneratorRuntime.wrap(function _callee101$(_context101) {
      while (1) {
        switch (_context101.prev = _context101.next) {
          case 0:
            return _context101.abrupt("return", _t(t, "POST", "/v1/accounts:signInWithCustomToken", be(t, e)));

          case 1:
          case "end":
            return _context101.stop();
        }
      }
    }, _callee101);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function qg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee102() {
    var i, n, r;
    return _regeneratorRuntime.wrap(function _callee102$(_context102) {
      while (1) {
        switch (_context102.prev = _context102.next) {
          case 0:
            i = fe(t);
            _context102.next = 3;
            return zg(i, {
              token: e,
              returnSecureToken: !0
            });

          case 3:
            n = _context102.sent;
            _context102.next = 6;
            return Xe._fromIdTokenResponse(i, "signIn", n);

          case 6:
            r = _context102.sent;
            _context102.next = 9;
            return i._updateCurrentUser(r.user);

          case 9:
            return _context102.abrupt("return", r);

          case 10:
          case "end":
            return _context102.stop();
        }
      }
    }, _callee102);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var wn =
/*#__PURE__*/
function () {
  function wn(e, i) {
    _classCallCheck(this, wn);

    this.factorId = e, this.uid = i.mfaEnrollmentId, this.enrollmentTime = new Date(i.enrolledAt).toUTCString(), this.displayName = i.displayName;
  }

  _createClass(wn, null, [{
    key: "_fromServerResponse",
    value: function _fromServerResponse(e, i) {
      return "phoneInfo" in i ? Qa._fromServerResponse(e, i) : "totpInfo" in i ? Ya._fromServerResponse(e, i) : Ae(e, "internal-error");
    }
  }]);

  return wn;
}();

var Qa =
/*#__PURE__*/
function (_wn) {
  _inherits(Qa, _wn);

  function Qa(e) {
    var _this37;

    _classCallCheck(this, Qa);

    _this37 = _possibleConstructorReturn(this, _getPrototypeOf(Qa).call(this, "phone", e)), _this37.phoneNumber = e.phoneInfo;
    return _this37;
  }

  _createClass(Qa, null, [{
    key: "_fromServerResponse",
    value: function _fromServerResponse(e, i) {
      return new Qa(i);
    }
  }]);

  return Qa;
}(wn);

var Ya =
/*#__PURE__*/
function (_wn2) {
  _inherits(Ya, _wn2);

  function Ya(e) {
    _classCallCheck(this, Ya);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ya).call(this, "totp", e));
  }

  _createClass(Ya, null, [{
    key: "_fromServerResponse",
    value: function _fromServerResponse(e, i) {
      return new Ya(i);
    }
  }]);

  return Ya;
}(wn);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function vi(t, e, i) {
  var n;
  B(((n = i.url) === null || n === void 0 ? void 0 : n.length) > 0, t, "invalid-continue-uri"), B(typeof i.dynamicLinkDomain == "undefined" || i.dynamicLinkDomain.length > 0, t, "invalid-dynamic-link-domain"), e.continueUrl = i.url, e.dynamicLinkDomain = i.dynamicLinkDomain, e.canHandleCodeInApp = i.handleCodeInApp, i.iOS && (B(i.iOS.bundleId.length > 0, t, "missing-ios-bundle-id"), e.iOSBundleId = i.iOS.bundleId), i.android && (B(i.android.packageName.length > 0, t, "missing-android-pkg-name"), e.androidInstallApp = i.android.installApp, e.androidMinimumVersionCode = i.android.minimumVersion, e.androidPackageName = i.android.packageName);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Qg(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee104() {
    var _this38 = this;

    var n, r, a, o;
    return _regeneratorRuntime.wrap(function _callee104$(_context104) {
      while (1) {
        switch (_context104.prev = _context104.next) {
          case 0:
            r = fe(t), a = {
              requestType: "PASSWORD_RESET",
              email: e,
              clientType: "CLIENT_TYPE_WEB"
            };

            if (!(!((n = r._getRecaptchaConfig()) === null || n === void 0) && n.emailPasswordEnabled)) {
              _context104.next = 10;
              break;
            }

            _context104.next = 4;
            return Ht(r, a, "getOobCode", !0);

          case 4:
            o = _context104.sent;
            i && vi(r, o, i);
            _context104.next = 8;
            return As(r, o);

          case 8:
            _context104.next = 13;
            break;

          case 10:
            i && vi(r, a, i);
            _context104.next = 13;
            return As(r, a).catch(function (o) {
              return u(_this38, null,
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee103() {
                var l;
                return _regeneratorRuntime.wrap(function _callee103$(_context103) {
                  while (1) {
                    switch (_context103.prev = _context103.next) {
                      case 0:
                        if (!(o.code === "auth/missing-recaptcha-token")) {
                          _context103.next = 10;
                          break;
                        }

                        console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                        _context103.next = 4;
                        return Ht(r, a, "getOobCode", !0);

                      case 4:
                        l = _context103.sent;
                        i && vi(r, l, i);
                        _context103.next = 8;
                        return As(r, l);

                      case 8:
                        _context103.next = 11;
                        break;

                      case 10:
                        return _context103.abrupt("return", Promise.reject(o));

                      case 11:
                      case "end":
                        return _context103.stop();
                    }
                  }
                }, _callee103);
              }));
            });

          case 13:
          case "end":
            return _context104.stop();
        }
      }
    }, _callee104);
  }));
}

function Yg(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee105() {
    return _regeneratorRuntime.wrap(function _callee105$(_context105) {
      while (1) {
        switch (_context105.prev = _context105.next) {
          case 0:
            _context105.next = 2;
            return ku(te(t), {
              oobCode: e,
              newPassword: i
            });

          case 2:
          case "end":
            return _context105.stop();
        }
      }
    }, _callee105);
  }));
}

function Kg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee106() {
    return _regeneratorRuntime.wrap(function _callee106$(_context106) {
      while (1) {
        switch (_context106.prev = _context106.next) {
          case 0:
            _context106.next = 2;
            return Og(te(t), {
              oobCode: e
            });

          case 2:
          case "end":
            return _context106.stop();
        }
      }
    }, _callee106);
  }));
}

function Hu(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee107() {
    var i, n, r, a;
    return _regeneratorRuntime.wrap(function _callee107$(_context107) {
      while (1) {
        switch (_context107.prev = _context107.next) {
          case 0:
            i = te(t);
            _context107.next = 3;
            return ku(i, {
              oobCode: e
            });

          case 3:
            n = _context107.sent;
            r = n.requestType;
            _context107.t0 = (B(r, i, "internal-error"), r);
            _context107.next = _context107.t0 === "EMAIL_SIGNIN" ? 8 : _context107.t0 === "VERIFY_AND_CHANGE_EMAIL" ? 9 : _context107.t0 === "REVERT_SECOND_FACTOR_ADDITION" ? 11 : 12;
            break;

          case 8:
            return _context107.abrupt("break", 13);

          case 9:
            B(n.newEmail, i, "internal-error");
            return _context107.abrupt("break", 13);

          case 11:
            B(n.mfaInfo, i, "internal-error");

          case 12:
            B(n.email, i, "internal-error");

          case 13:
            a = null;
            return _context107.abrupt("return", (n.mfaInfo && (a = wn._fromServerResponse(fe(i), n.mfaInfo)), {
              data: {
                email: (n.requestType === "VERIFY_AND_CHANGE_EMAIL" ? n.newEmail : n.email) || null,
                previousEmail: (n.requestType === "VERIFY_AND_CHANGE_EMAIL" ? n.email : n.newEmail) || null,
                multiFactorInfo: a
              },
              operation: r
            }));

          case 15:
          case "end":
            return _context107.stop();
        }
      }
    }, _callee107);
  }));
}

function Jg(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee108() {
    var _ref25, i;

    return _regeneratorRuntime.wrap(function _callee108$(_context108) {
      while (1) {
        switch (_context108.prev = _context108.next) {
          case 0:
            _context108.next = 2;
            return Hu(te(t), e);

          case 2:
            _ref25 = _context108.sent;
            i = _ref25.data;
            return _context108.abrupt("return", i.email);

          case 5:
          case "end":
            return _context108.stop();
        }
      }
    }, _callee108);
  }));
}

function Xg(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee110() {
    var _this39 = this;

    var n, r, a, o, d, l, c;
    return _regeneratorRuntime.wrap(function _callee110$(_context110) {
      while (1) {
        switch (_context110.prev = _context110.next) {
          case 0:
            r = fe(t), a = {
              returnSecureToken: !0,
              email: e,
              password: i,
              clientType: "CLIENT_TYPE_WEB"
            };

            if (!(!((n = r._getRecaptchaConfig()) === null || n === void 0) && n.emailPasswordEnabled)) {
              _context110.next = 8;
              break;
            }

            _context110.next = 4;
            return Ht(r, a, "signUpPassword");

          case 4:
            d = _context110.sent;
            o = jn(r, d);
            _context110.next = 9;
            break;

          case 8:
            o = jn(r, a).catch(function (d) {
              return u(_this39, null,
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee109() {
                var h;
                return _regeneratorRuntime.wrap(function _callee109$(_context109) {
                  while (1) {
                    switch (_context109.prev = _context109.next) {
                      case 0:
                        if (!(d.code === "auth/missing-recaptcha-token")) {
                          _context109.next = 8;
                          break;
                        }

                        console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
                        _context109.next = 4;
                        return Ht(r, a, "signUpPassword");

                      case 4:
                        h = _context109.sent;
                        return _context109.abrupt("return", jn(r, h));

                      case 8:
                        return _context109.abrupt("return", Promise.reject(d));

                      case 9:
                      case "end":
                        return _context109.stop();
                    }
                  }
                }, _callee109);
              }));
            });

          case 9:
            _context110.next = 11;
            return o.catch(function (d) {
              return Promise.reject(d);
            });

          case 11:
            l = _context110.sent;
            _context110.next = 14;
            return Xe._fromIdTokenResponse(r, "signIn", l);

          case 14:
            c = _context110.sent;
            _context110.next = 17;
            return r._updateCurrentUser(c.user);

          case 17:
            return _context110.abrupt("return", c);

          case 18:
          case "end":
            return _context110.stop();
        }
      }
    }, _callee110);
  }));
}

function Zg(t, e, i) {
  return Dr(te(t), jt.credential(e, i));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ey(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee112() {
    var _this40 = this;

    var n, r, a, o, l;
    return _regeneratorRuntime.wrap(function _callee112$(_context112) {
      while (1) {
        switch (_context112.prev = _context112.next) {
          case 0:
            o = function _ref26(l, c) {
              B(c.handleCodeInApp, r, "argument-error"), c && vi(r, l, c);
            };

            r = fe(t), a = {
              requestType: "EMAIL_SIGNIN",
              email: e,
              clientType: "CLIENT_TYPE_WEB"
            };

            if (!(!((n = r._getRecaptchaConfig()) === null || n === void 0) && n.emailPasswordEnabled)) {
              _context112.next = 11;
              break;
            }

            _context112.next = 5;
            return Ht(r, a, "getOobCode", !0);

          case 5:
            l = _context112.sent;
            o(l, i);
            _context112.next = 9;
            return Ms(r, l);

          case 9:
            _context112.next = 14;
            break;

          case 11:
            o(a, i);
            _context112.next = 14;
            return Ms(r, a).catch(function (l) {
              return u(_this40, null,
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee111() {
                var c;
                return _regeneratorRuntime.wrap(function _callee111$(_context111) {
                  while (1) {
                    switch (_context111.prev = _context111.next) {
                      case 0:
                        if (!(l.code === "auth/missing-recaptcha-token")) {
                          _context111.next = 10;
                          break;
                        }

                        console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                        _context111.next = 4;
                        return Ht(r, a, "getOobCode", !0);

                      case 4:
                        c = _context111.sent;
                        o(c, i);
                        _context111.next = 8;
                        return Ms(r, c);

                      case 8:
                        _context111.next = 11;
                        break;

                      case 10:
                        return _context111.abrupt("return", Promise.reject(l));

                      case 11:
                      case "end":
                        return _context111.stop();
                    }
                  }
                }, _callee111);
              }));
            });

          case 14:
          case "end":
            return _context112.stop();
        }
      }
    }, _callee112);
  }));
}

function ty(t, e) {
  var i = kr.parseLink(e);
  return (i == null ? void 0 : i.operation) === "EMAIL_SIGNIN";
}

function iy(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee113() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee113$(_context113) {
      while (1) {
        switch (_context113.prev = _context113.next) {
          case 0:
            n = te(t), r = jt.credentialWithLink(e, i || cn());
            return _context113.abrupt("return", (B(r._tenantId === (n.tenantId || null), n, "tenant-id-mismatch"), Dr(n, r)));

          case 2:
          case "end":
            return _context113.stop();
        }
      }
    }, _callee113);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ny(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee114() {
    return _regeneratorRuntime.wrap(function _callee114$(_context114) {
      while (1) {
        switch (_context114.prev = _context114.next) {
          case 0:
            return _context114.abrupt("return", Re(t, "POST", "/v1/accounts:createAuthUri", be(t, e)));

          case 1:
          case "end":
            return _context114.stop();
        }
      }
    }, _callee114);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ry(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee115() {
    var i, n, _ref27, r;

    return _regeneratorRuntime.wrap(function _callee115$(_context115) {
      while (1) {
        switch (_context115.prev = _context115.next) {
          case 0:
            i = Va() ? cn() : "http://localhost";
            n = {
              identifier: e,
              continueUri: i
            };
            _context115.next = 4;
            return ny(te(t), n);

          case 4:
            _ref27 = _context115.sent;
            r = _ref27.signinMethods;
            return _context115.abrupt("return", r || []);

          case 7:
          case "end":
            return _context115.stop();
        }
      }
    }, _callee115);
  }));
}

function sy(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee116() {
    var i, r, _ref28, a;

    return _regeneratorRuntime.wrap(function _callee116$(_context116) {
      while (1) {
        switch (_context116.prev = _context116.next) {
          case 0:
            i = te(t);
            _context116.next = 3;
            return t.getIdToken();

          case 3:
            _context116.t0 = _context116.sent;
            r = {
              requestType: "VERIFY_EMAIL",
              idToken: _context116.t0
            };
            e && vi(i.auth, r, e);
            _context116.next = 8;
            return Ag(i.auth, r);

          case 8:
            _ref28 = _context116.sent;
            a = _ref28.email;
            _context116.t1 = a !== t.email;

            if (!_context116.t1) {
              _context116.next = 14;
              break;
            }

            _context116.next = 14;
            return t.reload();

          case 14:
          case "end":
            return _context116.stop();
        }
      }
    }, _callee116);
  }));
}

function ay(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee117() {
    var n, a, _ref29, o;

    return _regeneratorRuntime.wrap(function _callee117$(_context117) {
      while (1) {
        switch (_context117.prev = _context117.next) {
          case 0:
            n = te(t);
            _context117.next = 3;
            return t.getIdToken();

          case 3:
            _context117.t0 = _context117.sent;
            _context117.t1 = e;
            a = {
              requestType: "VERIFY_AND_CHANGE_EMAIL",
              idToken: _context117.t0,
              newEmail: _context117.t1
            };
            i && vi(n.auth, a, i);
            _context117.next = 9;
            return Mg(n.auth, a);

          case 9:
            _ref29 = _context117.sent;
            o = _ref29.email;
            _context117.t2 = o !== t.email;

            if (!_context117.t2) {
              _context117.next = 15;
              break;
            }

            _context117.next = 15;
            return t.reload();

          case 15:
          case "end":
            return _context117.stop();
        }
      }
    }, _callee117);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function oy(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee118() {
    return _regeneratorRuntime.wrap(function _callee118$(_context118) {
      while (1) {
        switch (_context118.prev = _context118.next) {
          case 0:
            return _context118.abrupt("return", Re(t, "POST", "/v1/accounts:update", e));

          case 1:
          case "end":
            return _context118.stop();
        }
      }
    }, _callee118);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ly(n, r) {
  return u(this, arguments,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee119(t, _ref30) {
    var e, i, a, l, c, d;
    return _regeneratorRuntime.wrap(function _callee119$(_context119) {
      while (1) {
        switch (_context119.prev = _context119.next) {
          case 0:
            e = _ref30.displayName, i = _ref30.photoURL;

            if (!(e === void 0 && i === void 0)) {
              _context119.next = 3;
              break;
            }

            return _context119.abrupt("return");

          case 3:
            a = te(t);
            _context119.next = 6;
            return a.getIdToken();

          case 6:
            _context119.t0 = _context119.sent;
            _context119.t1 = e;
            _context119.t2 = i;
            _context119.t3 = !0;
            l = {
              idToken: _context119.t0,
              displayName: _context119.t1,
              photoUrl: _context119.t2,
              returnSecureToken: _context119.t3
            };
            _context119.next = 13;
            return It(a, oy(a.auth, l));

          case 13:
            c = _context119.sent;
            a.displayName = c.displayName || null, a.photoURL = c.photoUrl || null;
            d = a.providerData.find(function (_ref31) {
              var h = _ref31.providerId;
              return h === "password";
            });
            d && (d.displayName = a.displayName, d.photoURL = a.photoURL);
            _context119.next = 19;
            return a._updateTokensIfNecessary(c);

          case 19:
          case "end":
            return _context119.stop();
        }
      }
    }, _callee119);
  }));
}

function cy(t, e) {
  return Vu(te(t), e, null);
}

function uy(t, e) {
  return Vu(te(t), null, e);
}

function Vu(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee120() {
    var n, a, o;
    return _regeneratorRuntime.wrap(function _callee120$(_context120) {
      while (1) {
        switch (_context120.prev = _context120.next) {
          case 0:
            n = t.auth;
            _context120.next = 3;
            return t.getIdToken();

          case 3:
            _context120.t0 = _context120.sent;
            _context120.t1 = !0;
            a = {
              idToken: _context120.t0,
              returnSecureToken: _context120.t1
            };
            e && (a.email = e), i && (a.password = i);
            _context120.next = 9;
            return It(t, xu(n, a));

          case 9:
            o = _context120.sent;
            _context120.next = 12;
            return t._updateTokensIfNecessary(o, !0);

          case 12:
          case "end":
            return _context120.stop();
        }
      }
    }, _callee120);
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function dy(t) {
  var e, i;
  if (!t) return null;
  var n = t.providerId,
      r = t.rawUserInfo ? JSON.parse(t.rawUserInfo) : {},
      a = t.isNewUser || t.kind === "identitytoolkit#SignupNewUserResponse";

  if (!n && (t == null ? void 0 : t.idToken)) {
    var o = (i = (e = Mr(t.idToken)) === null || e === void 0 ? void 0 : e.firebase) === null || i === void 0 ? void 0 : i.sign_in_provider;

    if (o) {
      var l = o !== "anonymous" && o !== "custom" ? o : null;
      return new wi(a, l);
    }
  }

  if (!n) return null;

  switch (n) {
    case "facebook.com":
      return new hy(a, r);

    case "github.com":
      return new py(a, r);

    case "google.com":
      return new fy(a, r);

    case "twitter.com":
      return new my(a, r, t.screenName || null);

    case "custom":
    case "anonymous":
      return new wi(a, null);

    default:
      return new wi(a, n, r);
  }
}

var wi = function wi(e, i) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  _classCallCheck(this, wi);

  this.isNewUser = e, this.providerId = i, this.profile = n;
};

var ju =
/*#__PURE__*/
function (_wi) {
  _inherits(ju, _wi);

  function ju(e, i, n, r) {
    var _this41;

    _classCallCheck(this, ju);

    _this41 = _possibleConstructorReturn(this, _getPrototypeOf(ju).call(this, e, i, n)), _this41.username = r;
    return _this41;
  }

  return ju;
}(wi);

var hy =
/*#__PURE__*/
function (_wi2) {
  _inherits(hy, _wi2);

  function hy(e, i) {
    _classCallCheck(this, hy);

    return _possibleConstructorReturn(this, _getPrototypeOf(hy).call(this, e, "facebook.com", i));
  }

  return hy;
}(wi);

var py =
/*#__PURE__*/
function (_ju) {
  _inherits(py, _ju);

  function py(e, i) {
    _classCallCheck(this, py);

    return _possibleConstructorReturn(this, _getPrototypeOf(py).call(this, e, "github.com", i, typeof (i == null ? void 0 : i.login) == "string" ? i == null ? void 0 : i.login : null));
  }

  return py;
}(ju);

var fy =
/*#__PURE__*/
function (_wi3) {
  _inherits(fy, _wi3);

  function fy(e, i) {
    _classCallCheck(this, fy);

    return _possibleConstructorReturn(this, _getPrototypeOf(fy).call(this, e, "google.com", i));
  }

  return fy;
}(wi);

var my =
/*#__PURE__*/
function (_ju2) {
  _inherits(my, _ju2);

  function my(e, i, n) {
    _classCallCheck(this, my);

    return _possibleConstructorReturn(this, _getPrototypeOf(my).call(this, e, "twitter.com", i, n));
  }

  return my;
}(ju);

function gy(t) {
  var e = t.user,
      i = t._tokenResponse;
  return e.isAnonymous && !i ? {
    providerId: null,
    isNewUser: !1,
    profile: null
  } : dy(i);
}

function yy(t, e, i, n) {
  return te(t).onIdTokenChanged(e, i, n);
}

function vy(t, e, i) {
  return te(t).beforeAuthStateChanged(e, i);
}

var qt =
/*#__PURE__*/
function () {
  function qt(e, i, n) {
    _classCallCheck(this, qt);

    this.type = e, this.credential = i, this.auth = n;
  }

  _createClass(qt, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        multiFactorSession: _defineProperty({}, this.type === "enroll" ? "idToken" : "pendingCredential", this.credential)
      };
    }
  }], [{
    key: "_fromIdtoken",
    value: function _fromIdtoken(e, i) {
      return new qt("enroll", e, i);
    }
  }, {
    key: "_fromMfaPendingCredential",
    value: function _fromMfaPendingCredential(e) {
      return new qt("signin", e);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e) {
      var i, n;

      if (e != null && e.multiFactorSession) {
        if (!((i = e.multiFactorSession) === null || i === void 0) && i.pendingCredential) return qt._fromMfaPendingCredential(e.multiFactorSession.pendingCredential);
        if (!((n = e.multiFactorSession) === null || n === void 0) && n.idToken) return qt._fromIdtoken(e.multiFactorSession.idToken);
      }

      return null;
    }
  }]);

  return qt;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ka =
/*#__PURE__*/
function () {
  function Ka(e, i, n) {
    _classCallCheck(this, Ka);

    this.session = e, this.hints = i, this.signInResolver = n;
  }

  _createClass(Ka, [{
    key: "resolveSignIn",
    value: function resolveSignIn(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee121() {
        var i;
        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                i = e;
                return _context121.abrupt("return", this.signInResolver(i));

              case 2:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this);
      }));
    }
  }], [{
    key: "_fromError",
    value: function _fromError(e, i) {
      var _this42 = this;

      var n = fe(e),
          r = i.customData._serverResponse,
          a = (r.mfaInfo || []).map(function (l) {
        return wn._fromServerResponse(n, l);
      });
      B(r.mfaPendingCredential, n, "internal-error");

      var o = qt._fromMfaPendingCredential(r.mfaPendingCredential);

      return new Ka(o, a, function (l) {
        return u(_this42, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee122() {
          var c, d, h;
          return _regeneratorRuntime.wrap(function _callee122$(_context122) {
            while (1) {
              switch (_context122.prev = _context122.next) {
                case 0:
                  _context122.next = 2;
                  return l._process(n, o);

                case 2:
                  c = _context122.sent;
                  delete r.mfaInfo, delete r.mfaPendingCredential;
                  d = Object.assign(Object.assign({}, r), {
                    idToken: c.idToken,
                    refreshToken: c.refreshToken
                  });
                  _context122.t0 = i.operationType;
                  _context122.next = _context122.t0 === "signIn" ? 8 : _context122.t0 === "reauthenticate" ? 14 : 15;
                  break;

                case 8:
                  _context122.next = 10;
                  return Xe._fromIdTokenResponse(n, i.operationType, d);

                case 10:
                  h = _context122.sent;
                  _context122.next = 13;
                  return n._updateCurrentUser(h.user);

                case 13:
                  return _context122.abrupt("return", h);

                case 14:
                  return _context122.abrupt("return", (B(i.user, n, "internal-error"), Xe._forOperation(i.user, i.operationType, d)));

                case 15:
                  Ae(n, "internal-error");

                case 16:
                case "end":
                  return _context122.stop();
              }
            }
          }, _callee122);
        }));
      });
    }
  }]);

  return Ka;
}();

function wy(t, e) {
  var i;
  var n = te(t),
      r = e;
  return B(e.customData.operationType, n, "argument-error"), B((i = r.customData._serverResponse) === null || i === void 0 ? void 0 : i.mfaPendingCredential, n, "argument-error"), Ka._fromError(n, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function by(t, e) {
  return Re(t, "POST", "/v2/accounts/mfaEnrollment:start", be(t, e));
}

function Iy(t, e) {
  return Re(t, "POST", "/v2/accounts/mfaEnrollment:finalize", be(t, e));
}

function _y(t, e) {
  return Re(t, "POST", "/v2/accounts/mfaEnrollment:withdraw", be(t, e));
}

var Ja =
/*#__PURE__*/
function () {
  function Ja(e) {
    var _this43 = this;

    _classCallCheck(this, Ja);

    this.user = e, this.enrolledFactors = [], e._onReload(function (i) {
      i.mfaInfo && (_this43.enrolledFactors = i.mfaInfo.map(function (n) {
        return wn._fromServerResponse(e.auth, n);
      }));
    });
  }

  _createClass(Ja, [{
    key: "getSession",
    value: function getSession() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee123() {
        return _regeneratorRuntime.wrap(function _callee123$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                _context123.t0 = qt;
                _context123.next = 3;
                return this.user.getIdToken();

              case 3:
                _context123.t1 = _context123.sent;
                _context123.t2 = this.user.auth;
                return _context123.abrupt("return", _context123.t0._fromIdtoken.call(_context123.t0, _context123.t1, _context123.t2));

              case 6:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee123, this);
      }));
    }
  }, {
    key: "enroll",
    value: function enroll(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee124() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee124$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                n = e;
                _context124.next = 3;
                return this.getSession();

              case 3:
                r = _context124.sent;
                _context124.next = 6;
                return It(this.user, n._process(this.user.auth, r, i));

              case 6:
                a = _context124.sent;
                _context124.next = 9;
                return this.user._updateTokensIfNecessary(a);

              case 9:
                return _context124.abrupt("return", this.user.reload());

              case 10:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee124, this);
      }));
    }
  }, {
    key: "unenroll",
    value: function unenroll(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee125() {
        var i, n, _r3;

        return _regeneratorRuntime.wrap(function _callee125$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                i = typeof e == "string" ? e : e.uid;
                _context125.next = 3;
                return this.user.getIdToken();

              case 3:
                n = _context125.sent;
                _context125.prev = 4;
                _context125.next = 7;
                return It(this.user, _y(this.user.auth, {
                  idToken: n,
                  mfaEnrollmentId: i
                }));

              case 7:
                _r3 = _context125.sent;
                this.enrolledFactors = this.enrolledFactors.filter(function (_ref32) {
                  var a = _ref32.uid;
                  return a !== i;
                });
                _context125.next = 11;
                return this.user._updateTokensIfNecessary(_r3);

              case 11:
                _context125.next = 13;
                return this.user.reload();

              case 13:
                _context125.next = 18;
                break;

              case 15:
                _context125.prev = 15;
                _context125.t0 = _context125["catch"](4);
                throw _context125.t0;

              case 18:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee125, this, [[4, 15]]);
      }));
    }
  }], [{
    key: "_fromUser",
    value: function _fromUser(e) {
      return new Ja(e);
    }
  }]);

  return Ja;
}();

var Fs =
/* @__PURE__ */
new WeakMap();

function Ey(t) {
  var e = te(t);
  return Fs.has(e) || Fs.set(e, Ja._fromUser(e)), Fs.get(e);
}

var cr = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Wu =
/*#__PURE__*/
function () {
  function Wu(e, i) {
    _classCallCheck(this, Wu);

    this.storageRetriever = e, this.type = i;
  }

  _createClass(Wu, [{
    key: "_isAvailable",
    value: function _isAvailable() {
      try {
        return this.storage ? (this.storage.setItem(cr, "1"), this.storage.removeItem(cr), Promise.resolve(!0)) : Promise.resolve(!1);
      } catch (e) {
        return Promise.resolve(!1);
      }
    }
  }, {
    key: "_set",
    value: function _set(e, i) {
      return this.storage.setItem(e, JSON.stringify(i)), Promise.resolve();
    }
  }, {
    key: "_get",
    value: function _get(e) {
      var i = this.storage.getItem(e);
      return Promise.resolve(i ? JSON.parse(i) : null);
    }
  }, {
    key: "_remove",
    value: function _remove(e) {
      return this.storage.removeItem(e), Promise.resolve();
    }
  }, {
    key: "storage",
    get: function get() {
      return this.storageRetriever();
    }
  }]);

  return Wu;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Cy() {
  var t = we();
  return Wa(t) || Fi(t);
}

var Sy = 1e3,
    Ty = 10;

var bi =
/*#__PURE__*/
function (_Wu) {
  _inherits(bi, _Wu);

  function bi() {
    var _this44;

    _classCallCheck(this, bi);

    _this44 = _possibleConstructorReturn(this, _getPrototypeOf(bi).call(this, function () {
      return window.localStorage;
    }, "LOCAL")), _this44.boundEventHandler = function (e, i) {
      return _this44.onStorageEvent(e, i);
    }, _this44.listeners = {}, _this44.localCache = {}, _this44.pollTimer = null, _this44.safariLocalStorageNotSynced = Cy() && yg(), _this44.fallbackToPolling = Tu(), _this44._shouldAllowMigration = !0;
    return _this44;
  }

  _createClass(bi, [{
    key: "forAllChangedKeys",
    value: function forAllChangedKeys(e) {
      for (var _i11 = 0, _Object$keys = Object.keys(this.listeners); _i11 < _Object$keys.length; _i11++) {
        var i = _Object$keys[_i11];
        var n = this.storage.getItem(i),
            _r4 = this.localCache[i];
        n !== _r4 && e(i, _r4, n);
      }
    }
  }, {
    key: "onStorageEvent",
    value: function onStorageEvent(e) {
      var _this45 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      if (!e.key) {
        this.forAllChangedKeys(function (o, l, c) {
          _this45.notifyListeners(o, c);
        });
        return;
      }

      var n = e.key;

      if (i ? this.detachListener() : this.stopPolling(), this.safariLocalStorageNotSynced) {
        var o = this.storage.getItem(n);
        if (e.newValue !== o) e.newValue !== null ? this.storage.setItem(n, e.newValue) : this.storage.removeItem(n);else if (this.localCache[n] === e.newValue && !i) return;
      }

      var r = function r() {
        var o = _this45.storage.getItem(n);

        !i && _this45.localCache[n] === o || _this45.notifyListeners(n, o);
      },
          a = this.storage.getItem(n);

      gg() && a !== e.newValue && e.newValue !== e.oldValue ? setTimeout(r, Ty) : r();
    }
  }, {
    key: "notifyListeners",
    value: function notifyListeners(e, i) {
      this.localCache[e] = i;
      var n = this.listeners[e];

      if (n) {
        for (var _i12 = 0, _Array$from = Array.from(n); _i12 < _Array$from.length; _i12++) {
          var _r5 = _Array$from[_i12];

          _r5(i && JSON.parse(i));
        }
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this46 = this;

      this.stopPolling(), this.pollTimer = setInterval(function () {
        _this46.forAllChangedKeys(function (e, i, n) {
          _this46.onStorageEvent(new StorageEvent("storage", {
            key: e,
            oldValue: i,
            newValue: n
          }), !0);
        });
      }, Sy);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
    }
  }, {
    key: "attachListener",
    value: function attachListener() {
      window.addEventListener("storage", this.boundEventHandler);
    }
  }, {
    key: "detachListener",
    value: function detachListener() {
      window.removeEventListener("storage", this.boundEventHandler);
    }
  }, {
    key: "_addListener",
    value: function _addListener(e, i) {
      Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[e] || (this.listeners[e] =
      /* @__PURE__ */
      new Set(), this.localCache[e] = this.storage.getItem(e)), this.listeners[e].add(i);
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(e, i) {
      this.listeners[e] && (this.listeners[e].delete(i), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
    }
  }, {
    key: "_set",
    value: function _set(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee126() {
        return _regeneratorRuntime.wrap(function _callee126$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                _context126.next = 2;
                return Wt(bi.prototype, this, "_set").call(this, e, i);

              case 2:
                this.localCache[e] = JSON.stringify(i);

              case 3:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee126, this);
      }));
    }
  }, {
    key: "_get",
    value: function _get(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee127() {
        var i;
        return _regeneratorRuntime.wrap(function _callee127$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                _context127.next = 2;
                return Wt(bi.prototype, this, "_get").call(this, e);

              case 2:
                i = _context127.sent;
                return _context127.abrupt("return", (this.localCache[e] = JSON.stringify(i), i));

              case 4:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee127, this);
      }));
    }
  }, {
    key: "_remove",
    value: function _remove(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee128() {
        return _regeneratorRuntime.wrap(function _callee128$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                _context128.next = 2;
                return Wt(bi.prototype, this, "_remove").call(this, e);

              case 2:
                delete this.localCache[e];

              case 3:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee128, this);
      }));
    }
  }]);

  return bi;
}(Wu);

bi.type = "LOCAL";
var Nr = bi;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Gu =
/*#__PURE__*/
function (_Wu2) {
  _inherits(Gu, _Wu2);

  function Gu() {
    _classCallCheck(this, Gu);

    return _possibleConstructorReturn(this, _getPrototypeOf(Gu).call(this, function () {
      return window.sessionStorage;
    }, "SESSION"));
  }

  _createClass(Gu, [{
    key: "_addListener",
    value: function _addListener(e, i) {}
  }, {
    key: "_removeListener",
    value: function _removeListener(e, i) {}
  }]);

  return Gu;
}(Wu);

Gu.type = "SESSION";
var Vt = Gu;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function Ry(t) {
  var _this47 = this;

  return Promise.all(t.map(function (e) {
    return u(_this47, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee129() {
      return _regeneratorRuntime.wrap(function _callee129$(_context129) {
        while (1) {
          switch (_context129.prev = _context129.next) {
            case 0:
              _context129.prev = 0;
              _context129.t0 = !0;
              _context129.next = 4;
              return e;

            case 4:
              _context129.t1 = _context129.sent;
              return _context129.abrupt("return", {
                fulfilled: _context129.t0,
                value: _context129.t1
              });

            case 8:
              _context129.prev = 8;
              _context129.t2 = _context129["catch"](0);
              return _context129.abrupt("return", {
                fulfilled: !1,
                reason: _context129.t2
              });

            case 11:
            case "end":
              return _context129.stop();
          }
        }
      }, _callee129, null, [[0, 8]]);
    }));
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Lr =
/*#__PURE__*/
function () {
  function Lr(e) {
    _classCallCheck(this, Lr);

    this.eventTarget = e, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
  }

  _createClass(Lr, [{
    key: "isListeningto",
    value: function isListeningto(e) {
      return this.eventTarget === e;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee131() {
        var _this48 = this;

        var i, _i$data, n, r, a, o, l, c;

        return _regeneratorRuntime.wrap(function _callee131$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                i = e, _i$data = i.data, n = _i$data.eventId, r = _i$data.eventType, a = _i$data.data, o = this.handlersMap[r];

                if (o != null && o.size) {
                  _context131.next = 3;
                  break;
                }

                return _context131.abrupt("return");

              case 3:
                i.ports[0].postMessage({
                  status: "ack",
                  eventId: n,
                  eventType: r
                });
                l = Array.from(o).map(function (d) {
                  return u(_this48, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee130() {
                    return _regeneratorRuntime.wrap(function _callee130$(_context130) {
                      while (1) {
                        switch (_context130.prev = _context130.next) {
                          case 0:
                            return _context130.abrupt("return", d(i.origin, a));

                          case 1:
                          case "end":
                            return _context130.stop();
                        }
                      }
                    }, _callee130);
                  }));
                });
                _context131.next = 7;
                return Ry(l);

              case 7:
                c = _context131.sent;
                i.ports[0].postMessage({
                  status: "done",
                  eventId: n,
                  eventType: r,
                  response: c
                });

              case 9:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee131, this);
      }));
    }
  }, {
    key: "_subscribe",
    value: function _subscribe(e, i) {
      Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[e] || (this.handlersMap[e] =
      /* @__PURE__ */
      new Set()), this.handlersMap[e].add(i);
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe(e, i) {
      this.handlersMap[e] && i && this.handlersMap[e].delete(i), (!i || this.handlersMap[e].size === 0) && delete this.handlersMap[e], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
  }], [{
    key: "_getInstance",
    value: function _getInstance(e) {
      var i = this.receivers.find(function (r) {
        return r.isListeningto(e);
      });
      if (i) return i;
      var n = new Lr(e);
      return this.receivers.push(n), n;
    }
  }]);

  return Lr;
}();

Lr.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function bn() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var i = "";

  for (var n = 0; n < e; n++) {
    i += Math.floor(Math.random() * 10);
  }

  return t + i;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Py =
/*#__PURE__*/
function () {
  function Py(e) {
    _classCallCheck(this, Py);

    this.target = e, this.handlers =
    /* @__PURE__ */
    new Set();
  }

  _createClass(Py, [{
    key: "removeMessageHandler",
    value: function removeMessageHandler(e) {
      e.messageChannel && (e.messageChannel.port1.removeEventListener("message", e.onMessage), e.messageChannel.port1.close()), this.handlers.delete(e);
    }
  }, {
    key: "_send",
    value: function _send(e, i) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee132() {
        var _this49 = this;

        var r, a, o;
        return _regeneratorRuntime.wrap(function _callee132$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                r = typeof MessageChannel != "undefined" ? new MessageChannel() : null;

                if (r) {
                  _context132.next = 3;
                  break;
                }

                throw new Error("connection_unavailable");

              case 3:
                return _context132.abrupt("return", new Promise(function (l, c) {
                  var d = bn("", 20);
                  r.port1.start();
                  var h = setTimeout(function () {
                    c(new Error("unsupported_event"));
                  }, n);
                  o = {
                    messageChannel: r,
                    onMessage: function onMessage(p) {
                      var g = p;
                      if (g.data.eventId === d) switch (g.data.status) {
                        case "ack":
                          clearTimeout(h), a = setTimeout(function () {
                            c(new Error("timeout"));
                          }, 3e3);
                          break;

                        case "done":
                          clearTimeout(a), l(g.data.response);
                          break;

                        default:
                          clearTimeout(h), clearTimeout(a), c(new Error("invalid_response"));
                          break;
                      }
                    }
                  }, _this49.handlers.add(o), r.port1.addEventListener("message", o.onMessage), _this49.target.postMessage({
                    eventType: e,
                    eventId: d,
                    data: i
                  }, [r.port2]);
                }).finally(function () {
                  o && _this49.removeMessageHandler(o);
                }));

              case 4:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee132);
      }));
    }
  }]);

  return Py;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function me() {
  return window;
}

function Oy(t) {
  me().location.href = t;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Xa() {
  return typeof me().WorkerGlobalScope != "undefined" && typeof me().importScripts == "function";
}

function Ay() {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee133() {
    return _regeneratorRuntime.wrap(function _callee133$(_context133) {
      while (1) {
        switch (_context133.prev = _context133.next) {
          case 0:
            if (navigator != null && navigator.serviceWorker) {
              _context133.next = 2;
              break;
            }

            return _context133.abrupt("return", null);

          case 2:
            _context133.prev = 2;
            _context133.next = 5;
            return navigator.serviceWorker.ready;

          case 5:
            return _context133.abrupt("return", _context133.sent.active);

          case 8:
            _context133.prev = 8;
            _context133.t0 = _context133["catch"](2);
            return _context133.abrupt("return", null);

          case 11:
          case "end":
            return _context133.stop();
        }
      }
    }, _callee133, null, [[2, 8]]);
  }));
}

function My() {
  var t;
  return ((t = navigator == null ? void 0 : navigator.serviceWorker) === null || t === void 0 ? void 0 : t.controller) || null;
}

function Fy() {
  return Xa() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var zu = "firebaseLocalStorageDb",
    ky = 1,
    ur = "firebaseLocalStorage",
    qu = "fbase_key";

var In =
/*#__PURE__*/
function () {
  function In(e) {
    _classCallCheck(this, In);

    this.request = e;
  }

  _createClass(In, [{
    key: "toPromise",
    value: function toPromise() {
      var _this50 = this;

      return new Promise(function (e, i) {
        _this50.request.addEventListener("success", function () {
          e(_this50.request.result);
        }), _this50.request.addEventListener("error", function () {
          i(_this50.request.error);
        });
      });
    }
  }]);

  return In;
}();

function $r(t, e) {
  return t.transaction([ur], e ? "readwrite" : "readonly").objectStore(ur);
}

function xy() {
  var t = indexedDB.deleteDatabase(zu);
  return new In(t).toPromise();
}

function sa() {
  var _this51 = this;

  var t = indexedDB.open(zu, ky);
  return new Promise(function (e, i) {
    t.addEventListener("error", function () {
      i(t.error);
    }), t.addEventListener("upgradeneeded", function () {
      var n = t.result;

      try {
        n.createObjectStore(ur, {
          keyPath: qu
        });
      } catch (r) {
        i(r);
      }
    }), t.addEventListener("success", function () {
      return u(_this51, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee134() {
        var n;
        return _regeneratorRuntime.wrap(function _callee134$(_context134) {
          while (1) {
            switch (_context134.prev = _context134.next) {
              case 0:
                n = t.result;

                if (!n.objectStoreNames.contains(ur)) {
                  _context134.next = 5;
                  break;
                }

                e(n);
                _context134.next = 13;
                break;

              case 5:
                n.close();
                _context134.next = 8;
                return xy();

              case 8:
                _context134.t0 = e;
                _context134.next = 11;
                return sa();

              case 11:
                _context134.t1 = _context134.sent;
                (0, _context134.t0)(_context134.t1);

              case 13:
              case "end":
                return _context134.stop();
            }
          }
        }, _callee134);
      }));
    });
  });
}

function sl(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee135() {
    var _$r$put;

    var n;
    return _regeneratorRuntime.wrap(function _callee135$(_context135) {
      while (1) {
        switch (_context135.prev = _context135.next) {
          case 0:
            n = $r(t, !0).put((_$r$put = {}, _defineProperty(_$r$put, qu, e), _defineProperty(_$r$put, "value", i), _$r$put));
            return _context135.abrupt("return", new In(n).toPromise());

          case 2:
          case "end":
            return _context135.stop();
        }
      }
    }, _callee135);
  }));
}

function Dy(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee136() {
    var i, n;
    return _regeneratorRuntime.wrap(function _callee136$(_context136) {
      while (1) {
        switch (_context136.prev = _context136.next) {
          case 0:
            i = $r(t, !1).get(e);
            _context136.next = 3;
            return new In(i).toPromise();

          case 3:
            n = _context136.sent;
            return _context136.abrupt("return", n === void 0 ? null : n.value);

          case 5:
          case "end":
            return _context136.stop();
        }
      }
    }, _callee136);
  }));
}

function al(t, e) {
  var i = $r(t, !0).delete(e);
  return new In(i).toPromise();
}

var Ny = 800,
    Ly = 3;

var Qu =
/*#__PURE__*/
function () {
  function Qu() {
    _classCallCheck(this, Qu);

    this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(function () {}, function () {});
  }

  _createClass(Qu, [{
    key: "_openDb",
    value: function _openDb() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee137() {
        return _regeneratorRuntime.wrap(function _callee137$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                if (!this.db) {
                  _context137.next = 4;
                  break;
                }

                _context137.t0 = this.db;
                _context137.next = 8;
                break;

              case 4:
                _context137.next = 6;
                return sa();

              case 6:
                this.db = _context137.sent;
                _context137.t0 = this.db;

              case 8:
                return _context137.abrupt("return", _context137.t0);

              case 9:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee137, this);
      }));
    }
  }, {
    key: "_withRetries",
    value: function _withRetries(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee138() {
        var i, n;
        return _regeneratorRuntime.wrap(function _callee138$(_context138) {
          while (1) {
            switch (_context138.prev = _context138.next) {
              case 0:
                i = 0;

              case 1:
                _context138.prev = 1;
                _context138.next = 4;
                return this._openDb();

              case 4:
                n = _context138.sent;
                _context138.next = 7;
                return e(n);

              case 7:
                return _context138.abrupt("return", _context138.sent);

              case 10:
                _context138.prev = 10;
                _context138.t0 = _context138["catch"](1);

                if (!(i++ > Ly)) {
                  _context138.next = 14;
                  break;
                }

                throw _context138.t0;

              case 14:
                this.db && (this.db.close(), this.db = void 0);

              case 15:
                _context138.next = 1;
                break;

              case 17:
              case "end":
                return _context138.stop();
            }
          }
        }, _callee138, this, [[1, 10]]);
      }));
    }
  }, {
    key: "initializeServiceWorkerMessaging",
    value: function initializeServiceWorkerMessaging() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee139() {
        return _regeneratorRuntime.wrap(function _callee139$(_context139) {
          while (1) {
            switch (_context139.prev = _context139.next) {
              case 0:
                return _context139.abrupt("return", Xa() ? this.initializeReceiver() : this.initializeSender());

              case 1:
              case "end":
                return _context139.stop();
            }
          }
        }, _callee139, this);
      }));
    }
  }, {
    key: "initializeReceiver",
    value: function initializeReceiver() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee142() {
        var _this52 = this;

        return _regeneratorRuntime.wrap(function _callee142$(_context142) {
          while (1) {
            switch (_context142.prev = _context142.next) {
              case 0:
                this.receiver = Lr._getInstance(Fy()), this.receiver._subscribe("keyChanged", function (e, i) {
                  return u(_this52, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee140() {
                    return _regeneratorRuntime.wrap(function _callee140$(_context140) {
                      while (1) {
                        switch (_context140.prev = _context140.next) {
                          case 0:
                            _context140.next = 2;
                            return this._poll();

                          case 2:
                            _context140.t0 = i.key;
                            _context140.t1 = _context140.sent.includes(_context140.t0);
                            return _context140.abrupt("return", {
                              keyProcessed: _context140.t1
                            });

                          case 5:
                          case "end":
                            return _context140.stop();
                        }
                      }
                    }, _callee140, this);
                  }));
                }), this.receiver._subscribe("ping", function (e, i) {
                  return u(_this52, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee141() {
                    return _regeneratorRuntime.wrap(function _callee141$(_context141) {
                      while (1) {
                        switch (_context141.prev = _context141.next) {
                          case 0:
                            return _context141.abrupt("return", ["keyChanged"]);

                          case 1:
                          case "end":
                            return _context141.stop();
                        }
                      }
                    }, _callee141);
                  }));
                });

              case 1:
              case "end":
                return _context142.stop();
            }
          }
        }, _callee142, this);
      }));
    }
  }, {
    key: "initializeSender",
    value: function initializeSender() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee143() {
        var e, i, n;
        return _regeneratorRuntime.wrap(function _callee143$(_context143) {
          while (1) {
            switch (_context143.prev = _context143.next) {
              case 0:
                _context143.next = 2;
                return Ay();

              case 2:
                this.activeServiceWorker = _context143.sent;

                if (this.activeServiceWorker) {
                  _context143.next = 5;
                  break;
                }

                return _context143.abrupt("return");

              case 5:
                this.sender = new Py(this.activeServiceWorker);
                _context143.next = 8;
                return this.sender._send("ping", {}, 800);

              case 8:
                n = _context143.sent;
                !n || ((e = n[0]) === null || e === void 0 ? void 0 : e.fulfilled) && ((i = n[0]) === null || i === void 0 ? void 0 : i.value.includes("keyChanged")) && (this.serviceWorkerReceiverAvailable = !0);

              case 10:
              case "end":
                return _context143.stop();
            }
          }
        }, _callee143, this);
      }));
    }
  }, {
    key: "notifyServiceWorker",
    value: function notifyServiceWorker(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee144() {
        return _regeneratorRuntime.wrap(function _callee144$(_context144) {
          while (1) {
            switch (_context144.prev = _context144.next) {
              case 0:
                if (!this.sender || !this.activeServiceWorker || My() !== this.activeServiceWorker) {
                  _context144.next = 8;
                  break;
                }

                _context144.prev = 1;
                _context144.next = 4;
                return this.sender._send("keyChanged", {
                  key: e
                }, this.serviceWorkerReceiverAvailable ? 800 : 50);

              case 4:
                _context144.next = 8;
                break;

              case 6:
                _context144.prev = 6;
                _context144.t0 = _context144["catch"](1);

              case 8:
              case "end":
                return _context144.stop();
            }
          }
        }, _callee144, this, [[1, 6]]);
      }));
    }
  }, {
    key: "_isAvailable",
    value: function _isAvailable() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee145() {
        var e;
        return _regeneratorRuntime.wrap(function _callee145$(_context145) {
          while (1) {
            switch (_context145.prev = _context145.next) {
              case 0:
                _context145.prev = 0;

                if (indexedDB) {
                  _context145.next = 3;
                  break;
                }

                return _context145.abrupt("return", !1);

              case 3:
                _context145.next = 5;
                return sa();

              case 5:
                e = _context145.sent;
                _context145.next = 8;
                return sl(e, cr, "1");

              case 8:
                _context145.next = 10;
                return al(e, cr);

              case 10:
                return _context145.abrupt("return", !0);

              case 13:
                _context145.prev = 13;
                _context145.t0 = _context145["catch"](0);

              case 15:
                return _context145.abrupt("return", !1);

              case 16:
              case "end":
                return _context145.stop();
            }
          }
        }, _callee145, null, [[0, 13]]);
      }));
    }
  }, {
    key: "_withPendingWrite",
    value: function _withPendingWrite(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee146() {
        return _regeneratorRuntime.wrap(function _callee146$(_context146) {
          while (1) {
            switch (_context146.prev = _context146.next) {
              case 0:
                this.pendingWrites++;
                _context146.prev = 1;
                _context146.next = 4;
                return e();

              case 4:
                _context146.prev = 4;
                this.pendingWrites--;
                return _context146.finish(4);

              case 7:
              case "end":
                return _context146.stop();
            }
          }
        }, _callee146, this, [[1,, 4, 7]]);
      }));
    }
  }, {
    key: "_set",
    value: function _set(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee148() {
        var _this53 = this;

        return _regeneratorRuntime.wrap(function _callee148$(_context148) {
          while (1) {
            switch (_context148.prev = _context148.next) {
              case 0:
                return _context148.abrupt("return", this._withPendingWrite(function () {
                  return u(_this53, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee147() {
                    return _regeneratorRuntime.wrap(function _callee147$(_context147) {
                      while (1) {
                        switch (_context147.prev = _context147.next) {
                          case 0:
                            _context147.next = 2;
                            return this._withRetries(function (n) {
                              return sl(n, e, i);
                            });

                          case 2:
                            this.localCache[e] = i;
                            return _context147.abrupt("return", this.notifyServiceWorker(e));

                          case 4:
                          case "end":
                            return _context147.stop();
                        }
                      }
                    }, _callee147, this);
                  }));
                }));

              case 1:
              case "end":
                return _context148.stop();
            }
          }
        }, _callee148, this);
      }));
    }
  }, {
    key: "_get",
    value: function _get(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee149() {
        var i;
        return _regeneratorRuntime.wrap(function _callee149$(_context149) {
          while (1) {
            switch (_context149.prev = _context149.next) {
              case 0:
                _context149.next = 2;
                return this._withRetries(function (n) {
                  return Dy(n, e);
                });

              case 2:
                i = _context149.sent;
                return _context149.abrupt("return", (this.localCache[e] = i, i));

              case 4:
              case "end":
                return _context149.stop();
            }
          }
        }, _callee149, this);
      }));
    }
  }, {
    key: "_remove",
    value: function _remove(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee151() {
        var _this54 = this;

        return _regeneratorRuntime.wrap(function _callee151$(_context151) {
          while (1) {
            switch (_context151.prev = _context151.next) {
              case 0:
                return _context151.abrupt("return", this._withPendingWrite(function () {
                  return u(_this54, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee150() {
                    return _regeneratorRuntime.wrap(function _callee150$(_context150) {
                      while (1) {
                        switch (_context150.prev = _context150.next) {
                          case 0:
                            _context150.next = 2;
                            return this._withRetries(function (i) {
                              return al(i, e);
                            });

                          case 2:
                            delete this.localCache[e];
                            return _context150.abrupt("return", this.notifyServiceWorker(e));

                          case 4:
                          case "end":
                            return _context150.stop();
                        }
                      }
                    }, _callee150, this);
                  }));
                }));

              case 1:
              case "end":
                return _context151.stop();
            }
          }
        }, _callee151, this);
      }));
    }
  }, {
    key: "_poll",
    value: function _poll() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee152() {
        var e, i, n, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _ref34, _r6, a, _i13, _Object$keys2, _r7;

        return _regeneratorRuntime.wrap(function _callee152$(_context152) {
          while (1) {
            switch (_context152.prev = _context152.next) {
              case 0:
                _context152.next = 2;
                return this._withRetries(function (r) {
                  var a = $r(r, !1).getAll();
                  return new In(a).toPromise();
                });

              case 2:
                e = _context152.sent;

                if (e) {
                  _context152.next = 5;
                  break;
                }

                return _context152.abrupt("return", []);

              case 5:
                if (!(this.pendingWrites !== 0)) {
                  _context152.next = 7;
                  break;
                }

                return _context152.abrupt("return", []);

              case 7:
                i = [], n =
                /* @__PURE__ */
                new Set();
                _iteratorNormalCompletion12 = true;
                _didIteratorError12 = false;
                _iteratorError12 = undefined;
                _context152.prev = 11;

                for (_iterator12 = e[Symbol.iterator](); !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                  _ref34 = _step12.value;
                  _r6 = _ref34.fbase_key;
                  a = _ref34.value;
                  n.add(_r6), JSON.stringify(this.localCache[_r6]) !== JSON.stringify(a) && (this.notifyListeners(_r6, a), i.push(_r6));
                }

                _context152.next = 19;
                break;

              case 15:
                _context152.prev = 15;
                _context152.t0 = _context152["catch"](11);
                _didIteratorError12 = true;
                _iteratorError12 = _context152.t0;

              case 19:
                _context152.prev = 19;
                _context152.prev = 20;

                if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                  _iterator12.return();
                }

              case 22:
                _context152.prev = 22;

                if (!_didIteratorError12) {
                  _context152.next = 25;
                  break;
                }

                throw _iteratorError12;

              case 25:
                return _context152.finish(22);

              case 26:
                return _context152.finish(19);

              case 27:
                for (_i13 = 0, _Object$keys2 = Object.keys(this.localCache); _i13 < _Object$keys2.length; _i13++) {
                  _r7 = _Object$keys2[_i13];
                  this.localCache[_r7] && !n.has(_r7) && (this.notifyListeners(_r7, null), i.push(_r7));
                }

                return _context152.abrupt("return", i);

              case 29:
              case "end":
                return _context152.stop();
            }
          }
        }, _callee152, this, [[11, 15, 19, 27], [20,, 22, 26]]);
      }));
    }
  }, {
    key: "notifyListeners",
    value: function notifyListeners(e, i) {
      this.localCache[e] = i;
      var n = this.listeners[e];

      if (n) {
        for (var _i14 = 0, _Array$from2 = Array.from(n); _i14 < _Array$from2.length; _i14++) {
          var _r8 = _Array$from2[_i14];

          _r8(i);
        }
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      var _this55 = this;

      this.stopPolling(), this.pollTimer = setInterval(function () {
        return u(_this55, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee153() {
          return _regeneratorRuntime.wrap(function _callee153$(_context153) {
            while (1) {
              switch (_context153.prev = _context153.next) {
                case 0:
                  return _context153.abrupt("return", this._poll());

                case 1:
                case "end":
                  return _context153.stop();
              }
            }
          }, _callee153, this);
        }));
      }, Ny);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
    }
  }, {
    key: "_addListener",
    value: function _addListener(e, i) {
      Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[e] || (this.listeners[e] =
      /* @__PURE__ */
      new Set(), this._get(e)), this.listeners[e].add(i);
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(e, i) {
      this.listeners[e] && (this.listeners[e].delete(i), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && this.stopPolling();
    }
  }]);

  return Qu;
}();

Qu.type = "LOCAL";
var Si = Qu;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function $y(t, e) {
  return Re(t, "POST", "/v2/accounts/mfaSignIn:start", be(t, e));
}

function Uy(t, e) {
  return Re(t, "POST", "/v2/accounts/mfaSignIn:finalize", be(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var By = 500,
    Hy = 6e4,
    Mn = 1e12;

var Vy =
/*#__PURE__*/
function () {
  function Vy(e) {
    _classCallCheck(this, Vy);

    this.auth = e, this.counter = Mn, this._widgets =
    /* @__PURE__ */
    new Map();
  }

  _createClass(Vy, [{
    key: "render",
    value: function render(e, i) {
      var n = this.counter;
      return this._widgets.set(n, new jy(e, this.auth.name, i || {})), this.counter++, n;
    }
  }, {
    key: "reset",
    value: function reset(e) {
      var i;
      var n = e || Mn;
      (i = this._widgets.get(n)) === null || i === void 0 || i.delete(), this._widgets.delete(n);
    }
  }, {
    key: "getResponse",
    value: function getResponse(e) {
      var i;
      var n = e || Mn;
      return ((i = this._widgets.get(n)) === null || i === void 0 ? void 0 : i.getResponse()) || "";
    }
  }, {
    key: "execute",
    value: function execute(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee154() {
        var i, n;
        return _regeneratorRuntime.wrap(function _callee154$(_context154) {
          while (1) {
            switch (_context154.prev = _context154.next) {
              case 0:
                n = e || Mn;
                return _context154.abrupt("return", ((i = this._widgets.get(n)) === null || i === void 0 || i.execute(), ""));

              case 2:
              case "end":
                return _context154.stop();
            }
          }
        }, _callee154, this);
      }));
    }
  }]);

  return Vy;
}();

var jy =
/*#__PURE__*/
function () {
  function jy(e, i, n) {
    var _this56 = this;

    _classCallCheck(this, jy);

    this.params = n, this.timerId = null, this.deleted = !1, this.responseToken = null, this.clickHandler = function () {
      _this56.execute();
    };
    var r = typeof e == "string" ? document.getElementById(e) : e;
    B(r, "argument-error", {
      appName: i
    }), this.container = r, this.isVisible = this.params.size !== "invisible", this.isVisible ? this.execute() : this.container.addEventListener("click", this.clickHandler);
  }

  _createClass(jy, [{
    key: "getResponse",
    value: function getResponse() {
      return this.checkIfDeleted(), this.responseToken;
    }
  }, {
    key: "delete",
    value: function _delete() {
      this.checkIfDeleted(), this.deleted = !0, this.timerId && (clearTimeout(this.timerId), this.timerId = null), this.container.removeEventListener("click", this.clickHandler);
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this57 = this;

      this.checkIfDeleted(), !this.timerId && (this.timerId = window.setTimeout(function () {
        _this57.responseToken = Wy(50);
        var _this57$params = _this57.params,
            e = _this57$params.callback,
            i = _this57$params["expired-callback"];
        if (e) try {
          e(_this57.responseToken);
        } catch (n) {}
        _this57.timerId = window.setTimeout(function () {
          if (_this57.timerId = null, _this57.responseToken = null, i) try {
            i();
          } catch (n) {}
          _this57.isVisible && _this57.execute();
        }, Hy);
      }, By));
    }
  }, {
    key: "checkIfDeleted",
    value: function checkIfDeleted() {
      if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
  }]);

  return jy;
}();

function Wy(t) {
  var e = [],
      i = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  for (var n = 0; n < t; n++) {
    e.push(i.charAt(Math.floor(Math.random() * i.length)));
  }

  return e.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ks = Au("rcb"),
    Gy = new yn(3e4, 6e4),
    zy = "https://www.google.com/recaptcha/api.js?";

var qy =
/*#__PURE__*/
function () {
  function qy() {
    _classCallCheck(this, qy);

    var e;
    this.hostLanguage = "", this.counter = 0, this.librarySeparatelyLoaded = !!(!((e = me().grecaptcha) === null || e === void 0) && e.render);
  }

  _createClass(qy, [{
    key: "load",
    value: function load(e) {
      var _this58 = this;

      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return B(Qy(i), e, "argument-error"), this.shouldResolveImmediately(i) && el(me().grecaptcha) ? Promise.resolve(me().grecaptcha) : new Promise(function (n, r) {
        var a = me().setTimeout(function () {
          r(xe(e, "network-request-failed"));
        }, Gy.get());

        me()[ks] = function () {
          me().clearTimeout(a), delete me()[ks];
          var l = me().grecaptcha;

          if (!l || !el(l)) {
            r(xe(e, "internal-error"));
            return;
          }

          var c = l.render;
          l.render = function (d, h) {
            var p = c(d, h);
            return _this58.counter++, p;
          }, _this58.hostLanguage = i, n(l);
        };

        var o = "".concat(zy, "?").concat(Ai({
          onload: ks,
          render: "explicit",
          hl: i
        }));
        Ga(o).catch(function () {
          clearTimeout(a), r(xe(e, "internal-error"));
        });
      });
    }
  }, {
    key: "clearedOneInstance",
    value: function clearedOneInstance() {
      this.counter--;
    }
  }, {
    key: "shouldResolveImmediately",
    value: function shouldResolveImmediately(e) {
      var i;
      return !!(!((i = me().grecaptcha) === null || i === void 0) && i.render) && (e === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
  }]);

  return qy;
}();

function Qy(t) {
  return t.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(t);
}

var Yy =
/*#__PURE__*/
function () {
  function Yy() {
    _classCallCheck(this, Yy);
  }

  _createClass(Yy, [{
    key: "load",
    value: function load(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee155() {
        return _regeneratorRuntime.wrap(function _callee155$(_context155) {
          while (1) {
            switch (_context155.prev = _context155.next) {
              case 0:
                return _context155.abrupt("return", new Vy(e));

              case 1:
              case "end":
                return _context155.stop();
            }
          }
        }, _callee155);
      }));
    }
  }, {
    key: "clearedOneInstance",
    value: function clearedOneInstance() {}
  }]);

  return Yy;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Yu = "recaptcha",
    Ky = {
  theme: "light",
  type: "image"
};

var Jy =
/*#__PURE__*/
function () {
  function Jy(e) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.assign({}, Ky);
    var n = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Jy);

    this.parameters = i, this.type = Yu, this.destroyed = !1, this.widgetId = null, this.tokenChangeListeners =
    /* @__PURE__ */
    new Set(), this.renderPromise = null, this.recaptcha = null, this.auth = fe(n), this.isInvisible = this.parameters.size === "invisible", B(typeof document != "undefined", this.auth, "operation-not-supported-in-this-environment");
    var r = typeof e == "string" ? document.getElementById(e) : e;
    B(r, this.auth, "argument-error"), this.container = r, this.parameters.callback = this.makeTokenCallback(this.parameters.callback), this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new Yy() : new qy(), this.validateStartingState();
  }

  _createClass(Jy, [{
    key: "verify",
    value: function verify() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee156() {
        var _this59 = this;

        var e, i, n;
        return _regeneratorRuntime.wrap(function _callee156$(_context156) {
          while (1) {
            switch (_context156.prev = _context156.next) {
              case 0:
                this.assertNotDestroyed();
                _context156.next = 3;
                return this.render();

              case 3:
                e = _context156.sent;
                i = this.getAssertedRecaptcha();
                n = i.getResponse(e);
                return _context156.abrupt("return", n || new Promise(function (r) {
                  var a = function a(o) {
                    !o || (_this59.tokenChangeListeners.delete(a), r(o));
                  };

                  _this59.tokenChangeListeners.add(a), _this59.isInvisible && i.execute(e);
                }));

              case 7:
              case "end":
                return _context156.stop();
            }
          }
        }, _callee156, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this60 = this;

      try {
        this.assertNotDestroyed();
      } catch (e) {
        return Promise.reject(e);
      }

      return this.renderPromise ? this.renderPromise : (this.renderPromise = this.makeRenderPromise().catch(function (e) {
        throw _this60.renderPromise = null, e;
      }), this.renderPromise);
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this.assertNotDestroyed(), this.widgetId !== null && this.getAssertedRecaptcha().reset(this.widgetId);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this61 = this;

      this.assertNotDestroyed(), this.destroyed = !0, this._recaptchaLoader.clearedOneInstance(), this.isInvisible || this.container.childNodes.forEach(function (e) {
        _this61.container.removeChild(e);
      });
    }
  }, {
    key: "validateStartingState",
    value: function validateStartingState() {
      B(!this.parameters.sitekey, this.auth, "argument-error"), B(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error"), B(typeof document != "undefined", this.auth, "operation-not-supported-in-this-environment");
    }
  }, {
    key: "makeTokenCallback",
    value: function makeTokenCallback(e) {
      var _this62 = this;

      return function (i) {
        if (_this62.tokenChangeListeners.forEach(function (n) {
          return n(i);
        }), typeof e == "function") e(i);else if (typeof e == "string") {
          var n = me()[e];
          typeof n == "function" && n(i);
        }
      };
    }
  }, {
    key: "assertNotDestroyed",
    value: function assertNotDestroyed() {
      B(!this.destroyed, this.auth, "internal-error");
    }
  }, {
    key: "makeRenderPromise",
    value: function makeRenderPromise() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee157() {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee157$(_context157) {
          while (1) {
            switch (_context157.prev = _context157.next) {
              case 0:
                _context157.next = 2;
                return this.init();

              case 2:
                if (this.widgetId) {
                  _context157.next = 6;
                  break;
                }

                e = this.container;

                if (!this.isInvisible) {
                  i = document.createElement("div");
                  e.appendChild(i), e = i;
                }

                this.widgetId = this.getAssertedRecaptcha().render(e, this.parameters);

              case 6:
                return _context157.abrupt("return", this.widgetId);

              case 7:
              case "end":
                return _context157.stop();
            }
          }
        }, _callee157, this);
      }));
    }
  }, {
    key: "init",
    value: function init() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee158() {
        var e;
        return _regeneratorRuntime.wrap(function _callee158$(_context158) {
          while (1) {
            switch (_context158.prev = _context158.next) {
              case 0:
                B(Va() && !Xa(), this.auth, "internal-error");
                _context158.next = 3;
                return Xy();

              case 3:
                _context158.next = 5;
                return this._recaptchaLoader.load(this.auth, this.auth.languageCode || void 0);

              case 5:
                this.recaptcha = _context158.sent;
                _context158.next = 8;
                return vg(this.auth);

              case 8:
                e = _context158.sent;
                B(e, this.auth, "internal-error"), this.parameters.sitekey = e;

              case 10:
              case "end":
                return _context158.stop();
            }
          }
        }, _callee158, this);
      }));
    }
  }, {
    key: "getAssertedRecaptcha",
    value: function getAssertedRecaptcha() {
      return B(this.recaptcha, this.auth, "internal-error"), this.recaptcha;
    }
  }]);

  return Jy;
}();

function Xy() {
  var t = null;
  return new Promise(function (e) {
    if (document.readyState === "complete") {
      e();
      return;
    }

    t = function t() {
      return e();
    }, window.addEventListener("load", t);
  }).catch(function (e) {
    throw t && window.removeEventListener("load", t), e;
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Za =
/*#__PURE__*/
function () {
  function Za(e, i) {
    _classCallCheck(this, Za);

    this.verificationId = e, this.onConfirmation = i;
  }

  _createClass(Za, [{
    key: "confirm",
    value: function confirm(e) {
      var i = Xt._fromVerification(this.verificationId, e);

      return this.onConfirmation(i);
    }
  }]);

  return Za;
}();

function Zy(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee159() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee159$(_context159) {
      while (1) {
        switch (_context159.prev = _context159.next) {
          case 0:
            n = fe(t);
            _context159.next = 3;
            return Ur(n, e, te(i));

          case 3:
            r = _context159.sent;
            return _context159.abrupt("return", new Za(r, function (a) {
              return Dr(n, a);
            }));

          case 5:
          case "end":
            return _context159.stop();
        }
      }
    }, _callee159);
  }));
}

function ev(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee160() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee160$(_context160) {
      while (1) {
        switch (_context160.prev = _context160.next) {
          case 0:
            n = te(t);
            _context160.next = 3;
            return xr(!1, n, "phone");

          case 3:
            _context160.next = 5;
            return Ur(n.auth, e, te(i));

          case 5:
            r = _context160.sent;
            return _context160.abrupt("return", new Za(r, function (a) {
              return Uu(n, a);
            }));

          case 7:
          case "end":
            return _context160.stop();
        }
      }
    }, _callee160);
  }));
}

function tv(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee161() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee161$(_context161) {
      while (1) {
        switch (_context161.prev = _context161.next) {
          case 0:
            n = te(t);
            _context161.next = 3;
            return Ur(n.auth, e, te(i));

          case 3:
            r = _context161.sent;
            return _context161.abrupt("return", new Za(r, function (a) {
              return Bu(n, a);
            }));

          case 5:
          case "end":
            return _context161.stop();
        }
      }
    }, _callee161);
  }));
}

function Ur(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee162() {
    var n, r, a, o, l, _ref35, _o3;

    return _regeneratorRuntime.wrap(function _callee162$(_context162) {
      while (1) {
        switch (_context162.prev = _context162.next) {
          case 0:
            _context162.next = 2;
            return i.verify();

          case 2:
            r = _context162.sent;
            _context162.prev = 3;
            B(typeof r == "string", t, "argument-error"), B(i.type === Yu, t, "argument-error");

            if (!(typeof e == "string" ? a = {
              phoneNumber: e
            } : a = e, "session" in a)) {
              _context162.next = 20;
              break;
            }

            o = a.session;

            if (!("phoneNumber" in a)) {
              _context162.next = 12;
              break;
            }

            B(o.type === "enroll", t, "internal-error");
            _context162.next = 11;
            return by(t, {
              idToken: o.credential,
              phoneEnrollmentInfo: {
                phoneNumber: a.phoneNumber,
                recaptchaToken: r
              }
            });

          case 11:
            return _context162.abrupt("return", _context162.sent.phoneSessionInfo.sessionInfo);

          case 12:
            B(o.type === "signin", t, "internal-error");
            l = ((n = a.multiFactorHint) === null || n === void 0 ? void 0 : n.uid) || a.multiFactorUid;
            B(l, t, "missing-multi-factor-info");
            _context162.next = 17;
            return $y(t, {
              mfaPendingCredential: o.credential,
              mfaEnrollmentId: l,
              phoneSignInInfo: {
                recaptchaToken: r
              }
            });

          case 17:
            return _context162.abrupt("return", _context162.sent.phoneResponseInfo.sessionInfo);

          case 20:
            _context162.next = 22;
            return Dg(t, {
              phoneNumber: a.phoneNumber,
              recaptchaToken: r
            });

          case 22:
            _ref35 = _context162.sent;
            _o3 = _ref35.sessionInfo;
            return _context162.abrupt("return", _o3);

          case 25:
            _context162.prev = 25;

            i._reset();

            return _context162.finish(25);

          case 28:
          case "end":
            return _context162.stop();
        }
      }
    }, _callee162, null, [[3,, 25, 28]]);
  }));
}

function iv(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee163() {
    return _regeneratorRuntime.wrap(function _callee163$(_context163) {
      while (1) {
        switch (_context163.prev = _context163.next) {
          case 0:
            _context163.next = 2;
            return qa(te(t), e);

          case 2:
          case "end":
            return _context163.stop();
        }
      }
    }, _callee163);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var et =
/*#__PURE__*/
function () {
  function et(e) {
    _classCallCheck(this, et);

    this.providerId = et.PROVIDER_ID, this.auth = fe(e);
  }

  _createClass(et, [{
    key: "verifyPhoneNumber",
    value: function verifyPhoneNumber(e, i) {
      return Ur(this.auth, e, te(i));
    }
  }], [{
    key: "credential",
    value: function credential(e, i) {
      return Xt._fromVerification(e, i);
    }
  }, {
    key: "credentialFromResult",
    value: function credentialFromResult(e) {
      var i = e;
      return et.credentialFromTaggedObject(i);
    }
  }, {
    key: "credentialFromError",
    value: function credentialFromError(e) {
      return et.credentialFromTaggedObject(e.customData || {});
    }
  }, {
    key: "credentialFromTaggedObject",
    value: function credentialFromTaggedObject(_ref36) {
      var e = _ref36._tokenResponse;
      if (!e) return null;
      var i = e.phoneNumber,
          n = e.temporaryProof;
      return i && n ? Xt._fromTokenResponse(i, n) : null;
    }
  }]);

  return et;
}();

et.PROVIDER_ID = "phone";
et.PHONE_SIGN_IN_METHOD = "phone";
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function oi(t, e) {
  return e ? ze(e) : (B(t._popupRedirectResolver, t, "argument-error"), t._popupRedirectResolver);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var eo =
/*#__PURE__*/
function (_ki5) {
  _inherits(eo, _ki5);

  function eo(e) {
    var _this63;

    _classCallCheck(this, eo);

    _this63 = _possibleConstructorReturn(this, _getPrototypeOf(eo).call(this, "custom", "custom")), _this63.params = e;
    return _this63;
  }

  _createClass(eo, [{
    key: "_getIdTokenResponse",
    value: function _getIdTokenResponse(e) {
      return bt(e, this._buildIdpRequest());
    }
  }, {
    key: "_linkToIdToken",
    value: function _linkToIdToken(e, i) {
      return bt(e, this._buildIdpRequest(i));
    }
  }, {
    key: "_getReauthenticationResolver",
    value: function _getReauthenticationResolver(e) {
      return bt(e, this._buildIdpRequest());
    }
  }, {
    key: "_buildIdpRequest",
    value: function _buildIdpRequest(e) {
      var i = {
        requestUri: this.params.requestUri,
        sessionId: this.params.sessionId,
        postBody: this.params.postBody,
        tenantId: this.params.tenantId,
        pendingToken: this.params.pendingToken,
        returnSecureToken: !0,
        returnIdpCredential: !0
      };
      return e && (i.idToken = e), i;
    }
  }]);

  return eo;
}(ki);

function nv(t) {
  return $u(t.auth, new eo(t), t.bypassAuthState);
}

function rv(t) {
  var e = t.auth,
      i = t.user;
  return B(i, e, "internal-error"), Lu(i, new eo(t), t.bypassAuthState);
}

function sv(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee164() {
    var e, i;
    return _regeneratorRuntime.wrap(function _callee164$(_context164) {
      while (1) {
        switch (_context164.prev = _context164.next) {
          case 0:
            e = t.auth, i = t.user;
            return _context164.abrupt("return", (B(i, e, "internal-error"), qa(i, new eo(t), t.bypassAuthState)));

          case 2:
          case "end":
            return _context164.stop();
        }
      }
    }, _callee164);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ku =
/*#__PURE__*/
function () {
  function Ku(e, i, n, r) {
    var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

    _classCallCheck(this, Ku);

    this.auth = e, this.resolver = n, this.user = r, this.bypassAuthState = a, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(i) ? i : [i];
  }

  _createClass(Ku, [{
    key: "execute",
    value: function execute() {
      var _this64 = this;

      return new Promise(function (e, i) {
        return u(_this64, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee165() {
          return _regeneratorRuntime.wrap(function _callee165$(_context165) {
            while (1) {
              switch (_context165.prev = _context165.next) {
                case 0:
                  this.pendingPromise = {
                    resolve: e,
                    reject: i
                  };
                  _context165.prev = 1;
                  _context165.next = 4;
                  return this.resolver._initialize(this.auth);

                case 4:
                  this.eventManager = _context165.sent;
                  _context165.next = 7;
                  return this.onExecution();

                case 7:
                  this.eventManager.registerConsumer(this);
                  _context165.next = 13;
                  break;

                case 10:
                  _context165.prev = 10;
                  _context165.t0 = _context165["catch"](1);
                  this.reject(_context165.t0);

                case 13:
                case "end":
                  return _context165.stop();
              }
            }
          }, _callee165, this, [[1, 10]]);
        }));
      });
    }
  }, {
    key: "onAuthEvent",
    value: function onAuthEvent(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee166() {
        var i, n, r, a, o, l, c;
        return _regeneratorRuntime.wrap(function _callee166$(_context166) {
          while (1) {
            switch (_context166.prev = _context166.next) {
              case 0:
                i = e.urlResponse, n = e.sessionId, r = e.postBody, a = e.tenantId, o = e.error, l = e.type;

                if (!o) {
                  _context166.next = 4;
                  break;
                }

                this.reject(o);
                return _context166.abrupt("return");

              case 4:
                c = {
                  auth: this.auth,
                  requestUri: i,
                  sessionId: n,
                  tenantId: a || void 0,
                  postBody: r || void 0,
                  user: this.user,
                  bypassAuthState: this.bypassAuthState
                };
                _context166.prev = 5;
                _context166.t0 = this;
                _context166.next = 9;
                return this.getIdpTask(l)(c);

              case 9:
                _context166.t1 = _context166.sent;

                _context166.t0.resolve.call(_context166.t0, _context166.t1);

                _context166.next = 16;
                break;

              case 13:
                _context166.prev = 13;
                _context166.t2 = _context166["catch"](5);
                this.reject(_context166.t2);

              case 16:
              case "end":
                return _context166.stop();
            }
          }
        }, _callee166, this, [[5, 13]]);
      }));
    }
  }, {
    key: "onError",
    value: function onError(e) {
      this.reject(e);
    }
  }, {
    key: "getIdpTask",
    value: function getIdpTask(e) {
      switch (e) {
        case "signInViaPopup":
        case "signInViaRedirect":
          return nv;

        case "linkViaPopup":
        case "linkViaRedirect":
          return sv;

        case "reauthViaPopup":
        case "reauthViaRedirect":
          return rv;

        default:
          Ae(this.auth, "internal-error");
      }
    }
  }, {
    key: "resolve",
    value: function resolve(e) {
      it(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(e), this.unregisterAndCleanUp();
    }
  }, {
    key: "reject",
    value: function reject(e) {
      it(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(e), this.unregisterAndCleanUp();
    }
  }, {
    key: "unregisterAndCleanUp",
    value: function unregisterAndCleanUp() {
      this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
    }
  }]);

  return Ku;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var av = new yn(2e3, 1e4);

function ov(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee167() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee167$(_context167) {
      while (1) {
        switch (_context167.prev = _context167.next) {
          case 0:
            n = fe(t);
            Mi(t, e, Et);
            r = oi(n, i);
            return _context167.abrupt("return", new yt(n, "signInViaPopup", e, r).executeNotNull());

          case 4:
          case "end":
            return _context167.stop();
        }
      }
    }, _callee167);
  }));
}

function lv(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee168() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee168$(_context168) {
      while (1) {
        switch (_context168.prev = _context168.next) {
          case 0:
            n = te(t);
            Mi(n.auth, e, Et);
            r = oi(n.auth, i);
            return _context168.abrupt("return", new yt(n.auth, "reauthViaPopup", e, r, n).executeNotNull());

          case 4:
          case "end":
            return _context168.stop();
        }
      }
    }, _callee168);
  }));
}

function cv(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee169() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee169$(_context169) {
      while (1) {
        switch (_context169.prev = _context169.next) {
          case 0:
            n = te(t);
            Mi(n.auth, e, Et);
            r = oi(n.auth, i);
            return _context169.abrupt("return", new yt(n.auth, "linkViaPopup", e, r, n).executeNotNull());

          case 4:
          case "end":
            return _context169.stop();
        }
      }
    }, _callee169);
  }));
}

var yt =
/*#__PURE__*/
function (_Ku) {
  _inherits(yt, _Ku);

  function yt(e, i, n, r, a) {
    var _this65;

    _classCallCheck(this, yt);

    _this65 = _possibleConstructorReturn(this, _getPrototypeOf(yt).call(this, e, i, r, a)), _this65.provider = n, _this65.authWindow = null, _this65.pollId = null, yt.currentPopupAction && yt.currentPopupAction.cancel(), yt.currentPopupAction = _assertThisInitialized(_this65);
    return _this65;
  }

  _createClass(yt, [{
    key: "executeNotNull",
    value: function executeNotNull() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee170() {
        var e;
        return _regeneratorRuntime.wrap(function _callee170$(_context170) {
          while (1) {
            switch (_context170.prev = _context170.next) {
              case 0:
                _context170.next = 2;
                return this.execute();

              case 2:
                e = _context170.sent;
                return _context170.abrupt("return", (B(e, this.auth, "internal-error"), e));

              case 4:
              case "end":
                return _context170.stop();
            }
          }
        }, _callee170, this);
      }));
    }
  }, {
    key: "onExecution",
    value: function onExecution() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee171() {
        var _this66 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee171$(_context171) {
          while (1) {
            switch (_context171.prev = _context171.next) {
              case 0:
                it(this.filter.length === 1, "Popup operations only handle one event");
                e = bn();
                _context171.next = 4;
                return this.resolver._openPopup(this.auth, this.provider, this.filter[0], e);

              case 4:
                this.authWindow = _context171.sent;
                this.authWindow.associatedEvent = e;

                this.resolver._originValidation(this.auth).catch(function (i) {
                  _this66.reject(i);
                });

                this.resolver._isIframeWebStorageSupported(this.auth, function (i) {
                  i || _this66.reject(xe(_this66.auth, "web-storage-unsupported"));
                });

                this.pollUserCancellation();

              case 9:
              case "end":
                return _context171.stop();
            }
          }
        }, _callee171, this);
      }));
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.reject(xe(this.auth, "cancelled-popup-request"));
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {
      this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, yt.currentPopupAction = null;
    }
  }, {
    key: "pollUserCancellation",
    value: function pollUserCancellation() {
      var _this67 = this;

      var e = function e() {
        var i, n;

        if (!((n = (i = _this67.authWindow) === null || i === void 0 ? void 0 : i.window) === null || n === void 0) && n.closed) {
          _this67.pollId = window.setTimeout(function () {
            _this67.pollId = null, _this67.reject(xe(_this67.auth, "popup-closed-by-user"));
          }, 8e3);
          return;
        }

        _this67.pollId = window.setTimeout(e, av.get());
      };

      e();
    }
  }, {
    key: "eventId",
    get: function get() {
      var e;
      return ((e = this.authWindow) === null || e === void 0 ? void 0 : e.associatedEvent) || null;
    }
  }]);

  return yt;
}(Ku);

yt.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var uv = "pendingRedirect",
    tn =
/* @__PURE__ */
new Map();

var nn =
/*#__PURE__*/
function (_Ku2) {
  _inherits(nn, _Ku2);

  function nn(e, i) {
    var _this68;

    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

    _classCallCheck(this, nn);

    _this68 = _possibleConstructorReturn(this, _getPrototypeOf(nn).call(this, e, ["signInViaRedirect", "linkViaRedirect", "reauthViaRedirect", "unknown"], i, void 0, n)), _this68.eventId = null;
    return _this68;
  }

  _createClass(nn, [{
    key: "execute",
    value: function execute() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee172() {
        var e, n;
        return _regeneratorRuntime.wrap(function _callee172$(_context172) {
          while (1) {
            switch (_context172.prev = _context172.next) {
              case 0:
                e = tn.get(this.auth._key());

                if (e) {
                  _context172.next = 20;
                  break;
                }

                _context172.prev = 2;
                _context172.next = 5;
                return dv(this.resolver, this.auth);

              case 5:
                if (!_context172.sent) {
                  _context172.next = 11;
                  break;
                }

                _context172.next = 8;
                return Wt(nn.prototype, this, "execute").call(this);

              case 8:
                _context172.t0 = _context172.sent;
                _context172.next = 12;
                break;

              case 11:
                _context172.t0 = null;

              case 12:
                n = _context172.t0;

                e = function e() {
                  return Promise.resolve(n);
                };

                _context172.next = 19;
                break;

              case 16:
                _context172.prev = 16;
                _context172.t1 = _context172["catch"](2);

                e = function e() {
                  return Promise.reject(_context172.t1);
                };

              case 19:
                tn.set(this.auth._key(), e);

              case 20:
                return _context172.abrupt("return", (this.bypassAuthState || tn.set(this.auth._key(), function () {
                  return Promise.resolve(null);
                }), e()));

              case 21:
              case "end":
                return _context172.stop();
            }
          }
        }, _callee172, this, [[2, 16]]);
      }));
    }
  }, {
    key: "onAuthEvent",
    value: function onAuthEvent(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee173() {
        var i;
        return _regeneratorRuntime.wrap(function _callee173$(_context173) {
          while (1) {
            switch (_context173.prev = _context173.next) {
              case 0:
                if (!(e.type === "signInViaRedirect")) {
                  _context173.next = 2;
                  break;
                }

                return _context173.abrupt("return", Wt(nn.prototype, this, "onAuthEvent").call(this, e));

              case 2:
                if (!(e.type === "unknown")) {
                  _context173.next = 5;
                  break;
                }

                this.resolve(null);
                return _context173.abrupt("return");

              case 5:
                if (!e.eventId) {
                  _context173.next = 12;
                  break;
                }

                _context173.next = 8;
                return this.auth._redirectUserForId(e.eventId);

              case 8:
                i = _context173.sent;

                if (!i) {
                  _context173.next = 11;
                  break;
                }

                return _context173.abrupt("return", (this.user = i, Wt(nn.prototype, this, "onAuthEvent").call(this, e)));

              case 11:
                this.resolve(null);

              case 12:
              case "end":
                return _context173.stop();
            }
          }
        }, _callee173, this);
      }));
    }
  }, {
    key: "onExecution",
    value: function onExecution() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee174() {
        return _regeneratorRuntime.wrap(function _callee174$(_context174) {
          while (1) {
            switch (_context174.prev = _context174.next) {
              case 0:
              case "end":
                return _context174.stop();
            }
          }
        }, _callee174);
      }));
    }
  }, {
    key: "cleanUp",
    value: function cleanUp() {}
  }]);

  return nn;
}(Ku);

function dv(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee175() {
    var i, n, r;
    return _regeneratorRuntime.wrap(function _callee175$(_context175) {
      while (1) {
        switch (_context175.prev = _context175.next) {
          case 0:
            i = Xu(e), n = Ju(t);
            _context175.next = 3;
            return n._isAvailable();

          case 3:
            if (_context175.sent) {
              _context175.next = 5;
              break;
            }

            return _context175.abrupt("return", !1);

          case 5:
            _context175.next = 7;
            return n._get(i);

          case 7:
            _context175.t0 = _context175.sent;
            r = _context175.t0 === "true";
            _context175.next = 11;
            return n._remove(i);

          case 11:
            return _context175.abrupt("return", r);

          case 12:
          case "end":
            return _context175.stop();
        }
      }
    }, _callee175);
  }));
}

function to(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee176() {
    return _regeneratorRuntime.wrap(function _callee176$(_context176) {
      while (1) {
        switch (_context176.prev = _context176.next) {
          case 0:
            return _context176.abrupt("return", Ju(t)._set(Xu(e), "true"));

          case 1:
          case "end":
            return _context176.stop();
        }
      }
    }, _callee176);
  }));
}

function hv() {
  tn.clear();
}

function io(t, e) {
  tn.set(t._key(), e);
}

function Ju(t) {
  return ze(t._redirectPersistence);
}

function Xu(t) {
  return Jt(uv, t.config.apiKey, t.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function pv(t, e, i) {
  return fv(t, e, i);
}

function fv(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee177() {
    var n, r;
    return _regeneratorRuntime.wrap(function _callee177$(_context177) {
      while (1) {
        switch (_context177.prev = _context177.next) {
          case 0:
            n = fe(t);
            Mi(t, e, Et);
            _context177.next = 4;
            return n._initializationPromise;

          case 4:
            r = oi(n, i);
            _context177.next = 7;
            return to(r, n);

          case 7:
            return _context177.abrupt("return", r._openRedirect(n, e, "signInViaRedirect"));

          case 8:
          case "end":
            return _context177.stop();
        }
      }
    }, _callee177);
  }));
}

function mv(t, e, i) {
  return gv(t, e, i);
}

function gv(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee178() {
    var n, r, a;
    return _regeneratorRuntime.wrap(function _callee178$(_context178) {
      while (1) {
        switch (_context178.prev = _context178.next) {
          case 0:
            n = te(t);
            Mi(n.auth, e, Et);
            _context178.next = 4;
            return n.auth._initializationPromise;

          case 4:
            r = oi(n.auth, i);
            _context178.next = 7;
            return to(r, n.auth);

          case 7:
            _context178.next = 9;
            return Zu(n);

          case 9:
            a = _context178.sent;
            return _context178.abrupt("return", r._openRedirect(n.auth, e, "reauthViaRedirect", a));

          case 11:
          case "end":
            return _context178.stop();
        }
      }
    }, _callee178);
  }));
}

function yv(t, e, i) {
  return vv(t, e, i);
}

function vv(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee179() {
    var n, r, a;
    return _regeneratorRuntime.wrap(function _callee179$(_context179) {
      while (1) {
        switch (_context179.prev = _context179.next) {
          case 0:
            n = te(t);
            Mi(n.auth, e, Et);
            _context179.next = 4;
            return n.auth._initializationPromise;

          case 4:
            r = oi(n.auth, i);
            _context179.next = 7;
            return xr(!1, n, e.providerId);

          case 7:
            _context179.next = 9;
            return to(r, n.auth);

          case 9:
            _context179.next = 11;
            return Zu(n);

          case 11:
            a = _context179.sent;
            return _context179.abrupt("return", r._openRedirect(n.auth, e, "linkViaRedirect", a));

          case 13:
          case "end":
            return _context179.stop();
        }
      }
    }, _callee179);
  }));
}

function wv(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee180() {
    return _regeneratorRuntime.wrap(function _callee180$(_context180) {
      while (1) {
        switch (_context180.prev = _context180.next) {
          case 0:
            _context180.next = 2;
            return fe(t)._initializationPromise;

          case 2:
            return _context180.abrupt("return", Br(t, e, !1));

          case 3:
          case "end":
            return _context180.stop();
        }
      }
    }, _callee180);
  }));
}

function Br(t, e) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee181() {
    var n, r, o;
    return _regeneratorRuntime.wrap(function _callee181$(_context181) {
      while (1) {
        switch (_context181.prev = _context181.next) {
          case 0:
            n = fe(t);
            r = oi(n, e);
            _context181.next = 4;
            return new nn(n, r, i).execute();

          case 4:
            o = _context181.sent;
            _context181.t0 = o && !i;

            if (!_context181.t0) {
              _context181.next = 12;
              break;
            }

            delete o.user._redirectEventId;
            _context181.next = 10;
            return n._persistUserIfCurrent(o.user);

          case 10:
            _context181.next = 12;
            return n._setRedirectUser(null, e);

          case 12:
            return _context181.abrupt("return", o);

          case 13:
          case "end":
            return _context181.stop();
        }
      }
    }, _callee181);
  }));
}

function Zu(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee182() {
    var e;
    return _regeneratorRuntime.wrap(function _callee182$(_context182) {
      while (1) {
        switch (_context182.prev = _context182.next) {
          case 0:
            e = bn("".concat(t.uid, ":::"));
            t._redirectEventId = e;
            _context182.next = 4;
            return t.auth._setRedirectUser(t);

          case 4:
            _context182.next = 6;
            return t.auth._persistUserIfCurrent(t);

          case 6:
            return _context182.abrupt("return", e);

          case 7:
          case "end":
            return _context182.stop();
        }
      }
    }, _callee182);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var bv = 10 * 60 * 1e3;

var ed =
/*#__PURE__*/
function () {
  function ed(e) {
    _classCallCheck(this, ed);

    this.auth = e, this.cachedEventUids =
    /* @__PURE__ */
    new Set(), this.consumers =
    /* @__PURE__ */
    new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
  }

  _createClass(ed, [{
    key: "registerConsumer",
    value: function registerConsumer(e) {
      this.consumers.add(e), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, e) && (this.sendToConsumer(this.queuedRedirectEvent, e), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
    }
  }, {
    key: "unregisterConsumer",
    value: function unregisterConsumer(e) {
      this.consumers.delete(e);
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      var _this69 = this;

      if (this.hasEventBeenHandled(e)) return !1;
      var i = !1;
      return this.consumers.forEach(function (n) {
        _this69.isEventForConsumer(e, n) && (i = !0, _this69.sendToConsumer(e, n), _this69.saveEventToCache(e));
      }), this.hasHandledPotentialRedirect || !Iv(e) || (this.hasHandledPotentialRedirect = !0, i || (this.queuedRedirectEvent = e, i = !0)), i;
    }
  }, {
    key: "sendToConsumer",
    value: function sendToConsumer(e, i) {
      var n;

      if (e.error && !td(e)) {
        var _r9 = ((n = e.error.code) === null || n === void 0 ? void 0 : n.split("auth/")[1]) || "internal-error";

        i.onError(xe(this.auth, _r9));
      } else i.onAuthEvent(e);
    }
  }, {
    key: "isEventForConsumer",
    value: function isEventForConsumer(e, i) {
      var n = i.eventId === null || !!e.eventId && e.eventId === i.eventId;
      return i.filter.includes(e.type) && n;
    }
  }, {
    key: "hasEventBeenHandled",
    value: function hasEventBeenHandled(e) {
      return Date.now() - this.lastProcessedEventTime >= bv && this.cachedEventUids.clear(), this.cachedEventUids.has(ol(e));
    }
  }, {
    key: "saveEventToCache",
    value: function saveEventToCache(e) {
      this.cachedEventUids.add(ol(e)), this.lastProcessedEventTime = Date.now();
    }
  }]);

  return ed;
}();

function ol(t) {
  return [t.type, t.eventId, t.sessionId, t.tenantId].filter(function (e) {
    return e;
  }).join("-");
}

function td(_ref37) {
  var t = _ref37.type,
      e = _ref37.error;
  return t === "unknown" && (e == null ? void 0 : e.code) === "auth/no-auth-event";
}

function Iv(t) {
  switch (t.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return !0;

    case "unknown":
      return td(t);

    default:
      return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function id(i) {
  return u(this, arguments,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee183(t) {
    var e,
        _args183 = arguments;
    return _regeneratorRuntime.wrap(function _callee183$(_context183) {
      while (1) {
        switch (_context183.prev = _context183.next) {
          case 0:
            e = _args183.length > 1 && _args183[1] !== undefined ? _args183[1] : {};
            return _context183.abrupt("return", Re(t, "GET", "/v1/projects", e));

          case 2:
          case "end":
            return _context183.stop();
        }
      }
    }, _callee183);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var _v = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
    Ev = /^https?/;

function Cv(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee184() {
    var _ref38, e, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, i;

    return _regeneratorRuntime.wrap(function _callee184$(_context184) {
      while (1) {
        switch (_context184.prev = _context184.next) {
          case 0:
            if (!t.config.emulator) {
              _context184.next = 2;
              break;
            }

            return _context184.abrupt("return");

          case 2:
            _context184.next = 4;
            return id(t);

          case 4:
            _ref38 = _context184.sent;
            e = _ref38.authorizedDomains;
            _iteratorNormalCompletion13 = true;
            _didIteratorError13 = false;
            _iteratorError13 = undefined;
            _context184.prev = 9;
            _iterator13 = e[Symbol.iterator]();

          case 11:
            if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
              _context184.next = 23;
              break;
            }

            i = _step13.value;
            _context184.prev = 13;

            if (!Sv(i)) {
              _context184.next = 16;
              break;
            }

            return _context184.abrupt("return");

          case 16:
            _context184.next = 20;
            break;

          case 18:
            _context184.prev = 18;
            _context184.t0 = _context184["catch"](13);

          case 20:
            _iteratorNormalCompletion13 = true;
            _context184.next = 11;
            break;

          case 23:
            _context184.next = 29;
            break;

          case 25:
            _context184.prev = 25;
            _context184.t1 = _context184["catch"](9);
            _didIteratorError13 = true;
            _iteratorError13 = _context184.t1;

          case 29:
            _context184.prev = 29;
            _context184.prev = 30;

            if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
              _iterator13.return();
            }

          case 32:
            _context184.prev = 32;

            if (!_didIteratorError13) {
              _context184.next = 35;
              break;
            }

            throw _iteratorError13;

          case 35:
            return _context184.finish(32);

          case 36:
            return _context184.finish(29);

          case 37:
            Ae(t, "unauthorized-domain");

          case 38:
          case "end":
            return _context184.stop();
        }
      }
    }, _callee184, null, [[9, 25, 29, 37], [13, 18], [30,, 32, 36]]);
  }));
}

function Sv(t) {
  var e = cn(),
      _ref39 = new URL(e),
      i = _ref39.protocol,
      n = _ref39.hostname;

  if (t.startsWith("chrome-extension://")) {
    var o = new URL(t);
    return o.hostname === "" && n === "" ? i === "chrome-extension:" && t.replace("chrome-extension://", "") === e.replace("chrome-extension://", "") : i === "chrome-extension:" && o.hostname === n;
  }

  if (!Ev.test(i)) return !1;
  if (_v.test(t)) return n === t;
  var r = t.replace(/\./g, "\\.");
  return new RegExp("^(.+\\." + r + "|" + r + ")$", "i").test(n);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Tv = new yn(3e4, 6e4);

function ll() {
  var t = me().___jsl;

  if (t != null && t.H) {
    for (var _i15 = 0, _Object$keys3 = Object.keys(t.H); _i15 < _Object$keys3.length; _i15++) {
      var e = _Object$keys3[_i15];
      if (t.H[e].r = t.H[e].r || [], t.H[e].L = t.H[e].L || [], t.H[e].r = _toConsumableArray(t.H[e].L), t.CP) for (var i = 0; i < t.CP.length; i++) {
        t.CP[i] = null;
      }
    }
  }
}

function Rv(t) {
  return new Promise(function (e, i) {
    var n, r, a;

    function o() {
      ll(), gapi.load("gapi.iframes", {
        callback: function callback() {
          e(gapi.iframes.getContext());
        },
        ontimeout: function ontimeout() {
          ll(), i(xe(t, "network-request-failed"));
        },
        timeout: Tv.get()
      });
    }

    if (!((r = (n = me().gapi) === null || n === void 0 ? void 0 : n.iframes) === null || r === void 0) && r.Iframe) e(gapi.iframes.getContext());else if (!((a = me().gapi) === null || a === void 0) && a.load) o();else {
      var l = Au("iframefcb");
      return me()[l] = function () {
        gapi.load ? o() : i(xe(t, "network-request-failed"));
      }, Ga("https://apis.google.com/js/api.js?onload=".concat(l)).catch(function (c) {
        return i(c);
      });
    }
  }).catch(function (e) {
    throw Wn = null, e;
  });
}

var Wn = null;

function Pv(t) {
  return Wn = Wn || Rv(t), Wn;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ov = new yn(5e3, 15e3),
    Av = "__/auth/iframe",
    Mv = "emulator/auth/iframe",
    Fv = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px"
  },
  "aria-hidden": "true",
  tabindex: "-1"
},
    kv =
/* @__PURE__ */
new Map([["identitytoolkit.googleapis.com", "p"], ["staging-identitytoolkit.sandbox.googleapis.com", "s"], ["test-identitytoolkit.sandbox.googleapis.com", "t"]]);

function xv(t) {
  var e = t.config;
  B(e.authDomain, t, "auth-domain-config-required");
  var i = e.emulator ? ja(e, Mv) : "https://".concat(t.config.authDomain, "/").concat(Av),
      n = {
    apiKey: e.apiKey,
    appName: t.name,
    v: ai
  },
      r = kv.get(t.config.apiHost);
  r && (n.eid = r);

  var a = t._getFrameworks();

  return a.length && (n.fw = a.join(",")), "".concat(i, "?").concat(Ai(n).slice(1));
}

function Dv(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee186() {
    var _this70 = this;

    var e, i;
    return _regeneratorRuntime.wrap(function _callee186$(_context186) {
      while (1) {
        switch (_context186.prev = _context186.next) {
          case 0:
            _context186.next = 2;
            return Pv(t);

          case 2:
            e = _context186.sent;
            i = me().gapi;
            return _context186.abrupt("return", (B(i, t, "internal-error"), e.open({
              where: document.body,
              url: xv(t),
              messageHandlersFilter: i.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
              attributes: Fv,
              dontclear: !0
            }, function (n) {
              return new Promise(function (r, a) {
                return u(_this70, null,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee185() {
                  var o, l, c;
                  return _regeneratorRuntime.wrap(function _callee185$(_context185) {
                    while (1) {
                      switch (_context185.prev = _context185.next) {
                        case 0:
                          c = function _ref40() {
                            me().clearTimeout(l), r(n);
                          };

                          _context185.next = 3;
                          return n.restyle({
                            setHideOnLeave: !1
                          });

                        case 3:
                          o = xe(t, "network-request-failed"), l = me().setTimeout(function () {
                            a(o);
                          }, Ov.get());
                          n.ping(c).then(c, function () {
                            a(o);
                          });

                        case 5:
                        case "end":
                          return _context185.stop();
                      }
                    }
                  }, _callee185);
                }));
              });
            })));

          case 5:
          case "end":
            return _context186.stop();
        }
      }
    }, _callee186);
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Nv = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no"
},
    Lv = 500,
    $v = 600,
    Uv = "_blank",
    Bv = "http://localhost";

var cl =
/*#__PURE__*/
function () {
  function cl(e) {
    _classCallCheck(this, cl);

    this.window = e, this.associatedEvent = null;
  }

  _createClass(cl, [{
    key: "close",
    value: function close() {
      if (this.window) try {
        this.window.close();
      } catch (e) {}
    }
  }]);

  return cl;
}();

function Hv(t, e, i) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Lv;
  var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $v;
  var a = Math.max((window.screen.availHeight - r) / 2, 0).toString(),
      o = Math.max((window.screen.availWidth - n) / 2, 0).toString();
  var l = "";
  var c = Object.assign(Object.assign({}, Nv), {
    width: n.toString(),
    height: r.toString(),
    top: a,
    left: o
  }),
      d = we().toLowerCase();
  i && (l = _u(d) ? Uv : i), Iu(d) && (e = e || Bv, c.scrollbars = "yes");
  var h = Object.entries(c).reduce(function (g, _ref41) {
    var _ref42 = _slicedToArray(_ref41, 2),
        f = _ref42[0],
        v = _ref42[1];

    return "".concat(g).concat(f, "=").concat(v, ",");
  }, "");
  if (mg(d) && l !== "_self") return Vv(e || "", l), new cl(null);
  var p = window.open(e || "", l, h);
  B(p, t, "popup-blocked");

  try {
    p.focus();
  } catch (g) {}

  return new cl(p);
}

function Vv(t, e) {
  var i = document.createElement("a");
  i.href = t, i.target = e;
  var n = document.createEvent("MouseEvent");
  n.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), i.dispatchEvent(n);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var jv = "__/auth/handler",
    Wv = "emulator/auth/handler",
    Gv = encodeURIComponent("fac");

function aa(t, e, i, n, r, a) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee187() {
    var o, _i16, _Object$entries2, _ref45, _ref44, h, p, _h2, l, _i17, _Object$keys4, _h3, c, d;

    return _regeneratorRuntime.wrap(function _callee187$(_context187) {
      while (1) {
        switch (_context187.prev = _context187.next) {
          case 0:
            B(t.config.authDomain, t, "auth-domain-config-required"), B(t.config.apiKey, t, "invalid-api-key");
            o = {
              apiKey: t.config.apiKey,
              appName: t.name,
              authType: i,
              redirectUrl: n,
              v: ai,
              eventId: r
            };

            if (e instanceof Et) {
              e.setDefaultLanguage(t.languageCode), o.providerId = e.providerId || "", Rf(e.getCustomParameters()) || (o.customParameters = JSON.stringify(e.getCustomParameters()));

              for (_i16 = 0, _Object$entries2 = Object.entries(a || {}); _i16 < _Object$entries2.length; _i16++) {
                _ref45 = _Object$entries2[_i16];
                _ref44 = _slicedToArray(_ref45, 2);
                h = _ref44[0];
                p = _ref44[1];
                o[h] = p;
              }
            }

            if (e instanceof xi) {
              _h2 = e.getScopes().filter(function (p) {
                return p !== "";
              });
              _h2.length > 0 && (o.scopes = _h2.join(","));
            }

            t.tenantId && (o.tid = t.tenantId);
            l = o;

            for (_i17 = 0, _Object$keys4 = Object.keys(l); _i17 < _Object$keys4.length; _i17++) {
              _h3 = _Object$keys4[_i17];
              l[_h3] === void 0 && delete l[_h3];
            }

            _context187.next = 9;
            return t._getAppCheckToken();

          case 9:
            c = _context187.sent;
            d = c ? "#".concat(Gv, "=").concat(encodeURIComponent(c)) : "";
            return _context187.abrupt("return", "".concat(zv(t), "?").concat(Ai(l).slice(1)).concat(d));

          case 12:
          case "end":
            return _context187.stop();
        }
      }
    }, _callee187);
  }));
}

function zv(_ref46) {
  var t = _ref46.config;
  return t.emulator ? ja(t, Wv) : "https://".concat(t.authDomain, "/").concat(jv);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var xs = "webStorageSupport";

var qv =
/*#__PURE__*/
function () {
  function qv() {
    _classCallCheck(this, qv);

    this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = Vt, this._completeRedirectFn = Br, this._overrideRedirectResult = io;
  }

  _createClass(qv, [{
    key: "_openPopup",
    value: function _openPopup(e, i, n, r) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee188() {
        var a, o;
        return _regeneratorRuntime.wrap(function _callee188$(_context188) {
          while (1) {
            switch (_context188.prev = _context188.next) {
              case 0:
                it((a = this.eventManagers[e._key()]) === null || a === void 0 ? void 0 : a.manager, "_initialize() not called before _openPopup()");
                _context188.next = 3;
                return aa(e, i, n, cn(), r);

              case 3:
                o = _context188.sent;
                return _context188.abrupt("return", Hv(e, o, bn()));

              case 5:
              case "end":
                return _context188.stop();
            }
          }
        }, _callee188, this);
      }));
    }
  }, {
    key: "_openRedirect",
    value: function _openRedirect(e, i, n, r) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee189() {
        var a;
        return _regeneratorRuntime.wrap(function _callee189$(_context189) {
          while (1) {
            switch (_context189.prev = _context189.next) {
              case 0:
                _context189.next = 2;
                return this._originValidation(e);

              case 2:
                _context189.next = 4;
                return aa(e, i, n, cn(), r);

              case 4:
                a = _context189.sent;
                return _context189.abrupt("return", (Oy(a), new Promise(function () {})));

              case 6:
              case "end":
                return _context189.stop();
            }
          }
        }, _callee189, this);
      }));
    }
  }, {
    key: "_initialize",
    value: function _initialize(e) {
      var _this71 = this;

      var i = e._key();

      if (this.eventManagers[i]) {
        var _this$eventManagers$i = this.eventManagers[i],
            _r10 = _this$eventManagers$i.manager,
            a = _this$eventManagers$i.promise;
        return _r10 ? Promise.resolve(_r10) : (it(a, "If manager is not set, promise should be"), a);
      }

      var n = this.initAndGetManager(e);
      return this.eventManagers[i] = {
        promise: n
      }, n.catch(function () {
        delete _this71.eventManagers[i];
      }), n;
    }
  }, {
    key: "initAndGetManager",
    value: function initAndGetManager(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee190() {
        var i, n;
        return _regeneratorRuntime.wrap(function _callee190$(_context190) {
          while (1) {
            switch (_context190.prev = _context190.next) {
              case 0:
                _context190.next = 2;
                return Dv(e);

              case 2:
                i = _context190.sent;
                n = new ed(e);
                return _context190.abrupt("return", (i.register("authEvent", function (r) {
                  return B(r == null ? void 0 : r.authEvent, e, "invalid-auth-event"), {
                    status: n.onEvent(r.authEvent) ? "ACK" : "ERROR"
                  };
                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[e._key()] = {
                  manager: n
                }, this.iframes[e._key()] = i, n));

              case 5:
              case "end":
                return _context190.stop();
            }
          }
        }, _callee190, this);
      }));
    }
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(e, i) {
      this.iframes[e._key()].send(xs, {
        type: xs
      }, function (r) {
        var a;
        var o = (a = r == null ? void 0 : r[0]) === null || a === void 0 ? void 0 : a[xs];
        o !== void 0 && i(!!o), Ae(e, "internal-error");
      }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(e) {
      var i = e._key();

      return this.originValidationPromises[i] || (this.originValidationPromises[i] = Cv(e)), this.originValidationPromises[i];
    }
  }, {
    key: "_shouldInitProactively",
    get: function get() {
      return Tu() || Wa() || Fi();
    }
  }]);

  return qv;
}();

var nd = qv;

var Qv =
/*#__PURE__*/
function () {
  function Qv(e) {
    _classCallCheck(this, Qv);

    this.factorId = e;
  }

  _createClass(Qv, [{
    key: "_process",
    value: function _process(e, i, n) {
      switch (i.type) {
        case "enroll":
          return this._finalizeEnroll(e, i.credential, n);

        case "signin":
          return this._finalizeSignIn(e, i.credential);

        default:
          return dt("unexpected MultiFactorSessionType");
      }
    }
  }]);

  return Qv;
}();

var no =
/*#__PURE__*/
function (_Qv) {
  _inherits(no, _Qv);

  function no(e) {
    var _this72;

    _classCallCheck(this, no);

    _this72 = _possibleConstructorReturn(this, _getPrototypeOf(no).call(this, "phone")), _this72.credential = e;
    return _this72;
  }

  _createClass(no, [{
    key: "_finalizeEnroll",
    value: function _finalizeEnroll(e, i, n) {
      return Iy(e, {
        idToken: i,
        displayName: n,
        phoneVerificationInfo: this.credential._makeVerificationRequest()
      });
    }
  }, {
    key: "_finalizeSignIn",
    value: function _finalizeSignIn(e, i) {
      return Uy(e, {
        mfaPendingCredential: i,
        phoneVerificationInfo: this.credential._makeVerificationRequest()
      });
    }
  }], [{
    key: "_fromCredential",
    value: function _fromCredential(e) {
      return new no(e);
    }
  }]);

  return no;
}(Qv);

var rd =
/*#__PURE__*/
function () {
  function rd() {
    _classCallCheck(this, rd);
  }

  _createClass(rd, null, [{
    key: "assertion",
    value: function assertion(e) {
      return no._fromCredential(e);
    }
  }]);

  return rd;
}();

rd.FACTOR_ID = "phone";
var ul = "@firebase/auth",
    dl = "0.23.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Yv =
/*#__PURE__*/
function () {
  function Yv(e) {
    _classCallCheck(this, Yv);

    this.auth = e, this.internalListeners =
    /* @__PURE__ */
    new Map();
  }

  _createClass(Yv, [{
    key: "getUid",
    value: function getUid() {
      var e;
      return this.assertAuthConfigured(), ((e = this.auth.currentUser) === null || e === void 0 ? void 0 : e.uid) || null;
    }
  }, {
    key: "getToken",
    value: function getToken(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee191() {
        return _regeneratorRuntime.wrap(function _callee191$(_context191) {
          while (1) {
            switch (_context191.prev = _context191.next) {
              case 0:
                this.assertAuthConfigured();
                _context191.next = 3;
                return this.auth._initializationPromise;

              case 3:
                if (!this.auth.currentUser) {
                  _context191.next = 10;
                  break;
                }

                _context191.next = 6;
                return this.auth.currentUser.getIdToken(e);

              case 6:
                _context191.t1 = _context191.sent;
                _context191.t0 = {
                  accessToken: _context191.t1
                };
                _context191.next = 11;
                break;

              case 10:
                _context191.t0 = null;

              case 11:
                return _context191.abrupt("return", _context191.t0);

              case 12:
              case "end":
                return _context191.stop();
            }
          }
        }, _callee191, this);
      }));
    }
  }, {
    key: "addAuthTokenListener",
    value: function addAuthTokenListener(e) {
      if (this.assertAuthConfigured(), this.internalListeners.has(e)) return;
      var i = this.auth.onIdTokenChanged(function (n) {
        e((n == null ? void 0 : n.stsTokenManager.accessToken) || null);
      });
      this.internalListeners.set(e, i), this.updateProactiveRefresh();
    }
  }, {
    key: "removeAuthTokenListener",
    value: function removeAuthTokenListener(e) {
      this.assertAuthConfigured();
      var i = this.internalListeners.get(e);
      !i || (this.internalListeners.delete(e), i(), this.updateProactiveRefresh());
    }
  }, {
    key: "assertAuthConfigured",
    value: function assertAuthConfigured() {
      B(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth");
    }
  }, {
    key: "updateProactiveRefresh",
    value: function updateProactiveRefresh() {
      this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
    }
  }]);

  return Yv;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Kv(t) {
  switch (t) {
    case "Node":
      return "node";

    case "ReactNative":
      return "rn";

    case "Worker":
      return "webworker";

    case "Cordova":
      return "cordova";

    default:
      return;
  }
}

function Jv(t) {
  ti(new $t("auth", function (e, _ref47) {
    var i = _ref47.options;
    var n = e.getProvider("app").getImmediate(),
        r = e.getProvider("heartbeat"),
        a = e.getProvider("app-check-internal"),
        _n$options = n.options,
        o = _n$options.apiKey,
        l = _n$options.authDomain;
    B(o && !o.includes(":"), "invalid-api-key", {
      appName: n.name
    });
    var c = {
      apiKey: o,
      authDomain: l,
      clientPlatform: t,
      apiHost: "identitytoolkit.googleapis.com",
      tokenApiHost: "securetoken.googleapis.com",
      apiScheme: "https",
      sdkClientVersion: Ru(t)
    },
        d = new Cg(n, r, a, c);
    return Tg(d, i), d;
  }, "PUBLIC").setInstantiationMode("EXPLICIT").setInstanceCreatedCallback(function (e, i, n) {
    e.getProvider("auth-internal").initialize();
  })), ti(new $t("auth-internal", function (e) {
    var i = fe(e.getProvider("auth").getImmediate());
    return function (n) {
      return new Yv(n);
    }(i);
  }, "PRIVATE").setInstantiationMode("EXPLICIT")), Dt(ul, dl, Kv(t)), Dt(ul, dl, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Xv = 5 * 60,
    Zv = Jc("authIdTokenMaxAge") || Xv;
var hl = null;

var ew = function ew(t) {
  return function (e) {
    return u(void 0, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee192() {
      var i, n, r;
      return _regeneratorRuntime.wrap(function _callee192$(_context192) {
        while (1) {
          switch (_context192.prev = _context192.next) {
            case 0:
              _context192.t0 = e;

              if (!_context192.t0) {
                _context192.next = 5;
                break;
              }

              _context192.next = 4;
              return e.getIdTokenResult();

            case 4:
              _context192.t0 = _context192.sent;

            case 5:
              i = _context192.t0;
              n = i && (new Date().getTime() - Date.parse(i.issuedAtTime)) / 1e3;

              if (!(n && n > Zv)) {
                _context192.next = 9;
                break;
              }

              return _context192.abrupt("return");

            case 9:
              r = i == null ? void 0 : i.token;
              _context192.t1 = hl !== r;

              if (!_context192.t1) {
                _context192.next = 15;
                break;
              }

              hl = r;
              _context192.next = 15;
              return fetch(t, {
                method: r ? "POST" : "DELETE",
                headers: r ? {
                  Authorization: "Bearer ".concat(r)
                } : {}
              });

            case 15:
            case "end":
              return _context192.stop();
          }
        }
      }, _callee192);
    }));
  };
};

function tw() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : au();
  var e = Ar(t, "auth");
  if (e.isInitialized()) return e.getImmediate();
  var i = Sg(t, {
    popupRedirectResolver: nd,
    persistence: [Si, Nr, Vt]
  }),
      n = Jc("authTokenSyncURL");

  if (n) {
    var a = ew(n);
    vy(i, a, function () {
      return a(i.currentUser);
    }), yy(i, function (o) {
      return a(o);
    });
  }

  var r = wf("auth");
  return r && za(i, "http://".concat(r)), i;
}

Jv("Browser");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function ii() {
  return window;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var iw = 2e3;

function nw(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee193() {
    var n, _ii, r, a, o;

    return _regeneratorRuntime.wrap(function _callee193$(_context193) {
      while (1) {
        switch (_context193.prev = _context193.next) {
          case 0:
            _ii = ii(), r = _ii.BuildInfo;
            it(e.sessionId, "AuthEvent did not contain a session ID");
            _context193.next = 4;
            return lw(e.sessionId);

          case 4:
            a = _context193.sent;
            o = {};
            return _context193.abrupt("return", (Fi() ? o.ibi = r.packageName : vn() ? o.apn = r.packageName : Ae(t, "operation-not-supported-in-this-environment"), r.displayName && (o.appDisplayName = r.displayName), o.sessionId = a, aa(t, i, e.type, void 0, (n = e.eventId) !== null && n !== void 0 ? n : void 0, o)));

          case 7:
          case "end":
            return _context193.stop();
        }
      }
    }, _callee193);
  }));
}

function rw(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee194() {
    var _ii2, e, i;

    return _regeneratorRuntime.wrap(function _callee194$(_context194) {
      while (1) {
        switch (_context194.prev = _context194.next) {
          case 0:
            _ii2 = ii(), e = _ii2.BuildInfo, i = {};
            Fi() ? i.iosBundleId = e.packageName : vn() ? i.androidPackageName = e.packageName : Ae(t, "operation-not-supported-in-this-environment");
            _context194.next = 4;
            return id(t, i);

          case 4:
          case "end":
            return _context194.stop();
        }
      }
    }, _callee194);
  }));
}

function sw(t) {
  var _ii3 = ii(),
      e = _ii3.cordova;

  return new Promise(function (i) {
    e.plugins.browsertab.isAvailable(function (n) {
      var r = null;
      n ? e.plugins.browsertab.openUrl(t) : r = e.InAppBrowser.open(t, fg() ? "_blank" : "_system", "location=yes"), i(r);
    });
  });
}

function aw(t, e, i) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee195() {
    var _ii4, n, r;

    return _regeneratorRuntime.wrap(function _callee195$(_context195) {
      while (1) {
        switch (_context195.prev = _context195.next) {
          case 0:
            _ii4 = ii(), n = _ii4.cordova;

            r = function r() {};

            _context195.prev = 2;
            _context195.next = 5;
            return new Promise(function (a, o) {
              var l = null;

              function c() {
                var p;
                a();
                var g = (p = n.plugins.browsertab) === null || p === void 0 ? void 0 : p.close;
                typeof g == "function" && g(), typeof (i == null ? void 0 : i.close) == "function" && i.close();
              }

              function d() {
                l || (l = window.setTimeout(function () {
                  o(xe(t, "redirect-cancelled-by-user"));
                }, iw));
              }

              function h() {
                (document == null ? void 0 : document.visibilityState) === "visible" && d();
              }

              e.addPassiveListener(c), document.addEventListener("resume", d, !1), vn() && document.addEventListener("visibilitychange", h, !1), r = function r() {
                e.removePassiveListener(c), document.removeEventListener("resume", d, !1), document.removeEventListener("visibilitychange", h, !1), l && window.clearTimeout(l);
              };
            });

          case 5:
            _context195.prev = 5;
            r();
            return _context195.finish(5);

          case 8:
          case "end":
            return _context195.stop();
        }
      }
    }, _callee195, null, [[2,, 5, 8]]);
  }));
}

function ow(t) {
  var e, i, n, r, a, o, l, c, d, h;
  var p = ii();
  B(typeof ((e = p == null ? void 0 : p.universalLinks) === null || e === void 0 ? void 0 : e.subscribe) == "function", t, "invalid-cordova-configuration", {
    missingPlugin: "cordova-universal-links-plugin-fix"
  }), B(typeof ((i = p == null ? void 0 : p.BuildInfo) === null || i === void 0 ? void 0 : i.packageName) != "undefined", t, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-buildInfo"
  }), B(typeof ((a = (r = (n = p == null ? void 0 : p.cordova) === null || n === void 0 ? void 0 : n.plugins) === null || r === void 0 ? void 0 : r.browsertab) === null || a === void 0 ? void 0 : a.openUrl) == "function", t, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-browsertab"
  }), B(typeof ((c = (l = (o = p == null ? void 0 : p.cordova) === null || o === void 0 ? void 0 : o.plugins) === null || l === void 0 ? void 0 : l.browsertab) === null || c === void 0 ? void 0 : c.isAvailable) == "function", t, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-browsertab"
  }), B(typeof ((h = (d = p == null ? void 0 : p.cordova) === null || d === void 0 ? void 0 : d.InAppBrowser) === null || h === void 0 ? void 0 : h.open) == "function", t, "invalid-cordova-configuration", {
    missingPlugin: "cordova-plugin-inappbrowser"
  });
}

function lw(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee196() {
    var e, i;
    return _regeneratorRuntime.wrap(function _callee196$(_context196) {
      while (1) {
        switch (_context196.prev = _context196.next) {
          case 0:
            e = cw(t);
            _context196.next = 3;
            return crypto.subtle.digest("SHA-256", e);

          case 3:
            i = _context196.sent;
            return _context196.abrupt("return", Array.from(new Uint8Array(i)).map(function (r) {
              return r.toString(16).padStart(2, "0");
            }).join(""));

          case 5:
          case "end":
            return _context196.stop();
        }
      }
    }, _callee196);
  }));
}

function cw(t) {
  if (it(/[0-9a-zA-Z]+/.test(t), "Can only convert alpha-numeric strings"), typeof TextEncoder != "undefined") return new TextEncoder().encode(t);
  var e = new ArrayBuffer(t.length),
      i = new Uint8Array(e);

  for (var n = 0; n < t.length; n++) {
    i[n] = t.charCodeAt(n);
  }

  return i;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var uw = 20;

var dw =
/*#__PURE__*/
function (_ed) {
  _inherits(dw, _ed);

  function dw() {
    var _this73;

    _classCallCheck(this, dw);

    _this73 = _possibleConstructorReturn(this, _getPrototypeOf(dw).apply(this, arguments)), _this73.passiveListeners =
    /* @__PURE__ */
    new Set(), _this73.initPromise = new Promise(function (e) {
      _this73.resolveInialized = e;
    });
    return _this73;
  }

  _createClass(dw, [{
    key: "addPassiveListener",
    value: function addPassiveListener(e) {
      this.passiveListeners.add(e);
    }
  }, {
    key: "removePassiveListener",
    value: function removePassiveListener(e) {
      this.passiveListeners.delete(e);
    }
  }, {
    key: "resetRedirect",
    value: function resetRedirect() {
      this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1;
    }
  }, {
    key: "onEvent",
    value: function onEvent(e) {
      return this.resolveInialized(), this.passiveListeners.forEach(function (i) {
        return i(e);
      }), _get2(_getPrototypeOf(dw.prototype), "onEvent", this).call(this, e);
    }
  }, {
    key: "initialized",
    value: function initialized() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee197() {
        return _regeneratorRuntime.wrap(function _callee197$(_context197) {
          while (1) {
            switch (_context197.prev = _context197.next) {
              case 0:
                _context197.next = 2;
                return this.initPromise;

              case 2:
              case "end":
                return _context197.stop();
            }
          }
        }, _callee197, this);
      }));
    }
  }]);

  return dw;
}(ed);

function hw(t, e) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: e,
    eventId: i,
    urlResponse: null,
    sessionId: mw(),
    postBody: null,
    tenantId: t.tenantId,
    error: xe(t, "no-auth-event")
  };
}

function pw(t, e) {
  return oa()._set(la(t), e);
}

function pl(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee198() {
    var e;
    return _regeneratorRuntime.wrap(function _callee198$(_context198) {
      while (1) {
        switch (_context198.prev = _context198.next) {
          case 0:
            _context198.next = 2;
            return oa()._get(la(t));

          case 2:
            e = _context198.sent;
            _context198.t0 = e;

            if (!_context198.t0) {
              _context198.next = 7;
              break;
            }

            _context198.next = 7;
            return oa()._remove(la(t));

          case 7:
            return _context198.abrupt("return", e);

          case 8:
          case "end":
            return _context198.stop();
        }
      }
    }, _callee198);
  }));
}

function fw(t, e) {
  var i, n;
  var r = yw(e);

  if (r.includes("/__/auth/callback")) {
    var a = Gn(r),
        o = a.firebaseError ? gw(decodeURIComponent(a.firebaseError)) : null,
        _l2 = (n = (i = o == null ? void 0 : o.code) === null || i === void 0 ? void 0 : i.split("auth/")) === null || n === void 0 ? void 0 : n[1],
        c = _l2 ? xe(_l2) : null;

    return c ? {
      type: t.type,
      eventId: t.eventId,
      tenantId: t.tenantId,
      error: c,
      urlResponse: null,
      sessionId: null,
      postBody: null
    } : {
      type: t.type,
      eventId: t.eventId,
      tenantId: t.tenantId,
      sessionId: t.sessionId,
      urlResponse: r,
      postBody: null
    };
  }

  return null;
}

function mw() {
  var t = [],
      e = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  for (var i = 0; i < uw; i++) {
    var n = Math.floor(Math.random() * e.length);
    t.push(e.charAt(n));
  }

  return t.join("");
}

function oa() {
  return ze(Nr);
}

function la(t) {
  return Jt("authEvent", t.config.apiKey, t.name);
}

function gw(t) {
  try {
    return JSON.parse(t);
  } catch (e) {
    return null;
  }
}

function yw(t) {
  var e = Gn(t),
      i = e.link ? decodeURIComponent(e.link) : void 0,
      n = Gn(i).link,
      r = e.deep_link_id ? decodeURIComponent(e.deep_link_id) : void 0;
  return Gn(r).link || r || n || i || t;
}

function Gn(t) {
  if (!(t != null && t.includes("?"))) return {};

  var _t$split3 = t.split("?"),
      _t$split4 = _toArray(_t$split3),
      e = _t$split4[0],
      i = _t$split4.slice(1);

  return fi(i.join("?"));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var vw = 500;

var ww =
/*#__PURE__*/
function () {
  function ww() {
    _classCallCheck(this, ww);

    this._redirectPersistence = Vt, this._shouldInitProactively = !0, this.eventManagers =
    /* @__PURE__ */
    new Map(), this.originValidationPromises = {}, this._completeRedirectFn = Br, this._overrideRedirectResult = io;
  }

  _createClass(ww, [{
    key: "_initialize",
    value: function _initialize(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee199() {
        var i, n;
        return _regeneratorRuntime.wrap(function _callee199$(_context199) {
          while (1) {
            switch (_context199.prev = _context199.next) {
              case 0:
                i = e._key();
                n = this.eventManagers.get(i);
                return _context199.abrupt("return", (n || (n = new dw(e), this.eventManagers.set(i, n), this.attachCallbackListeners(e, n)), n));

              case 3:
              case "end":
                return _context199.stop();
            }
          }
        }, _callee199, this);
      }));
    }
  }, {
    key: "_openPopup",
    value: function _openPopup(e) {
      Ae(e, "operation-not-supported-in-this-environment");
    }
  }, {
    key: "_openRedirect",
    value: function _openRedirect(e, i, n, r) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee200() {
        var a, o, l, c;
        return _regeneratorRuntime.wrap(function _callee200$(_context200) {
          while (1) {
            switch (_context200.prev = _context200.next) {
              case 0:
                ow(e);
                _context200.next = 3;
                return this._initialize(e);

              case 3:
                a = _context200.sent;
                _context200.next = 6;
                return a.initialized();

              case 6:
                a.resetRedirect();
                hv();
                _context200.next = 10;
                return this._originValidation(e);

              case 10:
                o = hw(e, n, r);
                _context200.next = 13;
                return pw(e, o);

              case 13:
                _context200.next = 15;
                return nw(e, o, i);

              case 15:
                l = _context200.sent;
                _context200.next = 18;
                return sw(l);

              case 18:
                c = _context200.sent;
                return _context200.abrupt("return", aw(e, a, c));

              case 20:
              case "end":
                return _context200.stop();
            }
          }
        }, _callee200, this);
      }));
    }
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(e, i) {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(e) {
      var i = e._key();

      return this.originValidationPromises[i] || (this.originValidationPromises[i] = rw(e)), this.originValidationPromises[i];
    }
  }, {
    key: "attachCallbackListeners",
    value: function attachCallbackListeners(e, i) {
      var _this74 = this;

      var _ii5 = ii(),
          n = _ii5.universalLinks,
          r = _ii5.handleOpenURL,
          a = _ii5.BuildInfo,
          o = setTimeout(function () {
        return u(_this74, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee201() {
          return _regeneratorRuntime.wrap(function _callee201$(_context201) {
            while (1) {
              switch (_context201.prev = _context201.next) {
                case 0:
                  _context201.next = 2;
                  return pl(e);

                case 2:
                  i.onEvent(fl());

                case 3:
                case "end":
                  return _context201.stop();
              }
            }
          }, _callee201);
        }));
      }, vw),
          l = function l(h) {
        return u(_this74, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee202() {
          var p, g;
          return _regeneratorRuntime.wrap(function _callee202$(_context202) {
            while (1) {
              switch (_context202.prev = _context202.next) {
                case 0:
                  clearTimeout(o);
                  _context202.next = 3;
                  return pl(e);

                case 3:
                  p = _context202.sent;
                  g = null;
                  p && (h == null ? void 0 : h.url) && (g = fw(p, h.url)), i.onEvent(g || fl());

                case 6:
                case "end":
                  return _context202.stop();
              }
            }
          }, _callee202);
        }));
      };

      typeof n != "undefined" && typeof n.subscribe == "function" && n.subscribe(null, l);
      var c = r,
          d = "".concat(a.packageName.toLowerCase(), "://");

      ii().handleOpenURL = function (h) {
        return u(_this74, null,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee203() {
          return _regeneratorRuntime.wrap(function _callee203$(_context203) {
            while (1) {
              switch (_context203.prev = _context203.next) {
                case 0:
                  if (h.toLowerCase().startsWith(d) && l({
                    url: h
                  }), typeof c == "function") try {
                    c(h);
                  } catch (p) {
                    console.error(p);
                  }

                case 1:
                case "end":
                  return _context203.stop();
              }
            }
          }, _callee203);
        }));
      };
    }
  }]);

  return ww;
}();

var bw = ww;

function fl() {
  return {
    type: "unknown",
    eventId: null,
    sessionId: null,
    urlResponse: null,
    postBody: null,
    tenantId: null,
    error: xe("no-auth-event")
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Iw(t, e) {
  fe(t)._logFramework(e);
}

var _w = "@firebase/auth-compat",
    Ew = "0.4.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Cw = 1e3;

function rn() {
  var t;
  return ((t = self == null ? void 0 : self.location) === null || t === void 0 ? void 0 : t.protocol) || null;
}

function Sw() {
  return rn() === "http:" || rn() === "https:";
}

function sd() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return !!((rn() === "file:" || rn() === "ionic:" || rn() === "capacitor:") && t.toLowerCase().match(/iphone|ipad|ipod|android/));
}

function Tw() {
  return Da() || Xc();
}

function Rw() {
  return eu() && (document == null ? void 0 : document.documentMode) === 11;
}

function Pw() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return /Edge\/\d+/.test(t);
}

function Ow() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : we();
  return Rw() || Pw(t);
}

function ad() {
  try {
    var _t2 = self.localStorage,
        e = bn();
    if (_t2) return _t2.setItem(e, "1"), _t2.removeItem(e), Ow() ? nr() : !0;
  } catch (t) {
    return ro() && nr();
  }

  return !1;
}

function ro() {
  return typeof global != "undefined" && "WorkerGlobalScope" in global && "importScripts" in global;
}

function Ds() {
  return (Sw() || Zc() || sd()) && !Tw() && ad() && !ro();
}

function od() {
  return sd() && typeof document != "undefined";
}

function Aw() {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee204() {
    return _regeneratorRuntime.wrap(function _callee204$(_context204) {
      while (1) {
        switch (_context204.prev = _context204.next) {
          case 0:
            return _context204.abrupt("return", od() ? new Promise(function (t) {
              var e = setTimeout(function () {
                t(!1);
              }, Cw);
              document.addEventListener("deviceready", function () {
                clearTimeout(e), t(!0);
              });
            }) : !1);

          case 1:
          case "end":
            return _context204.stop();
        }
      }
    }, _callee204);
  }));
}

function Mw() {
  return typeof window != "undefined" ? window : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Ge = {
  LOCAL: "local",
  NONE: "none",
  SESSION: "session"
},
    Hi = B,
    ld = "persistence";

function Fw(t, e) {
  if (Hi(Object.values(Ge).includes(e), t, "invalid-persistence-type"), Da()) {
    Hi(e !== Ge.SESSION, t, "unsupported-persistence-type");
    return;
  }

  if (Xc()) {
    Hi(e === Ge.NONE, t, "unsupported-persistence-type");
    return;
  }

  if (ro()) {
    Hi(e === Ge.NONE || e === Ge.LOCAL && nr(), t, "unsupported-persistence-type");
    return;
  }

  Hi(e === Ge.NONE || ad(), t, "unsupported-persistence-type");
}

function ca(t) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee205() {
    var e, i;
    return _regeneratorRuntime.wrap(function _callee205$(_context205) {
      while (1) {
        switch (_context205.prev = _context205.next) {
          case 0:
            _context205.next = 2;
            return t._initializationPromise;

          case 2:
            e = cd(), i = Jt(ld, t.config.apiKey, t.name);
            e && e.setItem(i, t._getPersistence());

          case 4:
          case "end":
            return _context205.stop();
        }
      }
    }, _callee205);
  }));
}

function kw(t, e) {
  var i = cd();
  if (!i) return [];
  var n = Jt(ld, t, e);

  switch (i.getItem(n)) {
    case Ge.NONE:
      return [Ei];

    case Ge.LOCAL:
      return [Si, Vt];

    case Ge.SESSION:
      return [Vt];

    default:
      return [];
  }
}

function cd() {
  var t;

  try {
    return ((t = Mw()) === null || t === void 0 ? void 0 : t.sessionStorage) || null;
  } catch (e) {
    return null;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var xw = B;

var Ft =
/*#__PURE__*/
function () {
  function Ft() {
    _classCallCheck(this, Ft);

    this.browserResolver = ze(nd), this.cordovaResolver = ze(bw), this.underlyingResolver = null, this._redirectPersistence = Vt, this._completeRedirectFn = Br, this._overrideRedirectResult = io;
  }

  _createClass(Ft, [{
    key: "_initialize",
    value: function _initialize(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee206() {
        return _regeneratorRuntime.wrap(function _callee206$(_context206) {
          while (1) {
            switch (_context206.prev = _context206.next) {
              case 0:
                _context206.next = 2;
                return this.selectUnderlyingResolver();

              case 2:
                return _context206.abrupt("return", this.assertedUnderlyingResolver._initialize(e));

              case 3:
              case "end":
                return _context206.stop();
            }
          }
        }, _callee206, this);
      }));
    }
  }, {
    key: "_openPopup",
    value: function _openPopup(e, i, n, r) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee207() {
        return _regeneratorRuntime.wrap(function _callee207$(_context207) {
          while (1) {
            switch (_context207.prev = _context207.next) {
              case 0:
                _context207.next = 2;
                return this.selectUnderlyingResolver();

              case 2:
                return _context207.abrupt("return", this.assertedUnderlyingResolver._openPopup(e, i, n, r));

              case 3:
              case "end":
                return _context207.stop();
            }
          }
        }, _callee207, this);
      }));
    }
  }, {
    key: "_openRedirect",
    value: function _openRedirect(e, i, n, r) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee208() {
        return _regeneratorRuntime.wrap(function _callee208$(_context208) {
          while (1) {
            switch (_context208.prev = _context208.next) {
              case 0:
                _context208.next = 2;
                return this.selectUnderlyingResolver();

              case 2:
                return _context208.abrupt("return", this.assertedUnderlyingResolver._openRedirect(e, i, n, r));

              case 3:
              case "end":
                return _context208.stop();
            }
          }
        }, _callee208, this);
      }));
    }
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(e, i) {
      this.assertedUnderlyingResolver._isIframeWebStorageSupported(e, i);
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(e) {
      return this.assertedUnderlyingResolver._originValidation(e);
    }
  }, {
    key: "selectUnderlyingResolver",
    value: function selectUnderlyingResolver() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee209() {
        var e;
        return _regeneratorRuntime.wrap(function _callee209$(_context209) {
          while (1) {
            switch (_context209.prev = _context209.next) {
              case 0:
                if (!this.underlyingResolver) {
                  _context209.next = 2;
                  break;
                }

                return _context209.abrupt("return");

              case 2:
                _context209.next = 4;
                return Aw();

              case 4:
                e = _context209.sent;
                this.underlyingResolver = e ? this.cordovaResolver : this.browserResolver;

              case 6:
              case "end":
                return _context209.stop();
            }
          }
        }, _callee209, this);
      }));
    }
  }, {
    key: "_shouldInitProactively",
    get: function get() {
      return od() || this.browserResolver._shouldInitProactively;
    }
  }, {
    key: "assertedUnderlyingResolver",
    get: function get() {
      return xw(this.underlyingResolver, "internal-error"), this.underlyingResolver;
    }
  }]);

  return Ft;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function ud(t) {
  return t.unwrap();
}

function Dw(t) {
  return t.wrapped();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function Nw(t) {
  return dd(t);
}

function Lw(t, e) {
  var i;
  var n = (i = e.customData) === null || i === void 0 ? void 0 : i._tokenResponse;

  if ((e == null ? void 0 : e.code) === "auth/multi-factor-auth-required") {
    var _r11 = e;
    _r11.resolver = new $w(t, wy(t, e));
  } else if (n) {
    var _r12 = dd(e),
        a = e;

    _r12 && (a.credential = _r12, a.tenantId = n.tenantId || void 0, a.email = n.email || void 0, a.phoneNumber = n.phoneNumber || void 0);
  }
}

function dd(t) {
  var _ref48 = t instanceof Ve ? t.customData : t,
      e = _ref48._tokenResponse;

  if (!e) return null;
  if (!(t instanceof Ve) && "temporaryProof" in e && "phoneNumber" in e) return et.credentialFromResult(t);
  var i = e.providerId;
  if (!i || i === Bi.PASSWORD) return null;
  var n;

  switch (i) {
    case Bi.GOOGLE:
      n = lt;
      break;

    case Bi.FACEBOOK:
      n = ot;
      break;

    case Bi.GITHUB:
      n = ct;
      break;

    case Bi.TWITTER:
      n = ut;
      break;

    default:
      var _r13 = e.oauthIdToken,
          a = e.oauthAccessToken,
          o = e.oauthTokenSecret,
          _l3 = e.pendingToken,
          c = e.nonce;
      return !a && !o && !_r13 && !_l3 ? null : _l3 ? i.startsWith("saml.") ? Ci._create(i, _l3) : pt._fromParams({
        providerId: i,
        signInMethod: i,
        pendingToken: _l3,
        idToken: _r13,
        accessToken: a
      }) : new yi(i).credential({
        idToken: _r13,
        accessToken: a,
        rawNonce: c
      });
  }

  return t instanceof Ve ? n.credentialFromError(t) : n.credentialFromResult(t);
}

function $e(t, e) {
  return e.catch(function (i) {
    throw i instanceof Ve && Lw(t, i), i;
  }).then(function (i) {
    var n = i.operationType,
        r = i.user;
    return {
      operationType: n,
      credential: Nw(i),
      additionalUserInfo: gy(i),
      user: vt.getOrCreate(r)
    };
  });
}

function ua(t, e) {
  return u(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee210() {
    var i;
    return _regeneratorRuntime.wrap(function _callee210$(_context210) {
      while (1) {
        switch (_context210.prev = _context210.next) {
          case 0:
            _context210.next = 2;
            return e;

          case 2:
            i = _context210.sent;
            return _context210.abrupt("return", {
              verificationId: i.verificationId,
              confirm: function confirm(n) {
                return $e(t, i.confirm(n));
              }
            });

          case 4:
          case "end":
            return _context210.stop();
        }
      }
    }, _callee210);
  }));
}

var $w =
/*#__PURE__*/
function () {
  function $w(e, i) {
    _classCallCheck(this, $w);

    this.resolver = i, this.auth = Dw(e);
  }

  _createClass($w, [{
    key: "resolveSignIn",
    value: function resolveSignIn(e) {
      return $e(ud(this.auth), this.resolver.resolveSignIn(e));
    }
  }, {
    key: "session",
    get: function get() {
      return this.resolver.session;
    }
  }, {
    key: "hints",
    get: function get() {
      return this.resolver.hints;
    }
  }]);

  return $w;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var vt =
/*#__PURE__*/
function () {
  function vt(e) {
    _classCallCheck(this, vt);

    this._delegate = e, this.multiFactor = Ey(e);
  }

  _createClass(vt, [{
    key: "delete",
    value: function _delete() {
      return this._delegate.delete();
    }
  }, {
    key: "reload",
    value: function reload() {
      return this._delegate.reload();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this._delegate.toJSON();
    }
  }, {
    key: "getIdTokenResult",
    value: function getIdTokenResult(e) {
      return this._delegate.getIdTokenResult(e);
    }
  }, {
    key: "getIdToken",
    value: function getIdToken(e) {
      return this._delegate.getIdToken(e);
    }
  }, {
    key: "linkAndRetrieveDataWithCredential",
    value: function linkAndRetrieveDataWithCredential(e) {
      return this.linkWithCredential(e);
    }
  }, {
    key: "linkWithCredential",
    value: function linkWithCredential(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee211() {
        return _regeneratorRuntime.wrap(function _callee211$(_context211) {
          while (1) {
            switch (_context211.prev = _context211.next) {
              case 0:
                return _context211.abrupt("return", $e(this.auth, Uu(this._delegate, e)));

              case 1:
              case "end":
                return _context211.stop();
            }
          }
        }, _callee211, this);
      }));
    }
  }, {
    key: "linkWithPhoneNumber",
    value: function linkWithPhoneNumber(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee212() {
        return _regeneratorRuntime.wrap(function _callee212$(_context212) {
          while (1) {
            switch (_context212.prev = _context212.next) {
              case 0:
                return _context212.abrupt("return", ua(this.auth, ev(this._delegate, e, i)));

              case 1:
              case "end":
                return _context212.stop();
            }
          }
        }, _callee212, this);
      }));
    }
  }, {
    key: "linkWithPopup",
    value: function linkWithPopup(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee213() {
        return _regeneratorRuntime.wrap(function _callee213$(_context213) {
          while (1) {
            switch (_context213.prev = _context213.next) {
              case 0:
                return _context213.abrupt("return", $e(this.auth, cv(this._delegate, e, Ft)));

              case 1:
              case "end":
                return _context213.stop();
            }
          }
        }, _callee213, this);
      }));
    }
  }, {
    key: "linkWithRedirect",
    value: function linkWithRedirect(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee214() {
        return _regeneratorRuntime.wrap(function _callee214$(_context214) {
          while (1) {
            switch (_context214.prev = _context214.next) {
              case 0:
                _context214.next = 2;
                return ca(fe(this.auth));

              case 2:
                return _context214.abrupt("return", yv(this._delegate, e, Ft));

              case 3:
              case "end":
                return _context214.stop();
            }
          }
        }, _callee214, this);
      }));
    }
  }, {
    key: "reauthenticateAndRetrieveDataWithCredential",
    value: function reauthenticateAndRetrieveDataWithCredential(e) {
      return this.reauthenticateWithCredential(e);
    }
  }, {
    key: "reauthenticateWithCredential",
    value: function reauthenticateWithCredential(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee215() {
        return _regeneratorRuntime.wrap(function _callee215$(_context215) {
          while (1) {
            switch (_context215.prev = _context215.next) {
              case 0:
                return _context215.abrupt("return", $e(this.auth, Bu(this._delegate, e)));

              case 1:
              case "end":
                return _context215.stop();
            }
          }
        }, _callee215, this);
      }));
    }
  }, {
    key: "reauthenticateWithPhoneNumber",
    value: function reauthenticateWithPhoneNumber(e, i) {
      return ua(this.auth, tv(this._delegate, e, i));
    }
  }, {
    key: "reauthenticateWithPopup",
    value: function reauthenticateWithPopup(e) {
      return $e(this.auth, lv(this._delegate, e, Ft));
    }
  }, {
    key: "reauthenticateWithRedirect",
    value: function reauthenticateWithRedirect(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee216() {
        return _regeneratorRuntime.wrap(function _callee216$(_context216) {
          while (1) {
            switch (_context216.prev = _context216.next) {
              case 0:
                _context216.next = 2;
                return ca(fe(this.auth));

              case 2:
                return _context216.abrupt("return", mv(this._delegate, e, Ft));

              case 3:
              case "end":
                return _context216.stop();
            }
          }
        }, _callee216, this);
      }));
    }
  }, {
    key: "sendEmailVerification",
    value: function sendEmailVerification(e) {
      return sy(this._delegate, e);
    }
  }, {
    key: "unlink",
    value: function unlink(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee217() {
        return _regeneratorRuntime.wrap(function _callee217$(_context217) {
          while (1) {
            switch (_context217.prev = _context217.next) {
              case 0:
                _context217.next = 2;
                return Gg(this._delegate, e);

              case 2:
                return _context217.abrupt("return", this);

              case 3:
              case "end":
                return _context217.stop();
            }
          }
        }, _callee217, this);
      }));
    }
  }, {
    key: "updateEmail",
    value: function updateEmail(e) {
      return cy(this._delegate, e);
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(e) {
      return uy(this._delegate, e);
    }
  }, {
    key: "updatePhoneNumber",
    value: function updatePhoneNumber(e) {
      return iv(this._delegate, e);
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(e) {
      return ly(this._delegate, e);
    }
  }, {
    key: "verifyBeforeUpdateEmail",
    value: function verifyBeforeUpdateEmail(e, i) {
      return ay(this._delegate, e, i);
    }
  }, {
    key: "emailVerified",
    get: function get() {
      return this._delegate.emailVerified;
    }
  }, {
    key: "isAnonymous",
    get: function get() {
      return this._delegate.isAnonymous;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this._delegate.metadata;
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return this._delegate.phoneNumber;
    }
  }, {
    key: "providerData",
    get: function get() {
      return this._delegate.providerData;
    }
  }, {
    key: "refreshToken",
    get: function get() {
      return this._delegate.refreshToken;
    }
  }, {
    key: "tenantId",
    get: function get() {
      return this._delegate.tenantId;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this._delegate.displayName;
    }
  }, {
    key: "email",
    get: function get() {
      return this._delegate.email;
    }
  }, {
    key: "photoURL",
    get: function get() {
      return this._delegate.photoURL;
    }
  }, {
    key: "providerId",
    get: function get() {
      return this._delegate.providerId;
    }
  }, {
    key: "uid",
    get: function get() {
      return this._delegate.uid;
    }
  }, {
    key: "auth",
    get: function get() {
      return this._delegate.auth;
    }
  }], [{
    key: "getOrCreate",
    value: function getOrCreate(e) {
      return vt.USER_MAP.has(e) || vt.USER_MAP.set(e, new vt(e)), vt.USER_MAP.get(e);
    }
  }]);

  return vt;
}();

vt.USER_MAP =
/* @__PURE__ */
new WeakMap();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Vi = B;

var da =
/*#__PURE__*/
function () {
  function da(e, i) {
    _classCallCheck(this, da);

    if (this.app = e, i.isInitialized()) {
      this._delegate = i.getImmediate(), this.linkUnderlyingAuth();
      return;
    }

    var n = e.options.apiKey;
    Vi(n, "invalid-api-key", {
      appName: e.name
    }), Vi(n, "invalid-api-key", {
      appName: e.name
    });
    var r = typeof window != "undefined" ? Ft : void 0;
    this._delegate = i.initialize({
      options: {
        persistence: Uw(n, e.name),
        popupRedirectResolver: r
      }
    }), this._delegate._updateErrorMap(Ym), this.linkUnderlyingAuth();
  }

  _createClass(da, [{
    key: "useDeviceLanguage",
    value: function useDeviceLanguage() {
      this._delegate.useDeviceLanguage();
    }
  }, {
    key: "signOut",
    value: function signOut() {
      return this._delegate.signOut();
    }
  }, {
    key: "useEmulator",
    value: function useEmulator(e, i) {
      za(this._delegate, e, i);
    }
  }, {
    key: "applyActionCode",
    value: function applyActionCode(e) {
      return Kg(this._delegate, e);
    }
  }, {
    key: "checkActionCode",
    value: function checkActionCode(e) {
      return Hu(this._delegate, e);
    }
  }, {
    key: "confirmPasswordReset",
    value: function confirmPasswordReset(e, i) {
      return Yg(this._delegate, e, i);
    }
  }, {
    key: "createUserWithEmailAndPassword",
    value: function createUserWithEmailAndPassword(e, i) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee218() {
        return _regeneratorRuntime.wrap(function _callee218$(_context218) {
          while (1) {
            switch (_context218.prev = _context218.next) {
              case 0:
                return _context218.abrupt("return", $e(this._delegate, Xg(this._delegate, e, i)));

              case 1:
              case "end":
                return _context218.stop();
            }
          }
        }, _callee218, this);
      }));
    }
  }, {
    key: "fetchProvidersForEmail",
    value: function fetchProvidersForEmail(e) {
      return this.fetchSignInMethodsForEmail(e);
    }
  }, {
    key: "fetchSignInMethodsForEmail",
    value: function fetchSignInMethodsForEmail(e) {
      return ry(this._delegate, e);
    }
  }, {
    key: "isSignInWithEmailLink",
    value: function isSignInWithEmailLink(e) {
      return ty(this._delegate, e);
    }
  }, {
    key: "getRedirectResult",
    value: function getRedirectResult() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee219() {
        var e;
        return _regeneratorRuntime.wrap(function _callee219$(_context219) {
          while (1) {
            switch (_context219.prev = _context219.next) {
              case 0:
                Vi(Ds(), this._delegate, "operation-not-supported-in-this-environment");
                _context219.next = 3;
                return wv(this._delegate, Ft);

              case 3:
                e = _context219.sent;
                return _context219.abrupt("return", e ? $e(this._delegate, Promise.resolve(e)) : {
                  credential: null,
                  user: null
                });

              case 5:
              case "end":
                return _context219.stop();
            }
          }
        }, _callee219, this);
      }));
    }
  }, {
    key: "addFrameworkForLogging",
    value: function addFrameworkForLogging(e) {
      Iw(this._delegate, e);
    }
  }, {
    key: "onAuthStateChanged",
    value: function onAuthStateChanged(e, i, n) {
      var _ml = ml(e, i, n),
          r = _ml.next,
          a = _ml.error,
          o = _ml.complete;

      return this._delegate.onAuthStateChanged(r, a, o);
    }
  }, {
    key: "onIdTokenChanged",
    value: function onIdTokenChanged(e, i, n) {
      var _ml2 = ml(e, i, n),
          r = _ml2.next,
          a = _ml2.error,
          o = _ml2.complete;

      return this._delegate.onIdTokenChanged(r, a, o);
    }
  }, {
    key: "sendSignInLinkToEmail",
    value: function sendSignInLinkToEmail(e, i) {
      return ey(this._delegate, e, i);
    }
  }, {
    key: "sendPasswordResetEmail",
    value: function sendPasswordResetEmail(e, i) {
      return Qg(this._delegate, e, i || void 0);
    }
  }, {
    key: "setPersistence",
    value: function setPersistence(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee220() {
        var i;
        return _regeneratorRuntime.wrap(function _callee220$(_context220) {
          while (1) {
            switch (_context220.prev = _context220.next) {
              case 0:
                Fw(this._delegate, e);
                _context220.t0 = e;
                _context220.next = _context220.t0 === Ge.SESSION ? 4 : _context220.t0 === Ge.LOCAL ? 6 : _context220.t0 === Ge.NONE ? 15 : 17;
                break;

              case 4:
                i = Vt;
                return _context220.abrupt("break", 18);

              case 6:
                _context220.next = 8;
                return ze(Si)._isAvailable();

              case 8:
                if (!_context220.sent) {
                  _context220.next = 12;
                  break;
                }

                _context220.t1 = Si;
                _context220.next = 13;
                break;

              case 12:
                _context220.t1 = Nr;

              case 13:
                i = _context220.t1;
                return _context220.abrupt("break", 18);

              case 15:
                i = Ei;
                return _context220.abrupt("break", 18);

              case 17:
                return _context220.abrupt("return", Ae("argument-error", {
                  appName: this._delegate.name
                }));

              case 18:
                return _context220.abrupt("return", this._delegate.setPersistence(i));

              case 19:
              case "end":
                return _context220.stop();
            }
          }
        }, _callee220, this);
      }));
    }
  }, {
    key: "signInAndRetrieveDataWithCredential",
    value: function signInAndRetrieveDataWithCredential(e) {
      return this.signInWithCredential(e);
    }
  }, {
    key: "signInAnonymously",
    value: function signInAnonymously() {
      return $e(this._delegate, Wg(this._delegate));
    }
  }, {
    key: "signInWithCredential",
    value: function signInWithCredential(e) {
      return $e(this._delegate, Dr(this._delegate, e));
    }
  }, {
    key: "signInWithCustomToken",
    value: function signInWithCustomToken(e) {
      return $e(this._delegate, qg(this._delegate, e));
    }
  }, {
    key: "signInWithEmailAndPassword",
    value: function signInWithEmailAndPassword(e, i) {
      return $e(this._delegate, Zg(this._delegate, e, i));
    }
  }, {
    key: "signInWithEmailLink",
    value: function signInWithEmailLink(e, i) {
      return $e(this._delegate, iy(this._delegate, e, i));
    }
  }, {
    key: "signInWithPhoneNumber",
    value: function signInWithPhoneNumber(e, i) {
      return ua(this._delegate, Zy(this._delegate, e, i));
    }
  }, {
    key: "signInWithPopup",
    value: function signInWithPopup(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee221() {
        return _regeneratorRuntime.wrap(function _callee221$(_context221) {
          while (1) {
            switch (_context221.prev = _context221.next) {
              case 0:
                return _context221.abrupt("return", (Vi(Ds(), this._delegate, "operation-not-supported-in-this-environment"), $e(this._delegate, ov(this._delegate, e, Ft))));

              case 1:
              case "end":
                return _context221.stop();
            }
          }
        }, _callee221, this);
      }));
    }
  }, {
    key: "signInWithRedirect",
    value: function signInWithRedirect(e) {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee222() {
        return _regeneratorRuntime.wrap(function _callee222$(_context222) {
          while (1) {
            switch (_context222.prev = _context222.next) {
              case 0:
                Vi(Ds(), this._delegate, "operation-not-supported-in-this-environment");
                _context222.next = 3;
                return ca(this._delegate);

              case 3:
                return _context222.abrupt("return", pv(this._delegate, e, Ft));

              case 4:
              case "end":
                return _context222.stop();
            }
          }
        }, _callee222, this);
      }));
    }
  }, {
    key: "updateCurrentUser",
    value: function updateCurrentUser(e) {
      return this._delegate.updateCurrentUser(e);
    }
  }, {
    key: "verifyPasswordResetCode",
    value: function verifyPasswordResetCode(e) {
      return Jg(this._delegate, e);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._delegate;
    }
  }, {
    key: "_delete",
    value: function _delete() {
      return this._delegate._delete();
    }
  }, {
    key: "linkUnderlyingAuth",
    value: function linkUnderlyingAuth() {
      var _this75 = this;

      this._delegate.wrapped = function () {
        return _this75;
      };
    }
  }, {
    key: "emulatorConfig",
    get: function get() {
      return this._delegate.emulatorConfig;
    }
  }, {
    key: "currentUser",
    get: function get() {
      return this._delegate.currentUser ? vt.getOrCreate(this._delegate.currentUser) : null;
    }
  }, {
    key: "languageCode",
    get: function get() {
      return this._delegate.languageCode;
    },
    set: function set(e) {
      this._delegate.languageCode = e;
    }
  }, {
    key: "settings",
    get: function get() {
      return this._delegate.settings;
    }
  }, {
    key: "tenantId",
    get: function get() {
      return this._delegate.tenantId;
    },
    set: function set(e) {
      this._delegate.tenantId = e;
    }
  }]);

  return da;
}();

da.Persistence = Ge;

function ml(t, e, i) {
  var _t3;

  var n = t;
  typeof t != "function" && (_t3 = t, n = _t3.next, e = _t3.error, i = _t3.complete, _t3);
  var r = n;
  return {
    next: function next(o) {
      return r(o && vt.getOrCreate(o));
    },
    error: e,
    complete: i
  };
}

function Uw(t, e) {
  var i = kw(t, e);

  if (typeof self != "undefined" && !i.includes(Si) && i.push(Si), typeof window != "undefined") {
    for (var _i18 = 0, _arr = [Nr, Vt]; _i18 < _arr.length; _i18++) {
      var n = _arr[_i18];
      i.includes(n) || i.push(n);
    }
  }

  return i.includes(Ei) || i.push(Ei), i;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var so =
/*#__PURE__*/
function () {
  function so() {
    _classCallCheck(this, so);

    this.providerId = "phone", this._delegate = new et(ud(gt.auth()));
  }

  _createClass(so, [{
    key: "verifyPhoneNumber",
    value: function verifyPhoneNumber(e, i) {
      return this._delegate.verifyPhoneNumber(e, i);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._delegate;
    }
  }], [{
    key: "credential",
    value: function credential(e, i) {
      return et.credential(e, i);
    }
  }]);

  return so;
}();

so.PHONE_SIGN_IN_METHOD = et.PHONE_SIGN_IN_METHOD;
so.PROVIDER_ID = et.PROVIDER_ID;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Bw = B;

var Hw =
/*#__PURE__*/
function () {
  function Hw(e, i) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : gt.app();

    _classCallCheck(this, Hw);

    var r;
    Bw((r = n.options) === null || r === void 0 ? void 0 : r.apiKey, "invalid-api-key", {
      appName: n.name
    }), this._delegate = new Jy(e, i, n.auth()), this.type = this._delegate.type;
  }

  _createClass(Hw, [{
    key: "clear",
    value: function clear() {
      this._delegate.clear();
    }
  }, {
    key: "render",
    value: function render() {
      return this._delegate.render();
    }
  }, {
    key: "verify",
    value: function verify() {
      return this._delegate.verify();
    }
  }]);

  return Hw;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Vw = "auth-compat";

function jw(t) {
  t.INTERNAL.registerComponent(new $t(Vw, function (e) {
    var i = e.getProvider("app-compat").getImmediate(),
        n = e.getProvider("auth");
    return new da(i, n);
  }, "PUBLIC").setServiceProps({
    ActionCodeInfo: {
      Operation: {
        EMAIL_SIGNIN: ui.EMAIL_SIGNIN,
        PASSWORD_RESET: ui.PASSWORD_RESET,
        RECOVER_EMAIL: ui.RECOVER_EMAIL,
        REVERT_SECOND_FACTOR_ADDITION: ui.REVERT_SECOND_FACTOR_ADDITION,
        VERIFY_AND_CHANGE_EMAIL: ui.VERIFY_AND_CHANGE_EMAIL,
        VERIFY_EMAIL: ui.VERIFY_EMAIL
      }
    },
    EmailAuthProvider: jt,
    FacebookAuthProvider: ot,
    GithubAuthProvider: ct,
    GoogleAuthProvider: lt,
    OAuthProvider: yi,
    SAMLAuthProvider: or,
    PhoneAuthProvider: so,
    PhoneMultiFactorGenerator: rd,
    RecaptchaVerifier: Hw,
    TwitterAuthProvider: ut,
    Auth: da,
    AuthCredential: ki,
    Error: Ve
  }).setInstantiationMode("LAZY").setMultipleInstances(!1)), t.registerVersion(_w, Ew);
}

jw(gt);
var gl = !1;

var hd = function hd(t) {
  if (gl) return gt.auth();

  if (t && t === "dev") {
    var e = "api_key";
    gt.initializeApp({
      apiKey: e
    });
    var i = tw();
    za(i, "http://localhost:39199");
  } else {
    var _i19 = {
      apiKey: t && t === "staging" ? "AIzaSyBKhAYwkvkmjm16FxCMvCUQjSRpKC0DbM8" : "AIzaSyDPD_SETLswR_U3dKawYkAyRhbzVXziD_4",
      authDomain: "fans-united-clients.firebaseapp.com",
      projectId: "fans-united-clients",
      messagingSenderId: "78627953958",
      appId: "1:78627953958:web:9e4c6caf6bd197b185f5e7",
      measurementId: "G-DPV1TYL0JW"
    };
    gt.initializeApp(_i19);
  }

  return gl = !0, gt.auth();
};

var Ki = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {},
    Hr = {
  exports: {}
},
    _n = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var yl = Object.getOwnPropertySymbols,
    Ww = Object.prototype.hasOwnProperty,
    Gw = Object.prototype.propertyIsEnumerable;

function zw(t) {
  if (t == null) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}

function qw() {
  try {
    if (!Object.assign) return !1;
    var t = new String("abc");
    if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5") return !1;

    for (var e = {}, i = 0; i < 10; i++) {
      e["_" + String.fromCharCode(i)] = i;
    }

    var n = Object.getOwnPropertyNames(e).map(function (a) {
      return e[a];
    });
    if (n.join("") !== "0123456789") return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (a) {
      r[a] = a;
    }), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
  } catch (a) {
    return !1;
  }
}

qw();
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var Qw = Zt,
    pd = 60103;
_n.Fragment = 60107;

if (typeof Symbol == "function" && Symbol.for) {
  var vl = Symbol.for;
  pd = vl("react.element"), _n.Fragment = vl("react.fragment");
}

var Yw = Qw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    Kw = Object.prototype.hasOwnProperty,
    Jw = {
  key: !0,
  ref: !0,
  __self: !0,
  __source: !0
};

function fd(t, e, i) {
  var n,
      r = {},
      a = null,
      o = null;
  i !== void 0 && (a = "" + i), e.key !== void 0 && (a = "" + e.key), e.ref !== void 0 && (o = e.ref);

  for (n in e) {
    Kw.call(e, n) && !Jw.hasOwnProperty(n) && (r[n] = e[n]);
  }

  if (t && t.defaultProps) for (n in e = t.defaultProps, e) {
    r[n] === void 0 && (r[n] = e[n]);
  }
  return {
    $$typeof: pd,
    type: t,
    key: a,
    ref: o,
    props: r,
    _owner: Yw.current
  };
}

_n.jsx = fd;
_n.jsxs = fd;

(function (t) {
  t.exports = _n;
})(Hr);

var Ne = Hr.exports.Fragment,
    _ = Hr.exports.jsx,
    j = Hr.exports.jsxs,
    md = Rr(null),
    Xw = function Xw(_ref49) {
  var t = _ref49.children,
      e = _ref49.fansUnitedEnvironment;

  var _K = K(null),
      _K2 = _slicedToArray(_K, 2),
      i = _K2[0],
      n = _K2[1],
      _K3 = K(!0),
      _K4 = _slicedToArray(_K3, 2),
      r = _K4[0],
      a = _K4[1];

  return He(function () {
    return hd(e).onAuthStateChanged(function (l) {
      cf(function () {
        a(!1), n(l);
      });
    });
  }, []),
  /* @__PURE__ */
  _(md.Provider, {
    value: i,
    children: !r && t
  });
};

function gd(t) {
  var e,
      i,
      n = "";
  if (typeof t == "string" || typeof t == "number") n += t;else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) {
    t[e] && (i = gd(t[e])) && (n && (n += " "), n += i);
  } else for (e in t) {
    t[e] && (n && (n += " "), n += e);
  }
  return n;
}

function kt() {
  for (var t, e, i = 0, n = ""; i < arguments.length;) {
    (t = arguments[i++]) && (e = gd(t)) && (n && (n += " "), n += e);
  }

  return n;
}

var sn = function sn(t) {
  return typeof t == "number" && !isNaN(t);
},
    ni = function ni(t) {
  return typeof t == "string";
},
    Be = function Be(t) {
  return typeof t == "function";
},
    zn = function zn(t) {
  return ni(t) || Be(t) ? t : null;
},
    Ns = function Ns(t) {
  return _i(t) || ni(t) || Be(t) || sn(t);
};

function Zw(t, e, i) {
  i === void 0 && (i = 300);
  var n = t.scrollHeight,
      r = t.style;
  requestAnimationFrame(function () {
    r.minHeight = "initial", r.height = n + "px", r.transition = "all ".concat(i, "ms"), requestAnimationFrame(function () {
      r.height = "0", r.padding = "0", r.margin = "0", setTimeout(e, i);
    });
  });
}

function Vr(t) {
  var e = t.enter,
      i = t.exit,
      _t$appendPosition = t.appendPosition,
      n = _t$appendPosition === void 0 ? !1 : _t$appendPosition,
      _t$collapse = t.collapse,
      r = _t$collapse === void 0 ? !0 : _t$collapse,
      _t$collapseDuration = t.collapseDuration,
      a = _t$collapseDuration === void 0 ? 300 : _t$collapseDuration;
  return function (o) {
    var l = o.children,
        c = o.position,
        d = o.preventExitTransition,
        h = o.done,
        p = o.nodeRef,
        g = o.isIn;
    var f = n ? "".concat(e, "--").concat(c) : e,
        v = n ? "".concat(i, "--").concat(c) : i,
        E = Te(0);
    return Oi(function () {
      var _y$classList2;

      var y = p.current,
          b = f.split(" "),
          C = function C(R) {
        var _y$classList;

        R.target === p.current && (y.dispatchEvent(new Event("d")), y.removeEventListener("animationend", C), y.removeEventListener("animationcancel", C), E.current === 0 && R.type !== "animationcancel" && (_y$classList = y.classList).remove.apply(_y$classList, _toConsumableArray(b)));
      };

      (_y$classList2 = y.classList).add.apply(_y$classList2, _toConsumableArray(b)), y.addEventListener("animationend", C), y.addEventListener("animationcancel", C);
    }, []), He(function () {
      var y = p.current,
          b = function b() {
        y.removeEventListener("animationend", b), r ? Zw(y, h, a) : h();
      };

      g || (d ? b() : (E.current = 1, y.className += " ".concat(v), y.addEventListener("animationend", b)));
    }, [g]), Zt.createElement(Zt.Fragment, null, l);
  };
}

function wl(t, e) {
  return t != null ? {
    content: t.content,
    containerId: t.props.containerId,
    id: t.props.toastId,
    theme: t.props.theme,
    type: t.props.type,
    data: t.props.data || {},
    isLoading: t.props.isLoading,
    icon: t.props.icon,
    status: e
  } : {};
}

var Je = {
  list:
  /* @__PURE__ */
  new Map(),
  emitQueue:
  /* @__PURE__ */
  new Map(),
  on: function on(t, e) {
    return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
  },
  off: function off(t, e) {
    if (e) {
      var i = this.list.get(t).filter(function (n) {
        return n !== e;
      });
      return this.list.set(t, i), this;
    }

    return this.list.delete(t), this;
  },
  cancelEmit: function cancelEmit(t) {
    var e = this.emitQueue.get(t);
    return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
  },
  emit: function emit(t) {
    var _this76 = this,
        _arguments = arguments;

    this.list.has(t) && this.list.get(t).forEach(function (e) {
      var i = setTimeout(function () {
        e.apply(void 0, _toConsumableArray([].slice.call(_arguments, 1)));
      }, 0);
      _this76.emitQueue.has(t) || _this76.emitQueue.set(t, []), _this76.emitQueue.get(t).push(i);
    });
  }
},
    Fn = function Fn(t) {
  var r = t,
      e = r.theme,
      i = r.type,
      n = An(r, ["theme", "type"]);
  return (
    /* @__PURE__ */
    _("svg", O({
      viewBox: "0 0 24 24",
      width: "100%",
      height: "100%",
      fill: e === "colored" ? "currentColor" : "var(--toastify-icon-color-".concat(i, ")")
    }, n))
  );
},
    Ls = {
  info: function info(t) {
    return (
      /* @__PURE__ */
      _(Fn, $(O({}, t), {
        children:
        /* @__PURE__ */
        _("path", {
          d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        })
      }))
    );
  },
  warning: function warning(t) {
    return (
      /* @__PURE__ */
      _(Fn, $(O({}, t), {
        children:
        /* @__PURE__ */
        _("path", {
          d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        })
      }))
    );
  },
  success: function success(t) {
    return (
      /* @__PURE__ */
      _(Fn, $(O({}, t), {
        children:
        /* @__PURE__ */
        _("path", {
          d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        })
      }))
    );
  },
  error: function error(t) {
    return (
      /* @__PURE__ */
      _(Fn, $(O({}, t), {
        children:
        /* @__PURE__ */
        _("path", {
          d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        })
      }))
    );
  },
  spinner: function spinner() {
    return (
      /* @__PURE__ */
      _("div", {
        className: "Toastify__spinner"
      })
    );
  }
};

function eb(t) {
  var _af = af(function (f) {
    return f + 1;
  }, 0),
      _af2 = _slicedToArray(_af, 2),
      e = _af2[1],
      _K5 = K([]),
      _K6 = _slicedToArray(_K5, 2),
      i = _K6[0],
      n = _K6[1],
      r = Te(null),
      a = Te(
  /* @__PURE__ */
  new Map()).current,
      o = function o(f) {
    return i.indexOf(f) !== -1;
  },
      l = Te({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props: t,
    containerId: null,
    isToastActive: o,
    getToast: function getToast(f) {
      return a.get(f);
    }
  }).current;

  function c(f) {
    var v = f.containerId;
    var E = l.props.limit;
    !E || v && l.containerId !== v || (l.count -= l.queue.length, l.queue = []);
  }

  function d(f) {
    n(function (v) {
      return f == null ? [] : v.filter(function (E) {
        return E !== f;
      });
    });
  }

  function h() {
    var _l$queue$shift = l.queue.shift(),
        f = _l$queue$shift.toastContent,
        v = _l$queue$shift.toastProps,
        E = _l$queue$shift.staleId;

    g(f, v, E);
  }

  function p(f, v) {
    var G = v,
        E = G.delay,
        y = G.staleId,
        b = An(G, ["delay", "staleId"]);
    if (!Ns(f) || function (Y) {
      return !r.current || l.props.enableMultiContainer && Y.containerId !== l.props.containerId || a.has(Y.toastId) && Y.updateId == null;
    }(b)) return;

    var C = b.toastId,
        R = b.updateId,
        M = b.data,
        F = l.props,
        m = function m() {
      return d(C);
    },
        I = R == null;

    I && l.count++;
    var w = $(O($(O({}, F), {
      style: F.toastStyle,
      key: l.toastKey++
    }), Object.fromEntries(Object.entries(b).filter(function (Y) {
      var _Y = _slicedToArray(Y, 2),
          W = _Y[0],
          x = _Y[1];

      return x != null;
    }))), {
      toastId: C,
      updateId: R,
      data: M,
      closeToast: m,
      isIn: !1,
      className: zn(b.className || F.toastClassName),
      bodyClassName: zn(b.bodyClassName || F.bodyClassName),
      progressClassName: zn(b.progressClassName || F.progressClassName),
      autoClose: !b.isLoading && (P = b.autoClose, k = F.autoClose, P === !1 || sn(P) && P > 0 ? P : k),
      deleteToast: function deleteToast() {
        var Y = wl(a.get(C), "removed");
        a.delete(C), Je.emit(4, Y);
        var W = l.queue.length;

        if (l.count = C == null ? l.count - l.displayedToast : l.count - 1, l.count < 0 && (l.count = 0), W > 0) {
          var x = C == null ? l.props.limit : 1;
          if (W === 1 || x === 1) l.displayedToast++, h();else {
            var N = x > W ? W : x;
            l.displayedToast = N;

            for (var U = 0; U < N; U++) {
              h();
            }
          }
        } else e();
      }
    });
    var P, k;
    w.iconOut = function (Y) {
      var W = Y.theme,
          x = Y.type,
          N = Y.isLoading,
          U = Y.icon,
          L = null;
      var T = {
        theme: W,
        type: x
      };
      return U === !1 || (Be(U) ? L = U(T) : _i(U) ? L = ea(U, T) : ni(U) || sn(U) ? L = U : N ? L = Ls.spinner() : function (S) {
        return S in Ls;
      }(x) && (L = Ls[x](T))), L;
    }(w), Be(b.onOpen) && (w.onOpen = b.onOpen), Be(b.onClose) && (w.onClose = b.onClose), w.closeButton = F.closeButton, b.closeButton === !1 || Ns(b.closeButton) ? w.closeButton = b.closeButton : b.closeButton === !0 && (w.closeButton = !Ns(F.closeButton) || F.closeButton);
    var A = f;
    _i(f) && !ni(f.type) ? A = ea(f, {
      closeToast: m,
      toastProps: w,
      data: M
    }) : Be(f) && (A = f({
      closeToast: m,
      toastProps: w,
      data: M
    })), F.limit && F.limit > 0 && l.count > F.limit && I ? l.queue.push({
      toastContent: A,
      toastProps: w,
      staleId: y
    }) : sn(E) ? setTimeout(function () {
      g(A, w, y);
    }, E) : g(A, w, y);
  }

  function g(f, v, E) {
    var y = v.toastId;
    E && a.delete(E);
    var b = {
      content: f,
      props: v
    };
    a.set(y, b), n(function (C) {
      return [].concat(_toConsumableArray(C), [y]).filter(function (R) {
        return R !== E;
      });
    }), Je.emit(4, wl(b, b.props.updateId == null ? "added" : "updated"));
  }

  return He(function () {
    return l.containerId = t.containerId, Je.cancelEmit(3).on(0, p).on(1, function (f) {
      return r.current && d(f);
    }).on(5, c).emit(2, l), function () {
      a.clear(), Je.emit(3, l);
    };
  }, []), He(function () {
    l.props = t, l.isToastActive = o, l.displayedToast = i.length;
  }), {
    getToastToRender: function getToastToRender(f) {
      var v =
      /* @__PURE__ */
      new Map(),
          E = Array.from(a.values());
      return t.newestOnTop && E.reverse(), E.forEach(function (y) {
        var b = y.props.position;
        v.has(b) || v.set(b, []), v.get(b).push(y);
      }), Array.from(v, function (y) {
        return f(y[0], y[1]);
      });
    },
    containerRef: r,
    isToastActive: o
  };
}

function bl(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}

function Il(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}

function tb(t) {
  var _K7 = K(!1),
      _K8 = _slicedToArray(_K7, 2),
      e = _K8[0],
      i = _K8[1],
      _K9 = K(!1),
      _K10 = _slicedToArray(_K9, 2),
      n = _K10[0],
      r = _K10[1],
      a = Te(null),
      o = Te({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: !0,
    canDrag: !1,
    boundingRect: null,
    didMove: !1
  }).current,
      l = Te(t),
      c = t.autoClose,
      d = t.pauseOnHover,
      h = t.closeToast,
      p = t.onClick,
      g = t.closeOnClick;

  function f(M) {
    if (t.draggable) {
      M.nativeEvent.type === "touchstart" && M.nativeEvent.preventDefault(), o.didMove = !1, document.addEventListener("mousemove", b), document.addEventListener("mouseup", C), document.addEventListener("touchmove", b), document.addEventListener("touchend", C);
      var F = a.current;
      o.canCloseOnClick = !0, o.canDrag = !0, o.boundingRect = F.getBoundingClientRect(), F.style.transition = "", o.x = bl(M.nativeEvent), o.y = Il(M.nativeEvent), t.draggableDirection === "x" ? (o.start = o.x, o.removalDistance = F.offsetWidth * (t.draggablePercent / 100)) : (o.start = o.y, o.removalDistance = F.offsetHeight * (t.draggablePercent === 80 ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
    }
  }

  function v(M) {
    if (o.boundingRect) {
      var _o$boundingRect = o.boundingRect,
          F = _o$boundingRect.top,
          m = _o$boundingRect.bottom,
          I = _o$boundingRect.left,
          w = _o$boundingRect.right;
      M.nativeEvent.type !== "touchend" && t.pauseOnHover && o.x >= I && o.x <= w && o.y >= F && o.y <= m ? y() : E();
    }
  }

  function E() {
    i(!0);
  }

  function y() {
    i(!1);
  }

  function b(M) {
    var F = a.current;
    o.canDrag && F && (o.didMove = !0, e && y(), o.x = bl(M), o.y = Il(M), o.delta = t.draggableDirection === "x" ? o.x - o.start : o.y - o.start, o.start !== o.x && (o.canCloseOnClick = !1), F.style.transform = "translate".concat(t.draggableDirection, "(").concat(o.delta, "px)"), F.style.opacity = "" + (1 - Math.abs(o.delta / o.removalDistance)));
  }

  function C() {
    document.removeEventListener("mousemove", b), document.removeEventListener("mouseup", C), document.removeEventListener("touchmove", b), document.removeEventListener("touchend", C);
    var M = a.current;

    if (o.canDrag && o.didMove && M) {
      if (o.canDrag = !1, Math.abs(o.delta) > o.removalDistance) return r(!0), void t.closeToast();
      M.style.transition = "transform 0.2s, opacity 0.2s", M.style.transform = "translate".concat(t.draggableDirection, "(0)"), M.style.opacity = "1";
    }
  }

  He(function () {
    l.current = t;
  }), He(function () {
    return a.current && a.current.addEventListener("d", E, {
      once: !0
    }), Be(t.onOpen) && t.onOpen(_i(t.children) && t.children.props), function () {
      var M = l.current;
      Be(M.onClose) && M.onClose(_i(M.children) && M.children.props);
    };
  }, []), He(function () {
    return t.pauseOnFocusLoss && (document.hasFocus() || y(), window.addEventListener("focus", E), window.addEventListener("blur", y)), function () {
      t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", y));
    };
  }, [t.pauseOnFocusLoss]);
  var R = {
    onMouseDown: f,
    onTouchStart: f,
    onMouseUp: v,
    onTouchEnd: v
  };
  return c && d && (R.onMouseEnter = y, R.onMouseLeave = E), g && (R.onClick = function (M) {
    p && p(M), o.canCloseOnClick && h();
  }), {
    playToast: E,
    pauseToast: y,
    isRunning: e,
    preventExitTransition: n,
    toastRef: a,
    eventHandlers: R
  };
}

function yd(t) {
  var e = t.closeToast,
      i = t.theme,
      _t$ariaLabel = t.ariaLabel,
      n = _t$ariaLabel === void 0 ? "close" : _t$ariaLabel;
  return (
    /* @__PURE__ */
    _("button", {
      className: "Toastify__close-button Toastify__close-button--".concat(i),
      type: "button",
      onClick: function onClick(r) {
        r.stopPropagation(), e(r);
      },
      "aria-label": n,
      children:
      /* @__PURE__ */
      _("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16",
        children:
        /* @__PURE__ */
        _("path", {
          fillRule: "evenodd",
          d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
        })
      })
    })
  );
}

function ib(t) {
  var e = t.delay,
      i = t.isRunning,
      n = t.closeToast,
      _t$type = t.type,
      r = _t$type === void 0 ? "default" : _t$type,
      a = t.hide,
      o = t.className,
      l = t.style,
      c = t.controlledProgress,
      d = t.progress,
      h = t.rtl,
      p = t.isIn,
      g = t.theme;
  var f = a || c && d === 0,
      v = $(O({}, l), {
    animationDuration: "".concat(e, "ms"),
    animationPlayState: i ? "running" : "paused",
    opacity: f ? 0 : 1
  });
  c && (v.transform = "scaleX(".concat(d, ")"));
  var E = kt("Toastify__progress-bar", c ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--".concat(g), "Toastify__progress-bar--".concat(r), {
    "Toastify__progress-bar--rtl": h
  }),
      y = Be(o) ? o({
    rtl: h,
    type: r,
    defaultClassName: E
  }) : kt(E, o);
  return Zt.createElement("div", _defineProperty({
    role: "progressbar",
    "aria-hidden": f ? "true" : "false",
    "aria-label": "notification timer",
    className: y,
    style: v
  }, c && d >= 1 ? "onTransitionEnd" : "onAnimationEnd", c && d < 1 ? null : function () {
    p && n();
  }));
}

var nb = function nb(t) {
  var _tb = tb(t),
      e = _tb.isRunning,
      i = _tb.preventExitTransition,
      n = _tb.toastRef,
      r = _tb.eventHandlers,
      a = t.closeButton,
      o = t.children,
      l = t.autoClose,
      c = t.onClick,
      d = t.type,
      h = t.hideProgressBar,
      p = t.closeToast,
      g = t.transition,
      f = t.position,
      v = t.className,
      E = t.style,
      y = t.bodyClassName,
      b = t.bodyStyle,
      C = t.progressClassName,
      R = t.progressStyle,
      M = t.updateId,
      F = t.role,
      m = t.progress,
      I = t.rtl,
      w = t.toastId,
      P = t.deleteToast,
      k = t.isIn,
      A = t.isLoading,
      G = t.iconOut,
      Y = t.closeOnClick,
      W = t.theme,
      x = kt("Toastify__toast", "Toastify__toast-theme--".concat(W), "Toastify__toast--".concat(d), {
    "Toastify__toast--rtl": I
  }, {
    "Toastify__toast--close-on-click": Y
  }),
      N = Be(v) ? v({
    rtl: I,
    position: f,
    type: d,
    defaultClassName: x
  }) : kt(x, v),
      U = !!m || !l,
      L = {
    closeToast: p,
    type: d,
    theme: W
  };

  var T = null;
  return a === !1 || (T = Be(a) ? a(L) : _i(a) ? ea(a, L) : yd(L)), Zt.createElement(g, {
    isIn: k,
    done: P,
    position: f,
    preventExitTransition: i,
    nodeRef: n
  },
  /* @__PURE__ */
  j("div", $(O({
    id: w,
    onClick: c,
    className: N
  }, r), {
    style: E,
    ref: n,
    children: [
    /* @__PURE__ */
    j("div", $(O({}, k && {
      role: F
    }), {
      className: Be(y) ? y({
        type: d
      }) : kt("Toastify__toast-body", y),
      style: b,
      children: [G != null &&
      /* @__PURE__ */
      _("div", {
        className: kt("Toastify__toast-icon", {
          "Toastify--animate-icon Toastify__zoom-enter": !A
        }),
        children: G
      }),
      /* @__PURE__ */
      _("div", {
        children: o
      })]
    })), T,
    /* @__PURE__ */
    _(ib, $(O({}, M && !U ? {
      key: "pb-".concat(M)
    } : {}), {
      rtl: I,
      theme: W,
      delay: l,
      isRunning: e,
      isIn: k,
      closeToast: p,
      hide: h,
      type: d,
      style: R,
      className: C,
      controlledProgress: U,
      progress: m || 0
    }))]
  })));
},
    jr = function jr(t, e) {
  return e === void 0 && (e = !1), {
    enter: "Toastify--animate Toastify__".concat(t, "-enter"),
    exit: "Toastify--animate Toastify__".concat(t, "-exit"),
    appendPosition: e
  };
},
    rb = Vr(jr("bounce", !0));

Vr(jr("slide", !0));
Vr(jr("zoom"));
Vr(jr("flip"));
var ha = Pr(function (t, e) {
  var _eb = eb(t),
      i = _eb.getToastToRender,
      n = _eb.containerRef,
      r = _eb.isToastActive,
      a = t.className,
      o = t.style,
      l = t.rtl,
      c = t.containerId;

  function d(h) {
    var p = kt("Toastify__toast-container", "Toastify__toast-container--".concat(h), {
      "Toastify__toast-container--rtl": l
    });
    return Be(a) ? a({
      position: h,
      rtl: l,
      defaultClassName: p
    }) : kt(p, zn(a));
  }

  return He(function () {
    e && (e.current = n.current);
  }, []),
  /* @__PURE__ */
  _("div", {
    ref: n,
    className: "Toastify",
    id: c,
    children: i(function (h, p) {
      var g = p.length ? O({}, o) : $(O({}, o), {
        pointerEvents: "none"
      });
      return (
        /* @__PURE__ */
        _("div", {
          className: d(h),
          style: g,
          children: p.map(function (f, v) {
            var E = f.content,
                y = f.props;
            return (
              /* @__PURE__ */
              qi(nb, $(O({}, y), {
                isIn: r(y.toastId),
                style: $(O({}, y.style), {
                  "--nth": v + 1,
                  "--len": p.length
                }),
                key: "toast-".concat(y.key)
              }), E)
            );
          })
        }, "container-".concat(h))
      );
    })
  });
});
ha.displayName = "ToastContainer", ha.defaultProps = {
  position: "top-right",
  transition: rb,
  autoClose: 5e3,
  closeButton: yd,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  closeOnClick: !0,
  draggable: !0,
  draggablePercent: 80,
  draggableDirection: "x",
  role: "alert",
  theme: "light"
};
var $s,
    zt =
/* @__PURE__ */
new Map(),
    Ji = [],
    sb = 1;

function vd() {
  return "" + sb++;
}

function ab(t) {
  return t && (ni(t.toastId) || sn(t.toastId)) ? t.toastId : vd();
}

function an(t, e) {
  return zt.size > 0 ? Je.emit(0, t, e) : Ji.push({
    content: t,
    options: e
  }), e.toastId;
}

function dr(t, e) {
  return $(O({}, e), {
    type: e && e.type || t,
    toastId: ab(e)
  });
}

function kn(t) {
  return function (e, i) {
    return an(e, dr(t, i));
  };
}

function X(t, e) {
  return an(t, dr("default", e));
}

X.loading = function (t, e) {
  return an(t, dr("default", O({
    isLoading: !0,
    autoClose: !1,
    closeOnClick: !1,
    closeButton: !1,
    draggable: !1
  }, e)));
}, X.promise = function (t, e, i) {
  var n,
      r = e.pending,
      a = e.error,
      o = e.success;
  r && (n = ni(r) ? X.loading(r, i) : X.loading(r.render, O(O({}, i), r)));

  var l = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  },
      c = function c(h, p, g) {
    if (p == null) return void X.dismiss(n);
    var f = $(O(O({
      type: h
    }, l), i), {
      data: g
    }),
        v = ni(p) ? {
      render: p
    } : p;
    return n ? X.update(n, O(O({}, f), v)) : X(v.render, O(O({}, f), v)), g;
  },
      d = Be(t) ? t() : t;

  return d.then(function (h) {
    return c("success", o, h);
  }).catch(function (h) {
    return c("error", a, h);
  }), d;
}, X.success = kn("success"), X.info = kn("info"), X.error = kn("error"), X.warning = kn("warning"), X.warn = X.warning, X.dark = function (t, e) {
  return an(t, dr("default", O({
    theme: "dark"
  }, e)));
}, X.dismiss = function (t) {
  zt.size > 0 ? Je.emit(1, t) : Ji = Ji.filter(function (e) {
    return t != null && e.options.toastId !== t;
  });
}, X.clearWaitingQueue = function (t) {
  return t === void 0 && (t = {}), Je.emit(5, t);
}, X.isActive = function (t) {
  var e = !1;
  return zt.forEach(function (i) {
    i.isToastActive && i.isToastActive(t) && (e = !0);
  }), e;
}, X.update = function (t, e) {
  e === void 0 && (e = {}), setTimeout(function () {
    var i = function (n, r) {
      var a = r.containerId;
      var o = zt.get(a || $s);
      return o && o.getToast(n);
    }(t, e);

    if (i) {
      var n = i.props,
          _r14 = i.content,
          a = $(O(O({
        delay: 100
      }, n), e), {
        toastId: e.toastId || t,
        updateId: vd()
      });
      a.toastId !== t && (a.staleId = t);
      var o = a.render || _r14;
      delete a.render, an(o, a);
    }
  }, 0);
}, X.done = function (t) {
  X.update(t, {
    progress: 1
  });
}, X.onChange = function (t) {
  return Je.on(4, t), function () {
    Je.off(4, t);
  };
}, X.POSITION = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
}, X.TYPE = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
}, Je.on(2, function (t) {
  $s = t.containerId || t, zt.set($s, t), Ji.forEach(function (e) {
    Je.emit(0, e.content, e.options);
  }), Ji = [];
}).on(3, function (t) {
  zt.delete(t.containerId || t), zt.size === 0 && Je.off(0).off(1).off(5);
});

function de(t) {
  var e = Lt(t);
  if (e === void 0) throw new Error("Context was used outside of its Provider");
  return e;
}

var ob = function ob(e) {
  _classCallCheck(this, ob);

  s(this, "userNotFound");
  s(this, "noPostsFound");
  s(this, "posts");
  s(this, "users");
  s(this, "dictionary");
  s(this, "sortSelectPlaceholder");
  s(this, "typeSelectPlaceholder");
  s(this, "moderatedLabelCheckbox");
  s(this, "deletedLabelCheckbox");
  s(this, "profileIdsSelectPlaceholder");
  s(this, "discussionsSelectPlaceholder");
  s(this, "loading");
  s(this, "noOptionsMessage");
  s(this, "moderated");
  s(this, "onDate");
  s(this, "reason");
  s(this, "user");
  s(this, "deletedAt");
  s(this, "showOlderVersions");
  s(this, "timeFormat");
  s(this, "inDiscussion");
  s(this, "byStaffMemberWithId");
  s(this, "moderationInfo");
  s(this, "at");
  s(this, "na");
  s(this, "filterBy");
  s(this, "sortBy");
  s(this, "moderatePosts");
  s(this, "previous");
  s(this, "next");
  s(this, "name");
  s(this, "tier");
  s(this, "points");
  s(this, "moderate");
  s(this, "ban");
  s(this, "deleteLabel");
  s(this, "moderateLinks");
  s(this, "linksWhitelistDescription");
  s(this, "moderatorId");
  s(this, "moderatorIdDescription");
  s(this, "forbiddenWordsDescription");
  s(this, "moderationReason");
  s(this, "save");
  s(this, "getDiscussionsFeatureErrorMessage");
  s(this, "updateDiscussionsFeatureMessage");
  s(this, "updateDiscussionsFeatureErrorMessage");
  s(this, "savingStaffIdErrorMessage");
  s(this, "cancel");
  s(this, "banPeriodLabel");
  s(this, "banReasonLabel");
  s(this, "day");
  s(this, "days");
  s(this, "indefinite");
  s(this, "customPeriod");
  s(this, "getProfilesErrorMessage");
  s(this, "getDiscussionsErrorMessage");
  s(this, "validationBanProfileErrorMessage");
  s(this, "banProfileMessage");
  s(this, "banProfileErrorMessage");
  s(this, "moderateProfileModalDescription");
  s(this, "validationModerateReasonErrorMessage");
  s(this, "moderateProfileMessage");
  s(this, "moderateProfileErrorMessage");
  s(this, "getPostsErrorMessage");
  s(this, "moderatePostsMessage");
  s(this, "moderatePostsErrorMessage");
  this.userNotFound = e && e.userNotFound ? e.userNotFound : "User not found. Please try again", this.noPostsFound = e && e.noPostsFound ? e.noPostsFound : "No posts found", this.posts = e && e.posts ? e.posts : "Posts", this.users = e && e.users ? e.users : "Users", this.dictionary = e && e.dictionary ? e.dictionary : "Dictionary", this.sortSelectPlaceholder = e && e.sortSelectPlaceholder ? e.sortSelectPlaceholder : "Sort posts...", this.typeSelectPlaceholder = e && e.typeSelectPlaceholder ? e.typeSelectPlaceholder : "Type posts...", this.moderatedLabelCheckbox = e && e.moderatedLabelCheckbox ? e.moderatedLabelCheckbox : "Moderated posts", this.deletedLabelCheckbox = e && e.deletedLabelCheckbox ? e.deletedLabelCheckbox : "Deleted posts", this.profileIdsSelectPlaceholder = e && e.profileIdsSelectPlaceholder ? e.profileIdsSelectPlaceholder : "Type the name or nickname of the profile...", this.discussionsSelectPlaceholder = e && e.discussionsSelectPlaceholder ? e.discussionsSelectPlaceholder : "Type the label of the discussion...", this.loading = e && e.loading ? e.loading : "Loading...", this.noOptionsMessage = e && e.noOptionsMessage ? e.noOptionsMessage : "No options were found for the provided value", this.moderated = e && e.moderated ? e.moderated : "MODERATED", this.onDate = e && e.onDate ? e.onDate : "on date", this.reason = e && e.reason ? e.reason : "Reason", this.user = e && e.user ? e.user : "User", this.deletedAt = e && e.deletedAt ? e.deletedAt : "Deleted at", this.showOlderVersions = e && e.showOlderVersions ? e.showOlderVersions : "Show older versions", this.timeFormat = e && e.timeFormat ? e.timeFormat : "HH:mm, DD.MM.YYYY", this.inDiscussion = e && e.inDiscussion ? e.inDiscussion : "in discussion", this.moderationInfo = e && e.moderationInfo ? e.moderationInfo : "Moderation info:", this.byStaffMemberWithId = e && e.byStaffMemberWithId ? e.byStaffMemberWithId : "By staff member with ID:", this.at = e && e.at ? e.at : "at", this.na = e && e.na ? e.na : "N/A", this.filterBy = e && e.filterBy ? e.filterBy : "Filter by:", this.sortBy = e && e.sortBy ? e.sortBy : "Sort by:", this.moderatePosts = e && e.moderatePosts ? e.moderatePosts : "Moderate selected posts", this.previous = e && e.previous ? e.previous : "Previous", this.next = e && e.next ? e.next : "Next", this.name = e && e.name ? e.name : "Name", this.tier = e && e.tier ? e.tier : "Tier", this.points = e && e.points ? e.points : "Points", this.moderate = e && e.moderate ? e.moderate : "Moderate", this.ban = e && e.ban ? e.ban : "Ban", this.deleteLabel = e && e.deleteLabel ? e.deleteLabel : "Delete", this.moderateLinks = e && e.moderateLinks ? e.moderateLinks : "Moderate links", this.linksWhitelistDescription = e && e.linksWhitelistDescription ? e.linksWhitelistDescription : "Enter the URLs that you want to be excluded and will be not affected by the moderation of links. Every link should be on a new line", this.moderatorId = e && e.moderatorId ? e.moderatorId : "Moderator ID", this.moderatorIdDescription = e && e.moderatorIdDescription ? e.moderatorIdDescription : "When not provided, the ID of the currently logged in staff member will be set", this.updateDiscussionsFeatureMessage = e && e.updateDiscussionsFeatureMessage ? e.updateDiscussionsFeatureMessage : "Successfully updated discussions features!", this.updateDiscussionsFeatureErrorMessage = e && e.updateDiscussionsFeatureErrorMessage ? e.updateDiscussionsFeatureErrorMessage : "There was a problem with updating discussions feature. Please try again", this.savingStaffIdErrorMessage = e && e.savingStaffIdErrorMessage ? e.savingStaffIdErrorMessage : "There was a problem with saving moderator ID", this.getDiscussionsFeatureErrorMessage = e && e.getDiscussionsFeatureErrorMessage ? e.getDiscussionsFeatureErrorMessage : "There was a problem with fetching discussions feature", this.forbiddenWordsDescription = e && e.forbiddenWordsDescription ? e.forbiddenWordsDescription : "Enter the words who are forbidden from users in discussions. Every word should be on a new line", this.moderationReason = e && e.moderationReason ? e.moderationReason : "Moderation reason", this.save = e && e.save ? e.save : "Save", this.cancel = e && e.cancel ? e.cancel : "Cancel", this.getPostsErrorMessage = e && e.getPostsErrorMessage ? e.getPostsErrorMessage : "There was a problem with fetching posts", this.getProfilesErrorMessage = e && e.getProfilesErrorMessage ? e.getProfilesErrorMessage : "There was a problem fetching profiles", this.getDiscussionsErrorMessage = e && e.getDiscussionsErrorMessage ? e.getDiscussionsErrorMessage : "There was a problem fetching discussions", this.validationBanProfileErrorMessage = e && e.validationBanProfileErrorMessage ? e.validationBanProfileErrorMessage : "The ban period and ban reason are required fields", this.banProfileMessage = e && e.banProfileMessage ? e.banProfileMessage : "You have successfully ban the user", this.banProfileErrorMessage = e && e.banProfileErrorMessage ? e.banProfileErrorMessage : "There was a problem with banning the specified profile", this.banPeriodLabel = e && e.banPeriodLabel ? e.banPeriodLabel : "Ban period in days", this.banReasonLabel = e && e.banReasonLabel ? e.banReasonLabel : "Ban reason", this.day = e && e.day ? e.day : "day", this.days = e && e.days ? e.days : "days", this.indefinite = e && e.indefinite ? e.indefinite : "INDEFINITE", this.customPeriod = e && e.customPeriod ? e.customPeriod : "Custom period", this.moderateProfileModalDescription = e && e.moderateProfileModalDescription ? e.moderateProfileModalDescription : "The following operation will moderate all posts for the selected user", this.moderateProfileMessage = e && e.moderateProfileMessage ? e.moderateProfileMessage : "You have successfully moderate all posts for user", this.moderateProfileErrorMessage = e && e.moderateProfileErrorMessage ? e.moderateProfileErrorMessage : "There was a problem with moderating all posts for user", this.validationModerateReasonErrorMessage = e && e.validationModerateReasonErrorMessage ? e.validationModerateReasonErrorMessage : "The moderation reason is required field", this.moderatePostsMessage = e && e.moderatePostsMessage ? e.moderatePostsMessage : "You have successfully moderate all selected posts", this.moderatePostsErrorMessage = e && e.moderatePostsErrorMessage ? e.moderatePostsErrorMessage : "There was a problem with moderating all selected posts";
};

var Ie = Rr(null),
    lb = function lb(_ref50) {
  var t = _ref50.labels,
      e = _ref50.children;
  var i = new ob(t);
  return (
    /* @__PURE__ */
    _(Ie.Provider, {
      value: i,
      children: e
    })
  );
},
    cb = function cb(_ref51) {
  var t = _ref51.fansUnitedEnvironment;

  var _K11 = K(""),
      _K12 = _slicedToArray(_K11, 2),
      e = _K12[0],
      i = _K12[1],
      _K13 = K(""),
      _K14 = _slicedToArray(_K13, 2),
      n = _K14[0],
      r = _K14[1],
      _de = de(Ie),
      a = _de.userNotFound;

  return (
    /* @__PURE__ */
    _("div", {
      className: "dw-flex dw-items-center dw-justify-center dw-min-h-screen dw-bg-gray-100",
      children:
      /* @__PURE__ */
      j("div", {
        className: "dw-px-8 dw-py-6 dw-mt-4 dw-text-left dw-bg-white dw-shadow-lg",
        children: [
        /* @__PURE__ */
        _("h3", {
          className: "dw-text-2xl dw-font-bold dw-text-center dw-mb-4",
          children: "Sign in"
        }),
        /* @__PURE__ */
        _("p", {
          className: "dw-text-gray-400 dw-text-xs dw-mb-4 dw-text-center",
          children: "Use your account in the Fans United platform."
        }),
        /* @__PURE__ */
        j("div", {
          className: "dw-mt-4",
          children: [
          /* @__PURE__ */
          j("div", {
            children: [
            /* @__PURE__ */
            _("label", {
              className: "dw-block",
              htmlFor: "email",
              children: "Email"
            }),
            /* @__PURE__ */
            _("input", {
              value: e,
              type: "text",
              placeholder: "Email",
              className: "dw-w-full dw-px-4 dw-py-2 dw-mt-2 dw-border dw-rounded-md focus:dw-outline-none focus:dw-ring-1 focus:dw-ring-gray-600",
              onChange: function onChange(l) {
                l.persist(), i(l.target.value);
              }
            })]
          }),
          /* @__PURE__ */
          j("div", {
            className: "dw-mt-4",
            children: [
            /* @__PURE__ */
            _("label", {
              className: "dw-block",
              htmlFor: "password",
              children: "Password"
            }),
            /* @__PURE__ */
            _("input", {
              value: n,
              type: "password",
              placeholder: "Password",
              className: "dw-w-full dw-px-4 dw-py-2 dw-mt-2 dw-border dw-rounded-md focus:dw-outline-none focus:dw-ring-1 focus:dw-ring-gray-600",
              onChange: function onChange(l) {
                l.persist(), r(l.target.value);
              }
            })]
          }),
          /* @__PURE__ */
          _("div", {
            className: "dw-flex dw-items-baseline dw-justify-between",
            children:
            /* @__PURE__ */
            _("button", {
              onClick: function onClick() {
                return u(void 0, null,
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee223() {
                  return _regeneratorRuntime.wrap(function _callee223$(_context223) {
                    while (1) {
                      switch (_context223.prev = _context223.next) {
                        case 0:
                          _context223.prev = 0;
                          _context223.next = 3;
                          return hd(t).signInWithEmailAndPassword(e, n);

                        case 3:
                          _context223.next = 8;
                          break;

                        case 5:
                          _context223.prev = 5;
                          _context223.t0 = _context223["catch"](0);
                          console.error(_context223.t0), X.error(a);

                        case 8:
                        case "end":
                          return _context223.stop();
                      }
                    }
                  }, _callee223, null, [[0, 5]]);
                }));
              },
              className: "dw-px-6 dw-py-2 dw-mt-4 dw-text-white dw-bg-gray-600 dw-rounded-lg hover:dw-bg-gray-900",
              children: "Login"
            })
          })]
        })]
      })
    })
  );
},
    ub = function ub(_ref52) {
  var t = _ref52.children;
  return (
    /* @__PURE__ */
    _("div", {
      className: "dw-w-full dw-bg-white dw-p-2",
      "data-testid": "widget-card",
      children: t
    })
  );
},
    db = function db(_ref53) {
  var t = _ref53.tabValue,
      e = _ref53.setTabValue;

  var _Lt = Lt(Ie),
      i = _Lt.posts,
      n = _Lt.users,
      r = _Lt.dictionary;

  return (
    /* @__PURE__ */
    _("div", {
      className: "dw-relative dw-grid md:dw-grid-cols-3 dw-grid-cols-1 dw-gap-1 dw-w-full dw-mb-6",
      children: [i, n, r].map(function (o) {
        return (
          /* @__PURE__ */
          _("div", {
            className: "dw-mb-2 md:dw-mr-2 last:dw-mr-0 dw-flex-auto dw-text-center",
            children:
            /* @__PURE__ */
            _("a", {
              className: "dw-text-xs dw-font-bold dw-p-4 dw-rounded dw-block dw-leading-normal dw-cursor-pointer dw-text-white " + (t === o ? "dw-bg-brandColor" : "dw-bg-gray-400"),
              onClick: function onClick() {
                return e(o);
              },
              children: o
            })
          }, "widget-tab-".concat(o))
        );
      })
    })
  );
};

function ri(t) {
  return ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (e) {
    return typeof e;
  } : function (e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ri(t);
}

function hb(t, e) {
  if (ri(t) != "object" || !t) return t;
  var i = t[Symbol.toPrimitive];

  if (i !== void 0) {
    var n = i.call(t, e || "default");
    if (ri(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (e === "string" ? String : Number)(t);
}

function wd(t) {
  var e = hb(t, "string");
  return ri(e) == "symbol" ? e : String(e);
}

function mi(t, e, i) {
  return e = wd(e), e in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}

function _l(t, e) {
  var i = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), i.push.apply(i, n);
  }

  return i;
}

function q(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _l(Object(i), !0).forEach(function (n) {
      mi(t, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : _l(Object(i)).forEach(function (n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }

  return t;
}

function pb(t) {
  if (Array.isArray(t)) return t;
}

function fb(t, e) {
  var i = t == null ? null : typeof Symbol != "undefined" && t[Symbol.iterator] || t["@@iterator"];

  if (i != null) {
    var n,
        r,
        a,
        o,
        l = [],
        c = !0,
        d = !1;

    try {
      if (a = (i = i.call(t)).next, e === 0) {
        if (Object(i) !== i) return;
        c = !1;
      } else for (; !(c = (n = a.call(i)).done) && (l.push(n.value), l.length !== e); c = !0) {
        ;
      }
    } catch (h) {
      d = !0, r = h;
    } finally {
      try {
        if (!c && i.return != null && (o = i.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw r;
      }
    }

    return l;
  }
}

function pa(t, e) {
  (e == null || e > t.length) && (e = t.length);

  for (var i = 0, n = new Array(e); i < e; i++) {
    n[i] = t[i];
  }

  return n;
}

function bd(t, e) {
  if (!!t) {
    if (typeof t == "string") return pa(t, e);
    var i = Object.prototype.toString.call(t).slice(8, -1);
    if (i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set") return Array.from(t);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return pa(t, e);
  }
}

function mb() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function Oe(t, e) {
  return pb(t) || fb(t, e) || bd(t, e) || mb();
}

function gb(t, e) {
  if (t == null) return {};
  var i = {},
      n = Object.keys(t),
      r,
      a;

  for (a = 0; a < n.length; a++) {
    r = n[a], !(e.indexOf(r) >= 0) && (i[r] = t[r]);
  }

  return i;
}

function ft(t, e) {
  if (t == null) return {};
  var i = gb(t, e),
      n,
      r;

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);

    for (r = 0; r < a.length; r++) {
      n = a[r], !(e.indexOf(n) >= 0) && (!Object.prototype.propertyIsEnumerable.call(t, n) || (i[n] = t[n]));
    }
  }

  return i;
}

var yb = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];

function Id(t) {
  var e = t.defaultInputValue,
      i = e === void 0 ? "" : e,
      n = t.defaultMenuIsOpen,
      r = n === void 0 ? !1 : n,
      a = t.defaultValue,
      o = a === void 0 ? null : a,
      l = t.inputValue,
      c = t.menuIsOpen,
      d = t.onChange,
      h = t.onInputChange,
      p = t.onMenuClose,
      g = t.onMenuOpen,
      f = t.value,
      v = ft(t, yb),
      E = K(l !== void 0 ? l : i),
      y = Oe(E, 2),
      b = y[0],
      C = y[1],
      R = K(c !== void 0 ? c : r),
      M = Oe(R, 2),
      F = M[0],
      m = M[1],
      I = K(f !== void 0 ? f : o),
      w = Oe(I, 2),
      P = w[0],
      k = w[1],
      A = ke(function (L, T) {
    typeof d == "function" && d(L, T), k(L);
  }, [d]),
      G = ke(function (L, T) {
    var S;
    typeof h == "function" && (S = h(L, T)), C(S !== void 0 ? S : L);
  }, [h]),
      Y = ke(function () {
    typeof g == "function" && g(), m(!0);
  }, [g]),
      W = ke(function () {
    typeof p == "function" && p(), m(!1);
  }, [p]),
      x = l !== void 0 ? l : b,
      N = c !== void 0 ? c : F,
      U = f !== void 0 ? f : P;
  return q(q({}, v), {}, {
    inputValue: x,
    menuIsOpen: N,
    onChange: A,
    onInputChange: G,
    onMenuClose: W,
    onMenuOpen: Y,
    value: U
  });
}

function ae() {
  return ae = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];

      for (var n in i) {
        Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
      }
    }

    return t;
  }, ae.apply(this, arguments);
}

function vb(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function El(t, e) {
  for (var i = 0; i < e.length; i++) {
    var n = e[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, wd(n.key), n);
  }
}

function wb(t, e, i) {
  return e && El(t.prototype, e), i && El(t, i), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}

function fa(t, e) {
  return fa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (n, r) {
    return n.__proto__ = r, n;
  }, fa(t, e);
}

function bb(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && fa(t, e);
}

function hr(t) {
  return hr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, hr(t);
}

function _d() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}

  return (_d = function _d() {
    return !!t;
  })();
}

function Ib(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function _b(t, e) {
  if (e && (ri(e) === "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Ib(t);
}

function Eb(t) {
  var e = _d();

  return function () {
    var n = hr(t),
        r;

    if (e) {
      var a = hr(this).constructor;
      r = Reflect.construct(n, arguments, a);
    } else r = n.apply(this, arguments);

    return _b(this, r);
  };
}

function Cb(t) {
  if (Array.isArray(t)) return pa(t);
}

function Sb(t) {
  if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}

function Tb() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function ao(t) {
  return Cb(t) || Sb(t) || bd(t) || Tb();
}

function Rb(t) {
  if (t.sheet) return t.sheet;

  for (var e = 0; e < document.styleSheets.length; e++) {
    if (document.styleSheets[e].ownerNode === t) return document.styleSheets[e];
  }
}

function Pb(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}

var Ob =
/* @__PURE__ */
function () {
  function t(i) {
    var n = this;
    this._insertTag = function (r) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(r, a), n.tags.push(r);
    }, this.isSpeedy = i.speedy === void 0 ? !0 : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }

  var e = t.prototype;
  return e.hydrate = function (n) {
    n.forEach(this._insertTag);
  }, e.insert = function (n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Pb(this));
    var r = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var a = Rb(r);

      try {
        a.insertRule(n, a.cssRules.length);
      } catch (o) {}
    } else r.appendChild(document.createTextNode(n));

    this.ctr++;
  }, e.flush = function () {
    this.tags.forEach(function (n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(),
    De = "-ms-",
    pr = "-moz-",
    re = "-webkit-",
    Ed = "comm",
    oo = "rule",
    lo = "decl",
    Ab = "@import",
    Cd = "@keyframes",
    Mb = "@layer",
    Fb = Math.abs,
    Wr = String.fromCharCode,
    kb = Object.assign;

function xb(t, e) {
  return Fe(t, 0) ^ 45 ? (((e << 2 ^ Fe(t, 0)) << 2 ^ Fe(t, 1)) << 2 ^ Fe(t, 2)) << 2 ^ Fe(t, 3) : 0;
}

function Sd(t) {
  return t.trim();
}

function Db(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}

function se(t, e, i) {
  return t.replace(e, i);
}

function ma(t, e) {
  return t.indexOf(e);
}

function Fe(t, e) {
  return t.charCodeAt(e) | 0;
}

function pn(t, e, i) {
  return t.slice(e, i);
}

function st(t) {
  return t.length;
}

function co(t) {
  return t.length;
}

function xn(t, e) {
  return e.push(t), t;
}

function Nb(t, e) {
  return t.map(e).join("");
}

var Gr = 1,
    Ti = 1,
    Td = 0,
    je = 0,
    ge = 0,
    Di = "";

function zr(t, e, i, n, r, a, o) {
  return {
    value: t,
    root: e,
    parent: i,
    type: n,
    props: r,
    children: a,
    line: Gr,
    column: Ti,
    length: o,
    return: ""
  };
}

function ji(t, e) {
  return kb(zr("", null, null, "", null, null, 0), t, {
    length: -t.length
  }, e);
}

function Lb() {
  return ge;
}

function $b() {
  return ge = je > 0 ? Fe(Di, --je) : 0, Ti--, ge === 10 && (Ti = 1, Gr--), ge;
}

function Qe() {
  return ge = je < Td ? Fe(Di, je++) : 0, Ti++, ge === 10 && (Ti = 1, Gr++), ge;
}

function ht() {
  return Fe(Di, je);
}

function qn() {
  return je;
}

function En(t, e) {
  return pn(Di, t, e);
}

function fn(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function Rd(t) {
  return Gr = Ti = 1, Td = st(Di = t), je = 0, [];
}

function Pd(t) {
  return Di = "", t;
}

function Qn(t) {
  return Sd(En(je - 1, ga(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}

function Ub(t) {
  for (; (ge = ht()) && ge < 33;) {
    Qe();
  }

  return fn(t) > 2 || fn(ge) > 3 ? "" : " ";
}

function Bb(t, e) {
  for (; --e && Qe() && !(ge < 48 || ge > 102 || ge > 57 && ge < 65 || ge > 70 && ge < 97);) {
    ;
  }

  return En(t, qn() + (e < 6 && ht() == 32 && Qe() == 32));
}

function ga(t) {
  for (; Qe();) {
    switch (ge) {
      case t:
        return je;

      case 34:
      case 39:
        t !== 34 && t !== 39 && ga(ge);
        break;

      case 40:
        t === 41 && ga(t);
        break;

      case 92:
        Qe();
        break;
    }
  }

  return je;
}

function Hb(t, e) {
  for (; Qe() && t + ge !== 47 + 10;) {
    if (t + ge === 42 + 42 && ht() === 47) break;
  }

  return "/*" + En(e, je - 1) + "*" + Wr(t === 47 ? t : Qe());
}

function Vb(t) {
  for (; !fn(ht());) {
    Qe();
  }

  return En(t, je);
}

function jb(t) {
  return Pd(Yn("", null, null, null, [""], t = Rd(t), 0, [0], t));
}

function Yn(t, e, i, n, r, a, o, l, c) {
  for (var d = 0, h = 0, p = o, g = 0, f = 0, v = 0, E = 1, y = 1, b = 1, C = 0, R = "", M = r, F = a, m = n, I = R; y;) {
    switch (v = C, C = Qe()) {
      case 40:
        if (v != 108 && Fe(I, p - 1) == 58) {
          ma(I += se(Qn(C), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }

      case 34:
      case 39:
      case 91:
        I += Qn(C);
        break;

      case 9:
      case 10:
      case 13:
      case 32:
        I += Ub(v);
        break;

      case 92:
        I += Bb(qn() - 1, 7);
        continue;

      case 47:
        switch (ht()) {
          case 42:
          case 47:
            xn(Wb(Hb(Qe(), qn()), e, i), c);
            break;

          default:
            I += "/";
        }

        break;

      case 123 * E:
        l[d++] = st(I) * b;

      case 125 * E:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            y = 0;

          case 59 + h:
            b == -1 && (I = se(I, /\f/g, "")), f > 0 && st(I) - p && xn(f > 32 ? Sl(I + ";", n, i, p - 1) : Sl(se(I, " ", "") + ";", n, i, p - 2), c);
            break;

          case 59:
            I += ";";

          default:
            if (xn(m = Cl(I, e, i, d, h, r, l, R, M = [], F = [], p), a), C === 123) if (h === 0) Yn(I, e, m, m, M, a, p, l, F);else switch (g === 99 && Fe(I, 3) === 110 ? 100 : g) {
              case 100:
              case 108:
              case 109:
              case 115:
                Yn(t, m, m, n && xn(Cl(t, m, m, 0, 0, r, l, R, r, M = [], p), F), r, F, p, l, n ? M : F);
                break;

              default:
                Yn(I, m, m, m, [""], F, 0, l, F);
            }
        }

        d = h = f = 0, E = b = 1, R = I = "", p = o;
        break;

      case 58:
        p = 1 + st(I), f = v;

      default:
        if (E < 1) {
          if (C == 123) --E;else if (C == 125 && E++ == 0 && $b() == 125) continue;
        }

        switch (I += Wr(C), C * E) {
          case 38:
            b = h > 0 ? 1 : (I += "\f", -1);
            break;

          case 44:
            l[d++] = (st(I) - 1) * b, b = 1;
            break;

          case 64:
            ht() === 45 && (I += Qn(Qe())), g = ht(), h = p = st(R = I += Vb(qn())), C++;
            break;

          case 45:
            v === 45 && st(I) == 2 && (E = 0);
        }

    }
  }

  return a;
}

function Cl(t, e, i, n, r, a, o, l, c, d, h) {
  for (var p = r - 1, g = r === 0 ? a : [""], f = co(g), v = 0, E = 0, y = 0; v < n; ++v) {
    for (var b = 0, C = pn(t, p + 1, p = Fb(E = o[v])), R = t; b < f; ++b) {
      (R = Sd(E > 0 ? g[b] + " " + C : se(C, /&\f/g, g[b]))) && (c[y++] = R);
    }
  }

  return zr(t, e, i, r === 0 ? oo : l, c, d, h);
}

function Wb(t, e, i) {
  return zr(t, e, i, Ed, Wr(Lb()), pn(t, 2, -2), 0);
}

function Sl(t, e, i, n) {
  return zr(t, e, i, lo, pn(t, 0, n), pn(t, n + 1, -1), n);
}

function Ii(t, e) {
  for (var i = "", n = co(t), r = 0; r < n; r++) {
    i += e(t[r], r, t, e) || "";
  }

  return i;
}

function Gb(t, e, i, n) {
  switch (t.type) {
    case Mb:
      if (t.children.length) break;

    case Ab:
    case lo:
      return t.return = t.return || t.value;

    case Ed:
      return "";

    case Cd:
      return t.return = t.value + "{" + Ii(t.children, n) + "}";

    case oo:
      t.value = t.props.join(",");
  }

  return st(i = Ii(t.children, n)) ? t.return = t.value + "{" + i + "}" : "";
}

function zb(t) {
  var e = co(t);
  return function (i, n, r, a) {
    for (var o = "", l = 0; l < e; l++) {
      o += t[l](i, n, r, a) || "";
    }

    return o;
  };
}

function qb(t) {
  return function (e) {
    e.root || (e = e.return) && t(e);
  };
}

function Qb(t) {
  var e =
  /* @__PURE__ */
  Object.create(null);
  return function (i) {
    return e[i] === void 0 && (e[i] = t(i)), e[i];
  };
}

var Yb = function Yb(e, i, n) {
  for (var r = 0, a = 0; r = a, a = ht(), r === 38 && a === 12 && (i[n] = 1), !fn(a);) {
    Qe();
  }

  return En(e, je);
},
    Kb = function Kb(e, i) {
  var n = -1,
      r = 44;

  do {
    switch (fn(r)) {
      case 0:
        r === 38 && ht() === 12 && (i[n] = 1), e[n] += Yb(je - 1, i, n);
        break;

      case 2:
        e[n] += Qn(r);
        break;

      case 4:
        if (r === 44) {
          e[++n] = ht() === 58 ? "&\f" : "", i[n] = e[n].length;
          break;
        }

      default:
        e[n] += Wr(r);
    }
  } while (r = Qe());

  return e;
},
    Jb = function Jb(e, i) {
  return Pd(Kb(Rd(e), i));
},
    Tl =
/* @__PURE__ */
new WeakMap(),
    Xb = function Xb(e) {
  if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
    for (var i = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) {
      if (n = n.parent, !n) return;
    }

    if (!(e.props.length === 1 && i.charCodeAt(0) !== 58 && !Tl.get(n)) && !r) {
      Tl.set(e, !0);

      for (var a = [], o = Jb(i, a), l = n.props, c = 0, d = 0; c < o.length; c++) {
        for (var h = 0; h < l.length; h++, d++) {
          e.props[d] = a[c] ? o[c].replace(/&\f/g, l[h]) : l[h] + " " + o[c];
        }
      }
    }
  }
},
    Zb = function Zb(e) {
  if (e.type === "decl") {
    var i = e.value;
    i.charCodeAt(0) === 108 && i.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};

function Od(t, e) {
  switch (xb(t, e)) {
    case 5103:
      return re + "print-" + t + t;

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return re + t + t;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return re + t + pr + t + De + t + t;

    case 6828:
    case 4268:
      return re + t + De + t + t;

    case 6165:
      return re + t + De + "flex-" + t + t;

    case 5187:
      return re + t + se(t, /(\w+).+(:[^]+)/, re + "box-$1$2" + De + "flex-$1$2") + t;

    case 5443:
      return re + t + De + "flex-item-" + se(t, /flex-|-self/, "") + t;

    case 4675:
      return re + t + De + "flex-line-pack" + se(t, /align-content|flex-|-self/, "") + t;

    case 5548:
      return re + t + De + se(t, "shrink", "negative") + t;

    case 5292:
      return re + t + De + se(t, "basis", "preferred-size") + t;

    case 6060:
      return re + "box-" + se(t, "-grow", "") + re + t + De + se(t, "grow", "positive") + t;

    case 4554:
      return re + se(t, /([^-])(transform)/g, "$1" + re + "$2") + t;

    case 6187:
      return se(se(se(t, /(zoom-|grab)/, re + "$1"), /(image-set)/, re + "$1"), t, "") + t;

    case 5495:
    case 3959:
      return se(t, /(image-set\([^]*)/, re + "$1$`$1");

    case 4968:
      return se(se(t, /(.+:)(flex-)?(.*)/, re + "box-pack:$3" + De + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + re + t + t;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return se(t, /(.+)-inline(.+)/, re + "$1$2") + t;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (st(t) - 1 - e > 6) switch (Fe(t, e + 1)) {
        case 109:
          if (Fe(t, e + 4) !== 45) break;

        case 102:
          return se(t, /(.+:)(.+)-([^]+)/, "$1" + re + "$2-$3$1" + pr + (Fe(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;

        case 115:
          return ~ma(t, "stretch") ? Od(se(t, "stretch", "fill-available"), e) + t : t;
      }
      break;

    case 4949:
      if (Fe(t, e + 1) !== 115) break;

    case 6444:
      switch (Fe(t, st(t) - 3 - (~ma(t, "!important") && 10))) {
        case 107:
          return se(t, ":", ":" + re) + t;

        case 101:
          return se(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + re + (Fe(t, 14) === 45 ? "inline-" : "") + "box$3$1" + re + "$2$3$1" + De + "$2box$3") + t;
      }

      break;

    case 5936:
      switch (Fe(t, e + 11)) {
        case 114:
          return re + t + De + se(t, /[svh]\w+-[tblr]{2}/, "tb") + t;

        case 108:
          return re + t + De + se(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;

        case 45:
          return re + t + De + se(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }

      return re + t + De + t + t;
  }

  return t;
}

var e0 = function e0(e, i, n, r) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case lo:
      e.return = Od(e.value, e.length);
      break;

    case Cd:
      return Ii([ji(e, {
        value: se(e.value, "@", "@" + re)
      })], r);

    case oo:
      if (e.length) return Nb(e.props, function (a) {
        switch (Db(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Ii([ji(e, {
              props: [se(a, /:(read-\w+)/, ":" + pr + "$1")]
            })], r);

          case "::placeholder":
            return Ii([ji(e, {
              props: [se(a, /:(plac\w+)/, ":" + re + "input-$1")]
            }), ji(e, {
              props: [se(a, /:(plac\w+)/, ":" + pr + "$1")]
            }), ji(e, {
              props: [se(a, /:(plac\w+)/, De + "input-$1")]
            })], r);
        }

        return "";
      });
  }
},
    t0 = [e0],
    i0 = function i0(e) {
  var i = e.key;

  if (i === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function (E) {
      var y = E.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(E), E.setAttribute("data-s", ""));
    });
  }

  var r = e.stylisPlugins || t0,
      a = {},
      o,
      l = [];
  o = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + i + ' "]'), function (E) {
    for (var y = E.getAttribute("data-emotion").split(" "), b = 1; b < y.length; b++) {
      a[y[b]] = !0;
    }

    l.push(E);
  });
  var c,
      d = [Xb, Zb];
  {
    var h,
        p = [Gb, qb(function (E) {
      h.insert(E);
    })],
        g = zb(d.concat(r, p)),
        f = function f(y) {
      return Ii(jb(y), g);
    };

    c = function c(y, b, C, R) {
      h = C, f(y ? y + "{" + b.styles + "}" : b.styles), R && (v.inserted[b.name] = !0);
    };
  }
  var v = {
    key: i,
    sheet: new Ob({
      key: i,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: c
  };
  return v.sheet.hydrate(l), v;
},
    Ad = {
  exports: {}
},
    oe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var Me = typeof Symbol == "function" && Symbol.for,
    uo = Me ? Symbol.for("react.element") : 60103,
    ho = Me ? Symbol.for("react.portal") : 60106,
    qr = Me ? Symbol.for("react.fragment") : 60107,
    Qr = Me ? Symbol.for("react.strict_mode") : 60108,
    Yr = Me ? Symbol.for("react.profiler") : 60114,
    Kr = Me ? Symbol.for("react.provider") : 60109,
    Jr = Me ? Symbol.for("react.context") : 60110,
    po = Me ? Symbol.for("react.async_mode") : 60111,
    Xr = Me ? Symbol.for("react.concurrent_mode") : 60111,
    Zr = Me ? Symbol.for("react.forward_ref") : 60112,
    es = Me ? Symbol.for("react.suspense") : 60113,
    n0 = Me ? Symbol.for("react.suspense_list") : 60120,
    ts = Me ? Symbol.for("react.memo") : 60115,
    is = Me ? Symbol.for("react.lazy") : 60116,
    r0 = Me ? Symbol.for("react.block") : 60121,
    s0 = Me ? Symbol.for("react.fundamental") : 60117,
    a0 = Me ? Symbol.for("react.responder") : 60118,
    o0 = Me ? Symbol.for("react.scope") : 60119;

function Ye(t) {
  if (typeof t == "object" && t !== null) {
    var e = t.$$typeof;

    switch (e) {
      case uo:
        switch (t = t.type, t) {
          case po:
          case Xr:
          case qr:
          case Yr:
          case Qr:
          case es:
            return t;

          default:
            switch (t = t && t.$$typeof, t) {
              case Jr:
              case Zr:
              case is:
              case ts:
              case Kr:
                return t;

              default:
                return e;
            }

        }

      case ho:
        return e;
    }
  }
}

function Md(t) {
  return Ye(t) === Xr;
}

oe.AsyncMode = po;
oe.ConcurrentMode = Xr;
oe.ContextConsumer = Jr;
oe.ContextProvider = Kr;
oe.Element = uo;
oe.ForwardRef = Zr;
oe.Fragment = qr;
oe.Lazy = is;
oe.Memo = ts;
oe.Portal = ho;
oe.Profiler = Yr;
oe.StrictMode = Qr;
oe.Suspense = es;

oe.isAsyncMode = function (t) {
  return Md(t) || Ye(t) === po;
};

oe.isConcurrentMode = Md;

oe.isContextConsumer = function (t) {
  return Ye(t) === Jr;
};

oe.isContextProvider = function (t) {
  return Ye(t) === Kr;
};

oe.isElement = function (t) {
  return typeof t == "object" && t !== null && t.$$typeof === uo;
};

oe.isForwardRef = function (t) {
  return Ye(t) === Zr;
};

oe.isFragment = function (t) {
  return Ye(t) === qr;
};

oe.isLazy = function (t) {
  return Ye(t) === is;
};

oe.isMemo = function (t) {
  return Ye(t) === ts;
};

oe.isPortal = function (t) {
  return Ye(t) === ho;
};

oe.isProfiler = function (t) {
  return Ye(t) === Yr;
};

oe.isStrictMode = function (t) {
  return Ye(t) === Qr;
};

oe.isSuspense = function (t) {
  return Ye(t) === es;
};

oe.isValidElementType = function (t) {
  return typeof t == "string" || typeof t == "function" || t === qr || t === Xr || t === Yr || t === Qr || t === es || t === n0 || typeof t == "object" && t !== null && (t.$$typeof === is || t.$$typeof === ts || t.$$typeof === Kr || t.$$typeof === Jr || t.$$typeof === Zr || t.$$typeof === s0 || t.$$typeof === a0 || t.$$typeof === o0 || t.$$typeof === r0);
};

oe.typeOf = Ye;

(function (t) {
  t.exports = oe;
})(Ad);

var Fd = Ad.exports,
    l0 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
},
    c0 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
},
    kd = {};
kd[Fd.ForwardRef] = l0;
kd[Fd.Memo] = c0;
var u0 = !0;

function d0(t, e, i) {
  var n = "";
  return i.split(" ").forEach(function (r) {
    t[r] !== void 0 ? e.push(t[r] + ";") : n += r + " ";
  }), n;
}

var xd = function xd(e, i, n) {
  var r = e.key + "-" + i.name;
  (n === !1 || u0 === !1) && e.registered[r] === void 0 && (e.registered[r] = i.styles);
},
    h0 = function h0(e, i, n) {
  xd(e, i, n);
  var r = e.key + "-" + i.name;

  if (e.inserted[i.name] === void 0) {
    var a = i;

    do {
      e.insert(i === a ? "." + r : "", a, e.sheet, !0), a = a.next;
    } while (a !== void 0);
  }
};

function p0(t) {
  for (var e = 0, i, n = 0, r = t.length; r >= 4; ++n, r -= 4) {
    i = t.charCodeAt(n) & 255 | (t.charCodeAt(++n) & 255) << 8 | (t.charCodeAt(++n) & 255) << 16 | (t.charCodeAt(++n) & 255) << 24, i = (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= i >>> 24, e = (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }

  switch (r) {
    case 3:
      e ^= (t.charCodeAt(n + 2) & 255) << 16;

    case 2:
      e ^= (t.charCodeAt(n + 1) & 255) << 8;

    case 1:
      e ^= t.charCodeAt(n) & 255, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }

  return e ^= e >>> 13, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}

var f0 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    m0 = /[A-Z]|^ms/g,
    g0 = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    Dd = function Dd(e) {
  return e.charCodeAt(1) === 45;
},
    Rl = function Rl(e) {
  return e != null && typeof e != "boolean";
},
    Us =
/* @__PURE__ */
Qb(function (t) {
  return Dd(t) ? t : t.replace(m0, "-$&").toLowerCase();
}),
    Pl = function Pl(e, i) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof i == "string") return i.replace(g0, function (n, r, a) {
        return at = {
          name: r,
          styles: a,
          next: at
        }, r;
      });
  }

  return f0[e] !== 1 && !Dd(e) && typeof i == "number" && i !== 0 ? i + "px" : i;
};

function mn(t, e, i) {
  if (i == null) return "";
  if (i.__emotion_styles !== void 0) return i;

  switch (typeof i) {
    case "boolean":
      return "";

    case "object":
      {
        if (i.anim === 1) return at = {
          name: i.name,
          styles: i.styles,
          next: at
        }, i.name;

        if (i.styles !== void 0) {
          var n = i.next;
          if (n !== void 0) for (; n !== void 0;) {
            at = {
              name: n.name,
              styles: n.styles,
              next: at
            }, n = n.next;
          }
          var r = i.styles + ";";
          return r;
        }

        return y0(t, e, i);
      }

    case "function":
      {
        if (t !== void 0) {
          var a = at,
              o = i(t);
          return at = a, mn(t, e, o);
        }

        break;
      }
  }

  if (e == null) return i;
  var l = e[i];
  return l !== void 0 ? l : i;
}

function y0(t, e, i) {
  var n = "";
  if (Array.isArray(i)) for (var r = 0; r < i.length; r++) {
    n += mn(t, e, i[r]) + ";";
  } else for (var a in i) {
    var o = i[a];
    if (typeof o != "object") e != null && e[o] !== void 0 ? n += a + "{" + e[o] + "}" : Rl(o) && (n += Us(a) + ":" + Pl(a, o) + ";");else if (Array.isArray(o) && typeof o[0] == "string" && (e == null || e[o[0]] === void 0)) for (var l = 0; l < o.length; l++) {
      Rl(o[l]) && (n += Us(a) + ":" + Pl(a, o[l]) + ";");
    } else {
      var c = mn(t, e, o);

      switch (a) {
        case "animation":
        case "animationName":
          {
            n += Us(a) + ":" + c + ";";
            break;
          }

        default:
          n += a + "{" + c + "}";
      }
    }
  }
  return n;
}

var Ol = /label:\s*([^\s;\n{]+)\s*(;|$)/g,
    at,
    Nd = function Nd(e, i, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
  var r = !0,
      a = "";
  at = void 0;
  var o = e[0];
  o == null || o.raw === void 0 ? (r = !1, a += mn(n, i, o)) : a += o[0];

  for (var l = 1; l < e.length; l++) {
    a += mn(n, i, e[l]), r && (a += o[l]);
  }

  Ol.lastIndex = 0;

  for (var c = "", d; (d = Ol.exec(a)) !== null;) {
    c += "-" + d[1];
  }

  var h = p0(a) + c;
  return {
    name: h,
    styles: a,
    next: at
  };
},
    v0 = function v0(e) {
  return e();
},
    w0 = ve["useInsertionEffect"] ? ve["useInsertionEffect"] : !1,
    b0 = w0 || v0,
    fo = {}.hasOwnProperty,
    Ld =
/* @__PURE__ */
ve.createContext(typeof HTMLElement != "undefined" ?
/* @__PURE__ */
i0({
  key: "css"
}) : null);

Ld.Provider;

var I0 = function I0(e) {
  return (
    /* @__PURE__ */
    Pr(function (i, n) {
      var r = Lt(Ld);
      return e(i, r, n);
    })
  );
},
    _0 =
/* @__PURE__ */
ve.createContext({}),
    ya = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__",
    E0 = function E0(e, i) {
  var n = {};

  for (var r in i) {
    fo.call(i, r) && (n[r] = i[r]);
  }

  return n[ya] = e, n;
},
    C0 = function C0(e) {
  var i = e.cache,
      n = e.serialized,
      r = e.isStringTag;
  return xd(i, n, r), b0(function () {
    return h0(i, n, r);
  }), null;
},
    S0 =
/* @__PURE__ */
I0(function (t, e, i) {
  var n = t.css;
  typeof n == "string" && e.registered[n] !== void 0 && (n = e.registered[n]);
  var r = t[ya],
      a = [n],
      o = "";
  typeof t.className == "string" ? o = d0(e.registered, a, t.className) : t.className != null && (o = t.className + " ");
  var l = Nd(a, void 0, ve.useContext(_0));
  o += e.key + "-" + l.name;
  var c = {};

  for (var d in t) {
    fo.call(t, d) && d !== "css" && d !== ya && (c[d] = t[d]);
  }

  return c.ref = i, c.className = o,
  /* @__PURE__ */
  j(Ne, {
    children: [
    /* @__PURE__ */
    _(C0, {
      cache: e,
      serialized: l,
      isStringTag: typeof r == "string"
    }),
    /* @__PURE__ */
    _(r, O({}, c))]
  });
}),
    T0 = S0,
    Q = function Q(e, i) {
  var n = arguments;
  if (i == null || !fo.call(i, "css")) return ve.createElement.apply(void 0, n);
  var r = n.length,
      a = new Array(r);
  a[0] = T0, a[1] = E0(e, i);

  for (var o = 2; o < r; o++) {
    a[o] = n[o];
  }

  return ve.createElement.apply(null, a);
};

function mo() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) {
    e[i] = arguments[i];
  }

  return Nd(e);
}

var R0 = function R0() {
  var e = mo.apply(void 0, arguments),
      i = "animation-" + e.name;
  return {
    name: i,
    styles: "@keyframes " + i + "{" + e.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

function P0(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

var O0 = Math.min,
    A0 = Math.max,
    fr = Math.round,
    Dn = Math.floor,
    mr = function mr(t) {
  return {
    x: t,
    y: t
  };
};

function M0(t) {
  return $(O({}, t), {
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}

function $d(t) {
  return Bd(t) ? (t.nodeName || "").toLowerCase() : "#document";
}

function tt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}

function Ud(t) {
  var e;
  return (e = (Bd(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}

function Bd(t) {
  return t instanceof Node || t instanceof tt(t).Node;
}

function va(t) {
  return t instanceof Element || t instanceof tt(t).Element;
}

function go(t) {
  return t instanceof HTMLElement || t instanceof tt(t).HTMLElement;
}

function Al(t) {
  return typeof ShadowRoot == "undefined" ? !1 : t instanceof ShadowRoot || t instanceof tt(t).ShadowRoot;
}

function Hd(t) {
  var _yo = yo(t),
      e = _yo.overflow,
      i = _yo.overflowX,
      n = _yo.overflowY,
      r = _yo.display;

  return /auto|scroll|overlay|hidden|clip/.test(e + n + i) && !["inline", "contents"].includes(r);
}

function F0() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}

function k0(t) {
  return ["html", "body", "#document"].includes($d(t));
}

function yo(t) {
  return tt(t).getComputedStyle(t);
}

function x0(t) {
  if ($d(t) === "html") return t;
  var e = t.assignedSlot || t.parentNode || Al(t) && t.host || Ud(t);
  return Al(e) ? e.host : e;
}

function Vd(t) {
  var e = x0(t);
  return k0(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : go(e) && Hd(e) ? e : Vd(e);
}

function gr(t, e, i) {
  var n;
  e === void 0 && (e = []), i === void 0 && (i = !0);
  var r = Vd(t),
      a = r === ((n = t.ownerDocument) == null ? void 0 : n.body),
      o = tt(r);
  return a ? e.concat(o, o.visualViewport || [], Hd(r) ? r : [], o.frameElement && i ? gr(o.frameElement) : []) : e.concat(r, gr(r, [], i));
}

function D0(t) {
  var e = yo(t);
  var i = parseFloat(e.width) || 0,
      n = parseFloat(e.height) || 0;
  var r = go(t),
      a = r ? t.offsetWidth : i,
      o = r ? t.offsetHeight : n,
      l = fr(i) !== a || fr(n) !== o;
  return l && (i = a, n = o), {
    width: i,
    height: n,
    $: l
  };
}

function vo(t) {
  return va(t) ? t : t.contextElement;
}

function Bs(t) {
  var e = vo(t);
  if (!go(e)) return mr(1);

  var i = e.getBoundingClientRect(),
      _D = D0(e),
      n = _D.width,
      r = _D.height,
      a = _D.$;

  var o = (a ? fr(i.width) : i.width) / n,
      l = (a ? fr(i.height) : i.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: o,
    y: l
  };
}

var N0 =
/* @__PURE__ */
mr(0);

function L0(t) {
  var e = tt(t);
  return !F0() || !e.visualViewport ? N0 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}

function $0(t, e, i) {
  return e === void 0 && (e = !1), !i || e && i !== tt(t) ? !1 : e;
}

function Ml(t, e, i, n) {
  e === void 0 && (e = !1), i === void 0 && (i = !1);
  var r = t.getBoundingClientRect(),
      a = vo(t);
  var o = mr(1);
  e && (n ? va(n) && (o = Bs(n)) : o = Bs(t));
  var l = $0(a, i, n) ? L0(a) : mr(0);
  var c = (r.left + l.x) / o.x,
      d = (r.top + l.y) / o.y,
      h = r.width / o.x,
      p = r.height / o.y;

  if (a) {
    var g = tt(a),
        f = n && va(n) ? tt(n) : n;
    var v = g,
        E = v.frameElement;

    for (; E && n && f !== v;) {
      var y = Bs(E),
          b = E.getBoundingClientRect(),
          C = yo(E),
          R = b.left + (E.clientLeft + parseFloat(C.paddingLeft)) * y.x,
          M = b.top + (E.clientTop + parseFloat(C.paddingTop)) * y.y;
      c *= y.x, d *= y.y, h *= y.x, p *= y.y, c += R, d += M, v = tt(E), E = v.frameElement;
    }
  }

  return M0({
    width: h,
    height: p,
    x: c,
    y: d
  });
}

function U0(t, e) {
  var i = null,
      n;
  var r = Ud(t);

  function a() {
    var l;
    clearTimeout(n), (l = i) == null || l.disconnect(), i = null;
  }

  function o(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), a();

    var _t$getBoundingClientR = t.getBoundingClientRect(),
        d = _t$getBoundingClientR.left,
        h = _t$getBoundingClientR.top,
        p = _t$getBoundingClientR.width,
        g = _t$getBoundingClientR.height;

    if (l || e(), !p || !g) return;
    var f = Dn(h),
        v = Dn(r.clientWidth - (d + p)),
        E = Dn(r.clientHeight - (h + g)),
        y = Dn(d),
        C = {
      rootMargin: -f + "px " + -v + "px " + -E + "px " + -y + "px",
      threshold: A0(0, O0(1, c)) || 1
    };
    var R = !0;

    function M(F) {
      var m = F[0].intersectionRatio;

      if (m !== c) {
        if (!R) return o();
        m ? o(!1, m) : n = setTimeout(function () {
          o(!1, 1e-7);
        }, 100);
      }

      R = !1;
    }

    try {
      i = new IntersectionObserver(M, $(O({}, C), {
        root: r.ownerDocument
      }));
    } catch (F) {
      i = new IntersectionObserver(M, C);
    }

    i.observe(t);
  }

  return o(!0), a;
}

function B0(t, e, i, n) {
  n === void 0 && (n = {});
  var _n4 = n,
      _n4$ancestorScroll = _n4.ancestorScroll,
      r = _n4$ancestorScroll === void 0 ? !0 : _n4$ancestorScroll,
      _n4$ancestorResize = _n4.ancestorResize,
      a = _n4$ancestorResize === void 0 ? !0 : _n4$ancestorResize,
      _n4$elementResize = _n4.elementResize,
      o = _n4$elementResize === void 0 ? typeof ResizeObserver == "function" : _n4$elementResize,
      _n4$layoutShift = _n4.layoutShift,
      l = _n4$layoutShift === void 0 ? typeof IntersectionObserver == "function" : _n4$layoutShift,
      _n4$animationFrame = _n4.animationFrame,
      c = _n4$animationFrame === void 0 ? !1 : _n4$animationFrame,
      d = vo(t),
      h = r || a ? [].concat(_toConsumableArray(d ? gr(d) : []), _toConsumableArray(gr(e))) : [];
  h.forEach(function (b) {
    r && b.addEventListener("scroll", i, {
      passive: !0
    }), a && b.addEventListener("resize", i);
  });
  var p = d && l ? U0(d, i) : null;
  var g = -1,
      f = null;
  o && (f = new ResizeObserver(function (b) {
    var _b2 = _slicedToArray(b, 1),
        C = _b2[0];

    C && C.target === d && f && (f.unobserve(e), cancelAnimationFrame(g), g = requestAnimationFrame(function () {
      var R;
      (R = f) == null || R.observe(e);
    })), i();
  }), d && !c && f.observe(d), f.observe(e));
  var v,
      E = c ? Ml(t) : null;
  c && y();

  function y() {
    var b = Ml(t);
    E && (b.x !== E.x || b.y !== E.y || b.width !== E.width || b.height !== E.height) && i(), E = b, v = requestAnimationFrame(y);
  }

  return i(), function () {
    var b;
    h.forEach(function (C) {
      r && C.removeEventListener("scroll", i), a && C.removeEventListener("resize", i);
    }), p == null || p(), (b = f) == null || b.disconnect(), f = null, c && cancelAnimationFrame(v);
  };
}

var wa = Oi,
    H0 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"],
    yr = function yr() {};

function V0(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}

function j0(t, e) {
  for (var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), r = 2; r < i; r++) {
    n[r - 2] = arguments[r];
  }

  var a = [].concat(n);
  if (e && t) for (var o in e) {
    e.hasOwnProperty(o) && e[o] && a.push("".concat(V0(t, o)));
  }
  return a.filter(function (l) {
    return l;
  }).map(function (l) {
    return String(l).trim();
  }).join(" ");
}

var Fl = function Fl(e) {
  return Z0(e) ? e.filter(Boolean) : ri(e) === "object" && e !== null ? [e] : [];
},
    jd = function jd(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var i = ft(e, H0);
  return q({}, i);
},
    he = function he(e, i, n) {
  var r = e.cx,
      a = e.getStyles,
      o = e.getClassNames,
      l = e.className;
  return {
    css: a(i, e),
    className: r(n != null ? n : {}, o(i, e), l)
  };
};

function W0(t, e, i) {
  if (i) {
    var n = i(t, e);
    if (typeof n == "string") return n;
  }

  return t;
}

function ns(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}

function G0(t) {
  return ns(t) ? window.innerHeight : t.clientHeight;
}

function Wd(t) {
  return ns(t) ? window.pageYOffset : t.scrollTop;
}

function vr(t, e) {
  if (ns(t)) {
    window.scrollTo(0, e);
    return;
  }

  t.scrollTop = e;
}

function z0(t) {
  var e = getComputedStyle(t),
      i = e.position === "absolute",
      n = /(auto|scroll)/;
  if (e.position === "fixed") return document.documentElement;

  for (var r = t; r = r.parentElement;) {
    if (e = getComputedStyle(r), !(i && e.position === "static") && n.test(e.overflow + e.overflowY + e.overflowX)) return r;
  }

  return document.documentElement;
}

function q0(t, e, i, n) {
  return i * ((t = t / n - 1) * t * t + 1) + e;
}

function Nn(t, e) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200,
      n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : yr,
      r = Wd(t),
      a = e - r,
      o = 10,
      l = 0;

  function c() {
    l += o;
    var d = q0(l, r, a, i);
    vr(t, d), l < i ? window.requestAnimationFrame(c) : n(t);
  }

  c();
}

function kl(t, e) {
  var i = t.getBoundingClientRect(),
      n = e.getBoundingClientRect(),
      r = e.offsetHeight / 3;
  n.bottom + r > i.bottom ? vr(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + r, t.scrollHeight)) : n.top - r < i.top && vr(t, Math.max(e.offsetTop - r, 0));
}

function Q0(t) {
  var e = t.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}

function xl() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch (t) {
    return !1;
  }
}

function Y0() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (t) {
    return !1;
  }
}

var Gd = !1,
    K0 = {
  get passive() {
    return Gd = !0;
  }

},
    Ln = typeof window != "undefined" ? window : {};
Ln.addEventListener && Ln.removeEventListener && (Ln.addEventListener("p", yr, K0), Ln.removeEventListener("p", yr, !1));
var J0 = Gd;

function X0(t) {
  return t != null;
}

function Z0(t) {
  return Array.isArray(t);
}

function $n(t, e, i) {
  return t ? e : i;
}

var eI = function eI(e) {
  for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) {
    n[r - 1] = arguments[r];
  }

  var a = Object.entries(e).filter(function (o) {
    var l = Oe(o, 1),
        c = l[0];
    return !n.includes(c);
  });
  return a.reduce(function (o, l) {
    var c = Oe(l, 2),
        d = c[0],
        h = c[1];
    return o[d] = h, o;
  }, {});
},
    tI = ["children", "innerProps"],
    iI = ["children", "innerProps"];

function nI(t) {
  var e = t.maxHeight,
      i = t.menuEl,
      n = t.minHeight,
      r = t.placement,
      a = t.shouldScroll,
      o = t.isFixedPosition,
      l = t.controlHeight,
      c = z0(i),
      d = {
    placement: "bottom",
    maxHeight: e
  };
  if (!i || !i.offsetParent) return d;
  var h = c.getBoundingClientRect(),
      p = h.height,
      g = i.getBoundingClientRect(),
      f = g.bottom,
      v = g.height,
      E = g.top,
      y = i.offsetParent.getBoundingClientRect(),
      b = y.top,
      C = o ? window.innerHeight : G0(c),
      R = Wd(c),
      M = parseInt(getComputedStyle(i).marginBottom, 10),
      F = parseInt(getComputedStyle(i).marginTop, 10),
      m = b - F,
      I = C - E,
      w = m + R,
      P = p - R - E,
      k = f - C + R + M,
      A = R + E - F,
      G = 160;

  switch (r) {
    case "auto":
    case "bottom":
      if (I >= v) return {
        placement: "bottom",
        maxHeight: e
      };
      if (P >= v && !o) return a && Nn(c, k, G), {
        placement: "bottom",
        maxHeight: e
      };

      if (!o && P >= n || o && I >= n) {
        a && Nn(c, k, G);
        var Y = o ? I - M : P - M;
        return {
          placement: "bottom",
          maxHeight: Y
        };
      }

      if (r === "auto" || o) {
        var W = e,
            x = o ? m : w;
        return x >= n && (W = Math.min(x - M - l, e)), {
          placement: "top",
          maxHeight: W
        };
      }

      if (r === "bottom") return a && vr(c, k), {
        placement: "bottom",
        maxHeight: e
      };
      break;

    case "top":
      if (m >= v) return {
        placement: "top",
        maxHeight: e
      };
      if (w >= v && !o) return a && Nn(c, A, G), {
        placement: "top",
        maxHeight: e
      };

      if (!o && w >= n || o && m >= n) {
        var N = e;
        return (!o && w >= n || o && m >= n) && (N = o ? m - F : w - F), a && Nn(c, A, G), {
          placement: "top",
          maxHeight: N
        };
      }

      return {
        placement: "bottom",
        maxHeight: e
      };

    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }

  return d;
}

function rI(t) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return t ? e[t] : "bottom";
}

var zd = function zd(e) {
  return e === "auto" ? "bottom" : e;
},
    sI = function sI(e, i) {
  var n,
      r = e.placement,
      a = e.theme,
      o = a.borderRadius,
      l = a.spacing,
      c = a.colors;
  return q((n = {
    label: "menu"
  }, mi(n, rI(r), "100%"), mi(n, "position", "absolute"), mi(n, "width", "100%"), mi(n, "zIndex", 1), n), i ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: o,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: l.menuGutter,
    marginTop: l.menuGutter
  });
},
    qd =
/* @__PURE__ */
Rr(null),
    aI = function aI(e) {
  var i = e.children,
      n = e.minMenuHeight,
      r = e.maxMenuHeight,
      a = e.menuPlacement,
      o = e.menuPosition,
      l = e.menuShouldScrollIntoView,
      c = e.theme,
      d = Lt(qd) || {},
      h = d.setPortalPlacement,
      p = Te(null),
      g = K(r),
      f = Oe(g, 2),
      v = f[0],
      E = f[1],
      y = K(null),
      b = Oe(y, 2),
      C = b[0],
      R = b[1],
      M = c.spacing.controlHeight;
  return wa(function () {
    var F = p.current;

    if (!!F) {
      var m = o === "fixed",
          I = l && !m,
          w = nI({
        maxHeight: r,
        menuEl: F,
        minHeight: n,
        placement: a,
        shouldScroll: I,
        isFixedPosition: m,
        controlHeight: M
      });
      E(w.maxHeight), R(w.placement), h == null || h(w.placement);
    }
  }, [r, a, o, l, n, h, M]), i({
    ref: p,
    placerProps: q(q({}, e), {}, {
      placement: C || zd(a),
      maxHeight: v
    })
  });
},
    oI = function oI(e) {
  var i = e.children,
      n = e.innerRef,
      r = e.innerProps;
  return Q("div", ae({}, he(e, "menu", {
    menu: !0
  }), {
    ref: n
  }, r), i);
},
    lI = oI,
    cI = function cI(e, i) {
  var n = e.maxHeight,
      r = e.theme.spacing.baseUnit;
  return q({
    maxHeight: n,
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
  }, i ? {} : {
    paddingBottom: r,
    paddingTop: r
  });
},
    uI = function uI(e) {
  var i = e.children,
      n = e.innerProps,
      r = e.innerRef,
      a = e.isMulti;
  return Q("div", ae({}, he(e, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: r
  }, n), i);
},
    Qd = function Qd(e, i) {
  var n = e.theme,
      r = n.spacing.baseUnit,
      a = n.colors;
  return q({
    textAlign: "center"
  }, i ? {} : {
    color: a.neutral40,
    padding: "".concat(r * 2, "px ").concat(r * 3, "px")
  });
},
    dI = Qd,
    hI = Qd,
    pI = function pI(e) {
  var i = e.children,
      n = i === void 0 ? "No options" : i,
      r = e.innerProps,
      a = ft(e, tI);
  return Q("div", ae({}, he(q(q({}, a), {}, {
    children: n,
    innerProps: r
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), r), n);
},
    fI = function fI(e) {
  var i = e.children,
      n = i === void 0 ? "Loading..." : i,
      r = e.innerProps,
      a = ft(e, iI);
  return Q("div", ae({}, he(q(q({}, a), {}, {
    children: n,
    innerProps: r
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), r), n);
},
    mI = function mI(e) {
  var i = e.rect,
      n = e.offset,
      r = e.position;
  return {
    left: i.left,
    position: r,
    top: n,
    width: i.width,
    zIndex: 1
  };
},
    gI = function gI(e) {
  var i = e.appendTo,
      n = e.children,
      r = e.controlElement,
      a = e.innerProps,
      o = e.menuPlacement,
      l = e.menuPosition,
      c = Te(null),
      d = Te(null),
      h = K(zd(o)),
      p = Oe(h, 2),
      g = p[0],
      f = p[1],
      v = mt(function () {
    return {
      setPortalPlacement: f
    };
  }, []),
      E = K(null),
      y = Oe(E, 2),
      b = y[0],
      C = y[1],
      R = ke(function () {
    if (!!r) {
      var I = Q0(r),
          w = l === "fixed" ? 0 : window.pageYOffset,
          P = I[g] + w;
      (P !== (b == null ? void 0 : b.offset) || I.left !== (b == null ? void 0 : b.rect.left) || I.width !== (b == null ? void 0 : b.rect.width)) && C({
        offset: P,
        rect: I
      });
    }
  }, [r, l, g, b == null ? void 0 : b.offset, b == null ? void 0 : b.rect.left, b == null ? void 0 : b.rect.width]);
  wa(function () {
    R();
  }, [R]);
  var M = ke(function () {
    typeof d.current == "function" && (d.current(), d.current = null), r && c.current && (d.current = B0(r, c.current, R, {
      elementResize: "ResizeObserver" in window
    }));
  }, [r, R]);
  wa(function () {
    M();
  }, [M]);
  var F = ke(function (I) {
    c.current = I, M();
  }, [M]);
  if (!i && l !== "fixed" || !b) return null;
  var m = Q("div", ae({
    ref: F
  }, he(q(q({}, e), {}, {
    offset: b.offset,
    position: l,
    rect: b.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), n);
  return Q(qd.Provider, {
    value: v
  }, i ?
  /* @__PURE__ */
  uf(m, i) : m);
},
    yI = function yI(e) {
  var i = e.isDisabled,
      n = e.isRtl;
  return {
    label: "container",
    direction: n ? "rtl" : void 0,
    pointerEvents: i ? "none" : void 0,
    position: "relative"
  };
},
    vI = function vI(e) {
  var i = e.children,
      n = e.innerProps,
      r = e.isDisabled,
      a = e.isRtl;
  return Q("div", ae({}, he(e, "container", {
    "--is-disabled": r,
    "--is-rtl": a
  }), n), i);
},
    wI = function wI(e, i) {
  var n = e.theme.spacing,
      r = e.isMulti,
      a = e.hasValue,
      o = e.selectProps.controlShouldRenderValue;
  return q({
    alignItems: "center",
    display: r && a && o ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, i ? {} : {
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px")
  });
},
    bI = function bI(e) {
  var i = e.children,
      n = e.innerProps,
      r = e.isMulti,
      a = e.hasValue;
  return Q("div", ae({}, he(e, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": r,
    "value-container--has-value": a
  }), n), i);
},
    II = function II() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
},
    _I = function _I(e) {
  var i = e.children,
      n = e.innerProps;
  return Q("div", ae({}, he(e, "indicatorsContainer", {
    indicators: !0
  }), n), i);
},
    Dl,
    EI = ["size"],
    CI = ["innerProps", "isRtl", "size"],
    SI = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
},
    Yd = function Yd(e) {
  var i = e.size,
      n = ft(e, EI);
  return Q("svg", ae({
    height: i,
    width: i,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: SI
  }, n));
},
    wo = function wo(e) {
  return Q(Yd, ae({
    size: 20
  }, e), Q("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
},
    Kd = function Kd(e) {
  return Q(Yd, ae({
    size: 20
  }, e), Q("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
},
    Jd = function Jd(e, i) {
  var n = e.isFocused,
      r = e.theme,
      a = r.spacing.baseUnit,
      o = r.colors;
  return q({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, i ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: a * 2,
    ":hover": {
      color: n ? o.neutral80 : o.neutral40
    }
  });
},
    TI = Jd,
    RI = function RI(e) {
  var i = e.children,
      n = e.innerProps;
  return Q("div", ae({}, he(e, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), n), i || Q(Kd, null));
},
    PI = Jd,
    OI = function OI(e) {
  var i = e.children,
      n = e.innerProps;
  return Q("div", ae({}, he(e, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), n), i || Q(wo, null));
},
    AI = function AI(e, i) {
  var n = e.isDisabled,
      r = e.theme,
      a = r.spacing.baseUnit,
      o = r.colors;
  return q({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, i ? {} : {
    backgroundColor: n ? o.neutral10 : o.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
},
    MI = function MI(e) {
  var i = e.innerProps;
  return Q("span", ae({}, i, he(e, "indicatorSeparator", {
    "indicator-separator": !0
  })));
},
    FI = R0(Dl || (Dl = P0(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]))),
    kI = function kI(e, i) {
  var n = e.isFocused,
      r = e.size,
      a = e.theme,
      o = a.colors,
      l = a.spacing.baseUnit;
  return q({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: r,
    lineHeight: 1,
    marginRight: r,
    textAlign: "center",
    verticalAlign: "middle"
  }, i ? {} : {
    color: n ? o.neutral60 : o.neutral20,
    padding: l * 2
  });
},
    Hs = function Hs(e) {
  var i = e.delay,
      n = e.offset;
  return Q("span", {
    css:
    /* @__PURE__ */
    mo({
      animation: "".concat(FI, " 1s ease-in-out ").concat(i, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
},
    xI = function xI(e) {
  var i = e.innerProps,
      n = e.isRtl,
      r = e.size,
      a = r === void 0 ? 4 : r,
      o = ft(e, CI);
  return Q("div", ae({}, he(q(q({}, o), {}, {
    innerProps: i,
    isRtl: n,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), i), Q(Hs, {
    delay: 0,
    offset: n
  }), Q(Hs, {
    delay: 160,
    offset: !0
  }), Q(Hs, {
    delay: 320,
    offset: !n
  }));
},
    DI = function DI(e, i) {
  var n = e.isDisabled,
      r = e.isFocused,
      a = e.theme,
      o = a.colors,
      l = a.borderRadius,
      c = a.spacing;
  return q({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, i ? {} : {
    backgroundColor: n ? o.neutral5 : o.neutral0,
    borderColor: n ? o.neutral10 : r ? o.primary : o.neutral20,
    borderRadius: l,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: r ? "0 0 0 1px ".concat(o.primary) : void 0,
    "&:hover": {
      borderColor: r ? o.primary : o.neutral30
    }
  });
},
    NI = function NI(e) {
  var i = e.children,
      n = e.isDisabled,
      r = e.isFocused,
      a = e.innerRef,
      o = e.innerProps,
      l = e.menuIsOpen;
  return Q("div", ae({
    ref: a
  }, he(e, "control", {
    control: !0,
    "control--is-disabled": n,
    "control--is-focused": r,
    "control--menu-is-open": l
  }), o, {
    "aria-disabled": n || void 0
  }), i);
},
    LI = NI,
    $I = ["data"],
    UI = function UI(e, i) {
  var n = e.theme.spacing;
  return i ? {} : {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
},
    BI = function BI(e) {
  var i = e.children,
      n = e.cx,
      r = e.getStyles,
      a = e.getClassNames,
      o = e.Heading,
      l = e.headingProps,
      c = e.innerProps,
      d = e.label,
      h = e.theme,
      p = e.selectProps;
  return Q("div", ae({}, he(e, "group", {
    group: !0
  }), c), Q(o, ae({}, l, {
    selectProps: p,
    theme: h,
    getStyles: r,
    getClassNames: a,
    cx: n
  }), d), Q("div", null, i));
},
    HI = function HI(e, i) {
  var n = e.theme,
      r = n.colors,
      a = n.spacing;
  return q({
    label: "group",
    cursor: "default",
    display: "block"
  }, i ? {} : {
    color: r.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
},
    VI = function VI(e) {
  var i = jd(e);
  i.data;
  var n = ft(i, $I);
  return Q("div", ae({}, he(e, "groupHeading", {
    "group-heading": !0
  }), n));
},
    jI = BI,
    WI = ["innerRef", "isDisabled", "isHidden", "inputClassName"],
    GI = function GI(e, i) {
  var n = e.isDisabled,
      r = e.value,
      a = e.theme,
      o = a.spacing,
      l = a.colors;
  return q(q({
    visibility: n ? "hidden" : "visible",
    transform: r ? "translateZ(0)" : ""
  }, zI), i ? {} : {
    margin: o.baseUnit / 2,
    paddingBottom: o.baseUnit / 2,
    paddingTop: o.baseUnit / 2,
    color: l.neutral80
  });
},
    Xd = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
},
    zI = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": q({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, Xd)
},
    qI = function qI(e) {
  return q({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, Xd);
},
    QI = function QI(e) {
  var i = e.cx,
      n = e.value,
      r = jd(e),
      a = r.innerRef,
      o = r.isDisabled,
      l = r.isHidden,
      c = r.inputClassName,
      d = ft(r, WI);
  return Q("div", ae({}, he(e, "input", {
    "input-container": !0
  }), {
    "data-value": n || ""
  }), Q("input", ae({
    className: i({
      input: !0
    }, c),
    ref: a,
    style: qI(l),
    disabled: o
  }, d)));
},
    YI = QI,
    KI = function KI(e, i) {
  var n = e.theme,
      r = n.spacing,
      a = n.borderRadius,
      o = n.colors;
  return q({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, i ? {} : {
    backgroundColor: o.neutral10,
    borderRadius: a / 2,
    margin: r.baseUnit / 2
  });
},
    JI = function JI(e, i) {
  var n = e.theme,
      r = n.borderRadius,
      a = n.colors,
      o = e.cropWithEllipsis;
  return q({
    overflow: "hidden",
    textOverflow: o || o === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, i ? {} : {
    borderRadius: r / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
},
    XI = function XI(e, i) {
  var n = e.theme,
      r = n.spacing,
      a = n.borderRadius,
      o = n.colors,
      l = e.isFocused;
  return q({
    alignItems: "center",
    display: "flex"
  }, i ? {} : {
    borderRadius: a / 2,
    backgroundColor: l ? o.dangerLight : void 0,
    paddingLeft: r.baseUnit,
    paddingRight: r.baseUnit,
    ":hover": {
      backgroundColor: o.dangerLight,
      color: o.danger
    }
  });
},
    Zd = function Zd(e) {
  var i = e.children,
      n = e.innerProps;
  return Q("div", n, i);
},
    ZI = Zd,
    e_ = Zd;

function t_(t) {
  var e = t.children,
      i = t.innerProps;
  return Q("div", ae({
    role: "button"
  }, i), e || Q(wo, {
    size: 14
  }));
}

var i_ = function i_(e) {
  var i = e.children,
      n = e.components,
      r = e.data,
      a = e.innerProps,
      o = e.isDisabled,
      l = e.removeProps,
      c = e.selectProps,
      d = n.Container,
      h = n.Label,
      p = n.Remove;
  return Q(d, {
    data: r,
    innerProps: q(q({}, he(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": o
    })), a),
    selectProps: c
  }, Q(h, {
    data: r,
    innerProps: q({}, he(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, i), Q(p, {
    data: r,
    innerProps: q(q({}, he(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(i || "option")
    }, l),
    selectProps: c
  }));
},
    n_ = i_,
    r_ = function r_(e, i) {
  var n = e.isDisabled,
      r = e.isFocused,
      a = e.isSelected,
      o = e.theme,
      l = o.spacing,
      c = o.colors;
  return q({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, i ? {} : {
    backgroundColor: a ? c.primary : r ? c.primary25 : "transparent",
    color: n ? c.neutral20 : a ? c.neutral0 : "inherit",
    padding: "".concat(l.baseUnit * 2, "px ").concat(l.baseUnit * 3, "px"),
    ":active": {
      backgroundColor: n ? void 0 : a ? c.primary : c.primary50
    }
  });
},
    s_ = function s_(e) {
  var i = e.children,
      n = e.isDisabled,
      r = e.isFocused,
      a = e.isSelected,
      o = e.innerRef,
      l = e.innerProps;
  return Q("div", ae({}, he(e, "option", {
    option: !0,
    "option--is-disabled": n,
    "option--is-focused": r,
    "option--is-selected": a
  }), {
    ref: o,
    "aria-disabled": n
  }, l), i);
},
    a_ = s_,
    o_ = function o_(e, i) {
  var n = e.theme,
      r = n.spacing,
      a = n.colors;
  return q({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, i ? {} : {
    color: a.neutral50,
    marginLeft: r.baseUnit / 2,
    marginRight: r.baseUnit / 2
  });
},
    l_ = function l_(e) {
  var i = e.children,
      n = e.innerProps;
  return Q("div", ae({}, he(e, "placeholder", {
    placeholder: !0
  }), n), i);
},
    c_ = l_,
    u_ = function u_(e, i) {
  var n = e.isDisabled,
      r = e.theme,
      a = r.spacing,
      o = r.colors;
  return q({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, i ? {} : {
    color: n ? o.neutral40 : o.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
},
    d_ = function d_(e) {
  var i = e.children,
      n = e.isDisabled,
      r = e.innerProps;
  return Q("div", ae({}, he(e, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": n
  }), r), i);
},
    h_ = d_,
    p_ = {
  ClearIndicator: OI,
  Control: LI,
  DropdownIndicator: RI,
  DownChevron: Kd,
  CrossIcon: wo,
  Group: jI,
  GroupHeading: VI,
  IndicatorsContainer: _I,
  IndicatorSeparator: MI,
  Input: YI,
  LoadingIndicator: xI,
  Menu: lI,
  MenuList: uI,
  MenuPortal: gI,
  LoadingMessage: fI,
  NoOptionsMessage: pI,
  MultiValue: n_,
  MultiValueContainer: ZI,
  MultiValueLabel: e_,
  MultiValueRemove: t_,
  Option: a_,
  Placeholder: c_,
  SelectContainer: vI,
  SingleValue: h_,
  ValueContainer: bI
},
    f_ = function f_(e) {
  return q(q({}, p_), e.components);
},
    Nl = Number.isNaN || function (e) {
  return typeof e == "number" && e !== e;
};

function m_(t, e) {
  return !!(t === e || Nl(t) && Nl(e));
}

function g_(t, e) {
  if (t.length !== e.length) return !1;

  for (var i = 0; i < t.length; i++) {
    if (!m_(t[i], e[i])) return !1;
  }

  return !0;
}

function y_(t, e) {
  e === void 0 && (e = g_);
  var i = null;

  function n() {
    for (var r = [], a = 0; a < arguments.length; a++) {
      r[a] = arguments[a];
    }

    if (i && i.lastThis === this && e(r, i.lastArgs)) return i.lastResult;
    var o = t.apply(this, r);
    return i = {
      lastResult: o,
      lastArgs: r,
      lastThis: this
    }, o;
  }

  return n.clear = function () {
    i = null;
  }, n;
}

var v_ = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
},
    w_ = function w_(e) {
  return Q("span", ae({
    css: v_
  }, e));
},
    Ll = w_,
    b_ = {
  guidance: function guidance(e) {
    var i = e.isSearchable,
        n = e.isMulti,
        r = e.tabSelectsValue,
        a = e.context,
        o = e.isInitialFocus;

    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(r ? ", press Tab to select the option and exit the menu" : "", ".");

      case "input":
        return o ? "".concat(e["aria-label"] || "Select", " is focused ").concat(i ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";

      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";

      default:
        return "";
    }
  },
  onChange: function onChange(e) {
    var i = e.action,
        n = e.label,
        r = n === void 0 ? "" : n,
        a = e.labels,
        o = e.isDisabled;

    switch (i) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(r, ", deselected.");

      case "clear":
        return "All selected options have been cleared.";

      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");

      case "select-option":
        return o ? "option ".concat(r, " is disabled. Select another option.") : "option ".concat(r, ", selected.");

      default:
        return "";
    }
  },
  onFocus: function onFocus(e) {
    var i = e.context,
        n = e.focused,
        r = e.options,
        a = e.label,
        o = a === void 0 ? "" : a,
        l = e.selectValue,
        c = e.isDisabled,
        d = e.isSelected,
        h = e.isAppleDevice,
        p = function p(E, y) {
      return E && E.length ? "".concat(E.indexOf(y) + 1, " of ").concat(E.length) : "";
    };

    if (i === "value" && l) return "value ".concat(o, " focused, ").concat(p(l, n), ".");

    if (i === "menu" && h) {
      var g = c ? " disabled" : "",
          f = "".concat(d ? " selected" : "").concat(g);
      return "".concat(o).concat(f, ", ").concat(p(r, n), ".");
    }

    return "";
  },
  onFilter: function onFilter(e) {
    var i = e.inputValue,
        n = e.resultsMessage;
    return "".concat(n).concat(i ? " for search term " + i : "", ".");
  }
},
    I_ = function I_(e) {
  var i = e.ariaSelection,
      n = e.focusedOption,
      r = e.focusedValue,
      a = e.focusableOptions,
      o = e.isFocused,
      l = e.selectValue,
      c = e.selectProps,
      d = e.id,
      h = e.isAppleDevice,
      p = c.ariaLiveMessages,
      g = c.getOptionLabel,
      f = c.inputValue,
      v = c.isMulti,
      E = c.isOptionDisabled,
      y = c.isSearchable,
      b = c.menuIsOpen,
      C = c.options,
      R = c.screenReaderStatus,
      M = c.tabSelectsValue,
      F = c.isLoading,
      m = c["aria-label"],
      I = c["aria-live"],
      w = mt(function () {
    return q(q({}, b_), p || {});
  }, [p]),
      P = mt(function () {
    var x = "";

    if (i && w.onChange) {
      var N = i.option,
          U = i.options,
          L = i.removedValue,
          T = i.removedValues,
          S = i.value,
          D = function D(ie) {
        return Array.isArray(ie) ? null : ie;
      },
          H = L || N || D(S),
          V = H ? g(H) : "",
          z = U || T || void 0,
          J = z ? z.map(g) : [],
          Z = q({
        isDisabled: H && E(H, l),
        label: V,
        labels: J
      }, i);

      x = w.onChange(Z);
    }

    return x;
  }, [i, w, E, l, g]),
      k = mt(function () {
    var x = "",
        N = n || r,
        U = !!(n && l && l.includes(n));

    if (N && w.onFocus) {
      var L = {
        focused: N,
        label: g(N),
        isDisabled: E(N, l),
        isSelected: U,
        options: a,
        context: N === n ? "menu" : "value",
        selectValue: l,
        isAppleDevice: h
      };
      x = w.onFocus(L);
    }

    return x;
  }, [n, r, g, E, w, a, l, h]),
      A = mt(function () {
    var x = "";

    if (b && C.length && !F && w.onFilter) {
      var N = R({
        count: a.length
      });
      x = w.onFilter({
        inputValue: f,
        resultsMessage: N
      });
    }

    return x;
  }, [a, f, b, w, C, R, F]),
      G = (i == null ? void 0 : i.action) === "initial-input-focus",
      Y = mt(function () {
    var x = "";

    if (w.guidance) {
      var N = r ? "value" : b ? "menu" : "input";
      x = w.guidance({
        "aria-label": m,
        context: N,
        isDisabled: n && E(n, l),
        isMulti: v,
        isSearchable: y,
        tabSelectsValue: M,
        isInitialFocus: G
      });
    }

    return x;
  }, [m, n, r, v, E, y, b, w, l, M, G]),
      W = Q(ta, null, Q("span", {
    id: "aria-selection"
  }, P), Q("span", {
    id: "aria-focused"
  }, k), Q("span", {
    id: "aria-results"
  }, A), Q("span", {
    id: "aria-guidance"
  }, Y));
  return Q(ta, null, Q(Ll, {
    id: d
  }, G && W), Q(Ll, {
    "aria-live": I,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, o && !G && W));
},
    __ = I_,
    ba = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}],
    E_ = new RegExp("[" + ba.map(function (t) {
  return t.letters;
}).join("") + "]", "g"),
    eh = {};

for (var Vs = 0; Vs < ba.length; Vs++) {
  for (var js = ba[Vs], Ws = 0; Ws < js.letters.length; Ws++) {
    eh[js.letters[Ws]] = js.base;
  }
}

var th = function th(e) {
  return e.replace(E_, function (i) {
    return eh[i];
  });
},
    C_ = y_(th),
    $l = function $l(e) {
  return e.replace(/^\s+|\s+$/g, "");
},
    S_ = function S_(e) {
  return "".concat(e.label, " ").concat(e.value);
},
    T_ = function T_(e) {
  return function (i, n) {
    if (i.data.__isNew__) return !0;
    var r = q({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: S_,
      trim: !0,
      matchFrom: "any"
    }, e),
        a = r.ignoreCase,
        o = r.ignoreAccents,
        l = r.stringify,
        c = r.trim,
        d = r.matchFrom,
        h = c ? $l(n) : n,
        p = c ? $l(l(i)) : l(i);
    return a && (h = h.toLowerCase(), p = p.toLowerCase()), o && (h = C_(h), p = th(p)), d === "start" ? p.substr(0, h.length) === h : p.indexOf(h) > -1;
  };
},
    R_ = ["innerRef"];

function P_(t) {
  var e = t.innerRef,
      i = ft(t, R_),
      n = eI(i, "onExited", "in", "enter", "exit", "appear");
  return Q("input", ae({
    ref: e
  }, n, {
    css:
    /* @__PURE__ */
    mo({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}

var O_ = function O_(e) {
  e.cancelable && e.preventDefault(), e.stopPropagation();
};

function A_(t) {
  var e = t.isEnabled,
      i = t.onBottomArrive,
      n = t.onBottomLeave,
      r = t.onTopArrive,
      a = t.onTopLeave,
      o = Te(!1),
      l = Te(!1),
      c = Te(0),
      d = Te(null),
      h = ke(function (y, b) {
    if (d.current !== null) {
      var C = d.current,
          R = C.scrollTop,
          M = C.scrollHeight,
          F = C.clientHeight,
          m = d.current,
          I = b > 0,
          w = M - F - R,
          P = !1;
      w > b && o.current && (n && n(y), o.current = !1), I && l.current && (a && a(y), l.current = !1), I && b > w ? (i && !o.current && i(y), m.scrollTop = M, P = !0, o.current = !0) : !I && -b > R && (r && !l.current && r(y), m.scrollTop = 0, P = !0, l.current = !0), P && O_(y);
    }
  }, [i, n, r, a]),
      p = ke(function (y) {
    h(y, y.deltaY);
  }, [h]),
      g = ke(function (y) {
    c.current = y.changedTouches[0].clientY;
  }, []),
      f = ke(function (y) {
    var b = c.current - y.changedTouches[0].clientY;
    h(y, b);
  }, [h]),
      v = ke(function (y) {
    if (!!y) {
      var b = J0 ? {
        passive: !1
      } : !1;
      y.addEventListener("wheel", p, b), y.addEventListener("touchstart", g, b), y.addEventListener("touchmove", f, b);
    }
  }, [f, g, p]),
      E = ke(function (y) {
    !y || (y.removeEventListener("wheel", p, !1), y.removeEventListener("touchstart", g, !1), y.removeEventListener("touchmove", f, !1));
  }, [f, g, p]);
  return He(function () {
    if (!!e) {
      var y = d.current;
      return v(y), function () {
        E(y);
      };
    }
  }, [e, v, E]), function (y) {
    d.current = y;
  };
}

var Ul = ["boxSizing", "height", "overflow", "paddingRight", "position"],
    Bl = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};

function Hl(t) {
  t.preventDefault();
}

function Vl(t) {
  t.stopPropagation();
}

function jl() {
  var t = this.scrollTop,
      e = this.scrollHeight,
      i = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : i === e && (this.scrollTop = t - 1);
}

function Wl() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}

var Gl = !!(typeof window != "undefined" && window.document && window.document.createElement),
    Wi = 0,
    di = {
  capture: !1,
  passive: !1
};

function M_(t) {
  var e = t.isEnabled,
      i = t.accountForScrollbars,
      n = i === void 0 ? !0 : i,
      r = Te({}),
      a = Te(null),
      o = ke(function (c) {
    if (!!Gl) {
      var d = document.body,
          h = d && d.style;

      if (n && Ul.forEach(function (v) {
        var E = h && h[v];
        r.current[v] = E;
      }), n && Wi < 1) {
        var p = parseInt(r.current.paddingRight, 10) || 0,
            g = document.body ? document.body.clientWidth : 0,
            f = window.innerWidth - g + p || 0;
        Object.keys(Bl).forEach(function (v) {
          var E = Bl[v];
          h && (h[v] = E);
        }), h && (h.paddingRight = "".concat(f, "px"));
      }

      d && Wl() && (d.addEventListener("touchmove", Hl, di), c && (c.addEventListener("touchstart", jl, di), c.addEventListener("touchmove", Vl, di))), Wi += 1;
    }
  }, [n]),
      l = ke(function (c) {
    if (!!Gl) {
      var d = document.body,
          h = d && d.style;
      Wi = Math.max(Wi - 1, 0), n && Wi < 1 && Ul.forEach(function (p) {
        var g = r.current[p];
        h && (h[p] = g);
      }), d && Wl() && (d.removeEventListener("touchmove", Hl, di), c && (c.removeEventListener("touchstart", jl, di), c.removeEventListener("touchmove", Vl, di)));
    }
  }, [n]);
  return He(function () {
    if (!!e) {
      var c = a.current;
      return o(c), function () {
        l(c);
      };
    }
  }, [e, o, l]), function (c) {
    a.current = c;
  };
}

var F_ = function F_(e) {
  var i = e.target;
  return i.ownerDocument.activeElement && i.ownerDocument.activeElement.blur();
},
    k_ = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};

function x_(t) {
  var e = t.children,
      i = t.lockEnabled,
      n = t.captureEnabled,
      r = n === void 0 ? !0 : n,
      a = t.onBottomArrive,
      o = t.onBottomLeave,
      l = t.onTopArrive,
      c = t.onTopLeave,
      d = A_({
    isEnabled: r,
    onBottomArrive: a,
    onBottomLeave: o,
    onTopArrive: l,
    onTopLeave: c
  }),
      h = M_({
    isEnabled: i
  }),
      p = function p(f) {
    d(f), h(f);
  };

  return Q(ta, null, i && Q("div", {
    onClick: F_,
    css: k_
  }), e(p));
}

var D_ = {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
},
    N_ = function N_(e) {
  var i = e.name,
      n = e.onFocus;
  return Q("input", {
    required: !0,
    name: i,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: n,
    css: D_,
    value: "",
    onChange: function onChange() {}
  });
},
    L_ = N_;

function bo(t) {
  var e;
  return typeof window != "undefined" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}

function $_() {
  return bo(/^iPhone/i);
}

function ih() {
  return bo(/^Mac/i);
}

function U_() {
  return bo(/^iPad/i) || ih() && navigator.maxTouchPoints > 1;
}

function B_() {
  return $_() || U_();
}

function H_() {
  return ih() || B_();
}

var V_ = function V_(e) {
  return e.label;
},
    j_ = function j_(e) {
  return e.label;
},
    W_ = function W_(e) {
  return e.value;
},
    G_ = function G_(e) {
  return !!e.isDisabled;
},
    z_ = {
  clearIndicator: PI,
  container: yI,
  control: DI,
  dropdownIndicator: TI,
  group: UI,
  groupHeading: HI,
  indicatorsContainer: II,
  indicatorSeparator: AI,
  input: GI,
  loadingIndicator: kI,
  loadingMessage: hI,
  menu: sI,
  menuList: cI,
  menuPortal: mI,
  multiValue: KI,
  multiValueLabel: JI,
  multiValueRemove: XI,
  noOptionsMessage: dI,
  option: r_,
  placeholder: o_,
  singleValue: u_,
  valueContainer: wI
},
    q_ = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
},
    Q_ = 4,
    nh = 4,
    Y_ = 38,
    K_ = nh * 2,
    J_ = {
  baseUnit: nh,
  controlHeight: Y_,
  menuGutter: K_
},
    Gs = {
  borderRadius: Q_,
  colors: q_,
  spacing: J_
},
    X_ = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: xl(),
  captureMenuScroll: !xl(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: T_(),
  formatGroupLabel: V_,
  getOptionLabel: j_,
  getOptionValue: W_,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: G_,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Y0(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(e) {
    var i = e.count;
    return "".concat(i, " result").concat(i !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};

function zl(t, e, i, n) {
  var r = ah(t, e, i),
      a = oh(t, e, i),
      o = sh(t, e),
      l = wr(t, e);
  return {
    type: "option",
    data: e,
    isDisabled: r,
    isSelected: a,
    label: o,
    value: l,
    index: n
  };
}

function Kn(t, e) {
  return t.options.map(function (i, n) {
    if ("options" in i) {
      var r = i.options.map(function (o, l) {
        return zl(t, o, e, l);
      }).filter(function (o) {
        return Ql(t, o);
      });
      return r.length > 0 ? {
        type: "group",
        data: i,
        options: r,
        index: n
      } : void 0;
    }

    var a = zl(t, i, e, n);
    return Ql(t, a) ? a : void 0;
  }).filter(X0);
}

function rh(t) {
  return t.reduce(function (e, i) {
    return i.type === "group" ? e.push.apply(e, ao(i.options.map(function (n) {
      return n.data;
    }))) : e.push(i.data), e;
  }, []);
}

function ql(t, e) {
  return t.reduce(function (i, n) {
    return n.type === "group" ? i.push.apply(i, ao(n.options.map(function (r) {
      return {
        data: r.data,
        id: "".concat(e, "-").concat(n.index, "-").concat(r.index)
      };
    }))) : i.push({
      data: n.data,
      id: "".concat(e, "-").concat(n.index)
    }), i;
  }, []);
}

function Z_(t, e) {
  return rh(Kn(t, e));
}

function Ql(t, e) {
  var i = t.inputValue,
      n = i === void 0 ? "" : i,
      r = e.data,
      a = e.isSelected,
      o = e.label,
      l = e.value;
  return (!ch(t) || !a) && lh(t, {
    label: o,
    value: l,
    data: r
  }, n);
}

function eE(t, e) {
  var i = t.focusedValue,
      n = t.selectValue,
      r = n.indexOf(i);

  if (r > -1) {
    var a = e.indexOf(i);
    if (a > -1) return i;
    if (r < e.length) return e[r];
  }

  return null;
}

function tE(t, e) {
  var i = t.focusedOption;
  return i && e.indexOf(i) > -1 ? i : e[0];
}

var zs = function zs(e, i) {
  var n,
      r = (n = e.find(function (a) {
    return a.data === i;
  })) === null || n === void 0 ? void 0 : n.id;
  return r || null;
},
    sh = function sh(e, i) {
  return e.getOptionLabel(i);
},
    wr = function wr(e, i) {
  return e.getOptionValue(i);
};

function ah(t, e, i) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(e, i) : !1;
}

function oh(t, e, i) {
  if (i.indexOf(e) > -1) return !0;
  if (typeof t.isOptionSelected == "function") return t.isOptionSelected(e, i);
  var n = wr(t, e);
  return i.some(function (r) {
    return wr(t, r) === n;
  });
}

function lh(t, e, i) {
  return t.filterOption ? t.filterOption(e, i) : !0;
}

var ch = function ch(e) {
  var i = e.hideSelectedOptions,
      n = e.isMulti;
  return i === void 0 ? n : i;
},
    iE = 1,
    Io =
/* @__PURE__ */
function (t) {
  bb(i, t);
  var e = Eb(i);

  function i(n) {
    var r;

    if (vb(this, i), r = e.call(this, n), r.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, r.blockOptionHover = !1, r.isComposing = !1, r.commonProps = void 0, r.initialTouchX = 0, r.initialTouchY = 0, r.openAfterFocus = !1, r.scrollToFocusedOptionOnUpdate = !1, r.userIsDragging = void 0, r.isAppleDevice = H_(), r.controlRef = null, r.getControlRef = function (c) {
      r.controlRef = c;
    }, r.focusedOptionRef = null, r.getFocusedOptionRef = function (c) {
      r.focusedOptionRef = c;
    }, r.menuListRef = null, r.getMenuListRef = function (c) {
      r.menuListRef = c;
    }, r.inputRef = null, r.getInputRef = function (c) {
      r.inputRef = c;
    }, r.focus = r.focusInput, r.blur = r.blurInput, r.onChange = function (c, d) {
      var h = r.props,
          p = h.onChange,
          g = h.name;
      d.name = g, r.ariaOnChange(c, d), p(c, d);
    }, r.setValue = function (c, d, h) {
      var p = r.props,
          g = p.closeMenuOnSelect,
          f = p.isMulti,
          v = p.inputValue;
      r.onInputChange("", {
        action: "set-value",
        prevInputValue: v
      }), g && (r.setState({
        inputIsHiddenAfterUpdate: !f
      }), r.onMenuClose()), r.setState({
        clearFocusValueOnUpdate: !0
      }), r.onChange(c, {
        action: d,
        option: h
      });
    }, r.selectOption = function (c) {
      var d = r.props,
          h = d.blurInputOnSelect,
          p = d.isMulti,
          g = d.name,
          f = r.state.selectValue,
          v = p && r.isOptionSelected(c, f),
          E = r.isOptionDisabled(c, f);

      if (v) {
        var y = r.getOptionValue(c);
        r.setValue(f.filter(function (b) {
          return r.getOptionValue(b) !== y;
        }), "deselect-option", c);
      } else if (!E) p ? r.setValue([].concat(ao(f), [c]), "select-option", c) : r.setValue(c, "select-option");else {
        r.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: g
        });
        return;
      }

      h && r.blurInput();
    }, r.removeValue = function (c) {
      var d = r.props.isMulti,
          h = r.state.selectValue,
          p = r.getOptionValue(c),
          g = h.filter(function (v) {
        return r.getOptionValue(v) !== p;
      }),
          f = $n(d, g, g[0] || null);
      r.onChange(f, {
        action: "remove-value",
        removedValue: c
      }), r.focusInput();
    }, r.clearValue = function () {
      var c = r.state.selectValue;
      r.onChange($n(r.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, r.popValue = function () {
      var c = r.props.isMulti,
          d = r.state.selectValue,
          h = d[d.length - 1],
          p = d.slice(0, d.length - 1),
          g = $n(c, p, p[0] || null);
      r.onChange(g, {
        action: "pop-value",
        removedValue: h
      });
    }, r.getFocusedOptionId = function (c) {
      return zs(r.state.focusableOptionsWithIds, c);
    }, r.getFocusableOptionsWithIds = function () {
      return ql(Kn(r.props, r.state.selectValue), r.getElementId("option"));
    }, r.getValue = function () {
      return r.state.selectValue;
    }, r.cx = function () {
      for (var c = arguments.length, d = new Array(c), h = 0; h < c; h++) {
        d[h] = arguments[h];
      }

      return j0.apply(void 0, [r.props.classNamePrefix].concat(d));
    }, r.getOptionLabel = function (c) {
      return sh(r.props, c);
    }, r.getOptionValue = function (c) {
      return wr(r.props, c);
    }, r.getStyles = function (c, d) {
      var h = r.props.unstyled,
          p = z_[c](d, h);
      p.boxSizing = "border-box";
      var g = r.props.styles[c];
      return g ? g(p, d) : p;
    }, r.getClassNames = function (c, d) {
      var h, p;
      return (h = (p = r.props.classNames)[c]) === null || h === void 0 ? void 0 : h.call(p, d);
    }, r.getElementId = function (c) {
      return "".concat(r.state.instancePrefix, "-").concat(c);
    }, r.getComponents = function () {
      return f_(r.props);
    }, r.buildCategorizedOptions = function () {
      return Kn(r.props, r.state.selectValue);
    }, r.getCategorizedOptions = function () {
      return r.props.menuIsOpen ? r.buildCategorizedOptions() : [];
    }, r.buildFocusableOptions = function () {
      return rh(r.buildCategorizedOptions());
    }, r.getFocusableOptions = function () {
      return r.props.menuIsOpen ? r.buildFocusableOptions() : [];
    }, r.ariaOnChange = function (c, d) {
      r.setState({
        ariaSelection: q({
          value: c
        }, d)
      });
    }, r.onMenuMouseDown = function (c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), r.focusInput());
    }, r.onMenuMouseMove = function (c) {
      r.blockOptionHover = !1;
    }, r.onControlMouseDown = function (c) {
      if (!c.defaultPrevented) {
        var d = r.props.openMenuOnClick;
        r.state.isFocused ? r.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && r.onMenuClose() : d && r.openMenu("first") : (d && (r.openAfterFocus = !0), r.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, r.onDropdownIndicatorMouseDown = function (c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !r.props.isDisabled) {
        var d = r.props,
            h = d.isMulti,
            p = d.menuIsOpen;
        r.focusInput(), p ? (r.setState({
          inputIsHiddenAfterUpdate: !h
        }), r.onMenuClose()) : r.openMenu("first"), c.preventDefault();
      }
    }, r.onClearIndicatorMouseDown = function (c) {
      c && c.type === "mousedown" && c.button !== 0 || (r.clearValue(), c.preventDefault(), r.openAfterFocus = !1, c.type === "touchend" ? r.focusInput() : setTimeout(function () {
        return r.focusInput();
      }));
    }, r.onScroll = function (c) {
      typeof r.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && ns(c.target) && r.props.onMenuClose() : typeof r.props.closeMenuOnScroll == "function" && r.props.closeMenuOnScroll(c) && r.props.onMenuClose();
    }, r.onCompositionStart = function () {
      r.isComposing = !0;
    }, r.onCompositionEnd = function () {
      r.isComposing = !1;
    }, r.onTouchStart = function (c) {
      var d = c.touches,
          h = d && d.item(0);
      !h || (r.initialTouchX = h.clientX, r.initialTouchY = h.clientY, r.userIsDragging = !1);
    }, r.onTouchMove = function (c) {
      var d = c.touches,
          h = d && d.item(0);

      if (!!h) {
        var p = Math.abs(h.clientX - r.initialTouchX),
            g = Math.abs(h.clientY - r.initialTouchY),
            f = 5;
        r.userIsDragging = p > f || g > f;
      }
    }, r.onTouchEnd = function (c) {
      r.userIsDragging || (r.controlRef && !r.controlRef.contains(c.target) && r.menuListRef && !r.menuListRef.contains(c.target) && r.blurInput(), r.initialTouchX = 0, r.initialTouchY = 0);
    }, r.onControlTouchEnd = function (c) {
      r.userIsDragging || r.onControlMouseDown(c);
    }, r.onClearIndicatorTouchEnd = function (c) {
      r.userIsDragging || r.onClearIndicatorMouseDown(c);
    }, r.onDropdownIndicatorTouchEnd = function (c) {
      r.userIsDragging || r.onDropdownIndicatorMouseDown(c);
    }, r.handleInputChange = function (c) {
      var d = r.props.inputValue,
          h = c.currentTarget.value;
      r.setState({
        inputIsHiddenAfterUpdate: !1
      }), r.onInputChange(h, {
        action: "input-change",
        prevInputValue: d
      }), r.props.menuIsOpen || r.onMenuOpen();
    }, r.onInputFocus = function (c) {
      r.props.onFocus && r.props.onFocus(c), r.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (r.openAfterFocus || r.props.openMenuOnFocus) && r.openMenu("first"), r.openAfterFocus = !1;
    }, r.onInputBlur = function (c) {
      var d = r.props.inputValue;

      if (r.menuListRef && r.menuListRef.contains(document.activeElement)) {
        r.inputRef.focus();
        return;
      }

      r.props.onBlur && r.props.onBlur(c), r.onInputChange("", {
        action: "input-blur",
        prevInputValue: d
      }), r.onMenuClose(), r.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, r.onOptionHover = function (c) {
      if (!(r.blockOptionHover || r.state.focusedOption === c)) {
        var d = r.getFocusableOptions(),
            h = d.indexOf(c);
        r.setState({
          focusedOption: c,
          focusedOptionId: h > -1 ? r.getFocusedOptionId(c) : null
        });
      }
    }, r.shouldHideSelectedOptions = function () {
      return ch(r.props);
    }, r.onValueInputFocus = function (c) {
      c.preventDefault(), c.stopPropagation(), r.focus();
    }, r.onKeyDown = function (c) {
      var d = r.props,
          h = d.isMulti,
          p = d.backspaceRemovesValue,
          g = d.escapeClearsValue,
          f = d.inputValue,
          v = d.isClearable,
          E = d.isDisabled,
          y = d.menuIsOpen,
          b = d.onKeyDown,
          C = d.tabSelectsValue,
          R = d.openMenuOnFocus,
          M = r.state,
          F = M.focusedOption,
          m = M.focusedValue,
          I = M.selectValue;

      if (!E && !(typeof b == "function" && (b(c), c.defaultPrevented))) {
        switch (r.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!h || f) return;
            r.focusValue("previous");
            break;

          case "ArrowRight":
            if (!h || f) return;
            r.focusValue("next");
            break;

          case "Delete":
          case "Backspace":
            if (f) return;
            if (m) r.removeValue(m);else {
              if (!p) return;
              h ? r.popValue() : v && r.clearValue();
            }
            break;

          case "Tab":
            if (r.isComposing || c.shiftKey || !y || !C || !F || R && r.isOptionSelected(F, I)) return;
            r.selectOption(F);
            break;

          case "Enter":
            if (c.keyCode === 229) break;

            if (y) {
              if (!F || r.isComposing) return;
              r.selectOption(F);
              break;
            }

            return;

          case "Escape":
            y ? (r.setState({
              inputIsHiddenAfterUpdate: !1
            }), r.onInputChange("", {
              action: "menu-close",
              prevInputValue: f
            }), r.onMenuClose()) : v && g && r.clearValue();
            break;

          case " ":
            if (f) return;

            if (!y) {
              r.openMenu("first");
              break;
            }

            if (!F) return;
            r.selectOption(F);
            break;

          case "ArrowUp":
            y ? r.focusOption("up") : r.openMenu("last");
            break;

          case "ArrowDown":
            y ? r.focusOption("down") : r.openMenu("first");
            break;

          case "PageUp":
            if (!y) return;
            r.focusOption("pageup");
            break;

          case "PageDown":
            if (!y) return;
            r.focusOption("pagedown");
            break;

          case "Home":
            if (!y) return;
            r.focusOption("first");
            break;

          case "End":
            if (!y) return;
            r.focusOption("last");
            break;

          default:
            return;
        }

        c.preventDefault();
      }
    }, r.state.instancePrefix = "react-select-" + (r.props.instanceId || ++iE), r.state.selectValue = Fl(n.value), n.menuIsOpen && r.state.selectValue.length) {
      var a = r.getFocusableOptionsWithIds(),
          o = r.buildFocusableOptions(),
          l = o.indexOf(r.state.selectValue[0]);
      r.state.focusableOptionsWithIds = a, r.state.focusedOption = o[l], r.state.focusedOptionId = zs(a, o[l]);
    }

    return r;
  }

  return wb(i, [{
    key: "componentDidMount",
    value: function value() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && kl(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(r) {
      var a = this.props,
          o = a.isDisabled,
          l = a.menuIsOpen,
          c = this.state.isFocused;
      (c && !o && r.isDisabled || c && l && !r.menuIsOpen) && this.focusInput(), c && o && !r.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !o && r.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (kl(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "onMenuOpen",
    value: function value() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function value() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function value(r, a) {
      this.props.onInputChange(r, a);
    }
  }, {
    key: "focusInput",
    value: function value() {
      !this.inputRef || this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function value() {
      !this.inputRef || this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function value(r) {
      var a = this,
          o = this.state,
          l = o.selectValue,
          c = o.isFocused,
          d = this.buildFocusableOptions(),
          h = r === "first" ? 0 : d.length - 1;

      if (!this.props.isMulti) {
        var p = d.indexOf(l[0]);
        p > -1 && (h = p);
      }

      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: d[h],
        focusedOptionId: this.getFocusedOptionId(d[h])
      }, function () {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function value(r) {
      var a = this.state,
          o = a.selectValue,
          l = a.focusedValue;

      if (!!this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = o.indexOf(l);
        l || (c = -1);
        var d = o.length - 1,
            h = -1;

        if (!!o.length) {
          switch (r) {
            case "previous":
              c === 0 ? h = 0 : c === -1 ? h = d : h = c - 1;
              break;

            case "next":
              c > -1 && c < d && (h = c + 1);
              break;
          }

          this.setState({
            inputIsHidden: h !== -1,
            focusedValue: o[h]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function value() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first",
          a = this.props.pageSize,
          o = this.state.focusedOption,
          l = this.getFocusableOptions();

      if (!!l.length) {
        var c = 0,
            d = l.indexOf(o);
        o || (d = -1), r === "up" ? c = d > 0 ? d - 1 : l.length - 1 : r === "down" ? c = (d + 1) % l.length : r === "pageup" ? (c = d - a, c < 0 && (c = 0)) : r === "pagedown" ? (c = d + a, c > l.length - 1 && (c = l.length - 1)) : r === "last" && (c = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: l[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(l[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: function value() {
      return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Gs) : q(q({}, Gs), this.props.theme) : Gs;
    }
  }, {
    key: "getCommonProps",
    value: function value() {
      var r = this.clearValue,
          a = this.cx,
          o = this.getStyles,
          l = this.getClassNames,
          c = this.getValue,
          d = this.selectOption,
          h = this.setValue,
          p = this.props,
          g = p.isMulti,
          f = p.isRtl,
          v = p.options,
          E = this.hasValue();
      return {
        clearValue: r,
        cx: a,
        getStyles: o,
        getClassNames: l,
        getValue: c,
        hasValue: E,
        isMulti: g,
        isRtl: f,
        options: v,
        selectOption: d,
        selectProps: p,
        setValue: h,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function value() {
      var r = this.state.selectValue;
      return r.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function value() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function value() {
      var r = this.props,
          a = r.isClearable,
          o = r.isMulti;
      return a === void 0 ? o : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function value(r, a) {
      return ah(this.props, r, a);
    }
  }, {
    key: "isOptionSelected",
    value: function value(r, a) {
      return oh(this.props, r, a);
    }
  }, {
    key: "filterOption",
    value: function value(r, a) {
      return lh(this.props, r, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function value(r, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue,
            l = this.state.selectValue;
        return this.props.formatOptionLabel(r, {
          context: a,
          inputValue: o,
          selectValue: l
        });
      } else return this.getOptionLabel(r);
    }
  }, {
    key: "formatGroupLabel",
    value: function value(r) {
      return this.props.formatGroupLabel(r);
    }
  }, {
    key: "startListeningComposition",
    value: function value() {
      document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
    }
  }, {
    key: "stopListeningComposition",
    value: function value() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: function value() {
      document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
    }
  }, {
    key: "stopListeningToTouch",
    value: function value() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: function value() {
      var r = this.props,
          a = r.isDisabled,
          o = r.isSearchable,
          l = r.inputId,
          c = r.inputValue,
          d = r.tabIndex,
          h = r.form,
          p = r.menuIsOpen,
          g = r.required,
          f = this.getComponents(),
          v = f.Input,
          E = this.state,
          y = E.inputIsHidden,
          b = E.ariaSelection,
          C = this.commonProps,
          R = l || this.getElementId("input"),
          M = q(q(q({
        "aria-autocomplete": "list",
        "aria-expanded": p,
        "aria-haspopup": !0,
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": g,
        role: "combobox",
        "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
      }, p && {
        "aria-controls": this.getElementId("listbox")
      }), !o && {
        "aria-readonly": !0
      }), this.hasValue() ? (b == null ? void 0 : b.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      return o ?
      /* @__PURE__ */
      _(v, O($(O({}, C), {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: R,
        innerRef: this.getInputRef,
        isDisabled: a,
        isHidden: y,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: d,
        form: h,
        type: "text",
        value: c
      }), M)) :
      /* @__PURE__ */
      _(P_, O({
        id: R,
        innerRef: this.getInputRef,
        onBlur: this.onInputBlur,
        onChange: yr,
        onFocus: this.onInputFocus,
        disabled: a,
        tabIndex: d,
        inputMode: "none",
        form: h,
        value: ""
      }, M));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function value() {
      var r = this,
          a = this.getComponents(),
          o = a.MultiValue,
          l = a.MultiValueContainer,
          c = a.MultiValueLabel,
          d = a.MultiValueRemove,
          h = a.SingleValue,
          p = a.Placeholder,
          g = this.commonProps,
          f = this.props,
          v = f.controlShouldRenderValue,
          E = f.isDisabled,
          y = f.isMulti,
          b = f.inputValue,
          C = f.placeholder,
          R = this.state,
          M = R.selectValue,
          F = R.focusedValue,
          m = R.isFocused;
      if (!this.hasValue() || !v) return b ? null :
      /* @__PURE__ */
      qi(p, $(O({}, g), {
        key: "placeholder",
        isDisabled: E,
        isFocused: m,
        innerProps: {
          id: this.getElementId("placeholder")
        }
      }), C);
      if (y) return M.map(function (w, P) {
        var k = w === F,
            A = "".concat(r.getOptionLabel(w), "-").concat(r.getOptionValue(w));
        return (
          /* @__PURE__ */
          qi(o, $(O({}, g), {
            components: {
              Container: l,
              Label: c,
              Remove: d
            },
            isFocused: k,
            isDisabled: E,
            key: A,
            index: P,
            removeProps: {
              onClick: function onClick() {
                return r.removeValue(w);
              },
              onTouchEnd: function onTouchEnd() {
                return r.removeValue(w);
              },
              onMouseDown: function onMouseDown(Y) {
                Y.preventDefault();
              }
            },
            data: w
          }), r.formatOptionLabel(w, "value"))
        );
      });
      if (b) return null;
      var I = M[0];
      return (
        /* @__PURE__ */
        _(h, $(O({}, g), {
          data: I,
          isDisabled: E,
          children: this.formatOptionLabel(I, "value")
        }))
      );
    }
  }, {
    key: "renderClearIndicator",
    value: function value() {
      var r = this.getComponents(),
          a = r.ClearIndicator,
          o = this.commonProps,
          l = this.props,
          c = l.isDisabled,
          d = l.isLoading,
          h = this.state.isFocused;
      if (!this.isClearable() || !a || c || !this.hasValue() || d) return null;
      var p = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return (
        /* @__PURE__ */
        _(a, $(O({}, o), {
          innerProps: p,
          isFocused: h
        }))
      );
    }
  }, {
    key: "renderLoadingIndicator",
    value: function value() {
      var r = this.getComponents(),
          a = r.LoadingIndicator,
          o = this.commonProps,
          l = this.props,
          c = l.isDisabled,
          d = l.isLoading,
          h = this.state.isFocused;
      if (!a || !d) return null;
      var p = {
        "aria-hidden": "true"
      };
      return (
        /* @__PURE__ */
        _(a, $(O({}, o), {
          innerProps: p,
          isDisabled: c,
          isFocused: h
        }))
      );
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function value() {
      var r = this.getComponents(),
          a = r.DropdownIndicator,
          o = r.IndicatorSeparator;
      if (!a || !o) return null;
      var l = this.commonProps,
          c = this.props.isDisabled,
          d = this.state.isFocused;
      return (
        /* @__PURE__ */
        _(o, $(O({}, l), {
          isDisabled: c,
          isFocused: d
        }))
      );
    }
  }, {
    key: "renderDropdownIndicator",
    value: function value() {
      var r = this.getComponents(),
          a = r.DropdownIndicator;
      if (!a) return null;
      var o = this.commonProps,
          l = this.props.isDisabled,
          c = this.state.isFocused,
          d = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return (
        /* @__PURE__ */
        _(a, $(O({}, o), {
          innerProps: d,
          isDisabled: l,
          isFocused: c
        }))
      );
    }
  }, {
    key: "renderMenu",
    value: function value() {
      var r = this,
          a = this.getComponents(),
          o = a.Group,
          l = a.GroupHeading,
          c = a.Menu,
          d = a.MenuList,
          h = a.MenuPortal,
          p = a.LoadingMessage,
          g = a.NoOptionsMessage,
          f = a.Option,
          v = this.commonProps,
          E = this.state.focusedOption,
          y = this.props,
          b = y.captureMenuScroll,
          C = y.inputValue,
          R = y.isLoading,
          M = y.loadingMessage,
          F = y.minMenuHeight,
          m = y.maxMenuHeight,
          I = y.menuIsOpen,
          w = y.menuPlacement,
          P = y.menuPosition,
          k = y.menuPortalTarget,
          A = y.menuShouldBlockScroll,
          G = y.menuShouldScrollIntoView,
          Y = y.noOptionsMessage,
          W = y.onMenuScrollToTop,
          x = y.onMenuScrollToBottom;
      if (!I) return null;

      var N = function N(V, z) {
        var J = V.type,
            Z = V.data,
            ne = V.isDisabled,
            ie = V.isSelected,
            Pe = V.label,
            ce = V.value,
            pe = E === Z,
            Ze = ne ? void 0 : function () {
          return r.onOptionHover(Z);
        },
            Ot = ne ? void 0 : function () {
          return r.selectOption(Z);
        },
            Pn = "".concat(r.getElementId("option"), "-").concat(z),
            $i = {
          id: Pn,
          onClick: Ot,
          onMouseMove: Ze,
          onMouseOver: Ze,
          tabIndex: -1,
          role: "option",
          "aria-selected": r.isAppleDevice ? void 0 : ie
        };
        return (
          /* @__PURE__ */
          qi(f, $(O({}, v), {
            innerProps: $i,
            data: Z,
            isDisabled: ne,
            isSelected: ie,
            key: Pn,
            label: Pe,
            type: J,
            value: ce,
            isFocused: pe,
            innerRef: pe ? r.getFocusedOptionRef : void 0
          }), r.formatOptionLabel(V.data, "menu"))
        );
      },
          U;

      if (this.hasOptions()) U = this.getCategorizedOptions().map(function (H) {
        if (H.type === "group") {
          var V = H.data,
              z = H.options,
              J = H.index,
              Z = "".concat(r.getElementId("group"), "-").concat(J),
              ne = "".concat(Z, "-heading");
          return (
            /* @__PURE__ */
            qi(o, $(O({}, v), {
              key: Z,
              data: V,
              options: z,
              Heading: l,
              headingProps: {
                id: ne,
                data: H.data
              },
              label: r.formatGroupLabel(H.data)
            }), H.options.map(function (ie) {
              return N(ie, "".concat(J, "-").concat(ie.index));
            }))
          );
        } else if (H.type === "option") return N(H, "".concat(H.index));
      });else if (R) {
        var L = M({
          inputValue: C
        });
        if (L === null) return null;
        U =
        /* @__PURE__ */
        _(p, $(O({}, v), {
          children: L
        }));
      } else {
        var T = Y({
          inputValue: C
        });
        if (T === null) return null;
        U =
        /* @__PURE__ */
        _(g, $(O({}, v), {
          children: T
        }));
      }

      var S = {
        minMenuHeight: F,
        maxMenuHeight: m,
        menuPlacement: w,
        menuPosition: P,
        menuShouldScrollIntoView: G
      },
          D =
      /* @__PURE__ */
      _(aI, $(O(O({}, v), S), {
        children: function children(H) {
          var V = H.ref,
              z = H.placerProps,
              J = z.placement,
              Z = z.maxHeight;
          return (
            /* @__PURE__ */
            _(c, $(O(O({}, v), S), {
              innerRef: V,
              innerProps: {
                onMouseDown: r.onMenuMouseDown,
                onMouseMove: r.onMenuMouseMove
              },
              isLoading: R,
              placement: J,
              children:
              /* @__PURE__ */
              _(x_, {
                captureEnabled: b,
                onTopArrive: W,
                onBottomArrive: x,
                lockEnabled: A,
                children: function children(ne) {
                  return (
                    /* @__PURE__ */
                    _(d, $(O({}, v), {
                      innerRef: function innerRef(Pe) {
                        r.getMenuListRef(Pe), ne(Pe);
                      },
                      innerProps: {
                        role: "listbox",
                        "aria-multiselectable": v.isMulti,
                        id: r.getElementId("listbox")
                      },
                      isLoading: R,
                      maxHeight: Z,
                      focusedOption: E,
                      children: U
                    }))
                  );
                }
              })
            }))
          );
        }
      }));

      return k || P === "fixed" ?
      /* @__PURE__ */
      _(h, $(O({}, v), {
        appendTo: k,
        controlElement: this.controlRef,
        menuPlacement: w,
        menuPosition: P,
        children: D
      })) : D;
    }
  }, {
    key: "renderFormField",
    value: function value() {
      var r = this,
          a = this.props,
          o = a.delimiter,
          l = a.isDisabled,
          c = a.isMulti,
          d = a.name,
          h = a.required,
          p = this.state.selectValue;
      if (h && !this.hasValue() && !l) return (
        /* @__PURE__ */
        _(L_, {
          name: d,
          onFocus: this.onValueInputFocus
        })
      );
      if (!(!d || l)) if (c) {
        if (o) {
          var g = p.map(function (E) {
            return r.getOptionValue(E);
          }).join(o);
          return (
            /* @__PURE__ */
            _("input", {
              name: d,
              type: "hidden",
              value: g
            })
          );
        } else {
          var f = p.length > 0 ? p.map(function (E, y) {
            return (
              /* @__PURE__ */
              _("input", {
                name: d,
                type: "hidden",
                value: r.getOptionValue(E)
              }, "i-".concat(y))
            );
          }) :
          /* @__PURE__ */
          _("input", {
            name: d,
            type: "hidden",
            value: ""
          });
          return (
            /* @__PURE__ */
            _("div", {
              children: f
            })
          );
        }
      } else {
        var v = p[0] ? this.getOptionValue(p[0]) : "";
        return (
          /* @__PURE__ */
          _("input", {
            name: d,
            type: "hidden",
            value: v
          })
        );
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function value() {
      var r = this.commonProps,
          a = this.state,
          o = a.ariaSelection,
          l = a.focusedOption,
          c = a.focusedValue,
          d = a.isFocused,
          h = a.selectValue,
          p = this.getFocusableOptions();
      return (
        /* @__PURE__ */
        _(__, $(O({}, r), {
          id: this.getElementId("live-region"),
          ariaSelection: o,
          focusedOption: l,
          focusedValue: c,
          isFocused: d,
          selectValue: h,
          focusableOptions: p,
          isAppleDevice: this.isAppleDevice
        }))
      );
    }
  }, {
    key: "render",
    value: function value() {
      var r = this.getComponents(),
          a = r.Control,
          o = r.IndicatorsContainer,
          l = r.SelectContainer,
          c = r.ValueContainer,
          d = this.props,
          h = d.className,
          p = d.id,
          g = d.isDisabled,
          f = d.menuIsOpen,
          v = this.state.isFocused,
          E = this.commonProps = this.getCommonProps();
      return (
        /* @__PURE__ */
        j(l, $(O({}, E), {
          className: h,
          innerProps: {
            id: p,
            onKeyDown: this.onKeyDown
          },
          isDisabled: g,
          isFocused: v,
          children: [this.renderLiveRegion(),
          /* @__PURE__ */
          j(a, $(O({}, E), {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: g,
            isFocused: v,
            menuIsOpen: f,
            children: [
            /* @__PURE__ */
            j(c, $(O({}, E), {
              isDisabled: g,
              children: [this.renderPlaceholderOrValue(), this.renderInput()]
            })),
            /* @__PURE__ */
            j(o, $(O({}, E), {
              isDisabled: g,
              children: [this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator()]
            }))]
          })), this.renderMenu(), this.renderFormField()]
        }))
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function value(r, a) {
      var o = a.prevProps,
          l = a.clearFocusValueOnUpdate,
          c = a.inputIsHiddenAfterUpdate,
          d = a.ariaSelection,
          h = a.isFocused,
          p = a.prevWasFocused,
          g = a.instancePrefix,
          f = r.options,
          v = r.value,
          E = r.menuIsOpen,
          y = r.inputValue,
          b = r.isMulti,
          C = Fl(v),
          R = {};

      if (o && (v !== o.value || f !== o.options || E !== o.menuIsOpen || y !== o.inputValue)) {
        var M = E ? Z_(r, C) : [],
            F = E ? ql(Kn(r, C), "".concat(g, "-option")) : [],
            m = l ? eE(a, C) : null,
            I = tE(a, M),
            w = zs(F, I);
        R = {
          selectValue: C,
          focusedOption: I,
          focusedOptionId: w,
          focusableOptionsWithIds: F,
          focusedValue: m,
          clearFocusValueOnUpdate: !1
        };
      }

      var P = c != null && r !== o ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {},
          k = d,
          A = h && p;
      return h && !A && (k = {
        value: $n(b, C, C[0] || null),
        options: C,
        action: "initial-input-focus"
      }, A = !p), (d == null ? void 0 : d.action) === "initial-input-focus" && (k = null), q(q(q({}, R), P), {}, {
        prevProps: r,
        ariaSelection: k,
        prevWasFocused: A
      });
    }
  }]), i;
}(of);

Io.defaultProps = X_;
var nE =
/* @__PURE__ */
Pr(function (t, e) {
  var i = Id(t);
  return (
    /* @__PURE__ */
    _(Io, O({
      ref: e
    }, i))
  );
}),
    rE = nE;

var sE = {
  container: function container(t) {
    return O({}, t);
  },
  control: function control(t) {
    return $(O({}, t), {
      fontSize: "14px",
      borderRadius: "0.25em",
      padding: "2px 6px",
      "&:hover": {
        borderColor: "gray"
      },
      border: "1px solid lightgray",
      textTransform: "capitalize"
    });
  },
  input: function input(t) {
    return $(O({}, t), {
      "input:focus": {
        boxShadow: "none"
      }
    });
  },
  option: function option(t, e) {
    return $(O({}, t), {
      backgroundColor: e.isSelected ? "#0066cc" : "white",
      "&:hover": {
        backgroundColor: e.isSelected ? "#0066cc" : "lightgray"
      },
      textTransform: "capitalize"
    });
  }
},
    Yl = function Yl(t) {
  return {
    id: t,
    value: t,
    label: t
  };
},
    Kl = function Kl(_ref54) {
  var t = _ref54.defaultValue,
      e = _ref54.filterType,
      i = _ref54.filterValues,
      n = _ref54.setFilters,
      r = _ref54.handleResetPosts;

  var _Lt2 = Lt(Ie),
      a = _Lt2.sortSelectPlaceholder,
      o = _Lt2.typeSelectPlaceholder,
      l = i.map(function (d) {
    return Yl(d);
  });

  return (
    /* @__PURE__ */
    j("div", {
      className: "dw-w-full dw-py-2",
      children: [
      /* @__PURE__ */
      _("label", {
        className: "dw-text-sm dw-mb-1",
        children: e === "type" ? "Type" : ""
      }),
      /* @__PURE__ */
      _(rE, {
        onChange: function onChange(d) {
          var h = d.value.toLocaleLowerCase();
          e === "sort" ? n(function (p) {
            return $(O({}, p), {
              sort: h
            });
          }) : e === "type" && n(function (p) {
            return $(O({}, p), {
              type: h
            });
          }), r();
        },
        options: l,
        styles: sE,
        defaultValue: Yl(t),
        placeholder: e === "sort" ? a : o
      })]
    })
  );
};

var uh =
/* @__PURE__ */
function (t) {
  return t.OLDEST = "oldest", t.LATEST = "latest", t.INTERACTED = "interacted", t.POPULAR = "popular", t.REPORTED = "reported", t;
}(uh || {}),
    dh =
/* @__PURE__ */
function (t) {
  return t.ALL = "all", t.PUBLIC = "public", t.PRIVATE = "private", t;
}(dh || {});

var aE = function aE() {
  _classCallCheck(this, aE);

  s(this, "sort", "latest");
  s(this, "type", "all");
  s(this, "moderated", !1);
  s(this, "deleted", !1);
  s(this, "profileIds", []);
  s(this, "discussionIds", []);
  s(this, "limit", 10);
  s(this, "startAfter", "");
};

var Jl = function Jl(_ref55) {
  var t = _ref55.filterType,
      e = _ref55.value,
      i = _ref55.setFilters,
      n = _ref55.handleResetPosts;

  var _Lt3 = Lt(Ie),
      r = _Lt3.moderatedLabelCheckbox,
      a = _Lt3.deletedLabelCheckbox;

  return (
    /* @__PURE__ */
    j("div", {
      className: "dw-flex dw-items-center dw-cursor-pointer",
      onClick: function onClick() {
        t === "isModerated" ? i(function (l) {
          return $(O({}, l), {
            moderated: !e
          });
        }) : t === "isDeleted" && i(function (l) {
          return $(O({}, l), {
            deleted: !e
          });
        }), n();
      },
      children: [
      /* @__PURE__ */
      _("input", {
        type: "checkbox",
        className: "dw-mr-2 focus:dw-outline-none dw-outline-none dw-cursor-pointer",
        checked: e,
        readOnly: !0
      }),
      /* @__PURE__ */
      _("span", {
        className: "dw-text-blueGray-600 dw-select-none",
        children: t === "isModerated" ? r : a
      })]
    })
  );
};

var oE = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];

function lE(t) {
  var e = t.defaultOptions,
      i = e === void 0 ? !1 : e,
      n = t.cacheOptions,
      r = n === void 0 ? !1 : n,
      a = t.loadOptions;
  t.options;
  var o = t.isLoading,
      l = o === void 0 ? !1 : o,
      c = t.onInputChange,
      d = t.filterOption,
      h = d === void 0 ? null : d,
      p = ft(t, oE),
      g = p.inputValue,
      f = Te(void 0),
      v = Te(!1),
      E = K(Array.isArray(i) ? i : void 0),
      y = Oe(E, 2),
      b = y[0],
      C = y[1],
      R = K(typeof g != "undefined" ? g : ""),
      M = Oe(R, 2),
      F = M[0],
      m = M[1],
      I = K(i === !0),
      w = Oe(I, 2),
      P = w[0],
      k = w[1],
      A = K(void 0),
      G = Oe(A, 2),
      Y = G[0],
      W = G[1],
      x = K([]),
      N = Oe(x, 2),
      U = N[0],
      L = N[1],
      T = K(!1),
      S = Oe(T, 2),
      D = S[0],
      H = S[1],
      V = K({}),
      z = Oe(V, 2),
      J = z[0],
      Z = z[1],
      ne = K(void 0),
      ie = Oe(ne, 2),
      Pe = ie[0],
      ce = ie[1],
      pe = K(void 0),
      Ze = Oe(pe, 2),
      Ot = Ze[0],
      Pn = Ze[1];
  r !== Ot && (Z({}), Pn(r)), i !== Pe && (C(Array.isArray(i) ? i : void 0), ce(i)), He(function () {
    return v.current = !0, function () {
      v.current = !1;
    };
  }, []);
  var $i = ke(function (Ui, ci) {
    if (!a) return ci();
    var We = a(Ui, ci);
    We && typeof We.then == "function" && We.then(ci, function () {
      return ci();
    });
  }, [a]);
  He(function () {
    i === !0 && $i(F, function (Ui) {
      !v.current || (C(Ui || []), k(!!f.current));
    });
  }, []);
  var Jp = ke(function (Ui, ci) {
    var We = W0(Ui, ci, c);

    if (!We) {
      f.current = void 0, m(""), W(""), L([]), k(!1), H(!1);
      return;
    }

    if (r && J[We]) m(We), W(We), L(J[We]), k(!1), H(!1);else {
      var Zp = f.current = {};
      m(We), k(!0), H(!Y), $i(We, function (Is) {
        !v || Zp === f.current && (f.current = void 0, k(!1), W(We), L(Is || []), H(!1), Z(Is ? q(q({}, J), {}, mi({}, We, Is)) : J));
      });
    }
  }, [r, $i, Y, J, c]),
      Xp = D ? [] : F && Y ? U : b || [];
  return q(q({}, p), {}, {
    options: Xp,
    isLoading: P || l,
    onInputChange: Jp,
    filterOption: h
  });
}

var cE =
/* @__PURE__ */
Pr(function (t, e) {
  var i = lE(t),
      n = Id(i);
  return (
    /* @__PURE__ */
    _(Io, O({
      ref: e
    }, n))
  );
}),
    hh = cE,
    uE = {
  exports: {}
};

(function (t) {
  var e = function (i) {
    var n = Object.prototype,
        r = n.hasOwnProperty,
        a = Object.defineProperty || function (T, S, D) {
      T[S] = D.value;
    },
        o,
        l = typeof Symbol == "function" ? Symbol : {},
        c = l.iterator || "@@iterator",
        d = l.asyncIterator || "@@asyncIterator",
        h = l.toStringTag || "@@toStringTag";

    function p(T, S, D) {
      return Object.defineProperty(T, S, {
        value: D,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), T[S];
    }

    try {
      p({}, "");
    } catch (T) {
      p = function p(S, D, H) {
        return S[D] = H;
      };
    }

    function g(T, S, D, H) {
      var V = S && S.prototype instanceof R ? S : R,
          z = Object.create(V.prototype),
          J = new N(H || []);
      return a(z, "_invoke", {
        value: G(T, D, J)
      }), z;
    }

    i.wrap = g;

    function f(T, S, D) {
      try {
        return {
          type: "normal",
          arg: T.call(S, D)
        };
      } catch (H) {
        return {
          type: "throw",
          arg: H
        };
      }
    }

    var v = "suspendedStart",
        E = "suspendedYield",
        y = "executing",
        b = "completed",
        C = {};

    function R() {}

    function M() {}

    function F() {}

    var m = {};
    p(m, c, function () {
      return this;
    });
    var I = Object.getPrototypeOf,
        w = I && I(I(U([])));
    w && w !== n && r.call(w, c) && (m = w);
    var P = F.prototype = R.prototype = Object.create(m);
    M.prototype = F, a(P, "constructor", {
      value: F,
      configurable: !0
    }), a(F, "constructor", {
      value: M,
      configurable: !0
    }), M.displayName = p(F, h, "GeneratorFunction");

    function k(T) {
      ["next", "throw", "return"].forEach(function (S) {
        p(T, S, function (D) {
          return this._invoke(S, D);
        });
      });
    }

    i.isGeneratorFunction = function (T) {
      var S = typeof T == "function" && T.constructor;
      return S ? S === M || (S.displayName || S.name) === "GeneratorFunction" : !1;
    }, i.mark = function (T) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(T, F) : (T.__proto__ = F, p(T, h, "GeneratorFunction")), T.prototype = Object.create(P), T;
    }, i.awrap = function (T) {
      return {
        __await: T
      };
    };

    function A(T, S) {
      function D(z, J, Z, ne) {
        var ie = f(T[z], T, J);
        if (ie.type === "throw") ne(ie.arg);else {
          var Pe = ie.arg,
              ce = Pe.value;
          return ce && typeof ce == "object" && r.call(ce, "__await") ? S.resolve(ce.__await).then(function (pe) {
            D("next", pe, Z, ne);
          }, function (pe) {
            D("throw", pe, Z, ne);
          }) : S.resolve(ce).then(function (pe) {
            Pe.value = pe, Z(Pe);
          }, function (pe) {
            return D("throw", pe, Z, ne);
          });
        }
      }

      var H;

      function V(z, J) {
        function Z() {
          return new S(function (ne, ie) {
            D(z, J, ne, ie);
          });
        }

        return H = H ? H.then(Z, Z) : Z();
      }

      a(this, "_invoke", {
        value: V
      });
    }

    k(A.prototype), p(A.prototype, d, function () {
      return this;
    }), i.AsyncIterator = A, i.async = function (T, S, D, H, V) {
      V === void 0 && (V = Promise);
      var z = new A(g(T, S, D, H), V);
      return i.isGeneratorFunction(S) ? z : z.next().then(function (J) {
        return J.done ? J.value : z.next();
      });
    };

    function G(T, S, D) {
      var H = v;
      return function (z, J) {
        if (H === y) throw new Error("Generator is already running");

        if (H === b) {
          if (z === "throw") throw J;
          return L();
        }

        for (D.method = z, D.arg = J;;) {
          var Z = D.delegate;

          if (Z) {
            var ne = Y(Z, D);

            if (ne) {
              if (ne === C) continue;
              return ne;
            }
          }

          if (D.method === "next") D.sent = D._sent = D.arg;else if (D.method === "throw") {
            if (H === v) throw H = b, D.arg;
            D.dispatchException(D.arg);
          } else D.method === "return" && D.abrupt("return", D.arg);
          H = y;
          var ie = f(T, S, D);

          if (ie.type === "normal") {
            if (H = D.done ? b : E, ie.arg === C) continue;
            return {
              value: ie.arg,
              done: D.done
            };
          } else ie.type === "throw" && (H = b, D.method = "throw", D.arg = ie.arg);
        }
      };
    }

    function Y(T, S) {
      var D = S.method,
          H = T.iterator[D];
      if (H === o) return S.delegate = null, D === "throw" && T.iterator.return && (S.method = "return", S.arg = o, Y(T, S), S.method === "throw") || D !== "return" && (S.method = "throw", S.arg = new TypeError("The iterator does not provide a '" + D + "' method")), C;
      var V = f(H, T.iterator, S.arg);
      if (V.type === "throw") return S.method = "throw", S.arg = V.arg, S.delegate = null, C;
      var z = V.arg;
      if (!z) return S.method = "throw", S.arg = new TypeError("iterator result is not an object"), S.delegate = null, C;
      if (z.done) S[T.resultName] = z.value, S.next = T.nextLoc, S.method !== "return" && (S.method = "next", S.arg = o);else return z;
      return S.delegate = null, C;
    }

    k(P), p(P, h, "Generator"), p(P, c, function () {
      return this;
    }), p(P, "toString", function () {
      return "[object Generator]";
    });

    function W(T) {
      var S = {
        tryLoc: T[0]
      };
      1 in T && (S.catchLoc = T[1]), 2 in T && (S.finallyLoc = T[2], S.afterLoc = T[3]), this.tryEntries.push(S);
    }

    function x(T) {
      var S = T.completion || {};
      S.type = "normal", delete S.arg, T.completion = S;
    }

    function N(T) {
      this.tryEntries = [{
        tryLoc: "root"
      }], T.forEach(W, this), this.reset(!0);
    }

    i.keys = function (T) {
      var S = Object(T),
          D = [];

      for (var H in S) {
        D.push(H);
      }

      return D.reverse(), function V() {
        for (; D.length;) {
          var z = D.pop();
          if (z in S) return V.value = z, V.done = !1, V;
        }

        return V.done = !0, V;
      };
    };

    function U(T) {
      if (T) {
        var S = T[c];
        if (S) return S.call(T);
        if (typeof T.next == "function") return T;

        if (!isNaN(T.length)) {
          var D = -1,
              H = function V() {
            for (; ++D < T.length;) {
              if (r.call(T, D)) return V.value = T[D], V.done = !1, V;
            }

            return V.value = o, V.done = !0, V;
          };

          return H.next = H;
        }
      }

      return {
        next: L
      };
    }

    i.values = U;

    function L() {
      return {
        value: o,
        done: !0
      };
    }

    return N.prototype = {
      constructor: N,
      reset: function reset(T) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = o, this.done = !1, this.delegate = null, this.method = "next", this.arg = o, this.tryEntries.forEach(x), !T) for (var S in this) {
          S.charAt(0) === "t" && r.call(this, S) && !isNaN(+S.slice(1)) && (this[S] = o);
        }
      },
      stop: function stop() {
        this.done = !0;
        var T = this.tryEntries[0],
            S = T.completion;
        if (S.type === "throw") throw S.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(T) {
        if (this.done) throw T;
        var S = this;

        function D(ne, ie) {
          return z.type = "throw", z.arg = T, S.next = ne, ie && (S.method = "next", S.arg = o), !!ie;
        }

        for (var H = this.tryEntries.length - 1; H >= 0; --H) {
          var V = this.tryEntries[H],
              z = V.completion;
          if (V.tryLoc === "root") return D("end");

          if (V.tryLoc <= this.prev) {
            var J = r.call(V, "catchLoc"),
                Z = r.call(V, "finallyLoc");

            if (J && Z) {
              if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
              if (this.prev < V.finallyLoc) return D(V.finallyLoc);
            } else if (J) {
              if (this.prev < V.catchLoc) return D(V.catchLoc, !0);
            } else if (Z) {
              if (this.prev < V.finallyLoc) return D(V.finallyLoc);
            } else throw new Error("try statement without catch or finally");
          }
        }
      },
      abrupt: function abrupt(T, S) {
        for (var D = this.tryEntries.length - 1; D >= 0; --D) {
          var H = this.tryEntries[D];

          if (H.tryLoc <= this.prev && r.call(H, "finallyLoc") && this.prev < H.finallyLoc) {
            var V = H;
            break;
          }
        }

        V && (T === "break" || T === "continue") && V.tryLoc <= S && S <= V.finallyLoc && (V = null);
        var z = V ? V.completion : {};
        return z.type = T, z.arg = S, V ? (this.method = "next", this.next = V.finallyLoc, C) : this.complete(z);
      },
      complete: function complete(T, S) {
        if (T.type === "throw") throw T.arg;
        return T.type === "break" || T.type === "continue" ? this.next = T.arg : T.type === "return" ? (this.rval = this.arg = T.arg, this.method = "return", this.next = "end") : T.type === "normal" && S && (this.next = S), C;
      },
      finish: function finish(T) {
        for (var S = this.tryEntries.length - 1; S >= 0; --S) {
          var D = this.tryEntries[S];
          if (D.finallyLoc === T) return this.complete(D.completion, D.afterLoc), x(D), C;
        }
      },
      catch: function _catch(T) {
        for (var S = this.tryEntries.length - 1; S >= 0; --S) {
          var D = this.tryEntries[S];

          if (D.tryLoc === T) {
            var H = D.completion;

            if (H.type === "throw") {
              var V = H.arg;
              x(D);
            }

            return V;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(T, S, D) {
        return this.delegate = {
          iterator: U(T),
          resultName: S,
          nextLoc: D
        }, this.method === "next" && (this.arg = o), C;
      }
    }, i;
  }(t.exports);

  try {
    regeneratorRuntime = e;
  } catch (i) {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
})(uE);

var hi = function hi() {
  return u(void 0, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee224() {
    var t;
    return _regeneratorRuntime.wrap(function _callee224$(_context224) {
      while (1) {
        switch (_context224.prev = _context224.next) {
          case 0:
            t = gt.auth().currentUser;

            if (!t) {
              _context224.next = 5;
              break;
            }

            _context224.next = 4;
            return t.getIdToken();

          case 4:
            return _context224.abrupt("return", _context224.sent);

          case 5:
          case "end":
            return _context224.stop();
        }
      }
    }, _callee224);
  }));
};

var dE = typeof Ki == "object" && Ki && Ki.Object === Object && Ki,
    hE = dE,
    pE = hE,
    fE = typeof self == "object" && self && self.Object === Object && self,
    mE = pE || fE || Function("return this")(),
    ph = mE,
    gE = ph,
    yE = gE.Symbol,
    _o = yE;

function vE(t, e) {
  for (var i = -1, n = t == null ? 0 : t.length, r = Array(n); ++i < n;) {
    r[i] = e(t[i], i, t);
  }

  return r;
}

var wE = vE,
    bE = Array.isArray,
    IE = bE,
    Xl = _o,
    fh = Object.prototype,
    _E = fh.hasOwnProperty,
    EE = fh.toString,
    Gi = Xl ? Xl.toStringTag : void 0;

function CE(t) {
  var e = _E.call(t, Gi),
      i = t[Gi];

  try {
    t[Gi] = void 0;
    var n = !0;
  } catch (a) {}

  var r = EE.call(t);
  return n && (e ? t[Gi] = i : delete t[Gi]), r;
}

var SE = CE,
    TE = Object.prototype,
    RE = TE.toString;

function PE(t) {
  return RE.call(t);
}

var OE = PE,
    Zl = _o,
    AE = SE,
    ME = OE,
    FE = "[object Null]",
    kE = "[object Undefined]",
    ec = Zl ? Zl.toStringTag : void 0;

function xE(t) {
  return t == null ? t === void 0 ? kE : FE : ec && ec in Object(t) ? AE(t) : ME(t);
}

var DE = xE;

function NE(t) {
  return t != null && typeof t == "object";
}

var LE = NE,
    $E = DE,
    UE = LE,
    BE = "[object Symbol]";

function HE(t) {
  return typeof t == "symbol" || UE(t) && $E(t) == BE;
}

var mh = HE,
    tc = _o,
    VE = wE,
    jE = IE,
    WE = mh,
    GE = 1 / 0,
    ic = tc ? tc.prototype : void 0,
    nc = ic ? ic.toString : void 0;

function gh(t) {
  if (typeof t == "string") return t;
  if (jE(t)) return VE(t, gh) + "";
  if (WE(t)) return nc ? nc.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -GE ? "-0" : e;
}

var zE = gh,
    qE = zE;

function QE(t) {
  return t == null ? "" : qE(t);
}

var rs = QE;

function YE(t, e, i) {
  var n = -1,
      r = t.length;
  e < 0 && (e = -e > r ? 0 : r + e), i = i > r ? r : i, i < 0 && (i += r), r = e > i ? 0 : i - e >>> 0, e >>>= 0;

  for (var a = Array(r); ++n < r;) {
    a[n] = t[n + e];
  }

  return a;
}

var KE = YE,
    JE = KE;

function XE(t, e, i) {
  var n = t.length;
  return i = i === void 0 ? n : i, !e && i >= n ? t : JE(t, e, i);
}

var ZE = XE,
    eC = "\\ud800-\\udfff",
    tC = "\\u0300-\\u036f",
    iC = "\\ufe20-\\ufe2f",
    nC = "\\u20d0-\\u20ff",
    rC = tC + iC + nC,
    sC = "\\ufe0e\\ufe0f",
    aC = "\\u200d",
    oC = RegExp("[" + aC + eC + rC + sC + "]");

function lC(t) {
  return oC.test(t);
}

var yh = lC;

function cC(t) {
  return t.split("");
}

var uC = cC,
    vh = "\\ud800-\\udfff",
    dC = "\\u0300-\\u036f",
    hC = "\\ufe20-\\ufe2f",
    pC = "\\u20d0-\\u20ff",
    fC = dC + hC + pC,
    mC = "\\ufe0e\\ufe0f",
    gC = "[" + vh + "]",
    Ia = "[" + fC + "]",
    _a = "\\ud83c[\\udffb-\\udfff]",
    yC = "(?:" + Ia + "|" + _a + ")",
    wh = "[^" + vh + "]",
    bh = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    Ih = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    vC = "\\u200d",
    _h = yC + "?",
    Eh = "[" + mC + "]?",
    wC = "(?:" + vC + "(?:" + [wh, bh, Ih].join("|") + ")" + Eh + _h + ")*",
    bC = Eh + _h + wC,
    IC = "(?:" + [wh + Ia + "?", Ia, bh, Ih, gC].join("|") + ")",
    _C = RegExp(_a + "(?=" + _a + ")|" + IC + bC, "g");

function EC(t) {
  return t.match(_C) || [];
}

var CC = EC,
    SC = uC,
    TC = yh,
    RC = CC;

function PC(t) {
  return TC(t) ? RC(t) : SC(t);
}

var OC = PC,
    AC = ZE,
    MC = yh,
    FC = OC,
    kC = rs;

function xC(t) {
  return function (e) {
    e = kC(e);
    var i = MC(e) ? FC(e) : void 0,
        n = i ? i[0] : e.charAt(0),
        r = i ? AC(i, 1).join("") : e.slice(1);
    return n[t]() + r;
  };
}

var DC = xC,
    NC = DC,
    LC = NC("toUpperCase"),
    $C = LC,
    UC = rs,
    BC = $C;

function HC(t) {
  return BC(UC(t).toLowerCase());
}

var VC = HC;

function jC(t, e, i, n) {
  var r = -1,
      a = t == null ? 0 : t.length;

  for (n && a && (i = t[++r]); ++r < a;) {
    i = e(i, t[r], r, t);
  }

  return i;
}

var WC = jC;

function GC(t) {
  return function (e) {
    return t == null ? void 0 : t[e];
  };
}

var zC = GC,
    qC = zC,
    QC = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
},
    YC = qC(QC),
    KC = YC,
    JC = KC,
    XC = rs,
    ZC = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
    eS = "\\u0300-\\u036f",
    tS = "\\ufe20-\\ufe2f",
    iS = "\\u20d0-\\u20ff",
    nS = eS + tS + iS,
    rS = "[" + nS + "]",
    sS = RegExp(rS, "g");

function aS(t) {
  return t = XC(t), t && t.replace(ZC, JC).replace(sS, "");
}

var oS = aS,
    lS = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

function cS(t) {
  return t.match(lS) || [];
}

var uS = cS,
    dS = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

function hS(t) {
  return dS.test(t);
}

var pS = hS,
    Ch = "\\ud800-\\udfff",
    fS = "\\u0300-\\u036f",
    mS = "\\ufe20-\\ufe2f",
    gS = "\\u20d0-\\u20ff",
    yS = fS + mS + gS,
    Sh = "\\u2700-\\u27bf",
    Th = "a-z\\xdf-\\xf6\\xf8-\\xff",
    vS = "\\xac\\xb1\\xd7\\xf7",
    wS = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",
    bS = "\\u2000-\\u206f",
    IS = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    Rh = "A-Z\\xc0-\\xd6\\xd8-\\xde",
    _S = "\\ufe0e\\ufe0f",
    Ph = vS + wS + bS + IS,
    Oh = "['\u2019]",
    rc = "[" + Ph + "]",
    ES = "[" + yS + "]",
    Ah = "\\d+",
    CS = "[" + Sh + "]",
    Mh = "[" + Th + "]",
    Fh = "[^" + Ch + Ph + Ah + Sh + Th + Rh + "]",
    SS = "\\ud83c[\\udffb-\\udfff]",
    TS = "(?:" + ES + "|" + SS + ")",
    RS = "[^" + Ch + "]",
    kh = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    xh = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    pi = "[" + Rh + "]",
    PS = "\\u200d",
    sc = "(?:" + Mh + "|" + Fh + ")",
    OS = "(?:" + pi + "|" + Fh + ")",
    ac = "(?:" + Oh + "(?:d|ll|m|re|s|t|ve))?",
    oc = "(?:" + Oh + "(?:D|LL|M|RE|S|T|VE))?",
    Dh = TS + "?",
    Nh = "[" + _S + "]?",
    AS = "(?:" + PS + "(?:" + [RS, kh, xh].join("|") + ")" + Nh + Dh + ")*",
    MS = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
    FS = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
    kS = Nh + Dh + AS,
    xS = "(?:" + [CS, kh, xh].join("|") + ")" + kS,
    DS = RegExp([pi + "?" + Mh + "+" + ac + "(?=" + [rc, pi, "$"].join("|") + ")", OS + "+" + oc + "(?=" + [rc, pi + sc, "$"].join("|") + ")", pi + "?" + sc + "+" + ac, pi + "+" + oc, FS, MS, Ah, xS].join("|"), "g");

function NS(t) {
  return t.match(DS) || [];
}

var LS = NS,
    $S = uS,
    US = pS,
    BS = rs,
    HS = LS;

function VS(t, e, i) {
  return t = BS(t), e = i ? void 0 : e, e === void 0 ? US(t) ? HS(t) : $S(t) : t.match(e) || [];
}

var jS = VS,
    WS = WC,
    GS = oS,
    zS = jS,
    qS = "['\u2019]",
    QS = RegExp(qS, "g");

function YS(t) {
  return function (e) {
    return WS(zS(GS(e).replace(QS, "")), t, "");
  };
}

var Lh = YS,
    KS = VC,
    JS = Lh,
    XS = JS(function (t, e, i) {
  return e = e.toLowerCase(), t + (i ? KS(e) : e);
}),
    ZS = XS,
    eT = Lh,
    tT = eT(function (t, e, i) {
  return t + (i ? "_" : "") + e.toLowerCase();
}),
    iT = tT;

var nT = function nT(t, e, i, n) {
  return {
    apiKey: t,
    clientId: e,
    lang: i || "en",
    environment: n || "prod",
    idSchema: "native",
    errorHandlingMode: "standard",
    authProvider: {
      getIdToken: function getIdToken() {
        return "";
      },
      logout: function logout() {}
    }
  };
},
    rT = function rT(t) {
  var i = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"),
      n = decodeURIComponent(window.atob(i).split("").map(function (r) {
    return "%" + ("00" + r.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
  return JSON.parse(n);
},
    Jn = function Jn(t, e) {
  if (Array.isArray(t)) return t.map(function (i) {
    return Jn(i, e);
  });

  if (t != null && t.constructor === Object) {
    if (e === "camel") return Object.keys(t).reduce(function (i, n) {
      return $(O({}, i), _defineProperty({}, ZS(n), Jn(t[n], e)));
    }, {});
    if (e === "snake") return Object.keys(t).reduce(function (i, n) {
      return $(O({}, i), _defineProperty({}, iT(n), Jn(t[n], e)));
    }, {});
  }

  return t;
},
    sT = function sT(t) {
  return t === "dev" ? "http://localhost:8070/v1" : t === "staging" ? "https://client.fansunitedstagingapi.com/v1" : t === "watg" ? "https://client.watg.fansunitedapi.com/v1" : "https://client.fansunitedapi.com/v1";
},
    aT = function aT(t) {
  return t === "dev" ? "http://localhost:9020/v1" : t === "staging" ? "https://discussions.fansunitedstagingapi.com/v1" : t === "watg" ? "https://discussions.watg.fansunitedapi.com/v1" : "https://discussions.fansunitedapi.com/v1";
},
    oT = function oT(t) {
  return t === "dev" ? "http://localhost:8010/v1" : t === "staging" ? "https://profile.fansunitedstagingapi.com/v1" : t === "watg" ? "https://profile.watg.fansunitedapi.com/v1" : "https://profile.fansunitedapi.com/v1";
};

var lT = function lT(e) {
  var _this77 = this;

  _classCallCheck(this, lT);

  s(this, "apiKey", null);
  s(this, "clientId", null);
  s(this, "clientBaseURL", null);
  s(this, "profileBaseURL", null);
  s(this, "discussionsBaseURL", null);
  s(this, "headers", null);
  s(this, "getDiscussionsFeature", function () {
    return u(_this77, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee225() {
      return _regeneratorRuntime.wrap(function _callee225$(_context225) {
        while (1) {
          switch (_context225.prev = _context225.next) {
            case 0:
              _context225.next = 2;
              return fetch(this.clientBaseURL + new URLSearchParams({
                key: this.apiKey,
                disable_cache: Date.now().toString()
              }), {
                headers: this.headers
              });

            case 2:
              _context225.next = 4;
              return _context225.sent.json();

            case 4:
              return _context225.abrupt("return", _context225.sent);

            case 5:
            case "end":
              return _context225.stop();
          }
        }
      }, _callee225, this);
    }));
  });
  s(this, "updateDiscussionsFeature", function (e) {
    return u(_this77, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee226() {
      var i;
      return _regeneratorRuntime.wrap(function _callee226$(_context226) {
        while (1) {
          switch (_context226.prev = _context226.next) {
            case 0:
              _context226.next = 2;
              return hi();

            case 2:
              i = _context226.sent;
              _context226.next = 5;
              return fetch(this.clientBaseURL + new URLSearchParams({
                key: this.apiKey
              }), {
                headers: $(O({}, this.headers), {
                  Authorization: "Bearer " + i
                }),
                method: "PATCH",
                body: JSON.stringify(e)
              });

            case 5:
              _context226.next = 7;
              return _context226.sent.json();

            case 7:
              return _context226.abrupt("return", _context226.sent);

            case 8:
            case "end":
              return _context226.stop();
          }
        }
      }, _callee226, this);
    }));
  });
  s(this, "banUser", function (e, i) {
    return u(_this77, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee227() {
      var n, r;
      return _regeneratorRuntime.wrap(function _callee227$(_context227) {
        while (1) {
          switch (_context227.prev = _context227.next) {
            case 0:
              n = "/discussions/users/".concat(e, "/ban?");
              _context227.next = 3;
              return hi();

            case 3:
              r = _context227.sent;
              _context227.next = 6;
              return fetch(this.discussionsBaseURL + n + new URLSearchParams({
                key: this.apiKey,
                client_id: this.clientId
              }), {
                headers: $(O({}, this.headers), {
                  Authorization: "Bearer " + r
                }),
                method: "POST",
                body: JSON.stringify(i)
              });

            case 6:
            case "end":
              return _context227.stop();
          }
        }
      }, _callee227, this);
    }));
  });
  s(this, "moderateUser", function (e, i) {
    return u(_this77, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee228() {
      var n, r;
      return _regeneratorRuntime.wrap(function _callee228$(_context228) {
        while (1) {
          switch (_context228.prev = _context228.next) {
            case 0:
              n = "/moderation/bulk?";
              _context228.next = 3;
              return hi();

            case 3:
              r = _context228.sent;
              _context228.next = 6;
              return fetch(this.discussionsBaseURL + n + new URLSearchParams({
                key: this.apiKey,
                client_id: this.clientId,
                user_id: e,
                reason: i
              }), {
                headers: $(O({}, this.headers), {
                  Authorization: "Bearer " + r
                }),
                method: "POST"
              });

            case 6:
            case "end":
              return _context228.stop();
          }
        }
      }, _callee228, this);
    }));
  });
  s(this, "getAllPosts", function (e, i) {
    return u(_this77, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee229() {
      var n, r, a, o, _l4, c, _d3, h;

      return _regeneratorRuntime.wrap(function _callee229$(_context229) {
        while (1) {
          switch (_context229.prev = _context229.next) {
            case 0:
              n = "/posts/staff?";
              this.clearEmptyFields(e);
              r = this.constructQueryParams(e, i);
              _context229.next = 5;
              return hi();

            case 5:
              a = _context229.sent;
              _context229.next = 8;
              return fetch(this.discussionsBaseURL + n + r, {
                headers: $(O({}, this.headers), {
                  Authorization: "Bearer " + a
                })
              });

            case 8:
              o = _context229.sent;

              if (!o.ok) {
                _context229.next = 26;
                break;
              }

              _context229.next = 12;
              return o.json();

            case 12:
              _l4 = _context229.sent;
              c = Array.from(new Set(_l4.data.map(function (h) {
                return h.user_id;
              })));
              _d3 = null;
              _context229.t0 = c.length;

              if (!_context229.t0) {
                _context229.next = 20;
                break;
              }

              _context229.next = 19;
              return fetch(this.profileBaseURL + new URLSearchParams({
                key: this.apiKey,
                client_id: this.clientId,
                profile_ids: c.join(",")
              }), {
                headers: this.headers
              });

            case 19:
              _d3 = _context229.sent;

            case 20:
              if (!(_d3 && _d3.ok)) {
                _context229.next = 25;
                break;
              }

              _context229.next = 23;
              return _d3.json();

            case 23:
              h = _context229.sent;
              return _context229.abrupt("return", (_l4.data = _l4.data.map(function (p) {
                return p.user_model = h.data.find(function (g) {
                  return g.id === p.user_id;
                }), p;
              }), _l4));

            case 25:
              return _context229.abrupt("return", _l4);

            case 26:
              _context229.next = 28;
              return o.json();

            case 28:
              return _context229.abrupt("return", _context229.sent);

            case 29:
            case "end":
              return _context229.stop();
          }
        }
      }, _callee229, this);
    }));
  });
  s(this, "moderatePosts", function (e, i) {
    return u(_this77, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee230() {
      var n, r;
      return _regeneratorRuntime.wrap(function _callee230$(_context230) {
        while (1) {
          switch (_context230.prev = _context230.next) {
            case 0:
              n = "/moderation/bulk?";
              _context230.next = 3;
              return hi();

            case 3:
              r = _context230.sent;
              _context230.next = 6;
              return fetch(this.discussionsBaseURL + n + new URLSearchParams({
                key: this.apiKey,
                client_id: this.clientId,
                post_ids: e.join(","),
                reason: i
              }), {
                headers: $(O({}, this.headers), {
                  Authorization: "Bearer " + r
                }),
                method: "POST"
              });

            case 6:
            case "end":
              return _context230.stop();
          }
        }
      }, _callee230, this);
    }));
  });
  s(this, "getDiscussions", function (e) {
    return u(_this77, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee231() {
      var i;
      return _regeneratorRuntime.wrap(function _callee231$(_context231) {
        while (1) {
          switch (_context231.prev = _context231.next) {
            case 0:
              i = "/discussions?";
              _context231.next = 3;
              return fetch(this.discussionsBaseURL + i + new URLSearchParams({
                key: this.apiKey,
                client_id: this.clientId,
                label: e,
                disable_cache: "".concat(Date.now())
              }), {
                headers: this.headers
              });

            case 3:
              _context231.next = 5;
              return _context231.sent.json();

            case 5:
              return _context231.abrupt("return", _context231.sent);

            case 6:
            case "end":
              return _context231.stop();
          }
        }
      }, _callee231, this);
    }));
  });
  s(this, "constructQueryParams", function (e, i) {
    var n = {
      key: _this77.apiKey,
      client_id: _this77.clientId
    };
    return i && (n = $(O({}, n), {
      start_after: i
    })), new URLSearchParams(e ? O(O({}, n), Jn(e, "snake")) : n);
  });
  s(this, "clearEmptyFields", function (e) {
    e && Object.keys(e).length > 0 && Object.keys(e).forEach(function (i) {
      (!e[i] || e[i].length == 0) && delete e[i];
    });
  });
  this.apiKey = e.apiKey, this.clientId = e.clientId;
  var i = "/clients/".concat(this.clientId, "/features/discussions?"),
      n = "/profiles?";
  this.clientBaseURL = sT(e.environment) + i, this.profileBaseURL = oT(e.environment) + n, this.discussionsBaseURL = aT(e.environment), this.headers = {
    "Content-Type": "application/json"
  };
};

var cT = Object.create,
    Eo = Object.defineProperty,
    uT = Object.getOwnPropertyDescriptor,
    dT = Object.getOwnPropertyNames,
    hT = Object.getPrototypeOf,
    pT = Object.prototype.hasOwnProperty,
    fT = function fT(t, e, i) {
  return e in t ? Eo(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : t[e] = i;
},
    ss = function ss(t, e) {
  return function () {
    return e || t((e = {
      exports: {}
    }).exports, e), e.exports;
  };
},
    mT = function mT(t, e, i, n) {
  if (e && typeof e == "object" || typeof e == "function") {
    var _iteratorNormalCompletion14 = true;
    var _didIteratorError14 = false;
    var _iteratorError14 = undefined;

    try {
      var _loop4 = function _loop4() {
        var r = _step14.value;
        !pT.call(t, r) && r !== i && Eo(t, r, {
          get: function get() {
            return e[r];
          },
          enumerable: !(n = uT(e, r)) || n.enumerable
        });
      };

      for (var _iterator14 = dT(e)[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
        _loop4();
      }
    } catch (err) {
      _didIteratorError14 = true;
      _iteratorError14 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
          _iterator14.return();
        }
      } finally {
        if (_didIteratorError14) {
          throw _iteratorError14;
        }
      }
    }
  }

  return t;
},
    gT = function gT(t, e, i) {
  return i = t != null ? cT(hT(t)) : {}, mT(e || !t || !t.__esModule ? Eo(i, "default", {
    value: t,
    enumerable: !0
  }) : i, t);
},
    lc = function lc(t, e, i) {
  return fT(t, typeof e != "symbol" ? e + "" : e, i), i;
},
    yT = ss(function (t, e) {
  var i = function () {
    function n(f, v) {
      return v != null && f instanceof v;
    }

    var r;

    try {
      r = Map;
    } catch (f) {
      r = function r() {};
    }

    var a;

    try {
      a = Set;
    } catch (f) {
      a = function a() {};
    }

    var o;

    try {
      o = Promise;
    } catch (f) {
      o = function o() {};
    }

    function l(f, v, E, y, b) {
      typeof v == "object" && (E = v.depth, y = v.prototype, b = v.includeNonEnumerable, v = v.circular);
      var C = [],
          R = [],
          M = typeof Buffer < "u";
      typeof v > "u" && (v = !0), typeof E > "u" && (E = 1 / 0);

      function F(m, I) {
        if (m === null) return null;
        if (I === 0) return m;
        var w, P;
        if (typeof m != "object") return m;
        if (n(m, r)) w = new r();else if (n(m, a)) w = new a();else if (n(m, o)) w = new o(function (L, T) {
          m.then(function (S) {
            L(F(S, I - 1));
          }, function (S) {
            T(F(S, I - 1));
          });
        });else if (l.__isArray(m)) w = [];else if (l.__isRegExp(m)) w = new RegExp(m.source, g(m)), m.lastIndex && (w.lastIndex = m.lastIndex);else if (l.__isDate(m)) w = new Date(m.getTime());else {
          if (M && Buffer.isBuffer(m)) return Buffer.allocUnsafe ? w = Buffer.allocUnsafe(m.length) : w = new Buffer(m.length), m.copy(w), w;
          n(m, Error) ? w = Object.create(m) : typeof y > "u" ? (P = Object.getPrototypeOf(m), w = Object.create(P)) : (w = Object.create(y), P = y);
        }

        if (v) {
          var k = C.indexOf(m);
          if (k != -1) return R[k];
          C.push(m), R.push(w);
        }

        n(m, r) && m.forEach(function (L, T) {
          var S = F(T, I - 1),
              D = F(L, I - 1);
          w.set(S, D);
        }), n(m, a) && m.forEach(function (L) {
          var T = F(L, I - 1);
          w.add(T);
        });

        for (var A in m) {
          var G;
          P && (G = Object.getOwnPropertyDescriptor(P, A)), !(G && G.set == null) && (w[A] = F(m[A], I - 1));
        }

        if (Object.getOwnPropertySymbols) for (var Y = Object.getOwnPropertySymbols(m), A = 0; A < Y.length; A++) {
          var W = Y[A],
              x = Object.getOwnPropertyDescriptor(m, W);
          x && !x.enumerable && !b || (w[W] = F(m[W], I - 1), x.enumerable || Object.defineProperty(w, W, {
            enumerable: !1
          }));
        }
        if (b) for (var N = Object.getOwnPropertyNames(m), A = 0; A < N.length; A++) {
          var U = N[A],
              x = Object.getOwnPropertyDescriptor(m, U);
          x && x.enumerable || (w[U] = F(m[U], I - 1), Object.defineProperty(w, U, {
            enumerable: !1
          }));
        }
        return w;
      }

      return F(f, E);
    }

    l.clonePrototype = function (f) {
      if (f === null) return null;

      var v = function v() {};

      return v.prototype = f, new v();
    };

    function c(f) {
      return Object.prototype.toString.call(f);
    }

    l.__objToStr = c;

    function d(f) {
      return typeof f == "object" && c(f) === "[object Date]";
    }

    l.__isDate = d;

    function h(f) {
      return typeof f == "object" && c(f) === "[object Array]";
    }

    l.__isArray = h;

    function p(f) {
      return typeof f == "object" && c(f) === "[object RegExp]";
    }

    l.__isRegExp = p;

    function g(f) {
      var v = "";
      return f.global && (v += "g"), f.ignoreCase && (v += "i"), f.multiline && (v += "m"), v;
    }

    return l.__getRegExpFlags = g, l;
  }();

  typeof e == "object" && e.exports && (e.exports = i);
}),
    vT = ss(function (t, e) {
  var i = typeof Reflect == "object" ? Reflect : null,
      n = i && typeof i.apply == "function" ? i.apply : function (m, I, w) {
    return Function.prototype.apply.call(m, I, w);
  },
      r;
  i && typeof i.ownKeys == "function" ? r = i.ownKeys : Object.getOwnPropertySymbols ? r = function r(m) {
    return Object.getOwnPropertyNames(m).concat(Object.getOwnPropertySymbols(m));
  } : r = function r(m) {
    return Object.getOwnPropertyNames(m);
  };

  function a(m) {
    console && console.warn && console.warn(m);
  }

  var o = Number.isNaN || function (m) {
    return m !== m;
  };

  function l() {
    l.init.call(this);
  }

  e.exports = l, e.exports.once = R, l.EventEmitter = l, l.prototype._events = void 0, l.prototype._eventsCount = 0, l.prototype._maxListeners = void 0;
  var c = 10;

  function d(m) {
    if (typeof m != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof m);
  }

  Object.defineProperty(l, "defaultMaxListeners", {
    enumerable: !0,
    get: function get() {
      return c;
    },
    set: function set(m) {
      if (typeof m != "number" || m < 0 || o(m)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + m + ".");
      c = m;
    }
  }), l.init = function () {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events =
    /* @__PURE__ */
    Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, l.prototype.setMaxListeners = function (m) {
    if (typeof m != "number" || m < 0 || o(m)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + m + ".");
    return this._maxListeners = m, this;
  };

  function h(m) {
    return m._maxListeners === void 0 ? l.defaultMaxListeners : m._maxListeners;
  }

  l.prototype.getMaxListeners = function () {
    return h(this);
  }, l.prototype.emit = function (m) {
    for (var I = [], w = 1; w < arguments.length; w++) {
      I.push(arguments[w]);
    }

    var P = m === "error",
        k = this._events;
    if (k !== void 0) P = P && k.error === void 0;else if (!P) return !1;

    if (P) {
      var A;
      if (I.length > 0 && (A = I[0]), A instanceof Error) throw A;
      var G = new Error("Unhandled error." + (A ? " (" + A.message + ")" : ""));
      throw G.context = A, G;
    }

    var Y = k[m];
    if (Y === void 0) return !1;
    if (typeof Y == "function") n(Y, this, I);else for (var W = Y.length, x = y(Y, W), w = 0; w < W; ++w) {
      n(x[w], this, I);
    }
    return !0;
  };

  function p(m, I, w, P) {
    var k, A, G;
    if (d(w), A = m._events, A === void 0 ? (A = m._events =
    /* @__PURE__ */
    Object.create(null), m._eventsCount = 0) : (A.newListener !== void 0 && (m.emit("newListener", I, w.listener ? w.listener : w), A = m._events), G = A[I]), G === void 0) G = A[I] = w, ++m._eventsCount;else if (typeof G == "function" ? G = A[I] = P ? [w, G] : [G, w] : P ? G.unshift(w) : G.push(w), k = h(m), k > 0 && G.length > k && !G.warned) {
      G.warned = !0;
      var Y = new Error("Possible EventEmitter memory leak detected. " + G.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Y.name = "MaxListenersExceededWarning", Y.emitter = m, Y.type = I, Y.count = G.length, a(Y);
    }
    return m;
  }

  l.prototype.addListener = function (m, I) {
    return p(this, m, I, !1);
  }, l.prototype.on = l.prototype.addListener, l.prototype.prependListener = function (m, I) {
    return p(this, m, I, !0);
  };

  function g() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }

  function f(m, I, w) {
    var P = {
      fired: !1,
      wrapFn: void 0,
      target: m,
      type: I,
      listener: w
    },
        k = g.bind(P);
    return k.listener = w, P.wrapFn = k, k;
  }

  l.prototype.once = function (m, I) {
    return d(I), this.on(m, f(this, m, I)), this;
  }, l.prototype.prependOnceListener = function (m, I) {
    return d(I), this.prependListener(m, f(this, m, I)), this;
  }, l.prototype.removeListener = function (m, I) {
    var w, P, k, A, G;
    if (d(I), P = this._events, P === void 0) return this;
    if (w = P[m], w === void 0) return this;
    if (w === I || w.listener === I) --this._eventsCount === 0 ? this._events =
    /* @__PURE__ */
    Object.create(null) : (delete P[m], P.removeListener && this.emit("removeListener", m, w.listener || I));else if (typeof w != "function") {
      for (k = -1, A = w.length - 1; A >= 0; A--) {
        if (w[A] === I || w[A].listener === I) {
          G = w[A].listener, k = A;
          break;
        }
      }

      if (k < 0) return this;
      k === 0 ? w.shift() : b(w, k), w.length === 1 && (P[m] = w[0]), P.removeListener !== void 0 && this.emit("removeListener", m, G || I);
    }
    return this;
  }, l.prototype.off = l.prototype.removeListener, l.prototype.removeAllListeners = function (m) {
    var I, w, P;
    if (w = this._events, w === void 0) return this;
    if (w.removeListener === void 0) return arguments.length === 0 ? (this._events =
    /* @__PURE__ */
    Object.create(null), this._eventsCount = 0) : w[m] !== void 0 && (--this._eventsCount === 0 ? this._events =
    /* @__PURE__ */
    Object.create(null) : delete w[m]), this;

    if (arguments.length === 0) {
      var k = Object.keys(w),
          A;

      for (P = 0; P < k.length; ++P) {
        A = k[P], A !== "removeListener" && this.removeAllListeners(A);
      }

      return this.removeAllListeners("removeListener"), this._events =
      /* @__PURE__ */
      Object.create(null), this._eventsCount = 0, this;
    }

    if (I = w[m], typeof I == "function") this.removeListener(m, I);else if (I !== void 0) for (P = I.length - 1; P >= 0; P--) {
      this.removeListener(m, I[P]);
    }
    return this;
  };

  function v(m, I, w) {
    var P = m._events;
    if (P === void 0) return [];
    var k = P[I];
    return k === void 0 ? [] : typeof k == "function" ? w ? [k.listener || k] : [k] : w ? C(k) : y(k, k.length);
  }

  l.prototype.listeners = function (m) {
    return v(this, m, !0);
  }, l.prototype.rawListeners = function (m) {
    return v(this, m, !1);
  }, l.listenerCount = function (m, I) {
    return typeof m.listenerCount == "function" ? m.listenerCount(I) : E.call(m, I);
  }, l.prototype.listenerCount = E;

  function E(m) {
    var I = this._events;

    if (I !== void 0) {
      var w = I[m];
      if (typeof w == "function") return 1;
      if (w !== void 0) return w.length;
    }

    return 0;
  }

  l.prototype.eventNames = function () {
    return this._eventsCount > 0 ? r(this._events) : [];
  };

  function y(m, I) {
    for (var w = new Array(I), P = 0; P < I; ++P) {
      w[P] = m[P];
    }

    return w;
  }

  function b(m, I) {
    for (; I + 1 < m.length; I++) {
      m[I] = m[I + 1];
    }

    m.pop();
  }

  function C(m) {
    for (var I = new Array(m.length), w = 0; w < I.length; ++w) {
      I[w] = m[w].listener || m[w];
    }

    return I;
  }

  function R(m, I) {
    return new Promise(function (w, P) {
      function k(G) {
        m.removeListener(I, A), P(G);
      }

      function A() {
        typeof m.removeListener == "function" && m.removeListener("error", k), w([].slice.call(arguments));
      }

      F(m, I, A, {
        once: !0
      }), I !== "error" && M(m, k, {
        once: !0
      });
    });
  }

  function M(m, I, w) {
    typeof m.on == "function" && F(m, "error", I, w);
  }

  function F(m, I, w, P) {
    if (typeof m.on == "function") P.once ? m.once(I, w) : m.on(I, w);else if (typeof m.addEventListener == "function") m.addEventListener(I, function k(A) {
      P.once && m.removeEventListener(I, k), w(A);
    });else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof m);
  }
}),
    wT = ss(function (t, e) {
  (function () {
    var i,
        n,
        r = [].splice,
        a = function a(l, c) {
      if (!(l instanceof c)) throw new Error("Bound instance method accessed before binding");
    },
        o = [].indexOf;

    n = yT(), i = vT().EventEmitter, e.exports = function () {
      var l =
      /*#__PURE__*/
      function (_i20) {
        _inherits(l, _i20);

        function l() {
          var _this78;

          var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, l);

          _this78 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this)), _this78.get = _this78.get.bind(_assertThisInitialized(_this78)), _this78.mget = _this78.mget.bind(_assertThisInitialized(_this78)), _this78.set = _this78.set.bind(_assertThisInitialized(_this78)), _this78.mset = _this78.mset.bind(_assertThisInitialized(_this78)), _this78.del = _this78.del.bind(_assertThisInitialized(_this78)), _this78.take = _this78.take.bind(_assertThisInitialized(_this78)), _this78.ttl = _this78.ttl.bind(_assertThisInitialized(_this78)), _this78.getTtl = _this78.getTtl.bind(_assertThisInitialized(_this78)), _this78.keys = _this78.keys.bind(_assertThisInitialized(_this78)), _this78.has = _this78.has.bind(_assertThisInitialized(_this78)), _this78.getStats = _this78.getStats.bind(_assertThisInitialized(_this78)), _this78.flushAll = _this78.flushAll.bind(_assertThisInitialized(_this78)), _this78.flushStats = _this78.flushStats.bind(_assertThisInitialized(_this78)), _this78.close = _this78.close.bind(_assertThisInitialized(_this78)), _this78._checkData = _this78._checkData.bind(_assertThisInitialized(_this78)), _this78._check = _this78._check.bind(_assertThisInitialized(_this78)), _this78._isInvalidKey = _this78._isInvalidKey.bind(_assertThisInitialized(_this78)), _this78._wrap = _this78._wrap.bind(_assertThisInitialized(_this78)), _this78._getValLength = _this78._getValLength.bind(_assertThisInitialized(_this78)), _this78._error = _this78._error.bind(_assertThisInitialized(_this78)), _this78._initErrors = _this78._initErrors.bind(_assertThisInitialized(_this78)), _this78.options = d, _this78._initErrors(), _this78.data = {}, _this78.options = Object.assign({
            forceString: !1,
            objectValueSize: 80,
            promiseValueSize: 80,
            arrayValueSize: 40,
            stdTTL: 0,
            checkperiod: 600,
            useClones: !0,
            deleteOnExpire: !0,
            enableLegacyCallbacks: !1,
            maxKeys: -1
          }, _this78.options), _this78.options.enableLegacyCallbacks && (console.warn("WARNING! node-cache legacy callback support will drop in v6.x"), ["get", "mget", "set", "del", "ttl", "getTtl", "keys", "has"].forEach(function (h) {
            var p;
            p = _this78[h], _this78[h] = function () {
              var _E2, _E3, _r$call, _r$call2;

              for (var _len19 = arguments.length, g = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
                g[_key19] = arguments[_key19];
              }

              var f, v, E, y;
              if (E = g, (_E2 = E, _E3 = _toArray(_E2), g = _E3.slice(0), _E2), (_r$call = r.call(g, -1), _r$call2 = _slicedToArray(_r$call, 1), f = _r$call2[0], _r$call), typeof f == "function") try {
                y = p.apply(void 0, _toConsumableArray(g)), f(null, y);
              } catch (b) {
                v = b, f(v);
              } else return p.apply(void 0, _toConsumableArray(g).concat([f]));
            };
          })), _this78.stats = {
            hits: 0,
            misses: 0,
            keys: 0,
            ksize: 0,
            vsize: 0
          }, _this78.validKeyTypes = ["string", "number"], _this78._checkData();
          return _this78;
        }

        _createClass(l, [{
          key: "get",
          value: function get(d) {
            var h, p;
            if (a(this, l), (p = this._isInvalidKey(d)) != null) throw p;
            if (this.data[d] != null && this._check(d, this.data[d])) return this.stats.hits++, h = this._unwrap(this.data[d]), h;
            this.stats.misses++;
          }
        }, {
          key: "mget",
          value: function mget(d) {
            var h, p, g, f, v, E;
            if (a(this, l), !Array.isArray(d)) throw h = this._error("EKEYSTYPE"), h;

            for (E = {}, g = 0, v = d.length; g < v; g++) {
              if (f = d[g], (p = this._isInvalidKey(f)) != null) throw p;
              this.data[f] != null && this._check(f, this.data[f]) ? (this.stats.hits++, E[f] = this._unwrap(this.data[f])) : this.stats.misses++;
            }

            return E;
          }
        }, {
          key: "set",
          value: function set(d, h, p) {
            var g, f, v;
            if (a(this, l), this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) throw g = this._error("ECACHEFULL"), g;
            if (this.options.forceString && !typeof h === "string" && (h = JSON.stringify(h)), p == null && (p = this.options.stdTTL), (f = this._isInvalidKey(d)) != null) throw f;
            return v = !1, this.data[d] && (v = !0, this.stats.vsize -= this._getValLength(this._unwrap(this.data[d], !1))), this.data[d] = this._wrap(h, p), this.stats.vsize += this._getValLength(h), v || (this.stats.ksize += this._getKeyLength(d), this.stats.keys++), this.emit("set", d, h), !0;
          }
        }, {
          key: "mset",
          value: function mset(d) {
            var h, p, g, f, v, E, y, b, C, R;
            if (a(this, l), this.options.maxKeys > -1 && this.stats.keys + d.length >= this.options.maxKeys) throw h = this._error("ECACHEFULL"), h;

            for (g = 0, y = d.length; g < y; g++) {
              var _E4;

              if (E = d[g], (_E4 = E, v = _E4.key, R = _E4.val, C = _E4.ttl, _E4), C && typeof C != "number") throw h = this._error("ETTLTYPE"), h;
              if ((p = this._isInvalidKey(v)) != null) throw p;
            }

            for (f = 0, b = d.length; f < b; f++) {
              var _E5;

              E = d[f], (_E5 = E, v = _E5.key, R = _E5.val, C = _E5.ttl, _E5), this.set(v, R, C);
            }

            return !0;
          }
        }, {
          key: "del",
          value: function del(d) {
            var h, p, g, f, v, E;

            for (a(this, l), Array.isArray(d) || (d = [d]), h = 0, g = 0, v = d.length; g < v; g++) {
              if (f = d[g], (p = this._isInvalidKey(f)) != null) throw p;
              this.data[f] != null && (this.stats.vsize -= this._getValLength(this._unwrap(this.data[f], !1)), this.stats.ksize -= this._getKeyLength(f), this.stats.keys--, h++, E = this.data[f], delete this.data[f], this.emit("del", f, E.v));
            }

            return h;
          }
        }, {
          key: "take",
          value: function take(d) {
            var h;
            return a(this, l), h = this.get(d), h != null && this.del(d), h;
          }
        }, {
          key: "ttl",
          value: function ttl(d, h) {
            var p;
            if (a(this, l), h || (h = this.options.stdTTL), !d) return !1;
            if ((p = this._isInvalidKey(d)) != null) throw p;
            return this.data[d] != null && this._check(d, this.data[d]) ? (h >= 0 ? this.data[d] = this._wrap(this.data[d].v, h, !1) : this.del(d), !0) : !1;
          }
        }, {
          key: "getTtl",
          value: function getTtl(d) {
            var h, p;

            if (a(this, l), !!d) {
              if ((p = this._isInvalidKey(d)) != null) throw p;
              if (this.data[d] != null && this._check(d, this.data[d])) return h = this.data[d].t, h;
            }
          }
        }, {
          key: "keys",
          value: function keys() {
            var d;
            return a(this, l), d = Object.keys(this.data), d;
          }
        }, {
          key: "has",
          value: function has(d) {
            var h;
            return a(this, l), h = this.data[d] != null && this._check(d, this.data[d]), h;
          }
        }, {
          key: "getStats",
          value: function getStats() {
            return a(this, l), this.stats;
          }
        }, {
          key: "flushAll",
          value: function flushAll() {
            var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            a(this, l), this.data = {}, this.stats = {
              hits: 0,
              misses: 0,
              keys: 0,
              ksize: 0,
              vsize: 0
            }, this._killCheckPeriod(), this._checkData(d), this.emit("flush");
          }
        }, {
          key: "flushStats",
          value: function flushStats() {
            a(this, l), this.stats = {
              hits: 0,
              misses: 0,
              keys: 0,
              ksize: 0,
              vsize: 0
            }, this.emit("flush_stats");
          }
        }, {
          key: "close",
          value: function close() {
            a(this, l), this._killCheckPeriod();
          }
        }, {
          key: "_checkData",
          value: function _checkData() {
            var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
            var h, p, g;
            a(this, l), p = this.data;

            for (h in p) {
              g = p[h], this._check(h, g);
            }

            d && this.options.checkperiod > 0 && (this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1e3, d), this.checkTimeout != null && this.checkTimeout.unref != null && this.checkTimeout.unref());
          }
        }, {
          key: "_killCheckPeriod",
          value: function _killCheckPeriod() {
            if (this.checkTimeout != null) return clearTimeout(this.checkTimeout);
          }
        }, {
          key: "_check",
          value: function _check(d, h) {
            var p;
            return a(this, l), p = !0, h.t !== 0 && h.t < Date.now() && (this.options.deleteOnExpire && (p = !1, this.del(d)), this.emit("expired", d, this._unwrap(h))), p;
          }
        }, {
          key: "_isInvalidKey",
          value: function _isInvalidKey(d) {
            var h;
            if (a(this, l), h = typeof d, o.call(this.validKeyTypes, h) < 0) return this._error("EKEYTYPE", {
              type: typeof d
            });
          }
        }, {
          key: "_wrap",
          value: function _wrap(d, h) {
            var p = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
            var g, f, v;
            return a(this, l), this.options.useClones || (p = !1), f = Date.now(), g = 0, v = 1e3, h === 0 ? g = 0 : h ? g = f + h * v : this.options.stdTTL === 0 ? g = this.options.stdTTL : g = f + this.options.stdTTL * v, {
              t: g,
              v: p ? n(d) : d
            };
          }
        }, {
          key: "_unwrap",
          value: function _unwrap(d) {
            var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            return this.options.useClones || (h = !1), d.v != null ? h ? n(d.v) : d.v : null;
          }
        }, {
          key: "_getKeyLength",
          value: function _getKeyLength(d) {
            return d.toString().length;
          }
        }, {
          key: "_getValLength",
          value: function _getValLength(d) {
            return a(this, l), typeof d == "string" ? d.length : this.options.forceString ? JSON.stringify(d).length : Array.isArray(d) ? this.options.arrayValueSize * d.length : typeof d == "number" ? 8 : typeof (d == null ? void 0 : d.then) == "function" ? this.options.promiseValueSize : typeof Buffer < "u" && Buffer !== null && Buffer.isBuffer(d) ? d.length : d != null && typeof d == "object" ? this.options.objectValueSize * Object.keys(d).length : typeof d == "boolean" ? 8 : 0;
          }
        }, {
          key: "_error",
          value: function _error(d) {
            var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var p;
            return a(this, l), p = new Error(), p.name = d, p.errorcode = d, p.message = this.ERRORS[d] != null ? this.ERRORS[d](h) : "-", p.data = h, p;
          }
        }, {
          key: "_initErrors",
          value: function _initErrors() {
            var d, h, p;
            a(this, l), this.ERRORS = {}, p = this._ERRORS;

            for (h in p) {
              d = p[h], this.ERRORS[h] = this.createErrorMessage(d);
            }
          }
        }, {
          key: "createErrorMessage",
          value: function createErrorMessage(d) {
            return function (h) {
              return d.replace("__key", h.type);
            };
          }
        }]);

        return l;
      }(i);

      return l.prototype._ERRORS = {
        ENOTFOUND: "Key `__key` not found",
        ECACHEFULL: "Cache max keys amount exceeded",
        EKEYTYPE: "The key argument has to be of type `string` or `number`. Found: `__key`",
        EKEYSTYPE: "The keys argument has to be an array.",
        ETTLTYPE: "The ttl argument has to be a number."
      }, l;
    }.call(this);
  }).call(t);
}),
    bT = ss(function (t, e) {
  (function () {
    var i;
    i = e.exports = wT(), i.version = "5.1.2";
  }).call(t);
}),
    cc = function cc(t) {
  var e = 200,
      i = [],
      n = 0;
  return i[n] = [], t.forEach(function (r) {
    i[n].length <= e - 1 ? i[n].push(r) : (n++, i[n] = [r]);
  }), i;
},
    Xn = function Xn(t, e) {
  var i = [];

  for (; t.length > e;) {
    var n = t.splice(0, e);
    i.push(n);
  }

  return i.push(t), i;
},
    Ct = function Ct(t, e) {
  var i = "";
  return t === "prod" ? i = {
    profile: "https://profile.fansunitedapi.com/v1",
    football: "https://football.fansunitedapi.com/v1",
    idMapping: "https://id-mapping.fansunitedapi.com/v1",
    predictor: "https://prediction.fansunitedapi.com/v1",
    client: "https://client.fansunitedapi.com/v1",
    loyalty: "https://loyalty.fansunitedapi.com/v1",
    miniGames: "https://mini-games.fansunitedapi.com/v1",
    discussions: "https://discussions.fansunitedapi.com/v1"
  }[e] : t === "dev" ? i = {
    profile: "http://localhost:8010/v1",
    football: "http://localhost:8080/v1",
    idMapping: "http://localhost:8030/v1",
    predictor: "http://localhost:8040/v1",
    client: "http://localhost:8070/v1",
    loyalty: "http://localhost:8060/v1",
    miniGames: "http://localhost:9040/v1",
    discussions: "http://localhost:9020/v1"
  }[e] : t === "watg" ? i = {
    profile: "https://profile.watg.fansunitedapi.com/v1",
    football: "https://football.watg.fansunitedapi.com/v1",
    idMapping: "https://id-mapping.watg.fansunitedapi.com/v1",
    predictor: "https://prediction.watg.fansunitedapi.com/v1",
    client: "https://client.watg.fansunitedapi.com/v1",
    loyalty: "https://loyalty.watg.fansunitedapi.com/v1",
    miniGames: "https://mini-games.watg.fansunitedapi.com/v1",
    discussions: "https://discussions.watg.fansunitedapi.com/v1"
  }[e] : i = {
    profile: "https://profile.fansunitedstagingapi.com/v1",
    football: "https://football.fansunitedstagingapi.com/v1",
    idMapping: "https://id-mapping.fansunitedstagingapi.com/v1",
    predictor: "https://prediction.fansunitedstagingapi.com/v1",
    client: "https://client.fansunitedstagingapi.com/v1",
    loyalty: "https://loyalty.fansunitedstagingapi.com/v1",
    miniGames: "https://mini-games.fansunitedstagingapi.com/v1",
    discussions: "https://discussions.fansunitedstagingapi.com/v1"
  }[e], i;
},
    as = function as(t) {
  return t.filter(function (e, i, n) {
    return i === n.indexOf(e);
  });
},
    Ee = function Ee(t) {
  return t || !1;
},
    Ce = function Ce() {
  return "&disable_cache=".concat(Date.now());
},
    $h = function $h(t) {
  return JSON.parse(JSON.stringify(t.sort(function (e, i) {
    return e.localeCompare(i);
  })));
},
    IT = function IT() {
  _classCallCheck(this, IT);

  s(this, "id", null);
  s(this, "name", null);
  s(this, "nickname", null);
  s(this, "avatar", null);
  s(this, "gender", null);
  s(this, "country", null);
  s(this, "birthDate", null);
  s(this, "interests", []);
  s(this, "followingCount", 0);
  s(this, "followersCount", 0);
},
    _T = function _T() {
  var _this79 = this;

  _classCallCheck(this, _T);

  s(this, "profilesFromResponse", function (t) {
    return t ? t.map(function (e) {
      return _this79.fullProfileFromResponse(e);
    }) : null;
  });
  s(this, "fullProfileFromResponse", function (t) {
    var e = new IT();
    return e.id = t.id, e.name = t.name, e.nickname = t.nickname, e.avatar = t.avatar, e.gender = t.gender, e.country = t.country, e.birthDate = t.birth_date, e.interests = t.interests ? t.interests : [], e.followingCount = t.following_count, e.followersCount = t.followers_count, e;
  });
},
    Uh = function Uh() {
  _classCallCheck(this, Uh);

  s(this, "nextPageStartsAfter", null);
  s(this, "itemsPerPage", null);
},
    os = function os() {
  _classCallCheck(this, os);

  s(this, "pagination", new Uh());
},
    qe = function qe() {
  _classCallCheck(this, qe);

  s(this, "meta", new os());
  s(this, "data", []);
},
    ET = function ET() {
  _classCallCheck(this, ET);

  s(this, "avatar", null);
  s(this, "followingId", null);
  s(this, "name", null);
  s(this, "nickname", null);
  s(this, "profileId", null);
},
    CT = function CT() {
  var _this80 = this;

  _classCallCheck(this, CT);

  s(this, "followResponse", function (t) {
    return t.map(function (e) {
      return _this80.remapResponse(e);
    });
  });
  s(this, "followingFromResponse", function (t) {
    var e = new qe();
    return e.meta.pagination.nextPageStartsAfter = t.meta.pagination.next_page_starts_after, e.meta.pagination.itemsPerPage = t.meta.pagination.items_per_page, e.data = t.data.map(function (i) {
      return _this80.remapResponse(i);
    }), e;
  });
  s(this, "remapResponse", function (t) {
    var e = new ET();
    return e.avatar = t.avatar, e.followingId = t.following_id, e.name = t.name, e.profileId = t.profile_id, e.nickname = t.nickname, e;
  });
},
    ST = function ST() {
  _classCallCheck(this, ST);

  s(this, "avatar", null);
  s(this, "followerId", null);
  s(this, "name", null);
  s(this, "nickname", null);
  s(this, "profileId", null);
},
    TT = function TT() {
  var _this81 = this;

  _classCallCheck(this, TT);

  s(this, "followersFromResponse", function (t) {
    var e = new qe();
    return e.meta.pagination.nextPageStartsAfter = t.meta.pagination.next_page_starts_after, e.meta.pagination.itemsPerPage = t.meta.pagination.items_per_page, e.data = t.data.map(function (i) {
      return _this81.remapResponse(i);
    }), e;
  });
  s(this, "remapResponse", function (t) {
    var e = new ST();
    return e.avatar = t.avatar, e.followerId = t.follower_id, e.name = t.name, e.profileId = t.profile_id, e;
  });
},
    uc = function uc() {
  _classCallCheck(this, uc);

  s(this, "profile_ids", []);
};

function Ea(t) {
  this.message = t;
}

Ea.prototype = new Error(), Ea.prototype.name = "InvalidCharacterError";

var dc = typeof window < "u" && window.atob && window.atob.bind(window) || function (t) {
  var e = String(t).replace(/=+$/, "");
  if (e.length % 4 == 1) throw new Ea("'atob' failed: The string to be decoded is not correctly encoded.");

  for (var i, n, r = 0, a = 0, o = ""; n = e.charAt(a++); ~n && (i = r % 4 ? 64 * i + n : n, r++ % 4) ? o += String.fromCharCode(255 & i >> (-2 * r & 6)) : 0) {
    n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  }

  return o;
};

function RT(t) {
  var e = t.replace(/-/g, "+").replace(/_/g, "/");

  switch (e.length % 4) {
    case 0:
      break;

    case 2:
      e += "==";
      break;

    case 3:
      e += "=";
      break;

    default:
      throw "Illegal base64url string!";
  }

  try {
    return function (i) {
      return decodeURIComponent(dc(i).replace(/(.)/g, function (n, r) {
        var a = r.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      }));
    }(e);
  } catch (i) {
    return dc(e);
  }
}

function br(t) {
  this.message = t;
}

function PT(t, e) {
  if (typeof t != "string") throw new br("Invalid token specified");
  var i = (e = e || {}).header === !0 ? 0 : 1;

  try {
    return JSON.parse(RT(t.split(".")[i]));
  } catch (n) {
    throw new br("Invalid token specified: " + n.message);
  }
}

br.prototype = new Error(), br.prototype.name = "InvalidTokenError";

var OT = PT,
    Ue = {
  native: "id",
  sportradar: "sportradar_id",
  sportal365: "sportal365_id",
  enetpulse: "enetpulse_id",
  api_football: "api_football_id"
},
    hc = {
  PREDICTOR_USER_RELATED_OPERATION: "https://docs.fansunitedmedia.com/docs/predictor-operations#user-related-operations"
},
    pc = ["matchId", "matchType", "market", "prediction"],
    AT =
/* @__PURE__ */
new Map().set("FT_1X2", "fullTimeOneXTwo").set("HT_1X2", "halfTimeOneXTwo").set("BOTH_TEAMS_SCORE", "bothTeamsScore").set("DOUBLE_CHANCE", "doubleChance").set("HT_FT", "halfTimeFullTime").set("PLAYER_SCORE", "playerScore").set("PLAYER_YELLOW_CARD", "playerYellowCard").set("PLAYER_RED_CARD", "playerRedCard").set("RED_CARD_MATCH", "redCardMatch").set("PENALTY_MATCH", "penaltyMatch").set("PLAYER_SCORE_FIRST_GOAL", "playerScoreFirstGoal").set("CORNERS_MATCH", "cornersMatch").set("CORRECT_SCORE", "correctScore").set("CORRECT_SCORE_ADVANCED", "correctScoreAdvanced").set("CORRECT_SCORE_HT", "correctScoreHalfTime").set("PLAYER_SCORE_HATTRICK", "playerScoreHattrick").set("PLAYER_SCORE_TWICE", "playerScoreTwice").set("OVER_GOALS_0_5", "overZeroPointFiveGoals").set("OVER_GOALS_1_5", "overOnePointFiveGoals").set("OVER_GOALS_2_5", "overTwoPointFiveGoals").set("OVER_GOALS_3_5", "overThreePointFiveGoals").set("OVER_GOALS_4_5", "overFourPointFiveGoals").set("OVER_GOALS_5_5", "overFivePointFiveGoals").set("OVER_GOALS_6_5", "overSixPointFiveGoals").set("OVER_CORNERS_6_5", "overSixPointFiveCorners").set("OVER_CORNERS_7_5", "overSevenPointFiveCorners").set("OVER_CORNERS_8_5", "overEightPointFiveCorners").set("OVER_CORNERS_9_5", "overNinePointFiveCorners").set("OVER_CORNERS_10_5", "overTenPointFiveCorners").set("OVER_CORNERS_11_5", "overElevenPointFiveCorners").set("OVER_CORNERS_12_5", "overTwelvePointFiveCorners").set("OVER_CORNERS_13_5", "overThirteenPointFiveCorners"),
    fc = {
  UNEXPECTED_STATUS_PROP: "Unexpected provided property 'status'. You can NOT use this property for this method. For more information visit our documentation: \n ".concat(hc.PREDICTOR_USER_RELATED_OPERATION),
  UNEXPECTED_TYPE_PROP: "Unexpected provided property 'type'. You can NOT use this property for this method. For more information visit our documentation: \n ".concat(hc.PREDICTOR_USER_RELATED_OPERATION)
},
    MT = function MT(t, e) {
  return "The prediction '".concat(t, "' is invalid for market '").concat(e, "'. Please check again have you passed appropriate prediction model. For more information please visit our documentation: https://docs.fansunitedmedia.com/sdks/js/match.quiz#gamerelatedoperations");
},
    Bh = function Bh(t) {
  return "The market '".concat(t, "' is not supported from Fans United. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/predictor-operations#make-football-prediction");
},
    FT = function FT(t) {
  return "The market '".concat(t, "' is not valid for Top X game. The only available market is CORRECT_SCORE.");
},
    kT = function kT(t) {
  return "The field/s '".concat(t.length > 1 ? t.join(", ") : t[0], "' is/are invalid. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/javascript-sdk");
},
    xT = function xT(t, e) {
  return "The following field/s is/are missing from ".concat(t, ": '").concat(e.length > 1 ? e.join(", ") : e[0], "'. For more information please visit our documentation: https://docs.fansunitedmedia.com/docs/predictor-operations#make-football-prediction");
},
    DT = function DT(t, e) {
  return "The field ".concat(t, " has incorrect type. The correct type is ").concat(e);
},
    Un = function Un(t, e) {
  var _this82 = this;

  _classCallCheck(this, Un);

  s(this, "data", {
    error: {
      code: 0,
      status: "",
      message: ""
    }
  });
  s(this, "status", 0);
  s(this, "statusText", "");
  s(this, "headers", null);
  s(this, "errorMessage", function () {
    return _this82.data.error.message;
  });
  this.data.error.code = e.code, this.data.error.status = e.status, this.data.error.message = e.message, this.status = t.status, this.statusText = t.statusText, this.headers = t.headers;
},
    ue = function ue(t, e, i) {
  _classCallCheck(this, ue);

  s(this, "error", {
    code: 0,
    status: "",
    message: ""
  });
  this.error.code = t, this.error.status = e, this.error.message = i;
},
    St = function St(t, e) {
  var _this83 = this;

  _classCallCheck(this, St);

  s(this, "baseUrl", null);
  s(this, "apiSignInUrl", null);
  s(this, "jwtToken", null);
  s(this, "idSchema", null);
  s(this, "retryRequest", !1);
  s(this, "headers", null);
  s(this, "authHeaders", null);
  s(this, "errorHandlingMode", null);
  s(this, "fetchWithoutAuth", function (t, e) {
    return u(_this83, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee232() {
      var i, n, _r15;

      return _regeneratorRuntime.wrap(function _callee232$(_context232) {
        while (1) {
          switch (_context232.prev = _context232.next) {
            case 0:
              _context232.next = 2;
              return fetch(this.baseUrl + t, {
                headers: this.headers
              });

            case 2:
              i = _context232.sent;
              _context232.next = 5;
              return i.json();

            case 5:
              n = _context232.sent;

              if (i.ok) {
                _context232.next = 9;
                break;
              }

              _r15 = this.transformFetchException(i, n);
              throw console.warn(e, _r15), _r15;

            case 9:
              return _context232.abrupt("return", n);

            case 10:
            case "end":
              return _context232.stop();
          }
        }
      }, _callee232, this);
    }));
  });
  s(this, "fetchWithAuth", function (t, e, i, n) {
    return u(_this83, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee233() {
      var r, a, o;
      return _regeneratorRuntime.wrap(function _callee233$(_context233) {
        while (1) {
          switch (_context233.prev = _context233.next) {
            case 0:
              this.validateJWTToken();
              r = null, a = null;

              if (!(i && n)) {
                _context233.next = 8;
                break;
              }

              _context233.next = 5;
              return fetch(this.baseUrl + t, {
                method: i,
                headers: this.authHeaders,
                body: JSON.stringify(n)
              });

            case 5:
              r = _context233.sent;
              _context233.next = 17;
              break;

            case 8:
              if (!(i && !n)) {
                _context233.next = 14;
                break;
              }

              _context233.next = 11;
              return fetch(this.baseUrl + t, {
                method: i,
                headers: this.authHeaders
              });

            case 11:
              r = _context233.sent;
              _context233.next = 17;
              break;

            case 14:
              _context233.next = 16;
              return fetch(this.baseUrl + t, {
                headers: this.authHeaders
              });

            case 16:
              r = _context233.sent;

            case 17:
              _context233.t0 = i !== "DELETE";

              if (!_context233.t0) {
                _context233.next = 22;
                break;
              }

              _context233.next = 21;
              return r.json();

            case 21:
              a = _context233.sent;

            case 22:
              if (r.ok) {
                _context233.next = 39;
                break;
              }

              _context233.t1 = (r.status === 401 || r.status === 403) && !this.retryRequest;

              if (!_context233.t1) {
                _context233.next = 28;
                break;
              }

              this.retryRequest = !0;
              _context233.next = 28;
              return this.fetchWithAuth(t, e, i, n);

            case 28:
              this.retryRequest = !1;
              _context233.t2 = this;
              _context233.t3 = r;
              _context233.t4 = a;

              if (_context233.t4) {
                _context233.next = 36;
                break;
              }

              _context233.next = 35;
              return r.json();

            case 35:
              _context233.t4 = _context233.sent;

            case 36:
              _context233.t5 = _context233.t4;
              o = _context233.t2.transformFetchException.call(_context233.t2, _context233.t3, _context233.t5);
              throw console.warn(e, o), o;

            case 39:
              return _context233.abrupt("return", (this.retryRequest = !1, a));

            case 40:
            case "end":
              return _context233.stop();
          }
        }
      }, _callee233, this);
    }));
  });
  s(this, "transformFetchException", function (t, e) {
    if (!e && t.status === 401) {
      if (_this83.errorHandlingMode === "standard") return new ue(401, "unauthorized", "Invalid JWT token is provided");
      var a = {
        code: 401,
        status: "unauthorized",
        message: "Invalid JWT token is provided"
      };
      return new Un(t, a);
    }

    var _e$error = e.error,
        i = _e$error.code,
        n = _e$error.status,
        r = _e$error.message;
    return _this83.errorHandlingMode === "standard" ? new ue(i, n, r) : new Un(t, e.error);
  });
  s(this, "validateJWTToken", function () {
    var t = null;

    try {
      t = OT(_this83.jwtToken);
    } catch (e) {
      if (_this83.errorHandlingMode === "default") {
        var i = {
          status: 401,
          statusText: e.message,
          headers: {}
        },
            n = {
          code: 401,
          status: "invalid_token",
          message: "Invalid JWT token is provided"
        };
        throw new Un(i, n);
      } else if (_this83.errorHandlingMode === "standard") throw new ue(401, "invalid_token", "Invalid JWT token is provided");
    }

    if (Date.now() > t.exp * 1e3) {
      if (_this83.errorHandlingMode === "default") {
        var _e3 = {
          status: 401,
          statusText: "",
          headers: {}
        },
            _i21 = {
          code: 401,
          status: "invalid_token",
          message: "The provided JWT token is expired"
        };
        throw new Un(_e3, _i21);
      } else if (_this83.errorHandlingMode === "standard") throw new ue(401, "invalid_token", "The provided JWT token is expired");
    }
  });
  this.baseUrl = e, this.apiSignInUrl = "?key=".concat(t.apiKey, "&client_id=").concat(t.clientId), this.jwtToken = t.authProvider.getIdToken(), this.errorHandlingMode = t.errorHandlingMode, this.idSchema = t.idSchema, this.headers = {
    "Content-Type": "application/json"
  }, this.authHeaders = {
    "Content-Type": "application/json",
    Authorization: "Bearer ".concat(t.authProvider.getIdToken())
  };
},
    NT = "/countries",
    Le = "/profile",
    Bn = "/profiles",
    Hh =
/*#__PURE__*/
function (_St) {
  _inherits(Hh, _St);

  function Hh(e) {
    var _this84;

    _classCallCheck(this, Hh);

    _this84 = _possibleConstructorReturn(this, _getPrototypeOf(Hh).call(this, e, Ct(e.environment, "profile")));
    s(_assertThisInitialized(_this84), "profileRemapper", null);
    s(_assertThisInitialized(_this84), "followingRemapper", null);
    s(_assertThisInitialized(_this84), "followersRemapper", null);
    s(_assertThisInitialized(_this84), "lang", null);
    s(_assertThisInitialized(_this84), "limitIds", 100);
    s(_assertThisInitialized(_this84), "getCountries", function (e) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee234() {
        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee234$(_context234) {
          while (1) {
            switch (_context234.prev = _context234.next) {
              case 0:
                i = "&lang=".concat(this.lang), n = "".concat(NT).concat(this.apiSignInUrl).concat(i), r = Date.now(), a = "There was a problem fetching profile countries";
                e && (n += "&disable_cache=".concat(r));
                _context234.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                return _context234.abrupt("return", _context234.sent.data);

              case 5:
              case "end":
                return _context234.stop();
            }
          }
        }, _callee234, this);
      }));
    });
    s(_assertThisInitialized(_this84), "getProfile", function (e) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee235() {
        var i, n, _r16, _r17;

        return _regeneratorRuntime.wrap(function _callee235$(_context235) {
          while (1) {
            switch (_context235.prev = _context235.next) {
              case 0:
                i = "".concat(Le).concat(this.apiSignInUrl), n = "";

                if (!e) {
                  _context235.next = 9;
                  break;
                }

                i = "".concat(Bn, "/").concat(e).concat(this.apiSignInUrl), n = "There was a problem fetching the following profile: ".concat(e);
                _context235.next = 5;
                return this.fetchWithoutAuth(i, n);

              case 5:
                _r16 = _context235.sent;
                return _context235.abrupt("return", this.profileRemapper.fullProfileFromResponse(_r16.data));

              case 9:
                n = "There was a problem fetching your profile from API";
                _context235.next = 12;
                return this.fetchWithAuth(i, n);

              case 12:
                _r17 = _context235.sent;
                return _context235.abrupt("return", this.profileRemapper.fullProfileFromResponse(_r17.data));

              case 14:
              case "end":
                return _context235.stop();
            }
          }
        }, _callee235, this);
      }));
    });
    s(_assertThisInitialized(_this84), "getProfiles", function (e, i, n) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee236() {
        var r, a, h, p, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, g, f, v, c, _d4, o, l;

        return _regeneratorRuntime.wrap(function _callee236$(_context236) {
          while (1) {
            switch (_context236.prev = _context236.next) {
              case 0:
                r = Date.now(), a = "There was a problem fetching the following profiles: ".concat(e.join(","));

                if (!(e && e.length)) {
                  _context236.next = 41;
                  break;
                }

                if (!(e.length > this.limitIds)) {
                  _context236.next = 35;
                  break;
                }

                h = [], p = Xn(e, this.limitIds);
                _iteratorNormalCompletion15 = true;
                _didIteratorError15 = false;
                _iteratorError15 = undefined;
                _context236.prev = 7;
                _iterator15 = p[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
                  _context236.next = 20;
                  break;
                }

                g = _step15.value;
                f = "".concat(Bn).concat(this.apiSignInUrl, "&profile_ids=").concat(g.join(","));
                a = "There was a problem fetching the following profiles: ".concat(g.join(",")), n && (f += "&disable_cache=".concat(r));
                _context236.next = 15;
                return this.fetchWithoutAuth(f, a);

              case 15:
                v = _context236.sent;
                h.push.apply(h, _toConsumableArray(this.profileRemapper.profilesFromResponse(v.data)));

              case 17:
                _iteratorNormalCompletion15 = true;
                _context236.next = 9;
                break;

              case 20:
                _context236.next = 26;
                break;

              case 22:
                _context236.prev = 22;
                _context236.t0 = _context236["catch"](7);
                _didIteratorError15 = true;
                _iteratorError15 = _context236.t0;

              case 26:
                _context236.prev = 26;
                _context236.prev = 27;

                if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
                  _iterator15.return();
                }

              case 29:
                _context236.prev = 29;

                if (!_didIteratorError15) {
                  _context236.next = 32;
                  break;
                }

                throw _iteratorError15;

              case 32:
                return _context236.finish(29);

              case 33:
                return _context236.finish(26);

              case 34:
                return _context236.abrupt("return", h);

              case 35:
                c = "".concat(Bn).concat(this.apiSignInUrl, "&profile_ids=").concat(e.join(","));
                n && (c += "&disable_cache=".concat(r));
                _context236.next = 39;
                return this.fetchWithoutAuth(c, a);

              case 39:
                _d4 = _context236.sent;
                return _context236.abrupt("return", this.profileRemapper.profilesFromResponse(_d4.data));

              case 41:
                o = "".concat(Bn).concat(this.apiSignInUrl, "&search=").concat(i);
                n && (o += "&disable_cache=".concat(r));
                _context236.next = 45;
                return this.fetchWithoutAuth(o, a);

              case 45:
                l = _context236.sent;
                return _context236.abrupt("return", this.profileRemapper.profilesFromResponse(l.data));

              case 47:
              case "end":
                return _context236.stop();
            }
          }
        }, _callee236, this, [[7, 22, 26, 34], [27,, 29, 33]]);
      }));
    });
    s(_assertThisInitialized(_this84), "getFollowers", function (e, i) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee237() {
        var n, r, o, _o4, a;

        return _regeneratorRuntime.wrap(function _callee237$(_context237) {
          while (1) {
            switch (_context237.prev = _context237.next) {
              case 0:
                n = "".concat(Le, "/followers").concat(this.apiSignInUrl), r = "There was a problem fetching the followers for own profile";

                if (!(e && !i)) {
                  _context237.next = 9;
                  break;
                }

                n = "".concat(Le, "/followers").concat(this.apiSignInUrl).concat(e.constructFilterUrl());
                _context237.next = 5;
                return this.fetchWithAuth(n, r);

              case 5:
                o = _context237.sent;
                return _context237.abrupt("return", this.followersRemapper.followersFromResponse(o));

              case 9:
                if (!(!e && !i)) {
                  _context237.next = 14;
                  break;
                }

                _context237.next = 12;
                return this.fetchWithAuth(n, r);

              case 12:
                _o4 = _context237.sent;
                return _context237.abrupt("return", this.followersRemapper.followersFromResponse(_o4));

              case 14:
                e && i ? n = "".concat(Le, "/").concat(i, "/followers").concat(this.apiSignInUrl).concat(e.constructFilterUrl()) : !e && i && (n = "".concat(Le, "/").concat(i, "/followers").concat(this.apiSignInUrl)), r = "There was a problem fetching the followers for profile: ".concat(i);
                _context237.next = 17;
                return this.fetchWithoutAuth(n, r);

              case 17:
                a = _context237.sent;
                return _context237.abrupt("return", this.followersRemapper.followersFromResponse(a));

              case 19:
              case "end":
                return _context237.stop();
            }
          }
        }, _callee237, this);
      }));
    });
    s(_assertThisInitialized(_this84), "getFollowing", function (e, i) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee238() {
        var n, r, o, _o5, a;

        return _regeneratorRuntime.wrap(function _callee238$(_context238) {
          while (1) {
            switch (_context238.prev = _context238.next) {
              case 0:
                n = "".concat(Le, "/following").concat(this.apiSignInUrl), r = "There was a problem fetching the followers of own profile";

                if (!(e && !i)) {
                  _context238.next = 9;
                  break;
                }

                n = "".concat(Le, "/following").concat(this.apiSignInUrl).concat(e.constructFilterUrl());
                _context238.next = 5;
                return this.fetchWithAuth(n, r);

              case 5:
                o = _context238.sent;
                return _context238.abrupt("return", this.followingRemapper.followingFromResponse(o));

              case 9:
                if (!(!e && !i)) {
                  _context238.next = 14;
                  break;
                }

                _context238.next = 12;
                return this.fetchWithAuth(n, r);

              case 12:
                _o5 = _context238.sent;
                return _context238.abrupt("return", this.followingRemapper.followingFromResponse(_o5));

              case 14:
                e && i ? n = "".concat(Le, "/").concat(i, "/following").concat(this.apiSignInUrl).concat(e.constructFilterUrl()) : !e && i && (n = "".concat(Le, "/").concat(i, "/following").concat(this.apiSignInUrl)), r = "There was a problem fetching the followers of the following profile: ".concat(i);
                _context238.next = 17;
                return this.fetchWithoutAuth(n, r);

              case 17:
                a = _context238.sent;
                return _context238.abrupt("return", this.followingRemapper.followingFromResponse(a));

              case 19:
              case "end":
                return _context238.stop();
            }
          }
        }, _callee238, this);
      }));
    });
    s(_assertThisInitialized(_this84), "follow", function (e) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee239() {
        var i, n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee239$(_context239) {
          while (1) {
            switch (_context239.prev = _context239.next) {
              case 0:
                i = new uc();
                i.profile_ids = e;
                n = Le + "/follow".concat(this.apiSignInUrl);
                r = "There was a problem with following profiles: ".concat(e.join(","));
                a = "POST";
                _context239.next = 7;
                return this.fetchWithAuth(n, r, a, i);

              case 7:
                o = _context239.sent;
                return _context239.abrupt("return", this.followingRemapper.followResponse(o.data));

              case 9:
              case "end":
                return _context239.stop();
            }
          }
        }, _callee239, this);
      }));
    });
    s(_assertThisInitialized(_this84), "unfollow", function (e) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee240() {
        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee240$(_context240) {
          while (1) {
            switch (_context240.prev = _context240.next) {
              case 0:
                i = new uc();
                i.profile_ids = e;
                n = Le + "/follow".concat(this.apiSignInUrl), r = "There was a problem with unfollowing profiles: ".concat(e.join(",")), a = "DELETE";
                _context240.next = 5;
                return this.fetchWithAuth(n, r, a, i);

              case 5:
                return _context240.abrupt("return", !0);

              case 6:
              case "end":
                return _context240.stop();
            }
          }
        }, _callee240, this);
      }));
    });
    s(_assertThisInitialized(_this84), "getBadges", function (e) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee241() {
        var i, n;
        return _regeneratorRuntime.wrap(function _callee241$(_context241) {
          while (1) {
            switch (_context241.prev = _context241.next) {
              case 0:
                i = "".concat(Le, "/badges").concat(this.apiSignInUrl), n = "There was a problem with fetching own badges";

                if (!e) {
                  _context241.next = 9;
                  break;
                }

                i = "".concat(Le, "/").concat(e, "/badges").concat(this.apiSignInUrl);
                n = "There was a problem with fetching the badges";
                _context241.next = 6;
                return this.fetchWithoutAuth(i, n);

              case 6:
                _context241.t0 = _context241.sent.data;
                _context241.next = 12;
                break;

              case 9:
                _context241.next = 11;
                return this.fetchWithAuth(i, n);

              case 11:
                _context241.t0 = _context241.sent.data;

              case 12:
                return _context241.abrupt("return", _context241.t0);

              case 13:
              case "end":
                return _context241.stop();
            }
          }
        }, _callee241, this);
      }));
    });
    s(_assertThisInitialized(_this84), "updateProfile", function (e) {
      return u(_assertThisInitialized(_this84), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee242() {
        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee242$(_context242) {
          while (1) {
            switch (_context242.prev = _context242.next) {
              case 0:
                i = Le + this.apiSignInUrl;
                n = "There was a problem updating the own profile";
                r = "PATCH";
                _context242.next = 5;
                return this.fetchWithAuth(i, n, r, e);

              case 5:
                a = _context242.sent;
                return _context242.abrupt("return", this.profileRemapper.fullProfileFromResponse(a.data));

              case 7:
              case "end":
                return _context242.stop();
            }
          }
        }, _callee242, this);
      }));
    });
    _this84.lang = e.lang, _this84.profileRemapper = new _T(), _this84.followingRemapper = new CT(), _this84.followersRemapper = new TT();
    return _this84;
  }

  return Hh;
}(St),
    Vh = function (t) {
  return t.NATIVE = "native", t.ENETPULSE = "enetpulse", t.SPORTRADAR = "sportradar", t.SPORTAL_365 = "sportal365", t.API_FOOTBALL = "api_football", t;
}(Vh || {}),
    zi = {
  player: "players",
  team: "teams",
  homeTeam: "teams",
  awayTeam: "teams",
  country: "countries",
  competition: "competitions",
  match: "matches"
},
    LT =
/*#__PURE__*/
function (_St2) {
  _inherits(LT, _St2);

  function LT(e) {
    var _this85;

    _classCallCheck(this, LT);

    _this85 = _possibleConstructorReturn(this, _getPrototypeOf(LT).call(this, e, Ct(e.environment, "idMapping")));
    s(_assertThisInitialized(_this85), "getEntityById", function (e, i) {
      return u(_assertThisInitialized(_this85), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee243() {
        var n, r;
        return _regeneratorRuntime.wrap(function _callee243$(_context243) {
          while (1) {
            switch (_context243.prev = _context243.next) {
              case 0:
                n = "/football".concat(this.apiSignInUrl, "&input_provider=").concat(this.idSchema, "&").concat(zi[e], "=").concat(i), r = "There was a problem with id mapping request for the following id: ".concat(i);
                _context243.next = 3;
                return this.fetchWithoutAuth(n, r);

              case 3:
                return _context243.abrupt("return", _context243.sent);

              case 4:
              case "end":
                return _context243.stop();
            }
          }
        }, _callee243, this);
      }));
    });
    s(_assertThisInitialized(_this85), "getEntityByIdAndSchema", function (e, i, n) {
      return u(_assertThisInitialized(_this85), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee244() {
        var r, a;
        return _regeneratorRuntime.wrap(function _callee244$(_context244) {
          while (1) {
            switch (_context244.prev = _context244.next) {
              case 0:
                r = "/football".concat(this.apiSignInUrl, "&input_provider=").concat(n, "&").concat(zi[e], "=").concat(i), a = "There was a problem with id mapping request for the following id: ".concat(i);
                _context244.next = 3;
                return this.fetchWithoutAuth(r, a);

              case 3:
                return _context244.abrupt("return", _context244.sent);

              case 4:
              case "end":
                return _context244.stop();
            }
          }
        }, _callee244, this);
      }));
    });
    s(_assertThisInitialized(_this85), "getEntityIdsByIdsAndSchema", function (e, i, n) {
      return u(_assertThisInitialized(_this85), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee245() {
        var r, a;
        return _regeneratorRuntime.wrap(function _callee245$(_context245) {
          while (1) {
            switch (_context245.prev = _context245.next) {
              case 0:
                r = "/football".concat(this.apiSignInUrl, "&input_provider=").concat(n, "&").concat(zi[e], "=").concat(i.join(",")), a = "There was a problem with id mapping request for the following ids: ".concat(i.join(","));
                _context245.next = 3;
                return this.fetchWithoutAuth(r, a);

              case 3:
                return _context245.abrupt("return", _context245.sent);

              case 4:
              case "end":
                return _context245.stop();
            }
          }
        }, _callee245, this);
      }));
    });
    s(_assertThisInitialized(_this85), "getEntitiesByIds", function (e, i, n) {
      return u(_assertThisInitialized(_this85), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee246() {
        var r, a, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, o, _l5, c, _d5;

        return _regeneratorRuntime.wrap(function _callee246$(_context246) {
          while (1) {
            switch (_context246.prev = _context246.next) {
              case 0:
                i.sort(function (o, l) {
                  return o.localeCompare(l);
                });
                r = cc(i), a = [];
                _iteratorNormalCompletion16 = true;
                _didIteratorError16 = false;
                _iteratorError16 = undefined;
                _context246.prev = 5;
                _iterator16 = r[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done) {
                  _context246.next = 18;
                  break;
                }

                o = _step16.value;
                _l5 = "/football".concat(this.apiSignInUrl, "&input_provider=").concat(n, "&").concat(zi[e], "=").concat(o.join(","));
                c = "There was a problem with id mapping request for the following ids :".concat(o.join(","));
                _context246.next = 13;
                return this.fetchWithoutAuth(_l5, c);

              case 13:
                _d5 = _context246.sent;
                a = [].concat(_toConsumableArray(a), _toConsumableArray(_d5.data));

              case 15:
                _iteratorNormalCompletion16 = true;
                _context246.next = 7;
                break;

              case 18:
                _context246.next = 24;
                break;

              case 20:
                _context246.prev = 20;
                _context246.t0 = _context246["catch"](5);
                _didIteratorError16 = true;
                _iteratorError16 = _context246.t0;

              case 24:
                _context246.prev = 24;
                _context246.prev = 25;

                if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
                  _iterator16.return();
                }

              case 27:
                _context246.prev = 27;

                if (!_didIteratorError16) {
                  _context246.next = 30;
                  break;
                }

                throw _iteratorError16;

              case 30:
                return _context246.finish(27);

              case 31:
                return _context246.finish(24);

              case 32:
                return _context246.abrupt("return", a);

              case 33:
              case "end":
                return _context246.stop();
            }
          }
        }, _callee246, this, [[5, 20, 24, 32], [25,, 27, 31]]);
      }));
    });
    s(_assertThisInitialized(_this85), "getEntitiesByIdObjs", function (e, i) {
      return u(_assertThisInitialized(_this85), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee247() {
        var _this86 = this;

        var n, r, a, o, l, _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _loop5, _iterator17, _step17;

        return _regeneratorRuntime.wrap(function _callee247$(_context248) {
          while (1) {
            switch (_context248.prev = _context248.next) {
              case 0:
                n = [], r = {}, a = [];
                Object.keys(e).forEach(function (c) {
                  n.push.apply(n, e[c]);
                });
                o = as(n), l = cc(o);
                _iteratorNormalCompletion17 = true;
                _didIteratorError17 = false;
                _iteratorError17 = undefined;
                _context248.prev = 6;
                _loop5 =
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _loop5() {
                  var c, d, h, p, g;
                  return _regeneratorRuntime.wrap(function _loop5$(_context247) {
                    while (1) {
                      switch (_context247.prev = _context247.next) {
                        case 0:
                          c = _step17.value;
                          d = "";

                          if (!(Object.keys(e).forEach(function (h) {
                            r[h] = [];
                            var p = c.filter(function (g) {
                              return e[h].includes(g);
                            });
                            p && p.length > 0 && (r[h] = p);
                          }), Object.keys(r).forEach(function (h) {
                            r[h].length > 0 && (r[h].sort(function (p, g) {
                              return p.localeCompare(g);
                            }), d += "&", d += "".concat(zi[h], "=").concat(r[h].join(",")));
                          }), d && d.length > 0)) {
                            _context247.next = 11;
                            break;
                          }

                          h = "/football".concat(_this86.apiSignInUrl, "&input_provider=").concat(i || "native").concat(d);
                          p = "There was a problem with id mapping request";
                          _context247.next = 7;
                          return _this86.fetchWithoutAuth(h, p);

                        case 7:
                          g = _context247.sent;
                          a.push(g.data);
                          _context247.next = 12;
                          break;

                        case 11:
                          a.push([]);

                        case 12:
                        case "end":
                          return _context247.stop();
                      }
                    }
                  }, _loop5);
                });
                _iterator17 = l[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done) {
                  _context248.next = 14;
                  break;
                }

                return _context248.delegateYield(_loop5(), "t0", 11);

              case 11:
                _iteratorNormalCompletion17 = true;
                _context248.next = 9;
                break;

              case 14:
                _context248.next = 20;
                break;

              case 16:
                _context248.prev = 16;
                _context248.t1 = _context248["catch"](6);
                _didIteratorError17 = true;
                _iteratorError17 = _context248.t1;

              case 20:
                _context248.prev = 20;
                _context248.prev = 21;

                if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
                  _iterator17.return();
                }

              case 23:
                _context248.prev = 23;

                if (!_didIteratorError17) {
                  _context248.next = 26;
                  break;
                }

                throw _iteratorError17;

              case 26:
                return _context248.finish(23);

              case 27:
                return _context248.finish(20);

              case 28:
                return _context248.abrupt("return", Array.prototype.concat.apply([], a));

              case 29:
              case "end":
                return _context248.stop();
            }
          }
        }, _callee247, null, [[6, 16, 20, 28], [21,, 23, 27]]);
      }));
    });
    s(_assertThisInitialized(_this85), "getTopEntities", function () {
      return u(_assertThisInitialized(_this85), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee248() {
        var e, i;
        return _regeneratorRuntime.wrap(function _callee248$(_context249) {
          while (1) {
            switch (_context249.prev = _context249.next) {
              case 0:
                e = "/football/top".concat(this.apiSignInUrl), i = "There was a problem with top id mappings request";
                _context249.next = 3;
                return this.fetchWithoutAuth(e, i);

              case 3:
                return _context249.abrupt("return", _context249.sent.data);

              case 4:
              case "end":
                return _context249.stop();
            }
          }
        }, _callee248, this);
      }));
    });
    return _this85;
  }

  return LT;
}(St),
    mc = "FansUnited",
    qs = {
  football: {
    ids: [],
    countries: [],
    competitions: [],
    expirations: {
      ids: 0
    }
  },
  profile: {
    info: {},
    statistics: {},
    badges: null,
    countries: [],
    expirations: {
      profile: 0,
      statistics: 0,
      badges: 0
    }
  },
  client: {
    features: {},
    expirations: {
      features: 0
    }
  }
},
    $T = function $T(t) {
  var _this87 = this;

  _classCallCheck(this, $T);

  s(this, "idSchema", "");
  s(this, "expirationProfileTimeout", 600);
  s(this, "expirationBadgesTimeout", 3600);
  s(this, "expirationClientFeaturesTimeout", 14400);
  s(this, "expirationFootballIdsTimeout", 604800);
  s(this, "clearData", function () {
    _this87.setData(qs);
  });
  s(this, "getEntityById", function () {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return _this87.getData().football.ids.find(function (i) {
      var n = Ue[_this87.idSchema];
      return i && "".concat(i[n]) === e && i.resource === t;
    });
  });
  s(this, "getEntity", function (t, e, i) {
    return Array.isArray(t) ? _this87.getData().football.ids.filter(function (n) {
      var r = Ue[i];
      return n && t.includes("".concat(n[r])) && n.resource === e;
    }) : _this87.getData().football.ids.find(function (n) {
      var r = Ue[i];
      return n && "".concat(n[r]) === t && n.resource === e;
    });
  });
  s(this, "getEntityByNativeId", function () {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return _this87.getData().football.ids.find(function (i) {
      return i && "".concat(i.id) === e && i.resource === t;
    });
  });
  s(this, "checkForExistingIdObjs", function (t, e) {
    var i = Ue[e],
        n = {};
    return Object.keys(t).forEach(function (r) {
      var a = t[r],
          o = _this87.getEntity(a, r, e).map(function (c) {
        return c[i];
      }),
          l = t[r].filter(function (c) {
        return !o.includes(c);
      });

      n[r] = a.map(function (c) {
        return l.includes(c) ? {
          id: c,
          exists: !1
        } : {
          id: c,
          exists: !0
        };
      });
    }), n;
  });
  s(this, "getIdsByType", function (t, e, i) {
    var n = Ue[i],
        r = Ue[e],
        a = {};
    return Object.keys(t).forEach(function (o) {
      var l = t[o],
          c = [];
      _this87.getData().football.ids.forEach(function (d) {
        l.forEach(function (h, p) {
          h === d[r] && o === d.resource && (c[p] = d[n]);
        });
      }), a[o] = c;
    }), a;
  });
  s(this, "addIdMapping", function (t) {
    var e = _this87.getData();

    e.football.ids.push(t), _this87.setData(e);
  });
  s(this, "addIdMappings", function (t) {
    var e = _this87.getData(),
        i = e.football.ids;

    i = [].concat(_toConsumableArray(i), _toConsumableArray(t)), e.football.ids = i, _this87.setData(e);
  });
  s(this, "addTopIdMappings", function (t) {
    var e = _this87.getData();

    if (e.football.ids.length) {
      var i = JSON.parse(JSON.stringify(e.football.ids));
      i = i.filter(function (n) {
        return n.resource !== "match";
      }), t = t.filter(function (n) {
        return n.resource === "match";
      }), i = [].concat(_toConsumableArray(i), _toConsumableArray(t)), e.football.ids = i;
    } else e.football.ids = t;

    e.football.expirations.ids = Math.floor(Date.now() / 1e3) + _this87.expirationFootballIdsTimeout, _this87.setData(e);
  });
  s(this, "setOwnProfile", function (t) {
    var e = _this87.getData();

    e.profile.info = t, e.profile.expirations.profile = Math.floor(Date.now() / 1e3) + _this87.expirationProfileTimeout, _this87.setData(e);
  });
  s(this, "getOwnProfile", function () {
    return _this87.getData().profile.info;
  });
  s(this, "getProfileCountries", function () {
    return _this87.getData().profile.countries;
  });
  s(this, "setProfileCountries", function (t) {
    var e = _this87.getData();

    e.profile.countries = t, _this87.setData(e);
  });
  s(this, "getProfileStats", function () {
    return _this87.getData().profile.statistics;
  });
  s(this, "setProfileStats", function (t) {
    var e = _this87.getData();

    e.profile.statistics = t, e.profile.expirations.statistics = Math.floor(Date.now() / 1e3) + _this87.expirationProfileTimeout, _this87.setData(e);
  });
  s(this, "getProfileBadges", function () {
    return _this87.getData().profile.badges;
  });
  s(this, "setProfileBadges", function (t) {
    var e = _this87.getData();

    e.profile.badges = t, e.profile.expirations.badges = Math.floor(Date.now() / 1e3) + _this87.expirationBadgesTimeout, _this87.setData(e);
  });
  s(this, "getFootballCountries", function () {
    return _this87.getData().football.countries;
  });
  s(this, "setFootballCountries", function (t) {
    var e = _this87.getData();

    e.football.countries = t, _this87.setData(e);
  });
  s(this, "getCompetitions", function (t) {
    var e = _this87.getData();

    return t ? t.competitionSearchFilter(e.football.competitions) : e.football.competitions;
  });
  s(this, "setCompetitions", function (t) {
    var e = _this87.getData(),
        i = _toConsumableArray(e.football.competitions);

    i.push.apply(i, _toConsumableArray(t)), e.football.competitions = _this87.makeCompetitionsUnique(i), _this87.setData(e);
  });
  s(this, "getCompetitionsLength", function () {
    var _this87$getData = _this87.getData(),
        t = _this87$getData.football;

    return t.competitions.length;
  });
  s(this, "getClientFeatures", function () {
    return _this87.getData().client.features;
  });
  s(this, "setClientFeatures", function (t) {
    var e = _this87.getData(),
        i = JSON.parse(JSON.stringify(t));

    e.client.expirations.features = Math.floor(Date.now() / 1e3) + _this87.expirationClientFeaturesTimeout, e.client.features = i, _this87.setData(e);
  });
  s(this, "deleteClientFeatures", function () {
    var t = _this87.getData(),
        e = JSON.parse(JSON.stringify(t));

    e.client = {
      features: {},
      expirations: {
        features: 0
      }
    }, _this87.setData(e);
  });
  s(this, "getExpiration", function (t, e) {
    _this87.initialNewSchema(t, "expirations");

    var i = _this87.getData();

    switch (e) {
      case "profile":
        return i.profile.expirations.profile;

      case "statistics":
        return i.profile.expirations.statistics;

      case "badges":
        return i.profile.expirations.badges;

      case "features":
        return i.client.expirations.features;

      case "ids":
        return i.football.expirations.ids;
    }
  });
  s(this, "makeCompetitionsUnique", function (t) {
    var e =
    /* @__PURE__ */
    new Set();
    return t.filter(function (i) {
      var n = !e.has(i.id);
      return e.add(i.id), n;
    });
  });
  s(this, "getData", function () {
    return JSON.parse(localStorage.getItem(mc));
  });
  s(this, "setData", function (t) {
    localStorage.setItem(mc, JSON.stringify(t));
  });
  s(this, "initialNewSchema", function (t, e) {
    var i = _this87.getData();

    (!i || !i[t] || !i[t][e]) && _this87.setData(qs);
  });
  this.idSchema = t, (this.getData() === void 0 || this.getData() === null) && this.setData(qs);
},
    UT = gT(bT()),
    ee =
/*#__PURE__*/
function () {
  function ee(t) {
    var _this88 = this;

    _classCallCheck(this, ee);

    s(this, "profileTTL", 600);
    s(this, "clientTTL", 14400);
    s(this, "profileBadgesTTL", 3600);
    s(this, "idMappingsExpiration", 0);
    s(this, "idSchema", "");
    s(this, "clearData", function () {
      return ee.nodeCache.flushAll();
    });
    s(this, "getEntityById", function (t, e) {
      var i = ee.nodeCache.get("ids");
      return i ? i.find(function (n) {
        var r = Ue[_this88.idSchema];
        return n && "".concat(n[r]) === e && n.resource === t;
      }) : null;
    });
    s(this, "getEntity", function (t, e, i) {
      var n = ee.nodeCache.get("ids");
      return n ? Array.isArray(t) ? [] : null : Array.isArray(t) ? n.filter(function (r) {
        var a = Ue[i];
        return r && t.includes("".concat(r[a])) && r.resource === e;
      }) : n.find(function (r) {
        var a = Ue[i];
        return r && "".concat(r[a]) === t && r.resource === e;
      });
    });
    s(this, "checkForExistingIdObjs", function (t, e) {
      var i = Ue[e],
          n = {};
      return Object.keys(t).forEach(function (r) {
        var a = t[r],
            o = _this88.getEntity(a, r, e).map(function (c) {
          return c[i];
        }),
            l = t[r].filter(function (c) {
          return !o.includes(c);
        });

        n[r] = a.map(function (c) {
          return l.includes(c) ? {
            id: c,
            exists: !1
          } : {
            id: c,
            exists: !0
          };
        });
      }), n;
    });
    s(this, "getIdsByType", function (t, e, i) {
      var n = Ue[i],
          r = Ue[e],
          a = ee.nodeCache.get("ids"),
          o = {};
      return a ? (Object.keys(t).forEach(function (l) {
        var c = t[l],
            d = [];
        a.forEach(function (h) {
          c.forEach(function (p, g) {
            p === h[r] && l === h.resource && (d[g] = h[n]);
          });
        }), o[l] = d;
      }), o) : null;
    });
    s(this, "addIdMapping", function (t) {
      var e = ee.nodeCache.get("ids");
      e.push(t), ee.nodeCache.set("ids", e);
    });
    s(this, "addIdMappings", function (t) {
      var e = ee.nodeCache.get("ids");
      e = [].concat(_toConsumableArray(e), _toConsumableArray(t)), ee.nodeCache.set("ids", e);
    });
    s(this, "addTopIdMappings", function (t) {
      var e = ee.nodeCache.get("ids"),
          i = 604800;

      if (e) {
        var n = JSON.parse(JSON.stringify(e));
        n = n.filter(function (r) {
          return r.resource !== "match";
        }), t = t.filter(function (r) {
          return r.resource === "match";
        }), n = [].concat(_toConsumableArray(n), _toConsumableArray(t)), ee.nodeCache.set("ids", n);
      } else ee.nodeCache.set("ids", t);

      _this88.idMappingsExpiration = Math.floor(Date.now() / 1e3) + i;
    });
    s(this, "setOwnProfile", function (t) {
      return ee.nodeCache.set("profile", t, _this88.profileTTL);
    });
    s(this, "getOwnProfile", function () {
      return ee.nodeCache.get("profile");
    });
    s(this, "getProfileCountries", function () {
      return ee.nodeCache.get("profile_countries");
    });
    s(this, "setProfileCountries", function (t) {
      return ee.nodeCache.set("profile_countries", t);
    });
    s(this, "getProfileStats", function () {
      return ee.nodeCache.get("profile_stats");
    });
    s(this, "setProfileStats", function (t) {
      return ee.nodeCache.set("profile_stats", t, _this88.profileTTL);
    });
    s(this, "getProfileBadges", function () {
      return ee.nodeCache.get("profile_badges");
    });
    s(this, "setProfileBadges", function (t) {
      ee.nodeCache.set("profile_badges", t, _this88.profileBadgesTTL);
    });
    s(this, "getFootballCountries", function () {
      return ee.nodeCache.get("football_countries");
    });
    s(this, "setFootballCountries", function (t) {
      return ee.nodeCache.set("football_countries", t);
    });
    s(this, "getCompetitions", function (t) {
      var e = ee.nodeCache.get("football_competitions");
      return e ? t ? t.competitionSearchFilter(e) : e : null;
    });
    s(this, "setCompetitions", function (t) {
      return ee.nodeCache.set("football_competitions", t);
    });
    s(this, "getCompetitionsLength", function () {
      var t = ee.nodeCache.get("football_competitions");
      return t ? t.length : 0;
    });
    s(this, "getClientFeatures", function () {
      return ee.nodeCache.get("client");
    });
    s(this, "setClientFeatures", function (t) {
      return ee.nodeCache.set("client", t, _this88.clientTTL);
    });
    s(this, "deleteClientFeatures", function () {
      return ee.nodeCache.del("client");
    });
    s(this, "getExpiration", function (t, e) {
      var i = _this88.getKeyFromExpirationType(e);

      return i === "ids" ? _this88.idMappingsExpiration : ee.nodeCache.getTtl(i);
    });
    s(this, "getKeyFromExpirationType", function (t) {
      switch (t) {
        case "profile":
          return "profile";

        case "statistics":
          return "profile_stats";

        case "badges":
          return "profile_badges";

        case "features":
          return "client";

        case "ids":
          return "ids";
      }
    });
  }

  _createClass(ee, null, [{
    key: "getInstance",
    value: function getInstance(t) {
      return ee.instance || (ee.instance = new ee(t), ee.nodeCache.options.useClones = !1), ee.instance;
    }
  }]);

  return ee;
}(),
    Ca = ee;

lc(Ca, "instance"), lc(Ca, "nodeCache", new UT.default());

var Cn = function Cn() {
  _classCallCheck(this, Cn);

  s(this, "createLocalCacheInstance", function (t) {
    return typeof window > "u" ? Ca.getInstance(t) : new $T(t);
  });
},
    BT = function BT(t) {
  var _this89 = this;

  _classCallCheck(this, BT);

  s(this, "localCache", null);
  s(this, "https", null);
  s(this, "getEntitiesByIds", function (t, e, i) {
    return u(_this89, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee249() {
      var n, _r18, a;

      return _regeneratorRuntime.wrap(function _callee249$(_context250) {
        while (1) {
          switch (_context250.prev = _context250.next) {
            case 0:
              _context250.next = 2;
              return this.setTopIdMappings();

            case 2:
              _context250.prev = 2;
              n = this.localCache.checkForExistingIdObjs(t, e);
              _r18 = this.splitForRequestAndExisting(n);
              _context250.next = 7;
              return this.https.getEntitiesByIdObjs(_r18.request, e);

            case 7:
              a = _context250.sent;
              return _context250.abrupt("return", (this.localCache.addIdMappings(a), this.localCache.getIdsByType(t, e, i)));

            case 11:
              _context250.prev = 11;
              _context250.t0 = _context250["catch"](2);
              return _context250.abrupt("return", (console.warn("There was a problem retrieving the entity ids ", _context250.t0), Promise.resolve([])));

            case 14:
            case "end":
              return _context250.stop();
          }
        }
      }, _callee249, this, [[2, 11]]);
    }));
  });
  s(this, "getEntityById", function (t, e, i) {
    return u(_this89, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee250() {
      var n, r;
      return _regeneratorRuntime.wrap(function _callee250$(_context251) {
        while (1) {
          switch (_context251.prev = _context251.next) {
            case 0:
              n = this.localCache.getEntity(t, e, i);

              if (!n) {
                _context251.next = 3;
                break;
              }

              return _context251.abrupt("return", n);

            case 3:
              _context251.next = 5;
              return this.requestEntity(t, e, i);

            case 5:
              r = _context251.sent;
              return _context251.abrupt("return", (this.localCache.addIdMappings(r), r));

            case 7:
            case "end":
              return _context251.stop();
          }
        }
      }, _callee250, this);
    }));
  });
  s(this, "splitForRequestAndExisting", function (t) {
    var e = {},
        i = {};
    return Object.keys(t).forEach(function (n) {
      e[n] = t[n].filter(function (r) {
        return !r.exists;
      }).map(function (r) {
        return r.id;
      }), i[n] = t[n].filter(function (r) {
        return r.exists;
      }).map(function (r) {
        return r.id;
      });
    }), {
      existing: i,
      request: e
    };
  });
  s(this, "requestEntity", function (t, e, i) {
    return u(_this89, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee251() {
      return _regeneratorRuntime.wrap(function _callee251$(_context252) {
        while (1) {
          switch (_context252.prev = _context252.next) {
            case 0:
              _context252.prev = 0;
              t = Array.isArray(t) ? t : [t];
              _context252.next = 4;
              return this.https.getEntitiesByIds(e, t, i);

            case 4:
              return _context252.abrupt("return", _context252.sent);

            case 7:
              _context252.prev = 7;
              _context252.t0 = _context252["catch"](0);
              return _context252.abrupt("return", (console.warn("There was a problem retrieving the requested entity: ".concat(_context252.t0)), null));

            case 10:
            case "end":
              return _context252.stop();
          }
        }
      }, _callee251, this, [[0, 7]]);
    }));
  });
  s(this, "setTopIdMappings", function () {
    return u(_this89, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee252() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee252$(_context253) {
        while (1) {
          switch (_context253.prev = _context253.next) {
            case 0:
              t = Math.floor(Date.now() / 1e3);

              if (!(this.localCache.getExpiration("football", "ids") > t)) {
                _context253.next = 3;
                break;
              }

              return _context253.abrupt("return", Promise.resolve());

            case 3:
              _context253.next = 5;
              return this.https.getTopEntities();

            case 5:
              e = _context253.sent;
              this.localCache.addTopIdMappings(e);

            case 7:
            case "end":
              return _context253.stop();
          }
        }
      }, _callee252, this);
    }));
  });
  this.localCache = new Cn().createLocalCacheInstance(t.idSchema), this.https = new LT(t);
},
    jh = function jh(t) {
  switch (t) {
    case "competitions":
      return "competition";

    case "players":
    case "relatedPlayer":
    case "squad":
      return "player";

    case "teams":
    case "participants":
    case "homeTeam":
    case "awayTeam":
    case "timeline":
    case "teamId":
      return "team";

    default:
      return t;
  }
},
    HT = function HT() {
  var _this90 = this;

  _classCallCheck(this, HT);

  s(this, "extractedObjIds", {});
  s(this, "traverse", function (t, e) {
    return e = jh(e), Array.isArray(t) ? _this90.traverseArrExtract(t, e) : t && typeof t == "object" && _this90.traverseObjExtract(t, e), _this90.extractedObjIds;
  });
  s(this, "traverseArrExtract", function (t, e) {
    t && t.length > 0 && t.forEach(function (i) {
      _this90.traverseObjExtract(i, e);
    });
  });
  s(this, "traverseObjExtract", function (t, e) {
    t && Object.keys(t).length > 0 && Object.keys(t).forEach(function (i) {
      var n = t[i];
      i === "id" || i === "teamId" ? (_this90.extractedObjIds.hasOwnProperty(e) || (_this90.extractedObjIds[e] = []), n && _this90.extractedObjIds[e].push(n)) : t[i] && _this90.traverse(t[i], i);
    });
  });
},
    VT = function VT() {
  var _this91 = this;

  _classCallCheck(this, VT);

  s(this, "replaceObjIdsIndex", null);
  s(this, "remappedIdsObj", {});
  s(this, "traverse", function (t, e, i) {
    return e = jh(e), _this91.replaceObjIdsIndex === null && (_this91.initReplaceObjIdsIndex(i), _this91.remappedIdsObj = i), Array.isArray(t) ? _this91.traverseArrReplace(t, e) : t && typeof t == "object" && _this91.traverseObjReplace(t, e), t;
  });
  s(this, "initReplaceObjIdsIndex", function (t) {
    _this91.replaceObjIdsIndex = {}, Object.keys(t).forEach(function (e) {
      _this91.replaceObjIdsIndex[e] = 0;
    });
  });
  s(this, "traverseArrReplace", function (t, e) {
    t && t.length > 0 && t.forEach(function (i) {
      _this91.traverseObjReplace(i, e);
    });
  });
  s(this, "traverseObjReplace", function (t, e) {
    t && Object.keys(t).length > 0 && Object.keys(t).forEach(function (i) {
      i === "id" || i === "teamId" ? t[i] && (t[i] = _this91.remappedIdsObj[e][_this91.replaceObjIdsIndex[e]], _this91.replaceObjIdsIndex[e] = _this91.replaceObjIdsIndex[e] + 1) : t[i] && _this91.traverse(t[i], i, _this91.remappedIdsObj);
    });
  });
},
    Tt = function Tt(t) {
  var _this92 = this;

  _classCallCheck(this, Tt);

  s(this, "idSchema", "");
  s(this, "idMappingFacade", null);
  s(this, "getEntityIdBySchemaId", function (t, e) {
    return _this92.idMappingFacade.getEntityById(e, t, _this92.idSchema);
  });
  s(this, "remapEntities", function (t, e) {
    return u(_this92, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee253() {
      var i, n;
      return _regeneratorRuntime.wrap(function _callee253$(_context254) {
        while (1) {
          switch (_context254.prev = _context254.next) {
            case 0:
              i = JSON.parse(JSON.stringify(t));
              _context254.prev = 1;

              if (!(this.idSchema !== "native")) {
                _context254.next = 7;
                break;
              }

              n = new HT().traverse(i, e);
              return _context254.abrupt("return", this.idMappingFacade.getEntitiesByIds(n, "native", this.idSchema).then(function (r) {
                return new VT().traverse(i, e, r);
              }));

            case 7:
              return _context254.abrupt("return", t);

            case 8:
              _context254.next = 13;
              break;

            case 10:
              _context254.prev = 10;
              _context254.t0 = _context254["catch"](1);
              return _context254.abrupt("return", (console.warn("There was a problem remapping entity: ".concat(e, " with inner entity "), _context254.t0), []));

            case 13:
            case "end":
              return _context254.stop();
          }
        }
      }, _callee253, this, [[1, 10]]);
    }));
  });
  s(this, "getEntityIdsBySchemaId", function (t, e, i) {
    return u(_this92, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee254() {
      var n;
      return _regeneratorRuntime.wrap(function _callee254$(_context255) {
        while (1) {
          switch (_context255.prev = _context255.next) {
            case 0:
              n = {};
              n[e] = t;

              if (!(this.idSchema !== "native")) {
                _context255.next = 8;
                break;
              }

              _context255.next = 5;
              return this.idMappingFacade.getEntitiesByIds(n, this.idSchema, i);

            case 5:
              _context255.t0 = _context255.sent;
              _context255.next = 9;
              break;

            case 8:
              _context255.t0 = n;

            case 9:
              return _context255.abrupt("return", _context255.t0);

            case 10:
            case "end":
              return _context255.stop();
          }
        }
      }, _callee254, this);
    }));
  });
  this.idSchema = t.idSchema, this.idMappingFacade = new BT(t);
},
    nt = function nt(t) {
  _classCallCheck(this, nt);

  s(this, "completed", !1);
  s(this, "percentage");
  this.percentage = t;
},
    jT = function jT() {
  _classCallCheck(this, jT);

  s(this, "teamFollowed", new nt(10));
  s(this, "teamFavourite", new nt(15));
  s(this, "playerFollowed", new nt(10));
  s(this, "playerFavourite", new nt(10));
  s(this, "competitionFollowed", new nt(10));
  s(this, "competitionFavourite", new nt(5));
  s(this, "addedBirthdate", new nt(10));
  s(this, "addedGender", new nt(10));
  s(this, "addedCountry", new nt(10));
  s(this, "addedAvatar", new nt(10));
},
    WT = function WT() {
  _classCallCheck(this, WT);

  s(this, "totalPercentage");
  s(this, "breakdown", new jT());
},
    gc = function gc(t) {
  var _this93 = this;

  _classCallCheck(this, gc);

  s(this, "limit", 0);
  s(this, "startAfter", null);
  s(this, "constructFilterUrl", function () {
    var t = "";
    return _this93.limit && (t = t + "&", t = t + "limit=".concat(_this93.limit)), _this93.startAfter && (t = t + "&", t = t + "start_after=".concat(_this93.startAfter)), t;
  });
  this.limit = t.limit ? t.limit : 20, this.startAfter = t.startAfter ? t.startAfter : null;
},
    ls = function ls(t, e, i) {
  var _this94 = this;

  _classCallCheck(this, ls);

  s(this, "localCache");
  s(this, "profileHttps", null);
  s(this, "activityHttps", null);
  s(this, "getOwn", function () {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee255() {
      var t, _e4;

      return _regeneratorRuntime.wrap(function _callee255$(_context256) {
        while (1) {
          switch (_context256.prev = _context256.next) {
            case 0:
              t = this.getLocalStorageData("profile");

              if (!t) {
                _context256.next = 3;
                break;
              }

              return _context256.abrupt("return", JSON.parse(JSON.stringify(t)));

            case 3:
              _context256.prev = 3;
              _context256.next = 6;
              return this.profileHttps.getProfile();

            case 6:
              _e4 = _context256.sent;
              return _context256.abrupt("return", (this.localCache.setOwnProfile(_e4), _e4));

            case 10:
              _context256.prev = 10;
              _context256.t0 = _context256["catch"](3);
              throw console.warn("There was a problem retrieving your profile: ", _context256.t0), _context256.t0;

            case 13:
            case "end":
              return _context256.stop();
          }
        }
      }, _callee255, this, [[3, 10]]);
    }));
  });
  s(this, "updateOwnProfile", function () {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee256() {
      var _t4;

      return _regeneratorRuntime.wrap(function _callee256$(_context257) {
        while (1) {
          switch (_context257.prev = _context257.next) {
            case 0:
              _context257.prev = 0;
              _context257.next = 3;
              return this.profileHttps.getProfile();

            case 3:
              _t4 = _context257.sent;
              return _context257.abrupt("return", (this.localCache.setOwnProfile(_t4), _t4));

            case 7:
              _context257.prev = 7;
              _context257.t0 = _context257["catch"](0);
              throw console.warn("There was a problem retrieving your profile: ", _context257.t0), _context257.t0;

            case 10:
            case "end":
              return _context257.stop();
          }
        }
      }, _callee256, this, [[0, 7]]);
    }));
  });
  s(this, "getByIds", function (t, e, i) {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee257() {
      return _regeneratorRuntime.wrap(function _callee257$(_context258) {
        while (1) {
          switch (_context258.prev = _context258.next) {
            case 0:
              if (!(t && t.length > 0 && e || !t && t.length === 0 && !e)) {
                _context258.next = 2;
                break;
              }

              throw new ue(400, "invalid_method_call", "The method 'getByIds' from Profile namespace is not called correctly. You need to provide 'profileIds' OR 'search' parameters to the method, but you can't use both of them or neither of them.");

            case 2:
              _context258.prev = 2;
              _context258.next = 5;
              return this.profileHttps.getProfiles(t, e, i);

            case 5:
              return _context258.abrupt("return", _context258.sent);

            case 8:
              _context258.prev = 8;
              _context258.t0 = _context258["catch"](2);
              throw console.warn("There was a problem retrieving the selected profiles: ".concat(t.join(","), " "), _context258.t0), _context258.t0;

            case 11:
            case "end":
              return _context258.stop();
          }
        }
      }, _callee257, this, [[2, 8]]);
    }));
  });
  s(this, "getById", function (t) {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee258() {
      return _regeneratorRuntime.wrap(function _callee258$(_context259) {
        while (1) {
          switch (_context259.prev = _context259.next) {
            case 0:
              _context259.prev = 0;
              _context259.next = 3;
              return this.profileHttps.getProfile(t);

            case 3:
              return _context259.abrupt("return", _context259.sent);

            case 6:
              _context259.prev = 6;
              _context259.t0 = _context259["catch"](0);
              throw console.warn("There was a problem retrieving the selected profile: ".concat(t, " "), _context259.t0), _context259.t0;

            case 9:
            case "end":
              return _context259.stop();
          }
        }
      }, _callee258, this, [[0, 6]]);
    }));
  });
  s(this, "getCountries", function (t) {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee259() {
      var e, _i22;

      return _regeneratorRuntime.wrap(function _callee259$(_context260) {
        while (1) {
          switch (_context260.prev = _context260.next) {
            case 0:
              t = t || !1;
              e = this.localCache.getProfileCountries();

              if (!(e && e.length > 0)) {
                _context260.next = 4;
                break;
              }

              return _context260.abrupt("return", e);

            case 4:
              _context260.prev = 4;
              _context260.next = 7;
              return this.profileHttps.getCountries(t);

            case 7:
              _i22 = _context260.sent;
              return _context260.abrupt("return", (this.localCache.setProfileCountries(_i22), _i22));

            case 11:
              _context260.prev = 11;
              _context260.t0 = _context260["catch"](4);
              throw console.warn("There was a problem retrieving profile countries: ", _context260.t0), _context260.t0;

            case 14:
            case "end":
              return _context260.stop();
          }
        }
      }, _callee259, this, [[4, 11]]);
    }));
  });
  s(this, "getFollowers", function (t, e) {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee260() {
      var _i23, n, _r19, a;

      return _regeneratorRuntime.wrap(function _callee260$(_context261) {
        while (1) {
          switch (_context261.prev = _context261.next) {
            case 0:
              _context261.prev = 0;
              t && (t = new gc(t));
              _context261.next = 4;
              return this.profileHttps.getFollowers(t, e);

            case 4:
              _i23 = _context261.sent;
              n = _i23.data.map(function (r) {
                return r.followerId;
              });

              if (!n.length) {
                _context261.next = 12;
                break;
              }

              _context261.next = 9;
              return this.getByIds(n);

            case 9:
              _r19 = _context261.sent;
              a = _i23.data.map(function (o) {
                return _r19.forEach(function (l) {
                  o.followerId === l.id && (o.name = l.name, o.nickname = l.nickname, o.avatar = l.avatar);
                }), o;
              });
              return _context261.abrupt("return", (_i23.data = a, _i23));

            case 12:
              return _context261.abrupt("return", _i23);

            case 15:
              _context261.prev = 15;
              _context261.t0 = _context261["catch"](0);
              throw console.warn("There was a problem retrieving your followers: ", _context261.t0), _context261.t0;

            case 18:
            case "end":
              return _context261.stop();
          }
        }
      }, _callee260, this, [[0, 15]]);
    }));
  });
  s(this, "getFollowing", function (t, e) {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee261() {
      var _i24, n, _r20, a;

      return _regeneratorRuntime.wrap(function _callee261$(_context262) {
        while (1) {
          switch (_context262.prev = _context262.next) {
            case 0:
              _context262.prev = 0;
              t && (t = new gc(t));
              _context262.next = 4;
              return this.profileHttps.getFollowing(t, e);

            case 4:
              _i24 = _context262.sent;
              n = _i24.data.map(function (r) {
                return r.followingId;
              });

              if (!n.length) {
                _context262.next = 12;
                break;
              }

              _context262.next = 9;
              return this.getByIds(n);

            case 9:
              _r20 = _context262.sent;
              a = _i24.data.map(function (o) {
                return _r20.forEach(function (l) {
                  o.followingId === l.id && (o.name = l.name, o.nickname = l.nickname, o.avatar = l.avatar);
                }), o;
              });
              return _context262.abrupt("return", (_i24.data = a, _i24));

            case 12:
              return _context262.abrupt("return", _i24);

            case 15:
              _context262.prev = 15;
              _context262.t0 = _context262["catch"](0);
              throw console.warn("There was a problem retrieving your following profiles: ", _context262.t0), _context262.t0;

            case 18:
            case "end":
              return _context262.stop();
          }
        }
      }, _callee261, this, [[0, 15]]);
    }));
  });
  s(this, "follow", function (t) {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee262() {
      return _regeneratorRuntime.wrap(function _callee262$(_context263) {
        while (1) {
          switch (_context263.prev = _context263.next) {
            case 0:
              _context263.prev = 0;
              _context263.next = 3;
              return this.profileHttps.follow(t);

            case 3:
              return _context263.abrupt("return", _context263.sent);

            case 6:
              _context263.prev = 6;
              _context263.t0 = _context263["catch"](0);
              throw console.warn("There was a problem following profiles: ".concat(t.join(","), " "), _context263.t0), _context263.t0;

            case 9:
            case "end":
              return _context263.stop();
          }
        }
      }, _callee262, this, [[0, 6]]);
    }));
  });
  s(this, "unfollow", function (t) {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee263() {
      return _regeneratorRuntime.wrap(function _callee263$(_context264) {
        while (1) {
          switch (_context264.prev = _context264.next) {
            case 0:
              _context264.prev = 0;
              _context264.next = 3;
              return this.profileHttps.unfollow(t);

            case 3:
              return _context264.abrupt("return", _context264.sent);

            case 6:
              _context264.prev = 6;
              _context264.t0 = _context264["catch"](0);
              throw console.warn("There was a problem unfollowing profiles: ".concat(t.join(","), " "), _context264.t0), _context264.t0;

            case 9:
            case "end":
              return _context264.stop();
          }
        }
      }, _callee263, this, [[0, 6]]);
    }));
  });
  s(this, "showFullnessProfile", function (t) {
    var e = new WT(),
        i = 0;
    return t.avatar && (e.breakdown.addedAvatar.completed = !0, i += e.breakdown.addedAvatar.percentage), t.birthDate && (e.breakdown.addedBirthdate.completed = !0, i += e.breakdown.addedBirthdate.percentage), t.country && (e.breakdown.addedCountry.completed = !0, i += e.breakdown.addedCountry.percentage), t.gender && (e.breakdown.addedGender.completed = !0, i += e.breakdown.addedGender.percentage), t.interests && t.interests.length > 0 && (t.interests.find(function (n) {
      return n.type === "team" && n.favourite;
    }) && (e.breakdown.teamFavourite.completed = !0, i += e.breakdown.teamFavourite.percentage), t.interests.find(function (n) {
      return n.type === "team";
    }) && (e.breakdown.teamFollowed.completed = !0, i += e.breakdown.teamFollowed.percentage), t.interests.find(function (n) {
      return n.type === "player" && n.favourite;
    }) && (e.breakdown.playerFavourite.completed = !0, i += e.breakdown.playerFavourite.percentage), t.interests.find(function (n) {
      return n.type === "player";
    }) && (e.breakdown.playerFollowed.completed = !0, i += e.breakdown.playerFollowed.percentage), t.interests.find(function (n) {
      return n.type === "competition" && n.favourite;
    }) && (e.breakdown.competitionFavourite.completed = !0, i += e.breakdown.competitionFavourite.percentage), t.interests.find(function (n) {
      return n.type === "competition";
    }) && (e.breakdown.competitionFollowed.completed = !0, i += e.breakdown.competitionFollowed.percentage)), e.totalPercentage = i, e;
  });
  s(this, "getStats", function () {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee264() {
      var t, e, i, n;
      return _regeneratorRuntime.wrap(function _callee264$(_context265) {
        while (1) {
          switch (_context265.prev = _context265.next) {
            case 0:
              t = ["predictionsMade", "predictions", "tiers", "badges"], e = this.getLocalStorageData("statistics"), i = e ? t.every(function (n) {
                return Object.keys(e).includes(n);
              }) : !1;

              if (!(e && Object.keys(e).length && i)) {
                _context265.next = 3;
                break;
              }

              return _context265.abrupt("return", JSON.parse(JSON.stringify(e)));

            case 3:
              _context265.prev = 3;
              _context265.next = 6;
              return this.activityHttps.getStats();

            case 6:
              n = _context265.sent;
              return _context265.abrupt("return", (this.localCache.setProfileStats(n), n));

            case 10:
              _context265.prev = 10;
              _context265.t0 = _context265["catch"](3);
              throw console.warn("There was a problem retrieving own profile statistics: ", _context265.t0), _context265.t0;

            case 13:
            case "end":
              return _context265.stop();
          }
        }
      }, _callee264, this, [[3, 10]]);
    }));
  });
  s(this, "getBadges", function () {
    return u(_this94, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee265() {
      var t, _e5;

      return _regeneratorRuntime.wrap(function _callee265$(_context266) {
        while (1) {
          switch (_context266.prev = _context266.next) {
            case 0:
              t = this.getLocalStorageData("badges");

              if (!t) {
                _context266.next = 3;
                break;
              }

              return _context266.abrupt("return", t);

            case 3:
              _context266.prev = 3;
              _context266.next = 6;
              return this.profileHttps.getBadges();

            case 6:
              _e5 = _context266.sent;
              return _context266.abrupt("return", (this.localCache.setProfileBadges(_e5), _e5));

            case 10:
              _context266.prev = 10;
              _context266.t0 = _context266["catch"](3);
              throw console.warn("There was a problem retrieving own profile badges: ", _context266.t0), _context266.t0;

            case 13:
            case "end":
              return _context266.stop();
          }
        }
      }, _callee265, this, [[3, 10]]);
    }));
  });
  s(this, "getLocalStorageData", function (t) {
    var e = Math.floor(Date.now() / 1e3),
        i = _this94.localCache.getExpiration("profile", t);

    switch (t) {
      case "profile":
        if (i > e) return _this94.localCache.getOwnProfile();

      case "statistics":
        if (i > e) return _this94.localCache.getProfileStats();

      case "badges":
        if (i > e) return _this94.localCache.getProfileBadges();

      default:
        return null;
    }
  });
  this.localCache = t, this.profileHttps = e, this.activityHttps = i;
},
    GT = function GT() {
  _classCallCheck(this, GT);

  s(this, "id", null);
  s(this, "name", null);
  s(this, "assets", null);
},
    zT = function zT() {
  var _this95 = this;

  _classCallCheck(this, zT);

  s(this, "extractUpdatedProps", function (t, e) {
    var i = ["name", "nickname", "gender", "avatar"],
        n = {};
    return Object.keys(t).forEach(function (r) {
      if (i.includes(r) && t[r] !== e[r]) n[r] = e[r];else if (r === "birthDate") (e[r] === null || t[r] === null && e[r] || t[r] !== e[r]) && (n.birth_date = e[r]);else if (r === "country") e[r] === null ? n.country_id = e[r] : (t[r] === null && e[r] || t[r].id !== e[r].id) && (n.country_id = e[r].id);else if (r === "interests") {
        var a = t[r],
            o = e[r];
        o.length && _this95.isNewInterest(a, o) ? n[r] = _this95.updateInterests(a, o) : (!o.length && a.length || a.length !== o.length && !_this95.isNewInterest(a, o)) && (n[r] = o);
      }
    }), n;
  });
  s(this, "updateInterests", function (t, e) {
    if (t.length === e.length) {
      var _this95$extractSameAn = _this95.extractSameAndNewInterests(t, e),
          _this95$extractSameAn2 = _slicedToArray(_this95$extractSameAn, 2),
          i = _this95$extractSameAn2[0],
          n = _this95$extractSameAn2[1];

      return [].concat(_toConsumableArray(n), _toConsumableArray(i));
    } else return e;
  });
  s(this, "isNewInterest", function (t, e) {
    var i = !1,
        _this95$extractSameAn3 = _this95.extractSameAndNewInterests(t, e),
        _this95$extractSameAn4 = _slicedToArray(_this95$extractSameAn3, 1),
        n = _this95$extractSameAn4[0];

    return n.length && (i = !0), i;
  });
  s(this, "extractSameAndNewInterests", function (t, e) {
    var i = e.filter(function (n) {
      return t.some(function (r) {
        return n.id === r.id && n.type === r.type && n.source === r.source && n.favourite === r.favourite;
      });
    });
    return [e.filter(function (n) {
      return !t.some(function (r) {
        return n.id === r.id && n.type === r.type && n.source === r.source && n.favourite === r.favourite;
      });
    }), i];
  });
  s(this, "isAvatarValidURL", function (t) {
    try {
      return new URL(t), !0;
    } catch (e) {
      return !1;
    }
  });
},
    Se =
/*#__PURE__*/
function (_Error3) {
  _inherits(Se, _Error3);

  function Se(e, i, n) {
    var _this96;

    _classCallCheck(this, Se);

    _this96 = _possibleConstructorReturn(this, _getPrototypeOf(Se).call(this));
    s(_assertThisInitialized(_this96), "code", 0);
    s(_assertThisInitialized(_this96), "status", null);
    s(_assertThisInitialized(_this96), "message", null);
    s(_assertThisInitialized(_this96), "errorMessage", function () {
      return _this96.message;
    });
    _this96.code = e, _this96.status = i, _this96.message = n;
    return _this96;
  }

  return Se;
}(_wrapNativeSuper(Error)),
    qT = function qT(t, e, i, n, r) {
  var _this97 = this;

  _classCallCheck(this, qT);

  s(this, "idsRemapper", null);
  s(this, "profileHttps", null);
  s(this, "profileService", null);
  s(this, "localCache", null);
  s(this, "profileFacade", null);
  s(this, "ownProfile", null);
  s(this, "modified", !1);
  s(this, "expireAt", 0);
  s(this, "promises", []);
  s(this, "isFetching", !1);
  s(this, "errorHandlingMode", null);
  s(this, "getOwnProfile", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee266() {
      var t, _e6;

      return _regeneratorRuntime.wrap(function _callee266$(_context267) {
        while (1) {
          switch (_context267.prev = _context267.next) {
            case 0:
              if (!this.isFetching) {
                _context267.next = 6;
                break;
              }

              console.log("Another thread is fetching profile...");
              _context267.next = 4;
              return this.delay(100);

            case 4:
              _context267.next = 0;
              break;

            case 6:
              if (!(this.modified && this.ownProfile)) {
                _context267.next = 8;
                break;
              }

              return _context267.abrupt("return", (console.log("Timestamp is less than 10 minutes OR profile is modifying "), this.ownProfile));

            case 8:
              t = Math.floor(Date.now() / 1e3);

              if (!(!this.ownProfile || this.expireAt < t)) {
                _context267.next = 22;
                break;
              }

              this.isFetching = !0, this.expireAt = Math.floor(Date.now() / 1e3) + 600;
              _context267.prev = 11;
              _context267.next = 14;
              return this.profileFacade.getOwn();

            case 14:
              _e6 = _context267.sent;
              this.setOwnProfile(_e6);
              _context267.next = 21;
              break;

            case 18:
              _context267.prev = 18;
              _context267.t0 = _context267["catch"](11);
              throw this.isFetching = !1, _context267.t0;

            case 21:
              return _context267.abrupt("return", (this.modified = !1, this.isFetching = !1, this.ownProfile));

            case 22:
              return _context267.abrupt("return", this.ownProfile);

            case 23:
            case "end":
              return _context267.stop();
          }
        }
      }, _callee266, this, [[11, 18]]);
    }));
  });
  s(this, "delay", function (t) {
    return new Promise(function (e) {
      setTimeout(e, t);
    });
  });
  s(this, "setOwnProfile", function (t) {
    _this97.ownProfile = t;
  });
  s(this, "getInfo", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee267() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee267$(_context268) {
        while (1) {
          switch (_context268.prev = _context268.next) {
            case 0:
              _context268.next = 2;
              return this.getOwnProfile();

            case 2:
              t = _context268.sent;
              e = JSON.parse(JSON.stringify(t));
              return _context268.abrupt("return", (delete e.interests, e));

            case 5:
            case "end":
              return _context268.stop();
          }
        }
      }, _callee267, this);
    }));
  });
  s(this, "showInterests", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee268() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee268$(_context269) {
        while (1) {
          switch (_context269.prev = _context269.next) {
            case 0:
              _context269.next = 2;
              return this.getOwnProfile();

            case 2:
              t = _context269.sent;
              e = JSON.parse(JSON.stringify(t));
              _context269.next = 6;
              return this.idsRemapper.remapInterests(e.interests);

            case 6:
              return _context269.abrupt("return", _context269.sent);

            case 7:
            case "end":
              return _context269.stop();
          }
        }
      }, _callee268, this);
    }));
  });
  s(this, "showFullInterests", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee269() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee269$(_context270) {
        while (1) {
          switch (_context270.prev = _context270.next) {
            case 0:
              _context270.next = 2;
              return this.getOwnProfile();

            case 2:
              t = _context270.sent;
              e = JSON.parse(JSON.stringify(t));
              _context270.next = 6;
              return this.idsRemapper.showFullInterests(e.interests);

            case 6:
              return _context270.abrupt("return", _context270.sent);

            case 7:
            case "end":
              return _context270.stop();
          }
        }
      }, _callee269, this);
    }));
  });
  s(this, "getFollowers", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee270() {
      return _regeneratorRuntime.wrap(function _callee270$(_context271) {
        while (1) {
          switch (_context271.prev = _context271.next) {
            case 0:
              _context271.next = 2;
              return this.profileFacade.getFollowers(t);

            case 2:
              return _context271.abrupt("return", _context271.sent);

            case 3:
            case "end":
              return _context271.stop();
          }
        }
      }, _callee270, this);
    }));
  });
  s(this, "getFollowing", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee271() {
      return _regeneratorRuntime.wrap(function _callee271$(_context272) {
        while (1) {
          switch (_context272.prev = _context272.next) {
            case 0:
              _context272.next = 2;
              return this.profileFacade.getFollowing(t);

            case 2:
              return _context272.abrupt("return", _context272.sent);

            case 3:
            case "end":
              return _context272.stop();
          }
        }
      }, _callee271, this);
    }));
  });
  s(this, "follow", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee272() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee272$(_context273) {
        while (1) {
          switch (_context273.prev = _context273.next) {
            case 0:
              _context273.next = 2;
              return this.profileFacade.follow(t);

            case 2:
              e = _context273.sent;
              _context273.next = 5;
              return this.profileFacade.updateOwnProfile();

            case 5:
              i = _context273.sent;
              return _context273.abrupt("return", (this.setOwnProfile(i), e));

            case 7:
            case "end":
              return _context273.stop();
          }
        }
      }, _callee272, this);
    }));
  });
  s(this, "unfollow", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee273() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee273$(_context274) {
        while (1) {
          switch (_context274.prev = _context274.next) {
            case 0:
              _context274.next = 2;
              return this.profileFacade.unfollow(t);

            case 2:
              e = _context274.sent;
              _context274.next = 5;
              return this.profileFacade.updateOwnProfile();

            case 5:
              i = _context274.sent;
              return _context274.abrupt("return", (this.setOwnProfile(i), e));

            case 7:
            case "end":
              return _context274.stop();
          }
        }
      }, _callee273, this);
    }));
  });
  s(this, "getStats", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee274() {
      var t;
      return _regeneratorRuntime.wrap(function _callee274$(_context275) {
        while (1) {
          switch (_context275.prev = _context275.next) {
            case 0:
              _context275.next = 2;
              return this.profileFacade.getStats();

            case 2:
              t = _context275.sent;
              _context275.next = 5;
              return this.idsRemapper.remapProfileStats(t);

            case 5:
              return _context275.abrupt("return", _context275.sent);

            case 6:
            case "end":
              return _context275.stop();
          }
        }
      }, _callee274, this);
    }));
  });
  s(this, "getBadges", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee275() {
      return _regeneratorRuntime.wrap(function _callee275$(_context276) {
        while (1) {
          switch (_context276.prev = _context276.next) {
            case 0:
              _context276.next = 2;
              return this.profileFacade.getBadges();

            case 2:
              return _context276.abrupt("return", _context276.sent);

            case 3:
            case "end":
              return _context276.stop();
          }
        }
      }, _callee275, this);
    }));
  });
  s(this, "addInterestPromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee276() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee276$(_context277) {
        while (1) {
          switch (_context277.prev = _context277.next) {
            case 0:
              this.modified = !0;
              e = O({}, t);
              _context277.next = 4;
              return this.getOwnProfile();

            case 4:
              i = null;

              if (!(t.source !== "custom")) {
                _context277.next = 11;
                break;
              }

              _context277.next = 8;
              return this.idsRemapper.remapInterestToNative(e);

            case 8:
              i = _context277.sent;
              _context277.next = 12;
              break;

            case 11:
              i = e;

            case 12:
              n = this.ownProfile.interests.filter(function (r) {
                return r.id !== i.id || r.type !== i.type || r.source !== i.source;
              });
              return _context277.abrupt("return", (this.ownProfile.interests = _toConsumableArray(n), this.ownProfile.interests.push(i), this));

            case 14:
            case "end":
              return _context277.stop();
          }
        }
      }, _callee276, this);
    }));
  });
  s(this, "addInterest", function (t) {
    return _this97.promises.push(_this97.addInterestPromise(t)), _this97;
  });
  s(this, "removeInterestPromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee277() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee277$(_context278) {
        while (1) {
          switch (_context278.prev = _context278.next) {
            case 0:
              this.modified = !0;
              e = O({}, t);
              _context278.next = 4;
              return this.getOwnProfile();

            case 4:
              i = null;

              if (!(t.source !== "custom")) {
                _context278.next = 11;
                break;
              }

              _context278.next = 8;
              return this.idsRemapper.remapInterestToNative(e);

            case 8:
              i = _context278.sent;
              _context278.next = 12;
              break;

            case 11:
              i = e;

            case 12:
              this.ownProfile.interests = this.ownProfile.interests.filter(function (n) {
                return n.id !== i.id || n.type !== i.type || n.source !== i.source;
              });
              return _context278.abrupt("return", this);

            case 14:
            case "end":
              return _context278.stop();
          }
        }
      }, _callee277, this);
    }));
  });
  s(this, "removeInterest", function (t) {
    return _this97.promises.push(_this97.removeInterestPromise(t)), _this97;
  });
  s(this, "setBirthdatePromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee278() {
      return _regeneratorRuntime.wrap(function _callee278$(_context279) {
        while (1) {
          switch (_context279.prev = _context279.next) {
            case 0:
              this.modified = !0;
              _context279.next = 3;
              return this.getOwnProfile();

            case 3:
              t ? this.ownProfile.birthDate = t : this.ownProfile.birthDate = null;
              return _context279.abrupt("return", this);

            case 5:
            case "end":
              return _context279.stop();
          }
        }
      }, _callee278, this);
    }));
  });
  s(this, "setBirthdate", function (t) {
    return _this97.promises.push(_this97.setBirthdatePromise(t)), _this97;
  });
  s(this, "setGenderPromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee279() {
      return _regeneratorRuntime.wrap(function _callee279$(_context280) {
        while (1) {
          switch (_context280.prev = _context280.next) {
            case 0:
              this.modified = !0;
              _context280.next = 3;
              return this.getOwnProfile();

            case 3:
              t === "male" || t === "female" ? this.ownProfile.gender = t : this.ownProfile.gender = "unspecified";
              return _context280.abrupt("return", this);

            case 5:
            case "end":
              return _context280.stop();
          }
        }
      }, _callee279, this);
    }));
  });
  s(this, "setGender", function (t) {
    return _this97.promises.push(_this97.setGenderPromise(t)), _this97;
  });
  s(this, "setNicknamePromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee280() {
      return _regeneratorRuntime.wrap(function _callee280$(_context281) {
        while (1) {
          switch (_context281.prev = _context281.next) {
            case 0:
              this.modified = !0;
              _context281.next = 3;
              return this.getOwnProfile();

            case 3:
              this.ownProfile.nickname = t;
              return _context281.abrupt("return", this);

            case 5:
            case "end":
              return _context281.stop();
          }
        }
      }, _callee280, this);
    }));
  });
  s(this, "setNickname", function (t) {
    return _this97.promises.push(_this97.setNicknamePromise(t)), _this97;
  });
  s(this, "setNamePromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee281() {
      return _regeneratorRuntime.wrap(function _callee281$(_context282) {
        while (1) {
          switch (_context282.prev = _context282.next) {
            case 0:
              this.modified = !0;
              _context282.next = 3;
              return this.getOwnProfile();

            case 3:
              this.ownProfile.name = t;
              return _context282.abrupt("return", this);

            case 5:
            case "end":
              return _context282.stop();
          }
        }
      }, _callee281, this);
    }));
  });
  s(this, "setName", function (t) {
    return _this97.promises.push(_this97.setNamePromise(t)), _this97;
  });
  s(this, "setCountryPromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee282() {
      return _regeneratorRuntime.wrap(function _callee282$(_context283) {
        while (1) {
          switch (_context283.prev = _context283.next) {
            case 0:
              this.modified = !0;
              _context283.next = 3;
              return this.getOwnProfile();

            case 3:
              t && !this.ownProfile.country ? (this.ownProfile.country = new GT(), this.ownProfile.country.id = t) : t && this.ownProfile.country ? this.ownProfile.country.id = t : this.ownProfile.country = null;
              return _context283.abrupt("return", this);

            case 5:
            case "end":
              return _context283.stop();
          }
        }
      }, _callee282, this);
    }));
  });
  s(this, "setCountry", function (t) {
    return _this97.promises.push(_this97.setCountryPromise(t)), _this97;
  });
  s(this, "showFullnessProfile", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee283() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee283$(_context284) {
        while (1) {
          switch (_context284.prev = _context284.next) {
            case 0:
              _context284.next = 2;
              return this.getOwnProfile();

            case 2:
              t = _context284.sent;
              e = JSON.parse(JSON.stringify(t));
              return _context284.abrupt("return", this.profileFacade.showFullnessProfile(e));

            case 5:
            case "end":
              return _context284.stop();
          }
        }
      }, _callee283, this);
    }));
  });
  s(this, "setAvatarPromise", function (t) {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee284() {
      return _regeneratorRuntime.wrap(function _callee284$(_context285) {
        while (1) {
          switch (_context285.prev = _context285.next) {
            case 0:
              this.modified = !0;
              _context285.next = 3;
              return this.getOwnProfile();

            case 3:
              if (!this.profileService.isAvatarValidURL(t)) {
                _context285.next = 7;
                break;
              }

              this.ownProfile.avatar = t;
              _context285.next = 11;
              break;

            case 7:
              if (!(this.errorHandlingMode === "default")) {
                _context285.next = 9;
                break;
              }

              throw new Se(400, "invalid_avatar", "Invalid URL syntax for avatar image.");

            case 9:
              if (!(this.errorHandlingMode === "standard")) {
                _context285.next = 11;
                break;
              }

              throw new ue(400, "invalid_avatar", "Invalid URL syntax for avatar image.");

            case 11:
              return _context285.abrupt("return", this);

            case 12:
            case "end":
              return _context285.stop();
          }
        }
      }, _callee284, this);
    }));
  });
  s(this, "setAvatar", function (t) {
    return _this97.promises.push(_this97.setAvatarPromise(t)), _this97;
  });
  s(this, "update", function () {
    return u(_this97, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee285() {
      var t, e, i, _r21, a, n;

      return _regeneratorRuntime.wrap(function _callee285$(_context286) {
        while (1) {
          switch (_context286.prev = _context286.next) {
            case 0:
              if (!(this.promises.length === 0)) {
                _context286.next = 2;
                break;
              }

              return _context286.abrupt("return", this.ownProfile);

            case 2:
              _context286.next = 4;
              return Promise.all(this.promises);

            case 4:
              _context286.next = 6;
              return this.profileFacade.getOwn();

            case 6:
              t = _context286.sent;
              _context286.next = 9;
              return this.getOwnProfile();

            case 9:
              e = _context286.sent;
              i = this.profileService.extractUpdatedProps(t, e);

              if (!(this.modified = !1, this.expireAt = 0, Object.keys(i).length)) {
                _context286.next = 17;
                break;
              }

              _context286.next = 14;
              return this.profileHttps.updateProfile(i);

            case 14:
              _r21 = _context286.sent;
              a = JSON.parse(JSON.stringify(_r21));
              return _context286.abrupt("return", (this.setOwnProfile(a), this.localCache.setOwnProfile(a), delete _r21.interests, _r21));

            case 17:
              n = JSON.parse(JSON.stringify(this.ownProfile));
              return _context286.abrupt("return", (delete n.interests, n));

            case 19:
            case "end":
              return _context286.stop();
          }
        }
      }, _callee285, this);
    }));
  });
  this.idsRemapper = t, this.localCache = e, this.profileHttps = i, this.errorHandlingMode = r, this.profileService = new zT(), this.profileFacade = new ls(e, i, n);
},
    QT = function QT(t, e, i, n) {
  var _this98 = this;

  _classCallCheck(this, QT);

  s(this, "idsRemapper", null);
  s(this, "profileHttps", null);
  s(this, "activityHttps", null);
  s(this, "profileFacade", null);
  s(this, "profileId", "");
  s(this, "setId", function (t) {
    return _this98.profileId = t, _this98;
  });
  s(this, "getProfile", function () {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee286() {
      return _regeneratorRuntime.wrap(function _callee286$(_context287) {
        while (1) {
          switch (_context287.prev = _context287.next) {
            case 0:
              _context287.next = 2;
              return this.profileFacade.getById(this.profileId);

            case 2:
              return _context287.abrupt("return", _context287.sent);

            case 3:
            case "end":
              return _context287.stop();
          }
        }
      }, _callee286, this);
    }));
  });
  s(this, "getInfo", function () {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee287() {
      var t;
      return _regeneratorRuntime.wrap(function _callee287$(_context288) {
        while (1) {
          switch (_context288.prev = _context288.next) {
            case 0:
              _context288.next = 2;
              return this.getProfile();

            case 2:
              t = _context288.sent;
              return _context288.abrupt("return", (delete t.interests, t));

            case 4:
            case "end":
              return _context288.stop();
          }
        }
      }, _callee287, this);
    }));
  });
  s(this, "showInterests", function () {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee288() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee288$(_context289) {
        while (1) {
          switch (_context289.prev = _context289.next) {
            case 0:
              _context289.next = 2;
              return this.getProfile();

            case 2:
              t = _context289.sent;
              e = JSON.parse(JSON.stringify(t));
              _context289.next = 6;
              return this.idsRemapper.remapInterests(e.interests);

            case 6:
              return _context289.abrupt("return", _context289.sent);

            case 7:
            case "end":
              return _context289.stop();
          }
        }
      }, _callee288, this);
    }));
  });
  s(this, "showFullInterests", function () {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee289() {
      var t, e;
      return _regeneratorRuntime.wrap(function _callee289$(_context290) {
        while (1) {
          switch (_context290.prev = _context290.next) {
            case 0:
              _context290.next = 2;
              return this.getProfile();

            case 2:
              t = _context290.sent;
              e = JSON.parse(JSON.stringify(t));
              _context290.next = 6;
              return this.idsRemapper.showFullInterests(e.interests);

            case 6:
              return _context290.abrupt("return", _context290.sent);

            case 7:
            case "end":
              return _context290.stop();
          }
        }
      }, _callee289, this);
    }));
  });
  s(this, "getFollowers", function (t) {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee290() {
      return _regeneratorRuntime.wrap(function _callee290$(_context291) {
        while (1) {
          switch (_context291.prev = _context291.next) {
            case 0:
              _context291.next = 2;
              return this.profileFacade.getFollowers(t, this.profileId);

            case 2:
              return _context291.abrupt("return", _context291.sent);

            case 3:
            case "end":
              return _context291.stop();
          }
        }
      }, _callee290, this);
    }));
  });
  s(this, "getFollowing", function (t) {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee291() {
      return _regeneratorRuntime.wrap(function _callee291$(_context292) {
        while (1) {
          switch (_context292.prev = _context292.next) {
            case 0:
              _context292.next = 2;
              return this.profileFacade.getFollowing(t, this.profileId);

            case 2:
              return _context292.abrupt("return", _context292.sent);

            case 3:
            case "end":
              return _context292.stop();
          }
        }
      }, _callee291, this);
    }));
  });
  s(this, "showFullnessProfile", function () {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee292() {
      var t;
      return _regeneratorRuntime.wrap(function _callee292$(_context293) {
        while (1) {
          switch (_context293.prev = _context293.next) {
            case 0:
              _context293.next = 2;
              return this.getProfile();

            case 2:
              t = _context293.sent;
              return _context293.abrupt("return", this.profileFacade.showFullnessProfile(t));

            case 4:
            case "end":
              return _context293.stop();
          }
        }
      }, _callee292, this);
    }));
  });
  s(this, "getStats", function (t) {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee293() {
      var e;
      return _regeneratorRuntime.wrap(function _callee293$(_context294) {
        while (1) {
          switch (_context294.prev = _context294.next) {
            case 0:
              _context294.next = 2;
              return this.activityHttps.getStats(this.profileId, t);

            case 2:
              e = _context294.sent;
              _context294.next = 5;
              return this.idsRemapper.remapProfileStats(e);

            case 5:
              return _context294.abrupt("return", _context294.sent);

            case 6:
            case "end":
              return _context294.stop();
          }
        }
      }, _callee293, this);
    }));
  });
  s(this, "getBadges", function () {
    return u(_this98, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee294() {
      return _regeneratorRuntime.wrap(function _callee294$(_context295) {
        while (1) {
          switch (_context295.prev = _context295.next) {
            case 0:
              _context295.next = 2;
              return this.profileHttps.getBadges(this.profileId);

            case 2:
              return _context295.abrupt("return", _context295.sent);

            case 3:
            case "end":
              return _context295.stop();
          }
        }
      }, _callee294, this);
    }));
  });
  this.idsRemapper = t, this.profileHttps = i, this.activityHttps = n, this.profileFacade = new ls(e, i, n);
},
    YT = function YT(t, e, i) {
  var _this99 = this;

  _classCallCheck(this, YT);

  s(this, "localCache", null);
  s(this, "https", null);
  s(this, "idMapping", null);
  s(this, "getCountriesWithIdMapping", function (t) {
    return u(_this99, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee295() {
      var _e7;

      return _regeneratorRuntime.wrap(function _callee295$(_context296) {
        while (1) {
          switch (_context296.prev = _context296.next) {
            case 0:
              _context296.prev = 0;
              _context296.next = 3;
              return this.getCountries(t);

            case 3:
              _e7 = _context296.sent;
              return _context296.abrupt("return", this.idMapping.remapEntities(_e7, "country"));

            case 7:
              _context296.prev = 7;
              _context296.t0 = _context296["catch"](0);
              throw console.warn("There was a problem browsing countries as football entities", _context296.t0), _context296.t0;

            case 10:
            case "end":
              return _context296.stop();
          }
        }
      }, _callee295, this, [[0, 7]]);
    }));
  });
  s(this, "getCountries", function (t) {
    return u(_this99, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee296() {
      var e, _i25;

      return _regeneratorRuntime.wrap(function _callee296$(_context297) {
        while (1) {
          switch (_context297.prev = _context297.next) {
            case 0:
              t = t || !1;
              e = this.localCache.getFootballCountries();

              if (!(e && e.length > 0)) {
                _context297.next = 4;
                break;
              }

              return _context297.abrupt("return", e);

            case 4:
              _context297.prev = 4;
              _context297.next = 7;
              return this.https.getCountries(t);

            case 7:
              _i25 = _context297.sent;
              return _context297.abrupt("return", (this.localCache.setFootballCountries(_i25), _i25));

            case 11:
              _context297.prev = 11;
              _context297.t0 = _context297["catch"](4);
              throw console.warn("There was a problem retrieving countries as football entities", _context297.t0), _context297.t0;

            case 14:
            case "end":
              return _context297.stop();
          }
        }
      }, _callee296, this, [[4, 11]]);
    }));
  });
  this.localCache = t, this.idMapping = i, this.https = e;
},
    yc = function yc(t) {
  var _this100 = this;

  _classCallCheck(this, yc);

  s(this, "countryId", null);
  s(this, "name", null);
  s(this, "gender", null);
  s(this, "type", null);
  s(this, "sortField", null);
  s(this, "sortOrder", null);
  s(this, "competitionIds", null);
  s(this, "constructFilterUrl", function () {
    var t = "";
    return _this100.countryId && (t = t + "&", t = t + "country_id=".concat(_this100.countryId)), _this100.gender && (t = t + "&", t = t + "gender=".concat(_this100.gender)), _this100.type && (t = t + "&", t = t + "type=".concat(_this100.type)), _this100.sortField && (t = t + "&", t = t + "sort_field=".concat(_this100.sortField)), _this100.sortOrder && (t = t + "&", t = t + "sort_order=".concat(_this100.sortOrder)), _this100.name && (t = t + "&", t = t + "name=".concat(_this100.name)), _this100.competitionIds && (t = t + "&", t = t + "competition_ids=".concat(_this100.competitionIds.join(","))), t;
  });
  s(this, "competitionSearchFilter", function (t) {
    try {
      var e = _this100.filter(t);

      return _this100.sortField || _this100.sortOrder ? _this100.sort(e) : e;
    } catch (e) {
      return console.warn("There was a problem filtering the local competitions", e), [];
    }
  });
  s(this, "filter", function (t) {
    var e = _this100.entitiesToSearchWith();

    return t.filter(function (i) {
      var n = !0;
      return e.forEach(function (r) {
        r !== "sortOrder" && r !== "sortField" && (r === "countryId" ? n && (n = i.country.id === _this100[r]) : r === "name" ? n && (n = i.name.toLocaleLowerCase().includes(_this100[r].toLocaleLowerCase())) : r === "competitionIds" ? n && (n = _this100[r].some(function (a) {
          return i.id === a;
        })) : n && (n = i[r].toLocaleLowerCase() === _this100[r].toLocaleLowerCase()));
      }), n;
    });
  });
  s(this, "entitiesToSearchWith", function () {
    var t = [];
    return _this100.countryId && t.push("countryId"), _this100.name && t.push("name"), _this100.gender && t.push("gender"), _this100.type && t.push("type"), _this100.sortField && t.push("sortField"), _this100.sortOrder && t.push("sortOrder"), _this100.competitionIds && t.push("competitionIds"), t;
  });
  s(this, "sort", function (t) {
    var e = [];
    return _this100.sortField === "name" ? e = t.sort(function (i, n) {
      return _this100.sortOrder && _this100.sortOrder === "desc" ? n.name.localeCompare(i.name) : i.name.localeCompare(n.name);
    }) : _this100.sortField === "country" ? e = t.sort(function (i, n) {
      return _this100.sortOrder && _this100.sortOrder === "desc" ? n.country.name.localeCompare(i.country.name) : i.country.name.localeCompare(n.country.name);
    }) : _this100.sortField === "scope" ? t.forEach(function (i) {
      return e[_this100.competitionIds.indexOf(i.id)] = i;
    }) : !_this100.sortField && _this100.sortOrder === "desc" && (e = t.sort(function (i, n) {
      return n.id.localeCompare(i.id);
    })), e;
  });
  this.countryId = t.countryId ? "".concat(t.countryId) : null, this.name = t.name ? t.name : null, this.gender = t.gender ? t.gender : null, this.type = t.type ? t.type : null, this.sortField = t.sortField ? "".concat(t.sortField) : null, this.sortOrder = t.sortOrder ? "".concat(t.sortOrder) : null, this.competitionIds = t.competitionIds ? t.competitionIds : null;
},
    KT = function KT(t, e, i) {
  var _this101 = this;

  _classCallCheck(this, KT);

  s(this, "localStorage", null);
  s(this, "https", null);
  s(this, "idMapping", null);
  s(this, "getCompetitionsIdMapping", function (t, e) {
    return u(_this101, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee297() {
      var _i26, _r22, _r23, n;

      return _regeneratorRuntime.wrap(function _callee297$(_context298) {
        while (1) {
          switch (_context298.prev = _context298.next) {
            case 0:
              _context298.prev = 0;
              _i26 = !1;

              if (!t) {
                _context298.next = 15;
                break;
              }

              if (!(t = new yc(t), t.countryId)) {
                _context298.next = 8;
                break;
              }

              _context298.next = 6;
              return this.idMapping.getEntityIdsBySchemaId(["".concat(t.countryId)], "country", "native");

            case 6:
              _r22 = _context298.sent;
              _r22.country.length === 0 && (_i26 = !0), t.countryId = _r22.country[0];

            case 8:
              if (!t.competitionIds) {
                _context298.next = 13;
                break;
              }

              _context298.next = 11;
              return this.idMapping.getEntityIdsBySchemaId(t.competitionIds, "competition", "native");

            case 11:
              _r23 = _context298.sent;
              _r23.competition.length === 0 && (_i26 = !0), t.competitionIds = _r23.competition;

            case 13:
              if (!_i26) {
                _context298.next = 15;
                break;
              }

              return _context298.abrupt("return", []);

            case 15:
              _context298.next = 17;
              return this.getCompetitions(t, e);

            case 17:
              n = _context298.sent;
              _context298.next = 20;
              return this.idMapping.remapEntities(n, "competition");

            case 20:
              return _context298.abrupt("return", _context298.sent);

            case 23:
              _context298.prev = 23;
              _context298.t0 = _context298["catch"](0);
              throw console.warn("There was a problem browsing all of the competitions", _context298.t0), _context298.t0;

            case 26:
            case "end":
              return _context298.stop();
          }
        }
      }, _callee297, this, [[0, 23]]);
    }));
  });
  s(this, "getCompetitionsMapWithNativeIds", function (t) {
    return u(_this101, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee298() {
      var e, i, n, r, a, o;
      return _regeneratorRuntime.wrap(function _callee298$(_context299) {
        while (1) {
          switch (_context299.prev = _context299.next) {
            case 0:
              e =
              /* @__PURE__ */
              new Map();
              i = t.length;
              n = new yc({
                competitionIds: t,
                limit: i
              });
              _context299.next = 5;
              return this.getCompetitions(n);

            case 5:
              r = _context299.sent;
              r.sort(function (l, c) {
                return l.id.localeCompare(c.id);
              });
              a = $h(t);
              _context299.next = 10;
              return this.idMapping.remapEntities(r, "competition");

            case 10:
              o = _context299.sent;
              return _context299.abrupt("return", (a.forEach(function (l, c) {
                return e.set(l, o[c]);
              }), e));

            case 12:
            case "end":
              return _context299.stop();
          }
        }
      }, _callee298, this);
    }));
  });
  s(this, "getCompetitions", function (t, e) {
    return u(_this101, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee299() {
      var i;
      return _regeneratorRuntime.wrap(function _callee299$(_context300) {
        while (1) {
          switch (_context300.prev = _context300.next) {
            case 0:
              i = null;

              if (this.localStorage.getCompetitionsLength()) {
                _context300.next = 12;
                break;
              }

              _context300.prev = 2;
              _context300.next = 5;
              return this.https.getCompetitions();

            case 5:
              i = _context300.sent;
              _context300.next = 11;
              break;

            case 8:
              _context300.prev = 8;
              _context300.t0 = _context300["catch"](2);
              throw console.warn("There was a problem retrieving all competitions", _context300.t0), _context300.t0;

            case 11:
              this.localStorage.setCompetitions(i);

            case 12:
              return _context300.abrupt("return", this.localStorage.getCompetitions(t));

            case 13:
            case "end":
              return _context300.stop();
          }
        }
      }, _callee299, this, [[2, 8]]);
    }));
  });
  s(this, "getCompetitionByIdIdMapping", function (t, e) {
    return u(_this101, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee300() {
      var _i27, n;

      return _regeneratorRuntime.wrap(function _callee300$(_context301) {
        while (1) {
          switch (_context301.prev = _context301.next) {
            case 0:
              _context301.prev = 0;
              _context301.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "competition", "native");

            case 3:
              _i27 = _context301.sent.competition[0];
              _context301.next = 6;
              return this.getCompetitionById(_i27, e);

            case 6:
              n = _context301.sent;
              _context301.next = 9;
              return this.idMapping.remapEntities(n, "competition");

            case 9:
              return _context301.abrupt("return", _context301.sent);

            case 12:
              _context301.prev = 12;
              _context301.t0 = _context301["catch"](0);
              throw console.warn("There was a problem browsing the following competition:".concat(t), _context301.t0), _context301.t0;

            case 15:
            case "end":
              return _context301.stop();
          }
        }
      }, _callee300, this, [[0, 12]]);
    }));
  });
  s(this, "getCompetitionById", function (t, e) {
    return u(_this101, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee301() {
      return _regeneratorRuntime.wrap(function _callee301$(_context302) {
        while (1) {
          switch (_context302.prev = _context302.next) {
            case 0:
              _context302.prev = 0;
              e = e || !1;
              _context302.next = 4;
              return this.https.getCompetitionById(t, e);

            case 4:
              return _context302.abrupt("return", _context302.sent);

            case 7:
              _context302.prev = 7;
              _context302.t0 = _context302["catch"](0);
              throw console.warn("There was a problem retrieving the competition with the following id: ".concat(t), _context302.t0), _context302.t0;

            case 10:
            case "end":
              return _context302.stop();
          }
        }
      }, _callee301, this, [[0, 7]]);
    }));
  });
  s(this, "getTopCompetitionsIdMapping", function (t) {
    return u(_this101, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee302() {
      var _e8;

      return _regeneratorRuntime.wrap(function _callee302$(_context303) {
        while (1) {
          switch (_context303.prev = _context303.next) {
            case 0:
              _context303.prev = 0;
              _context303.next = 3;
              return this.getTopCompetitions(t);

            case 3:
              _e8 = _context303.sent;
              _context303.next = 6;
              return this.idMapping.remapEntities(_e8, "competition");

            case 6:
              return _context303.abrupt("return", _context303.sent);

            case 9:
              _context303.prev = 9;
              _context303.t0 = _context303["catch"](0);
              throw console.warn("There was a problem browsing the top competitions", _context303.t0), _context303.t0;

            case 12:
            case "end":
              return _context303.stop();
          }
        }
      }, _callee302, this, [[0, 9]]);
    }));
  });
  s(this, "getTopCompetitions", function (t) {
    return u(_this101, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee303() {
      return _regeneratorRuntime.wrap(function _callee303$(_context304) {
        while (1) {
          switch (_context304.prev = _context304.next) {
            case 0:
              _context304.prev = 0;
              t = t || !1;
              _context304.next = 4;
              return this.https.getTopCompetitions(t);

            case 4:
              return _context304.abrupt("return", _context304.sent);

            case 7:
              _context304.prev = 7;
              _context304.t0 = _context304["catch"](0);
              throw console.warn("There was a problem retrieving the top competitions", _context304.t0), _context304.t0;

            case 10:
            case "end":
              return _context304.stop();
          }
        }
      }, _callee303, this, [[0, 7]]);
    }));
  });
  this.localStorage = t, this.idMapping = i, this.https = e;
},
    vc = function vc(t) {
  var _this102 = this;

  _classCallCheck(this, vc);

  s(this, "name", null);
  s(this, "countryId", null);
  s(this, "national", !1);
  s(this, "gender", null);
  s(this, "limit", null);
  s(this, "page", null);
  s(this, "scope", null);
  s(this, "sortField", null);
  s(this, "sortOrder", null);
  s(this, "teamIds", null);
  s(this, "constructFilterUrl", function () {
    var t = "";
    return _this102.name && (t = t + "&", t = t + "name=".concat(_this102.name)), _this102.countryId && (t = t + "&", t = t + "country_id=".concat(_this102.countryId)), _this102.national && (t = t + "&", t = t + "national=".concat(_this102.national)), _this102.gender && (t = t + "&", t = t + "gender=".concat(_this102.gender)), _this102.limit && (t = t + "&", t = t + "limit=".concat(_this102.limit)), _this102.scope && (t = t + "&", t = t + "scope=".concat(_this102.scope.join(","))), _this102.page && (t = t + "&", t = t + "page=".concat(_this102.page)), _this102.sortField && (t = t + "&", t = t + "sort_field=".concat(_this102.sortField)), _this102.sortOrder && (t = t + "&", t = t + "sort_order=".concat(_this102.sortOrder)), _this102.teamIds && (t = t + "&", t = t + "team_ids=".concat(_this102.teamIds.join(","))), t;
  });
  this.name = t.name ? t.name : null, this.countryId = t.countryId ? "".concat(t.countryId) : null, this.national = t.national ? t.national : !1, this.gender = t.gender ? t.gender : null, this.limit = t.limit ? t.limit : null, this.page = t.page ? t.page : null, this.scope = t.scope ? t.scope : null, this.sortField = t.sortField ? "".concat(t.sortField) : null, this.sortOrder = t.sortOrder ? "".concat(t.sortOrder) : null, this.teamIds = t.teamIds ? t.teamIds : null;
},
    JT = function JT() {
  _classCallCheck(this, JT);

  s(this, "reason", "");
  s(this, "words", []);
},
    Wh = function Wh() {
  _classCallCheck(this, Wh);

  s(this, "enabled", !1);
  s(this, "moderateLinks", !1);
  s(this, "linksWhitelist", []);
  s(this, "moderatorProfileId", "");
  s(this, "dictionary", new JT());
},
    XT = function XT() {
  _classCallCheck(this, XT);

  s(this, "enabled", !1);
  s(this, "clientId", null);
  s(this, "automaticModeration", new Wh());
},
    ZT = function ZT() {
  _classCallCheck(this, ZT);

  s(this, "general", []);
  s(this, "predictor", []);
  s(this, "topX", []);
  s(this, "matchQuiz", []);
},
    Co = function Co() {
  _classCallCheck(this, Co);

  s(this, "points", null);
  s(this, "gameParticipationCount", null);
  s(this, "entityId", null);
  s(this, "entityType", null);
  s(this, "predictionsMade", null);
  s(this, "correctPredictions", null);
},
    e1 = function e1() {
  _classCallCheck(this, e1);

  s(this, "id");
  s(this, "label");
  s(this, "assets", {
    mainImageUrl: ""
  });
  s(this, "enabled");
  s(this, "requirements", new Co());
},
    Gh =
/*#__PURE__*/
function (_Co) {
  _inherits(Gh, _Co);

  function Gh() {
    var _this103;

    _classCallCheck(this, Gh);

    _this103 = _possibleConstructorReturn(this, _getPrototypeOf(Gh).apply(this, arguments));
    s(_assertThisInitialized(_this103), "postPoints", null);
    s(_assertThisInitialized(_this103), "postsCount", null);
    s(_assertThisInitialized(_this103), "reactionsCount", null);
    s(_assertThisInitialized(_this103), "totalDiscussionPoints", null);
    return _this103;
  }

  return Gh;
}(Co),
    t1 = function t1() {
  _classCallCheck(this, t1);

  s(this, "id");
  s(this, "label");
  s(this, "assets", {
    mainImageUrl: ""
  });
  s(this, "enabled");
  s(this, "requirements", new Gh());
},
    i1 = function i1() {
  _classCallCheck(this, i1);

  s(this, "id");
  s(this, "weight");
  s(this, "multiplier");
  s(this, "conditions");
},
    n1 = function n1() {
  _classCallCheck(this, n1);

  s(this, "value", [new i1()]);
},
    zh = function zh() {
  _classCallCheck(this, zh);

  s(this, "points", null);
  s(this, "tiers", null);
  s(this, "badges", null);
},
    r1 = function r1() {
  _classCallCheck(this, r1);

  s(this, "enabled", !1);
  s(this, "clientId", null);
  s(this, "conditions", {
    list: null
  });
  s(this, "actions", new n1());
  s(this, "rewards", new zh());
},
    s1 = function s1() {
  _classCallCheck(this, s1);

  s(this, "general", null);
  s(this, "predictor", null);
  s(this, "activity", null);
  s(this, "topX", null);
  s(this, "matchQuiz", null);
  s(this, "discussionPost", null);
},
    qh = function qh() {
  _classCallCheck(this, qh);

  s(this, "enabled", !1);
  s(this, "clientId", null);
  s(this, "defaultMarkets", null);
  s(this, "competitionsWhitelist", null);
},
    Qh = function Qh() {
  _classCallCheck(this, Qh);

  s(this, "enabled", !1);
  s(this, "clientId", null);
  s(this, "minFixtures", null);
  s(this, "maxFixtures", null);
  s(this, "competitionsWhitelist", null);
},
    a1 = function a1() {
  _classCallCheck(this, a1);

  s(this, "competitions", []);
  s(this, "teams", []);
  s(this, "markets", []);
},
    Yh = function Yh() {
  _classCallCheck(this, Yh);

  s(this, "enabled", !1);
  s(this, "clientId", null);
  s(this, "fullCoverageCompetitions", null);
  s(this, "markets", null);
  s(this, "successRateScopes", new a1());
  s(this, "userDataConfig", null);
},
    o1 = function o1() {
  _classCallCheck(this, o1);

  s(this, "storeIp", !1);
  s(this, "storeDeviceId", !1);
  s(this, "storeAgent", !1);
},
    l1 = function l1() {
  var _this104 = this;

  _classCallCheck(this, l1);

  s(this, "remapPredictorConfig", function (t) {
    var e = new Yh();
    return e.enabled = t.enabled, e.clientId = t.client_id, e.fullCoverageCompetitions = t.full_coverage_competitions, e.markets = t.markets, e.successRateScopes = t.success_rate_scopes, e.userDataConfig = t.user_data_config ? _this104.remapUserDataConfig(t.user_data_config) : null, e;
  });
  s(this, "remapTopXConfig", function (t) {
    var e = new Qh();
    return e.enabled = t.enabled, e.clientId = t.client_id, e.minFixtures = t.min_fixtures, e.maxFixtures = t.max_fixtures, e.competitionsWhitelist = t.competitions_whitelist, e;
  });
  s(this, "remapMatchQuizConfig", function (t) {
    var e = new qh();
    return e.enabled = t.enabled, e.clientId = t.client_id, e.defaultMarkets = t.default_markets, e.competitionsWhitelist = t.competitions_whitelist, e;
  });
  s(this, "remapLoyaltyConfig", function (t) {
    var e = new r1();
    return e.enabled = t.enabled, e.clientId = t.client_id, e.conditions.list = t.conditions.list, e.actions.value = t.actions.value, e.rewards = _this104.remapRewards(t.rewards), e;
  });
  s(this, "remapDiscussionsConfig", function (t) {
    var e = new XT();
    return e.enabled = t.enabled, e.clientId = t.client_id, e.automaticModeration = t.automatic_moderation ? _this104.remapAutomaticModeration(t.automatic_moderation) : null, e;
  });
  s(this, "remapAutomaticModeration", function (t) {
    var e = new Wh();
    return e.enabled = t.enabled, e.moderateLinks = t.moderate_links, e.linksWhitelist = t.links_whitelist, e.moderatorProfileId = t.moderator_profile_id, e.dictionary = t.dictionary, e;
  });
  s(this, "remapRewards", function (t) {
    var e = new zh();
    return e.points = _this104.remapPoints(t.points), e.tiers = t.tiers, e.badges = _this104.remapBadges(t.badges), e;
  });
  s(this, "remapPoints", function (t) {
    var e = new s1();
    return e.general = t.general, e.discussionPost = t.discussion_post, e.predictor = t.predictor, e.activity = t.activity, e.topX = t.top_x, e.matchQuiz = t.match_quiz, e;
  });
  s(this, "remapBadges", function (t) {
    var e = new ZT();
    return e.general = _this104.remapGeneralBadgeValues(t.general), e.predictor = _this104.remapBadgeValues(t.predictor), e.topX = _this104.remapBadgeValues(t.top_x), e.matchQuiz = _this104.remapBadgeValues(t.match_quiz), e;
  });
  s(this, "remapBadgeValues", function (t) {
    return t.map(function (e) {
      var i = new e1();
      return i.id = e.id, i.label = e.label, i.enabled = e.enabled, e.assets ? i.assets.mainImageUrl = e.assets.main_image_url : i.assets = e.assets, i.requirements = _this104.remapRequirements(e.requirements), i;
    });
  });
  s(this, "remapRequirements", function (t) {
    var e = new Co();
    return e.points = t.points, e.gameParticipationCount = t.game_participation_count, e.entityId = t.entity_id, e.entityType = t.entity_type, e.predictionsMade = t.predictions_made, e.correctPredictions = t.correct_predictions, e;
  });
  s(this, "remapUserDataConfig", function (t) {
    var e = new o1();
    return e.storeIp = t.store_ip, e.storeDeviceId = t.store_device_id, e.storeAgent = t.store_agent, e;
  });
  s(this, "remapGeneralBadgeValues", function (t) {
    return t.map(function (e) {
      var i = new t1();
      return i.id = e.id, i.label = e.label, i.enabled = e.enabled, e.assets ? i.assets.mainImageUrl = e.assets.main_image_url : i.assets = e.assets, i.requirements = _this104.remapGeneralRequirements(e.requirements), i;
    });
  });
  s(this, "remapGeneralRequirements", function (t) {
    var e = new Gh();
    return e.points = t.points, e.gameParticipationCount = t.game_participation_count, e.entityId = t.entity_id, e.entityType = t.entity_type, e.predictionsMade = t.predictions_made, e.correctPredictions = t.correct_predictions, e.postPoints = t.post_points, e.postsCount = t.posts_count, e.reactionsCount = t.reactions_count, e.totalDiscussionPoints = t.total_discussion_points, e;
  });
},
    Ni =
/*#__PURE__*/
function (_St3) {
  _inherits(Ni, _St3);

  function Ni(e) {
    var _this105;

    _classCallCheck(this, Ni);

    _this105 = _possibleConstructorReturn(this, _getPrototypeOf(Ni).call(this, e, Ct(e.environment, "client")));
    s(_assertThisInitialized(_this105), "featureConfigRemapper", null);
    s(_assertThisInitialized(_this105), "localStorage", null);
    s(_assertThisInitialized(_this105), "clientId", null);
    s(_assertThisInitialized(_this105), "getConfig", function (e) {
      return u(_assertThisInitialized(_this105), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee304() {
        var i, n, _r24, a, o;

        return _regeneratorRuntime.wrap(function _callee304$(_context305) {
          while (1) {
            switch (_context305.prev = _context305.next) {
              case 0:
                i = this.getCachedFeatures();

                if (i) {
                  _context305.next = 7;
                  break;
                }

                n = "/clients/".concat(this.clientId, "/features"), _r24 = this.apiSignInUrl.split("&")[0], a = n + _r24, o = "There was a problem fetching client features from Client API";
                _context305.next = 5;
                return this.fetchWithoutAuth(a, o);

              case 5:
                i = _context305.sent.data;
                this.localStorage.setClientFeatures(i);

              case 7:
                _context305.t0 = e;
                _context305.next = _context305.t0 === "predictor" ? 10 : _context305.t0 === "topX" ? 11 : _context305.t0 === "matchQuiz" ? 12 : _context305.t0 === "loyalty" ? 13 : _context305.t0 === "discussions" ? 14 : 15;
                break;

              case 10:
                return _context305.abrupt("return", this.featureConfigRemapper.remapPredictorConfig(i.predictor));

              case 11:
                return _context305.abrupt("return", this.featureConfigRemapper.remapTopXConfig(i.top_x));

              case 12:
                return _context305.abrupt("return", this.featureConfigRemapper.remapMatchQuizConfig(i.match_quiz));

              case 13:
                return _context305.abrupt("return", this.featureConfigRemapper.remapLoyaltyConfig(i.loyalty));

              case 14:
                return _context305.abrupt("return", this.featureConfigRemapper.remapDiscussionsConfig(i.discussions));

              case 15:
              case "end":
                return _context305.stop();
            }
          }
        }, _callee304, this);
      }));
    });
    s(_assertThisInitialized(_this105), "getCachedFeatures", function () {
      var e = _this105.getLocalStorageData();

      if (!(!e || !Object.keys(e).length)) return e.predictor.client_id && e.predictor.client_id !== _this105.clientId ? (_this105.localStorage.deleteClientFeatures(), null) : e;
    });
    s(_assertThisInitialized(_this105), "getLocalStorageData", function () {
      var e = Math.floor(Date.now() / 1e3);
      return _this105.localStorage.getExpiration("client", "features") > e ? _this105.localStorage.getClientFeatures() : null;
    });
    _this105.clientId = e.clientId, _this105.localStorage = new Cn().createLocalCacheInstance(e.idSchema), _this105.featureConfigRemapper = new l1();
    return _this105;
  }

  return Ni;
}(St),
    So = function So(t) {
  var _this106 = this;

  _classCallCheck(this, So);

  s(this, "clientHttps", null);
  s(this, "setAvailableMarketsForMatch", function (t) {
    return u(_this106, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee305() {
      var _this107 = this;

      var _ref56, e, i;

      return _regeneratorRuntime.wrap(function _callee305$(_context306) {
        while (1) {
          switch (_context306.prev = _context306.next) {
            case 0:
              _context306.next = 2;
              return this.clientHttps.getConfig("predictor");

            case 2:
              _ref56 = _context306.sent;
              e = _ref56.fullCoverageCompetitions;
              i = _ref56.markets;

              if (!Array.isArray(t)) {
                _context306.next = 7;
                break;
              }

              return _context306.abrupt("return", t.map(function (n) {
                return _this107.setAvailableMarkets(n, e, i);
              }));

            case 7:
              if (!(typeof t == "object" && Object.keys(t).length)) {
                _context306.next = 9;
                break;
              }

              return _context306.abrupt("return", this.setAvailableMarkets(t, e, i));

            case 9:
            case "end":
              return _context306.stop();
          }
        }
      }, _callee305, this);
    }));
  });
  s(this, "setAvailableMarkets", function (t, e, i) {
    var r;
    var n = (r = t.context.competition) == null ? void 0 : r.id;
    return n && _this106.isMatchInCoverageCompetition(n, e) ? (t.availableMarkets = i.all, t) : (t.availableMarkets = i.main, t);
  });
  s(this, "isMatchInCoverageCompetition", function (t, e) {
    var i = !1;
    return e.includes(t) && (i = !0), i;
  });
  this.clientHttps = new Ni(t);
},
    c1 = function c1(t, e, i) {
  var _this108 = this;

  _classCallCheck(this, c1);

  s(this, "footballService", null);
  s(this, "https", null);
  s(this, "idMapping", null);
  s(this, "getTeamsIdMapping", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee306() {
      var _i28, _r25, _r26, _r27, n;

      return _regeneratorRuntime.wrap(function _callee306$(_context307) {
        while (1) {
          switch (_context307.prev = _context307.next) {
            case 0:
              _context307.prev = 0;
              _i28 = !1;

              if (!t) {
                _context307.next = 18;
                break;
              }

              if (!(t = new vc(t), t.countryId)) {
                _context307.next = 8;
                break;
              }

              _context307.next = 6;
              return this.idMapping.getEntityIdsBySchemaId(["".concat(t.countryId)], "country", "native");

            case 6:
              _r25 = _context307.sent;
              _r25.country.length === 0 && (_i28 = !0), t.countryId = _r25.country[0];

            case 8:
              if (!t.scope) {
                _context307.next = 13;
                break;
              }

              _context307.next = 11;
              return this.idMapping.getEntityIdsBySchemaId(t.scope, "competition", "native");

            case 11:
              _r26 = _context307.sent;
              _r26.competition.length === 0 && (_i28 = !0), t.scope = _r26.competition;

            case 13:
              if (!t.teamIds) {
                _context307.next = 18;
                break;
              }

              _context307.next = 16;
              return this.idMapping.getEntityIdsBySchemaId(t.teamIds, "team", "native");

            case 16:
              _r27 = _context307.sent;
              _r27.team.length === 0 && (_i28 = !0), t.teamIds = _r27.team;

            case 18:
              if (!_i28) {
                _context307.next = 20;
                break;
              }

              return _context307.abrupt("return", []);

            case 20:
              _context307.next = 22;
              return this.getTeams(t, e);

            case 22:
              n = _context307.sent;
              _context307.next = 25;
              return this.idMapping.remapEntities(n.data, "team");

            case 25:
              n.data = _context307.sent;
              return _context307.abrupt("return", n);

            case 29:
              _context307.prev = 29;
              _context307.t0 = _context307["catch"](0);
              throw console.warn("There was a problem browsing all teams", _context307.t0), _context307.t0;

            case 32:
            case "end":
              return _context307.stop();
          }
        }
      }, _callee306, this, [[0, 29]]);
    }));
  });
  s(this, "getTeamsMapWithNativeIds", function (t) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee307() {
      var e, i, n, _ref57, r, a, o;

      return _regeneratorRuntime.wrap(function _callee307$(_context308) {
        while (1) {
          switch (_context308.prev = _context308.next) {
            case 0:
              e =
              /* @__PURE__ */
              new Map();
              i = t.length;
              n = new vc({
                teamIds: t,
                limit: i
              });
              _context308.next = 5;
              return this.getTeams(n);

            case 5:
              _ref57 = _context308.sent;
              r = _ref57.data;
              r.sort(function (l, c) {
                return l.id.localeCompare(c.id);
              });
              a = $h(t);
              _context308.next = 11;
              return this.idMapping.remapEntities(r, "team");

            case 11:
              o = _context308.sent;
              return _context308.abrupt("return", (a.forEach(function (l, c) {
                return e.set(l, o[c]);
              }), e));

            case 13:
            case "end":
              return _context308.stop();
          }
        }
      }, _callee307, this);
    }));
  });
  s(this, "getTeams", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee308() {
      return _regeneratorRuntime.wrap(function _callee308$(_context309) {
        while (1) {
          switch (_context309.prev = _context309.next) {
            case 0:
              _context309.prev = 0;
              e = e || !1;
              _context309.next = 4;
              return this.https.getTeams(t, e);

            case 4:
              return _context309.abrupt("return", _context309.sent);

            case 7:
              _context309.prev = 7;
              _context309.t0 = _context309["catch"](0);
              throw console.warn("There was a problem retrieving all teams", _context309.t0), _context309.t0;

            case 10:
            case "end":
              return _context309.stop();
          }
        }
      }, _callee308, this, [[0, 7]]);
    }));
  });
  s(this, "getTeamByIdIdMapping", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee309() {
      var _i29;

      return _regeneratorRuntime.wrap(function _callee309$(_context310) {
        while (1) {
          switch (_context310.prev = _context310.next) {
            case 0:
              _context310.prev = 0;
              _context310.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "team", "native");

            case 3:
              t = _context310.sent.team[0];
              _context310.next = 6;
              return this.getTeamById(t, e);

            case 6:
              _i29 = _context310.sent;
              _context310.next = 9;
              return this.idMapping.remapEntities(_i29, "team");

            case 9:
              return _context310.abrupt("return", _context310.sent);

            case 12:
              _context310.prev = 12;
              _context310.t0 = _context310["catch"](0);
              throw console.warn("There was a problem browsing the following team:".concat(t), _context310.t0), _context310.t0;

            case 15:
            case "end":
              return _context310.stop();
          }
        }
      }, _callee309, this, [[0, 12]]);
    }));
  });
  s(this, "getTeamById", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee310() {
      return _regeneratorRuntime.wrap(function _callee310$(_context311) {
        while (1) {
          switch (_context311.prev = _context311.next) {
            case 0:
              _context311.prev = 0;
              e = e || !1;
              _context311.next = 4;
              return this.https.getTeamById(t, e);

            case 4:
              return _context311.abrupt("return", _context311.sent);

            case 7:
              _context311.prev = 7;
              _context311.t0 = _context311["catch"](0);
              throw console.warn("There was a problem retrieving the following team: ".concat(t), _context311.t0), _context311.t0;

            case 10:
            case "end":
              return _context311.stop();
          }
        }
      }, _callee310, this, [[0, 7]]);
    }));
  });
  s(this, "getTopTeamsIdMapping", function (t) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee311() {
      var _e9;

      return _regeneratorRuntime.wrap(function _callee311$(_context312) {
        while (1) {
          switch (_context312.prev = _context312.next) {
            case 0:
              _context312.prev = 0;
              _context312.next = 3;
              return this.getTopTeams(t);

            case 3:
              _e9 = _context312.sent;
              _context312.next = 6;
              return this.idMapping.remapEntities(_e9, "team");

            case 6:
              return _context312.abrupt("return", _context312.sent);

            case 9:
              _context312.prev = 9;
              _context312.t0 = _context312["catch"](0);
              throw console.warn("There was a problem browsing the top teams", _context312.t0), _context312.t0;

            case 12:
            case "end":
              return _context312.stop();
          }
        }
      }, _callee311, this, [[0, 9]]);
    }));
  });
  s(this, "getTopTeams", function (t) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee312() {
      return _regeneratorRuntime.wrap(function _callee312$(_context313) {
        while (1) {
          switch (_context313.prev = _context313.next) {
            case 0:
              _context313.prev = 0;
              t = t || !1;
              _context313.next = 4;
              return this.https.getTopTeams(t);

            case 4:
              return _context313.abrupt("return", _context313.sent);

            case 7:
              _context313.prev = 7;
              _context313.t0 = _context313["catch"](0);
              throw console.warn("There was a problem retrieving the top teams", _context313.t0), _context313.t0;

            case 10:
            case "end":
              return _context313.stop();
          }
        }
      }, _callee312, this, [[0, 7]]);
    }));
  });
  s(this, "getNextMatchForTeamIdMapping", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee313() {
      var _i30;

      return _regeneratorRuntime.wrap(function _callee313$(_context314) {
        while (1) {
          switch (_context314.prev = _context314.next) {
            case 0:
              _context314.prev = 0;
              _context314.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "team", "native");

            case 3:
              t = _context314.sent.team[0];
              _context314.next = 6;
              return this.getNextMatchForTeam(t, e);

            case 6:
              _i30 = _context314.sent;
              _context314.next = 9;
              return this.idMapping.remapEntities(_i30, "match");

            case 9:
              return _context314.abrupt("return", _context314.sent);

            case 12:
              _context314.prev = 12;
              _context314.t0 = _context314["catch"](0);
              throw console.warn("There was a problem browsing the next match for the following team:".concat(t), _context314.t0), _context314.t0;

            case 15:
            case "end":
              return _context314.stop();
          }
        }
      }, _callee313, this, [[0, 12]]);
    }));
  });
  s(this, "getNextMatchForTeam", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee314() {
      var _i31;

      return _regeneratorRuntime.wrap(function _callee314$(_context315) {
        while (1) {
          switch (_context315.prev = _context315.next) {
            case 0:
              _context315.prev = 0;
              e = e || !1;
              _context315.next = 4;
              return this.https.getNextMatchForTeam(t, e);

            case 4:
              _i31 = _context315.sent;
              _context315.next = 7;
              return this.footballService.setAvailableMarketsForMatch(_i31);

            case 7:
              return _context315.abrupt("return", _context315.sent);

            case 10:
              _context315.prev = 10;
              _context315.t0 = _context315["catch"](0);
              throw console.warn("There was a problem retrieving the next match for the following team: ".concat(t), _context315.t0), _context315.t0;

            case 13:
            case "end":
              return _context315.stop();
          }
        }
      }, _callee314, this, [[0, 10]]);
    }));
  });
  s(this, "getPrevMatchForTeamIdMapping", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee315() {
      var _i32;

      return _regeneratorRuntime.wrap(function _callee315$(_context316) {
        while (1) {
          switch (_context316.prev = _context316.next) {
            case 0:
              _context316.prev = 0;
              _context316.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "team", "native");

            case 3:
              t = _context316.sent.team[0];
              _context316.next = 6;
              return this.getPrevMatchForTeam(t, e);

            case 6:
              _i32 = _context316.sent;
              _context316.next = 9;
              return this.idMapping.remapEntities(_i32, "match");

            case 9:
              return _context316.abrupt("return", _context316.sent);

            case 12:
              _context316.prev = 12;
              _context316.t0 = _context316["catch"](0);
              throw console.warn("There was a problem browsing the previous match for the following team:".concat(t), _context316.t0), _context316.t0;

            case 15:
            case "end":
              return _context316.stop();
          }
        }
      }, _callee315, this, [[0, 12]]);
    }));
  });
  s(this, "getPrevMatchForTeam", function (t, e) {
    return u(_this108, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee316() {
      var _i33;

      return _regeneratorRuntime.wrap(function _callee316$(_context317) {
        while (1) {
          switch (_context317.prev = _context317.next) {
            case 0:
              _context317.prev = 0;
              e = e || !1;
              _context317.next = 4;
              return this.https.getPrevMatchForTeam(t, e);

            case 4:
              _i33 = _context317.sent;
              _context317.next = 7;
              return this.footballService.setAvailableMarketsForMatch(_i33);

            case 7:
              return _context317.abrupt("return", _context317.sent);

            case 10:
              _context317.prev = 10;
              _context317.t0 = _context317["catch"](0);
              throw console.warn("There was a problem retrieving the previous match for the following team: ".concat(t), _context317.t0), _context317.t0;

            case 13:
            case "end":
              return _context317.stop();
          }
        }
      }, _callee316, this, [[0, 10]]);
    }));
  });
  this.idMapping = i, this.https = e, this.footballService = new So(t);
},
    wc = function wc(t) {
  var _this109 = this;

  _classCallCheck(this, wc);

  s(this, "countryId", null);
  s(this, "scope", null);
  s(this, "name", null);
  s(this, "playerIds", null);
  s(this, "limit", null);
  s(this, "page", null);
  s(this, "sortField", null);
  s(this, "sortOrder", null);
  s(this, "constructFilterUrl", function () {
    var t = "";
    return _this109.countryId && (t = t + "&", t = t + "country_id=".concat(_this109.countryId)), _this109.scope && (t = t + "&", t = t + "scope=".concat(_this109.scope.join(","))), _this109.name && (t = t + "&", t = t + "name=".concat(_this109.name)), _this109.playerIds && (t = t + "&", t = t + "player_ids=".concat(_this109.playerIds.join(","))), _this109.limit && (t = t + "&", t = t + "limit=".concat(_this109.limit)), _this109.page && (t = t + "&", t = t + "page=".concat(_this109.page)), _this109.sortField && (t = t + "&", t = t + "sort_field=".concat(_this109.sortField)), _this109.sortOrder && (t = t + "&", t = t + "sort_order=".concat(_this109.sortOrder)), t;
  });
  this.countryId = t.countryId ? t.countryId : null, this.scope = t.scope ? t.scope : null, this.name = t.name ? t.name : null, this.playerIds = t.playerIds ? t.playerIds : null, this.limit = t.limit ? t.limit : null, this.page = t.page ? t.page : null, this.sortField = t.sortField ? t.sortField : null, this.sortOrder = t.sortOrder ? t.sortOrder : null;
},
    To = function To(t, e, i) {
  var _this110 = this;

  _classCallCheck(this, To);

  s(this, "https", null);
  s(this, "footballService", null);
  s(this, "idMapping", null);
  s(this, "getPlayersIdMapping", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee317() {
      var _i34, _r28, _r29, _r30, n;

      return _regeneratorRuntime.wrap(function _callee317$(_context318) {
        while (1) {
          switch (_context318.prev = _context318.next) {
            case 0:
              _context318.prev = 0;
              _i34 = !1;

              if (!t) {
                _context318.next = 20;
                break;
              }

              if (!(t = new wc(t), t.countryId)) {
                _context318.next = 8;
                break;
              }

              _context318.next = 6;
              return this.idMapping.getEntityIdsBySchemaId([t.countryId], "country", "native");

            case 6:
              _r28 = _context318.sent;
              _r28.country.length === 0 && (_i34 = !0), t.countryId = _r28.country[0];

            case 8:
              if (!t.playerIds) {
                _context318.next = 13;
                break;
              }

              _context318.next = 11;
              return this.idMapping.getEntityIdsBySchemaId(t.playerIds, "player", "native");

            case 11:
              _r29 = _context318.sent;
              _r29.player.length === 0 && (_i34 = !0), t.playerIds = _r29.player;

            case 13:
              if (!t.scope) {
                _context318.next = 18;
                break;
              }

              _context318.next = 16;
              return this.idMapping.getEntityIdsBySchemaId(t.scope, "competition", "native");

            case 16:
              _r30 = _context318.sent;
              _r30.competition.length === 0 && (_i34 = !0), t.scope = _r30.competition;

            case 18:
              if (!_i34) {
                _context318.next = 20;
                break;
              }

              return _context318.abrupt("return", []);

            case 20:
              _context318.next = 22;
              return this.getPlayers(t, e);

            case 22:
              n = _context318.sent;
              _context318.next = 25;
              return this.idMapping.remapEntities(n.data, "player");

            case 25:
              n.data = _context318.sent;
              return _context318.abrupt("return", n);

            case 29:
              _context318.prev = 29;
              _context318.t0 = _context318["catch"](0);
              throw console.warn("There was a problem browsing the players", _context318.t0), _context318.t0;

            case 32:
            case "end":
              return _context318.stop();
          }
        }
      }, _callee317, this, [[0, 29]]);
    }));
  });
  s(this, "getPlayersWithNativeIds", function (t) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee318() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee318$(_context319) {
        while (1) {
          switch (_context319.prev = _context319.next) {
            case 0:
              e = t.length;
              i = new wc({
                playerIds: t,
                limit: e
              });
              _context319.next = 4;
              return this.getPlayers(i);

            case 4:
              n = _context319.sent;
              n.data.sort(function (r, a) {
                return r.id.localeCompare(a.id);
              });
              _context319.next = 8;
              return this.idMapping.remapEntities(n.data, "player");

            case 8:
              return _context319.abrupt("return", _context319.sent);

            case 9:
            case "end":
              return _context319.stop();
          }
        }
      }, _callee318, this);
    }));
  });
  s(this, "getPlayersMapWithNativeIds", function (t) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee319() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee319$(_context320) {
        while (1) {
          switch (_context320.prev = _context320.next) {
            case 0:
              e = {}, i = as(t);
              i.sort(function (r, a) {
                return r.localeCompare(a);
              });
              _context320.next = 4;
              return this.getPlayersWithNativeIds(i);

            case 4:
              n = _context320.sent;
              return _context320.abrupt("return", (i.forEach(function (r, a) {
                return e[r] = n[a];
              }), e));

            case 6:
            case "end":
              return _context320.stop();
          }
        }
      }, _callee319, this);
    }));
  });
  s(this, "getPlayers", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee320() {
      return _regeneratorRuntime.wrap(function _callee320$(_context321) {
        while (1) {
          switch (_context321.prev = _context321.next) {
            case 0:
              _context321.prev = 0;
              e = e || !1;
              _context321.next = 4;
              return this.https.getPlayers(t, e);

            case 4:
              return _context321.abrupt("return", _context321.sent);

            case 7:
              _context321.prev = 7;
              _context321.t0 = _context321["catch"](0);
              throw console.warn("There was a problem retrieving the players", _context321.t0), _context321.t0;

            case 10:
            case "end":
              return _context321.stop();
          }
        }
      }, _callee320, this, [[0, 7]]);
    }));
  });
  s(this, "getPlayerIdMapping", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee321() {
      var _i35, n;

      return _regeneratorRuntime.wrap(function _callee321$(_context322) {
        while (1) {
          switch (_context322.prev = _context322.next) {
            case 0:
              _context322.prev = 0;
              _context322.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "player", "native");

            case 3:
              _i35 = _context322.sent;
              _context322.next = 6;
              return this.getPlayerById(_i35.player[0], e);

            case 6:
              n = _context322.sent;
              _context322.next = 9;
              return this.idMapping.remapEntities(n, "player");

            case 9:
              return _context322.abrupt("return", _context322.sent);

            case 12:
              _context322.prev = 12;
              _context322.t0 = _context322["catch"](0);
              throw console.warn("There was a problem browsing the following player:".concat(t), _context322.t0), _context322.t0;

            case 15:
            case "end":
              return _context322.stop();
          }
        }
      }, _callee321, this, [[0, 12]]);
    }));
  });
  s(this, "getPlayerById", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee322() {
      return _regeneratorRuntime.wrap(function _callee322$(_context323) {
        while (1) {
          switch (_context323.prev = _context323.next) {
            case 0:
              _context323.prev = 0;
              e = e || !1;
              _context323.next = 4;
              return this.https.getPlayerById(t, e);

            case 4:
              return _context323.abrupt("return", _context323.sent);

            case 7:
              _context323.prev = 7;
              _context323.t0 = _context323["catch"](0);
              throw console.warn("There was a problem retrieving the following player: ".concat(t), _context323.t0), _context323.t0;

            case 10:
            case "end":
              return _context323.stop();
          }
        }
      }, _callee322, this, [[0, 7]]);
    }));
  });
  s(this, "getTopPlayersIdMapping", function (t) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee323() {
      var _e10;

      return _regeneratorRuntime.wrap(function _callee323$(_context324) {
        while (1) {
          switch (_context324.prev = _context324.next) {
            case 0:
              _context324.prev = 0;
              _context324.next = 3;
              return this.getTopPlayers(t);

            case 3:
              _e10 = _context324.sent;
              _context324.next = 6;
              return this.idMapping.remapEntities(_e10, "player");

            case 6:
              return _context324.abrupt("return", _context324.sent);

            case 9:
              _context324.prev = 9;
              _context324.t0 = _context324["catch"](0);
              throw console.warn("There was a problem browsing the top players", _context324.t0), _context324.t0;

            case 12:
            case "end":
              return _context324.stop();
          }
        }
      }, _callee323, this, [[0, 9]]);
    }));
  });
  s(this, "getTopPlayers", function (t) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee324() {
      return _regeneratorRuntime.wrap(function _callee324$(_context325) {
        while (1) {
          switch (_context325.prev = _context325.next) {
            case 0:
              _context325.prev = 0;
              t = t || !1;
              _context325.next = 4;
              return this.https.getTopPlayers(t);

            case 4:
              return _context325.abrupt("return", _context325.sent);

            case 7:
              _context325.prev = 7;
              _context325.t0 = _context325["catch"](0);
              throw console.warn("There was a problem retrieving the top players", _context325.t0), _context325.t0;

            case 10:
            case "end":
              return _context325.stop();
          }
        }
      }, _callee324, this, [[0, 7]]);
    }));
  });
  s(this, "getNextMatchForPlayerIdMapping", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee325() {
      var _i36;

      return _regeneratorRuntime.wrap(function _callee325$(_context326) {
        while (1) {
          switch (_context326.prev = _context326.next) {
            case 0:
              _context326.prev = 0;
              _context326.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "player", "native");

            case 3:
              t = _context326.sent.player[0];
              _context326.next = 6;
              return this.getNextMatchForPlayer(t, e);

            case 6:
              _i36 = _context326.sent;
              _context326.next = 9;
              return this.idMapping.remapEntities(_i36, "match");

            case 9:
              return _context326.abrupt("return", _context326.sent);

            case 12:
              _context326.prev = 12;
              _context326.t0 = _context326["catch"](0);
              throw console.warn("There was a problem browsing the next match for player:".concat(t), _context326.t0), _context326.t0;

            case 15:
            case "end":
              return _context326.stop();
          }
        }
      }, _callee325, this, [[0, 12]]);
    }));
  });
  s(this, "getNextMatchForPlayer", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee326() {
      var _i37;

      return _regeneratorRuntime.wrap(function _callee326$(_context327) {
        while (1) {
          switch (_context327.prev = _context327.next) {
            case 0:
              _context327.prev = 0;
              e = e || !1;
              _context327.next = 4;
              return this.https.getNextMatchForPlayer(t, e);

            case 4:
              _i37 = _context327.sent;
              _context327.next = 7;
              return this.footballService.setAvailableMarketsForMatch(_i37);

            case 7:
              return _context327.abrupt("return", _context327.sent);

            case 10:
              _context327.prev = 10;
              _context327.t0 = _context327["catch"](0);
              throw console.warn("There was a problem retrieving the next match for player: ".concat(t), _context327.t0), _context327.t0;

            case 13:
            case "end":
              return _context327.stop();
          }
        }
      }, _callee326, this, [[0, 10]]);
    }));
  });
  s(this, "getPrevMatchForPlayerIdMapping", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee327() {
      var _i38;

      return _regeneratorRuntime.wrap(function _callee327$(_context328) {
        while (1) {
          switch (_context328.prev = _context328.next) {
            case 0:
              _context328.prev = 0;
              _context328.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "player", "native");

            case 3:
              t = _context328.sent.player[0];
              _context328.next = 6;
              return this.getPrevMatchForPlayer(t, e);

            case 6:
              _i38 = _context328.sent;
              _context328.next = 9;
              return this.idMapping.remapEntities(_i38, "match");

            case 9:
              return _context328.abrupt("return", _context328.sent);

            case 12:
              _context328.prev = 12;
              _context328.t0 = _context328["catch"](0);
              throw console.warn("There was a problem browsing the previous match for player:".concat(t), _context328.t0), _context328.t0;

            case 15:
            case "end":
              return _context328.stop();
          }
        }
      }, _callee327, this, [[0, 12]]);
    }));
  });
  s(this, "getPrevMatchForPlayer", function (t, e) {
    return u(_this110, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee328() {
      var _i39;

      return _regeneratorRuntime.wrap(function _callee328$(_context329) {
        while (1) {
          switch (_context329.prev = _context329.next) {
            case 0:
              _context329.prev = 0;
              e = e || !1;
              _context329.next = 4;
              return this.https.getPrevMatchForPlayer(t, e);

            case 4:
              _i39 = _context329.sent;
              _context329.next = 7;
              return this.footballService.setAvailableMarketsForMatch(_i39);

            case 7:
              return _context329.abrupt("return", _context329.sent);

            case 10:
              _context329.prev = 10;
              _context329.t0 = _context329["catch"](0);
              throw console.warn("There was a problem retrieving the previous match for player: ".concat(t), _context329.t0), _context329.t0;

            case 13:
            case "end":
              return _context329.stop();
          }
        }
      }, _callee328, this, [[0, 10]]);
    }));
  });
  this.idMapping = i, this.https = e, this.footballService = new So(t);
},
    Qs = function Qs(t) {
  var _this111 = this;

  _classCallCheck(this, Qs);

  s(this, "countryIds", null);
  s(this, "competitionIds", null);
  s(this, "matchIds", null);
  s(this, "status", null);
  s(this, "teamIds", null);
  s(this, "fromDate", null);
  s(this, "toDate", null);
  s(this, "limit", null);
  s(this, "page", null);
  s(this, "sortField", null);
  s(this, "sortOrder", null);
  s(this, "constructFilterUrl", function () {
    var t = "";
    return _this111.countryIds && (t = t + "&", t = t + "countries=".concat(_this111.countryIds.join(","))), _this111.competitionIds && (t = t + "&", t = t + "competitions=".concat(_this111.competitionIds.join(","))), _this111.matchIds && (t = t + "&", t = t + "matches=".concat(_this111.matchIds.join(","))), _this111.status && (t = t + "&", t = t + "status=".concat(_this111.status)), _this111.teamIds && (t = t + "&", t = t + "teams=".concat(_this111.teamIds.join(","))), _this111.fromDate && (t = t + "&", t = t + "from_date=".concat(_this111.fromDate)), _this111.toDate && (t = t + "&", t = t + "to_date=".concat(_this111.toDate)), _this111.limit && (t = t + "&", t = t + "limit=".concat(_this111.limit)), _this111.page && (t = t + "&", t = t + "page=".concat(_this111.page)), _this111.sortField && (t = t + "&", t = t + "sort_field=".concat(_this111.sortField)), _this111.sortOrder && (t = t + "&", t = t + "sort_order=".concat(_this111.sortOrder)), t;
  });
  this.countryIds = t.countryIds ? t.countryIds : null, this.competitionIds = t.competitionIds ? t.competitionIds : null, this.matchIds = t.matchIds ? t.matchIds : null, this.status = t.status ? t.status : null, this.teamIds = t.teamIds ? t.teamIds : null, this.fromDate = t.fromDate ? t.fromDate : null, this.toDate = t.toDate ? t.toDate : null, this.limit = t.limit ? t.limit : null, this.page = t.page ? t.page : null, this.sortField = t.sortField ? t.sortField : null, this.sortOrder = t.sortOrder ? t.sortOrder : null;
},
    Ro = function Ro(t, e, i) {
  var _this112 = this;

  _classCallCheck(this, Ro);

  s(this, "https", null);
  s(this, "idMapping", null);
  s(this, "footballService", null);
  s(this, "getMatchesIdMapping", function (t, e) {
    return u(_this112, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee329() {
      var n, _n5, _n6, _n7, _i40;

      return _regeneratorRuntime.wrap(function _callee329$(_context330) {
        while (1) {
          switch (_context330.prev = _context330.next) {
            case 0:
              _context330.prev = 0;

              if (!t) {
                _context330.next = 22;
                break;
              }

              if (!(t = new Qs(t), t.countryIds)) {
                _context330.next = 7;
                break;
              }

              _context330.next = 5;
              return this.idMapping.getEntityIdsBySchemaId(t.countryIds, "country", "native");

            case 5:
              n = _context330.sent;
              t.countryIds = n.country;

            case 7:
              if (!t.competitionIds) {
                _context330.next = 12;
                break;
              }

              _context330.next = 10;
              return this.idMapping.getEntityIdsBySchemaId(t.competitionIds, "competition", "native");

            case 10:
              _n5 = _context330.sent;
              t.competitionIds = _n5.competition;

            case 12:
              if (!t.matchIds) {
                _context330.next = 17;
                break;
              }

              _context330.next = 15;
              return this.idMapping.getEntityIdsBySchemaId(t.matchIds, "match", "native");

            case 15:
              _n6 = _context330.sent;
              t.matchIds = _n6.match;

            case 17:
              if (!t.teamIds) {
                _context330.next = 22;
                break;
              }

              _context330.next = 20;
              return this.idMapping.getEntityIdsBySchemaId(t.teamIds, "team", "native");

            case 20:
              _n7 = _context330.sent;
              t.teamIds = _n7.team;

            case 22:
              _context330.next = 24;
              return this.getMatches(t, e);

            case 24:
              _i40 = _context330.sent;
              _context330.next = 27;
              return this.footballService.setAvailableMarketsForMatch(_toConsumableArray(_i40.data));

            case 27:
              _i40.data = _context330.sent;
              _context330.next = 30;
              return this.idMapping.remapEntities(_i40.data, "match");

            case 30:
              _i40.data = _context330.sent;
              return _context330.abrupt("return", _i40);

            case 34:
              _context330.prev = 34;
              _context330.t0 = _context330["catch"](0);
              throw console.warn("There was a problem browsing the matches", _context330.t0), _context330.t0;

            case 37:
            case "end":
              return _context330.stop();
          }
        }
      }, _callee329, this, [[0, 34]]);
    }));
  });
  s(this, "getMatchesWithNativeIds", function (t) {
    return u(_this112, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee330() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee330$(_context331) {
        while (1) {
          switch (_context331.prev = _context331.next) {
            case 0:
              e = t.length;
              i = new Qs({
                matchIds: t,
                limit: e
              });
              _context331.next = 4;
              return this.getMatches(i);

            case 4:
              n = _context331.sent;
              n.data.sort(function (r, a) {
                return r.id.localeCompare(a.id);
              });
              _context331.next = 8;
              return this.idMapping.remapEntities(n.data, "match");

            case 8:
              return _context331.abrupt("return", _context331.sent);

            case 9:
            case "end":
              return _context331.stop();
          }
        }
      }, _callee330, this);
    }));
  });
  s(this, "getMatchesMapWithNativeIds", function (t) {
    return u(_this112, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee331() {
      var e, i, n, _r31, a, o;

      return _regeneratorRuntime.wrap(function _callee331$(_context332) {
        while (1) {
          switch (_context332.prev = _context332.next) {
            case 0:
              e = {}, i = as(t);
              i.sort(function (r, a) {
                return r.localeCompare(a);
              });
              _context332.next = 4;
              return this.getMatchesWithNativeIds(i);

            case 4:
              n = _context332.sent;

              if (!(i.length !== n.length)) {
                _context332.next = 12;
                break;
              }

              _r31 = new Qs({
                matchIds: i,
                limit: i.length
              });
              _context332.next = 9;
              return this.getMatches(_r31);

            case 9:
              a = _context332.sent;
              o = i.filter(function (l) {
                if (a.data.every(function (c) {
                  return c.id !== l;
                })) return l;
              });
              i = i.filter(function (l) {
                if (!o.includes(l)) return l;
              });

            case 12:
              return _context332.abrupt("return", (i.forEach(function (r, a) {
                return e[r] = n[a];
              }), e));

            case 13:
            case "end":
              return _context332.stop();
          }
        }
      }, _callee331, this);
    }));
  });
  s(this, "getMatches", function (t, e) {
    return u(_this112, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee332() {
      return _regeneratorRuntime.wrap(function _callee332$(_context333) {
        while (1) {
          switch (_context333.prev = _context333.next) {
            case 0:
              _context333.prev = 0;
              e = e || !1;
              _context333.next = 4;
              return this.https.getMatches(t, e);

            case 4:
              return _context333.abrupt("return", _context333.sent);

            case 7:
              _context333.prev = 7;
              _context333.t0 = _context333["catch"](0);
              throw console.warn("There was a problem retrieving the matches", _context333.t0), _context333.t0;

            case 10:
            case "end":
              return _context333.stop();
          }
        }
      }, _callee332, this, [[0, 7]]);
    }));
  });
  s(this, "getMatchIdMapping", function (t, e) {
    return u(_this112, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee333() {
      var _i41, n, _r32;

      return _regeneratorRuntime.wrap(function _callee333$(_context334) {
        while (1) {
          switch (_context334.prev = _context334.next) {
            case 0:
              _context334.prev = 0;
              _context334.next = 3;
              return this.idMapping.getEntityIdsBySchemaId([t], "match", "native");

            case 3:
              _i41 = _context334.sent;
              _context334.next = 6;
              return this.getMatchById(_i41.match[0], e);

            case 6:
              n = _context334.sent;
              _context334.next = 9;
              return this.footballService.setAvailableMarketsForMatch(n);

            case 9:
              _r32 = _context334.sent;
              _context334.next = 12;
              return this.idMapping.remapEntities(_r32, "match");

            case 12:
              return _context334.abrupt("return", _context334.sent);

            case 15:
              _context334.prev = 15;
              _context334.t0 = _context334["catch"](0);
              throw console.warn("There was a problem browsing the following match: ".concat(t), _context334.t0), _context334.t0;

            case 18:
            case "end":
              return _context334.stop();
          }
        }
      }, _callee333, this, [[0, 15]]);
    }));
  });
  s(this, "getMatchById", function (t, e) {
    return u(_this112, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee334() {
      return _regeneratorRuntime.wrap(function _callee334$(_context335) {
        while (1) {
          switch (_context335.prev = _context335.next) {
            case 0:
              _context335.prev = 0;
              e = e || !1;
              _context335.next = 4;
              return this.https.getMatchById(t, e);

            case 4:
              return _context335.abrupt("return", _context335.sent);

            case 7:
              _context335.prev = 7;
              _context335.t0 = _context335["catch"](0);
              throw console.warn("There was a problem retrieving the following match: ".concat(t), _context335.t0), _context335.t0;

            case 10:
            case "end":
              return _context335.stop();
          }
        }
      }, _callee334, this, [[0, 7]]);
    }));
  });
  this.https = e, this.idMapping = i, this.footballService = new So(t);
},
    u1 = function u1(t) {
  var _this113 = this;

  _classCallCheck(this, u1);

  s(this, "entities", null);
  s(this, "query", null);
  s(this, "scope", null);
  s(this, "constructFilterUrl", function () {
    var t = "";
    return _this113.entities && (t = t + "&", t = t + "entities=".concat(_this113.entities.join(","))), _this113.query && (t = t + "&", t = t + "q=".concat(_this113.query)), _this113.scope && (t = t + "&", t = t + "scope=".concat(_this113.scope.join(","))), t;
  });
  this.entities = t.entities ? t.entities : null, this.query = t.query ? t.query : null, this.scope = t.scope ? t.scope : null;
},
    d1 = function d1(t, e) {
  var _this114 = this;

  _classCallCheck(this, d1);

  s(this, "https", null);
  s(this, "idMapping", null);
  s(this, "searchIdMapping", function (t, e) {
    return u(_this114, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee335() {
      var n, i, _n8, _n9, _n10;

      return _regeneratorRuntime.wrap(function _callee335$(_context336) {
        while (1) {
          switch (_context336.prev = _context336.next) {
            case 0:
              _context336.prev = 0;

              if (!(t = new u1(t), t.scope)) {
                _context336.next = 6;
                break;
              }

              _context336.next = 4;
              return this.idMapping.getEntityIdsBySchemaId(t.scope, "competition", "native");

            case 4:
              n = _context336.sent;
              t.scope = n.competition;

            case 6:
              _context336.next = 8;
              return this.search(t, e);

            case 8:
              i = _context336.sent;

              if (!(i.teams && i.teams.length > 0)) {
                _context336.next = 14;
                break;
              }

              _context336.next = 12;
              return this.idMapping.remapEntities(i.teams, "team");

            case 12:
              _n8 = _context336.sent;
              i.teams = _n8;

            case 14:
              if (!(i.players && i.players.length > 0)) {
                _context336.next = 19;
                break;
              }

              _context336.next = 17;
              return this.idMapping.remapEntities(i.players, "player");

            case 17:
              _n9 = _context336.sent;
              i.players = _n9;

            case 19:
              if (!(i.competitions && i.competitions.length > 0)) {
                _context336.next = 24;
                break;
              }

              _context336.next = 22;
              return this.idMapping.remapEntities(i.competitions, "competition");

            case 22:
              _n10 = _context336.sent;
              i.competitions = _n10;

            case 24:
              return _context336.abrupt("return", i);

            case 27:
              _context336.prev = 27;
              _context336.t0 = _context336["catch"](0);
              throw console.warn("There was a problem with browsing the search result", _context336.t0), _context336.t0;

            case 30:
            case "end":
              return _context336.stop();
          }
        }
      }, _callee335, this, [[0, 27]]);
    }));
  });
  s(this, "search", function (t, e) {
    return u(_this114, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee336() {
      return _regeneratorRuntime.wrap(function _callee336$(_context337) {
        while (1) {
          switch (_context337.prev = _context337.next) {
            case 0:
              _context337.prev = 0;
              _context337.next = 3;
              return this.https.search(t, e);

            case 3:
              return _context337.abrupt("return", _context337.sent);

            case 6:
              _context337.prev = 6;
              _context337.t0 = _context337["catch"](0);
              throw console.warn("There was a problem retrieving the search response", _context337.t0), _context337.t0;

            case 9:
            case "end":
              return _context337.stop();
          }
        }
      }, _callee336, this, [[0, 6]]);
    }));
  });
  this.https = t, this.idMapping = e;
},
    Kh = function Kh(t, e, i, n) {
  var _this115 = this;

  _classCallCheck(this, Kh);

  s(this, "countriesFacade", null);
  s(this, "competitionsFacade", null);
  s(this, "teamsFacade", null);
  s(this, "playerFacade", null);
  s(this, "matchFacade", null);
  s(this, "searchFacade", null);
  s(this, "getCountries", function (t) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee337() {
      return _regeneratorRuntime.wrap(function _callee337$(_context338) {
        while (1) {
          switch (_context338.prev = _context338.next) {
            case 0:
              return _context338.abrupt("return", this.countriesFacade.getCountriesWithIdMapping(t));

            case 1:
            case "end":
              return _context338.stop();
          }
        }
      }, _callee337, this);
    }));
  });
  s(this, "getCompetitions", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee338() {
      return _regeneratorRuntime.wrap(function _callee338$(_context339) {
        while (1) {
          switch (_context339.prev = _context339.next) {
            case 0:
              return _context339.abrupt("return", this.competitionsFacade.getCompetitionsIdMapping(t, e));

            case 1:
            case "end":
              return _context339.stop();
          }
        }
      }, _callee338, this);
    }));
  });
  s(this, "getCompetitionById", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee339() {
      return _regeneratorRuntime.wrap(function _callee339$(_context340) {
        while (1) {
          switch (_context340.prev = _context340.next) {
            case 0:
              return _context340.abrupt("return", this.competitionsFacade.getCompetitionByIdIdMapping(t, e));

            case 1:
            case "end":
              return _context340.stop();
          }
        }
      }, _callee339, this);
    }));
  });
  s(this, "getTopCompetitions", function (t) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee340() {
      return _regeneratorRuntime.wrap(function _callee340$(_context341) {
        while (1) {
          switch (_context341.prev = _context341.next) {
            case 0:
              return _context341.abrupt("return", this.competitionsFacade.getTopCompetitionsIdMapping(t));

            case 1:
            case "end":
              return _context341.stop();
          }
        }
      }, _callee340, this);
    }));
  });
  s(this, "getCompetitionsMapWithNativeIds", function (t) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee341() {
      return _regeneratorRuntime.wrap(function _callee341$(_context342) {
        while (1) {
          switch (_context342.prev = _context342.next) {
            case 0:
              _context342.next = 2;
              return this.competitionsFacade.getCompetitionsMapWithNativeIds(t);

            case 2:
              return _context342.abrupt("return", _context342.sent);

            case 3:
            case "end":
              return _context342.stop();
          }
        }
      }, _callee341, this);
    }));
  });
  s(this, "getTeams", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee342() {
      return _regeneratorRuntime.wrap(function _callee342$(_context343) {
        while (1) {
          switch (_context343.prev = _context343.next) {
            case 0:
              return _context343.abrupt("return", this.teamsFacade.getTeamsIdMapping(t, e));

            case 1:
            case "end":
              return _context343.stop();
          }
        }
      }, _callee342, this);
    }));
  });
  s(this, "getTeamById", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee343() {
      return _regeneratorRuntime.wrap(function _callee343$(_context344) {
        while (1) {
          switch (_context344.prev = _context344.next) {
            case 0:
              return _context344.abrupt("return", this.teamsFacade.getTeamByIdIdMapping(t, e));

            case 1:
            case "end":
              return _context344.stop();
          }
        }
      }, _callee343, this);
    }));
  });
  s(this, "getTopTeams", function (t) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee344() {
      return _regeneratorRuntime.wrap(function _callee344$(_context345) {
        while (1) {
          switch (_context345.prev = _context345.next) {
            case 0:
              return _context345.abrupt("return", this.teamsFacade.getTopTeamsIdMapping(t));

            case 1:
            case "end":
              return _context345.stop();
          }
        }
      }, _callee344, this);
    }));
  });
  s(this, "getNextMatchForTeam", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee345() {
      return _regeneratorRuntime.wrap(function _callee345$(_context346) {
        while (1) {
          switch (_context346.prev = _context346.next) {
            case 0:
              return _context346.abrupt("return", this.teamsFacade.getNextMatchForTeamIdMapping(t, e));

            case 1:
            case "end":
              return _context346.stop();
          }
        }
      }, _callee345, this);
    }));
  });
  s(this, "getPrevMatchForTeam", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee346() {
      return _regeneratorRuntime.wrap(function _callee346$(_context347) {
        while (1) {
          switch (_context347.prev = _context347.next) {
            case 0:
              return _context347.abrupt("return", this.teamsFacade.getPrevMatchForTeamIdMapping(t, e));

            case 1:
            case "end":
              return _context347.stop();
          }
        }
      }, _callee346, this);
    }));
  });
  s(this, "getTeamsMapWithNativeIds", function (t) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee347() {
      return _regeneratorRuntime.wrap(function _callee347$(_context348) {
        while (1) {
          switch (_context348.prev = _context348.next) {
            case 0:
              _context348.next = 2;
              return this.teamsFacade.getTeamsMapWithNativeIds(t);

            case 2:
              return _context348.abrupt("return", _context348.sent);

            case 3:
            case "end":
              return _context348.stop();
          }
        }
      }, _callee347, this);
    }));
  });
  s(this, "getPlayers", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee348() {
      return _regeneratorRuntime.wrap(function _callee348$(_context349) {
        while (1) {
          switch (_context349.prev = _context349.next) {
            case 0:
              return _context349.abrupt("return", this.playerFacade.getPlayersIdMapping(t, e));

            case 1:
            case "end":
              return _context349.stop();
          }
        }
      }, _callee348, this);
    }));
  });
  s(this, "getPlayerById", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee349() {
      return _regeneratorRuntime.wrap(function _callee349$(_context350) {
        while (1) {
          switch (_context350.prev = _context350.next) {
            case 0:
              return _context350.abrupt("return", this.playerFacade.getPlayerIdMapping(t, e));

            case 1:
            case "end":
              return _context350.stop();
          }
        }
      }, _callee349, this);
    }));
  });
  s(this, "getTopPlayers", function (t) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee350() {
      return _regeneratorRuntime.wrap(function _callee350$(_context351) {
        while (1) {
          switch (_context351.prev = _context351.next) {
            case 0:
              return _context351.abrupt("return", this.playerFacade.getTopPlayersIdMapping(t));

            case 1:
            case "end":
              return _context351.stop();
          }
        }
      }, _callee350, this);
    }));
  });
  s(this, "getNextMatchForPlayer", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee351() {
      return _regeneratorRuntime.wrap(function _callee351$(_context352) {
        while (1) {
          switch (_context352.prev = _context352.next) {
            case 0:
              return _context352.abrupt("return", this.playerFacade.getNextMatchForPlayerIdMapping(t, e));

            case 1:
            case "end":
              return _context352.stop();
          }
        }
      }, _callee351, this);
    }));
  });
  s(this, "getPrevMatchForPlayer", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee352() {
      return _regeneratorRuntime.wrap(function _callee352$(_context353) {
        while (1) {
          switch (_context353.prev = _context353.next) {
            case 0:
              return _context353.abrupt("return", this.playerFacade.getPrevMatchForPlayerIdMapping(t, e));

            case 1:
            case "end":
              return _context353.stop();
          }
        }
      }, _callee352, this);
    }));
  });
  s(this, "getPlayersMapWithNativeIds", function (t) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee353() {
      return _regeneratorRuntime.wrap(function _callee353$(_context354) {
        while (1) {
          switch (_context354.prev = _context354.next) {
            case 0:
              return _context354.abrupt("return", this.playerFacade.getPlayersMapWithNativeIds(t));

            case 1:
            case "end":
              return _context354.stop();
          }
        }
      }, _callee353, this);
    }));
  });
  s(this, "getMatches", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee354() {
      return _regeneratorRuntime.wrap(function _callee354$(_context355) {
        while (1) {
          switch (_context355.prev = _context355.next) {
            case 0:
              return _context355.abrupt("return", this.matchFacade.getMatchesIdMapping(t, e));

            case 1:
            case "end":
              return _context355.stop();
          }
        }
      }, _callee354, this);
    }));
  });
  s(this, "getMatchById", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee355() {
      return _regeneratorRuntime.wrap(function _callee355$(_context356) {
        while (1) {
          switch (_context356.prev = _context356.next) {
            case 0:
              return _context356.abrupt("return", this.matchFacade.getMatchIdMapping(t, e));

            case 1:
            case "end":
              return _context356.stop();
          }
        }
      }, _callee355, this);
    }));
  });
  s(this, "search", function (t, e) {
    return u(_this115, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee356() {
      return _regeneratorRuntime.wrap(function _callee356$(_context357) {
        while (1) {
          switch (_context357.prev = _context357.next) {
            case 0:
              return _context357.abrupt("return", this.searchFacade.searchIdMapping(t, e));

            case 1:
            case "end":
              return _context357.stop();
          }
        }
      }, _callee356, this);
    }));
  });
  this.countriesFacade = new YT(e, i, n), this.competitionsFacade = new KT(e, i, n), this.teamsFacade = new c1(t, i, n), this.playerFacade = new To(t, i, n), this.matchFacade = new Ro(t, i, n), this.searchFacade = new d1(i, n);
},
    h1 = function h1() {
  _classCallCheck(this, h1);

  s(this, "id", "");
  s(this, "alias", "");
  s(this, "countryCode", "");
  s(this, "assets", null);
  s(this, "name", "");
},
    Rt = function Rt() {
  var _this116 = this;

  _classCallCheck(this, Rt);

  s(this, "countriesFromResponse", function (t) {
    if (t) return t.map(function (e) {
      return _this116.countryFromResponse(e);
    });
  });
  s(this, "countryFromResponse", function (t) {
    try {
      if (t) {
        var e = new h1();
        return e.id = t.id, e.alias = t.alias, e.assets = t.assets, e.countryCode = t.country_code, e.name = t.name, e;
      }
    } catch (e) {
      throw e;
    }

    return null;
  });
},
    p1 = function p1() {
  _classCallCheck(this, p1);

  s(this, "id", "");
  s(this, "country", null);
  s(this, "gender", "");
  s(this, "assets", null);
  s(this, "type", "");
  s(this, "name", "");
},
    Li =
/*#__PURE__*/
function () {
  function Li() {
    _classCallCheck(this, Li);

    s(this, "countryRemapper", null);
    this.countryRemapper = new Rt();
  }

  _createClass(Li, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new p1();
        return e.id = t.id, e.country = this.countryRemapper.countryFromResponse(t.country), e.gender = t.gender, e.assets = t.assets, e.type = t.type, e.name = t.name, e;
      } catch (e) {
        throw console.warn("There was a problem remapping the competition response", e), e;
      }
    }
  }]);

  return Li;
}(),
    f1 = function f1() {
  _classCallCheck(this, f1);

  s(this, "id", "");
  s(this, "country", null);
  s(this, "gender", "");
  s(this, "assets", null);
  s(this, "type", "");
  s(this, "name", "");
  s(this, "participants", []);
},
    m1 = function m1() {
  _classCallCheck(this, m1);

  s(this, "id", "");
  s(this, "country", null);
  s(this, "gender", "");
  s(this, "assets", null);
  s(this, "name", "");
  s(this, "code", "");
  s(this, "national", !1);
  s(this, "fullName", "");
  s(this, "shortName", "");
  s(this, "isDeleted", !1);
},
    li =
/*#__PURE__*/
function () {
  function li() {
    _classCallCheck(this, li);

    s(this, "countryRemapper", null);
    this.countryRemapper = new Rt();
  }

  _createClass(li, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new m1();
        return e.id = t.id, e.country = this.countryRemapper.countryFromResponse(t.country), e.gender = t.gender, e.assets = t.assets, e.code = t.code, e.national = t.national, e.fullName = t.full_name, e.shortName = t.short_name, e.name = t.name, e.isDeleted = t.is_deleted, e;
      } catch (e) {
        throw console.warn("There was a problem remapping teams response", e), e;
      }
    }
  }]);

  return li;
}(),
    g1 =
/*#__PURE__*/
function () {
  function g1() {
    _classCallCheck(this, g1);

    s(this, "countryRemapper", null);
    s(this, "teamBasicRemapper", null);
    this.countryRemapper = new Rt(), this.teamBasicRemapper = new li();
  }

  _createClass(g1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      var _this117 = this;

      try {
        var e = new f1();
        return e.id = t.id, e.country = this.countryRemapper.countryFromResponse(t.country), e.gender = t.gender, e.assets = t.assets, e.type = t.type, e.name = t.name, e.participants = t.participants.map(function (i) {
          return _this117.teamBasicRemapper.fromResponse(i);
        }), e;
      } catch (e) {
        throw console.warn("There was a problem remapping the competition response", e), e;
      }
    }
  }]);

  return g1;
}(),
    y1 = function y1() {
  _classCallCheck(this, y1);

  s(this, "primary", null);
  s(this, "secondary", null);
  s(this, "tertiary", null);
},
    v1 = function v1() {
  _classCallCheck(this, v1);

  s(this, "id", "");
  s(this, "country", null);
  s(this, "gender", "");
  s(this, "assets", null);
  s(this, "name", "");
  s(this, "competitions", []);
  s(this, "code", "");
  s(this, "national", !1);
  s(this, "fullName", "");
  s(this, "shortName", "");
  s(this, "isDeleted", !1);
  s(this, "colors", new y1());
  s(this, "squad", []);
},
    w1 = function w1() {
  _classCallCheck(this, w1);

  s(this, "id", "");
  s(this, "startDate", "");
  s(this, "endDate", "");
  s(this, "shirtNumber");
  s(this, "loan", !1);
  s(this, "position", "");
  s(this, "country", null);
  s(this, "name", "");
  s(this, "assets", null);
  s(this, "birthDate", "");
},
    b1 =
/*#__PURE__*/
function () {
  function b1() {
    _classCallCheck(this, b1);

    s(this, "countryRemapper", null);
    this.countryRemapper = new Rt();
  }

  _createClass(b1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new w1();
        return e.id = t.id, e.startDate = t.start_date, e.endDate = t.end_date, e.shirtNumber = t.shirt_number, e.loan = t.loan, e.position = t.position, e.country = this.countryRemapper.countryFromResponse(t.country), e.name = t.name, e.assets = t.assets, e.birthDate = t.birth_date, e;
      } catch (e) {
        throw console.warn("There was a problem remapping the player from squad", e), e;
      }
    }
  }]);

  return b1;
}(),
    I1 =
/*#__PURE__*/
function () {
  function I1() {
    _classCallCheck(this, I1);

    s(this, "countryRemapper", null);
    s(this, "competitionRemapper", null);
    s(this, "playerRemapper", null);
    this.countryRemapper = new Rt(), this.competitionRemapper = new Li(), this.playerRemapper = new b1();
  }

  _createClass(I1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      var _this118 = this;

      try {
        var e = new v1();
        return e.id = t.id, e.country = this.countryRemapper.countryFromResponse(t.country), e.gender = t.gender, e.assets = t.assets, e.code = t.code, e.national = t.national, e.fullName = t.full_name, e.shortName = t.short_name, e.name = t.name, e.isDeleted = t.is_deleted, e.competitions = t.competitions ? t.competitions.map(function (i) {
          return _this118.competitionRemapper.fromResponse(i);
        }) : [], e.colors = t.colors ? t.colors : e.colors, e.squad = t.squad ? t.squad.map(function (i) {
          return _this118.playerRemapper.fromResponse(i);
        }) : [], e;
      } catch (e) {
        throw console.warn("There was a problem remapping team response", e), e;
      }
    }
  }]);

  return I1;
}(),
    _1 = function _1() {
  _classCallCheck(this, _1);

  s(this, "id", "");
  s(this, "kickoffAt", "");
  s(this, "finishedAt", "");
  s(this, "updatedAt", "");
  s(this, "availableMarkets", null);
  s(this, "homeTeam", null);
  s(this, "awayTeam", null);
  s(this, "isDeleted", !1);
  s(this, "lineupsConfirmed", !1);
  s(this, "startedAt", "");
  s(this, "minute", "");
  s(this, "scores", null);
  s(this, "context", {
    competition: null
  });
  s(this, "status", {
    type: null,
    subType: null
  });
},
    E1 = function E1() {
  _classCallCheck(this, E1);

  s(this, "ftScore", null);
  s(this, "htScore", null);
  s(this, "aetScore", null);
  s(this, "aggScore", null);
  s(this, "penScore", null);
},
    Jh =
/*#__PURE__*/
function () {
  function Jh() {
    _classCallCheck(this, Jh);

    s(this, "statEntityFromResponse", function (t) {
      return {
        homeGoals: t.home_goals,
        awayGoals: t.away_goals
      };
    });
  }

  _createClass(Jh, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new E1();
        return e.ftScore = this.statEntityFromResponse(t.ft_score), e.htScore = this.statEntityFromResponse(t.ht_score), e.aetScore = this.statEntityFromResponse(t.aet_score), e.aggScore = this.statEntityFromResponse(t.agg_score), e.penScore = this.statEntityFromResponse(t.pen_score), e;
      } catch (e) {
        throw console.warn("There was a problem remapping the scores", e), e;
      }
    }
  }]);

  return Jh;
}(),
    C1 =
/*#__PURE__*/
function () {
  function C1() {
    _classCallCheck(this, C1);

    s(this, "teamRemapper", null);
    s(this, "competitionRemapper", null);
    s(this, "scoresRemapper", null);
    this.teamRemapper = new li(), this.competitionRemapper = new Li(), this.scoresRemapper = new Jh();
  }

  _createClass(C1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new _1();
        return e.id = t.id, e.kickoffAt = t.kickoff_at, e.finishedAt = t.finished_at, e.updatedAt = t.updated_at, e.isDeleted = t.is_deleted, e.homeTeam = this.teamRemapper.fromResponse(t.home_team), e.awayTeam = this.teamRemapper.fromResponse(t.away_team), e.lineupsConfirmed = t.lineups_confirmed, e.startedAt = t.started_at, e.minute = t.minute, e.scores = this.scoresRemapper.fromResponse(t.scores), e.context = {
          competition: t.context.competition ? this.competitionRemapper.fromResponse(t.context.competition) : null
        }, e.status = {
          type: t.status.type,
          subType: t.status.sub_type
        }, e;
      } catch (e) {
        throw console.warn("There was a problem remapping the match response", e), e;
      }
    }
  }]);

  return C1;
}(),
    Sn = function Sn() {
  _classCallCheck(this, Sn);

  s(this, "type", null);
  s(this, "subType", null);
},
    S1 = function S1() {
  _classCallCheck(this, S1);

  s(this, "id", "");
  s(this, "kickoffAt", "");
  s(this, "finishedAt", "");
  s(this, "updatedAt", "");
  s(this, "availableMarkets", null);
  s(this, "isDeleted", !1);
  s(this, "homeTeam", null);
  s(this, "awayTeam", null);
  s(this, "lineupsConfirmed", !1);
  s(this, "startedAt", "");
  s(this, "minute", "");
  s(this, "scores", null);
  s(this, "stats", null);
  s(this, "context", {
    competition: null
  });
  s(this, "timeline", []);
  s(this, "status", new Sn());
  s(this, "lineups", null);
},
    T1 = function T1() {
  _classCallCheck(this, T1);

  s(this, "corners", null);
  s(this, "cornersFirstHalf", null);
  s(this, "cornersSecondHalf", null);
  s(this, "cornersExtraTime", null);
  s(this, "crosses", null);
  s(this, "crossesFirstHalf", null);
  s(this, "crossesSecondHalf", null);
  s(this, "crossesExtraTime", null);
  s(this, "offside", null);
  s(this, "offsideFirstHalf", null);
  s(this, "offsideSecondHalf", null);
  s(this, "offsideExtraTime", null);
  s(this, "shotsOn", null);
  s(this, "shotsOnFirstHalf", null);
  s(this, "shotsOnSecondHalf", null);
  s(this, "shotsOnExtraTime", null);
  s(this, "throwIn", null);
  s(this, "throwInFirstHalf", null);
  s(this, "throwInSecondHalf", null);
  s(this, "throwInExtraTime", null);
  s(this, "redCards", null);
  s(this, "redCardsFirstHalf", null);
  s(this, "redCardsSecondHalf", null);
  s(this, "redCardsExtraTime", null);
  s(this, "shotsOff", null);
  s(this, "shotsOffFirstHalf", null);
  s(this, "shotsOffSecondHalf", null);
  s(this, "shotsOffExtraTime", null);
  s(this, "goalKicks", null);
  s(this, "goalKicksFirstHalf", null);
  s(this, "goalKicksSecondHalf", null);
  s(this, "goalKicksExtraTime", null);
  s(this, "possession", null);
  s(this, "possessionFirstHalf", null);
  s(this, "possessionSecondHalf", null);
  s(this, "possessionExtraTime", null);
  s(this, "treatments", null);
  s(this, "treatmentsFirstHalf", null);
  s(this, "treatmentsSecondHalf", null);
  s(this, "treatmentsExtraTime", null);
  s(this, "yellowCards", null);
  s(this, "yellowCardsFirstHalf", null);
  s(this, "yellowCardsSecondHalf", null);
  s(this, "yellowCardsExtraTime", null);
  s(this, "shotsBlocked", null);
  s(this, "shotsBlockedFirstHalf", null);
  s(this, "shotsBlockedSecondHalf", null);
  s(this, "shotsBlockedExtraTime", null);
  s(this, "substitutions", null);
  s(this, "substitutionsFirstHalf", null);
  s(this, "substitutionsSecondHalf", null);
  s(this, "substitutionsExtraTime", null);
  s(this, "counterAttacks", null);
  s(this, "counterAttacksFirstHalf", null);
  s(this, "counterAttacksSecondHalf", null);
  s(this, "counterAttacksExtraTime", null);
  s(this, "foulsCommitted", null);
  s(this, "foulsCommittedFirstHalf", null);
  s(this, "foulsCommittedSecondHalf", null);
  s(this, "foulsCommittedExtraTime", null);
},
    R1 =
/*#__PURE__*/
function () {
  function R1() {
    _classCallCheck(this, R1);

    s(this, "statEntityFromResponse", function (t) {
      return {
        homeTeam: t ? t.home_team : null,
        awayTeam: t ? t.away_team : null
      };
    });
  }

  _createClass(R1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new T1();
        return e.corners = this.statEntityFromResponse(t.corners), e.cornersFirstHalf = this.statEntityFromResponse(t.corners_1h), e.cornersSecondHalf = this.statEntityFromResponse(t.corners_2h), e.cornersExtraTime = this.statEntityFromResponse(t.corners_et), e.crosses = this.statEntityFromResponse(t.crosses), e.crossesFirstHalf = this.statEntityFromResponse(t.crosses_1h), e.crossesSecondHalf = this.statEntityFromResponse(t.crosses_2h), e.crossesExtraTime = this.statEntityFromResponse(t.crosses_et), e.offside = this.statEntityFromResponse(t.offside), e.offsideFirstHalf = this.statEntityFromResponse(t.offside_1h), e.offsideSecondHalf = this.statEntityFromResponse(t.offside_2h), e.offsideExtraTime = this.statEntityFromResponse(t.offside_et), e.shotsOn = this.statEntityFromResponse(t.shots_on), e.shotsOnFirstHalf = this.statEntityFromResponse(t.shots_on_1h), e.shotsOnSecondHalf = this.statEntityFromResponse(t.shots_on_2h), e.shotsOnExtraTime = this.statEntityFromResponse(t.shots_on_et), e.throwIn = this.statEntityFromResponse(t.throw_in), e.throwInFirstHalf = this.statEntityFromResponse(t.throw_in_1h), e.throwInSecondHalf = this.statEntityFromResponse(t.throw_in_2h), e.throwInExtraTime = this.statEntityFromResponse(t.throw_in_et), e.redCards = this.statEntityFromResponse(t.red_cards), e.redCardsFirstHalf = this.statEntityFromResponse(t.red_cards_1h), e.redCardsSecondHalf = this.statEntityFromResponse(t.red_cards_2h), e.redCardsExtraTime = this.statEntityFromResponse(t.red_cards_et), e.shotsOff = this.statEntityFromResponse(t.shots_off), e.shotsOffFirstHalf = this.statEntityFromResponse(t.shots_off_1h), e.shotsOffSecondHalf = this.statEntityFromResponse(t.shots_off_2h), e.shotsOffExtraTime = this.statEntityFromResponse(t.shots_off_et), e.goalKicks = this.statEntityFromResponse(t.goal_kicks), e.goalKicksFirstHalf = this.statEntityFromResponse(t.goal_kicks_1h), e.goalKicksSecondHalf = this.statEntityFromResponse(t.goal_kicks_2h), e.goalKicksExtraTime = this.statEntityFromResponse(t.goal_kicks_et), e.possession = this.statEntityFromResponse(t.possession), e.possessionFirstHalf = this.statEntityFromResponse(t.possession_1h), e.possessionSecondHalf = this.statEntityFromResponse(t.possession_2h), e.possessionExtraTime = this.statEntityFromResponse(t.possession_et), e.treatments = this.statEntityFromResponse(t.treatments), e.treatmentsFirstHalf = this.statEntityFromResponse(t.treatments_1h), e.treatmentsSecondHalf = this.statEntityFromResponse(t.treatments_2h), e.treatmentsExtraTime = this.statEntityFromResponse(t.treatments_et), e.yellowCards = this.statEntityFromResponse(t.yellow_cards), e.yellowCardsFirstHalf = this.statEntityFromResponse(t.yellow_cards_1h), e.yellowCardsSecondHalf = this.statEntityFromResponse(t.yellow_cards_2h), e.yellowCardsExtraTime = this.statEntityFromResponse(t.yellow_cards_et), e.shotsBlocked = this.statEntityFromResponse(t.shots_blocked), e.shotsBlockedFirstHalf = this.statEntityFromResponse(t.shots_blocked_1h), e.shotsBlockedSecondHalf = this.statEntityFromResponse(t.shots_blocked_2h), e.shotsBlockedExtraTime = this.statEntityFromResponse(t.shots_blocked_et), e.substitutions = this.statEntityFromResponse(t.substitutions), e.substitutionsFirstHalf = this.statEntityFromResponse(t.substitutions_1h), e.substitutionsSecondHalf = this.statEntityFromResponse(t.substitutions_2h), e.substitutionsExtraTime = this.statEntityFromResponse(t.substitutions_et), e.counterAttacks = this.statEntityFromResponse(t.counter_attacks), e.counterAttacksFirstHalf = this.statEntityFromResponse(t.counter_attacks_1h), e.counterAttacksSecondHalf = this.statEntityFromResponse(t.counter_attacks_2h), e.counterAttacksExtraTime = this.statEntityFromResponse(t.counter_attacks_et), e.foulsCommitted = this.statEntityFromResponse(t.fouls_committed), e.foulsCommittedFirstHalf = this.statEntityFromResponse(t.fouls_committed_1h), e.foulsCommittedSecondHalf = this.statEntityFromResponse(t.fouls_committed_2h), e.foulsCommittedExtraTime = this.statEntityFromResponse(t.fouls_committed_et), e;
      } catch (e) {
        throw console.warn("There was a problem remapping the stats", e), e;
      }
    }
  }]);

  return R1;
}(),
    Xh = function Xh() {
  _classCallCheck(this, Xh);

  s(this, "homeTeam", {
    players: []
  });
  s(this, "awayTeam", {
    players: []
  });
},
    P1 = function P1() {
  _classCallCheck(this, P1);

  s(this, "id", "");
  s(this, "name", "");
  s(this, "position", "");
  s(this, "shirtNumber");
  s(this, "assets", null);
  s(this, "type", "");
},
    Zh =
/*#__PURE__*/
function () {
  function Zh() {
    _classCallCheck(this, Zh);
  }

  _createClass(Zh, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new P1();
        return e.id = t.id, e.name = t.name, e.position = t.position, e.shirtNumber = t.shirt_number, e.assets = t.assets, e.type = t.type, e;
      } catch (e) {
        throw console.warn("There was a problem remapping the player from timeline", e), e;
      }
    }
  }]);

  return Zh;
}(),
    O1 =
/*#__PURE__*/
function () {
  function O1() {
    _classCallCheck(this, O1);

    s(this, "playerRemapper", null);
    this.playerRemapper = new Zh();
  }

  _createClass(O1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      var _this119 = this;

      try {
        var e = new Xh();
        return e.homeTeam.players = t.home_team && t.home_team.players ? t.home_team.players.map(function (i) {
          return _this119.playerRemapper.fromResponse(i);
        }) : [], e.awayTeam.players = t.away_team && t.away_team.players ? t.away_team.players.map(function (i) {
          return _this119.playerRemapper.fromResponse(i);
        }) : [], e;
      } catch (e) {
        throw console.warn("There was a problem remapping the lineups", e), e;
      }
    }
  }]);

  return O1;
}(),
    A1 = function A1() {
  _classCallCheck(this, A1);

  s(this, "minute", "");
  s(this, "type", "");
  s(this, "teamId", "");
  s(this, "player", null);
  s(this, "relatedPlayer", null);
  s(this, "updatedAt", "");
},
    M1 =
/*#__PURE__*/
function () {
  function M1() {
    _classCallCheck(this, M1);

    s(this, "playerRemapper", null);
    this.playerRemapper = new Zh();
  }

  _createClass(M1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new A1();
        return e.minute = t.minute, e.type = t.type, e.teamId = t.team_id, e.player = this.playerRemapper.fromResponse(t.player), e.relatedPlayer = t.related_player ? this.playerRemapper.fromResponse(t.related_player) : null, e.updatedAt = t.updated_at, e;
      } catch (e) {
        throw console.warn("There was a problem remapping timeline", e), e;
      }
    }
  }]);

  return M1;
}(),
    F1 =
/*#__PURE__*/
function () {
  function F1() {
    _classCallCheck(this, F1);

    s(this, "teamMapper", null);
    s(this, "competitionsMapper", null);
    s(this, "lineupsMapper", null);
    s(this, "scoresMapper", null);
    s(this, "statsMapper", null);
    s(this, "timelineMapper", null);
    this.teamMapper = new li(), this.competitionsMapper = new Li(), this.lineupsMapper = new O1(), this.scoresMapper = new Jh(), this.statsMapper = new R1(), this.timelineMapper = new M1();
  }

  _createClass(F1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      var _this120 = this;

      try {
        var e = new S1();
        return e.id = t.id, e.kickoffAt = t.kickoff_at, e.finishedAt = t.finished_at, e.updatedAt = t.updated_at, e.isDeleted = t.is_deleted, e.homeTeam = t.home_team ? this.teamMapper.fromResponse(t.home_team) : null, e.awayTeam = t.away_team ? this.teamMapper.fromResponse(t.away_team) : null, e.lineupsConfirmed = t.lineups_confirmed, e.startedAt = t.started_at, e.minute = t.minute, e.scores = this.scoresMapper.fromResponse(t.scores), e.stats = this.statsMapper.fromResponse(t.stats), e.context = {
          competition: this.competitionsMapper.fromResponse(t.context.competition)
        }, e.timeline = t.timeline ? t.timeline.map(function (i) {
          return _this120.timelineMapper.fromResponse(i);
        }) : [], e.status = {
          type: t.status.type,
          subType: t.status.sub_type
        }, e.lineups = t.lineups ? this.lineupsMapper.fromResponse(t.lineups) : new Xh(), e;
      } catch (e) {
        throw console.warn("There was a problem remapping the match response", e), e;
      }
    }
  }]);

  return F1;
}(),
    k1 = function k1() {
  _classCallCheck(this, k1);

  s(this, "id", "");
  s(this, "country", null);
  s(this, "birthDate", "");
  s(this, "firstName", "");
  s(this, "lastName", "");
  s(this, "name", "");
  s(this, "position", "");
  s(this, "assets", null);
},
    x1 =
/*#__PURE__*/
function () {
  function x1() {
    _classCallCheck(this, x1);

    s(this, "countryRemapper", null);
    this.countryRemapper = new Rt();
  }

  _createClass(x1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      try {
        var e = new k1();
        return e.id = t.id, e.firstName = t.first_name ? t.first_name : null, e.lastName = t.last_name ? t.last_name : null, e.name = t.name ? t.name : null, e.birthDate = t.birth_date, e.country = this.countryRemapper.countryFromResponse(t.country), e.assets = t.assets, e.position = t.position, e;
      } catch (e) {
        throw console.warn("There was a problem remapping top player response", e), e;
      }
    }
  }]);

  return x1;
}(),
    D1 = function D1() {
  _classCallCheck(this, D1);

  s(this, "id", "");
  s(this, "country", null);
  s(this, "birthDate", "");
  s(this, "firstName", "");
  s(this, "lastName", "");
  s(this, "name", "");
  s(this, "position", "");
  s(this, "assets", null);
  s(this, "isDeleted", !1);
  s(this, "teams", []);
},
    ep =
/*#__PURE__*/
function () {
  function ep() {
    _classCallCheck(this, ep);

    s(this, "countryRemapper", null);
    s(this, "teamRemapper", null);
    this.countryRemapper = new Rt(), this.teamRemapper = new li();
  }

  _createClass(ep, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      var _this121 = this;

      try {
        var e = new D1();
        return e.id = t.id, e.firstName = t.first_name ? t.first_name : null, e.lastName = t.last_name ? t.last_name : null, e.name = t.name ? t.name : null, e.birthDate = t.birth_date, e.country = this.countryRemapper.countryFromResponse(t.country), e.assets = t.assets, e.teams = t.teams ? t.teams.map(function (i) {
          return _this121.teamRemapper.fromResponse(i);
        }) : [], e.position = t.position, e.isDeleted = t.is_deleted, e;
      } catch (e) {
        throw console.warn("There was a problem remapping players response", e), e;
      }
    }
  }]);

  return ep;
}(),
    N1 = function N1() {
  _classCallCheck(this, N1);

  s(this, "id", "");
  s(this, "country", null);
  s(this, "birthDate", "");
  s(this, "firstName", "");
  s(this, "lastName", "");
  s(this, "name", "");
  s(this, "position", "");
  s(this, "assets", null);
  s(this, "isDeleted", !1);
  s(this, "competitions", []);
  s(this, "teams", []);
},
    L1 =
/*#__PURE__*/
function () {
  function L1() {
    _classCallCheck(this, L1);

    s(this, "countryRemapper", null);
    s(this, "teamRemapper", null);
    s(this, "competitionRemapper", null);
    this.countryRemapper = new Rt(), this.teamRemapper = new li(), this.competitionRemapper = new Li();
  }

  _createClass(L1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      var _this122 = this;

      try {
        var e = new N1();
        return e.id = t.id, e.firstName = t.first_name ? t.first_name : null, e.lastName = t.last_name ? t.last_name : null, e.name = t.name ? t.name : null, e.birthDate = t.birth_date, e.country = this.countryRemapper.countryFromResponse(t.country), e.assets = t.assets, e.teams = t.teams ? t.teams.map(function (i) {
          return _this122.teamRemapper.fromResponse(i);
        }) : [], e.position = t.position, e.isDeleted = t.is_deleted, e.competitions = t.competitions ? t.competitions.map(function (i) {
          return _this122.competitionRemapper.fromResponse(i);
        }) : [], e;
      } catch (e) {
        throw console.warn("There was a problem remapping player response", e), e;
      }
    }
  }]);

  return L1;
}(),
    $1 = function $1() {
  _classCallCheck(this, $1);

  s(this, "teams", null);
  s(this, "players", null);
  s(this, "competitions", null);
},
    U1 =
/*#__PURE__*/
function () {
  function U1() {
    _classCallCheck(this, U1);

    s(this, "teamRemapper", null);
    s(this, "playerRemapper", null);
    s(this, "competitionremapper", null);
    this.teamRemapper = new li(), this.playerRemapper = new ep(), this.competitionremapper = new Li();
  }

  _createClass(U1, [{
    key: "fromResponse",
    value: function fromResponse(t) {
      var _this123 = this;

      try {
        var e = new $1();
        return e.teams = t.teams ? t.teams.map(function (i) {
          return _this123.teamRemapper.fromResponse(i);
        }) : [], e.players = t.players ? t.players.map(function (i) {
          return _this123.playerRemapper.fromResponse(i);
        }) : [], e.competitions = t.competitions ? t.competitions.map(function (i) {
          return _this123.competitionremapper.fromResponse(i);
        }) : [], e;
      } catch (e) {
        throw console.warn("There was a problem remapping search response", e), e;
      }
    }
  }]);

  return U1;
}(),
    Po = function Po() {
  _classCallCheck(this, Po);

  s(this, "currentPage", null);
  s(this, "itemsPerPage", null);
  s(this, "totalItems", null);
  s(this, "numberOfPages", null);
},
    cs = function cs() {
  _classCallCheck(this, cs);

  s(this, "pagination", new Po());
},
    Ys = function Ys() {
  _classCallCheck(this, Ys);

  s(this, "meta", new cs());
  s(this, "data", []);
},
    B1 = function B1() {
  _classCallCheck(this, B1);

  s(this, "remapMetaProp", function (t) {
    var e = new cs();
    return e.pagination.currentPage = t.pagination.current_page, e.pagination.itemsPerPage = t.pagination.items_per_page, e.pagination.totalItems = t.pagination.total_items, e.pagination.numberOfPages = t.pagination.number_of_pages, e;
  });
},
    us =
/*#__PURE__*/
function (_St4) {
  _inherits(us, _St4);

  function us(e) {
    var _this124;

    _classCallCheck(this, us);

    _this124 = _possibleConstructorReturn(this, _getPrototypeOf(us).call(this, e, Ct(e.environment, "football")));
    s(_assertThisInitialized(_this124), "limitIds", 200);
    s(_assertThisInitialized(_this124), "countryRemapper", null);
    s(_assertThisInitialized(_this124), "competitionBasicRemapper", null);
    s(_assertThisInitialized(_this124), "competitionFullRemapper", null);
    s(_assertThisInitialized(_this124), "teamBasicRemapper", null);
    s(_assertThisInitialized(_this124), "teamFullRemapper", null);
    s(_assertThisInitialized(_this124), "matchBasicRemapper", null);
    s(_assertThisInitialized(_this124), "matchFullRemapper", null);
    s(_assertThisInitialized(_this124), "playerBasicRemapper", null);
    s(_assertThisInitialized(_this124), "playerFullRemapper", null);
    s(_assertThisInitialized(_this124), "topPlayerRemapper", null);
    s(_assertThisInitialized(_this124), "searchRemapper", null);
    s(_assertThisInitialized(_this124), "footballMetaRemapper", null);
    s(_assertThisInitialized(_this124), "getCountries", function (e) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee357() {
        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee357$(_context358) {
          while (1) {
            switch (_context358.prev = _context358.next) {
              case 0:
                i = "There was a problem with the football countries request", n = "/countries".concat(this.apiSignInUrl), r = Date.now();
                e && (n += "&disable_cache=".concat(r));
                _context358.next = 4;
                return this.fetchWithoutAuth(n, i);

              case 4:
                a = _context358.sent;
                return _context358.abrupt("return", this.countryRemapper.countriesFromResponse(a.data));

              case 6:
              case "end":
                return _context358.stop();
            }
          }
        }, _callee357, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getCompetitions", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee358() {
        var _this125 = this;

        var n, r, a, o, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, _l6, c, _d6, _a5;

        return _regeneratorRuntime.wrap(function _callee358$(_context359) {
          while (1) {
            switch (_context359.prev = _context359.next) {
              case 0:
                n = Date.now(), r = "There was a problem with football competitions request";

                if (!(i = i || !1, e && e.competitionIds && e.competitionIds.length > this.limitIds - 1)) {
                  _context359.next = 37;
                  break;
                }

                a = [], o = Xn(e.competitionIds, this.limitIds);
                _iteratorNormalCompletion18 = true;
                _didIteratorError18 = false;
                _iteratorError18 = undefined;
                _context359.prev = 6;
                _iterator18 = o[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done) {
                  _context359.next = 20;
                  break;
                }

                _l6 = _step18.value;
                e.competitionIds = _l6;
                c = "/competitions".concat(this.apiSignInUrl).concat(e.constructFilterUrl());
                i && (c += "&disable_cache=".concat(n));
                _context359.next = 15;
                return this.fetchWithoutAuth(c, r);

              case 15:
                _d6 = _context359.sent;
                a.push(_d6.data.map(function (h) {
                  return _this125.competitionBasicRemapper.fromResponse(h);
                }));

              case 17:
                _iteratorNormalCompletion18 = true;
                _context359.next = 8;
                break;

              case 20:
                _context359.next = 26;
                break;

              case 22:
                _context359.prev = 22;
                _context359.t0 = _context359["catch"](6);
                _didIteratorError18 = true;
                _iteratorError18 = _context359.t0;

              case 26:
                _context359.prev = 26;
                _context359.prev = 27;

                if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
                  _iterator18.return();
                }

              case 29:
                _context359.prev = 29;

                if (!_didIteratorError18) {
                  _context359.next = 32;
                  break;
                }

                throw _iteratorError18;

              case 32:
                return _context359.finish(29);

              case 33:
                return _context359.finish(26);

              case 34:
                return _context359.abrupt("return", Array.prototype.concat.apply([], a));

              case 37:
                _a5 = "/competitions".concat(this.apiSignInUrl);
                e && (_a5 += "".concat(e.constructFilterUrl()));
                i && (_a5 += "&disable_cache=".concat(n));
                _context359.next = 42;
                return this.fetchWithoutAuth(_a5, r);

              case 42:
                _context359.t1 = function (o) {
                  return _this125.competitionBasicRemapper.fromResponse(o);
                };

                return _context359.abrupt("return", _context359.sent.data.map(_context359.t1));

              case 44:
              case "end":
                return _context359.stop();
            }
          }
        }, _callee358, this, [[6, 22, 26, 34], [27,, 29, 33]]);
      }));
    });
    s(_assertThisInitialized(_this124), "getCompetitionById", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee359() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee359$(_context360) {
          while (1) {
            switch (_context360.prev = _context360.next) {
              case 0:
                n = "/competitions/".concat(e).concat(this.apiSignInUrl), r = "There was a problem with football competition by ID request", a = Date.now();
                i && (n += "&disable_cache=".concat(a));
                _context360.next = 4;
                return this.fetchWithoutAuth(n, r);

              case 4:
                o = _context360.sent;
                return _context360.abrupt("return", this.competitionFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context360.stop();
            }
          }
        }, _callee359, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getTopCompetitions", function (e) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee360() {
        var _this126 = this;

        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee360$(_context361) {
          while (1) {
            switch (_context361.prev = _context361.next) {
              case 0:
                i = "There was a problem with top football competitions request", n = "/competitions/top".concat(this.apiSignInUrl), r = Date.now();
                e && (n += "&disable_cache=".concat(r));
                _context361.next = 4;
                return this.fetchWithoutAuth(n, i);

              case 4:
                _context361.t0 = function (a) {
                  return _this126.competitionBasicRemapper.fromResponse(a);
                };

                return _context361.abrupt("return", _context361.sent.data.map(_context361.t0));

              case 6:
              case "end":
                return _context361.stop();
            }
          }
        }, _callee360, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getTeams", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee361() {
        var _this127 = this;

        var n, r, a, o, _iteratorNormalCompletion19, _didIteratorError19, _iteratorError19, _iterator19, _step19, _l7, c, _d7, _a6, _o6, _l8;

        return _regeneratorRuntime.wrap(function _callee361$(_context362) {
          while (1) {
            switch (_context362.prev = _context362.next) {
              case 0:
                n = Date.now(), r = "There was a problem with football teams request";

                if (!(e && e.teamIds && e.teamIds.length > this.limitIds)) {
                  _context362.next = 37;
                  break;
                }

                a = [], o = Xn(e.teamIds, this.limitIds);
                _iteratorNormalCompletion19 = true;
                _didIteratorError19 = false;
                _iteratorError19 = undefined;
                _context362.prev = 6;
                _iterator19 = o[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done) {
                  _context362.next = 20;
                  break;
                }

                _l7 = _step19.value;
                e.teamIds = _l7;
                c = "/teams".concat(this.apiSignInUrl).concat(e.constructFilterUrl());
                i && (c += "disable_cache=".concat(n));
                _context362.next = 15;
                return this.fetchWithoutAuth(c, r);

              case 15:
                _d7 = _context362.sent;
                a.push(_d7.data.map(function (h) {
                  return _this127.teamBasicRemapper.fromResponse(h);
                }));

              case 17:
                _iteratorNormalCompletion19 = true;
                _context362.next = 8;
                break;

              case 20:
                _context362.next = 26;
                break;

              case 22:
                _context362.prev = 22;
                _context362.t0 = _context362["catch"](6);
                _didIteratorError19 = true;
                _iteratorError19 = _context362.t0;

              case 26:
                _context362.prev = 26;
                _context362.prev = 27;

                if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                  _iterator19.return();
                }

              case 29:
                _context362.prev = 29;

                if (!_didIteratorError19) {
                  _context362.next = 32;
                  break;
                }

                throw _iteratorError19;

              case 32:
                return _context362.finish(29);

              case 33:
                return _context362.finish(26);

              case 34:
                return _context362.abrupt("return", Array.prototype.concat.apply([], a));

              case 37:
                _a6 = new Ys(), _o6 = "/teams".concat(this.apiSignInUrl);
                e && (_o6 += "".concat(e.constructFilterUrl())), i && (_o6 += "&disable_cache=".concat(n));
                _context362.next = 41;
                return this.fetchWithoutAuth(_o6, r);

              case 41:
                _l8 = _context362.sent;
                return _context362.abrupt("return", (_a6.meta = this.footballMetaRemapper.remapMetaProp(_l8.meta), _a6.data = _l8.data.map(function (c) {
                  return _this127.teamBasicRemapper.fromResponse(c);
                }), _a6));

              case 43:
              case "end":
                return _context362.stop();
            }
          }
        }, _callee361, this, [[6, 22, 26, 34], [27,, 29, 33]]);
      }));
    });
    s(_assertThisInitialized(_this124), "getTeamById", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee362() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee362$(_context363) {
          while (1) {
            switch (_context363.prev = _context363.next) {
              case 0:
                n = "There was a problem with football team by ID request", r = "/teams/".concat(e).concat(this.apiSignInUrl), a = Date.now();
                i && (r += "disable_cache=".concat(a));
                _context363.next = 4;
                return this.fetchWithoutAuth(r, n);

              case 4:
                o = _context363.sent;
                return _context363.abrupt("return", this.teamFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context363.stop();
            }
          }
        }, _callee362, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getTopTeams", function (e) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee363() {
        var _this128 = this;

        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee363$(_context364) {
          while (1) {
            switch (_context364.prev = _context364.next) {
              case 0:
                i = "/teams/top".concat(this.apiSignInUrl), n = "There was a problem with top football teams request", r = Date.now();
                e && (i += "$disable_cache=".concat(r));
                _context364.next = 4;
                return this.fetchWithoutAuth(i, n);

              case 4:
                a = _context364.sent;
                return _context364.abrupt("return", a.data ? a.data.map(function (o) {
                  return _this128.teamBasicRemapper.fromResponse(o);
                }) : []);

              case 6:
              case "end":
                return _context364.stop();
            }
          }
        }, _callee363, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getNextMatchForTeam", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee364() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee364$(_context365) {
          while (1) {
            switch (_context365.prev = _context365.next) {
              case 0:
                n = "/teams/".concat(e, "/next-match").concat(this.apiSignInUrl), r = Date.now(), a = "There was a problem with next match for team request";
                i && (n += "&disable_cache=".concat(r));
                _context365.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                o = _context365.sent;
                return _context365.abrupt("return", this.matchFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context365.stop();
            }
          }
        }, _callee364, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getPrevMatchForTeam", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee365() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee365$(_context366) {
          while (1) {
            switch (_context366.prev = _context366.next) {
              case 0:
                n = "/teams/".concat(e, "/previous-match").concat(this.apiSignInUrl), r = Date.now(), a = "There was a problem with previous match for team request";
                i && (n += "disable_cache=".concat(r));
                _context366.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                o = _context366.sent;
                return _context366.abrupt("return", this.matchFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context366.stop();
            }
          }
        }, _callee365, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getPlayers", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee366() {
        var _this129 = this;

        var n, r, a, o, _iteratorNormalCompletion20, _didIteratorError20, _iteratorError20, _iterator20, _step20, _l9, c, _d8, _a7, _o7, _l10;

        return _regeneratorRuntime.wrap(function _callee366$(_context367) {
          while (1) {
            switch (_context367.prev = _context367.next) {
              case 0:
                n = Date.now(), r = "There was a problem with football players request";

                if (!(e && e.playerIds && e.playerIds.length > this.limitIds - 1)) {
                  _context367.next = 37;
                  break;
                }

                a = [], o = Xn(e.playerIds, this.limitIds);
                _iteratorNormalCompletion20 = true;
                _didIteratorError20 = false;
                _iteratorError20 = undefined;
                _context367.prev = 6;
                _iterator20 = o[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done) {
                  _context367.next = 20;
                  break;
                }

                _l9 = _step20.value;
                e.playerIds = _l9;
                c = "/players".concat(this.apiSignInUrl).concat(e.constructFilterUrl());
                i && (c += "&disable_cache=".concat(n));
                _context367.next = 15;
                return this.fetchWithoutAuth(c, r);

              case 15:
                _d8 = _context367.sent;
                a.push(_d8.data.map(function (h) {
                  return _this129.teamBasicRemapper.fromResponse(h);
                }));

              case 17:
                _iteratorNormalCompletion20 = true;
                _context367.next = 8;
                break;

              case 20:
                _context367.next = 26;
                break;

              case 22:
                _context367.prev = 22;
                _context367.t0 = _context367["catch"](6);
                _didIteratorError20 = true;
                _iteratorError20 = _context367.t0;

              case 26:
                _context367.prev = 26;
                _context367.prev = 27;

                if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
                  _iterator20.return();
                }

              case 29:
                _context367.prev = 29;

                if (!_didIteratorError20) {
                  _context367.next = 32;
                  break;
                }

                throw _iteratorError20;

              case 32:
                return _context367.finish(29);

              case 33:
                return _context367.finish(26);

              case 34:
                return _context367.abrupt("return", Array.prototype.concat.apply([], a));

              case 37:
                _a7 = new Ys(), _o7 = "/players".concat(this.apiSignInUrl);
                e && (_o7 += "".concat(e.constructFilterUrl())), i && (_o7 += "&disable_cache=".concat(n));
                _context367.next = 41;
                return this.fetchWithoutAuth(_o7, r);

              case 41:
                _l10 = _context367.sent;
                return _context367.abrupt("return", (_a7.meta = this.footballMetaRemapper.remapMetaProp(_l10.meta), _a7.data = _l10.data.map(function (c) {
                  return _this129.playerBasicRemapper.fromResponse(c);
                }), _a7));

              case 43:
              case "end":
                return _context367.stop();
            }
          }
        }, _callee366, this, [[6, 22, 26, 34], [27,, 29, 33]]);
      }));
    });
    s(_assertThisInitialized(_this124), "getPlayerById", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee367() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee367$(_context368) {
          while (1) {
            switch (_context368.prev = _context368.next) {
              case 0:
                n = "/players/".concat(e).concat(this.apiSignInUrl), r = Date.now(), a = "There was a problem with football player by ID request";
                i && (n += "&disable_cache=".concat(r));
                _context368.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                o = _context368.sent;
                return _context368.abrupt("return", this.playerFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context368.stop();
            }
          }
        }, _callee367, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getTopPlayers", function (e) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee368() {
        var _this130 = this;

        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee368$(_context369) {
          while (1) {
            switch (_context369.prev = _context369.next) {
              case 0:
                i = "/players/top".concat(this.apiSignInUrl), n = Date.now(), r = "There was a problem with top football players request";
                e && (i += "&disable_cache=".concat(n));
                _context369.next = 4;
                return this.fetchWithoutAuth(i, r);

              case 4:
                _context369.t0 = function (a) {
                  return _this130.topPlayerRemapper.fromResponse(a);
                };

                return _context369.abrupt("return", _context369.sent.data.map(_context369.t0));

              case 6:
              case "end":
                return _context369.stop();
            }
          }
        }, _callee368, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getNextMatchForPlayer", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee369() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee369$(_context370) {
          while (1) {
            switch (_context370.prev = _context370.next) {
              case 0:
                n = "/players/".concat(e, "/next-match").concat(this.apiSignInUrl), r = Date.now(), a = "There was a problem with next match for player request";
                i && (n += "&disable_cache=".concat(r));
                _context370.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                o = _context370.sent;
                return _context370.abrupt("return", this.matchFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context370.stop();
            }
          }
        }, _callee369, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getPrevMatchForPlayer", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee370() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee370$(_context371) {
          while (1) {
            switch (_context371.prev = _context371.next) {
              case 0:
                n = "/players/".concat(e, "/previous-match").concat(this.apiSignInUrl), r = Date.now(), a = "There was a problem with previous match for player request";
                i && (n += "&disable_cache=".concat(r));
                _context371.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                o = _context371.sent;
                return _context371.abrupt("return", this.matchFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context371.stop();
            }
          }
        }, _callee370, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getMatchById", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee371() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee371$(_context372) {
          while (1) {
            switch (_context372.prev = _context372.next) {
              case 0:
                n = "/matches/".concat(e).concat(this.apiSignInUrl), r = Date.now(), a = "There was a problem with match by ID request";
                i && (n += "&disable_cache=".concat(r));
                _context372.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                o = _context372.sent;
                return _context372.abrupt("return", this.matchFullRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context372.stop();
            }
          }
        }, _callee371, this);
      }));
    });
    s(_assertThisInitialized(_this124), "getMatches", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee372() {
        var _this131 = this;

        var n, r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee372$(_context373) {
          while (1) {
            switch (_context373.prev = _context373.next) {
              case 0:
                n = new Ys(), r = "/matches".concat(this.apiSignInUrl), a = Date.now(), o = "There was a problem with football matches request";
                e && (r += "".concat(e.constructFilterUrl())), i && (r += "&disable_cache=".concat(a));
                _context373.next = 4;
                return this.fetchWithoutAuth(r, o);

              case 4:
                l = _context373.sent;
                return _context373.abrupt("return", (n.meta = this.footballMetaRemapper.remapMetaProp(l.meta), n.data = l.data.map(function (c) {
                  return _this131.matchBasicRemapper.fromResponse(c);
                }), n));

              case 6:
              case "end":
                return _context373.stop();
            }
          }
        }, _callee372, this);
      }));
    });
    s(_assertThisInitialized(_this124), "search", function (e, i) {
      return u(_assertThisInitialized(_this124), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee373() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee373$(_context374) {
          while (1) {
            switch (_context374.prev = _context374.next) {
              case 0:
                n = "/search".concat(this.apiSignInUrl).concat(e.constructFilterUrl()), r = Date.now(), a = "There was a problem with football search request";
                i && (n += "&disable_cache=".concat(r));
                _context374.next = 4;
                return this.fetchWithoutAuth(n, a);

              case 4:
                o = _context374.sent;
                return _context374.abrupt("return", this.searchRemapper.fromResponse(o.data));

              case 6:
              case "end":
                return _context374.stop();
            }
          }
        }, _callee373, this);
      }));
    });
    _this124.apiSignInUrl = e.lang !== "en" ? _this124.apiSignInUrl + "&lang=".concat(e.lang) : _this124.apiSignInUrl, _this124.countryRemapper = new Rt(), _this124.competitionBasicRemapper = new Li(), _this124.competitionFullRemapper = new g1(), _this124.teamBasicRemapper = new li(), _this124.teamFullRemapper = new I1(), _this124.matchBasicRemapper = new C1(), _this124.matchFullRemapper = new F1(), _this124.playerBasicRemapper = new ep(), _this124.playerFullRemapper = new L1(), _this124.topPlayerRemapper = new x1(), _this124.searchRemapper = new U1(), _this124.footballMetaRemapper = new B1();
    return _this124;
  }

  return us;
}(St),
    ds = function (t) {
  return t.FT_1X2 = "FT_1X2", t.HT_1X2 = "HT_1X2", t.BOTH_TEAMS_SCORE = "BOTH_TEAMS_SCORE", t.DOUBLE_CHANCE = "DOUBLE_CHANCE", t.HT_FT = "HT_FT", t.PLAYER_SCORE = "PLAYER_SCORE", t.PLAYER_YELLOW_CARD = "PLAYER_YELLOW_CARD", t.PLAYER_RED_CARD = "PLAYER_RED_CARD", t.RED_CARD_MATCH = "RED_CARD_MATCH", t.PENALTY_MATCH = "PENALTY_MATCH", t.PLAYER_SCORE_FIRST_GOAL = "PLAYER_SCORE_FIRST_GOAL", t.CORNERS_MATCH = "CORNERS_MATCH", t.CORRECT_SCORE = "CORRECT_SCORE", t.CORRECT_SCORE_ADVANCED = "CORRECT_SCORE_ADVANCED", t.CORRECT_SCORE_HT = "CORRECT_SCORE_HT", t.PLAYER_SCORE_HATTRICK = "PLAYER_SCORE_HATTRICK", t.PLAYER_SCORE_TWICE = "PLAYER_SCORE_TWICE", t.OVER_GOALS_0_5 = "OVER_GOALS_0_5", t.OVER_GOALS_1_5 = "OVER_GOALS_1_5", t.OVER_GOALS_2_5 = "OVER_GOALS_2_5", t.OVER_GOALS_3_5 = "OVER_GOALS_3_5", t.OVER_GOALS_4_5 = "OVER_GOALS_4_5", t.OVER_GOALS_5_5 = "OVER_GOALS_5_5", t.OVER_GOALS_6_5 = "OVER_GOALS_6_5", t.OVER_CORNERS_6_5 = "OVER_CORNERS_6_5", t.OVER_CORNERS_7_5 = "OVER_CORNERS_7_5", t.OVER_CORNERS_8_5 = "OVER_CORNERS_8_5", t.OVER_CORNERS_9_5 = "OVER_CORNERS_9_5", t.OVER_CORNERS_10_5 = "OVER_CORNERS_10_5", t.OVER_CORNERS_11_5 = "OVER_CORNERS_11_5", t.OVER_CORNERS_12_5 = "OVER_CORNERS_12_5", t.OVER_CORNERS_13_5 = "OVER_CORNERS_13_5", t;
}(ds || {}),
    H1 = ["OVER_GOALS_0_5", "OVER_GOALS_1_5", "OVER_GOALS_2_5", "OVER_GOALS_3_5", "OVER_GOALS_4_5", "OVER_GOALS_5_5", "OVER_GOALS_6_5"],
    V1 = ["OVER_CORNERS_6_5", "OVER_CORNERS_7_5", "OVER_CORNERS_8_5", "OVER_CORNERS_9_5", "OVER_CORNERS_10_5", "OVER_CORNERS_11_5", "OVER_CORNERS_12_5", "OVER_CORNERS_13_5"],
    Nt = ["PLAYER_RED_CARD", "PLAYER_SCORE", "PLAYER_SCORE_FIRST_GOAL", "PLAYER_SCORE_HATTRICK", "PLAYER_SCORE_TWICE", "PLAYER_YELLOW_CARD"],
    j1 = ["FT_1X2", "HT_1X2", "HT_FT", "DOUBLE_CHANCE", "CORNERS_MATCH", "CORRECT_SCORE", "CORRECT_SCORE_HT", "CORRECT_SCORE_ADVANCED"],
    Ir = "PLAYER_SCORE_FIRST_GOAL",
    W1 = function W1() {
  _classCallCheck(this, W1);

  s(this, "id", "");
  s(this, "achievedAt", "");
},
    tp = function tp() {
  _classCallCheck(this, tp);

  s(this, "totalPoints", null);
  s(this, "postPoints", null);
  s(this, "postsMade", null);
  s(this, "reactionPoints", null);
  s(this, "reactionCount", null);
},
    bc = function bc() {
  _classCallCheck(this, bc);

  s(this, "participations", 0);
  s(this, "points", 0);
},
    Sa = function Sa() {
  _classCallCheck(this, Sa);

  s(this, "footballCompetitions", []);
  s(this, "footballTeams", []);
},
    ip = function ip() {
  _classCallCheck(this, ip);

  s(this, "predictionsMade", 0);
  s(this, "correct", 0);
  s(this, "points", 0);
  s(this, "breakdown", new Sa());
},
    np = function np() {
  _classCallCheck(this, np);

  s(this, "single", new ip());
  s(this, "topX", new bc());
  s(this, "matchQuiz", new bc());
},
    G1 = function G1() {
  _classCallCheck(this, G1);

  s(this, "overallPercent");
  s(this, "byFootballCompetition");
  s(this, "byFootballTeam");
  s(this, "byFootballMarket");
},
    z1 = function z1() {
  _classCallCheck(this, z1);

  s(this, "profileId");
  s(this, "tier");
  s(this, "points");
  s(this, "predictionsMade");
  s(this, "successRates", new G1());
  s(this, "predictions", new np());
  s(this, "tiers", []);
  s(this, "badges", []);
  s(this, "discussions", new tp());
},
    q1 = function q1() {
  _classCallCheck(this, q1);

  s(this, "entityId", "");
  s(this, "entityType", "");
  s(this, "entitySource", "");
  s(this, "model", null);
  s(this, "predictionsMade", 0);
  s(this, "correct", 0);
  s(this, "points", 0);
},
    Q1 = function Q1() {
  _classCallCheck(this, Q1);

  s(this, "successRatePercent");
  s(this, "model", null);
},
    rp = function rp() {
  _classCallCheck(this, rp);

  s(this, "content", null);
  s(this, "tags", []);
  s(this, "campaign", null);
},
    sp = function sp() {
  _classCallCheck(this, sp);

  s(this, "id", null);
  s(this, "profileId", null);
  s(this, "property", null);
  s(this, "value", null);
  s(this, "action", null);
  s(this, "context", new rp());
  s(this, "points", 0);
},
    Y1 = function Y1() {
  _classCallCheck(this, Y1);

  s(this, "meta", new cs());
  s(this, "data", [new sp()]);
},
    K1 = function K1() {
  var _this132 = this;

  _classCallCheck(this, K1);

  s(this, "remapSingleResponse", function (t) {
    var e = new sp();
    return e.id = t.id, e.profileId = t.profile_id, e.property = t.property, e.value = t.value, e.action = t.action, e.context.content = t.context.content, e.context.tags = t.context.tags, e.context.campaign = t.context.campaign, e.points = t.points, e;
  });
  s(this, "remapActivitiesResponse", function (t) {
    var e = new Y1();
    return e.meta.pagination.currentPage = t.meta.pagination.current_page, e.meta.pagination.itemsPerPage = t.meta.pagination.items_per_page, e.meta.pagination.numberOfPages = t.meta.pagination.number_of_pages, e.meta.pagination.totalItems = t.meta.pagination.total_items, e.data = t.data.map(function (i) {
      return _this132.remapSingleResponse(i);
    }), e;
  });
  s(this, "remapStatsResponse", function (t) {
    var e = new z1();
    return e.profileId = t.profile_id, e.tier = t.tier, e.points = t.points, e.predictionsMade = t.predictions_made, e.successRates.overallPercent = t.success_rates.overall_percent, e.successRates.byFootballCompetition = _this132.constructNewRecord(t.success_rates.by_competition), e.successRates.byFootballTeam = _this132.constructNewRecord(t.success_rates.by_team), e.successRates.byFootballMarket = _this132.constructNewRecord(t.success_rates.by_market), e.predictions = t.predictions ? _this132.remapPredictionsStats(t.predictions) : null, e.tiers = t.tiers ? _this132.remapAchievementsStats(t.tiers) : null, e.badges = t.badges ? _this132.remapAchievementsStats(t.badges) : null, e.discussions = t.discussions ? _this132.remapDiscussionStats(t.discussions) : null, e;
  });
  s(this, "constructNewRecord", function (t) {
    var e;
    if (Object.entries(t).length) Object.entries(t).forEach(function (_ref58) {
      var _ref59 = _slicedToArray(_ref58, 2),
          i = _ref59[0],
          n = _ref59[1];

      e = $(O({}, e), _defineProperty({}, i, _this132.remapSuccessRatePercent(n))), ds[i] && delete e[i].model;
    });else return t;
    return e;
  });
  s(this, "remapSuccessRatePercent", function (t) {
    var e = new Q1();
    return e.successRatePercent = t.success_rate_percent, e;
  });
  s(this, "remapPredictionsStats", function (t) {
    var e = new np();
    return e.single = _this132.remapSinglePredictionsStats(t.single), e.topX = t.top_x, e.matchQuiz = t.match_quiz, e;
  });
  s(this, "remapSinglePredictionsStats", function (t) {
    var e = new ip();
    return e.predictionsMade = t.predictions_made, e.correct = t.correct, e.points = t.points, e.breakdown = _this132.remapBreakdownSinglePredictionsStats(t.breakdown), e;
  });
  s(this, "remapBreakdownSinglePredictionsStats", function (t) {
    if (t && Object.keys(t).length) {
      var e = new Sa(),
          i = [],
          n = [];
      return Object.keys(t).forEach(function (r) {
        var a = new q1();
        a.entityId = r, a.entityType = t[r].entity_type, a.entitySource = t[r].entity_source, a.predictionsMade = t[r].predictions_made, a.correct = t[r].correct, a.points = t[r].points, a.entityType === "competition" ? i.push(a) : a.entityType === "team" && n.push(a);
      }), e.footballCompetitions = i, e.footballTeams = n, e;
    }

    return new Sa();
  });
  s(this, "remapAchievementsStats", function (t) {
    return t.map(function (e) {
      var i = new W1();
      return i.id = e.id, i.achievedAt = e.achieved_at, i;
    });
  });
  s(this, "remapDiscussionStats", function (t) {
    var e = new tp();
    return e.totalPoints = t.total_points, e.postPoints = t.post_points, e.postsMade = t.posts_made, e.reactionPoints = t.reaction_points, e.reactionCount = t.reaction_count, e;
  });
},
    ap =
/*#__PURE__*/
function (_St5) {
  _inherits(ap, _St5);

  function ap(e) {
    var _this133;

    _classCallCheck(this, ap);

    _this133 = _possibleConstructorReturn(this, _getPrototypeOf(ap).call(this, e, Ct(e.environment, "loyalty")));
    s(_assertThisInitialized(_this133), "activityRemapper", null);
    s(_assertThisInitialized(_this133), "createActivity", function (e) {
      return u(_assertThisInitialized(_this133), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee374() {
        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee374$(_context375) {
          while (1) {
            switch (_context375.prev = _context375.next) {
              case 0:
                i = "/activities".concat(this.apiSignInUrl);
                n = "There was a problem with creating activity";
                r = "POST";
                _context375.next = 5;
                return this.fetchWithAuth(i, n, r, e);

              case 5:
                a = _context375.sent;
                return _context375.abrupt("return", this.activityRemapper.remapSingleResponse(a));

              case 7:
              case "end":
                return _context375.stop();
            }
          }
        }, _callee374, this);
      }));
    });
    s(_assertThisInitialized(_this133), "deleteActivity", function (e) {
      return u(_assertThisInitialized(_this133), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee375() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee375$(_context376) {
          while (1) {
            switch (_context376.prev = _context376.next) {
              case 0:
                i = "/activities/".concat(e).concat(this.apiSignInUrl), n = "There was a problem deleting the following activity: ".concat(e), r = "DELETE";
                _context376.next = 3;
                return this.fetchWithAuth(i, n, r);

              case 3:
                return _context376.abrupt("return", !0);

              case 4:
              case "end":
                return _context376.stop();
            }
          }
        }, _callee375, this);
      }));
    });
    s(_assertThisInitialized(_this133), "getOwnActivities", function (e, i) {
      return u(_assertThisInitialized(_this133), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee376() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee376$(_context377) {
          while (1) {
            switch (_context377.prev = _context377.next) {
              case 0:
                n = "/activities".concat(this.apiSignInUrl), r = Date.now(), a = "There was a problem with fetching own activities";
                e && (n += "".concat(e.constructFilterUrl())), i && (n += "disable_cache=".concat(r));
                _context377.next = 4;
                return this.fetchWithAuth(n, a);

              case 4:
                o = _context377.sent;
                return _context377.abrupt("return", this.activityRemapper.remapActivitiesResponse(o));

              case 6:
              case "end":
                return _context377.stop();
            }
          }
        }, _callee376, this);
      }));
    });
    s(_assertThisInitialized(_this133), "getActivitiesForUser", function (e, i, n) {
      return u(_assertThisInitialized(_this133), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee377() {
        var r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee377$(_context378) {
          while (1) {
            switch (_context378.prev = _context378.next) {
              case 0:
                r = "/users/".concat(e, "/activities").concat(this.apiSignInUrl), a = Date.now(), o = "There was a problem with fetching activities for user: ".concat(e);
                i && (r += "".concat(i.constructFilterUrl())), n && (r += "disable_cache=".concat(a));
                _context378.next = 4;
                return this.fetchWithoutAuth(r, o);

              case 4:
                l = _context378.sent;
                return _context378.abrupt("return", this.activityRemapper.remapActivitiesResponse(l));

              case 6:
              case "end":
                return _context378.stop();
            }
          }
        }, _callee377, this);
      }));
    });
    s(_assertThisInitialized(_this133), "getStats", function (e, i) {
      return u(_assertThisInitialized(_this133), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee378() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee378$(_context379) {
          while (1) {
            switch (_context379.prev = _context379.next) {
              case 0:
                n = "", r = "", a = null;

                if (!e) {
                  _context379.next = 9;
                  break;
                }

                n += Ee(i) ? "/users/".concat(e, "/statistics").concat(this.apiSignInUrl).concat(Ce()) : "/users/".concat(e, "/statistics").concat(this.apiSignInUrl);
                r = "There was a problem fetching statistics for profile: ".concat(e);
                _context379.next = 6;
                return this.fetchWithoutAuth(n, r);

              case 6:
                a = _context379.sent;
                _context379.next = 14;
                break;

              case 9:
                n += "/statistics".concat(this.apiSignInUrl);
                r = "There was a problem fetching profile`s statistics";
                _context379.next = 13;
                return this.fetchWithAuth(n, r);

              case 13:
                a = _context379.sent;

              case 14:
                return _context379.abrupt("return", this.activityRemapper.remapStatsResponse(a.data));

              case 15:
              case "end":
                return _context379.stop();
            }
          }
        }, _callee378, this);
      }));
    });
    _this133.activityRemapper = new K1();
    return _this133;
  }

  return ap;
}(St),
    J1 = function J1() {
  _classCallCheck(this, J1);

  s(this, "id", "");
  s(this, "source", "");
  s(this, "type", "");
  s(this, "favourite", !1);
},
    X1 =
/*#__PURE__*/
function (_J) {
  _inherits(X1, _J);

  function X1() {
    var _this134;

    _classCallCheck(this, X1);

    _this134 = _possibleConstructorReturn(this, _getPrototypeOf(X1).apply(this, arguments));
    s(_assertThisInitialized(_this134), "model", null);
    return _this134;
  }

  return X1;
}(J1),
    Z1 = function Z1(t, e, i) {
  var _this135 = this;

  _classCallCheck(this, Z1);

  s(this, "idMapping", null);
  s(this, "idSchema", null);
  s(this, "native", "native");
  s(this, "footballFacade", null);
  s(this, "remapProfileStats", function (t) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee379() {
      var e, i, n, _r33, a, o, _r34, _a8, _o8;

      return _regeneratorRuntime.wrap(function _callee379$(_context380) {
        while (1) {
          switch (_context380.prev = _context380.next) {
            case 0:
              if (t.predictions) {
                _context380.next = 2;
                break;
              }

              return _context380.abrupt("return", t);

            case 2:
              e = t.successRates, i = t.predictions, n = {
                competition: this.getIdsKeys(e.byFootballCompetition, i.single.breakdown.footballCompetitions),
                team: this.getIdsKeys(e.byFootballTeam, i.single.breakdown.footballTeams)
              };

              if (!Object.values(n.competition).length) {
                _context380.next = 12;
                break;
              }

              _r33 = JSON.parse(JSON.stringify(t.successRates.byFootballCompetition));
              _context380.next = 7;
              return this.getEntitiesMap(n.competition, "competition");

            case 7:
              a = _context380.sent;
              _context380.next = 10;
              return this.setSuccessRatesModels(_r33, a);

            case 10:
              o = _context380.sent;
              t.successRates.byFootballCompetition = o, i.single.breakdown.footballCompetitions = this.reconstructBreakdown(i.single.breakdown.footballCompetitions, a);

            case 12:
              if (!Object.values(n.team).length) {
                _context380.next = 21;
                break;
              }

              _r34 = JSON.parse(JSON.stringify(t.successRates.byFootballTeam));
              _context380.next = 16;
              return this.getEntitiesMap(n.team, "team");

            case 16:
              _a8 = _context380.sent;
              _context380.next = 19;
              return this.setSuccessRatesModels(_r34, _a8);

            case 19:
              _o8 = _context380.sent;
              t.successRates.byFootballTeam = _o8, i.single.breakdown.footballTeams = this.reconstructBreakdown(i.single.breakdown.footballTeams, _a8);

            case 21:
              return _context380.abrupt("return", t);

            case 22:
            case "end":
              return _context380.stop();
          }
        }
      }, _callee379, this);
    }));
  });
  s(this, "setSuccessRatesModels", function (t, e) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee380() {
      var i;
      return _regeneratorRuntime.wrap(function _callee380$(_context381) {
        while (1) {
          switch (_context381.prev = _context381.next) {
            case 0:
              return _context381.abrupt("return", this.reconstructRecords(t, i, e));

            case 1:
            case "end":
              return _context381.stop();
          }
        }
      }, _callee380, this);
    }));
  });
  s(this, "getEntitiesMap", function (t, e) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee381() {
      return _regeneratorRuntime.wrap(function _callee381$(_context382) {
        while (1) {
          switch (_context382.prev = _context382.next) {
            case 0:
              _context382.t0 = e;
              _context382.next = _context382.t0 === "competition" ? 3 : _context382.t0 === "team" ? 6 : 9;
              break;

            case 3:
              _context382.next = 5;
              return this.footballFacade.getCompetitionsMapWithNativeIds(t);

            case 5:
              return _context382.abrupt("return", _context382.sent);

            case 6:
              _context382.next = 8;
              return this.footballFacade.getTeamsMapWithNativeIds(t);

            case 8:
              return _context382.abrupt("return", _context382.sent);

            case 9:
            case "end":
              return _context382.stop();
          }
        }
      }, _callee381, this);
    }));
  });
  s(this, "reconstructRecords", function (t, e, i) {
    return t && Object.keys(t).length ? (Object.keys(t).forEach(function (n) {
      var r = i.get(n);
      e = $(O({}, e), _defineProperty({}, r.id, t[n])), e[r.id].model = r;
    }), e) : t;
  });
  s(this, "reconstructBreakdown", function (t, e) {
    return t.length ? t.map(function (i) {
      var n = e.get(i.entityId);
      return i.entityId = n.id, i.model = n, i;
    }) : t;
  });
  s(this, "getIdsKeys", function (t, e) {
    var i = Object.keys(t);

    if (e.length) {
      var n = e.map(function (r) {
        return r.entityId;
      });
      return Array.from(
      /* @__PURE__ */
      new Set([].concat(_toConsumableArray(i), _toConsumableArray(n))));
    }

    return i;
  });
  s(this, "remapInterestsToIdSchema", function (t) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee383() {
      var _this136 = this;

      var _ret2;

      return _regeneratorRuntime.wrap(function _callee383$(_context384) {
        while (1) {
          switch (_context384.prev = _context384.next) {
            case 0:
              if (!(this.idSchema !== this.native)) {
                _context384.next = 9;
                break;
              }

              if (!(t && t.length > 0)) {
                _context384.next = 8;
                break;
              }

              return _context384.delegateYield(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee382() {
                var e, i, n, r, a, o, _loop6, _i42, _Object$entries3, _ref61;

                return _regeneratorRuntime.wrap(function _callee382$(_context383) {
                  while (1) {
                    switch (_context383.prev = _context383.next) {
                      case 0:
                        e = {}, i = {}, n = t.filter(function (l) {
                          return l.source.toLocaleUpperCase() === "FOOTBALL";
                        }), r = t.filter(function (l) {
                          return l.source.toLocaleUpperCase() !== "FOOTBALL";
                        });
                        n.forEach(function (l) {
                          e.hasOwnProperty(l.type) || (e[l.type] = [], i[l.type] = []), e[l.type].push(l.id), i[l.type].push(l);
                        });
                        _context383.next = 4;
                        return _this136.remapIdsObj(e, _this136.native, _this136.idSchema);

                      case 4:
                        a = _context383.sent;
                        o = [];

                        _loop6 = function _loop6() {
                          var _ref60 = _Object$entries3[_i42];
                          _ref61 = _slicedToArray(_ref60, 2);
                          var l = _ref61[0];
                          var c = _ref61[1];
                          c.forEach(function (d, h) {
                            d.id = a[l][h], o.push(d);
                          });
                        };

                        for (_i42 = 0, _Object$entries3 = Object.entries(i); _i42 < _Object$entries3.length; _i42++) {
                          _loop6();
                        }

                        return _context383.abrupt("return", {
                          v: o.concat(r)
                        });

                      case 9:
                      case "end":
                        return _context383.stop();
                    }
                  }
                }, _callee382);
              })(), "t0", 3);

            case 3:
              _ret2 = _context384.t0;

              if (!(typeof _ret2 === "object")) {
                _context384.next = 6;
                break;
              }

              return _context384.abrupt("return", _ret2.v);

            case 6:
              _context384.next = 9;
              break;

            case 8:
              return _context384.abrupt("return", t);

            case 9:
              return _context384.abrupt("return", t);

            case 10:
            case "end":
              return _context384.stop();
          }
        }
      }, _callee383, this);
    }));
  });
  s(this, "remapInterestToNative", function (t) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee384() {
      var _e11, i, n, _r35;

      return _regeneratorRuntime.wrap(function _callee384$(_context385) {
        while (1) {
          switch (_context385.prev = _context385.next) {
            case 0:
              if (!(this.idSchema !== this.native && t.source.toLocaleUpperCase() === "FOOTBALL")) {
                _context385.next = 7;
                break;
              }

              _e11 = {}, i = t.id, n = t.type;
              _e11[n] = [i];
              _context385.next = 5;
              return this.remapIdsObj(_e11, this.idSchema, this.native);

            case 5:
              _r35 = _context385.sent;
              return _context385.abrupt("return", (t.id = _r35[n][0], t));

            case 7:
              return _context385.abrupt("return", t);

            case 8:
            case "end":
              return _context385.stop();
          }
        }
      }, _callee384, this);
    }));
  });
  s(this, "inquiryCustomInterests", function (t, e) {
    var i = [];
    return t && t.length > 0 && (i = t.filter(function (n) {
      return n.source.toLocaleUpperCase() === "CUSTOM";
    }), e) ? i.map(function (n) {
      var r = new X1();
      return r.id = n.id, r.type = n.type, r.source = n.source, r.favourite = n.favourite, r;
    }) : i;
  });
  s(this, "remapInterests", function (t) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee385() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee385$(_context386) {
        while (1) {
          switch (_context386.prev = _context386.next) {
            case 0:
              e = this.inquiryCustomInterests(t, !1);

              if (!(e && e.length > 0)) {
                _context386.next = 7;
                break;
              }

              i = t.filter(function (r) {
                return r.source.toLocaleUpperCase() !== "CUSTOM";
              });
              _context386.next = 5;
              return this.remapInterestsToIdSchema(i);

            case 5:
              n = _context386.sent;
              return _context386.abrupt("return", (e.forEach(function (r) {
                return n.push(r);
              }), n));

            case 7:
              _context386.next = 9;
              return this.remapInterestsToIdSchema(t);

            case 9:
              return _context386.abrupt("return", _context386.sent);

            case 10:
            case "end":
              return _context386.stop();
          }
        }
      }, _callee385, this);
    }));
  });
  s(this, "showFullInterests", function (t) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee386() {
      var e, i, n, _ref62, _r36, _a9, _o9, _l11;

      return _regeneratorRuntime.wrap(function _callee386$(_context387) {
        while (1) {
          switch (_context387.prev = _context387.next) {
            case 0:
              e = [];

              if (!(t && t.length > 0)) {
                _context387.next = 13;
                break;
              }

              i = this.inquiryCustomInterests(t, !0);
              e.push(i);
              n = t.filter(function (c) {
                return c.source.toLocaleUpperCase() !== "CUSTOM";
              });
              _context387.next = 7;
              return this.getInterestsEntitiesMap(n);

            case 7:
              _ref62 = _context387.sent;
              _r36 = _ref62.competitionsMap;
              _a9 = _ref62.teamsMap;
              _o9 = _ref62.playersMap;
              _l11 = n.map(function (c) {
                var d = null;

                if (c.source.toLocaleUpperCase() === "FOOTBALL") {
                  if (c.type === "competition") return d = _r36.get(c.id), d && (c.id = d.id), c.model = d, c;
                  if (c.type === "team") return d = _a9.get(c.id), d && (c.id = d.id), c.model = d, c;
                  if (c.type === "player") return _o9 ? (c.model = _o9[c.id], c.id = _o9[c.id].id) : c.model = d, c;
                } else return c.model = d, c;
              });
              return _context387.abrupt("return", (e.push(_l11), e.flat()));

            case 13:
              return _context387.abrupt("return", e);

            case 14:
            case "end":
              return _context387.stop();
          }
        }
      }, _callee386, this);
    }));
  });
  s(this, "getInterestsEntitiesMap", function (t) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee387() {
      var e, i, n, r, a, o;
      return _regeneratorRuntime.wrap(function _callee387$(_context388) {
        while (1) {
          switch (_context388.prev = _context388.next) {
            case 0:
              e = [], i = [], n = [], r =
              /* @__PURE__ */
              new Map(), a =
              /* @__PURE__ */
              new Map(), o = null;
              t.forEach(function (l) {
                l.type === "competition" && l.source.toLocaleUpperCase() === "FOOTBALL" ? e.push(l.id) : l.type === "team" && l.source.toLocaleUpperCase() === "FOOTBALL" ? i.push(l.id) : l.type === "player" && l.source.toLocaleUpperCase() === "FOOTBALL" && n.push(l.id);
              });
              _context388.t0 = e.length;

              if (!_context388.t0) {
                _context388.next = 7;
                break;
              }

              _context388.next = 6;
              return this.footballFacade.getCompetitionsMapWithNativeIds(e);

            case 6:
              r = _context388.sent;

            case 7:
              _context388.t1 = i.length;

              if (!_context388.t1) {
                _context388.next = 12;
                break;
              }

              _context388.next = 11;
              return this.footballFacade.getTeamsMapWithNativeIds(i);

            case 11:
              a = _context388.sent;

            case 12:
              _context388.t2 = n.length;

              if (!_context388.t2) {
                _context388.next = 17;
                break;
              }

              _context388.next = 16;
              return this.footballFacade.getPlayersMapWithNativeIds(n);

            case 16:
              o = _context388.sent;

            case 17:
              return _context388.abrupt("return", {
                competitionsMap: r,
                teamsMap: a,
                playersMap: o
              });

            case 18:
            case "end":
              return _context388.stop();
          }
        }
      }, _callee387, this);
    }));
  });
  s(this, "remapIdsObj", function (t, e, i) {
    return u(_this135, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee388() {
      return _regeneratorRuntime.wrap(function _callee388$(_context389) {
        while (1) {
          switch (_context389.prev = _context389.next) {
            case 0:
              _context389.next = 2;
              return this.idMapping.idMappingFacade.getEntitiesByIds(t, e, i);

            case 2:
              return _context389.abrupt("return", _context389.sent);

            case 3:
            case "end":
              return _context389.stop();
          }
        }
      }, _callee388, this);
    }));
  });
  this.idMapping = i, this.idSchema = t.idSchema, this.footballFacade = e;
},
    eR = function eR(t, e) {
  var _this137 = this;

  _classCallCheck(this, eR);

  s(this, "idMapping", null);
  s(this, "profileOperations", null);
  s(this, "remapProfileStats", function (t) {
    return u(_this137, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee389() {
      return _regeneratorRuntime.wrap(function _callee389$(_context390) {
        while (1) {
          switch (_context390.prev = _context390.next) {
            case 0:
              _context390.next = 2;
              return this.profileOperations.remapProfileStats(t);

            case 2:
              return _context390.abrupt("return", _context390.sent);

            case 3:
            case "end":
              return _context390.stop();
          }
        }
      }, _callee389, this);
    }));
  });
  s(this, "remapInterestToNative", function (t) {
    return u(_this137, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee390() {
      return _regeneratorRuntime.wrap(function _callee390$(_context391) {
        while (1) {
          switch (_context391.prev = _context391.next) {
            case 0:
              _context391.next = 2;
              return this.profileOperations.remapInterestToNative(t);

            case 2:
              return _context391.abrupt("return", _context391.sent);

            case 3:
            case "end":
              return _context391.stop();
          }
        }
      }, _callee390, this);
    }));
  });
  s(this, "remapInterests", function (t) {
    return u(_this137, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee391() {
      return _regeneratorRuntime.wrap(function _callee391$(_context392) {
        while (1) {
          switch (_context392.prev = _context392.next) {
            case 0:
              _context392.next = 2;
              return this.profileOperations.remapInterests(t);

            case 2:
              return _context392.abrupt("return", _context392.sent);

            case 3:
            case "end":
              return _context392.stop();
          }
        }
      }, _callee391, this);
    }));
  });
  s(this, "showFullInterests", function (t) {
    return u(_this137, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee392() {
      return _regeneratorRuntime.wrap(function _callee392$(_context393) {
        while (1) {
          switch (_context393.prev = _context393.next) {
            case 0:
              _context393.next = 2;
              return this.profileOperations.showFullInterests(t);

            case 2:
              return _context393.abrupt("return", _context393.sent);

            case 3:
            case "end":
              return _context393.stop();
          }
        }
      }, _callee392, this);
    }));
  });
  this.idMapping = new Tt(t), this.profileOperations = new Z1(t, e, this.idMapping);
},
    hs = function hs(t) {
  var _this138 = this;

  _classCallCheck(this, hs);

  s(this, "idsRemapper", null);
  s(this, "profileHttps", null);
  s(this, "activityHttps", null);
  s(this, "footballHttps", null);
  s(this, "footballFacade", null);
  s(this, "idMapping", null);
  s(this, "localCache", null);
  s(this, "profileFacade", null);
  s(this, "ownProfileBuilder", null);
  s(this, "profileBuilder", null);
  s(this, "getOwn", function () {
    return _this138.ownProfileBuilder;
  });
  s(this, "getById", function (t) {
    return _this138.profileBuilder.setId(t);
  });
  s(this, "getCountries", function (t) {
    return u(_this138, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee393() {
      return _regeneratorRuntime.wrap(function _callee393$(_context394) {
        while (1) {
          switch (_context394.prev = _context394.next) {
            case 0:
              _context394.next = 2;
              return this.profileFacade.getCountries(t);

            case 2:
              return _context394.abrupt("return", _context394.sent);

            case 3:
            case "end":
              return _context394.stop();
          }
        }
      }, _callee393, this);
    }));
  });
  s(this, "getByIds", function (t, e, i) {
    return u(_this138, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee394() {
      return _regeneratorRuntime.wrap(function _callee394$(_context395) {
        while (1) {
          switch (_context395.prev = _context395.next) {
            case 0:
              _context395.next = 2;
              return this.profileFacade.getByIds(t, e, i);

            case 2:
              return _context395.abrupt("return", _context395.sent);

            case 3:
            case "end":
              return _context395.stop();
          }
        }
      }, _callee394, this);
    }));
  });
  this.profileHttps = new Hh(t), this.activityHttps = new ap(t), this.footballHttps = new us(t), this.idMapping = new Tt(t), this.localCache = new Cn().createLocalCacheInstance(t.idSchema), this.footballFacade = new Kh(t, this.localCache, this.footballHttps, this.idMapping), this.profileFacade = new ls(this.localCache, this.profileHttps, this.activityHttps), this.idsRemapper = new eR(t, this.footballFacade), this.ownProfileBuilder = new qT(this.idsRemapper, this.localCache, this.profileHttps, this.activityHttps, t.errorHandlingMode), this.profileBuilder = new QT(this.idsRemapper, this.localCache, this.profileHttps, this.activityHttps);
},
    op = function (t) {
  return t.EN = "en", t.BG = "bg", t.RO = "ro", t.EL = "el", t.SK = "sk", t.PT = "pt", t.SR = "sr", t.HU = "hu", t.SV = "sv", t.ES = "es", t.FR = "fr", t.NL = "nl", t.DE = "de", t.IT = "it", t;
}(op || {}),
    tR = function tR() {
  var _this139 = this;

  _classCallCheck(this, tR);

  s(this, "validate", function (t) {
    var e = _this139.validateField(t.lang),
        i = _this139.generateMessage(e);

    return {
      validation: e,
      message: i
    };
  });
  s(this, "validateField", function (t) {
    var e = Object.values(op),
        i = null;
    return t != null && t.length > 0 ? e.includes(t) ? i = "valid" : i = "invalid" : i = "missing", i;
  });
  s(this, "generateMessage", function (t) {
    var e = null,
        i = "warning";
    return t === "missing" && (e = "If no lang is passed the default one will be set which is: en"), t === "invalid" && (e = "This lang value is not supported, the default one will be set which is: en"), t === "valid" && (e = null, i = null), {
      text: e,
      type: i
    };
  });
},
    iR =
/*#__PURE__*/
function () {
  function iR() {
    _classCallCheck(this, iR);

    s(this, "validateField", function (t) {
      var e = ["dev", "staging", "prod", "watg"],
          i = null;
      return t != null && t.length > 0 ? e.includes(t) ? i = "valid" : i = "invalid" : i = "missing", i;
    });
    s(this, "generateMessage", function (t) {
      var e = null,
          i = "warning";
      return t === "missing" && (e = "If no environment is passed the default one will be set which is: prod"), t === "invalid" && (e = "This environment value is not supported, the default one will be set which is: prod"), t === "valid" && (e = null, i = null), {
        text: e,
        type: i
      };
    });
  }

  _createClass(iR, [{
    key: "validate",
    value: function validate(t) {
      var e = this.validateField(t.environment),
          i = this.generateMessage(e);
      return {
        validation: e,
        message: i
      };
    }
  }]);

  return iR;
}(),
    nR =
/*#__PURE__*/
function () {
  function nR() {
    _classCallCheck(this, nR);

    s(this, "validateField", function (t) {
      var e = null;
      return t != null && t.length > 0 ? e = "valid" : e = "missing", e;
    });
    s(this, "generateMessage", function (t) {
      var e = null,
          i = "error";
      return t === "missing" && (e = "The field apiKey with valid value must be provided to use Fans United JS SDK"), t === "valid" && (i = null), {
        text: e,
        type: i
      };
    });
  }

  _createClass(nR, [{
    key: "validate",
    value: function validate(t) {
      var e = this.validateField(t.apiKey),
          i = this.generateMessage(e);
      return {
        validation: e,
        message: i
      };
    }
  }]);

  return nR;
}(),
    rR =
/*#__PURE__*/
function () {
  function rR() {
    _classCallCheck(this, rR);

    s(this, "validateField", function (t) {
      var e = Object.values(Vh),
          i = null;
      return t != null && t.length > 0 ? e.includes(t) ? i = "valid" : i = "invalid" : i = "missing", i;
    });
    s(this, "generateMessage", function (t) {
      var e = null,
          i = "warning";
      return t === "missing" && (e = "If no idSchema is passed the default one will be set which is: native"), t === "invalid" && (e = "This idSchema value is not supported, the default one will be set which is: native"), t === "valid" && (e = null, i = null), {
        text: e,
        type: i
      };
    });
  }

  _createClass(rR, [{
    key: "validate",
    value: function validate(t) {
      var e = this.validateField(t.idSchema),
          i = this.generateMessage(e);
      return {
        validation: e,
        message: i
      };
    }
  }]);

  return rR;
}(),
    Ta = function Ta() {
  _classCallCheck(this, Ta);

  s(this, "getIdToken", null);
  s(this, "logout", null);
},
    Ks = function Ks() {
  _classCallCheck(this, Ks);

  s(this, "text", null);
  s(this, "type", null);
},
    sR = function sR() {
  _classCallCheck(this, sR);

  s(this, "validation", null);
  s(this, "message", new Ks());
  s(this, "getIdToken", {
    validation: null,
    message: new Ks()
  });
  s(this, "logout", {
    validation: null,
    message: new Ks()
  });
},
    aR =
/*#__PURE__*/
function () {
  function aR() {
    _classCallCheck(this, aR);

    s(this, "validateAuthProvider", function (t) {
      var e = Object.keys(new Ta()),
          i = new sR();

      if (t) {
        var n = Object.keys(t).filter(function (r) {
          return !e.includes(r);
        });
        n.length > 0 ? (i.validation = "invalid", i.message.type = "warning", i.message.text = "You have passed a property which is not supported for the authentication provider: ".concat(n.join(","))) : i.validation = "valid";
      } else i.validation = "missing", i.message.type = "error", i.message.text = "The field authProvider must be provided to use this SDK";

      return i;
    });
    s(this, "validateAuthProviderConfigFields", function (t, e) {
      return Object.keys(new Ta()).forEach(function (i) {
        t[i] ? e[i].validation = "valid" : e[i].validation = "missing";
      }), e;
    });
    s(this, "generateAuthProviderConfigMessages", function (t) {
      return Object.keys(t).filter(function (e) {
        return e !== "validation" && e !== "message";
      }).forEach(function (e) {
        var i = t[e];
        i.validation === "missing" && (i.message.text = "The following property is missing from the authProvider object: ".concat(e), i.message.type = "error");
      }), t;
    });
    s(this, "checkAuthProviderConfigMessagesForErrors", function (t) {
      return Object.keys(t).filter(function (e) {
        return e !== "validation" && e !== "message";
      }).forEach(function (e) {
        t[e].validation === "missing" && t.validation === "valid" && (t.validation = "invalid", t.message.type = "error", t.message.text = "The field authProvider has missing properties");
      }), t;
    });
  }

  _createClass(aR, [{
    key: "validate",
    value: function validate(t) {
      var e = this.validateAuthProvider(t.authProvider);
      return e.validation !== "missing" && (e = this.validateAuthProviderConfigFields(t.authProvider, e), e = this.generateAuthProviderConfigMessages(e), e = this.checkAuthProviderConfigMessagesForErrors(e)), e;
    }
  }]);

  return aR;
}(),
    Ic = function Ic() {
  _classCallCheck(this, Ic);

  s(this, "validation");
  s(this, "message");
},
    oR = function oR() {
  _classCallCheck(this, oR);

  s(this, "apiKey", null);
  s(this, "environment", null);
  s(this, "idSchema", null);
  s(this, "clientId", null);
  s(this, "lang", null);
  s(this, "errorHandlingMode", null);
  s(this, "authProvider", {
    getIdToken: new Ic(),
    logout: new Ic()
  });
  s(this, "isValid", !1);
},
    lR =
/*#__PURE__*/
function () {
  function lR() {
    _classCallCheck(this, lR);

    s(this, "validateField", function (t) {
      var e = null;
      return t != null && t.length > 0 ? e = "valid" : e = "missing", e;
    });
    s(this, "generateMessage", function (t) {
      var e = null,
          i = "error";
      return t === "missing" && (e = "The field clientId must be provided to use Fans United JS SDK"), t === "valid" && (e = null, i = null), {
        text: e,
        type: i
      };
    });
  }

  _createClass(lR, [{
    key: "validate",
    value: function validate(t) {
      var e = this.validateField(t.clientId),
          i = this.generateMessage(e);
      return {
        validation: e,
        message: i
      };
    }
  }]);

  return lR;
}(),
    cR = function cR() {
  var _this140 = this;

  _classCallCheck(this, cR);

  s(this, "validate", function (t) {
    var e = _this140.validateField(t.errorHandlingMode),
        i = _this140.generateMessage(e);

    return {
      validation: e,
      message: i
    };
  });
  s(this, "validateField", function (t) {
    var e = ["default", "standard"],
        i = null;
    return t ? e.includes(t) ? i = "valid" : i = "invalid" : i = "missing", i;
  });
  s(this, "generateMessage", function (t) {
    var e = null,
        i = "warning";
    return t === "missing" && (e = "If no errorHandlingMode is passed the default one will be set which is: default"), t === "invalid" && (e = "This errorHandlingMode value is not supported, the default one will be set which is: default"), t === "valid" && (e = null, i = null), {
      text: e,
      type: i
    };
  });
},
    uR = function uR() {
  var _this141 = this;

  _classCallCheck(this, uR);

  s(this, "validate", function (t) {
    var e = _this141.checkFieldsForValues(t);

    return e.isValid = _this141.containsErrorMessage(e), e;
  });
  s(this, "checkFieldsForValues", function (t) {
    var e = new oR(),
        i = {
      apiKey: new nR(),
      environment: new iR(),
      idSchema: new rR(),
      clientId: new lR(),
      lang: new tR(),
      errorHandlingMode: new cR(),
      authProvider: new aR()
    };

    for (var _i43 = 0, _Object$entries4 = Object.entries(e); _i43 < _Object$entries4.length; _i43++) {
      var _ref65 = _Object$entries4[_i43];

      var _ref64 = _slicedToArray(_ref65, 2);

      var n = _ref64[0];
      var _r37 = _ref64[1];
      n !== "isValid" && (_r37 = i[n].validate(t));
    }

    return Object.keys(i).forEach(function (n) {
      e[n] = i[n].validate(t);
    }), e;
  });
  s(this, "containsErrorMessage", function (t) {
    var e = !0;

    for (var _i44 = 0, _Object$entries5 = Object.entries(t); _i44 < _Object$entries5.length; _i44++) {
      var _ref68 = _Object$entries5[_i44];

      var _ref67 = _slicedToArray(_ref68, 2);

      var i = _ref67[0];
      var n = _ref67[1];

      if (i !== "authProvider") {
        if (i !== "isValid" && n.message.type === "error") return e = !1, e;
        if (i !== "isValid" && n.message.type === "warning") return e = !0, e;
      } else if (n.message.type === "error") return e = !1, e;
    }

    return e;
  });
},
    lp = function lp(t) {
  var _this142 = this;

  _classCallCheck(this, lp);

  s(this, "https", null);
  s(this, "idMapping", null);
  s(this, "localCache", null);
  s(this, "footballFacade", null);
  s(this, "getCountries", function (t) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee395() {
      return _regeneratorRuntime.wrap(function _callee395$(_context396) {
        while (1) {
          switch (_context396.prev = _context396.next) {
            case 0:
              _context396.next = 2;
              return this.footballFacade.getCountries(t);

            case 2:
              return _context396.abrupt("return", _context396.sent);

            case 3:
            case "end":
              return _context396.stop();
          }
        }
      }, _callee395, this);
    }));
  });
  s(this, "getCompetitions", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee396() {
      return _regeneratorRuntime.wrap(function _callee396$(_context397) {
        while (1) {
          switch (_context397.prev = _context397.next) {
            case 0:
              _context397.next = 2;
              return this.footballFacade.getCompetitions(t, e);

            case 2:
              return _context397.abrupt("return", _context397.sent);

            case 3:
            case "end":
              return _context397.stop();
          }
        }
      }, _callee396, this);
    }));
  });
  s(this, "getCompetitionById", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee397() {
      return _regeneratorRuntime.wrap(function _callee397$(_context398) {
        while (1) {
          switch (_context398.prev = _context398.next) {
            case 0:
              _context398.next = 2;
              return this.footballFacade.getCompetitionById(t, e);

            case 2:
              return _context398.abrupt("return", _context398.sent);

            case 3:
            case "end":
              return _context398.stop();
          }
        }
      }, _callee397, this);
    }));
  });
  s(this, "getTopCompetitions", function (t) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee398() {
      return _regeneratorRuntime.wrap(function _callee398$(_context399) {
        while (1) {
          switch (_context399.prev = _context399.next) {
            case 0:
              _context399.next = 2;
              return this.footballFacade.getTopCompetitions(t);

            case 2:
              return _context399.abrupt("return", _context399.sent);

            case 3:
            case "end":
              return _context399.stop();
          }
        }
      }, _callee398, this);
    }));
  });
  s(this, "getTeams", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee399() {
      return _regeneratorRuntime.wrap(function _callee399$(_context400) {
        while (1) {
          switch (_context400.prev = _context400.next) {
            case 0:
              _context400.next = 2;
              return this.footballFacade.getTeams(t, e);

            case 2:
              return _context400.abrupt("return", _context400.sent);

            case 3:
            case "end":
              return _context400.stop();
          }
        }
      }, _callee399, this);
    }));
  });
  s(this, "getTeamById", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee400() {
      return _regeneratorRuntime.wrap(function _callee400$(_context401) {
        while (1) {
          switch (_context401.prev = _context401.next) {
            case 0:
              _context401.next = 2;
              return this.footballFacade.getTeamById(t, e);

            case 2:
              return _context401.abrupt("return", _context401.sent);

            case 3:
            case "end":
              return _context401.stop();
          }
        }
      }, _callee400, this);
    }));
  });
  s(this, "getTopTeams", function (t) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee401() {
      return _regeneratorRuntime.wrap(function _callee401$(_context402) {
        while (1) {
          switch (_context402.prev = _context402.next) {
            case 0:
              _context402.next = 2;
              return this.footballFacade.getTopTeams(t);

            case 2:
              return _context402.abrupt("return", _context402.sent);

            case 3:
            case "end":
              return _context402.stop();
          }
        }
      }, _callee401, this);
    }));
  });
  s(this, "getNextMatchForTeam", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee402() {
      return _regeneratorRuntime.wrap(function _callee402$(_context403) {
        while (1) {
          switch (_context403.prev = _context403.next) {
            case 0:
              _context403.next = 2;
              return this.footballFacade.getNextMatchForTeam(t, e);

            case 2:
              return _context403.abrupt("return", _context403.sent);

            case 3:
            case "end":
              return _context403.stop();
          }
        }
      }, _callee402, this);
    }));
  });
  s(this, "getPrevMatchForTeam", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee403() {
      return _regeneratorRuntime.wrap(function _callee403$(_context404) {
        while (1) {
          switch (_context404.prev = _context404.next) {
            case 0:
              _context404.next = 2;
              return this.footballFacade.getPrevMatchForTeam(t, e);

            case 2:
              return _context404.abrupt("return", _context404.sent);

            case 3:
            case "end":
              return _context404.stop();
          }
        }
      }, _callee403, this);
    }));
  });
  s(this, "getPlayers", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee404() {
      return _regeneratorRuntime.wrap(function _callee404$(_context405) {
        while (1) {
          switch (_context405.prev = _context405.next) {
            case 0:
              _context405.next = 2;
              return this.footballFacade.getPlayers(t, e);

            case 2:
              return _context405.abrupt("return", _context405.sent);

            case 3:
            case "end":
              return _context405.stop();
          }
        }
      }, _callee404, this);
    }));
  });
  s(this, "getPlayerById", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee405() {
      return _regeneratorRuntime.wrap(function _callee405$(_context406) {
        while (1) {
          switch (_context406.prev = _context406.next) {
            case 0:
              _context406.next = 2;
              return this.footballFacade.getPlayerById(t, e);

            case 2:
              return _context406.abrupt("return", _context406.sent);

            case 3:
            case "end":
              return _context406.stop();
          }
        }
      }, _callee405, this);
    }));
  });
  s(this, "getTopPlayers", function (t) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee406() {
      return _regeneratorRuntime.wrap(function _callee406$(_context407) {
        while (1) {
          switch (_context407.prev = _context407.next) {
            case 0:
              _context407.next = 2;
              return this.footballFacade.getTopPlayers(t);

            case 2:
              return _context407.abrupt("return", _context407.sent);

            case 3:
            case "end":
              return _context407.stop();
          }
        }
      }, _callee406, this);
    }));
  });
  s(this, "getNextMatchForPlayer", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee407() {
      return _regeneratorRuntime.wrap(function _callee407$(_context408) {
        while (1) {
          switch (_context408.prev = _context408.next) {
            case 0:
              _context408.next = 2;
              return this.footballFacade.getNextMatchForPlayer(t, e);

            case 2:
              return _context408.abrupt("return", _context408.sent);

            case 3:
            case "end":
              return _context408.stop();
          }
        }
      }, _callee407, this);
    }));
  });
  s(this, "getPrevMatchForPlayer", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee408() {
      return _regeneratorRuntime.wrap(function _callee408$(_context409) {
        while (1) {
          switch (_context409.prev = _context409.next) {
            case 0:
              _context409.next = 2;
              return this.footballFacade.getPrevMatchForPlayer(t, e);

            case 2:
              return _context409.abrupt("return", _context409.sent);

            case 3:
            case "end":
              return _context409.stop();
          }
        }
      }, _callee408, this);
    }));
  });
  s(this, "getMatches", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee409() {
      return _regeneratorRuntime.wrap(function _callee409$(_context410) {
        while (1) {
          switch (_context410.prev = _context410.next) {
            case 0:
              _context410.next = 2;
              return this.footballFacade.getMatches(t, e);

            case 2:
              return _context410.abrupt("return", _context410.sent);

            case 3:
            case "end":
              return _context410.stop();
          }
        }
      }, _callee409, this);
    }));
  });
  s(this, "getMatchById", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee410() {
      return _regeneratorRuntime.wrap(function _callee410$(_context411) {
        while (1) {
          switch (_context411.prev = _context411.next) {
            case 0:
              _context411.next = 2;
              return this.footballFacade.getMatchById(t, e);

            case 2:
              return _context411.abrupt("return", _context411.sent);

            case 3:
            case "end":
              return _context411.stop();
          }
        }
      }, _callee410, this);
    }));
  });
  s(this, "search", function (t, e) {
    return u(_this142, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee411() {
      return _regeneratorRuntime.wrap(function _callee411$(_context412) {
        while (1) {
          switch (_context412.prev = _context412.next) {
            case 0:
              _context412.next = 2;
              return this.footballFacade.search(t, e);

            case 2:
              return _context412.abrupt("return", _context412.sent);

            case 3:
            case "end":
              return _context412.stop();
          }
        }
      }, _callee411, this);
    }));
  });
  this.https = new us(t), this.idMapping = new Tt(t), this.localCache = new Cn().createLocalCacheInstance(t.idSchema), this.footballFacade = new Kh(t, this.localCache, this.https, this.idMapping);
},
    dR = function dR() {
  _classCallCheck(this, dR);

  s(this, "value", null);
  s(this, "playerId", null);
  s(this, "playerModel", null);
},
    cp = function cp() {
  _classCallCheck(this, cp);

  s(this, "market", null);
  s(this, "matchId", null);
  s(this, "matchType", null);
  s(this, "matchModel", null);
  s(this, "prediction", new dR());
  s(this, "result", null);
},
    hR = function hR() {
  _classCallCheck(this, hR);

  s(this, "value", !1);
  s(this, "playerId", null);
},
    Ri = function Ri(t, e, i, n) {
  _classCallCheck(this, Ri);

  s(this, "matchId", null);
  s(this, "market", null);
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.market = e, this.prediction = new hR(), this.prediction.value = i, this.prediction.playerId = n;
},
    up = function up() {
  _classCallCheck(this, up);

  s(this, "settledAt", null);
  s(this, "resettledAt", null);
  s(this, "status", null);
  s(this, "outcome", null);
  s(this, "points", 0);
},
    pR = function pR() {
  _classCallCheck(this, pR);

  s(this, "value", null);
},
    Oo = function Oo(t, e, i) {
  _classCallCheck(this, Oo);

  s(this, "matchId", null);
  s(this, "market", null);
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.market = e, this.prediction = new pR(), this.prediction.value = i;
},
    Tn = function Tn() {
  _classCallCheck(this, Tn);

  s(this, "value", !1);
},
    dp = function dp(t, e, i) {
  _classCallCheck(this, dp);

  s(this, "matchId", null);
  s(this, "market", null);
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.market = e, this.prediction = new Tn(), this.prediction.value = i;
},
    hp = function hp(t, e, i) {
  _classCallCheck(this, hp);

  s(this, "matchId", null);
  s(this, "market", null);
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.market = e, this.prediction = new Tn(), this.prediction.value = i;
},
    fR = function fR(t, e, i) {
  var _this143 = this;

  _classCallCheck(this, fR);

  s(this, "matchFacade", null);
  s(this, "playerFacade", null);
  s(this, "predictorService", null);
  s(this, "remapFixturesRequest", function (t) {
    var e = {};
    if (e.match_id = t.matchId, e.match_type = "FOOTBALL", t instanceof Ri) e.market = t.market, e.prediction = t.prediction.value, e.player_id = t.prediction.playerId;else if (t instanceof dp || t instanceof hp) e.market = t.market, e.prediction = t.prediction.value;else if (t instanceof Oo) {
      e.market = t.market;

      var _i45 = t.prediction.value.split(":");

      e.goals_home = Number(_i45[0]), e.goals_away = Number(_i45[1]);
    } else e.market = t.market, e.prediction = t.prediction.value;
    return e;
  });
  s(this, "remapFixturesResponse", function (t) {
    return u(_this143, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee412() {
      var e, i, n, r, a, _iteratorNormalCompletion21, _didIteratorError21, _iteratorError21, _iterator21, _step21, _l12, o, _iteratorNormalCompletion22, _didIteratorError22, _iteratorError22, _iterator22, _step22, _l13, c;

      return _regeneratorRuntime.wrap(function _callee412$(_context413) {
        while (1) {
          switch (_context413.prev = _context413.next) {
            case 0:
              e = "OWN_GOAL", i = [], n = [], r = null, a = [];
              t.length > 1 && t.sort(function (l, c) {
                return l.match_id.localeCompare(c.match_id);
              });
              _iteratorNormalCompletion21 = true;
              _didIteratorError21 = false;
              _iteratorError21 = undefined;
              _context413.prev = 5;

              for (_iterator21 = t[Symbol.iterator](); !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                _l12 = _step21.value;
                i.push(_l12.match_id), _l12.player_id && !n.includes(_l12.player_id) && n.push(_l12.player_id);
              }

              _context413.next = 13;
              break;

            case 9:
              _context413.prev = 9;
              _context413.t0 = _context413["catch"](5);
              _didIteratorError21 = true;
              _iteratorError21 = _context413.t0;

            case 13:
              _context413.prev = 13;
              _context413.prev = 14;

              if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
                _iterator21.return();
              }

            case 16:
              _context413.prev = 16;

              if (!_didIteratorError21) {
                _context413.next = 19;
                break;
              }

              throw _iteratorError21;

            case 19:
              return _context413.finish(16);

            case 20:
              return _context413.finish(13);

            case 21:
              _context413.next = 23;
              return this.matchFacade.getMatchesMapWithNativeIds(i);

            case 23:
              o = _context413.sent;
              n.sort(function (l, c) {
                return l.localeCompare(c);
              });
              _context413.t1 = n && n.length > 0 && !n.includes(e);

              if (!_context413.t1) {
                _context413.next = 30;
                break;
              }

              _context413.next = 29;
              return this.playerFacade.getPlayersMapWithNativeIds(n);

            case 29:
              r = _context413.sent;

            case 30:
              _iteratorNormalCompletion22 = true;
              _didIteratorError22 = false;
              _iteratorError22 = undefined;
              _context413.prev = 33;

              for (_iterator22 = t[Symbol.iterator](); !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                _l13 = _step22.value;
                c = new cp();
                _l13.target ? c.market = this.predictorService.convertMarketForResponseModel(_l13.market, _l13.target) : c.market = _l13.market, c.matchId = o[_l13.match_id].id, c.matchType = _l13.match_type, c.matchModel = o ? o[_l13.match_id] : null, delete c.matchModel.availableMarkets, _l13.goals_home !== void 0 && _l13.goals_away !== void 0 ? c.prediction.value = _l13.goals_home.toString() + ":" + _l13.goals_away.toString() : c.prediction.value = _l13.prediction, c.prediction.playerId = _l13.player_id ? _l13.player_id : null, c.prediction.playerId && c.prediction.playerId !== e && (c.prediction.playerModel = r[_l13.player_id], c.prediction.playerId = r[_l13.player_id].id), c.result = this.remapResult(_l13.result), a.push(c);
              }

              _context413.next = 41;
              break;

            case 37:
              _context413.prev = 37;
              _context413.t2 = _context413["catch"](33);
              _didIteratorError22 = true;
              _iteratorError22 = _context413.t2;

            case 41:
              _context413.prev = 41;
              _context413.prev = 42;

              if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
                _iterator22.return();
              }

            case 44:
              _context413.prev = 44;

              if (!_didIteratorError22) {
                _context413.next = 47;
                break;
              }

              throw _iteratorError22;

            case 47:
              return _context413.finish(44);

            case 48:
              return _context413.finish(41);

            case 49:
              return _context413.abrupt("return", a);

            case 50:
            case "end":
              return _context413.stop();
          }
        }
      }, _callee412, this, [[5, 9, 13, 21], [14,, 16, 20], [33, 37, 41, 49], [42,, 44, 48]]);
    }));
  });
  s(this, "remapResult", function (t) {
    var e = new up();
    return e.settledAt = t.settled_at, e.resettledAt = t.resettled_at, e.status = t.status, e.outcome = t.outcome, e.points = t.points, e;
  });
  this.matchFacade = t, this.playerFacade = e, this.predictorService = i;
},
    ps = function ps() {
  _classCallCheck(this, ps);

  s(this, "goldenGoal", null);
},
    _c = function _c() {
  _classCallCheck(this, _c);

  s(this, "id", null);
  s(this, "gameInstanceId", null);
  s(this, "gameType", null);
  s(this, "wager", null);
  s(this, "totalFixtures", null);
  s(this, "settledFixtures", null);
  s(this, "userId", null);
  s(this, "fixtures", []);
  s(this, "status", null);
  s(this, "tiebreaker", new ps());
  s(this, "points", null);
  s(this, "createdAt", null);
  s(this, "updatedAt", null);
},
    _e = function _e() {
  _classCallCheck(this, _e);

  s(this, "no", 0);
  s(this, "yes", 0);
},
    mR = function mR() {
  _classCallCheck(this, mR);

  s(this, "fullTimeOneXTwo", {});
  s(this, "halfTimeOneXTwo", {});
  s(this, "bothTeamsScore", new _e());
  s(this, "doubleChance", {});
  s(this, "halfTimeFullTime", {});
  s(this, "playerScore", {});
  s(this, "playerYellowCard", {});
  s(this, "playerRedCard", {});
  s(this, "redCardMatch", new _e());
  s(this, "penaltyMatch", new _e());
  s(this, "playerScoreFirstGoal", {});
  s(this, "cornersMatch", {});
  s(this, "correctScore", {});
  s(this, "correctScoreHalfTime", {});
  s(this, "correctScoreAdvanced", {});
  s(this, "playerScoreHattrick", {});
  s(this, "playerScoreTwice", {});
  s(this, "overZeroPointFiveGoals", new _e());
  s(this, "overOnePointFiveGoals", new _e());
  s(this, "overTwoPointFiveGoals", new _e());
  s(this, "overThreePointFiveGoals", new _e());
  s(this, "overFourPointFiveGoals", new _e());
  s(this, "overFivePointFiveGoals", new _e());
  s(this, "overSixPointFiveGoals", new _e());
  s(this, "overSixPointFiveCorners", new _e());
  s(this, "overSevenPointFiveCorners", new _e());
  s(this, "overEightPointFiveCorners", new _e());
  s(this, "overNinePointFiveCorners", new _e());
  s(this, "overTenPointFiveCorners", new _e());
  s(this, "overElevenPointFiveCorners", new _e());
  s(this, "overTwelvePointFiveCorners", new _e());
  s(this, "overThirteenPointFiveCorners", new _e());
},
    fs = function fs() {
  _classCallCheck(this, fs);

  s(this, "timeTiebreaker", !1);
},
    Zn = function Zn() {
  _classCallCheck(this, Zn);

  s(this, "id", null);
  s(this, "title", null);
  s(this, "description", null);
  s(this, "type", null);
  s(this, "status", null);
  s(this, "outcome", null);
  s(this, "predictionsCutoff", null);
  s(this, "fixtures", []);
  s(this, "tiebreaker", new fs());
  s(this, "predictionId", null);
  s(this, "participantsCount", 0);
  s(this, "related", null);
  s(this, "excludedProfileIds", null);
  s(this, "rules", null);
  s(this, "flags", null);
  s(this, "points", null);
  s(this, "createdAt", null);
  s(this, "updatedAt", null);
  s(this, "predictionsMadeAt", null);
  s(this, "scheduleOpenAt", null);
  s(this, "images", null);
  s(this, "predictionTiebreaker", new ps());
},
    Ra = function Ra() {
  _classCallCheck(this, Ra);

  s(this, "userId", null);
  s(this, "points", null);
  s(this, "results", []);
  s(this, "tiebreaker", null);
},
    pp = function (t) {
  return t.ACTIVE = "ACTIVE", t.WON = "WON", t.LOST = "LOST", t.PARTIALLY_WON = "PARTIALLY_WON", t.CANCELED = "CANCELED", t;
}(pp || {}),
    Ec = ["WON", "LOST", "PARTIALLY_WON", "CANCELED"],
    rt = function rt(t) {
  var _this144 = this;

  _classCallCheck(this, rt);

  s(this, "limit", null);
  s(this, "startAfter", null);
  s(this, "status", null);
  s(this, "type", null);
  s(this, "matchIds", null);
  s(this, "constructFiltersUrl", function () {
    var t = "",
        e = !1;
    return _this144.status && (e = Object.values(pp).some(function (i) {
      return _this144.status.includes(i);
    })), _this144.limit && (t += "&", t += "limit=".concat(_this144.limit)), _this144.startAfter && (t += "&", t += "start_after=".concat(_this144.startAfter)), _this144.status && e && (t += "&", t += "status=".concat(_this144.status.join(","))), _this144.type && (t += "&", t += "game_types=".concat(_this144.type)), _this144.matchIds && (t += "&", t += "match_ids=".concat(_this144.matchIds.join(","))), t;
  });
  this.limit = t.limit ? t.limit : null, this.startAfter = t.startAfter ? t.startAfter : null, this.status = t.status ? t.status : null, this.type = t.type ? t.type : null, this.matchIds = t.matchIds ? t.matchIds : null;
},
    ms =
/*#__PURE__*/
function () {
  function ms(t) {
    _classCallCheck(this, ms);

    s(this, "limit");
    s(this, "startAfter");
    this.limit = t.limit ? t.limit : null, this.startAfter = t.startAfter ? t.startAfter : null;
  }

  _createClass(ms, [{
    key: "constructMainFiltersUrl",
    value: function constructMainFiltersUrl() {
      var t = "";
      return this.limit && (t += "&", t += "limit=".concat(this.limit)), this.startAfter && (t += "&", t += "start_after=".concat(this.startAfter)), t;
    }
  }]);

  return ms;
}(),
    fp = function (t) {
  return t.OPEN = "OPEN", t.LIVE = "LIVE", t.PENDING = "PENDING", t.CANCELED = "CANCELED", t.CLOSED = "CLOSED", t.SETTLED = "SETTLED", t;
}(fp || {}),
    Qt =
/*#__PURE__*/
function (_ms) {
  _inherits(Qt, _ms);

  function Qt(e) {
    var _this145;

    _classCallCheck(this, Qt);

    _this145 = _possibleConstructorReturn(this, _getPrototypeOf(Qt).call(this, e));
    s(_assertThisInitialized(_this145), "status", null);
    s(_assertThisInitialized(_this145), "type", null);
    s(_assertThisInitialized(_this145), "gameIds", null);
    s(_assertThisInitialized(_this145), "sortOrder", null);
    s(_assertThisInitialized(_this145), "constructFiltersUrl", function () {
      var e = _get2(_getPrototypeOf(Qt.prototype), "constructMainFiltersUrl", _assertThisInitialized(_this145)).call(_assertThisInitialized(_this145));

      return _this145.status && Object.values(fp).includes(_this145.status) && (e += "&", e += "status=".concat(_this145.status)), _this145.type && (e += "&", e += "type=".concat(_this145.type)), _this145.gameIds && _this145.gameIds.length > 0 && (e += "&", e += "game_ids=".concat(_this145.gameIds.join(","))), _this145.sortOrder && (e += "&", e += "sort_order=".concat(_this145.sortOrder)), e;
    });
    _this145.status = e.status ? e.status : null, _this145.type = e.type ? e.type : null, _this145.gameIds = e.gameIds ? e.gameIds : null, _this145.sortOrder = e.sortOrder ? e.sortOrder : null;
    return _this145;
  }

  return Qt;
}(ms),
    Ao = function Ao() {
  _classCallCheck(this, Ao);

  s(this, "main", null);
  s(this, "cover", null);
  s(this, "mobile", null);
},
    _r = function _r() {
  _classCallCheck(this, _r);

  s(this, "id", null);
  s(this, "title", null);
  s(this, "description", null);
  s(this, "type", null);
  s(this, "status", null);
  s(this, "scheduleOpenAt", null);
  s(this, "predictionsCutoff", null);
  s(this, "fixtures", []);
  s(this, "tiebreaker", new fs());
  s(this, "participantsCount", 0);
  s(this, "related", null);
  s(this, "excludedProfileIds", null);
  s(this, "rules", null);
  s(this, "labels", null);
  s(this, "customFields", null);
  s(this, "flags", null);
  s(this, "images", new Ao());
  s(this, "createdAt", null);
  s(this, "updatedAt", null);
},
    Xi = function Xi() {
  _classCallCheck(this, Xi);

  s(this, "id", null);
  s(this, "title", null);
  s(this, "description", null);
  s(this, "type", null);
  s(this, "status", null);
  s(this, "outcome", null);
  s(this, "predictionsCutoff", null);
  s(this, "fixtures", []);
  s(this, "tiebreaker", new fs());
  s(this, "predictionId", null);
  s(this, "participantsCount", 0);
  s(this, "related", null);
  s(this, "excludedProfileIds", null);
  s(this, "rules", null);
  s(this, "flags", null);
  s(this, "points", null);
  s(this, "createdAt", null);
  s(this, "updatedAt", null);
  s(this, "predictionsMadeAt", null);
  s(this, "images", null);
  s(this, "scheduleOpenAt", null);
},
    mp =
/*#__PURE__*/
function (_r38) {
  _inherits(mp, _r38);

  function mp() {
    var _this146;

    _classCallCheck(this, mp);

    _this146 = _possibleConstructorReturn(this, _getPrototypeOf(mp).apply(this, arguments));
    s(_assertThisInitialized(_this146), "adContent", null);
    return _this146;
  }

  return mp;
}(_r),
    gs = function gs(t, e) {
  var _this147 = this;

  _classCallCheck(this, gs);

  s(this, "footballHttps", null);
  s(this, "idMapping", null);
  s(this, "matchFacade", null);
  s(this, "playerFacade", null);
  s(this, "profileNamespace", null);
  s(this, "remapMatchIdToNative", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee413() {
      return _regeneratorRuntime.wrap(function _callee413$(_context414) {
        while (1) {
          switch (_context414.prev = _context414.next) {
            case 0:
              _context414.next = 2;
              return this.idMapping.getEntityIdsBySchemaId(t, "match", "native");

            case 2:
              return _context414.abrupt("return", _context414.sent.match);

            case 3:
            case "end":
              return _context414.stop();
          }
        }
      }, _callee413, this);
    }));
  });
  s(this, "remapPlayerIdToNative", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee414() {
      return _regeneratorRuntime.wrap(function _callee414$(_context415) {
        while (1) {
          switch (_context415.prev = _context415.next) {
            case 0:
              _context415.next = 2;
              return this.idMapping.getEntityIdsBySchemaId(t, "player", "native");

            case 2:
              return _context415.abrupt("return", _context415.sent.player[0]);

            case 3:
            case "end":
              return _context415.stop();
          }
        }
      }, _callee414, this);
    }));
  });
  s(this, "remapPlayerIdMapToNative", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee415() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee415$(_context416) {
        while (1) {
          switch (_context416.prev = _context416.next) {
            case 0:
              e = {};
              i = as(t);
              _context416.next = 4;
              return this.idMapping.getEntityIdsBySchemaId(i, "player", "native");

            case 4:
              n = _context416.sent.player;
              return _context416.abrupt("return", (i.forEach(function (r, a) {
                return e[r] = n[a];
              }), e));

            case 6:
            case "end":
              return _context416.stop();
          }
        }
      }, _callee415, this);
    }));
  });
  s(this, "remapPlayerIdToIdSchema", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee416() {
      var e, i, _i46, _Object$entries6, _ref73, _ref70, _r39, _a10, _i48, _Object$keys5, _o10, n, _i47, _Object$entries7, _ref74, _ref72, _r40, _a11, _i49, _Object$keys6, _o11;

      return _regeneratorRuntime.wrap(function _callee416$(_context417) {
        while (1) {
          switch (_context417.prev = _context417.next) {
            case 0:
              e = ["playerScore", "playerYellowCard", "playerRedCard", "playerScoreFirstGoal", "playerScoreHattrick", "playerScoreTwice"], i = [];

              for (_i46 = 0, _Object$entries6 = Object.entries(t); _i46 < _Object$entries6.length; _i46++) {
                _ref73 = _Object$entries6[_i46];
                _ref70 = _slicedToArray(_ref73, 2);
                _r39 = _ref70[0];
                _a10 = _ref70[1];

                if (e.includes(_r39)) {
                  for (_i48 = 0, _Object$keys5 = Object.keys(_a10); _i48 < _Object$keys5.length; _i48++) {
                    _o10 = _Object$keys5[_i48];
                    _o10 !== "NOBODY" && _o10 !== "OWN_GOAL" && i.push(_o10);
                  }
                }
              }

              if (i.length) {
                _context417.next = 4;
                break;
              }

              return _context417.abrupt("return", t);

            case 4:
              _context417.next = 6;
              return this.playerFacade.getPlayersMapWithNativeIds(i);

            case 6:
              n = _context417.sent;

              for (_i47 = 0, _Object$entries7 = Object.entries(t); _i47 < _Object$entries7.length; _i47++) {
                _ref74 = _Object$entries7[_i47];
                _ref72 = _slicedToArray(_ref74, 2);
                _r40 = _ref72[0];
                _a11 = _ref72[1];

                if (e.includes(_r40)) {
                  for (_i49 = 0, _Object$keys6 = Object.keys(_a11); _i49 < _Object$keys6.length; _i49++) {
                    _o11 = _Object$keys6[_i49];
                    _o11 !== "NOBODY" && _o11 !== "OWN_GOAL" && (_a11[n[_o11].id] = _a11[_o11], _a11[n[_o11].id].model = n[_o11], this.idMapping.idSchema !== "native" && delete _a11[_o11]);
                  }
                }
              }

              return _context417.abrupt("return", t);

            case 9:
            case "end":
              return _context417.stop();
          }
        }
      }, _callee416, this);
    }));
  });
  s(this, "convertMarketForResponseModel", function (t, e) {
    var i = e.toString();
    return t + "_" + i;
  });
  s(this, "getMarketSummary", function (t, e, i) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee417() {
      var _this148 = this;

      var n, r, _a12, _o12, _a13, _o13;

      return _regeneratorRuntime.wrap(function _callee417$(_context418) {
        while (1) {
          switch (_context418.prev = _context418.next) {
            case 0:
              n = AT.get(e), r = {};

              if (!(r.matchId = t.matchId, r.matchType = t.matchType, Object.keys(t.predictions).includes(n))) {
                _context418.next = 5;
                break;
              }

              r[n] = t.predictions[n];
              _context418.next = 6;
              break;

            case 5:
              throw new Error("You have passed invalid market");

            case 6:
              if (!(Nt.includes(e) && i)) {
                _context418.next = 23;
                break;
              }

              _a12 = "";
              _context418.t0 = i !== "OWN_GOAL" && i !== "NOBODY";

              if (!_context418.t0) {
                _context418.next = 13;
                break;
              }

              _context418.next = 12;
              return this.idMapping.idMappingFacade.getEntitiesByIds({
                player: [i]
              }, this.idMapping.idSchema, "native");

            case 12:
              _a12 = _context418.sent.player[0];

            case 13:
              if (!(_a12 && r[n][_a12])) {
                _context418.next = 20;
                break;
              }

              _context418.next = 16;
              return this.playerFacade.getPlayersMapWithNativeIds([_a12]);

            case 16:
              _o12 = _context418.sent;
              return _context418.abrupt("return", (r[n][_a12].model = _o12[_a12], r[n][_a12]));

            case 20:
              return _context418.abrupt("return", _a12 ? (r[n][_a12] = new _e(), r[n][_a12]) : r[n][i]);

            case 21:
              _context418.next = 34;
              break;

            case 23:
              if (!(Nt.includes(e) && !i)) {
                _context418.next = 34;
                break;
              }

              _a13 = Object.keys(r[n]).filter(function (l) {
                return l !== "NOBODY" && l !== "OWN_GOAL";
              });

              if (!_a13.length) {
                _context418.next = 31;
                break;
              }

              _context418.next = 28;
              return this.playerFacade.getPlayersMapWithNativeIds(_a13);

            case 28:
              _context418.t1 = _context418.sent;
              _context418.next = 32;
              break;

            case 31:
              _context418.t1 = {};

            case 32:
              _o13 = _context418.t1;
              Object.keys(_o13).length && Object.keys(r[n]).forEach(function (l) {
                l !== "NOBODY" && l !== "OWN_GOAL" && (r[n][_o13[l].id] = r[n][l], r[n][_o13[l].id].model = _o13[l], _this148.idMapping.idSchema !== "native" && delete r[n][l]);
              });

            case 34:
              return _context418.abrupt("return", r);

            case 35:
            case "end":
              return _context418.stop();
          }
        }
      }, _callee417, this);
    }));
  });
  s(this, "remapCompetitionsFromConfig", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee418() {
      var _e12, i, n, _r41, _a14, _o14, _e13, _i50;

      return _regeneratorRuntime.wrap(function _callee418$(_context419) {
        while (1) {
          switch (_context419.prev = _context419.next) {
            case 0:
              if (!(t instanceof Yh)) {
                _context419.next = 14;
                break;
              }

              _e12 = {
                competition: t.fullCoverageCompetitions
              };
              i = {
                competition: t.successRateScopes.competitions
              };
              n = {
                team: t.successRateScopes.teams
              };
              _context419.next = 6;
              return this.idMapping.idMappingFacade.getEntitiesByIds(_e12, "native", this.idMapping.idSchema);

            case 6:
              _r41 = _context419.sent;
              _context419.next = 9;
              return this.idMapping.idMappingFacade.getEntitiesByIds(i, "native", this.idMapping.idSchema);

            case 9:
              _a14 = _context419.sent;
              _context419.next = 12;
              return this.idMapping.idMappingFacade.getEntitiesByIds(n, "native", this.idMapping.idSchema);

            case 12:
              _o14 = _context419.sent;
              return _context419.abrupt("return", (t.fullCoverageCompetitions = _r41.competition, t.successRateScopes.competitions = _a14.competition, t.successRateScopes.teams = _o14.team, t));

            case 14:
              if (!(t instanceof Qh || t instanceof qh)) {
                _context419.next = 20;
                break;
              }

              _e13 = {
                competition: t.competitionsWhitelist
              };
              _context419.next = 18;
              return this.idMapping.idMappingFacade.getEntitiesByIds(_e13, "native", this.idMapping.idSchema);

            case 18:
              _i50 = _context419.sent;
              return _context419.abrupt("return", (t.competitionsWhitelist = _i50.competition, t));

            case 20:
            case "end":
              return _context419.stop();
          }
        }
      }, _callee418, this);
    }));
  });
  s(this, "remapMatchIdsFixtures", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee419() {
      var _e14, i;

      return _regeneratorRuntime.wrap(function _callee419$(_context420) {
        while (1) {
          switch (_context420.prev = _context420.next) {
            case 0:
              if (!Array.isArray(t.data)) {
                _context420.next = 12;
                break;
              }

              if (!(t.data.length > 0)) {
                _context420.next = 9;
                break;
              }

              _e14 = [], i = [];
              t.data.forEach(function (n) {
                n instanceof _r || n instanceof Zn || n instanceof Xi || n instanceof mp ? (n.fixtures.forEach(function (r) {
                  return _e14.push(r.matchId);
                }), n instanceof Xi && n.fixtures.forEach(function (r) {
                  r.prediction.playerId && r.prediction.playerId !== "OWN_GOAL" && i.push(r.prediction.playerId);
                })) : n instanceof Ra && n.results.forEach(function (r) {
                  return _e14.push(r.matchId);
                });
              });
              _context420.next = 6;
              return this.refactorResponseArrModel(t, _e14, i);

            case 6:
              return _context420.abrupt("return", _context420.sent);

            case 9:
              return _context420.abrupt("return", t);

            case 10:
              _context420.next = 15;
              break;

            case 12:
              _context420.next = 14;
              return this.refactorResponseObjModel(t);

            case 14:
              return _context420.abrupt("return", _context420.sent);

            case 15:
            case "end":
              return _context420.stop();
          }
        }
      }, _callee419, this);
    }));
  });
  s(this, "refactorResponseArrModel", function (t, e, i) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee420() {
      var _this149 = this;

      var n, r, a;
      return _regeneratorRuntime.wrap(function _callee420$(_context421) {
        while (1) {
          switch (_context421.prev = _context421.next) {
            case 0:
              n = [];
              _context421.next = 3;
              return this.matchFacade.getMatchesMapWithNativeIds(e);

            case 3:
              r = _context421.sent;
              a = {};
              _context421.t0 = i.length > 0;

              if (!_context421.t0) {
                _context421.next = 10;
                break;
              }

              _context421.next = 9;
              return this.playerFacade.getPlayersMapWithNativeIds(i);

            case 9:
              a = _context421.sent;

            case 10:
              t.data.forEach(function (o) {
                o instanceof _r || o instanceof Zn || o instanceof Xi ? (o.fixtures.forEach(function (l) {
                  _this149.handleMatchModel(r, l), o instanceof Xi && l.prediction.playerId && l.prediction.playerId !== "OWN_GOAL" && (l.prediction.playerModel = a[l.prediction.playerId], l.prediction.playerId = a[l.prediction.playerId].id);
                }), n.push(o)) : o instanceof Ra && (o.results.forEach(function (l) {
                  l.matchModel = r[l.matchId], delete l.matchModel.availableMarkets, l.matchId = l.matchModel.id;
                }), n.push(o));
              });
              t.data = n;
              return _context421.abrupt("return", t);

            case 13:
            case "end":
              return _context421.stop();
          }
        }
      }, _callee420, this);
    }));
  });
  s(this, "refactorResponseObjModel", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee421() {
      var _this150 = this;

      var e, i;
      return _regeneratorRuntime.wrap(function _callee421$(_context422) {
        while (1) {
          switch (_context422.prev = _context422.next) {
            case 0:
              e = [];
              t.fixtures.forEach(function (n) {
                return e.push(n.matchId);
              });
              _context422.next = 4;
              return this.matchFacade.getMatchesMapWithNativeIds(e);

            case 4:
              i = _context422.sent;
              return _context422.abrupt("return", (t.fixtures.forEach(function (n) {
                return _this150.handleMatchModel(i, n);
              }), t));

            case 6:
            case "end":
              return _context422.stop();
          }
        }
      }, _callee421, this);
    }));
  });
  s(this, "getCurrentGameId", function (t) {
    var e = new Date();

    if (t.data.length > 1) {
      var i = [];
      return t.data.forEach(function (n) {
        return i.push(n.predictionsCutoff);
      }), t.data.sort(function (n, r) {
        var _map = [n.predictionsCutoff, r.predictionsCutoff].map(function (l) {
          return Math.abs(new Date(l) - e);
        }),
            _map2 = _slicedToArray(_map, 2),
            a = _map2[0],
            o = _map2[1];

        return a - o;
      })[0].id;
    } else return t.data[0].id;
  });
  s(this, "initGameTypePredictions", function (t, e) {
    var i = {
      type: t,
      limit: null,
      startAfter: null
    };
    return e && (i = $(O({}, i), {
      limit: e.limit,
      startAfter: e.startAfter
    })), i = new rt(i), i;
  });
  s(this, "initGameFilters", function (t, e, i) {
    if (e && i) return e.type = t, e.gameIds = i, e = new Qt(e), e;
    if (e && !i) return e.type = t, e = new Qt(e), e;

    if (!e && i) {
      var n = {
        type: t,
        gameIds: i
      };
      return n = new Qt(n), n;
    } else {
      var _n11 = {
        type: t
      };
      return _n11 = new Qt(_n11), _n11;
    }
  });
  s(this, "addPredictionProp", function (t, e) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee422() {
      var _this151 = this;

      return _regeneratorRuntime.wrap(function _callee422$(_context423) {
        while (1) {
          switch (_context423.prev = _context423.next) {
            case 0:
              e.data.forEach(function (i) {
                t.data.forEach(function (n) {
                  i.id === n.game_instance_id && (i.predictionId = n.id, i.outcome = n.status, i.fixtures.forEach(function (r, a) {
                    n.fixtures[a].goals_home !== void 0 && n.fixtures[a].goals_away !== void 0 ? r.prediction.value = n.fixtures[a].goals_home + ":" + n.fixtures[a].goals_away : r.prediction.value = n.fixtures[a].prediction, n.fixtures[a].player_id ? r.prediction.playerId = n.fixtures[a].player_id : n.fixtures[a].target && (r.prediction.target = n.fixtures[a].target), r.prediction.result = _this151.remapResult(n.fixtures[a].result);
                  }), i.predictionsMadeAt = n.created_at, i.points = n.points, i instanceof Zn && (n.tiebreaker ? i.predictionTiebreaker.goldenGoal = n.tiebreaker.golden_goal : i.predictionTiebreaker = n.tiebreaker));
                });
              });
              e.meta.pagination.nextPageStartsAfter = t.meta.pagination.next_page_starts_after;
              _context423.next = 4;
              return this.remapMatchIdsFixtures(e);

            case 4:
              return _context423.abrupt("return", _context423.sent);

            case 5:
            case "end":
              return _context423.stop();
          }
        }
      }, _callee422, this);
    }));
  });
  s(this, "remapResult", function (t) {
    var e = new up();
    return e.settledAt = t.settled_at, e.resettledAt = t.resettled_at, e.status = t.status, e.outcome = t.outcome, e.points = t.points, e;
  });
  s(this, "areIdsExceeded", function (t) {
    return t.length > 10;
  });
  s(this, "initPredictionsFilters", function (t, e, i) {
    switch (e) {
      case "user":
        t && (t = new rt(t));
        break;

      case "current":
        if (t) _this147.deleteUnexpectedProperties(t), t.status = ["ACTIVE"], t = new rt(t);else {
          var n = {
            status: ["ACTIVE"]
          };
          t = new rt(n);
        }
        break;

      case "past":
        if (t) _this147.deleteUnexpectedProperties(t), t.status = Ec, t = new rt(t);else {
          var _n12 = {
            status: Ec
          };
          t = new rt(_n12);
        }
        break;

      case "matches":
        if (t) _this147.deleteUnexpectedProperties(t), t.matchIds = i, t = new rt(t);else {
          var _n13 = {
            matchIds: i
          };
          t = new rt(_n13);
        }
        break;
    }

    return t;
  });
  s(this, "completeGameMarketResults", function (t, e) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee423() {
      var _this152 = this;

      var i, n, _r42, _a15, _o15, _l14, c, _d10;

      return _regeneratorRuntime.wrap(function _callee423$(_context424) {
        while (1) {
          switch (_context424.prev = _context424.next) {
            case 0:
              _context424.t0 = e;
              _context424.next = _context424.t0 === "MATCH_QUIZ" ? 3 : _context424.t0 === "TOP_X" ? 16 : 27;
              break;

            case 3:
              i = {};
              n = t.results[0].matchId;
              _r42 = t.results.map(function (c) {
                return Nt.includes(c.market) && !c.result.includes("OWN_GOAL") ? _toConsumableArray(c.result) : [];
              }).flat();
              _context424.next = 8;
              return this.matchFacade.getMatchesMapWithNativeIds([n]);

            case 8:
              _a15 = _context424.sent;
              _context424.t1 = _r42.length;

              if (!_context424.t1) {
                _context424.next = 14;
                break;
              }

              _context424.next = 13;
              return this.playerFacade.getPlayersMapWithNativeIds(_r42);

            case 13:
              i = _context424.sent;

            case 14:
              t.results = t.results.map(function (c) {
                if (c.matchModel = _a15[c.matchId] ? _a15[c.matchId] : null, c.playerModels && Object.keys(i).length && c.result.forEach(function (d) {
                  var h = i[d];
                  c.playerModels.push(h);
                }), _this152.idMapping.idSchema !== "native" && (_this152.remapMatchIdForResultsMarkets(_a15, c), c.playerModels && Object.keys(i).length)) {
                  var _d9 = c.result;
                  c.result = _d9.map(function (h) {
                    return i[h].id;
                  });
                }

                return c;
              });
              return _context424.abrupt("return", t);

            case 16:
              _o15 = t.results.map(function (c) {
                return c.matchId;
              });
              _context424.next = 19;
              return this.matchFacade.getMatchesMapWithNativeIds(_o15);

            case 19:
              _l14 = _context424.sent;

              if (!(t.results = t.results.map(function (c) {
                return c.matchModel = _l14[c.matchId] ? _l14[c.matchId] : null, _this152.idMapping.idSchema !== "native" && _this152.remapMatchIdForResultsMarkets(_l14, c), c;
              }), t.tieBreakers.goldenGoals.length)) {
                _context424.next = 26;
                break;
              }

              c = t.tieBreakers.goldenGoals.map(function (h) {
                return h.playerId;
              });
              _context424.next = 24;
              return this.playerFacade.getPlayersMapWithNativeIds(c);

            case 24:
              _d10 = _context424.sent;
              t.tieBreakers.goldenGoals = t.tieBreakers.goldenGoals.map(function (h) {
                return h.matchModel = _l14[h.matchId], h.playerModel = _d10[h.playerId], _this152.idMapping.idSchema !== "native" && (h.matchId = _l14[h.matchId].id, h.playerId = _d10[h.playerId].id), h;
              });

            case 26:
              return _context424.abrupt("return", t);

            case 27:
            case "end":
              return _context424.stop();
          }
        }
      }, _callee423, this);
    }));
  });
  s(this, "completeContestWinners", function (t) {
    return u(_this147, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee424() {
      var _e15, i;

      return _regeneratorRuntime.wrap(function _callee424$(_context425) {
        while (1) {
          switch (_context425.prev = _context425.next) {
            case 0:
              if (!(t.userList && t.userList.length)) {
                _context425.next = 6;
                break;
              }

              _e15 = t.userList.map(function (n) {
                return n.profileId;
              });
              _context425.next = 4;
              return this.profileNamespace.getByIds(_e15);

            case 4:
              i = _context425.sent;
              t.userList.forEach(function (n) {
                var r = i.filter(function (a) {
                  return a.id === n.profileId;
                })[0];
                delete r.interests, n.profileModel = r;
              });

            case 6:
              return _context425.abrupt("return", t);

            case 7:
            case "end":
              return _context425.stop();
          }
        }
      }, _callee424, this);
    }));
  });
  s(this, "handleMatchModel", function (t, e) {
    t[e.matchId] ? (e.matchModel = t[e.matchId], delete e.matchModel.availableMarkets, e.matchId = e.matchModel.id) : (e.matchModel = null, _this147.idMapping.idSchema !== "native" && _this147.idMapping.idMappingFacade.getEntityById(e.matchId, "match", "native").then(function (i) {
      e.matchId = i[Ue[_this147.idMapping.idSchema]];
    }));
  });
  s(this, "remapMatchIdForResultsMarkets", function (t, e) {
    t[e.matchId] ? e.matchId = t[e.matchId].id : _this147.idMapping.idMappingFacade.getEntityById(e.matchId, "match", "native").then(function (i) {
      e.matchId = i[Ue[_this147.idMapping.idSchema]];
    });
  });
  s(this, "deleteUnexpectedProperties", function (t) {
    return t.status && (console.warn(fc.UNEXPECTED_STATUS_PROP), delete t.status), t.type && (console.warn(fc.UNEXPECTED_TYPE_PROP), delete t.type), t;
  });
  this.footballHttps = new us(t), this.idMapping = e, this.matchFacade = new Ro(t, this.footballHttps, e), this.playerFacade = new To(t, this.footballHttps, e), this.profileNamespace = new hs(t);
},
    gp = function gp(t) {
  var _this153 = this;

  _classCallCheck(this, gp);

  s(this, "gameInstanceId", null);
  s(this, "fixtures", []);
  s(this, "tiebreaker", null);
  this.gameInstanceId = t.gameInstanceId, t.fixtures.forEach(function (e) {
    return _this153.fixtures.push(new Oo(e.matchId, e.market, e.prediction.value));
  }), this.tiebreaker = t.tiebreaker ? t.tiebreaker : null;
},
    yp = function yp(t, e) {
  var _this154 = this;

  _classCallCheck(this, yp);

  s(this, "fixturesRemapper", null);
  s(this, "footballHttps", null);
  s(this, "matchFacade", null);
  s(this, "playerFacade", null);
  s(this, "predictorService", null);
  s(this, "remapRequestBody", function (t) {
    var e = {};
    return e.game_instance_id = t.gameInstanceId, e.fixtures = t.fixtures.map(function (i) {
      return _this154.fixturesRemapper.remapFixturesRequest(i);
    }), t instanceof gp && t.tiebreaker && (e.tiebreaker = {}, e.tiebreaker.golden_goal = t.tiebreaker.goldenGoal ? t.tiebreaker.goldenGoal : null), e;
  });
  s(this, "remapResponseArrayBody", function (t) {
    return u(_this154, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee425() {
      var _this155 = this;

      var _e16, i, n, _r43, _a16, _o16;

      return _regeneratorRuntime.wrap(function _callee425$(_context426) {
        while (1) {
          switch (_context426.prev = _context426.next) {
            case 0:
              if (!t.length) {
                _context426.next = 13;
                break;
              }

              _e16 = "OWN_GOAL", i = [], n = [], _r43 = {}, _a16 = [];
              t.forEach(function (l) {
                l.fixtures.forEach(function (c) {
                  i.push(c.match_id), c.player_id && c.player_id !== _e16 && n.push(c.player_id);
                });
              });
              _context426.next = 5;
              return this.matchFacade.getMatchesMapWithNativeIds(i);

            case 5:
              _o16 = _context426.sent;
              _context426.t0 = n.length > 0;

              if (!_context426.t0) {
                _context426.next = 11;
                break;
              }

              _context426.next = 10;
              return this.playerFacade.getPlayersMapWithNativeIds(n);

            case 10:
              _r43 = _context426.sent;

            case 11:
              t.forEach(function (l) {
                var c = new _c(),
                    d = [];
                c.id = l.id, c.gameInstanceId = l.game_instance_id, c.gameType = l.game_type, c.wager = l.wager, c.totalFixtures = l.total_fixtures, c.settledFixtures = l.settled_fixtures, c.userId = l.user_id, l.fixtures.forEach(function (h) {
                  var p = new cp();
                  h.target ? p.market = _this155.predictorService.convertMarketForResponseModel(h.market, h.target) : p.market = h.market, p.matchId = _o16[h.match_id].id, p.matchType = h.match_type, p.matchModel = _o16[h.match_id], delete p.matchModel.availableMarkets, h.goals_home !== void 0 && h.goals_away !== void 0 ? p.prediction.value = h.goals_home.toString() + ":" + h.goals_away.toString() : p.prediction.value = h.prediction, p.prediction.playerId = h.player_id ? h.player_id : null, p.prediction.playerId && p.prediction.playerId !== _e16 && (p.prediction.playerModel = _r43[p.prediction.playerId], p.prediction.playerId = _r43[p.prediction.playerId].id), p.result = _this155.fixturesRemapper.remapResult(h.result), d.push(p);
                }), c.fixtures = d, c.status = l.status, l.tiebreaker ? c.tiebreaker.goldenGoal = l.tiebreaker.golden_goal : c.tiebreaker = null, c.points = l.points, c.createdAt = l.created_at, c.updatedAt = l.updated_at, _a16.push(c);
              });
              return _context426.abrupt("return", _a16);

            case 13:
              return _context426.abrupt("return", t);

            case 14:
            case "end":
              return _context426.stop();
          }
        }
      }, _callee425, this);
    }));
  });
  s(this, "remapResponseObjBody", function (t) {
    return u(_this154, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee426() {
      var e;
      return _regeneratorRuntime.wrap(function _callee426$(_context427) {
        while (1) {
          switch (_context427.prev = _context427.next) {
            case 0:
              e = new _c();
              e.id = t.id;
              e.gameInstanceId = t.game_instance_id;
              e.gameType = t.game_type;
              e.wager = t.wager;
              e.totalFixtures = t.total_fixtures;
              e.settledFixtures = t.settled_fixtures;
              e.userId = t.user_id;
              _context427.next = 10;
              return this.fixturesRemapper.remapFixturesResponse(t.fixtures);

            case 10:
              e.fixtures = _context427.sent;
              e.status = t.status;
              t.tiebreaker ? e.tiebreaker.goldenGoal = t.tiebreaker.golden_goal : e.tiebreaker = null;
              e.points = t.points;
              e.createdAt = t.created_at;
              e.updatedAt = t.updated_at;
              return _context427.abrupt("return", e);

            case 17:
            case "end":
              return _context427.stop();
          }
        }
      }, _callee426, this);
    }));
  });
  s(this, "remapPredictionModel", function (t) {
    var e = new mR();
    return e.fullTimeOneXTwo = t.FT_1X2, e.halfTimeOneXTwo = t.HT_1X2, e.bothTeamsScore = t.BOTH_TEAMS_SCORE, e.overZeroPointFiveGoals = t.OVER_GOALS_0_5, e.overOnePointFiveGoals = t.OVER_GOALS_1_5, e.overTwoPointFiveGoals = t.OVER_GOALS_2_5, e.overThreePointFiveGoals = t.OVER_GOALS_3_5, e.overFourPointFiveGoals = t.OVER_GOALS_4_5, e.overFivePointFiveGoals = t.OVER_GOALS_5_5, e.overSixPointFiveGoals = t.OVER_GOALS_6_5, e.overSixPointFiveCorners = t.OVER_CORNERS_6_5, e.overSevenPointFiveCorners = t.OVER_CORNERS_7_5, e.overEightPointFiveCorners = t.OVER_CORNERS_8_5, e.overNinePointFiveCorners = t.OVER_CORNERS_9_5, e.overTenPointFiveCorners = t.OVER_CORNERS_10_5, e.overElevenPointFiveCorners = t.OVER_CORNERS_11_5, e.overTwelvePointFiveCorners = t.OVER_CORNERS_12_5, e.overThirteenPointFiveCorners = t.OVER_CORNERS_13_5, e.doubleChance = t.DOUBLE_CHANCE, e.halfTimeFullTime = t.HT_FT, e.playerScore = t.PLAYER_SCORE, e.playerYellowCard = t.PLAYER_YELLOW_CARD, e.playerRedCard = t.PLAYER_RED_CARD, e.redCardMatch = t.RED_CARD_MATCH, e.penaltyMatch = t.PENALTY_MATCH, e.playerScoreFirstGoal = t.PLAYER_SCORE_FIRST_GOAL, e.cornersMatch = t.CORNERS_MATCH, e.correctScore = t.CORRECT_SCORE, e.correctScoreHalfTime = t.CORRECT_SCORE_HT, e.correctScoreAdvanced = t.CORRECT_SCORE_ADVANCED, e.playerScoreHattrick = t.PLAYER_SCORE_HATTRICK, e.playerScoreTwice = t.PLAYER_SCORE_TWICE, e;
  });
  this.footballHttps = new us(t), this.matchFacade = new Ro(t, this.footballHttps, e), this.playerFacade = new To(t, this.footballHttps, e), this.predictorService = new gs(t, e), this.fixturesRemapper = new fR(this.matchFacade, this.playerFacade, this.predictorService);
},
    gR = function gR() {
  _classCallCheck(this, gR);

  s(this, "matchId", null);
  s(this, "matchType", null);
  s(this, "predictions", null);
},
    yR = function yR(t, e) {
  var _this156 = this;

  _classCallCheck(this, yR);

  s(this, "remapPredictions", null);
  s(this, "remapResponse", function (t) {
    var e = new gR();
    return e.matchId = t.match_id, e.matchType = t.match_type, e.predictions = _this156.remapPredictions.remapPredictionModel(t.predictions), e;
  });
  this.remapPredictions = new yp(t, e);
},
    vR = function vR() {
  _classCallCheck(this, vR);

  s(this, "matchId", null);
  s(this, "matchType", null);
  s(this, "market", null);
  s(this, "matchModel", null);
  s(this, "matchStatus", new Sn());
},
    wR = function wR() {
  _classCallCheck(this, wR);

  s(this, "value", null);
  s(this, "target", null);
  s(this, "playerId", null);
  s(this, "playerModel", null);
  s(this, "result", null);
},
    bR = function bR() {
  _classCallCheck(this, bR);

  s(this, "matchId", null);
  s(this, "matchType", null);
  s(this, "market", null);
  s(this, "matchModel", null);
  s(this, "matchStatus", new Sn());
  s(this, "prediction", new wR());
},
    IR = function IR() {
  _classCallCheck(this, IR);

  s(this, "value", null);
  s(this, "result", null);
},
    _R = function _R() {
  _classCallCheck(this, _R);

  s(this, "matchId", null);
  s(this, "matchType", null);
  s(this, "market", null);
  s(this, "matchModel", null);
  s(this, "matchStatus", new Sn());
  s(this, "prediction", new IR());
},
    ER = function ER() {
  _classCallCheck(this, ER);

  s(this, "matchId", null);
  s(this, "matchModel", null);
  s(this, "outcome", null);
},
    CR = function CR() {
  _classCallCheck(this, CR);

  s(this, "gameId", null);
  s(this, "results", null);
  s(this, "tieBreakers", null);
},
    vp = function vp() {
  _classCallCheck(this, vp);

  s(this, "entityId", null);
  s(this, "entityType", null);
},
    SR = function SR() {
  _classCallCheck(this, SR);

  s(this, "contestId", "");
  s(this, "contestType", "GAME");
  s(this, "contestModel", null);
  s(this, "description", "");
  s(this, "userList", []);
},
    TR = function TR() {
  _classCallCheck(this, TR);

  s(this, "position", "");
  s(this, "profileId", "");
  s(this, "profileModel", null);
  s(this, "note", "");
  s(this, "tags", []);
},
    RR = function RR() {
  var _this157 = this;

  _classCallCheck(this, RR);

  s(this, "remapPaginatedGames", function (t) {
    var e = new qe();
    return e.meta.pagination.nextPageStartsAfter = t.meta.pagination.next_page_starts_after, e.meta.pagination.itemsPerPage = t.meta.pagination.items_per_page, e.data = t.data.map(function (i) {
      return _this157.remapGamesListResponse(i);
    }), e;
  });
  s(this, "remapGamesListResponse", function (t) {
    var e = new _r();
    return e.id = t.id, e.title = t.title, e.description = t.description, e.type = t.type, e.status = t.status, e.scheduleOpenAt = t.schedule_open_at, e.predictionsCutoff = t.predictions_cutoff, e.fixtures = t.fixtures.map(function (i) {
      return _this157.remapFixturesResponse(i);
    }), e.tiebreaker = t.tiebreaker ? _this157.remapTimeTiebreaker(t.tiebreaker.time_tiebreaker) : null, e.participantsCount = t.participants_count, e.related = t.related ? _this157.remapRelated(t.related) : null, e.excludedProfileIds = t.excluded_profile_ids, e.rules = t.rules, e.labels = t.labels, e.customFields = t.custom_fields, e.flags = t.flags, e.images = t.images, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapGameByIdResponse", function (t) {
    var e = new mp();
    return e.id = t.id, e.title = t.title, e.description = t.description, e.type = t.type, e.status = t.status, e.scheduleOpenAt = t.schedule_open_at, e.predictionsCutoff = t.predictions_cutoff, e.fixtures = t.fixtures.map(function (i) {
      return _this157.remapFixturesResponse(i);
    }), e.tiebreaker = t.tiebreaker ? _this157.remapTimeTiebreaker(t.tiebreaker.time_tiebreaker) : null, e.participantsCount = t.participants_count, e.related = t.related ? _this157.remapRelated(t.related) : null, e.excludedProfileIds = t.excluded_profile_ids, e.rules = t.rules, e.flags = t.flags, e.adContent = t.ad_content, e.labels = t.labels, e.customFields = t.custom_fields, e.images = t.images, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapFixturesResponse", function (t) {
    var e = new vR();
    return e.matchId = t.match_id, e.matchType = t.match_type, e.market = t.market, e.matchStatus.type = t.match_status.type, e.matchStatus.subType = t.match_status.sub_type, e;
  });
  s(this, "remapPaginatedUserTopXEditions", function (t) {
    var e = new qe();
    return e.meta.pagination.nextPageStartsAfter = t.meta.pagination.next_page_starts_after, e.meta.pagination.itemsPerPage = t.meta.pagination.items_per_page, e.data = t.data.map(function (i) {
      return _this157.remapUserTopXEditionsResponse(i);
    }), e;
  });
  s(this, "remapUserTopXEditionsResponse", function (t) {
    var e = new Zn();
    return e.id = t.id, e.title = t.title, e.description = t.description, e.type = t.type, e.status = t.status, e.predictionsCutoff = t.predictions_cutoff, e.scheduleOpenAt = t.schedule_open_at, e.fixtures = t.fixtures.map(function (i) {
      return _this157.remapTopXFixturesResponse(i);
    }), e.tiebreaker = t.tiebreaker ? _this157.remapTimeTiebreaker(t.tiebreaker.time_tiebreaker) : null, e.participantsCount = t.participants_count, e.related = t.related ? _this157.remapRelated(t.related) : null, e.excludedProfileIds = t.excluded_profile_ids, e.rules = t.rules, e.flags = t.flags, e.images = t.images, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapTopXFixturesResponse", function (t) {
    var e = new _R();
    return e.matchId = t.match_id, e.matchType = t.match_type, e.market = t.market, e.matchStatus.type = t.match_status.type, e.matchStatus.subType = t.match_status.sub_type, e;
  });
  s(this, "remapPaginatedUserMathQuizEditions", function (t) {
    var e = new qe();
    return e.meta.pagination.nextPageStartsAfter = t.meta.pagination.next_page_starts_after, e.meta.pagination.itemsPerPage = t.meta.pagination.items_per_page, e.data = t.data.map(function (i) {
      return _this157.remapUserMatchQuizEditionsResponse(i);
    }), e;
  });
  s(this, "remapUserMatchQuizEditionsResponse", function (t) {
    var e = new Xi();
    return e.id = t.id, e.title = t.title, e.description = t.description, e.type = t.type, e.status = t.status, e.predictionsCutoff = t.predictions_cutoff, e.scheduleOpenAt = t.schedule_open_at, e.fixtures = t.fixtures.map(function (i) {
      return _this157.remapMatchQuizFixturesResponse(i);
    }), e.tiebreaker = t.tiebreaker ? _this157.remapTimeTiebreaker(t.tiebreaker.time_tiebreaker) : null, e.participantsCount = t.participants_count, e.related = t.related ? _this157.remapRelated(t.related) : null, e.excludedProfileIds = t.excluded_profile_ids, e.rules = t.rules, e.flags = t.flags, e.images = t.images, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapMatchQuizFixturesResponse", function (t) {
    var e = new bR();
    return e.matchId = t.match_id, e.matchType = t.match_type, e.market = t.market, e.matchStatus.type = t.match_status.type, e.matchStatus.subType = t.match_status.sub_type, e;
  });
  s(this, "remapPaginatedGameResults", function (t) {
    var e = new qe();
    return e.meta.pagination.nextPageStartsAfter = t.meta.pagination.next_page_starts_after, e.meta.pagination.itemsPerPage = t.meta.pagination.items_per_page, e.data = t.data.map(function (i) {
      return _this157.remapGameResults(i);
    }), e;
  });
  s(this, "remapGameResults", function (t) {
    var e = new Ra();
    return e.userId = t.user_id, e.points = t.points ? t.points : 0, e.results = t.results.map(function (i) {
      return _this157.remapResults(i);
    }), e.tiebreaker = t.tiebreaker ? _this157.remapTiebreaker(t.tiebreaker) : null, e;
  });
  s(this, "remapGameMarketsResults", function (t) {
    var e = new CR();
    return e.gameId = t.game_id, e.results = _this157.remapMarketsResults(t.results), e.tieBreakers = t.tie_breakers ? _this157.remapTieBreakers(t.tie_breakers) : null, e;
  });
  s(this, "remapContestWinners", function (t) {
    var e = new SR();
    return e.contestId = t.contest_id, e.contestType = t.contest_type, e.description = t.description, e.userList = t.user_list ? t.user_list.map(function (i) {
      return _this157.remapUserListWinners(i);
    }) : null, e;
  });
  s(this, "remapUserListWinners", function (t) {
    var e = new TR();
    return e.position = t.position, e.profileId = t.profile_id, e.note = t.note, e.tags = t.tags, e;
  });
  s(this, "remapTieBreakers", function (t) {
    var e = {
      goldenGoals: []
    };
    return e.goldenGoals = t.golden_goals.map(function (i) {
      return {
        minute: i.minute,
        matchId: i.match_id,
        matchModel: null,
        playerId: i.player_id,
        playerModel: null,
        goalType: i.goal_type
      };
    }), e;
  });
  s(this, "remapMarketsResults", function (t) {
    var e = [];
    return t.forEach(function (i) {
      var n = {
        matchId: i.match_id,
        market: i.market,
        result: _this157.remapMarketResult(i.market, i.result),
        matchModel: null,
        playerModels: [],
        matchStatus: _this157.remapMarketsResultsMatchStatus(i.match_status)
      };
      e.push(_this157.deleteUnusefulField(n));
    }), e;
  });
  s(this, "remapMarketsResultsMatchStatus", function (t) {
    var e = new Sn();
    return e.type = t.type, e.subType = t.sub_type, e;
  });
  s(this, "remapMarketResult", function (t, e) {
    if (j1.includes(t)) return e[0];
    if (Nt.includes(t)) return e;
    if (e[0] === "true") return !0;
    if (e[0] === "false") return !1;
  });
  s(this, "deleteUnusefulField", function (t) {
    return (!Nt.includes(t.market) || _this157.isPlayerMarketWithNoResult(t.market, t.result)) && delete t.playerModels, t;
  });
  s(this, "isPlayerMarketWithNoResult", function (t, e) {
    return Nt.includes(t) && e.length === 0;
  });
  s(this, "remapResults", function (t) {
    var e = new ER();
    return e.matchId = t.match_id, e.outcome = t.outcome, e;
  });
  s(this, "remapTiebreaker", function (t) {
    var e = new ps();
    return e.goldenGoal = t.golden_goal, e;
  });
  s(this, "remapTimeTiebreaker", function (t) {
    var e = new fs();
    return e.timeTiebreaker = t, e;
  });
  s(this, "remapRelated", function (t) {
    return t.map(function (e) {
      var i = new vp();
      return i.entityId = e.entity_id, i.entityType = e.entity_type, i;
    });
  });
},
    PR = function PR() {
  _classCallCheck(this, PR);

  s(this, "remapMetaData", function (t) {
    var e = new os();
    return e.pagination.nextPageStartsAfter = t.pagination.next_page_starts_after, e.pagination.itemsPerPage = t.pagination.items_per_page, e;
  });
},
    ys =
/*#__PURE__*/
function (_St6) {
  _inherits(ys, _St6);

  function ys(e, i) {
    var _this158;

    _classCallCheck(this, ys);

    _this158 = _possibleConstructorReturn(this, _getPrototypeOf(ys).call(this, e, Ct(e.environment, "predictor")));
    s(_assertThisInitialized(_this158), "predictionRemapper", null);
    s(_assertThisInitialized(_this158), "matchSummaryRemapper", null);
    s(_assertThisInitialized(_this158), "gamesRemapper", null);
    s(_assertThisInitialized(_this158), "metaRemapper", null);
    s(_assertThisInitialized(_this158), "makeFootballPrediction", function (e) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee427() {
        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee427$(_context428) {
          while (1) {
            switch (_context428.prev = _context428.next) {
              case 0:
                i = "/predictions".concat(this.apiSignInUrl);
                n = "There was a problem making POST request";
                r = "POST";
                _context428.next = 5;
                return this.fetchWithAuth(i, n, r, this.predictionRemapper.remapRequestBody(e));

              case 5:
                a = _context428.sent;
                _context428.next = 8;
                return this.predictionRemapper.remapResponseObjBody(a);

              case 8:
                return _context428.abrupt("return", _context428.sent);

              case 9:
              case "end":
                return _context428.stop();
            }
          }
        }, _callee427, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getMatchSummary", function (e, i) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee428() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee428$(_context429) {
          while (1) {
            switch (_context429.prev = _context429.next) {
              case 0:
                n = Ee(i) ? "/predictions/summary/".concat(e).concat(this.apiSignInUrl).concat(Ce()) : "/predictions/summary/".concat(e).concat(this.apiSignInUrl);
                r = "There was a problem fetching predictions for match: ".concat(e);
                _context429.next = 4;
                return this.fetchWithoutAuth(n, r);

              case 4:
                a = _context429.sent;
                return _context429.abrupt("return", this.matchSummaryRemapper.remapResponse(a));

              case 6:
              case "end":
                return _context429.stop();
            }
          }
        }, _callee428, this);
      }));
    });
    s(_assertThisInitialized(_this158), "deleteFootballPrediction", function (e) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee429() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee429$(_context430) {
          while (1) {
            switch (_context430.prev = _context430.next) {
              case 0:
                i = "/predictions/".concat(e).concat(this.apiSignInUrl), n = "There was a problem deleting your prediction: ".concat(e), r = "DELETE";
                _context430.next = 3;
                return this.fetchWithAuth(i, n, r);

              case 3:
                return _context430.abrupt("return", !0);

              case 4:
              case "end":
                return _context430.stop();
            }
          }
        }, _callee429, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getMyPredictions", function (e) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee430() {
        var i, n, r, a;
        return _regeneratorRuntime.wrap(function _callee430$(_context431) {
          while (1) {
            switch (_context431.prev = _context431.next) {
              case 0:
                i = new qe(), n = "/predictions".concat(this.apiSignInUrl), r = "There was a problem fetching own predictions";
                e && (n += "".concat(e.constructFiltersUrl()));
                _context431.next = 4;
                return this.fetchWithAuth(n, r);

              case 4:
                a = _context431.sent;
                i.meta = this.metaRemapper.remapMetaData(a.meta);
                _context431.next = 8;
                return this.predictionRemapper.remapResponseArrayBody(a.data);

              case 8:
                i.data = _context431.sent;
                return _context431.abrupt("return", i);

              case 10:
              case "end":
                return _context431.stop();
            }
          }
        }, _callee430, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getMyPredictionsNoRemap", function (e) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee431() {
        var i, n;
        return _regeneratorRuntime.wrap(function _callee431$(_context432) {
          while (1) {
            switch (_context432.prev = _context432.next) {
              case 0:
                i = "/predictions".concat(this.apiSignInUrl).concat(e.constructFiltersUrl()), n = "There was a problem fetching own predictions";
                _context432.next = 3;
                return this.fetchWithAuth(i, n);

              case 3:
                return _context432.abrupt("return", _context432.sent);

              case 4:
              case "end":
                return _context432.stop();
            }
          }
        }, _callee431, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getUserPredictions", function (e, i, n) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee432() {
        var r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee432$(_context433) {
          while (1) {
            switch (_context433.prev = _context433.next) {
              case 0:
                r = new qe(), a = Ee(i) ? "/predictions/users/".concat(e).concat(this.apiSignInUrl).concat(Ce()) : "/predictions/users/".concat(e).concat(this.apiSignInUrl), o = "There was a problem fetching predictions for user: ".concat(e);
                n && (a += "".concat(n.constructFiltersUrl()));
                _context433.next = 4;
                return this.fetchWithoutAuth(a, o);

              case 4:
                l = _context433.sent;
                r.meta = this.metaRemapper.remapMetaData(l.meta);
                _context433.next = 8;
                return this.predictionRemapper.remapResponseArrayBody(l.data);

              case 8:
                r.data = _context433.sent;
                return _context433.abrupt("return", r);

              case 10:
              case "end":
                return _context433.stop();
            }
          }
        }, _callee432, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getUserPredictionsNoRemap", function (e, i) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee433() {
        var n, r;
        return _regeneratorRuntime.wrap(function _callee433$(_context434) {
          while (1) {
            switch (_context434.prev = _context434.next) {
              case 0:
                n = "/predictions/users/".concat(e).concat(this.apiSignInUrl).concat(i.constructFiltersUrl()), r = "There was a problem fetching predictions for user: ".concat(e);
                _context434.next = 3;
                return this.fetchWithoutAuth(n, r);

              case 3:
                return _context434.abrupt("return", _context434.sent);

              case 4:
              case "end":
                return _context434.stop();
            }
          }
        }, _callee433, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getGames", function (e, i) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee434() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee434$(_context435) {
          while (1) {
            switch (_context435.prev = _context435.next) {
              case 0:
                n = Ee(i) ? "/games/".concat(this.apiSignInUrl).concat(e.constructFiltersUrl()).concat(Ce()) : "/games/".concat(this.apiSignInUrl).concat(e.constructFiltersUrl());
                r = "There was a problem fetching the games list";
                _context435.next = 4;
                return this.fetchWithoutAuth(n, r);

              case 4:
                a = _context435.sent;
                return _context435.abrupt("return", this.gamesRemapper.remapPaginatedGames(a));

              case 6:
              case "end":
                return _context435.stop();
            }
          }
        }, _callee434, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getGameById", function (e, i) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee435() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee435$(_context436) {
          while (1) {
            switch (_context436.prev = _context436.next) {
              case 0:
                n = Ee(i) ? "/games/".concat(e).concat(this.apiSignInUrl).concat(Ce()) : "/games/".concat(e).concat(this.apiSignInUrl);
                r = "There was a problem fetching the following game: ".concat(e);
                _context436.next = 4;
                return this.fetchWithoutAuth(n, r);

              case 4:
                a = _context436.sent;
                return _context436.abrupt("return", this.gamesRemapper.remapGameByIdResponse(a));

              case 6:
              case "end":
                return _context436.stop();
            }
          }
        }, _callee435, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getGamePredictions", function (e, i, n) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee436() {
        var r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee436$(_context437) {
          while (1) {
            switch (_context437.prev = _context437.next) {
              case 0:
                r = new qe(), a = Ee(i) ? "/games/".concat(e, "/predictions").concat(this.apiSignInUrl).concat(Ce()) : "/games/".concat(e, "/predictions").concat(this.apiSignInUrl), o = "There was a problem fetching the predictions for game: ".concat(e);
                n && (a += "".concat(n.constructFiltersUrl()));
                _context437.next = 4;
                return this.fetchWithoutAuth(a, o);

              case 4:
                l = _context437.sent;
                r.meta = this.metaRemapper.remapMetaData(l.meta);
                _context437.next = 8;
                return this.predictionRemapper.remapResponseArrayBody(l.data);

              case 8:
                r.data = _context437.sent;
                return _context437.abrupt("return", r);

              case 10:
              case "end":
                return _context437.stop();
            }
          }
        }, _callee436, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getUserGameEditions", function (e, i) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee437() {
        var _this159 = this;

        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee437$(_context438) {
          while (1) {
            switch (_context438.prev = _context438.next) {
              case 0:
                n = null;
                r = Ee(i) ? "/games/".concat(this.apiSignInUrl).concat(e.constructFiltersUrl()).concat(Ce()) : "/games/".concat(this.apiSignInUrl).concat(e.constructFiltersUrl());
                a = "There was a problem fetching the games list";
                _context438.next = 5;
                return this.fetchWithoutAuth(r, a);

              case 5:
                o = _context438.sent;
                return _context438.abrupt("return", (o.data.forEach(function (l) {
                  l.type === "TOP_X" ? n = _this159.gamesRemapper.remapPaginatedUserTopXEditions(o) : l.type === "MATCH_QUIZ" && (n = _this159.gamesRemapper.remapPaginatedUserMathQuizEditions(o));
                }), n));

              case 7:
              case "end":
                return _context438.stop();
            }
          }
        }, _callee437, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getGameResults", function (e, i, n) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee438() {
        var r, a, o;
        return _regeneratorRuntime.wrap(function _callee438$(_context439) {
          while (1) {
            switch (_context439.prev = _context439.next) {
              case 0:
                r = Ee(i) ? "/games/".concat(e, "/results/").concat(this.apiSignInUrl).concat(Ce()) : "/games/".concat(e, "/results/").concat(this.apiSignInUrl), a = "There was a problem fetching the results for the following game: ".concat(e);
                n && (r += "".concat(n.constructMainFiltersUrl()));
                _context439.next = 4;
                return this.fetchWithoutAuth(r, a);

              case 4:
                o = _context439.sent;
                return _context439.abrupt("return", this.gamesRemapper.remapPaginatedGameResults(o));

              case 6:
              case "end":
                return _context439.stop();
            }
          }
        }, _callee438, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getMarketResultsForGame", function (e, i) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee439() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee439$(_context440) {
          while (1) {
            switch (_context440.prev = _context440.next) {
              case 0:
                n = "/games/".concat(e, "/correct-results/").concat(this.apiSignInUrl), r = "There was a problem fetching the markets correct results for the following game: ".concat(e);
                Ee(i) && (n += "".concat(Ce()));
                _context440.next = 4;
                return this.fetchWithoutAuth(n, r);

              case 4:
                a = _context440.sent;
                return _context440.abrupt("return", this.gamesRemapper.remapGameMarketsResults(a.data));

              case 6:
              case "end":
                return _context440.stop();
            }
          }
        }, _callee439, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getContestWinners", function (e) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee440() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee440$(_context441) {
          while (1) {
            switch (_context441.prev = _context441.next) {
              case 0:
                i = "/winners/".concat(this.apiSignInUrl, "&contest_id=").concat(e);
                n = "There was a problem fetching winners for the following game: ".concat(e);
                _context441.next = 4;
                return this.fetchWithoutAuth(i, n);

              case 4:
                r = _context441.sent;
                return _context441.abrupt("return", this.gamesRemapper.remapContestWinners(r));

              case 6:
              case "end":
                return _context441.stop();
            }
          }
        }, _callee440, this);
      }));
    });
    s(_assertThisInitialized(_this158), "getPredictionById", function (e) {
      return u(_assertThisInitialized(_this158), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee441() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee441$(_context442) {
          while (1) {
            switch (_context442.prev = _context442.next) {
              case 0:
                i = "/predictions/".concat(e).concat(this.apiSignInUrl);
                n = "There was a problem fetching info for the following prediction: ".concat(e);
                _context442.next = 4;
                return this.fetchWithoutAuth(i, n);

              case 4:
                r = _context442.sent;
                _context442.next = 7;
                return this.predictionRemapper.remapResponseArrayBody([r.data]);

              case 7:
                return _context442.abrupt("return", _context442.sent[0]);

              case 8:
              case "end":
                return _context442.stop();
            }
          }
        }, _callee441, this);
      }));
    });
    _this158.predictionRemapper = new yp(e, i), _this158.matchSummaryRemapper = new yR(e, i), _this158.gamesRemapper = new RR(), _this158.metaRemapper = new PR();
    return _this158;
  }

  return ys;
}(St),
    wp = function wp() {
  _classCallCheck(this, wp);

  s(this, "gameInstanceId", null);
  s(this, "fixtures", null);
},
    bp = function (t) {
  return t.ONE = "1", t.X = "x", t.TWO = "2", t;
}(bp || {}),
    Ip = function (t) {
  return t.ONE_X = "1x", t.X_TWO = "x2", t.ONE_TWO = "12", t;
}(Ip || {}),
    _p = function (t) {
  return t.ONE_ONE = "1/1", t.ONE_X = "1/x", t.ONE_TWO = "1/2", t.X_ONE = "x/1", t.X_X = "x/x", t.X_TWO = "x/2", t.TWO_ONE = "2/1", t.TWO_X = "2/x", t.TWO_TWO = "2/2", t;
}(_p || {}),
    OR = function OR(t, e) {
  _classCallCheck(this, OR);

  s(this, "matchId", null);
  s(this, "market", "BOTH_TEAMS_SCORE");
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.prediction = new Tn(), this.prediction.value = e;
},
    AR = function AR() {
  _classCallCheck(this, AR);

  s(this, "value");
},
    MR = function MR(t, e) {
  _classCallCheck(this, MR);

  s(this, "matchId", null);
  s(this, "market", "CORNERS_MATCH");
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.prediction = new AR(), this.prediction.value = e;
},
    FR = function FR() {
  _classCallCheck(this, FR);

  s(this, "value", null);
},
    kR = function kR(t, e) {
  _classCallCheck(this, kR);

  s(this, "matchId", null);
  s(this, "market", "DOUBLE_CHANCE");
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.prediction = new FR(), this.prediction.value = e;
},
    xR = function xR() {
  _classCallCheck(this, xR);

  s(this, "value", null);
},
    DR = function DR(t, e, i) {
  _classCallCheck(this, DR);

  s(this, "matchId", null);
  s(this, "market", null);
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.market = e, this.prediction = new xR(), this.prediction.value = i;
},
    NR = function NR() {
  _classCallCheck(this, NR);

  s(this, "value", null);
},
    LR = function LR(t, e) {
  _classCallCheck(this, LR);

  s(this, "matchId", null);
  s(this, "market", "HT_FT");
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.prediction = new NR(), this.prediction.value = e;
},
    $R = function $R(t, e) {
  _classCallCheck(this, $R);

  s(this, "matchId", null);
  s(this, "market", "PENALTY_MATCH");
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.prediction = new Tn(), this.prediction.value = e;
},
    UR = function UR(t, e) {
  _classCallCheck(this, UR);

  s(this, "matchId", null);
  s(this, "market", "RED_CARD_MATCH");
  s(this, "matchType", "FOOTBALL");
  s(this, "prediction", null);
  this.matchId = t, this.prediction = new Tn(), this.prediction.value = e;
},
    Mo = function Mo(t) {
  var _this160 = this;

  _classCallCheck(this, Mo);

  s(this, "errorHandlingMode", null);
  s(this, "validateBodyFields", function (t, e) {
    var i = Object.keys(e),
        n = Object.keys(new wp());

    switch (t) {
      case "MATCH_QUIZ":
        i.forEach(function (l) {
          n.includes(l) || _this160.throwInvalidParamException([l]);
        });
        break;

      case "TOP_X":
        var _a17 = e;

        _a17.fixtures.forEach(function (l) {
          return _this160.validateMarketTopX(l.market);
        });

        var _o17 = "tiebreaker";
        i.includes(_o17) && _a17.tiebreaker && _this160.validateTiebreaker(_a17.tiebreaker), i.forEach(function (l) {
          l !== "tiebreaker" && !n.includes(l) && _this160.throwInvalidParamException([l]);
        });
        break;
    }

    var r = n.filter(function (a) {
      return !i.includes(a);
    });
    return r.length && _this160.throwMissingFieldsException("game prediction body", r), e.fixtures.forEach(function (a) {
      _this160.validateFixtureFields(a);
    }), e;
  });
  s(this, "validateFixture", function (t, e, i, n) {
    _this160.validateMarket(e);

    var r = Object.values(bp),
        a = Object.values(_p),
        o = Object.values(Ip);

    if (e === "FT_1X2" || e === "HT_1X2") {
      if (r.includes(i)) return new DR(t, e, i);
    } else if (e === "HT_FT") {
      if (a.includes(i)) return new LR(t, i);
    } else if (e === "DOUBLE_CHANCE") {
      if (o.includes(i)) return new kR(t, i);
    } else if (e === "CORRECT_SCORE" || e === "CORRECT_SCORE_ADVANCED" || e === "CORRECT_SCORE_HT") {
      if (typeof i == "string" && /\d+:\d+/.test(i)) return new Oo(t, e, i);
    } else if (e === "CORNERS_MATCH") {
      if (typeof i == "number") return new MR(t, i);
    } else if (e === "BOTH_TEAMS_SCORE") {
      if (_this160.isPredictionBoolean(i)) return new OR(t, i);
    } else if (e === "RED_CARD_MATCH") {
      if (_this160.isPredictionBoolean(i)) return new UR(t, i);
    } else if (e === "PENALTY_MATCH") {
      if (_this160.isPredictionBoolean(i)) return new $R(t, i);
    } else if (Nt.includes(e)) {
      var _l15 = "OWN_GOAL";

      if (_this160.validatePlayerId(e, n), e === Ir && _this160.isPredictionBoolean(i)) {
        var c = n && n === _l15 ? _l15 : n;
        return new Ri(t, e, i, c);
      }

      if (n && _this160.isPredictionBoolean(i)) return new Ri(t, e, i, n);
    } else if (H1.includes(e)) {
      if (_this160.isPredictionBoolean(i)) return new hp(t, e, i);
    } else if (V1.includes(e) && _this160.isPredictionBoolean(i)) return new dp(t, e, i);

    _this160.throwInvalidPredictionException(i, e);
  });
  s(this, "validateFixtureFields", function (t) {
    var e = Object.keys(t);
    e.forEach(function (n) {
      pc.includes(n) || _this160.throwInvalidParamException([n]);
    });
    var i = pc.filter(function (n) {
      if (n !== "matchType" && !e.includes(n)) return n;
    });
    i.length && _this160.throwMissingFieldsException("fixtures", i), _this160.validatePredictionKey(t.market, t.prediction);
  });
  s(this, "validateTiebreaker", function (t) {
    var e = Object.keys(t);
    (!e.length || typeof t != "object") && _this160.throwInvalidType("tiebreaker", "object");
    var i = Object.keys(new ps())[0];
    e.forEach(function (n) {
      i !== n && _this160.throwInvalidParamException([n]);
    }), e.includes(i) || _this160.throwMissingFieldsException("tiebreaker", [i]), typeof t.goldenGoal != "number" && _this160.throwInvalidType("goldenGoal", "number");
  });
  s(this, "validatePredictionKey", function (t, e) {
    if (typeof e == "object") {
      var i = Object.keys(e),
          n = ["value"];

      if (i.length || _this160.throwMissingFieldsException("prediction", n), i.length === 1 && !i.includes(n[0]) && _this160.throwInvalidParamException(i), i.length > 1) {
        Nt.includes(t) && n.push("playerId");

        var _r44 = i.filter(function (a) {
          return !n.includes(a);
        });

        _r44.length && _this160.throwInvalidParamException(_r44);
      }
    } else _this160.throwInvalidType("prediction", "object");
  });
  s(this, "validatePlayerId", function (t, e) {
    var i = "playerId";
    t !== Ir && (e || _this160.throwInvalidParamException([i]), typeof e != "string" && _this160.throwInvalidType(i, "string"));
  });
  s(this, "validateMarket", function (t) {
    Object.values(ds).includes(t) || _this160.throwInvalidMarketException(t);
  });
  s(this, "validateMarketTopX", function (t) {
    t !== "CORRECT_SCORE" && t !== "CORRECT_SCORE_ADVANCED" && _this160.throwInvalidMarketException(t, "TOP_X");
  });
  s(this, "isPredictionBoolean", function (t) {
    return typeof t == "boolean";
  });
  s(this, "throwInvalidPredictionException", function (t, e) {
    var i = MT(t, e);
    throw _this160.errorHandlingMode === "default" ? new Se(400, "INVALID_PREDICTION", i) : new ue(400, "INVALID_TYPE", i);
  });
  s(this, "throwInvalidMarketException", function (t, e) {
    var i = null;
    throw e && e === "TOP_X" ? i = FT(t) : i = Bh(t), _this160.errorHandlingMode === "default" ? new Se(400, "INVALID_MARKET", i) : new ue(400, "INVALID_TYPE", i);
  });
  s(this, "throwInvalidParamException", function (t) {
    var e = kT(t);
    throw _this160.errorHandlingMode === "default" ? new Se(400, "INVALID_FIELD", e) : new ue(400, "INVALID_TYPE", e);
  });
  s(this, "throwMissingFieldsException", function (t, e) {
    var i = xT(t, e);
    throw _this160.errorHandlingMode === "default" ? new Se(400, "INVALID_FIELD", i) : new ue(400, "INVALID_TYPE", i);
  });
  s(this, "throwInvalidType", function (t, e) {
    var i = DT(t, e);
    throw _this160.errorHandlingMode === "default" ? new Se(400, "INVALID_TYPE", i) : new ue(400, "INVALID_TYPE", i);
  });
  this.errorHandlingMode = t;
},
    BR = function BR(t, e, i, n) {
  var _this161 = this;

  _classCallCheck(this, BR);

  s(this, "predictorHttps", null);
  s(this, "clientHttps", null);
  s(this, "idMapping", null);
  s(this, "predictorService", null);
  s(this, "predictorValidator", null);
  s(this, "errorHandlingMode", null);
  s(this, "makeFootballPrediction", function (t, e, i, n) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee442() {
      var r, a, _o18, _l16, c, _d11;

      return _regeneratorRuntime.wrap(function _callee442$(_context443) {
        while (1) {
          switch (_context443.prev = _context443.next) {
            case 0:
              r = this.predictorValidator.validateFixture(t, e, i, n), a = new wp();

              if (!(this.idMapping.idSchema !== "native")) {
                _context443.next = 29;
                break;
              }

              _o18 = r.matchId;
              _l16 = "";
              _context443.next = 6;
              return this.predictorService.remapMatchIdToNative([_o18]);

            case 6:
              c = _context443.sent;

              if (!(r.matchId = c[0], this.errorHandlingMode === "default" && !r.matchId)) {
                _context443.next = 9;
                break;
              }

              throw new Se(400, "INVALID_FIELD", "Match id is invalid!").errorMessage();

            case 9:
              if (!(this.errorHandlingMode === "standard" && !r.matchId)) {
                _context443.next = 11;
                break;
              }

              throw new ue(400, "INVALID_FIELD", "Match id is invalid!");

            case 11:
              if (!(r instanceof Ri && r.prediction.playerId !== "OWN_GOAL")) {
                _context443.next = 22;
                break;
              }

              _context443.t0 = r.prediction.playerId;

              if (!_context443.t0) {
                _context443.next = 18;
                break;
              }

              _l16 = r.prediction.playerId;
              _context443.next = 17;
              return this.predictorService.remapPlayerIdToNative([_l16]);

            case 17:
              r.prediction.playerId = _context443.sent;

            case 18:
              if (!(this.errorHandlingMode === "default" && r.market !== Ir && !r.prediction.playerId)) {
                _context443.next = 20;
                break;
              }

              throw new Se(400, "INVALID_FIELD", "Player id is invalid!").errorMessage();

            case 20:
              if (!(this.errorHandlingMode === "standard" && r.market !== Ir && !r.prediction.playerId)) {
                _context443.next = 22;
                break;
              }

              throw new ue(400, "INVALID_FIELD", "Player id is invalid!");

            case 22:
              a.fixtures = [r];
              _context443.next = 25;
              return this.predictorHttps.makeFootballPrediction(a);

            case 25:
              _d11 = _context443.sent;
              return _context443.abrupt("return", (_d11.fixtures.forEach(function (h) {
                h.prediction.playerId && h.prediction.playerId !== "OWN_GOAL" && (h.prediction.playerId = _l16), h.matchId = _o18;
              }), _d11));

            case 29:
              a.fixtures = [r];
              _context443.next = 32;
              return this.predictorHttps.makeFootballPrediction(a);

            case 32:
              return _context443.abrupt("return", _context443.sent);

            case 33:
            case "end":
              return _context443.stop();
          }
        }
      }, _callee442, this);
    }));
  });
  s(this, "getMatchSummary", function (t, e) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee443() {
      var i, n, r;
      return _regeneratorRuntime.wrap(function _callee443$(_context444) {
        while (1) {
          switch (_context444.prev = _context444.next) {
            case 0:
              _context444.next = 2;
              return this.getMatchSummaryBase(t, e);

            case 2:
              i = _context444.sent;
              n = JSON.parse(JSON.stringify(i.predictions));
              _context444.next = 6;
              return this.predictorService.remapPlayerIdToIdSchema(n);

            case 6:
              r = _context444.sent;
              return _context444.abrupt("return", (i.predictions = r, i));

            case 8:
            case "end":
              return _context444.stop();
          }
        }
      }, _callee443, this);
    }));
  });
  s(this, "getMarketSummary", function (t, e, i, n) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee444() {
      var _r45;

      return _regeneratorRuntime.wrap(function _callee444$(_context445) {
        while (1) {
          switch (_context445.prev = _context445.next) {
            case 0:
              _context445.prev = 0;
              _context445.next = 3;
              return this.getMatchSummaryBase(t, n);

            case 3:
              _r45 = _context445.sent;
              _context445.next = 6;
              return this.predictorService.getMarketSummary(_r45, e, i);

            case 6:
              return _context445.abrupt("return", _context445.sent);

            case 9:
              _context445.prev = 9;
              _context445.t0 = _context445["catch"](0);
              throw _context445.t0;

            case 12:
            case "end":
              return _context445.stop();
          }
        }
      }, _callee444, this, [[0, 9]]);
    }));
  });
  s(this, "getMatchSummaryBase", function (t, e) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee445() {
      var _i51, _n14;

      return _regeneratorRuntime.wrap(function _callee445$(_context446) {
        while (1) {
          switch (_context446.prev = _context446.next) {
            case 0:
              if (!(this.idMapping.idSchema !== "native")) {
                _context446.next = 10;
                break;
              }

              _context446.next = 3;
              return this.predictorService.remapMatchIdToNative([t]);

            case 3:
              _i51 = _context446.sent[0];
              _context446.next = 6;
              return this.predictorHttps.getMatchSummary(_i51, e);

            case 6:
              _n14 = _context446.sent;
              return _context446.abrupt("return", (_n14.matchId = t, _n14));

            case 10:
              _context446.next = 12;
              return this.predictorHttps.getMatchSummary(t, e);

            case 12:
              return _context446.abrupt("return", _context446.sent);

            case 13:
            case "end":
              return _context446.stop();
          }
        }
      }, _callee445, this);
    }));
  });
  s(this, "getConfig", function () {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee446() {
      var t;
      return _regeneratorRuntime.wrap(function _callee446$(_context447) {
        while (1) {
          switch (_context447.prev = _context447.next) {
            case 0:
              _context447.next = 2;
              return this.clientHttps.getConfig("predictor");

            case 2:
              t = _context447.sent;

              if (!(this.idMapping.idSchema !== "native")) {
                _context447.next = 9;
                break;
              }

              _context447.next = 6;
              return this.predictorService.remapCompetitionsFromConfig(t);

            case 6:
              _context447.t0 = _context447.sent;
              _context447.next = 10;
              break;

            case 9:
              _context447.t0 = t;

            case 10:
              return _context447.abrupt("return", _context447.t0);

            case 11:
            case "end":
              return _context447.stop();
          }
        }
      }, _callee446, this);
    }));
  });
  s(this, "deleteFootballPrediction", function (t) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee447() {
      return _regeneratorRuntime.wrap(function _callee447$(_context448) {
        while (1) {
          switch (_context448.prev = _context448.next) {
            case 0:
              _context448.next = 2;
              return this.predictorHttps.deleteFootballPrediction(t);

            case 2:
              return _context448.abrupt("return", _context448.sent);

            case 3:
            case "end":
              return _context448.stop();
          }
        }
      }, _callee447, this);
    }));
  });
  s(this, "getMyPredictions", function (t) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee448() {
      var e;
      return _regeneratorRuntime.wrap(function _callee448$(_context449) {
        while (1) {
          switch (_context449.prev = _context449.next) {
            case 0:
              e = this.predictorService.initPredictionsFilters(t, "user");
              _context449.next = 3;
              return this.predictorHttps.getMyPredictions(e);

            case 3:
              return _context449.abrupt("return", _context449.sent);

            case 4:
            case "end":
              return _context449.stop();
          }
        }
      }, _callee448, this);
    }));
  });
  s(this, "getMyPredictionsForMatches", function (t, e) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee449() {
      var i;
      return _regeneratorRuntime.wrap(function _callee449$(_context450) {
        while (1) {
          switch (_context450.prev = _context450.next) {
            case 0:
              if (!(this.errorHandlingMode === "default" && this.predictorService.areIdsExceeded(t))) {
                _context450.next = 2;
                break;
              }

              throw new Se(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.").errorMessage();

            case 2:
              if (!(this.errorHandlingMode === "standard" && this.predictorService.areIdsExceeded(t))) {
                _context450.next = 4;
                break;
              }

              throw new ue(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.");

            case 4:
              _context450.t0 = this.idMapping.idSchema !== "native";

              if (!_context450.t0) {
                _context450.next = 9;
                break;
              }

              _context450.next = 8;
              return this.predictorService.remapMatchIdToNative(_toConsumableArray(t));

            case 8:
              t = _context450.sent;

            case 9:
              i = this.predictorService.initPredictionsFilters(e, "matches", t);
              _context450.next = 12;
              return this.predictorHttps.getMyPredictions(i);

            case 12:
              return _context450.abrupt("return", _context450.sent);

            case 13:
            case "end":
              return _context450.stop();
          }
        }
      }, _callee449, this);
    }));
  });
  s(this, "getMyCurrentPredictions", function (t) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee450() {
      var e;
      return _regeneratorRuntime.wrap(function _callee450$(_context451) {
        while (1) {
          switch (_context451.prev = _context451.next) {
            case 0:
              e = this.predictorService.initPredictionsFilters(t, "current");
              _context451.next = 3;
              return this.predictorHttps.getMyPredictions(e);

            case 3:
              return _context451.abrupt("return", _context451.sent);

            case 4:
            case "end":
              return _context451.stop();
          }
        }
      }, _callee450, this);
    }));
  });
  s(this, "getMyPastPredictions", function (t) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee451() {
      var e;
      return _regeneratorRuntime.wrap(function _callee451$(_context452) {
        while (1) {
          switch (_context452.prev = _context452.next) {
            case 0:
              e = this.predictorService.initPredictionsFilters(t, "past");
              _context452.next = 3;
              return this.predictorHttps.getMyPredictions(e);

            case 3:
              return _context452.abrupt("return", _context452.sent);

            case 4:
            case "end":
              return _context452.stop();
          }
        }
      }, _callee451, this);
    }));
  });
  s(this, "getUserPredictions", function (t, e, i) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee452() {
      var n;
      return _regeneratorRuntime.wrap(function _callee452$(_context453) {
        while (1) {
          switch (_context453.prev = _context453.next) {
            case 0:
              n = this.predictorService.initPredictionsFilters(e, "user");
              _context453.next = 3;
              return this.predictorHttps.getUserPredictions(t, i, n);

            case 3:
              return _context453.abrupt("return", _context453.sent);

            case 4:
            case "end":
              return _context453.stop();
          }
        }
      }, _callee452, this);
    }));
  });
  s(this, "getUserCurrentPredictions", function (t, e, i) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee453() {
      var n;
      return _regeneratorRuntime.wrap(function _callee453$(_context454) {
        while (1) {
          switch (_context454.prev = _context454.next) {
            case 0:
              n = this.predictorService.initPredictionsFilters(e, "current");
              _context454.next = 3;
              return this.predictorHttps.getUserPredictions(t, i, n);

            case 3:
              return _context454.abrupt("return", _context454.sent);

            case 4:
            case "end":
              return _context454.stop();
          }
        }
      }, _callee453, this);
    }));
  });
  s(this, "getUserPastPredictions", function (t, e, i) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee454() {
      var n;
      return _regeneratorRuntime.wrap(function _callee454$(_context455) {
        while (1) {
          switch (_context455.prev = _context455.next) {
            case 0:
              n = this.predictorService.initPredictionsFilters(e, "past");
              _context455.next = 3;
              return this.predictorHttps.getUserPredictions(t, i, n);

            case 3:
              return _context455.abrupt("return", _context455.sent);

            case 4:
            case "end":
              return _context455.stop();
          }
        }
      }, _callee454, this);
    }));
  });
  s(this, "getUserPredictionsForMatches", function (t, e, i, n) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee455() {
      var r;
      return _regeneratorRuntime.wrap(function _callee455$(_context456) {
        while (1) {
          switch (_context456.prev = _context456.next) {
            case 0:
              if (!(this.errorHandlingMode === "default" && this.predictorService.areIdsExceeded(e))) {
                _context456.next = 2;
                break;
              }

              throw new Se(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.").errorMessage();

            case 2:
              if (!(this.errorHandlingMode === "standard" && this.predictorService.areIdsExceeded(e))) {
                _context456.next = 4;
                break;
              }

              throw new ue(400, "EXCEEDED_LENGTH", "Maximum matchIds in PredictionFilters should be 10 or less.");

            case 4:
              _context456.t0 = this.idMapping.idSchema !== "native";

              if (!_context456.t0) {
                _context456.next = 9;
                break;
              }

              _context456.next = 8;
              return this.predictorService.remapMatchIdToNative(_toConsumableArray(e));

            case 8:
              e = _context456.sent;

            case 9:
              r = this.predictorService.initPredictionsFilters(i, "matches", e);
              _context456.next = 12;
              return this.predictorHttps.getUserPredictions(t, n, r);

            case 12:
              return _context456.abrupt("return", _context456.sent);

            case 13:
            case "end":
              return _context456.stop();
          }
        }
      }, _callee455, this);
    }));
  });
  s(this, "getPredictionById", function (t) {
    return u(_this161, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee456() {
      return _regeneratorRuntime.wrap(function _callee456$(_context457) {
        while (1) {
          switch (_context457.prev = _context457.next) {
            case 0:
              _context457.next = 2;
              return this.predictorHttps.getPredictionById(t);

            case 2:
              return _context457.abrupt("return", _context457.sent);

            case 3:
            case "end":
              return _context457.stop();
          }
        }
      }, _callee456, this);
    }));
  });
  this.predictorHttps = e, this.idMapping = n, this.clientHttps = i, this.errorHandlingMode = t.errorHandlingMode, this.predictorValidator = new Mo(t.errorHandlingMode), this.predictorService = new gs(t, n);
},
    HR = function HR(t) {
  var _this162 = this;

  _classCallCheck(this, HR);

  s(this, "predictorHttps", null);
  s(this, "clientHttps", null);
  s(this, "predictorFacade", null);
  s(this, "idMapping", null);
  s(this, "makeFootballPrediction", function (t, e, i, n) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee457() {
      return _regeneratorRuntime.wrap(function _callee457$(_context458) {
        while (1) {
          switch (_context458.prev = _context458.next) {
            case 0:
              _context458.next = 2;
              return this.predictorFacade.makeFootballPrediction(t, e, i, n);

            case 2:
              return _context458.abrupt("return", _context458.sent);

            case 3:
            case "end":
              return _context458.stop();
          }
        }
      }, _callee457, this);
    }));
  });
  s(this, "getMatchSummary", function (t, e) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee458() {
      return _regeneratorRuntime.wrap(function _callee458$(_context459) {
        while (1) {
          switch (_context459.prev = _context459.next) {
            case 0:
              _context459.next = 2;
              return this.predictorFacade.getMatchSummary(t, e);

            case 2:
              return _context459.abrupt("return", _context459.sent);

            case 3:
            case "end":
              return _context459.stop();
          }
        }
      }, _callee458, this);
    }));
  });
  s(this, "getMarketSummary", function (t, e, i, n) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee459() {
      return _regeneratorRuntime.wrap(function _callee459$(_context460) {
        while (1) {
          switch (_context460.prev = _context460.next) {
            case 0:
              _context460.next = 2;
              return this.predictorFacade.getMarketSummary(t, e, i, n);

            case 2:
              return _context460.abrupt("return", _context460.sent);

            case 3:
            case "end":
              return _context460.stop();
          }
        }
      }, _callee459, this);
    }));
  });
  s(this, "getConfig", function () {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee460() {
      return _regeneratorRuntime.wrap(function _callee460$(_context461) {
        while (1) {
          switch (_context461.prev = _context461.next) {
            case 0:
              _context461.next = 2;
              return this.predictorFacade.getConfig();

            case 2:
              return _context461.abrupt("return", _context461.sent);

            case 3:
            case "end":
              return _context461.stop();
          }
        }
      }, _callee460, this);
    }));
  });
  s(this, "deleteFootballPrediction", function (t) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee461() {
      return _regeneratorRuntime.wrap(function _callee461$(_context462) {
        while (1) {
          switch (_context462.prev = _context462.next) {
            case 0:
              _context462.next = 2;
              return this.predictorFacade.deleteFootballPrediction(t);

            case 2:
              return _context462.abrupt("return", _context462.sent);

            case 3:
            case "end":
              return _context462.stop();
          }
        }
      }, _callee461, this);
    }));
  });
  s(this, "getMyPredictions", function (t) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee462() {
      return _regeneratorRuntime.wrap(function _callee462$(_context463) {
        while (1) {
          switch (_context463.prev = _context463.next) {
            case 0:
              _context463.next = 2;
              return this.predictorFacade.getMyPredictions(t);

            case 2:
              return _context463.abrupt("return", _context463.sent);

            case 3:
            case "end":
              return _context463.stop();
          }
        }
      }, _callee462, this);
    }));
  });
  s(this, "getMyCurrentPredictions", function (t) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee463() {
      return _regeneratorRuntime.wrap(function _callee463$(_context464) {
        while (1) {
          switch (_context464.prev = _context464.next) {
            case 0:
              _context464.next = 2;
              return this.predictorFacade.getMyCurrentPredictions(t);

            case 2:
              return _context464.abrupt("return", _context464.sent);

            case 3:
            case "end":
              return _context464.stop();
          }
        }
      }, _callee463, this);
    }));
  });
  s(this, "getMyPastPredictions", function (t) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee464() {
      return _regeneratorRuntime.wrap(function _callee464$(_context465) {
        while (1) {
          switch (_context465.prev = _context465.next) {
            case 0:
              _context465.next = 2;
              return this.predictorFacade.getMyPastPredictions(t);

            case 2:
              return _context465.abrupt("return", _context465.sent);

            case 3:
            case "end":
              return _context465.stop();
          }
        }
      }, _callee464, this);
    }));
  });
  s(this, "getMyPredictionsForMatches", function (t, e) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee465() {
      return _regeneratorRuntime.wrap(function _callee465$(_context466) {
        while (1) {
          switch (_context466.prev = _context466.next) {
            case 0:
              _context466.next = 2;
              return this.predictorFacade.getMyPredictionsForMatches(t, e);

            case 2:
              return _context466.abrupt("return", _context466.sent);

            case 3:
            case "end":
              return _context466.stop();
          }
        }
      }, _callee465, this);
    }));
  });
  s(this, "getUserPredictions", function (t, e, i) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee466() {
      return _regeneratorRuntime.wrap(function _callee466$(_context467) {
        while (1) {
          switch (_context467.prev = _context467.next) {
            case 0:
              _context467.next = 2;
              return this.predictorFacade.getUserPredictions(t, e, i);

            case 2:
              return _context467.abrupt("return", _context467.sent);

            case 3:
            case "end":
              return _context467.stop();
          }
        }
      }, _callee466, this);
    }));
  });
  s(this, "getUserCurrentPredictions", function (t, e, i) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee467() {
      return _regeneratorRuntime.wrap(function _callee467$(_context468) {
        while (1) {
          switch (_context468.prev = _context468.next) {
            case 0:
              _context468.next = 2;
              return this.predictorFacade.getUserCurrentPredictions(t, e, i);

            case 2:
              return _context468.abrupt("return", _context468.sent);

            case 3:
            case "end":
              return _context468.stop();
          }
        }
      }, _callee467, this);
    }));
  });
  s(this, "getUserPastPredictions", function (t, e, i) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee468() {
      return _regeneratorRuntime.wrap(function _callee468$(_context469) {
        while (1) {
          switch (_context469.prev = _context469.next) {
            case 0:
              _context469.next = 2;
              return this.predictorFacade.getUserPastPredictions(t, e, i);

            case 2:
              return _context469.abrupt("return", _context469.sent);

            case 3:
            case "end":
              return _context469.stop();
          }
        }
      }, _callee468, this);
    }));
  });
  s(this, "getUserPredictionsForMatches", function (t, e, i, n) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee469() {
      return _regeneratorRuntime.wrap(function _callee469$(_context470) {
        while (1) {
          switch (_context470.prev = _context470.next) {
            case 0:
              _context470.next = 2;
              return this.predictorFacade.getUserPredictionsForMatches(t, e, i, n);

            case 2:
              return _context470.abrupt("return", _context470.sent);

            case 3:
            case "end":
              return _context470.stop();
          }
        }
      }, _callee469, this);
    }));
  });
  s(this, "getPredictionById", function (t) {
    return u(_this162, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee470() {
      return _regeneratorRuntime.wrap(function _callee470$(_context471) {
        while (1) {
          switch (_context471.prev = _context471.next) {
            case 0:
              _context471.next = 2;
              return this.predictorFacade.getPredictionById(t);

            case 2:
              return _context471.abrupt("return", _context471.sent);

            case 3:
            case "end":
              return _context471.stop();
          }
        }
      }, _callee470, this);
    }));
  });
  this.idMapping = new Tt(t), this.predictorHttps = new ys(t, this.idMapping), this.clientHttps = new Ni(t), this.predictorFacade = new BR(t, this.predictorHttps, this.clientHttps, this.idMapping);
},
    VR = function VR() {
  _classCallCheck(this, VR);

  s(this, "rankType", null);
  s(this, "fromDate", null);
  s(this, "toDate", null);
  s(this, "pagination", new Po());
},
    Ep = function Ep() {
  _classCallCheck(this, Ep);

  s(this, "position", null);
  s(this, "profileId", null);
  s(this, "profileModel", null);
  s(this, "points", null);
  s(this, "predictionsMade", null);
},
    jR = function jR() {
  var _this163 = this;

  _classCallCheck(this, jR);

  s(this, "remapResponse", function (t) {
    return t.meta = _this163.remapMeta(t.meta), t.data = _this163.remapData(t.data), t;
  });
  s(this, "remapMeta", function (t) {
    var e = new VR();
    return e.rankType = t.rank_type, e.fromDate = t.from_date, e.toDate = t.to_date, e.pagination.currentPage = t.pagination.current_page, e.pagination.itemsPerPage = t.pagination.items_per_page, e.pagination.totalItems = t.pagination.total_items, e.pagination.numberOfPages = t.pagination.number_of_pages, e;
  });
  s(this, "remapData", function (t) {
    var e = [];
    return t.forEach(function (i) {
      var n = new Ep();
      n.position = i.position, n.profileId = i.profile_id, n.points = i.points, n.predictionsMade = i.predictions_made, e.push(n);
    }), e;
  });
},
    WR =
/*#__PURE__*/
function (_Ep) {
  _inherits(WR, _Ep);

  function WR() {
    var _this164;

    _classCallCheck(this, WR);

    _this164 = _possibleConstructorReturn(this, _getPrototypeOf(WR).apply(this, arguments));
    s(_assertThisInitialized(_this164), "id", null);
    s(_assertThisInitialized(_this164), "rankType", null);
    s(_assertThisInitialized(_this164), "model", null);
    s(_assertThisInitialized(_this164), "gameType", null);
    return _this164;
  }

  return WR;
}(Ep),
    GR =
/*#__PURE__*/
function () {
  function GR() {
    var _this165 = this;

    _classCallCheck(this, GR);

    s(this, "remapRankings", function (t) {
      return t.meta = _this165.remapMeta(t.meta), t.data = _this165.remapData(t.data), t;
    });
    s(this, "remapMeta", function (t) {
      var e = new cs();
      return e.pagination.currentPage = t.pagination.current_page, e.pagination.itemsPerPage = t.pagination.items_per_page, e.pagination.numberOfPages = t.pagination.number_of_pages, e.pagination.totalItems = t.pagination.total_items, e;
    });
  }

  _createClass(GR, [{
    key: "remapData",
    value: function remapData(t) {
      var e = [];
      return t.forEach(function (i) {
        var n = new WR();
        n.id = i.id, n.rankType = i.rank_type, n.position = i.position, n.points = i.points, n.gameType = i.game_type, delete n.profileId, delete n.profileModel, delete n.predictionsMade, e.push(n);
      }), e;
    }
  }]);

  return GR;
}(),
    zR = function zR() {
  _classCallCheck(this, zR);

  s(this, "flags", "");
  s(this, "status", "");
  s(this, "type", "");
  s(this, "activeFrom", "");
  s(this, "activeTo", "");
  s(this, "createdFrom", "");
  s(this, "createdTo", "");
  s(this, "updatedFrom", "");
  s(this, "updatedTo", "");
},
    qR = function qR() {
  _classCallCheck(this, qR);

  s(this, "pagination", new Po());
  s(this, "filters", new zR());
},
    Cp = function Cp() {
  _classCallCheck(this, Cp);

  s(this, "id", null);
  s(this, "name", null);
  s(this, "description", null);
  s(this, "type", null);
  s(this, "fromDate", null);
  s(this, "toDate", null);
  s(this, "markets", []);
  s(this, "teamIds", []);
  s(this, "matchIds", []);
  s(this, "gameIds", []);
  s(this, "gameTypes", []);
  s(this, "competitionIds", []);
  s(this, "excludedProfileIds", []);
  s(this, "rules", null);
  s(this, "labels", null);
  s(this, "customFields", null);
  s(this, "flags", null);
  s(this, "images", new Ao());
  s(this, "status", null);
  s(this, "automaticallyChangeStatus", !0);
  s(this, "createdAt", null);
  s(this, "updatedAt", null);
  s(this, "related", null);
},
    QR =
/*#__PURE__*/
function (_Cp) {
  _inherits(QR, _Cp);

  function QR() {
    var _this166;

    _classCallCheck(this, QR);

    _this166 = _possibleConstructorReturn(this, _getPrototypeOf(QR).apply(this, arguments));
    s(_assertThisInitialized(_this166), "adContent", null);
    return _this166;
  }

  return QR;
}(Cp),
    YR = function YR() {
  var _this167 = this;

  _classCallCheck(this, YR);

  s(this, "remapResponse", function (t) {
    var e = [];
    return t.forEach(function (i) {
      var n = new Cp();
      n.id = i.id, n.name = i.name, n.description = i.description, n.type = i.type, n.fromDate = i.from_date, n.toDate = i.to_date, n.markets = i.markets ? i.markets : null, n.teamIds = i.team_ids ? i.team_ids : null, n.matchIds = i.match_ids ? i.match_ids : null, n.gameIds = i.game_ids ? i.game_ids : null, n.gameTypes = i.game_types ? i.game_types : null, n.competitionIds = i.competition_ids ? i.competition_ids : null, n.excludedProfileIds = i.excluded_profile_ids ? i.excluded_profile_ids : null, n.rules = i.rules ? i.rules : null, n.labels = i.labels ? i.labels : null, n.customFields = i.custom_fields ? i.custom_fields : null, n.flags = i.flags ? i.flags : null, n.images = i.images ? i.images : null, n.status = i.status ? i.status : null, n.automaticallyChangeStatus = i.automatically_change_status, n.createdAt = i.created_at, n.updatedAt = i.updated_at, n.related = i.related ? _this167.remapRelated(i.related) : null, e.push(n);
    }), e;
  });
  s(this, "remapResponseId", function (t) {
    var e = new QR();
    return e.id = t.id, e.name = t.name, e.description = t.description, e.type = t.type, e.fromDate = t.from_date, e.toDate = t.to_date, e.markets = t.markets ? t.markets : null, e.teamIds = t.team_ids ? t.team_ids : null, e.matchIds = t.match_ids ? t.match_ids : null, e.gameIds = t.game_ids ? t.game_ids : null, e.gameTypes = t.game_types ? t.game_types : null, e.competitionIds = t.competition_ids ? t.competition_ids : null, e.excludedProfileIds = t.excluded_profile_ids ? t.excluded_profile_ids : null, e.rules = t.rules ? t.rules : null, e.flags = t.flags ? t.flags : null, e.images = t.images ? t.images : null, e.status = t.status ? t.status : null, e.automaticallyChangeStatus = t.automatically_change_status, e.related = t.related ? _this167.remapRelated(t.related) : null, e.labels = t.labels, e.customFields = t.custom_fields, e.adContent = t.ad_content, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapMeta", function (t) {
    var e = new qR();
    return e.pagination.currentPage = t.pagination.current_page, e.pagination.itemsPerPage = t.pagination.items_per_page, e.pagination.totalItems = t.pagination.total_items, e.pagination.numberOfPages = t.pagination.number_of_pages, e.filters.flags = t.filters.flags, e.filters.status = t.filters.status, e.filters.type = t.filters.type, e.filters.activeFrom = t.filters.active_from, e.filters.activeTo = t.filters.active_to, e.filters.createdFrom = t.filters.created_from, e.filters.createdTo = t.filters.created_to, e.filters.updatedFrom = t.filters.updated_from, e.filters.updatedTo = t.filters.updated_to, e;
  });
  s(this, "remapRelated", function (t) {
    return t.map(function (e) {
      var i = new vp();
      return i.entityId = e.entity_id, i.entityType = e.entity_type, i;
    });
  });
},
    KR = function KR() {
  _classCallCheck(this, KR);

  s(this, "position", null);
  s(this, "points", null);
  s(this, "predictionsMade", null);
  s(this, "profileId", null);
  s(this, "profileModel", null);
  s(this, "successRatePercent", null);
},
    JR = function JR() {
  _classCallCheck(this, JR);

  s(this, "remapHighestSuccessRate", function (t) {
    return t.map(function (e) {
      var i = new KR();
      return i.position = e.position, i.points = e.points, i.predictionsMade = e.predictions_made, i.profileId = e.profile_id, i.successRatePercent = e.success_rate_percent, i;
    });
  });
},
    XR =
/*#__PURE__*/
function (_St7) {
  _inherits(XR, _St7);

  function XR(e) {
    var _this168;

    _classCallCheck(this, XR);

    _this168 = _possibleConstructorReturn(this, _getPrototypeOf(XR).call(this, e, Ct(e.environment, "loyalty")));
    s(_assertThisInitialized(_this168), "templateRemapper", null);
    s(_assertThisInitialized(_this168), "leaderboardRemapper", null);
    s(_assertThisInitialized(_this168), "rankingsRemapper", null);
    s(_assertThisInitialized(_this168), "highestSuccessRateRemapper", null);
    s(_assertThisInitialized(_this168), "getTemplates", function (e, i) {
      return u(_assertThisInitialized(_this168), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee471() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee471$(_context472) {
          while (1) {
            switch (_context472.prev = _context472.next) {
              case 0:
                n = e ? "/leaderboard/templates/".concat(this.apiSignInUrl).concat(e.constructFiltersUrl()) : "/leaderboard/templates/".concat(this.apiSignInUrl);
                n += Ee(i) ? Ce() : "";
                r = "There was a problem fetching the list of templates";
                _context472.next = 5;
                return this.fetchWithoutAuth(n, r);

              case 5:
                a = _context472.sent;
                o = JSON.parse(JSON.stringify(a));
                return _context472.abrupt("return", (o.meta = this.templateRemapper.remapMeta(a.meta), o.data = this.templateRemapper.remapResponse(a.data), o));

              case 8:
              case "end":
                return _context472.stop();
            }
          }
        }, _callee471, this);
      }));
    });
    s(_assertThisInitialized(_this168), "getTemplateById", function (e, i) {
      return u(_assertThisInitialized(_this168), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee472() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee472$(_context473) {
          while (1) {
            switch (_context473.prev = _context473.next) {
              case 0:
                n = Ee(i) ? "/leaderboard/templates/".concat(e).concat(this.apiSignInUrl).concat(Ce()) : "/leaderboard/templates/".concat(e).concat(this.apiSignInUrl);
                r = "There was a problem requesting the following template: ".concat(e);
                _context473.next = 4;
                return this.fetchWithoutAuth(n, r);

              case 4:
                a = _context473.sent;
                return _context473.abrupt("return", this.templateRemapper.remapResponseId(a.data));

              case 6:
              case "end":
                return _context473.stop();
            }
          }
        }, _callee472, this);
      }));
    });
    s(_assertThisInitialized(_this168), "getLeaderboard", function (e, i, n) {
      return u(_assertThisInitialized(_this168), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee473() {
        var r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee473$(_context474) {
          while (1) {
            switch (_context474.prev = _context474.next) {
              case 0:
                r = Ee(i) ? "/leaderboard/".concat(e, "/").concat(this.apiSignInUrl).concat(Ce()) : "/leaderboard/".concat(e, "/").concat(this.apiSignInUrl), a = "There was a problem fetching the leaderboard for the following template: ".concat(e);
                n && (r += "".concat(n.constructFiltersUrl()));
                _context474.next = 4;
                return this.fetchWithoutAuth(r, a);

              case 4:
                o = _context474.sent;
                l = JSON.parse(JSON.stringify(o));
                return _context474.abrupt("return", this.leaderboardRemapper.remapResponse(l));

              case 7:
              case "end":
                return _context474.stop();
            }
          }
        }, _callee473, this);
      }));
    });
    s(_assertThisInitialized(_this168), "getLeaderboardForGame", function (e, i, n) {
      return u(_assertThisInitialized(_this168), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee474() {
        var r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee474$(_context475) {
          while (1) {
            switch (_context475.prev = _context475.next) {
              case 0:
                r = Ee(i) ? "/leaderboard/games/".concat(e, "/").concat(this.apiSignInUrl).concat(Ce()) : "/leaderboard/games/".concat(e, "/").concat(this.apiSignInUrl), a = "There was a problem fetching the leaderboard for the following game: ".concat(e);
                n && (r += "".concat(n.constructFiltersUrl()));
                _context475.next = 4;
                return this.fetchWithoutAuth(r, a);

              case 4:
                o = _context475.sent;
                l = JSON.parse(JSON.stringify(o));
                return _context475.abrupt("return", this.leaderboardRemapper.remapResponse(l));

              case 7:
              case "end":
                return _context475.stop();
            }
          }
        }, _callee474, this);
      }));
    });
    s(_assertThisInitialized(_this168), "getUserRankings", function (e, i, n) {
      return u(_assertThisInitialized(_this168), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee475() {
        var r, a, o;
        return _regeneratorRuntime.wrap(function _callee475$(_context476) {
          while (1) {
            switch (_context476.prev = _context476.next) {
              case 0:
                r = "/leaderboard/users/".concat(e, "/rankings/").concat(this.apiSignInUrl), a = "There was a problem fetching the rankings for the following user: ".concat(e);
                i && (r += "".concat(i.constructFiltersUrl())), Ee(n) && (r += "".concat(Ce()));
                _context476.next = 4;
                return this.fetchWithoutAuth(r, a);

              case 4:
                o = _context476.sent;
                return _context476.abrupt("return", this.rankingsRemapper.remapRankings(o));

              case 6:
              case "end":
                return _context476.stop();
            }
          }
        }, _callee475, this);
      }));
    });
    s(_assertThisInitialized(_this168), "getHighestSuccessRate", function (e, i) {
      return u(_assertThisInitialized(_this168), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee476() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee476$(_context477) {
          while (1) {
            switch (_context477.prev = _context477.next) {
              case 0:
                n = "/statistics/top".concat(this.apiSignInUrl), r = "There was a problem fetching highest success rate";
                e && (n += "".concat(e.constructFiltersUrl())), Ee(i) && (n += "".concat(Ce()));
                _context477.next = 4;
                return this.fetchWithoutAuth(n, r);

              case 4:
                a = _context477.sent;
                return _context477.abrupt("return", this.highestSuccessRateRemapper.remapHighestSuccessRate(a.data));

              case 6:
              case "end":
                return _context477.stop();
            }
          }
        }, _callee476, this);
      }));
    });
    s(_assertThisInitialized(_this168), "getEntitiesFollows", function (e, i) {
      return u(_assertThisInitialized(_this168), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee477() {
        var n, r;
        return _regeneratorRuntime.wrap(function _callee477$(_context478) {
          while (1) {
            switch (_context478.prev = _context478.next) {
              case 0:
                n = Ee(i) ? "/statistics/follows".concat(this.apiSignInUrl).concat(Ce()) : "/statistics/follows".concat(this.apiSignInUrl), r = "There was a problem fetching follows for entities";
                e.footballCompetitions && (n += "&competitions=".concat(e.footballCompetitions.join(",")));
                e.footballTeams && (n += "&teams=".concat(e.footballTeams.join(",")));
                e.footballPlayers && (n += "&players=".concat(e.footballPlayers.join(",")));
                _context478.next = 6;
                return this.fetchWithoutAuth(n, r);

              case 6:
                return _context478.abrupt("return", _context478.sent.data);

              case 7:
              case "end":
                return _context478.stop();
            }
          }
        }, _callee477, this);
      }));
    });
    _this168.templateRemapper = new YR(), _this168.leaderboardRemapper = new jR(), _this168.rankingsRemapper = new GR(), _this168.highestSuccessRateRemapper = new JR();
    return _this168;
  }

  return XR;
}(St),
    ZR = function ZR() {
  _classCallCheck(this, ZR);

  s(this, "general");
  s(this, "predictor");
  s(this, "topX");
  s(this, "matchQuiz");
},
    Sp =
/*#__PURE__*/
function () {
  function Sp(t) {
    _classCallCheck(this, Sp);

    s(this, "limit", null);
    s(this, "page", null);
    this.limit = t.limit ? t.limit : null, this.page = t.page ? t.page : null;
  }

  _createClass(Sp, [{
    key: "constructFiltersUrl",
    value: function constructFiltersUrl() {
      var t = "";
      return this.limit && (t += "&", t += "limit=".concat(this.limit)), this.page && (t += "&", t += "page=".concat(this.page)), t;
    }
  }]);

  return Sp;
}(),
    eP =
/*#__PURE__*/
function (_Sp) {
  _inherits(eP, _Sp);

  function eP(e) {
    var _this169;

    _classCallCheck(this, eP);

    _this169 = _possibleConstructorReturn(this, _getPrototypeOf(eP).call(this, e));
    s(_assertThisInitialized(_this169), "sortOrder", null);
    s(_assertThisInitialized(_this169), "rankType", null);
    s(_assertThisInitialized(_this169), "leaderboardIds", null);
    s(_assertThisInitialized(_this169), "gameType", null);
    s(_assertThisInitialized(_this169), "constructFiltersUrl", function () {
      var e = _get2(_getPrototypeOf(eP.prototype), "constructFiltersUrl", _assertThisInitialized(_this169)).call(_assertThisInitialized(_this169));

      return _this169.sortOrder && (e += "&", e += "sort_order=".concat(_this169.sortOrder)), _this169.rankType && (e += "&", e += "rank_type=".concat(_this169.rankType)), _this169.leaderboardIds && (e += "&", e += "type_ids=".concat(_this169.leaderboardIds.join(","))), _this169.gameType && (e += "&", e += "game_type=".concat(_this169.gameType)), e;
    });
    _this169.sortOrder = e.sortOrder, _this169.rankType = e.rankType, _this169.leaderboardIds = e.leaderboardIds, _this169.gameType = e.type && e.type.toLowerCase() === "game" ? e.gameType : null;
    return _this169;
  }

  return eP;
}(Sp),
    tP = function tP(t) {
  var _this170 = this;

  _classCallCheck(this, tP);

  s(this, "idMappingService", null);
  s(this, "profileNamespace", null);
  s(this, "footballNamespace", null);
  s(this, "errorHandlingMode", null);
  s(this, "remapTemplatesIds", function (t) {
    return u(_this170, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee478() {
      var e, i, n, _r46, _a18;

      return _regeneratorRuntime.wrap(function _callee478$(_context479) {
        while (1) {
          switch (_context479.prev = _context479.next) {
            case 0:
              if (!(t.length > 0)) {
                _context479.next = 8;
                break;
              }

              e = [], i = [], n = [];
              t.forEach(function (o) {
                o.teamIds && o.teamIds.length > 0 ? e = [].concat(_toConsumableArray(e), _toConsumableArray(o.teamIds)) : o.matchIds && o.matchIds.length > 0 ? i = [].concat(_toConsumableArray(i), _toConsumableArray(o.matchIds)) : o.competitionIds && o.competitionIds.length > 0 && (n = [].concat(_toConsumableArray(n), _toConsumableArray(o.competitionIds)));
              });
              _r46 = {
                team: e,
                match: i,
                competition: n
              };
              _context479.next = 6;
              return this.idMappingService.idMappingFacade.getEntitiesByIds(_r46, "native", this.idMappingService.idSchema);

            case 6:
              _a18 = _context479.sent;
              return _context479.abrupt("return", (_toConsumableArray(_a18.team), _toConsumableArray(_a18.match), _toConsumableArray(_a18.competition), t.forEach(function (o) {
                o.teamIds && o.teamIds.length > 0 ? o.teamIds = o.teamIds.map(function (l) {
                  return _a18.team.shift();
                }) : o.matchIds && o.matchIds.length > 0 ? o.matchIds = o.matchIds.map(function (l) {
                  return _a18.match.shift();
                }) : o.competitionIds && o.competitionIds.length > 0 && (o.competitionIds = o.competitionIds.map(function (l) {
                  return _a18.competition.shift();
                }));
              }), t));

            case 8:
              return _context479.abrupt("return", t);

            case 9:
            case "end":
              return _context479.stop();
          }
        }
      }, _callee478, this);
    }));
  });
  s(this, "addProfileModelToLeaderboad", function (t) {
    return u(_this170, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee479() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee479$(_context480) {
        while (1) {
          switch (_context480.prev = _context480.next) {
            case 0:
              if (!(t.length > 0)) {
                _context480.next = 8;
                break;
              }

              e = [], i = t.map(function (r) {
                return r.profileId;
              });

              if (i.length) {
                _context480.next = 4;
                break;
              }

              return _context480.abrupt("return", t);

            case 4:
              _context480.next = 6;
              return this.profileNamespace.getByIds(i);

            case 6:
              n = _context480.sent;
              return _context480.abrupt("return", (t.forEach(function (r) {
                n.forEach(function (a) {
                  a.id === r.profileId && (delete a.interests, r.profileModel = a);
                }), r.profileModel || (r.profileModel = null), e.push(r);
              }), e));

            case 8:
              return _context480.abrupt("return", t);

            case 9:
            case "end":
              return _context480.stop();
          }
        }
      }, _callee479, this);
    }));
  });
  s(this, "buildClientBadges", function (t) {
    var e = new ZR();
    return e.general = _this170.extractEnabledBadgesId(t.general), e.predictor = _this170.extractEnabledBadgesId(t.predictor), e.topX = _this170.extractEnabledBadgesId(t.topX), e.matchQuiz = _this170.extractEnabledBadgesId(t.matchQuiz), e;
  });
  s(this, "initFilters", function (t, e) {
    switch (e) {
      case "loyalty":
        t && (t = new Sp(t));
        break;

      case "rankings":
        t && (t = new eP(t));
        break;
    }

    return t;
  });
  s(this, "addProfileModelToHighestSuccessRate", function (t) {
    return u(_this170, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee480() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee480$(_context481) {
        while (1) {
          switch (_context481.prev = _context481.next) {
            case 0:
              e = t.map(function (n) {
                return n.profileId;
              });

              if (e.length) {
                _context481.next = 3;
                break;
              }

              return _context481.abrupt("return", t);

            case 3:
              _context481.next = 5;
              return this.profileNamespace.getByIds(e);

            case 5:
              i = _context481.sent;
              return _context481.abrupt("return", t.map(function (n) {
                return i.forEach(function (r) {
                  r.id === n.profileId && (delete r.interests, n.profileModel = r);
                }), n;
              }));

            case 7:
            case "end":
              return _context481.stop();
          }
        }
      }, _callee480, this);
    }));
  });
  s(this, "extractRankingsIdsMap", function (t) {
    var e = [],
        i = [],
        n = [];
    return t.forEach(function (r) {
      r.rankType === "GAME" && r.gameType === "TOP_X" ? e.push(r.id) : r.rankType === "GAME" && r.gameType === "MATCH_QUIZ" ? i.push(r.id) : r.rankType === "TEMPLATE" && n.push(r.id);
    }), [e, i, n];
  });
  s(this, "setModelsForUserRankings", function (t, e, i, n) {
    return n.data.forEach(function (r) {
      r.gameType === "MATCH_QUIZ" && e ? r.model = e.filter(function (a) {
        return a.id === r.id;
      })[0] : r.gameType === "TOP_X" && t ? r.model = t.filter(function (a) {
        return a.id === r.id;
      })[0] : r.rankType === "TEMPLATE" && i && (r.model = i.filter(function (a) {
        return a.id === r.id;
      })[0]);
    }), n;
  });
  s(this, "completeContestWinners", function (t) {
    return u(_this170, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee481() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee481$(_context482) {
        while (1) {
          switch (_context482.prev = _context482.next) {
            case 0:
              if (!(t.userList && t.userList.length)) {
                _context482.next = 6;
                break;
              }

              e = t.userList.map(function (n) {
                return n.profileId;
              });
              _context482.next = 4;
              return this.profileNamespace.getByIds(e);

            case 4:
              i = _context482.sent;
              t.userList.forEach(function (n) {
                var r = i.filter(function (a) {
                  return a.id === n.profileId;
                })[0];
                delete r.interests, n.profileModel = r;
              });

            case 6:
              return _context482.abrupt("return", t);

            case 7:
            case "end":
              return _context482.stop();
          }
        }
      }, _callee481, this);
    }));
  });
  s(this, "validateEntitiesFollowsFilters", function (t) {
    if (!t || (!t.footballCompetitions || !t.footballCompetitions.length) && (!t.footballTeams || !t.footballTeams.length) && (!t.footballPlayers || !t.footballPlayers.length)) throw _this170.errorHandlingMode === "default" ? new Se(400, "invalid_filters", "At least one of footballCompetitions, footballTeams or footballPlayers properties should be provided for filters.") : new ue(400, "invalid_filters", "At least one of footballCompetitions, footballTeams or footballPlayers properties should be provided for filters.");
    if (t.footballCompetitions && t.footballCompetitions.length > 24 || t.footballTeams && t.footballTeams.length > 24 || t.footballPlayers && t.footballPlayers.length > 24) throw _this170.errorHandlingMode === "default" ? new Se(400, "EXCEEDED_LENGTH", "Maximum length per entity should be 24 or less.") : new ue(400, "EXCEEDED_LENGTH", "Maximum length per entity should be 24 or less.");
  });
  s(this, "remapEntitiesFollowsFilters", function (t) {
    return u(_this170, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee482() {
      var e, i, n, r;
      return _regeneratorRuntime.wrap(function _callee482$(_context483) {
        while (1) {
          switch (_context483.prev = _context483.next) {
            case 0:
              e = JSON.parse(JSON.stringify(t)), i = {}, n = {};
              e.footballCompetitions && e.footballCompetitions.length && (n.competition = e.footballCompetitions), e.footballTeams && e.footballTeams.length && (n.team = e.footballTeams), e.footballPlayers && e.footballPlayers.length && (n.player = e.footballPlayers);
              _context483.next = 4;
              return this.idMappingService.idMappingFacade.getEntitiesByIds(n, this.idMappingService.idSchema, "native");

            case 4:
              r = _context483.sent;
              return _context483.abrupt("return", (Object.keys(r).forEach(function (a) {
                a === "competition" ? i.footballCompetitions = r[a] : a === "team" ? i.footballTeams = r[a] : a === "player" && (i.footballPlayers = r[a]);
              }), i));

            case 6:
            case "end":
              return _context483.stop();
          }
        }
      }, _callee482, this);
    }));
  });
  s(this, "addModelsToEntitiesFollows", function (t) {
    return u(_this170, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee483() {
      var e, i, n, r, a, o, l, c, d;
      return _regeneratorRuntime.wrap(function _callee483$(_context484) {
        while (1) {
          switch (_context484.prev = _context484.next) {
            case 0:
              e = [], i = "fb:c:", n =
              /* @__PURE__ */
              new Map(), r = [], a = "fb:t:", o =
              /* @__PURE__ */
              new Map(), l = [], c = "fb:p:", d = null;
              t.breakdown.forEach(function (h) {
                h.id.includes(i) ? e.push(h.id) : h.id.includes(a) ? r.push(h.id) : h.id.includes(c) && l.push(h.id);
              });
              _context484.t0 = e.length;

              if (!_context484.t0) {
                _context484.next = 7;
                break;
              }

              _context484.next = 6;
              return this.footballNamespace.footballFacade.competitionsFacade.getCompetitionsMapWithNativeIds(e);

            case 6:
              n = _context484.sent;

            case 7:
              _context484.t1 = r.length;

              if (!_context484.t1) {
                _context484.next = 12;
                break;
              }

              _context484.next = 11;
              return this.footballNamespace.footballFacade.teamsFacade.getTeamsMapWithNativeIds(r);

            case 11:
              o = _context484.sent;

            case 12:
              _context484.t2 = l.length;

              if (!_context484.t2) {
                _context484.next = 17;
                break;
              }

              _context484.next = 16;
              return this.footballNamespace.footballFacade.playerFacade.getPlayersMapWithNativeIds(l);

            case 16:
              d = _context484.sent;

            case 17:
              t.breakdown.forEach(function (h) {
                h.id.includes(i) ? (h.model = n.get(h.id), h.id = h.model.id) : h.id.includes(a) ? (h.model = o.get(h.id), h.id = h.model.id) : h.id.includes(c) && (h.model = d[h.id], h.id = h.model.id);
              });
              return _context484.abrupt("return", t);

            case 19:
            case "end":
              return _context484.stop();
          }
        }
      }, _callee483, this);
    }));
  });
  s(this, "extractEnabledBadgesId", function (t) {
    var e = [];
    return t.forEach(function (i) {
      i.enabled && e.push(i.id);
    }), e;
  });
  this.idMappingService = new Tt(t), this.profileNamespace = new hs(t), this.footballNamespace = new lp(t), this.errorHandlingMode = t.errorHandlingMode;
},
    iP = function iP() {
  var _this171 = this;

  _classCallCheck(this, iP);

  s(this, "validate", function (t, e) {
    t.market && _this171.validateMarket(t.market, e), t.fromDate && _this171.validateDate(t.fromDate, "fromDate", e), t.toDate && _this171.validateDate(t.toDate, "toDate", e), t.usersCount && _this171.validateNumberFilters(t.usersCount, "usersCount", e), t.minimumPredictions && _this171.validateNumberFilters(t.minimumPredictions, "minimumPredictions", e);
  });
  s(this, "validateMarket", function (t, e) {
    if (!Object.keys(ds).includes(t)) {
      var i = Bh(t);
      throw e === "default" ? new Se(400, "INVALID_MARKET", i) : new ue(400, "INVALID_MARKET", i);
    }
  });
  s(this, "validateDate", function (t, e, i) {
    var n = /^\d{4}-\d{2}-\d{2}$/;
    if (typeof t != "string") throw i === "default" ? new Se(400, "invalid_filters", "You have provided invalid type. The valid type is string for ".concat(e, " filter")) : new ue(400, "invalid_filters", "You have provided invalid type. The valid type is string for ".concat(e, " filter"));
    if (!n.test(t)) throw i === "default" ? new Se(400, "invalid_filters", "You have provided invalid value. The valid value is YYYY-MM-DD for ".concat(e)) : new ue(400, "invalid_filters", "You have provided invalid value. The valid value is YYYY-MM-DD for ".concat(e));
  });
  s(this, "validateNumberFilters", function (t, e, i) {
    var n = e === "usersCount" ? 1 : 0,
        r = e === "usersCount" ? 1e3 : 1e6;
    if (typeof t != "number") throw i === "default" ? new Se(400, "invalid_filters", "You have provided invalid type. The valid type is number for ".concat(e, " filter")) : new ue(400, "invalid_filters", "You have provided invalid type. The valid type is number for ".concat(e, " filter"));
    if (t < n || t > r) throw i === "default" ? new Se(400, "invalid_filters", "You have provided invalid value. The valid value is between ".concat(n, " and ").concat(r)) : new ue(400, "invalid_filters", "You have provided invalid value. The valid value is between ".concat(n, " and ").concat(r));
  });
},
    Tp = function Tp(t, e) {
  var _this172 = this;

  _classCallCheck(this, Tp);

  s(this, "idMapping", null);
  s(this, "predictorHttps", null);
  s(this, "predictorService", null);
  s(this, "predictorValidator", null);
  s(this, "clientHttps", null);
  s(this, "errorHandlingMode", null);
  s(this, "getConfig", function () {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee484() {
      var t;
      return _regeneratorRuntime.wrap(function _callee484$(_context485) {
        while (1) {
          switch (_context485.prev = _context485.next) {
            case 0:
              _context485.next = 2;
              return this.clientHttps.getConfig("topX");

            case 2:
              t = _context485.sent;

              if (!(this.idMapping.idSchema !== "native")) {
                _context485.next = 9;
                break;
              }

              _context485.next = 6;
              return this.predictorService.remapCompetitionsFromConfig(t);

            case 6:
              _context485.t0 = _context485.sent;
              _context485.next = 10;
              break;

            case 9:
              _context485.t0 = t;

            case 10:
              return _context485.abrupt("return", _context485.t0);

            case 11:
            case "end":
              return _context485.stop();
          }
        }
      }, _callee484, this);
    }));
  });
  s(this, "getGames", function (t, e) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee485() {
      var i, n;
      return _regeneratorRuntime.wrap(function _callee485$(_context486) {
        while (1) {
          switch (_context486.prev = _context486.next) {
            case 0:
              e = e || !1;
              i = this.predictorService.initGameFilters("TOP_X", t);
              _context486.next = 4;
              return this.predictorHttps.getGames(i, e);

            case 4:
              n = _context486.sent;
              _context486.next = 7;
              return this.predictorService.remapMatchIdsFixtures(n);

            case 7:
              return _context486.abrupt("return", _context486.sent);

            case 8:
            case "end":
              return _context486.stop();
          }
        }
      }, _callee485, this);
    }));
  });
  s(this, "getGameById", function (t, e) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee486() {
      var i;
      return _regeneratorRuntime.wrap(function _callee486$(_context487) {
        while (1) {
          switch (_context487.prev = _context487.next) {
            case 0:
              e = e || !1;
              _context487.next = 3;
              return this.predictorHttps.getGameById(t, e);

            case 3:
              i = _context487.sent;
              _context487.next = 6;
              return this.predictorService.remapMatchIdsFixtures(i);

            case 6:
              return _context487.abrupt("return", _context487.sent);

            case 7:
            case "end":
              return _context487.stop();
          }
        }
      }, _callee486, this);
    }));
  });
  s(this, "getGamePredictions", function (t, e, i) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee487() {
      return _regeneratorRuntime.wrap(function _callee487$(_context488) {
        while (1) {
          switch (_context488.prev = _context488.next) {
            case 0:
              i = i || !1;
              e && (e.type && delete e.type, e.status && delete e.status, e = new rt(e));
              _context488.next = 4;
              return this.predictorHttps.getGamePredictions(t, i, e);

            case 4:
              return _context488.abrupt("return", _context488.sent);

            case 5:
            case "end":
              return _context488.stop();
          }
        }
      }, _callee487, this);
    }));
  });
  s(this, "getGameResults", function (t, e, i) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee488() {
      var n;
      return _regeneratorRuntime.wrap(function _callee488$(_context489) {
        while (1) {
          switch (_context489.prev = _context489.next) {
            case 0:
              i = i || !1, e && (e = new Qt(e));
              _context489.next = 3;
              return this.predictorHttps.getGameResults(t, i, e);

            case 3:
              n = _context489.sent;
              _context489.next = 6;
              return this.predictorService.remapMatchIdsFixtures(n);

            case 6:
              return _context489.abrupt("return", _context489.sent);

            case 7:
            case "end":
              return _context489.stop();
          }
        }
      }, _callee488, this);
    }));
  });
  s(this, "getCurrentGameResults", function (t) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee489() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee489$(_context490) {
        while (1) {
          switch (_context490.prev = _context490.next) {
            case 0:
              t = t || !1;
              e = {
                status: "OPEN",
                type: "TOP_X"
              };
              e = new Qt(e);
              _context490.next = 5;
              return this.predictorHttps.getGames(e, t);

            case 5:
              i = _context490.sent;
              n = this.predictorService.getCurrentGameId(i);
              _context490.next = 9;
              return this.getGameResults(n, null, t);

            case 9:
              return _context490.abrupt("return", _context490.sent.data[0]);

            case 10:
            case "end":
              return _context490.stop();
          }
        }
      }, _callee489, this);
    }));
  });
  s(this, "play", function (t) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee490() {
      var _this173 = this;

      var e, n, _r47, i;

      return _regeneratorRuntime.wrap(function _callee490$(_context491) {
        while (1) {
          switch (_context491.prev = _context491.next) {
            case 0:
              e = new gp(t);

              if (!(e = this.predictorValidator.validateBodyFields("TOP_X", e), e.fixtures = e.fixtures.map(function (n) {
                return _this173.predictorValidator.validateFixture(n.matchId, n.market, n.prediction.value);
              }), this.idMapping.idSchema !== "native")) {
                _context491.next = 8;
                break;
              }

              n = [];
              e.fixtures.forEach(function (a) {
                return n.push(a.matchId);
              });
              _context491.next = 6;
              return this.predictorService.remapMatchIdToNative(n);

            case 6:
              _r47 = _context491.sent;
              e.fixtures.forEach(function (a) {
                return a.matchId = _r47.shift();
              });

            case 8:
              _context491.next = 10;
              return this.predictorHttps.makeFootballPrediction(e);

            case 10:
              i = _context491.sent;
              return _context491.abrupt("return", (i.fixtures.forEach(function (n) {
                n.matchId = n.matchModel.id;
              }), i));

            case 12:
            case "end":
              return _context491.stop();
          }
        }
      }, _callee490, this);
    }));
  });
  s(this, "delete", function (t) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee491() {
      return _regeneratorRuntime.wrap(function _callee491$(_context492) {
        while (1) {
          switch (_context492.prev = _context492.next) {
            case 0:
              _context492.next = 2;
              return this.predictorHttps.deleteFootballPrediction(t);

            case 2:
              return _context492.abrupt("return", _context492.sent);

            case 3:
            case "end":
              return _context492.stop();
          }
        }
      }, _callee491, this);
    }));
  });
  s(this, "getMyGameEditions", function (t, e) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee492() {
      var i, n, r, _a19, _o19;

      return _regeneratorRuntime.wrap(function _callee492$(_context493) {
        while (1) {
          switch (_context493.prev = _context493.next) {
            case 0:
              t && t.limit && this.validateLimitFilterOnGames(t.limit), e = e || !1;
              i = this.predictorService.initGameTypePredictions("TOP_X", t);
              n = [];
              _context493.next = 5;
              return this.predictorHttps.getMyPredictionsNoRemap(i);

            case 5:
              r = _context493.sent;

              if (!(r.data.length > 0)) {
                _context493.next = 17;
                break;
              }

              r.data.forEach(function (l) {
                l.game_instance_id && n.push(l.game_instance_id);
              });
              _a19 = this.predictorService.initGameFilters("TOP_X", null, n);
              _context493.next = 11;
              return this.predictorHttps.getUserGameEditions(_a19, e);

            case 11:
              _o19 = _context493.sent;
              _context493.next = 14;
              return this.predictorService.addPredictionProp(r, _o19);

            case 14:
              return _context493.abrupt("return", _context493.sent);

            case 17:
              return _context493.abrupt("return", new qe());

            case 18:
            case "end":
              return _context493.stop();
          }
        }
      }, _callee492, this);
    }));
  });
  s(this, "getMyGamePrediction", function (t) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee493() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee493$(_context494) {
        while (1) {
          switch (_context494.prev = _context494.next) {
            case 0:
              e = this.predictorService.initGameTypePredictions("TOP_X");
              _context494.next = 3;
              return this.predictorHttps.getMyPredictions(e);

            case 3:
              i = _context494.sent;

              if (!(i.data.length > 0)) {
                _context494.next = 7;
                break;
              }

              n = i.data.filter(function (r) {
                return r.gameInstanceId === t;
              });
              return _context494.abrupt("return", n.length ? n[0] : null);

            case 7:
              return _context494.abrupt("return", null);

            case 8:
            case "end":
              return _context494.stop();
          }
        }
      }, _callee493, this);
    }));
  });
  s(this, "getUserGameEditions", function (t, e, i) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee494() {
      var n, r, a, _o20, _l17;

      return _regeneratorRuntime.wrap(function _callee494$(_context495) {
        while (1) {
          switch (_context495.prev = _context495.next) {
            case 0:
              e && e.limit && this.validateLimitFilterOnGames(e.limit), i = i || !1;
              n = this.predictorService.initGameTypePredictions("TOP_X", e);
              r = [];
              _context495.next = 5;
              return this.predictorHttps.getUserPredictionsNoRemap(t, n);

            case 5:
              a = _context495.sent;

              if (!(a.data.length > 0)) {
                _context495.next = 17;
                break;
              }

              a.data.forEach(function (c) {
                c.game_instance_id && r.push(c.game_instance_id);
              });
              _o20 = this.predictorService.initGameFilters("TOP_X", null, r);
              _context495.next = 11;
              return this.predictorHttps.getUserGameEditions(_o20, i);

            case 11:
              _l17 = _context495.sent;
              _context495.next = 14;
              return this.predictorService.addPredictionProp(a, _l17);

            case 14:
              return _context495.abrupt("return", _context495.sent);

            case 17:
              return _context495.abrupt("return", new qe());

            case 18:
            case "end":
              return _context495.stop();
          }
        }
      }, _callee494, this);
    }));
  });
  s(this, "getUserGamePrediction", function (t, e, i) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee495() {
      var n, r, _a20;

      return _regeneratorRuntime.wrap(function _callee495$(_context496) {
        while (1) {
          switch (_context496.prev = _context496.next) {
            case 0:
              i = i || !1;
              n = this.predictorService.initGameTypePredictions("TOP_X");
              _context496.next = 4;
              return this.predictorHttps.getUserPredictions(t, i, n);

            case 4:
              r = _context496.sent;

              if (!(r.data.length > 0)) {
                _context496.next = 10;
                break;
              }

              _a20 = r.data.filter(function (o) {
                return o.gameInstanceId === e;
              });
              return _context496.abrupt("return", _a20.length ? _a20[0] : null);

            case 10:
              return _context496.abrupt("return", null);

            case 11:
            case "end":
              return _context496.stop();
          }
        }
      }, _callee495, this);
    }));
  });
  s(this, "getMarketsResultsForGame", function (t, e) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee496() {
      var i;
      return _regeneratorRuntime.wrap(function _callee496$(_context497) {
        while (1) {
          switch (_context497.prev = _context497.next) {
            case 0:
              _context497.next = 2;
              return this.predictorHttps.getMarketResultsForGame(t, e);

            case 2:
              i = _context497.sent;
              _context497.next = 5;
              return this.predictorService.completeGameMarketResults(i, "TOP_X");

            case 5:
              return _context497.abrupt("return", _context497.sent);

            case 6:
            case "end":
              return _context497.stop();
          }
        }
      }, _callee496, this);
    }));
  });
  s(this, "getGameWinners", function (t) {
    return u(_this172, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee497() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee497$(_context498) {
        while (1) {
          switch (_context498.prev = _context498.next) {
            case 0:
              _context498.next = 2;
              return this.predictorHttps.getContestWinners(t);

            case 2:
              e = _context498.sent;
              _context498.next = 5;
              return this.getGameById(t);

            case 5:
              i = _context498.sent;
              return _context498.abrupt("return", (e.contestModel = i, this.predictorService.completeContestWinners(e)));

            case 7:
            case "end":
              return _context498.stop();
          }
        }
      }, _callee497, this);
    }));
  });
  s(this, "validateLimitFilterOnGames", function (t) {
    if (_this172.errorHandlingMode === "default" && t > 50) throw new Se(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
    if (_this172.errorHandlingMode === "standard" && t > 50) throw new ue(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
  });
  this.idMapping = e, this.errorHandlingMode = t.errorHandlingMode, this.predictorValidator = new Mo(t.errorHandlingMode), this.predictorHttps = new ys(t, e), this.predictorService = new gs(t, e), this.clientHttps = new Ni(t);
},
    Rp = function Rp(t) {
  var _this174 = this;

  _classCallCheck(this, Rp);

  s(this, "predictorHttps", null);
  s(this, "predictorService", null);
  s(this, "idMapping", null);
  s(this, "clientHttps", null);
  s(this, "predictorValidator", null);
  s(this, "errorHandlingMode", null);
  s(this, "getConfig", function () {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee498() {
      var t;
      return _regeneratorRuntime.wrap(function _callee498$(_context499) {
        while (1) {
          switch (_context499.prev = _context499.next) {
            case 0:
              _context499.next = 2;
              return this.clientHttps.getConfig("matchQuiz");

            case 2:
              t = _context499.sent;

              if (!(this.idMapping.idSchema !== "native")) {
                _context499.next = 9;
                break;
              }

              _context499.next = 6;
              return this.predictorService.remapCompetitionsFromConfig(t);

            case 6:
              _context499.t0 = _context499.sent;
              _context499.next = 10;
              break;

            case 9:
              _context499.t0 = t;

            case 10:
              return _context499.abrupt("return", _context499.t0);

            case 11:
            case "end":
              return _context499.stop();
          }
        }
      }, _callee498, this);
    }));
  });
  s(this, "play", function (t) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee499() {
      var _this175 = this;

      var e, i, n, _r48, _a21;

      return _regeneratorRuntime.wrap(function _callee499$(_context500) {
        while (1) {
          switch (_context500.prev = _context500.next) {
            case 0:
              t = this.predictorValidator.validateBodyFields("MATCH_QUIZ", t);
              e = t.fixtures.map(function (i) {
                return _this175.predictorValidator.validateFixture(i.matchId, i.market, i.prediction.value, i.prediction.playerId);
              });

              if (!(e && e.length && this.idMapping.idSchema !== "native")) {
                _context500.next = 15;
                break;
              }

              i = [], n = [];
              e.forEach(function (o) {
                i.push(o.matchId), o instanceof Ri && o.prediction.playerId && o.prediction.playerId !== "OWN_GOAL" && n.push(o.prediction.playerId);
              });
              _context500.next = 7;
              return this.predictorService.remapMatchIdToNative(i);

            case 7:
              _r48 = _context500.sent;
              _a21 = {};
              _context500.t0 = n && n.length > 0;

              if (!_context500.t0) {
                _context500.next = 14;
                break;
              }

              _context500.next = 13;
              return this.predictorService.remapPlayerIdMapToNative(n);

            case 13:
              _a21 = _context500.sent;

            case 14:
              e.forEach(function (o, l) {
                o.matchId = _r48[l], o instanceof Ri && o.prediction.playerId !== "OWN_GOAL" && (o.prediction.playerId = _a21[o.prediction.playerId]);
              });

            case 15:
              t.fixtures = e;
              _context500.next = 18;
              return this.predictorHttps.makeFootballPrediction(t);

            case 18:
              return _context500.abrupt("return", _context500.sent);

            case 19:
            case "end":
              return _context500.stop();
          }
        }
      }, _callee499, this);
    }));
  });
  s(this, "delete", function (t) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee500() {
      return _regeneratorRuntime.wrap(function _callee500$(_context501) {
        while (1) {
          switch (_context501.prev = _context501.next) {
            case 0:
              _context501.next = 2;
              return this.predictorHttps.deleteFootballPrediction(t);

            case 2:
              return _context501.abrupt("return", _context501.sent);

            case 3:
            case "end":
              return _context501.stop();
          }
        }
      }, _callee500, this);
    }));
  });
  s(this, "getGames", function (t, e) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee501() {
      var i, n;
      return _regeneratorRuntime.wrap(function _callee501$(_context502) {
        while (1) {
          switch (_context502.prev = _context502.next) {
            case 0:
              e = e || !1;
              i = this.predictorService.initGameFilters("MATCH_QUIZ", t);
              _context502.next = 4;
              return this.predictorHttps.getGames(i, e);

            case 4:
              n = _context502.sent;
              _context502.next = 7;
              return this.predictorService.remapMatchIdsFixtures(n);

            case 7:
              return _context502.abrupt("return", _context502.sent);

            case 8:
            case "end":
              return _context502.stop();
          }
        }
      }, _callee501, this);
    }));
  });
  s(this, "getGameById", function (t, e) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee502() {
      var i;
      return _regeneratorRuntime.wrap(function _callee502$(_context503) {
        while (1) {
          switch (_context503.prev = _context503.next) {
            case 0:
              e = e || !1;
              _context503.next = 3;
              return this.predictorHttps.getGameById(t, e);

            case 3:
              i = _context503.sent;
              _context503.next = 6;
              return this.predictorService.remapMatchIdsFixtures(i);

            case 6:
              return _context503.abrupt("return", _context503.sent);

            case 7:
            case "end":
              return _context503.stop();
          }
        }
      }, _callee502, this);
    }));
  });
  s(this, "getGamePredictions", function (t, e, i) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee503() {
      return _regeneratorRuntime.wrap(function _callee503$(_context504) {
        while (1) {
          switch (_context504.prev = _context504.next) {
            case 0:
              i = i || !1;
              e && (e.type && delete e.type, e.status && delete e.status, e = new rt(e));
              _context504.next = 4;
              return this.predictorHttps.getGamePredictions(t, i, e);

            case 4:
              return _context504.abrupt("return", _context504.sent);

            case 5:
            case "end":
              return _context504.stop();
          }
        }
      }, _callee503, this);
    }));
  });
  s(this, "getGameResults", function (t, e, i) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee504() {
      var n;
      return _regeneratorRuntime.wrap(function _callee504$(_context505) {
        while (1) {
          switch (_context505.prev = _context505.next) {
            case 0:
              i = i || !1, e && (e = new ms(e));
              _context505.next = 3;
              return this.predictorHttps.getGameResults(t, i, e);

            case 3:
              n = _context505.sent;
              _context505.next = 6;
              return this.predictorService.remapMatchIdsFixtures(n);

            case 6:
              return _context505.abrupt("return", _context505.sent);

            case 7:
            case "end":
              return _context505.stop();
          }
        }
      }, _callee504, this);
    }));
  });
  s(this, "getCurrentGameResults", function (t) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee505() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee505$(_context506) {
        while (1) {
          switch (_context506.prev = _context506.next) {
            case 0:
              t = t || !1;
              e = {
                status: "OPEN",
                type: "MATCH_QUIZ"
              };
              e = new Qt(e);
              _context506.next = 5;
              return this.predictorHttps.getGames(e, t);

            case 5:
              i = _context506.sent;
              n = this.predictorService.getCurrentGameId(i);
              _context506.next = 9;
              return this.getGameResults(n, null, t);

            case 9:
              return _context506.abrupt("return", _context506.sent.data[0]);

            case 10:
            case "end":
              return _context506.stop();
          }
        }
      }, _callee505, this);
    }));
  });
  s(this, "getMyGameEditions", function (t, e) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee506() {
      var i, n, r, _a22, _o21;

      return _regeneratorRuntime.wrap(function _callee506$(_context507) {
        while (1) {
          switch (_context507.prev = _context507.next) {
            case 0:
              t && t.limit && this.validateLimitFilterOnGames(t.limit), e = e || !1;
              i = this.predictorService.initGameTypePredictions("MATCH_QUIZ", t);
              n = [];
              _context507.next = 5;
              return this.predictorHttps.getMyPredictionsNoRemap(i);

            case 5:
              r = _context507.sent;

              if (!(r.data.length > 0)) {
                _context507.next = 17;
                break;
              }

              r.data.forEach(function (l) {
                l.game_instance_id && n.push(l.game_instance_id);
              });
              _a22 = this.predictorService.initGameFilters("MATCH_QUIZ", null, n);
              _context507.next = 11;
              return this.predictorHttps.getUserGameEditions(_a22, e);

            case 11:
              _o21 = _context507.sent;
              _context507.next = 14;
              return this.predictorService.addPredictionProp(r, _o21);

            case 14:
              return _context507.abrupt("return", _context507.sent);

            case 17:
              return _context507.abrupt("return", new qe());

            case 18:
            case "end":
              return _context507.stop();
          }
        }
      }, _callee506, this);
    }));
  });
  s(this, "getMyGamePrediction", function (t) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee507() {
      var e, i, n;
      return _regeneratorRuntime.wrap(function _callee507$(_context508) {
        while (1) {
          switch (_context508.prev = _context508.next) {
            case 0:
              e = this.predictorService.initGameTypePredictions("MATCH_QUIZ");
              _context508.next = 3;
              return this.predictorHttps.getMyPredictions(e);

            case 3:
              i = _context508.sent;

              if (!(i.data.length > 0)) {
                _context508.next = 7;
                break;
              }

              n = i.data.filter(function (r) {
                return r.gameInstanceId === t;
              });
              return _context508.abrupt("return", n.length ? n[0] : null);

            case 7:
              return _context508.abrupt("return", null);

            case 8:
            case "end":
              return _context508.stop();
          }
        }
      }, _callee507, this);
    }));
  });
  s(this, "getUserGameEditions", function (t, e, i) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee508() {
      var n, r, a, _o22, _l18;

      return _regeneratorRuntime.wrap(function _callee508$(_context509) {
        while (1) {
          switch (_context509.prev = _context509.next) {
            case 0:
              e && e.limit && this.validateLimitFilterOnGames(e.limit), i = i || !1;
              n = this.predictorService.initGameTypePredictions("MATCH_QUIZ", e);
              r = [];
              _context509.next = 5;
              return this.predictorHttps.getUserPredictionsNoRemap(t, n);

            case 5:
              a = _context509.sent;

              if (!(a.data.length > 0)) {
                _context509.next = 17;
                break;
              }

              a.data.forEach(function (c) {
                c.game_instance_id && r.push(c.game_instance_id);
              });
              _o22 = this.predictorService.initGameFilters("MATCH_QUIZ", null, r);
              _context509.next = 11;
              return this.predictorHttps.getUserGameEditions(_o22, i);

            case 11:
              _l18 = _context509.sent;
              _context509.next = 14;
              return this.predictorService.addPredictionProp(a, _l18);

            case 14:
              return _context509.abrupt("return", _context509.sent);

            case 17:
              return _context509.abrupt("return", new qe());

            case 18:
            case "end":
              return _context509.stop();
          }
        }
      }, _callee508, this);
    }));
  });
  s(this, "getUserGamePrediction", function (t, e, i) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee509() {
      var n, r, _a23;

      return _regeneratorRuntime.wrap(function _callee509$(_context510) {
        while (1) {
          switch (_context510.prev = _context510.next) {
            case 0:
              i = i || !1;
              n = this.predictorService.initGameTypePredictions("MATCH_QUIZ");
              _context510.next = 4;
              return this.predictorHttps.getUserPredictions(t, i, n);

            case 4:
              r = _context510.sent;

              if (!(r.data.length > 0)) {
                _context510.next = 10;
                break;
              }

              _a23 = r.data.filter(function (o) {
                return o.gameInstanceId === e;
              });
              return _context510.abrupt("return", _a23.length ? _a23[0] : null);

            case 10:
              return _context510.abrupt("return", null);

            case 11:
            case "end":
              return _context510.stop();
          }
        }
      }, _callee509, this);
    }));
  });
  s(this, "getMarketsResultsForGame", function (t, e) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee510() {
      var i;
      return _regeneratorRuntime.wrap(function _callee510$(_context511) {
        while (1) {
          switch (_context511.prev = _context511.next) {
            case 0:
              _context511.next = 2;
              return this.predictorHttps.getMarketResultsForGame(t, e);

            case 2:
              i = _context511.sent;
              _context511.next = 5;
              return this.predictorService.completeGameMarketResults(i, "MATCH_QUIZ");

            case 5:
              return _context511.abrupt("return", _context511.sent);

            case 6:
            case "end":
              return _context511.stop();
          }
        }
      }, _callee510, this);
    }));
  });
  s(this, "getGameWinners", function (t) {
    return u(_this174, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee511() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee511$(_context512) {
        while (1) {
          switch (_context512.prev = _context512.next) {
            case 0:
              _context512.next = 2;
              return this.predictorHttps.getContestWinners(t);

            case 2:
              e = _context512.sent;
              _context512.next = 5;
              return this.getGameById(t);

            case 5:
              i = _context512.sent;
              return _context512.abrupt("return", (e.contestModel = i, this.predictorService.completeContestWinners(e)));

            case 7:
            case "end":
              return _context512.stop();
          }
        }
      }, _callee511, this);
    }));
  });
  s(this, "validateLimitFilterOnGames", function (t) {
    if (_this174.errorHandlingMode === "default" && t > 50) throw new Se(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
    if (_this174.errorHandlingMode === "standard" && t > 50) throw new ue(400, "EXCEEDED_LENGTH", "Maximum limit for filtering games is 50 or less.");
  });
  this.predictorValidator = new Mo(t.errorHandlingMode), this.idMapping = new Tt(t), this.predictorHttps = new ys(t, this.idMapping), this.predictorService = new gs(t, this.idMapping), this.clientHttps = new Ni(t), this.errorHandlingMode = t.errorHandlingMode;
},
    nP =
/*#__PURE__*/
function () {
  function nP(t) {
    _classCallCheck(this, nP);

    s(this, "market");
    s(this, "fromDate");
    s(this, "toDate");
    s(this, "usersCount");
    s(this, "minimumPredictions");
    this.market = t.market ? t.market : null, this.fromDate = t.fromDate ? t.fromDate : null, this.toDate = t.toDate ? t.toDate : null, this.usersCount = t.usersCount ? t.usersCount : null, this.minimumPredictions = t.minimumPredictions ? t.minimumPredictions : null;
  }

  _createClass(nP, [{
    key: "constructFiltersUrl",
    value: function constructFiltersUrl() {
      var t = "";
      return this.market && (t += "&", t += "market=".concat(this.market)), this.fromDate && (t += "&", t += "from_date=".concat(this.fromDate)), this.toDate && (t += "&", t += "to_date=".concat(this.toDate)), this.usersCount && (t += "&", t += "users_count=".concat(this.usersCount)), this.minimumPredictions && (t += "&", t += "minimum_predictions=".concat(this.minimumPredictions)), t;
    }
  }]);

  return nP;
}(),
    rP =
/*#__PURE__*/
function () {
  function rP(t) {
    _classCallCheck(this, rP);

    s(this, "flags", null);
    s(this, "status", null);
    s(this, "type", null);
    s(this, "activeFrom", null);
    s(this, "activeTo", null);
    s(this, "createdFrom", null);
    s(this, "createdTo", null);
    s(this, "updatedFrom", null);
    s(this, "updatedTo", null);
    this.flags = t.flags ? t.flags : null, this.status = t.status ? t.status : null, this.type = t.type ? t.type : null, this.activeFrom = t.activeFrom ? t.activeFrom : null, this.activeTo = t.activeTo ? t.activeTo : null, this.createdFrom = t.createdFrom ? t.createdFrom : null, this.createdTo = t.createdTo ? t.createdTo : null, this.updatedFrom = t.updatedFrom ? t.updatedFrom : null, this.updatedTo = t.updatedTo ? t.updatedTo : null;
  }

  _createClass(rP, [{
    key: "constructFiltersUrl",
    value: function constructFiltersUrl() {
      var t = "";
      return this.flags && (t += "&", t += "flags=".concat(this.flags)), this.status && (t += "&", t += "status=".concat(this.status)), this.type && (t += "&", t += "type=".concat(this.type)), this.activeFrom && (t += "&", t += "active_from=".concat(this.activeFrom)), this.activeTo && (t += "&", t += "active_to=".concat(this.activeTo)), this.createdFrom && (t += "&", t += "created_from=".concat(this.createdFrom)), this.createdTo && (t += "&", t += "created_to=".concat(this.createdTo)), this.updatedFrom && (t += "&", t += "updated_from=".concat(this.updatedFrom)), this.updatedTo && (t += "&", t += "updated_to=".concat(this.updatedTo)), t;
    }
  }]);

  return rP;
}(),
    sP = function sP(t, e, i, n, r) {
  var _this176 = this;

  _classCallCheck(this, sP);

  s(this, "config", null);
  s(this, "clientHttps", null);
  s(this, "loyaltyHttps", null);
  s(this, "loyaltyService", null);
  s(this, "profileFacade", null);
  s(this, "loyaltyValidator", null);
  s(this, "idMapping", null);
  s(this, "topXFacade", null);
  s(this, "matchQuizFacade", null);
  s(this, "predictorHttps", null);
  s(this, "errorHandlingMode", null);
  s(this, "getConfig", function () {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee512() {
      return _regeneratorRuntime.wrap(function _callee512$(_context513) {
        while (1) {
          switch (_context513.prev = _context513.next) {
            case 0:
              _context513.next = 2;
              return this.clientHttps.getConfig("loyalty");

            case 2:
              return _context513.abrupt("return", _context513.sent);

            case 3:
            case "end":
              return _context513.stop();
          }
        }
      }, _callee512, this);
    }));
  });
  s(this, "getClientBadges", function () {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee513() {
      var t;
      return _regeneratorRuntime.wrap(function _callee513$(_context514) {
        while (1) {
          switch (_context514.prev = _context514.next) {
            case 0:
              _context514.next = 2;
              return this.getConfig();

            case 2:
              t = _context514.sent;
              return _context514.abrupt("return", this.loyaltyService.buildClientBadges(t.rewards.badges));

            case 4:
            case "end":
              return _context514.stop();
          }
        }
      }, _callee513, this);
    }));
  });
  s(this, "getTemplates", function (t, e) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee514() {
      var i;
      return _regeneratorRuntime.wrap(function _callee514$(_context515) {
        while (1) {
          switch (_context515.prev = _context515.next) {
            case 0:
              if (!(t && (t = new rP(t)), this.config.idSchema === "native")) {
                _context515.next = 4;
                break;
              }

              _context515.next = 3;
              return this.loyaltyHttps.getTemplates(t, e);

            case 3:
              return _context515.abrupt("return", _context515.sent);

            case 4:
              _context515.next = 6;
              return this.loyaltyHttps.getTemplates(t, e);

            case 6:
              i = _context515.sent;
              _context515.next = 9;
              return this.loyaltyService.remapTemplatesIds(_toConsumableArray(i.data));

            case 9:
              i.data = _context515.sent;
              return _context515.abrupt("return", i);

            case 11:
            case "end":
              return _context515.stop();
          }
        }
      }, _callee514, this);
    }));
  });
  s(this, "getTemplateById", function (t, e) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee515() {
      var i;
      return _regeneratorRuntime.wrap(function _callee515$(_context516) {
        while (1) {
          switch (_context516.prev = _context516.next) {
            case 0:
              _context516.next = 2;
              return this.loyaltyHttps.getTemplateById(t, e);

            case 2:
              i = _context516.sent;

              if (!(this.config.idSchema === "native")) {
                _context516.next = 7;
                break;
              }

              _context516.t0 = i;
              _context516.next = 10;
              break;

            case 7:
              _context516.next = 9;
              return this.loyaltyService.remapTemplatesIds([i]);

            case 9:
              _context516.t0 = _context516.sent[0];

            case 10:
              return _context516.abrupt("return", _context516.t0);

            case 11:
            case "end":
              return _context516.stop();
          }
        }
      }, _callee515, this);
    }));
  });
  s(this, "getLeaderboard", function (t, e, i) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee516() {
      var n;
      return _regeneratorRuntime.wrap(function _callee516$(_context517) {
        while (1) {
          switch (_context517.prev = _context517.next) {
            case 0:
              e = this.loyaltyService.initFilters(e, "loyalty");
              _context517.next = 3;
              return this.loyaltyHttps.getLeaderboard(t, i, e);

            case 3:
              n = _context517.sent;
              _context517.next = 6;
              return this.loyaltyService.addProfileModelToLeaderboad(n.data);

            case 6:
              n.data = _context517.sent;
              return _context517.abrupt("return", n);

            case 8:
            case "end":
              return _context517.stop();
          }
        }
      }, _callee516, this);
    }));
  });
  s(this, "getLeaderboardForGame", function (t, e, i) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee517() {
      var n;
      return _regeneratorRuntime.wrap(function _callee517$(_context518) {
        while (1) {
          switch (_context518.prev = _context518.next) {
            case 0:
              e = this.loyaltyService.initFilters(e, "loyalty");
              _context518.next = 3;
              return this.loyaltyHttps.getLeaderboardForGame(t, i, e);

            case 3:
              n = _context518.sent;
              _context518.next = 6;
              return this.loyaltyService.addProfileModelToLeaderboad(n.data);

            case 6:
              n.data = _context518.sent;
              return _context518.abrupt("return", n);

            case 8:
            case "end":
              return _context518.stop();
          }
        }
      }, _callee517, this);
    }));
  });
  s(this, "getOwnRankings", function (t, e) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee518() {
      var _ref75, i;

      return _regeneratorRuntime.wrap(function _callee518$(_context519) {
        while (1) {
          switch (_context519.prev = _context519.next) {
            case 0:
              _context519.next = 2;
              return this.profileFacade.getOwn();

            case 2:
              _ref75 = _context519.sent;
              i = _ref75.id;
              return _context519.abrupt("return", this.getUserRankings(i, t, e));

            case 5:
            case "end":
              return _context519.stop();
          }
        }
      }, _callee518, this);
    }));
  });
  s(this, "getUserRankings", function (t, e, i) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee519() {
      var n;
      return _regeneratorRuntime.wrap(function _callee519$(_context520) {
        while (1) {
          switch (_context520.prev = _context520.next) {
            case 0:
              e = this.loyaltyService.initFilters(e, "rankings");
              _context520.next = 3;
              return this.loyaltyHttps.getUserRankings(t, e, i);

            case 3:
              n = _context520.sent;
              _context520.next = 6;
              return this.getModelsForUserRankings(n);

            case 6:
              return _context520.abrupt("return", _context520.sent);

            case 7:
            case "end":
              return _context520.stop();
          }
        }
      }, _callee519, this);
    }));
  });
  s(this, "getHighestSuccessRate", function (t, e) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee520() {
      var i;
      return _regeneratorRuntime.wrap(function _callee520$(_context521) {
        while (1) {
          switch (_context521.prev = _context521.next) {
            case 0:
              t && (t = new nP(t), this.loyaltyValidator.validate(t, this.errorHandlingMode));
              _context521.next = 3;
              return this.loyaltyHttps.getHighestSuccessRate(t, e);

            case 3:
              i = _context521.sent;
              return _context521.abrupt("return", this.loyaltyService.addProfileModelToHighestSuccessRate(i));

            case 5:
            case "end":
              return _context521.stop();
          }
        }
      }, _callee520, this);
    }));
  });
  s(this, "getTemplateWinners", function (t) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee521() {
      var e, i;
      return _regeneratorRuntime.wrap(function _callee521$(_context522) {
        while (1) {
          switch (_context522.prev = _context522.next) {
            case 0:
              _context522.next = 2;
              return this.predictorHttps.getContestWinners(t);

            case 2:
              e = _context522.sent;
              _context522.next = 5;
              return this.getTemplateById(t);

            case 5:
              i = _context522.sent;
              return _context522.abrupt("return", (e.contestModel = i, this.loyaltyService.completeContestWinners(e)));

            case 7:
            case "end":
              return _context522.stop();
          }
        }
      }, _callee521, this);
    }));
  });
  s(this, "getEntitiesFollows", function (t, e) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee522() {
      var i;
      return _regeneratorRuntime.wrap(function _callee522$(_context523) {
        while (1) {
          switch (_context523.prev = _context523.next) {
            case 0:
              this.loyaltyService.validateEntitiesFollowsFilters(t);
              _context523.t0 = this.config.idSchema !== "native";

              if (!_context523.t0) {
                _context523.next = 6;
                break;
              }

              _context523.next = 5;
              return this.loyaltyService.remapEntitiesFollowsFilters(t);

            case 5:
              t = _context523.sent;

            case 6:
              _context523.next = 8;
              return this.loyaltyHttps.getEntitiesFollows(t, e);

            case 8:
              i = _context523.sent;
              _context523.next = 11;
              return this.loyaltyService.addModelsToEntitiesFollows(i);

            case 11:
              return _context523.abrupt("return", _context523.sent);

            case 12:
            case "end":
              return _context523.stop();
          }
        }
      }, _callee522, this);
    }));
  });
  s(this, "getModelsForUserRankings", function (t) {
    return u(_this176, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee523() {
      var e, i, n, _this$loyaltyService$, _this$loyaltyService$2, r, a, o, _l19, _l20;

      return _regeneratorRuntime.wrap(function _callee523$(_context524) {
        while (1) {
          switch (_context524.prev = _context524.next) {
            case 0:
              e = null, i = null, n = null, _this$loyaltyService$ = this.loyaltyService.extractRankingsIdsMap(t.data), _this$loyaltyService$2 = _slicedToArray(_this$loyaltyService$, 3), r = _this$loyaltyService$2[0], a = _this$loyaltyService$2[1], o = _this$loyaltyService$2[2];
              _context524.t0 = o.length;

              if (!_context524.t0) {
                _context524.next = 7;
                break;
              }

              _context524.next = 5;
              return this.getTemplates();

            case 5:
              _context524.t1 = function (l) {
                return o.includes(l.id);
              };

              e = _context524.sent.data.filter(_context524.t1);

            case 7:
              if (!r.length) {
                _context524.next = 12;
                break;
              }

              _l19 = {
                gameIds: r
              };
              _context524.next = 11;
              return this.topXFacade.getGames(_l19);

            case 11:
              i = _context524.sent.data;

            case 12:
              if (!a.length) {
                _context524.next = 17;
                break;
              }

              _l20 = {
                gameIds: a
              };
              _context524.next = 16;
              return this.matchQuizFacade.getGames(_l20);

            case 16:
              n = _context524.sent.data;

            case 17:
              return _context524.abrupt("return", this.loyaltyService.setModelsForUserRankings(i, n, e, t));

            case 18:
            case "end":
              return _context524.stop();
          }
        }
      }, _callee523, this);
    }));
  });
  this.config = t, this.clientHttps = e, this.loyaltyHttps = i, this.profileFacade = new ls(r, n), this.loyaltyService = new tP(this.config), this.loyaltyValidator = new iP(), this.idMapping = new Tt(t), this.topXFacade = new Tp(t, this.idMapping), this.matchQuizFacade = new Rp(t), this.predictorHttps = new ys(t, this.idMapping), this.errorHandlingMode = t.errorHandlingMode;
},
    aP = function aP(t) {
  var _this177 = this;

  _classCallCheck(this, aP);

  s(this, "clientHttps", null);
  s(this, "profileHttps", null);
  s(this, "loyaltyHttps", null);
  s(this, "loyaltyFacade", null);
  s(this, "localCache", null);
  s(this, "getConfig", function () {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee524() {
      return _regeneratorRuntime.wrap(function _callee524$(_context525) {
        while (1) {
          switch (_context525.prev = _context525.next) {
            case 0:
              _context525.next = 2;
              return this.loyaltyFacade.getConfig();

            case 2:
              return _context525.abrupt("return", _context525.sent);

            case 3:
            case "end":
              return _context525.stop();
          }
        }
      }, _callee524, this);
    }));
  });
  s(this, "getClientBadges", function () {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee525() {
      return _regeneratorRuntime.wrap(function _callee525$(_context526) {
        while (1) {
          switch (_context526.prev = _context526.next) {
            case 0:
              _context526.next = 2;
              return this.loyaltyFacade.getClientBadges();

            case 2:
              return _context526.abrupt("return", _context526.sent);

            case 3:
            case "end":
              return _context526.stop();
          }
        }
      }, _callee525, this);
    }));
  });
  s(this, "getTemplates", function (t, e) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee526() {
      return _regeneratorRuntime.wrap(function _callee526$(_context527) {
        while (1) {
          switch (_context527.prev = _context527.next) {
            case 0:
              _context527.next = 2;
              return this.loyaltyFacade.getTemplates(t, e);

            case 2:
              return _context527.abrupt("return", _context527.sent);

            case 3:
            case "end":
              return _context527.stop();
          }
        }
      }, _callee526, this);
    }));
  });
  s(this, "getTemplateById", function (t, e) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee527() {
      return _regeneratorRuntime.wrap(function _callee527$(_context528) {
        while (1) {
          switch (_context528.prev = _context528.next) {
            case 0:
              _context528.next = 2;
              return this.loyaltyFacade.getTemplateById(t, e);

            case 2:
              return _context528.abrupt("return", _context528.sent);

            case 3:
            case "end":
              return _context528.stop();
          }
        }
      }, _callee527, this);
    }));
  });
  s(this, "getLeaderboard", function (t, e, i) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee528() {
      return _regeneratorRuntime.wrap(function _callee528$(_context529) {
        while (1) {
          switch (_context529.prev = _context529.next) {
            case 0:
              _context529.next = 2;
              return this.loyaltyFacade.getLeaderboard(t, e, i);

            case 2:
              return _context529.abrupt("return", _context529.sent);

            case 3:
            case "end":
              return _context529.stop();
          }
        }
      }, _callee528, this);
    }));
  });
  s(this, "getLeaderboardForGame", function (t, e, i) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee529() {
      return _regeneratorRuntime.wrap(function _callee529$(_context530) {
        while (1) {
          switch (_context530.prev = _context530.next) {
            case 0:
              _context530.next = 2;
              return this.loyaltyFacade.getLeaderboardForGame(t, e, i);

            case 2:
              return _context530.abrupt("return", _context530.sent);

            case 3:
            case "end":
              return _context530.stop();
          }
        }
      }, _callee529, this);
    }));
  });
  s(this, "getOwnRankings", function (t, e) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee530() {
      return _regeneratorRuntime.wrap(function _callee530$(_context531) {
        while (1) {
          switch (_context531.prev = _context531.next) {
            case 0:
              _context531.next = 2;
              return this.loyaltyFacade.getOwnRankings(t, e);

            case 2:
              return _context531.abrupt("return", _context531.sent);

            case 3:
            case "end":
              return _context531.stop();
          }
        }
      }, _callee530, this);
    }));
  });
  s(this, "getUserRankings", function (t, e, i) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee531() {
      return _regeneratorRuntime.wrap(function _callee531$(_context532) {
        while (1) {
          switch (_context532.prev = _context532.next) {
            case 0:
              _context532.next = 2;
              return this.loyaltyFacade.getUserRankings(t, e, i);

            case 2:
              return _context532.abrupt("return", _context532.sent);

            case 3:
            case "end":
              return _context532.stop();
          }
        }
      }, _callee531, this);
    }));
  });
  s(this, "getHighestSuccessRate", function (t, e) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee532() {
      return _regeneratorRuntime.wrap(function _callee532$(_context533) {
        while (1) {
          switch (_context533.prev = _context533.next) {
            case 0:
              _context533.next = 2;
              return this.loyaltyFacade.getHighestSuccessRate(t, e);

            case 2:
              return _context533.abrupt("return", _context533.sent);

            case 3:
            case "end":
              return _context533.stop();
          }
        }
      }, _callee532, this);
    }));
  });
  s(this, "getTemplateWinners", function (t) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee533() {
      return _regeneratorRuntime.wrap(function _callee533$(_context534) {
        while (1) {
          switch (_context534.prev = _context534.next) {
            case 0:
              _context534.next = 2;
              return this.loyaltyFacade.getTemplateWinners(t);

            case 2:
              return _context534.abrupt("return", _context534.sent);

            case 3:
            case "end":
              return _context534.stop();
          }
        }
      }, _callee533, this);
    }));
  });
  s(this, "getEntitiesFollows", function (t, e) {
    return u(_this177, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee534() {
      return _regeneratorRuntime.wrap(function _callee534$(_context535) {
        while (1) {
          switch (_context535.prev = _context535.next) {
            case 0:
              _context535.next = 2;
              return this.loyaltyFacade.getEntitiesFollows(t, e);

            case 2:
              return _context535.abrupt("return", _context535.sent);

            case 3:
            case "end":
              return _context535.stop();
          }
        }
      }, _callee534, this);
    }));
  });
  this.clientHttps = new Ni(t), this.profileHttps = new Hh(t), this.loyaltyHttps = new XR(t), this.localCache = new Cn().createLocalCacheInstance(t.idSchema), this.loyaltyFacade = new sP(t, this.clientHttps, this.loyaltyHttps, this.profileHttps, this.localCache);
},
    oP = function oP(t) {
  var _this178 = this;

  _classCallCheck(this, oP);

  s(this, "topXFacade", null);
  s(this, "idMapping", null);
  s(this, "getConfig", function () {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee535() {
      return _regeneratorRuntime.wrap(function _callee535$(_context536) {
        while (1) {
          switch (_context536.prev = _context536.next) {
            case 0:
              _context536.next = 2;
              return this.topXFacade.getConfig();

            case 2:
              return _context536.abrupt("return", _context536.sent);

            case 3:
            case "end":
              return _context536.stop();
          }
        }
      }, _callee535, this);
    }));
  });
  s(this, "getGames", function (t, e) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee536() {
      return _regeneratorRuntime.wrap(function _callee536$(_context537) {
        while (1) {
          switch (_context537.prev = _context537.next) {
            case 0:
              _context537.next = 2;
              return this.topXFacade.getGames(t, e);

            case 2:
              return _context537.abrupt("return", _context537.sent);

            case 3:
            case "end":
              return _context537.stop();
          }
        }
      }, _callee536, this);
    }));
  });
  s(this, "getGameById", function (t, e) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee537() {
      return _regeneratorRuntime.wrap(function _callee537$(_context538) {
        while (1) {
          switch (_context538.prev = _context538.next) {
            case 0:
              _context538.next = 2;
              return this.topXFacade.getGameById(t, e);

            case 2:
              return _context538.abrupt("return", _context538.sent);

            case 3:
            case "end":
              return _context538.stop();
          }
        }
      }, _callee537, this);
    }));
  });
  s(this, "getGamePredictions", function (t, e, i) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee538() {
      return _regeneratorRuntime.wrap(function _callee538$(_context539) {
        while (1) {
          switch (_context539.prev = _context539.next) {
            case 0:
              _context539.next = 2;
              return this.topXFacade.getGamePredictions(t, e, i);

            case 2:
              return _context539.abrupt("return", _context539.sent);

            case 3:
            case "end":
              return _context539.stop();
          }
        }
      }, _callee538, this);
    }));
  });
  s(this, "getGameResults", function (t, e, i) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee539() {
      return _regeneratorRuntime.wrap(function _callee539$(_context540) {
        while (1) {
          switch (_context540.prev = _context540.next) {
            case 0:
              _context540.next = 2;
              return this.topXFacade.getGameResults(t, e, i);

            case 2:
              return _context540.abrupt("return", _context540.sent);

            case 3:
            case "end":
              return _context540.stop();
          }
        }
      }, _callee539, this);
    }));
  });
  s(this, "getCurrentGameResults", function (t) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee540() {
      return _regeneratorRuntime.wrap(function _callee540$(_context541) {
        while (1) {
          switch (_context541.prev = _context541.next) {
            case 0:
              _context541.next = 2;
              return this.topXFacade.getCurrentGameResults(t);

            case 2:
              return _context541.abrupt("return", _context541.sent);

            case 3:
            case "end":
              return _context541.stop();
          }
        }
      }, _callee540, this);
    }));
  });
  s(this, "play", function (t) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee541() {
      return _regeneratorRuntime.wrap(function _callee541$(_context542) {
        while (1) {
          switch (_context542.prev = _context542.next) {
            case 0:
              _context542.next = 2;
              return this.topXFacade.play(t);

            case 2:
              return _context542.abrupt("return", _context542.sent);

            case 3:
            case "end":
              return _context542.stop();
          }
        }
      }, _callee541, this);
    }));
  });
  s(this, "delete", function (t) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee542() {
      return _regeneratorRuntime.wrap(function _callee542$(_context543) {
        while (1) {
          switch (_context543.prev = _context543.next) {
            case 0:
              _context543.next = 2;
              return this.topXFacade.delete(t);

            case 2:
              return _context543.abrupt("return", _context543.sent);

            case 3:
            case "end":
              return _context543.stop();
          }
        }
      }, _callee542, this);
    }));
  });
  s(this, "getMyGameEditions", function (t, e) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee543() {
      return _regeneratorRuntime.wrap(function _callee543$(_context544) {
        while (1) {
          switch (_context544.prev = _context544.next) {
            case 0:
              _context544.next = 2;
              return this.topXFacade.getMyGameEditions(t, e);

            case 2:
              return _context544.abrupt("return", _context544.sent);

            case 3:
            case "end":
              return _context544.stop();
          }
        }
      }, _callee543, this);
    }));
  });
  s(this, "getMyGamePrediction", function (t) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee544() {
      return _regeneratorRuntime.wrap(function _callee544$(_context545) {
        while (1) {
          switch (_context545.prev = _context545.next) {
            case 0:
              _context545.next = 2;
              return this.topXFacade.getMyGamePrediction(t);

            case 2:
              return _context545.abrupt("return", _context545.sent);

            case 3:
            case "end":
              return _context545.stop();
          }
        }
      }, _callee544, this);
    }));
  });
  s(this, "getUserGameEditions", function (t, e, i) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee545() {
      return _regeneratorRuntime.wrap(function _callee545$(_context546) {
        while (1) {
          switch (_context546.prev = _context546.next) {
            case 0:
              _context546.next = 2;
              return this.topXFacade.getUserGameEditions(t, e, i);

            case 2:
              return _context546.abrupt("return", _context546.sent);

            case 3:
            case "end":
              return _context546.stop();
          }
        }
      }, _callee545, this);
    }));
  });
  s(this, "getUserGamePrediction", function (t, e, i) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee546() {
      return _regeneratorRuntime.wrap(function _callee546$(_context547) {
        while (1) {
          switch (_context547.prev = _context547.next) {
            case 0:
              _context547.next = 2;
              return this.topXFacade.getUserGamePrediction(t, e, i);

            case 2:
              return _context547.abrupt("return", _context547.sent);

            case 3:
            case "end":
              return _context547.stop();
          }
        }
      }, _callee546, this);
    }));
  });
  s(this, "getMarketsResultsForGame", function (t, e) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee547() {
      return _regeneratorRuntime.wrap(function _callee547$(_context548) {
        while (1) {
          switch (_context548.prev = _context548.next) {
            case 0:
              _context548.next = 2;
              return this.topXFacade.getMarketsResultsForGame(t, e);

            case 2:
              return _context548.abrupt("return", _context548.sent);

            case 3:
            case "end":
              return _context548.stop();
          }
        }
      }, _callee547, this);
    }));
  });
  s(this, "getGameWinners", function (t) {
    return u(_this178, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee548() {
      return _regeneratorRuntime.wrap(function _callee548$(_context549) {
        while (1) {
          switch (_context549.prev = _context549.next) {
            case 0:
              _context549.next = 2;
              return this.topXFacade.getGameWinners(t);

            case 2:
              return _context549.abrupt("return", _context549.sent);

            case 3:
            case "end":
              return _context549.stop();
          }
        }
      }, _callee548, this);
    }));
  });
  this.idMapping = new Tt(t), this.topXFacade = new Tp(t, this.idMapping);
},
    lP = function lP(t) {
  var _this179 = this;

  _classCallCheck(this, lP);

  s(this, "matchQuizFacade", null);
  s(this, "getConfig", function () {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee549() {
      return _regeneratorRuntime.wrap(function _callee549$(_context550) {
        while (1) {
          switch (_context550.prev = _context550.next) {
            case 0:
              _context550.next = 2;
              return this.matchQuizFacade.getConfig();

            case 2:
              return _context550.abrupt("return", _context550.sent);

            case 3:
            case "end":
              return _context550.stop();
          }
        }
      }, _callee549, this);
    }));
  });
  s(this, "play", function (t) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee550() {
      return _regeneratorRuntime.wrap(function _callee550$(_context551) {
        while (1) {
          switch (_context551.prev = _context551.next) {
            case 0:
              _context551.next = 2;
              return this.matchQuizFacade.play(t);

            case 2:
              return _context551.abrupt("return", _context551.sent);

            case 3:
            case "end":
              return _context551.stop();
          }
        }
      }, _callee550, this);
    }));
  });
  s(this, "delete", function (t) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee551() {
      return _regeneratorRuntime.wrap(function _callee551$(_context552) {
        while (1) {
          switch (_context552.prev = _context552.next) {
            case 0:
              _context552.next = 2;
              return this.matchQuizFacade.delete(t);

            case 2:
              return _context552.abrupt("return", _context552.sent);

            case 3:
            case "end":
              return _context552.stop();
          }
        }
      }, _callee551, this);
    }));
  });
  s(this, "getGames", function (t, e) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee552() {
      return _regeneratorRuntime.wrap(function _callee552$(_context553) {
        while (1) {
          switch (_context553.prev = _context553.next) {
            case 0:
              _context553.next = 2;
              return this.matchQuizFacade.getGames(t, e);

            case 2:
              return _context553.abrupt("return", _context553.sent);

            case 3:
            case "end":
              return _context553.stop();
          }
        }
      }, _callee552, this);
    }));
  });
  s(this, "getGameById", function (t, e) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee553() {
      return _regeneratorRuntime.wrap(function _callee553$(_context554) {
        while (1) {
          switch (_context554.prev = _context554.next) {
            case 0:
              _context554.next = 2;
              return this.matchQuizFacade.getGameById(t, e);

            case 2:
              return _context554.abrupt("return", _context554.sent);

            case 3:
            case "end":
              return _context554.stop();
          }
        }
      }, _callee553, this);
    }));
  });
  s(this, "getGamePredictions", function (t, e, i) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee554() {
      return _regeneratorRuntime.wrap(function _callee554$(_context555) {
        while (1) {
          switch (_context555.prev = _context555.next) {
            case 0:
              _context555.next = 2;
              return this.matchQuizFacade.getGamePredictions(t, e, i);

            case 2:
              return _context555.abrupt("return", _context555.sent);

            case 3:
            case "end":
              return _context555.stop();
          }
        }
      }, _callee554, this);
    }));
  });
  s(this, "getGameResults", function (t, e, i) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee555() {
      return _regeneratorRuntime.wrap(function _callee555$(_context556) {
        while (1) {
          switch (_context556.prev = _context556.next) {
            case 0:
              _context556.next = 2;
              return this.matchQuizFacade.getGameResults(t, e, i);

            case 2:
              return _context556.abrupt("return", _context556.sent);

            case 3:
            case "end":
              return _context556.stop();
          }
        }
      }, _callee555, this);
    }));
  });
  s(this, "getCurrentGameResults", function (t) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee556() {
      return _regeneratorRuntime.wrap(function _callee556$(_context557) {
        while (1) {
          switch (_context557.prev = _context557.next) {
            case 0:
              _context557.next = 2;
              return this.matchQuizFacade.getCurrentGameResults(t);

            case 2:
              return _context557.abrupt("return", _context557.sent);

            case 3:
            case "end":
              return _context557.stop();
          }
        }
      }, _callee556, this);
    }));
  });
  s(this, "getMyGameEditions", function (t, e) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee557() {
      return _regeneratorRuntime.wrap(function _callee557$(_context558) {
        while (1) {
          switch (_context558.prev = _context558.next) {
            case 0:
              _context558.next = 2;
              return this.matchQuizFacade.getMyGameEditions(t, e);

            case 2:
              return _context558.abrupt("return", _context558.sent);

            case 3:
            case "end":
              return _context558.stop();
          }
        }
      }, _callee557, this);
    }));
  });
  s(this, "getMyGamePrediction", function (t) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee558() {
      return _regeneratorRuntime.wrap(function _callee558$(_context559) {
        while (1) {
          switch (_context559.prev = _context559.next) {
            case 0:
              _context559.next = 2;
              return this.matchQuizFacade.getMyGamePrediction(t);

            case 2:
              return _context559.abrupt("return", _context559.sent);

            case 3:
            case "end":
              return _context559.stop();
          }
        }
      }, _callee558, this);
    }));
  });
  s(this, "getUserGameEditions", function (t, e, i) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee559() {
      return _regeneratorRuntime.wrap(function _callee559$(_context560) {
        while (1) {
          switch (_context560.prev = _context560.next) {
            case 0:
              _context560.next = 2;
              return this.matchQuizFacade.getUserGameEditions(t, e, i);

            case 2:
              return _context560.abrupt("return", _context560.sent);

            case 3:
            case "end":
              return _context560.stop();
          }
        }
      }, _callee559, this);
    }));
  });
  s(this, "getUserGamePrediction", function (t, e, i) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee560() {
      return _regeneratorRuntime.wrap(function _callee560$(_context561) {
        while (1) {
          switch (_context561.prev = _context561.next) {
            case 0:
              _context561.next = 2;
              return this.matchQuizFacade.getUserGamePrediction(t, e, i);

            case 2:
              return _context561.abrupt("return", _context561.sent);

            case 3:
            case "end":
              return _context561.stop();
          }
        }
      }, _callee560, this);
    }));
  });
  s(this, "getMarketsResultsForGame", function (t, e) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee561() {
      return _regeneratorRuntime.wrap(function _callee561$(_context562) {
        while (1) {
          switch (_context562.prev = _context562.next) {
            case 0:
              _context562.next = 2;
              return this.matchQuizFacade.getMarketsResultsForGame(t, e);

            case 2:
              return _context562.abrupt("return", _context562.sent);

            case 3:
            case "end":
              return _context562.stop();
          }
        }
      }, _callee561, this);
    }));
  });
  s(this, "getGameWinners", function (t) {
    return u(_this179, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee562() {
      return _regeneratorRuntime.wrap(function _callee562$(_context563) {
        while (1) {
          switch (_context563.prev = _context563.next) {
            case 0:
              _context563.next = 2;
              return this.matchQuizFacade.getGameWinners(t);

            case 2:
              return _context563.abrupt("return", _context563.sent);

            case 3:
            case "end":
              return _context563.stop();
          }
        }
      }, _callee562, this);
    }));
  });
  this.matchQuizFacade = new Rp(t);
},
    Cc = function Cc(t, e, i, n) {
  _classCallCheck(this, Cc);

  s(this, "action", null);
  s(this, "context", new rp());
  this.action = t, this.context.tags = e, i && (this.context.content = i), n && (this.context.campaign = n);
},
    Pp = function Pp(t) {
  var _this180 = this;

  _classCallCheck(this, Pp);

  s(this, "idSchema");
  s(this, "idMapping");
  s(this, "remapTagsIds", function (t, e, i) {
    return u(_this180, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee563() {
      var n, r, a, o, _loop7, _i52, _Object$entries8, _ref77;

      return _regeneratorRuntime.wrap(function _callee563$(_context564) {
        while (1) {
          switch (_context564.prev = _context564.next) {
            case 0:
              if (!(!t || !t.length)) {
                _context564.next = 2;
                break;
              }

              return _context564.abrupt("return", t);

            case 2:
              n = {}, r = {}, a = [];
              t.forEach(function (l) {
                n.hasOwnProperty(l.type) || (n[l.type] = [], r[l.type] = []), n[l.type].push(l.id), r[l.type].push(l);
              });
              _context564.next = 6;
              return this.idMapping.idMappingFacade.getEntitiesByIds(n, e, i);

            case 6:
              o = _context564.sent;

              _loop7 = function _loop7() {
                var _ref76 = _Object$entries8[_i52];
                _ref77 = _slicedToArray(_ref76, 2);
                var l = _ref77[0];
                var c = _ref77[1];
                c.forEach(function (d, h) {
                  d.id = o[l][h], a.push(d);
                });
              };

              for (_i52 = 0, _Object$entries8 = Object.entries(r); _i52 < _Object$entries8.length; _i52++) {
                _loop7();
              }

              return _context564.abrupt("return", a);

            case 10:
            case "end":
              return _context564.stop();
          }
        }
      }, _callee563, this);
    }));
  });
  this.idSchema = t.idSchema, this.idMapping = new Tt(t);
},
    Op = function Op(t) {
  _classCallCheck(this, Op);

  s(this, "page", null);
  s(this, "limit", null);
  this.page = t.page ? t.page : null, this.limit = t.limit ? t.limit : null;
},
    cP =
/*#__PURE__*/
function (_Op) {
  _inherits(cP, _Op);

  function cP(e) {
    var _this181;

    _classCallCheck(this, cP);

    _this181 = _possibleConstructorReturn(this, _getPrototypeOf(cP).call(this, e));
    s(_assertThisInitialized(_this181), "action", null);
    _this181.action = e.action ? e.action : null;
    return _this181;
  }

  _createClass(cP, [{
    key: "constructFilterUrl",
    value: function constructFilterUrl() {
      var e = "";
      return this.action && (e += "&", e += "action=".concat(this.action)), this.page && (e += "&", e += "page=".concat(this.page)), this.limit && (e += "&", e += "limit=".concat(this.limit)), e;
    }
  }]);

  return cP;
}(Op),
    uP =
/*#__PURE__*/
function (_Op2) {
  _inherits(uP, _Op2);

  function uP(e) {
    var _this182;

    _classCallCheck(this, uP);

    _this182 = _possibleConstructorReturn(this, _getPrototypeOf(uP).call(this, e));
    s(_assertThisInitialized(_this182), "action", null);
    _this182.action = e.action ? e.action : null;
    return _this182;
  }

  _createClass(uP, [{
    key: "constructFilterUrl",
    value: function constructFilterUrl() {
      var e = "";
      return this.action && (e += "&", e += "action=".concat(this.action)), this.page && (e += "&", e += "page=".concat(this.page)), this.limit && (e += "&", e += "limit=".concat(this.limit)), e;
    }
  }]);

  return uP;
}(Op),
    dP = function dP(t) {
  var _this183 = this;

  _classCallCheck(this, dP);

  s(this, "idSchema");
  s(this, "activityHttps");
  s(this, "activityService");
  s(this, "add", function (t, e, i, n) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee564() {
      var _a24, _o23, _l21, c, r;

      return _regeneratorRuntime.wrap(function _callee564$(_context565) {
        while (1) {
          switch (_context565.prev = _context565.next) {
            case 0:
              if (!(this.idSchema != "native")) {
                _context565.next = 10;
                break;
              }

              _a24 = JSON.parse(JSON.stringify(e));
              _context565.next = 4;
              return this.activityService.remapTagsIds(e, this.idSchema, "native");

            case 4:
              _o23 = _context565.sent;
              _l21 = new Cc(t, _o23, i, n);
              _context565.next = 8;
              return this.activityHttps.createActivity(_l21);

            case 8:
              c = _context565.sent;
              return _context565.abrupt("return", (c.context.tags = _a24, c));

            case 10:
              r = new Cc(t, e, i, n);
              return _context565.abrupt("return", this.activityHttps.createActivity(r));

            case 12:
            case "end":
              return _context565.stop();
          }
        }
      }, _callee564, this);
    }));
  });
  s(this, "delete", function (t) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee565() {
      return _regeneratorRuntime.wrap(function _callee565$(_context566) {
        while (1) {
          switch (_context566.prev = _context566.next) {
            case 0:
              _context566.next = 2;
              return this.activityHttps.deleteActivity(t);

            case 2:
              return _context566.abrupt("return", _context566.sent);

            case 3:
            case "end":
              return _context566.stop();
          }
        }
      }, _callee565, this);
    }));
  });
  s(this, "like", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee566() {
      var n;
      return _regeneratorRuntime.wrap(function _callee566$(_context567) {
        while (1) {
          switch (_context567.prev = _context567.next) {
            case 0:
              n = "like";
              _context567.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context567.abrupt("return", _context567.sent);

            case 4:
            case "end":
              return _context567.stop();
          }
        }
      }, _callee566, this);
    }));
  });
  s(this, "dislike", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee567() {
      var n;
      return _regeneratorRuntime.wrap(function _callee567$(_context568) {
        while (1) {
          switch (_context568.prev = _context568.next) {
            case 0:
              n = "dislike";
              _context568.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context568.abrupt("return", _context568.sent);

            case 4:
            case "end":
              return _context568.stop();
          }
        }
      }, _callee567, this);
    }));
  });
  s(this, "addPageview", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee568() {
      var n;
      return _regeneratorRuntime.wrap(function _callee568$(_context569) {
        while (1) {
          switch (_context569.prev = _context569.next) {
            case 0:
              n = "page_view";
              _context569.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context569.abrupt("return", _context569.sent);

            case 4:
            case "end":
              return _context569.stop();
          }
        }
      }, _callee568, this);
    }));
  });
  s(this, "addContentConsumed", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee569() {
      var n;
      return _regeneratorRuntime.wrap(function _callee569$(_context570) {
        while (1) {
          switch (_context570.prev = _context570.next) {
            case 0:
              n = "content_consumed";
              _context570.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context570.abrupt("return", _context570.sent);

            case 4:
            case "end":
              return _context570.stop();
          }
        }
      }, _callee569, this);
    }));
  });
  s(this, "addShare", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee570() {
      var n;
      return _regeneratorRuntime.wrap(function _callee570$(_context571) {
        while (1) {
          switch (_context571.prev = _context571.next) {
            case 0:
              n = "share";
              _context571.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context571.abrupt("return", _context571.sent);

            case 4:
            case "end":
              return _context571.stop();
          }
        }
      }, _callee570, this);
    }));
  });
  s(this, "addComment", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee571() {
      var n;
      return _regeneratorRuntime.wrap(function _callee571$(_context572) {
        while (1) {
          switch (_context572.prev = _context572.next) {
            case 0:
              n = "comment";
              _context572.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context572.abrupt("return", _context572.sent);

            case 4:
            case "end":
              return _context572.stop();
          }
        }
      }, _callee571, this);
    }));
  });
  s(this, "addClickAd", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee572() {
      var n;
      return _regeneratorRuntime.wrap(function _callee572$(_context573) {
        while (1) {
          switch (_context573.prev = _context573.next) {
            case 0:
              n = "click_ad";
              _context573.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context573.abrupt("return", _context573.sent);

            case 4:
            case "end":
              return _context573.stop();
          }
        }
      }, _callee572, this);
    }));
  });
  s(this, "addConversion", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee573() {
      var n;
      return _regeneratorRuntime.wrap(function _callee573$(_context574) {
        while (1) {
          switch (_context574.prev = _context574.next) {
            case 0:
              n = "conversion";
              _context574.next = 3;
              return this.add(n, t, e, i);

            case 3:
              return _context574.abrupt("return", _context574.sent);

            case 4:
            case "end":
              return _context574.stop();
          }
        }
      }, _callee573, this);
    }));
  });
  s(this, "getOwn", function (t, e) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee574() {
      var i, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _iterator23, _step23, n;

      return _regeneratorRuntime.wrap(function _callee574$(_context575) {
        while (1) {
          switch (_context575.prev = _context575.next) {
            case 0:
              if (!(e = e || !1, t && (t = new cP(t)), this.idSchema != "native")) {
                _context575.next = 31;
                break;
              }

              _context575.next = 3;
              return this.activityHttps.getOwnActivities(t, e);

            case 3:
              i = _context575.sent;
              _iteratorNormalCompletion23 = true;
              _didIteratorError23 = false;
              _iteratorError23 = undefined;
              _context575.prev = 7;
              _iterator23 = i.data[Symbol.iterator]();

            case 9:
              if (_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done) {
                _context575.next = 16;
                break;
              }

              n = _step23.value;
              _context575.next = 13;
              return this.activityService.remapTagsIds(n.context.tags, "native", this.idSchema);

            case 13:
              _iteratorNormalCompletion23 = true;
              _context575.next = 9;
              break;

            case 16:
              _context575.next = 22;
              break;

            case 18:
              _context575.prev = 18;
              _context575.t0 = _context575["catch"](7);
              _didIteratorError23 = true;
              _iteratorError23 = _context575.t0;

            case 22:
              _context575.prev = 22;
              _context575.prev = 23;

              if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
                _iterator23.return();
              }

            case 25:
              _context575.prev = 25;

              if (!_didIteratorError23) {
                _context575.next = 28;
                break;
              }

              throw _iteratorError23;

            case 28:
              return _context575.finish(25);

            case 29:
              return _context575.finish(22);

            case 30:
              return _context575.abrupt("return", i);

            case 31:
              _context575.next = 33;
              return this.activityHttps.getOwnActivities(t, e);

            case 33:
              return _context575.abrupt("return", _context575.sent);

            case 34:
            case "end":
              return _context575.stop();
          }
        }
      }, _callee574, this, [[7, 18, 22, 30], [23,, 25, 29]]);
    }));
  });
  s(this, "getForUser", function (t, e, i) {
    return u(_this183, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee575() {
      var n, _r49, _iteratorNormalCompletion24, _didIteratorError24, _iteratorError24, _iterator24, _step24, _a25;

      return _regeneratorRuntime.wrap(function _callee575$(_context576) {
        while (1) {
          switch (_context576.prev = _context576.next) {
            case 0:
              if (!(i = i || !1, e && (e = new uP(e)), this.idSchema != "native")) {
                _context576.next = 32;
                break;
              }

              _context576.next = 3;
              return this.activityHttps.getActivitiesForUser(t, e, i);

            case 3:
              n = _context576.sent;
              _r49 = JSON.parse(JSON.stringify(n));
              _iteratorNormalCompletion24 = true;
              _didIteratorError24 = false;
              _iteratorError24 = undefined;
              _context576.prev = 8;
              _iterator24 = _r49.data[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done) {
                _context576.next = 17;
                break;
              }

              _a25 = _step24.value;
              _context576.next = 14;
              return this.activityService.remapTagsIds(_toConsumableArray(_a25.context.tags), "native", this.idSchema);

            case 14:
              _iteratorNormalCompletion24 = true;
              _context576.next = 10;
              break;

            case 17:
              _context576.next = 23;
              break;

            case 19:
              _context576.prev = 19;
              _context576.t0 = _context576["catch"](8);
              _didIteratorError24 = true;
              _iteratorError24 = _context576.t0;

            case 23:
              _context576.prev = 23;
              _context576.prev = 24;

              if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
                _iterator24.return();
              }

            case 26:
              _context576.prev = 26;

              if (!_didIteratorError24) {
                _context576.next = 29;
                break;
              }

              throw _iteratorError24;

            case 29:
              return _context576.finish(26);

            case 30:
              return _context576.finish(23);

            case 31:
              return _context576.abrupt("return", _r49);

            case 32:
              _context576.next = 34;
              return this.activityHttps.getActivitiesForUser(t, e, i);

            case 34:
              return _context576.abrupt("return", _context576.sent);

            case 35:
            case "end":
              return _context576.stop();
          }
        }
      }, _callee575, this, [[8, 19, 23, 31], [24,, 26, 30]]);
    }));
  });
  this.idSchema = t.idSchema, this.activityHttps = new ap(t), this.activityService = new Pp(t);
},
    hP = function hP(t) {
  var _this184 = this;

  _classCallCheck(this, hP);

  s(this, "activityFacade");
  s(this, "add", function (t, e, i, n) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee576() {
      return _regeneratorRuntime.wrap(function _callee576$(_context577) {
        while (1) {
          switch (_context577.prev = _context577.next) {
            case 0:
              _context577.next = 2;
              return this.activityFacade.add(t, e, i, n);

            case 2:
              return _context577.abrupt("return", _context577.sent);

            case 3:
            case "end":
              return _context577.stop();
          }
        }
      }, _callee576, this);
    }));
  });
  s(this, "delete", function (t) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee577() {
      return _regeneratorRuntime.wrap(function _callee577$(_context578) {
        while (1) {
          switch (_context578.prev = _context578.next) {
            case 0:
              _context578.next = 2;
              return this.activityFacade.delete(t);

            case 2:
              return _context578.abrupt("return", _context578.sent);

            case 3:
            case "end":
              return _context578.stop();
          }
        }
      }, _callee577, this);
    }));
  });
  s(this, "like", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee578() {
      return _regeneratorRuntime.wrap(function _callee578$(_context579) {
        while (1) {
          switch (_context579.prev = _context579.next) {
            case 0:
              _context579.next = 2;
              return this.activityFacade.like(t, e, i);

            case 2:
              return _context579.abrupt("return", _context579.sent);

            case 3:
            case "end":
              return _context579.stop();
          }
        }
      }, _callee578, this);
    }));
  });
  s(this, "dislike", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee579() {
      return _regeneratorRuntime.wrap(function _callee579$(_context580) {
        while (1) {
          switch (_context580.prev = _context580.next) {
            case 0:
              _context580.next = 2;
              return this.activityFacade.dislike(t, e, i);

            case 2:
              return _context580.abrupt("return", _context580.sent);

            case 3:
            case "end":
              return _context580.stop();
          }
        }
      }, _callee579, this);
    }));
  });
  s(this, "addPageview", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee580() {
      return _regeneratorRuntime.wrap(function _callee580$(_context581) {
        while (1) {
          switch (_context581.prev = _context581.next) {
            case 0:
              _context581.next = 2;
              return this.activityFacade.addPageview(t, e, i);

            case 2:
              return _context581.abrupt("return", _context581.sent);

            case 3:
            case "end":
              return _context581.stop();
          }
        }
      }, _callee580, this);
    }));
  });
  s(this, "addContentConsumed", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee581() {
      return _regeneratorRuntime.wrap(function _callee581$(_context582) {
        while (1) {
          switch (_context582.prev = _context582.next) {
            case 0:
              _context582.next = 2;
              return this.activityFacade.addContentConsumed(t, e, i);

            case 2:
              return _context582.abrupt("return", _context582.sent);

            case 3:
            case "end":
              return _context582.stop();
          }
        }
      }, _callee581, this);
    }));
  });
  s(this, "addShare", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee582() {
      return _regeneratorRuntime.wrap(function _callee582$(_context583) {
        while (1) {
          switch (_context583.prev = _context583.next) {
            case 0:
              _context583.next = 2;
              return this.activityFacade.addShare(t, e, i);

            case 2:
              return _context583.abrupt("return", _context583.sent);

            case 3:
            case "end":
              return _context583.stop();
          }
        }
      }, _callee582, this);
    }));
  });
  s(this, "addComment", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee583() {
      return _regeneratorRuntime.wrap(function _callee583$(_context584) {
        while (1) {
          switch (_context584.prev = _context584.next) {
            case 0:
              _context584.next = 2;
              return this.activityFacade.addComment(t, e, i);

            case 2:
              return _context584.abrupt("return", _context584.sent);

            case 3:
            case "end":
              return _context584.stop();
          }
        }
      }, _callee583, this);
    }));
  });
  s(this, "addClickAd", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee584() {
      return _regeneratorRuntime.wrap(function _callee584$(_context585) {
        while (1) {
          switch (_context585.prev = _context585.next) {
            case 0:
              _context585.next = 2;
              return this.activityFacade.addClickAd(t, e, i);

            case 2:
              return _context585.abrupt("return", _context585.sent);

            case 3:
            case "end":
              return _context585.stop();
          }
        }
      }, _callee584, this);
    }));
  });
  s(this, "addConversion", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee585() {
      return _regeneratorRuntime.wrap(function _callee585$(_context586) {
        while (1) {
          switch (_context586.prev = _context586.next) {
            case 0:
              _context586.next = 2;
              return this.activityFacade.addConversion(t, e, i);

            case 2:
              return _context586.abrupt("return", _context586.sent);

            case 3:
            case "end":
              return _context586.stop();
          }
        }
      }, _callee585, this);
    }));
  });
  s(this, "getOwn", function (t, e) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee586() {
      return _regeneratorRuntime.wrap(function _callee586$(_context587) {
        while (1) {
          switch (_context587.prev = _context587.next) {
            case 0:
              _context587.next = 2;
              return this.activityFacade.getOwn(t, e);

            case 2:
              return _context587.abrupt("return", _context587.sent);

            case 3:
            case "end":
              return _context587.stop();
          }
        }
      }, _callee586, this);
    }));
  });
  s(this, "getForUser", function (t, e, i) {
    return u(_this184, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee587() {
      return _regeneratorRuntime.wrap(function _callee587$(_context588) {
        while (1) {
          switch (_context588.prev = _context588.next) {
            case 0:
              _context588.next = 2;
              return this.activityFacade.getForUser(t, e, i);

            case 2:
              return _context588.abrupt("return", _context588.sent);

            case 3:
            case "end":
              return _context588.stop();
          }
        }
      }, _callee587, this);
    }));
  });
  this.activityFacade = new dP(t);
},
    Ap = function Ap() {
  _classCallCheck(this, Ap);

  s(this, "id", null);
  s(this, "title", null);
  s(this, "description", null);
  s(this, "images", new Ao());
  s(this, "participationCount", null);
  s(this, "status", null);
  s(this, "flags", null);
  s(this, "createdAt", null);
  s(this, "updatedAt", null);
},
    pP =
/*#__PURE__*/
function (_Ap) {
  _inherits(pP, _Ap);

  function pP() {
    var _this185;

    _classCallCheck(this, pP);

    _this185 = _possibleConstructorReturn(this, _getPrototypeOf(pP).apply(this, arguments));
    s(_assertThisInitialized(_this185), "questions", []);
    return _this185;
  }

  return pP;
}(Ap),
    fP = function fP() {
  _classCallCheck(this, fP);

  s(this, "questionId", null);
  s(this, "question", null);
  s(this, "images", null);
  s(this, "options", []);
},
    mP = function mP() {
  _classCallCheck(this, mP);

  s(this, "optionId", null);
  s(this, "option", null);
  s(this, "images", null);
},
    gP = function gP() {
  _classCallCheck(this, gP);

  s(this, "classicQuizId", null);
  s(this, "userId", null);
  s(this, "questions", []);
},
    yP = function yP() {
  _classCallCheck(this, yP);

  s(this, "questionId", null);
  s(this, "optionId", null);
  s(this, "correct", null);
},
    vP = function vP() {
  var _this186 = this;

  _classCallCheck(this, vP);

  s(this, "remapClassicQuizzes", function (t) {
    return t.meta.pagination = _this186.remapMetaPagination(t.meta.pagination), t.data = t.data.map(function (e) {
      return _this186.remapBasicClassicQuiz(e);
    }), t;
  });
  s(this, "remapClassicQuizById", function (t) {
    var e = new pP();
    return e.id = t.id, e.title = t.title, e.description = t.description, e.images = t.images, e.participationCount = t.participation_count, e.status = t.status, e.flags = t.flags, e.questions = t.questions.map(function (i) {
      return _this186.remapQuestions(i);
    }), e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapClassicQuizParticipation", function (t) {
    var e = new gP();
    return e.classicQuizId = t.classic_quiz_id, e.userId = t.user_id, e.questions = t.questions ? t.questions.map(function (i) {
      return _this186.remapParticipationQuestions(i);
    }) : null, e;
  });
  s(this, "remapClassicQuizParticipationBody", function (t) {
    return t.map(function (e) {
      return {
        question_id: e.questionId,
        option_id: e.optionId
      };
    });
  });
  s(this, "remapMetaPagination", function (t) {
    var e = new Uh();
    return e.itemsPerPage = t.items_per_page, e.nextPageStartsAfter = t.next_page_starts_after, e;
  });
  s(this, "remapBasicClassicQuiz", function (t) {
    var e = new Ap();
    return e.id = t.id, e.title = t.title, e.description = t.description, e.images = t.images, e.participationCount = t.participation_count, e.status = t.status, e.flags = t.flags, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapQuestions", function (t) {
    var e = new fP();
    return e.questionId = t.question_id, e.question = t.question, e.images = t.images, e.options = t.options.map(function (i) {
      return _this186.remapOptions(i);
    }), e;
  });
  s(this, "remapOptions", function (t) {
    var e = new mP();
    return e.optionId = t.option_id, e.option = t.option, e.images = t.images, e;
  });
  s(this, "remapParticipationQuestions", function (t) {
    var e = new yP();
    return e.questionId = t.question_id, e.optionId = t.option_id, e.correct = t.correct, e;
  });
},
    wP =
/*#__PURE__*/
function (_St8) {
  _inherits(wP, _St8);

  function wP(e) {
    var _this187;

    _classCallCheck(this, wP);

    _this187 = _possibleConstructorReturn(this, _getPrototypeOf(wP).call(this, e, Ct(e.environment, "miniGames")));
    s(_assertThisInitialized(_this187), "remapper", null);
    s(_assertThisInitialized(_this187), "getClassicQuizzes", function (e, i) {
      return u(_assertThisInitialized(_this187), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee588() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee588$(_context589) {
          while (1) {
            switch (_context589.prev = _context589.next) {
              case 0:
                n = "/classic-quizzes".concat(this.apiSignInUrl);
                e && (n += e.constructMainFiltersUrl()), n += Ee(i) ? Ce() : "";
                r = "There was a problem with fetching classic quizzes";
                _context589.next = 5;
                return this.fetchWithoutAuth(n, r);

              case 5:
                a = _context589.sent;
                return _context589.abrupt("return", this.remapper.remapClassicQuizzes(a));

              case 7:
              case "end":
                return _context589.stop();
            }
          }
        }, _callee588, this);
      }));
    });
    s(_assertThisInitialized(_this187), "getClassicQuizById", function (e, i) {
      return u(_assertThisInitialized(_this187), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee589() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee589$(_context590) {
          while (1) {
            switch (_context590.prev = _context590.next) {
              case 0:
                n = "/classic-quizzes/".concat(e).concat(this.apiSignInUrl);
                Ee(i) && (n += Ce());
                r = "There was a problem with fetching classic quiz by ID";
                _context590.next = 5;
                return this.fetchWithoutAuth(n, r);

              case 5:
                a = _context590.sent;
                return _context590.abrupt("return", this.remapper.remapClassicQuizById(a.data));

              case 7:
              case "end":
                return _context590.stop();
            }
          }
        }, _callee589, this);
      }));
    });
    s(_assertThisInitialized(_this187), "participateInClassicQuiz", function (e, i) {
      return u(_assertThisInitialized(_this187), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee590() {
        var n, r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee590$(_context591) {
          while (1) {
            switch (_context591.prev = _context591.next) {
              case 0:
                n = "/classic-quizzes/".concat(e, "/participate").concat(this.apiSignInUrl);
                r = "There was a problem with participating in the following classic quiz: ".concat(e);
                a = "POST";
                o = {
                  questions: this.remapper.remapClassicQuizParticipationBody(i)
                };
                _context591.next = 6;
                return this.fetchWithAuth(n, r, a, o);

              case 6:
                l = _context591.sent;
                return _context591.abrupt("return", this.remapper.remapClassicQuizParticipation(l.data));

              case 8:
              case "end":
                return _context591.stop();
            }
          }
        }, _callee590, this);
      }));
    });
    _this187.remapper = new vP();
    return _this187;
  }

  return wP;
}(St),
    bP =
/*#__PURE__*/
function (_ms2) {
  _inherits(bP, _ms2);

  function bP(e) {
    var _this188;

    _classCallCheck(this, bP);

    _this188 = _possibleConstructorReturn(this, _getPrototypeOf(bP).call(this, e));
    s(_assertThisInitialized(_this188), "flags", null);
    s(_assertThisInitialized(_this188), "status", null);
    s(_assertThisInitialized(_this188), "constructMainFiltersUrl", function () {
      var e = _get2(_getPrototypeOf(bP.prototype), "constructMainFiltersUrl", _assertThisInitialized(_this188)).call(_assertThisInitialized(_this188));

      return _this188.flags && (e += "&flags=".concat(_this188.flags.join(","))), _this188.status && (e += "&status=".concat(_this188.status)), e;
    });
    _this188.flags = e && e.flags ? e.flags : null, _this188.status = e && e.status ? e.status : null;
    return _this188;
  }

  return bP;
}(ms),
    IP = function IP(t) {
  var _this189 = this;

  _classCallCheck(this, IP);

  s(this, "https", null);
  s(this, "getClassicQuizzes", function (t, e) {
    return u(_this189, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee591() {
      return _regeneratorRuntime.wrap(function _callee591$(_context592) {
        while (1) {
          switch (_context592.prev = _context592.next) {
            case 0:
              t && (t = new bP(t));
              _context592.next = 3;
              return this.https.getClassicQuizzes(t, e);

            case 3:
              return _context592.abrupt("return", _context592.sent);

            case 4:
            case "end":
              return _context592.stop();
          }
        }
      }, _callee591, this);
    }));
  });
  s(this, "getClassicQuizById", function (t, e) {
    return u(_this189, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee592() {
      return _regeneratorRuntime.wrap(function _callee592$(_context593) {
        while (1) {
          switch (_context593.prev = _context593.next) {
            case 0:
              _context593.next = 2;
              return this.https.getClassicQuizById(t, e);

            case 2:
              return _context593.abrupt("return", _context593.sent);

            case 3:
            case "end":
              return _context593.stop();
          }
        }
      }, _callee592, this);
    }));
  });
  s(this, "participateInClassicQuiz", function (t, e) {
    return u(_this189, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee593() {
      return _regeneratorRuntime.wrap(function _callee593$(_context594) {
        while (1) {
          switch (_context594.prev = _context594.next) {
            case 0:
              _context594.next = 2;
              return this.https.participateInClassicQuiz(t, e);

            case 2:
              return _context594.abrupt("return", _context594.sent);

            case 3:
            case "end":
              return _context594.stop();
          }
        }
      }, _callee593, this);
    }));
  });
  this.https = new wP(t);
},
    _P = function _P(t) {
  var _this190 = this;

  _classCallCheck(this, _P);

  s(this, "facade", null);
  s(this, "getClassicQuizzes", function (t, e) {
    return u(_this190, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee594() {
      return _regeneratorRuntime.wrap(function _callee594$(_context595) {
        while (1) {
          switch (_context595.prev = _context595.next) {
            case 0:
              _context595.next = 2;
              return this.facade.getClassicQuizzes(t, e);

            case 2:
              return _context595.abrupt("return", _context595.sent);

            case 3:
            case "end":
              return _context595.stop();
          }
        }
      }, _callee594, this);
    }));
  });
  s(this, "getClassicQuizById", function (t, e) {
    return u(_this190, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee595() {
      return _regeneratorRuntime.wrap(function _callee595$(_context596) {
        while (1) {
          switch (_context596.prev = _context596.next) {
            case 0:
              _context596.next = 2;
              return this.facade.getClassicQuizById(t, e);

            case 2:
              return _context596.abrupt("return", _context596.sent);

            case 3:
            case "end":
              return _context596.stop();
          }
        }
      }, _callee595, this);
    }));
  });
  s(this, "participateInClassicQuiz", function (t, e) {
    return u(_this190, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee596() {
      return _regeneratorRuntime.wrap(function _callee596$(_context597) {
        while (1) {
          switch (_context597.prev = _context597.next) {
            case 0:
              _context597.next = 2;
              return this.facade.participateInClassicQuiz(t, e);

            case 2:
              return _context597.abrupt("return", _context597.sent);

            case 3:
            case "end":
              return _context597.stop();
          }
        }
      }, _callee596, this);
    }));
  });
  this.facade = new IP(t);
},
    EP = function EP() {
  _classCallCheck(this, EP);

  s(this, "id", "");
  s(this, "label", "");
  s(this, "discussionType", "LEAGUE");
  s(this, "moderationType", "USER");
  s(this, "postsCount", 0);
  s(this, "pinnedPosts", []);
  s(this, "lastPostId", "");
  s(this, "context", null);
  s(this, "createdAt", "");
  s(this, "updatedAt", "");
},
    Fo = function Fo() {
  _classCallCheck(this, Fo);

  s(this, "pagination", {
    totalItems: 0,
    nextPageStartsAfter: "",
    lastCommentCreateTimestamp: ""
  });
},
    Mp = function Mp() {
  _classCallCheck(this, Mp);

  s(this, "id", "");
  s(this, "userId", "");
  s(this, "discussionId", "");
  s(this, "content", "");
  s(this, "repliesCount", 0);
  s(this, "replyId", "");
  s(this, "reactions", []);
  s(this, "reactionsCount", 0);
  s(this, "reports", []);
  s(this, "reportsCount", 0);
  s(this, "versions", null);
  s(this, "privatePost", !1);
  s(this, "deleted", !1);
  s(this, "deletedAt", "");
  s(this, "deletedBy", "");
  s(this, "moderated", !1);
  s(this, "moderatedAt", "");
  s(this, "moderatedBy", "");
  s(this, "moderatedReason", "");
  s(this, "createdAt", "");
  s(this, "updatedAt", "");
},
    CP = function CP() {
  _classCallCheck(this, CP);

  s(this, "meta", new Fo());
  s(this, "data", []);
},
    SP = function SP() {
  _classCallCheck(this, SP);

  s(this, "type", "");
  s(this, "userIds", []);
  s(this, "reactionCount", 0);
},
    TP = function TP() {
  _classCallCheck(this, TP);

  s(this, "updatedAt", "");
  s(this, "content", "");
},
    RP = function RP() {
  _classCallCheck(this, RP);

  s(this, "userId", null);
  s(this, "reason", "AD");
  s(this, "reasonDetails", null);
},
    PP =
/*#__PURE__*/
function (_Mp) {
  _inherits(PP, _Mp);

  function PP() {
    var _this191;

    _classCallCheck(this, PP);

    _this191 = _possibleConstructorReturn(this, _getPrototypeOf(PP).apply(this, arguments));
    s(_assertThisInitialized(_this191), "userModel", null);
    return _this191;
  }

  return PP;
}(Mp),
    OP = function OP() {
  _classCallCheck(this, OP);

  s(this, "meta", new Fo());
  s(this, "data", []);
},
    AP = function AP() {
  _classCallCheck(this, AP);

  s(this, "meta", new os());
  s(this, "data", []);
},
    MP = function MP() {
  var _this192 = this;

  _classCallCheck(this, MP);

  s(this, "remapToDiscussionById", function (t) {
    var e = new EP();
    return e.id = t.id, e.label = t.label, e.discussionType = t.discussion_type, e.moderationType = t.moderation_type, e.postsCount = t.posts_count, e.pinnedPosts = t.pinned_posts, e.lastPostId = t.last_post_id, e.context = t.context, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapToPostsForDiscussion", function (t, e) {
    var i = new CP(),
        n = new OP();
    return i.meta = _this192.remapToPostMeta(t.meta), i.data = t.data.map(function (r) {
      return _this192.remapToPostByIdBasic(r);
    }), n.meta = _this192.remapToPostMeta(t.meta), n.data = t.data.map(function (r) {
      return _this192.remapToPostByIdFull(r);
    }), e === "basic" ? i : n;
  });
  s(this, "remapToPosts", function (t) {
    var e = new AP();
    return e.meta = _this192.remapToMeta(t.meta), e.data = t.data.map(function (i) {
      return _this192.remapToPostByIdBasic(i);
    }), e;
  });
  s(this, "remapToPostMeta", function (t) {
    var e = new Fo();
    return e.pagination.totalItems = t.pagination.total_items, e.pagination.nextPageStartsAfter = t.pagination.next_page_starts_after, e.pagination.lastCommentCreateTimestamp = t.pagination.last_comment_create_timestamp, e;
  });
  s(this, "remapToMeta", function (t) {
    var e = new os();
    return e.pagination.itemsPerPage = t.pagination.items_per_page, e.pagination.nextPageStartsAfter = t.pagination.next_page_starts_after, e;
  });
  s(this, "remapToPostByIdBasic", function (t) {
    var e = new Mp();
    return e.id = t.id, e.userId = t.user_id, e.discussionId = t.discussion_id, e.content = t.content, e.reactionsCount = t.reactions_count, e.replyId = t.reply_id, e.reactions = t.reactions.length ? t.reactions.map(function (i) {
      return _this192.remapReactionsPost(i);
    }) : t.reactions, e.reactionsCount = t.reactions_count, e.reports = t.reports.length ? t.reports.map(function (i) {
      return _this192.remapReportPost(i);
    }) : t.reports, e.reportsCount = t.reports_count, e.versions = t.versions.length ? t.versions.map(function (i) {
      return _this192.remapVersionsPost(i);
    }) : t.versions, e.privatePost = t.private_post, e.deleted = t.deleted, e.deletedAt = t.deleted_at, e.deletedBy = t.deleted_by, e.moderated = t.moderated, e.moderatedAt = t.moderated_at, e.moderatedBy = t.moderated_by, e.moderatedReason = t.moderated_reason, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapToPostByIdFull", function (t) {
    var e = new PP();
    return e.id = t.id, e.userId = t.user_id, e.discussionId = t.discussion_id, e.content = t.content, e.reactionsCount = t.reactions_count, e.replyId = t.reply_id, e.reactions = t.reactions.length ? t.reactions.map(function (i) {
      return _this192.remapReactionsPost(i);
    }) : t.reactions, e.reactionsCount = t.reactions_count, e.reports = t.reports.length ? t.reports.map(function (i) {
      return _this192.remapReportPost(i);
    }) : t.reports, e.reportsCount = t.reports_count, e.versions = t.versions.length ? t.versions.map(function (i) {
      return _this192.remapVersionsPost(i);
    }) : t.versions, e.privatePost = t.private_post, e.deleted = t.deleted, e.deletedAt = t.deleted_at, e.deletedBy = t.deleted_by, e.moderated = t.moderated, e.moderatedAt = t.moderated_at, e.moderatedBy = t.moderated_by, e.moderatedReason = t.moderated_reason, e.createdAt = t.created_at, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapReactionsPost", function (t) {
    var e = new SP();
    return e.type = t.type, e.userIds = t.user_ids, e.reactionCount = t.reaction_count, e;
  });
  s(this, "remapVersionsPost", function (t) {
    var e = new TP();
    return e.content = t.content, e.updatedAt = t.updated_at, e;
  });
  s(this, "remapReportPost", function (t) {
    var e = new RP();
    return e.userId = t.user_id, e.reason = t.reason, e.reasonDetails = t.reason_details, e;
  });
},
    FP =
/*#__PURE__*/
function (_St9) {
  _inherits(FP, _St9);

  function FP(e) {
    var _this193;

    _classCallCheck(this, FP);

    _this193 = _possibleConstructorReturn(this, _getPrototypeOf(FP).call(this, e, Ct(e.environment, "discussions")));
    s(_assertThisInitialized(_this193), "remapper", null);
    s(_assertThisInitialized(_this193), "getById", function (e) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee597() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee597$(_context598) {
          while (1) {
            switch (_context598.prev = _context598.next) {
              case 0:
                i = "/discussions/".concat(e) + this.apiSignInUrl;
                n = "There was a problem getting discussion";
                _context598.next = 4;
                return this.fetchWithoutAuth(i, n);

              case 4:
                r = _context598.sent;
                return _context598.abrupt("return", this.remapper.remapToDiscussionById(r.data));

              case 6:
              case "end":
                return _context598.stop();
            }
          }
        }, _callee597, this);
      }));
    });
    s(_assertThisInitialized(_this193), "createPost", function (e, i) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee598() {
        var n, r, a, o;
        return _regeneratorRuntime.wrap(function _callee598$(_context599) {
          while (1) {
            switch (_context599.prev = _context599.next) {
              case 0:
                n = "/discussions/".concat(e, "/posts") + this.apiSignInUrl;
                r = "There was a problem creating post in discussion";
                a = "POST";
                _context599.next = 5;
                return this.fetchWithAuth(n, r, a, i);

              case 5:
                o = _context599.sent;
                return _context599.abrupt("return", this.remapper.remapToPostByIdBasic(o.data));

              case 7:
              case "end":
                return _context599.stop();
            }
          }
        }, _callee598, this);
      }));
    });
    s(_assertThisInitialized(_this193), "getPostById", function (e) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee599() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee599$(_context600) {
          while (1) {
            switch (_context600.prev = _context600.next) {
              case 0:
                i = "/posts/".concat(e) + this.apiSignInUrl;
                n = "There was a problem getting post by ID in discussion";
                _context600.next = 4;
                return this.fetchWithoutAuth(i, n);

              case 4:
                r = _context600.sent;
                return _context600.abrupt("return", this.remapper.remapToPostByIdFull(r.data));

              case 6:
              case "end":
                return _context600.stop();
            }
          }
        }, _callee599, this);
      }));
    });
    s(_assertThisInitialized(_this193), "updatePost", function (e, i) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee600() {
        var n, r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee600$(_context601) {
          while (1) {
            switch (_context601.prev = _context601.next) {
              case 0:
                n = "/posts/".concat(e) + this.apiSignInUrl;
                r = "There was a problem editing post in discussion";
                a = "PUT";
                o = {
                  content: i
                };
                _context601.next = 6;
                return this.fetchWithAuth(n, r, a, o);

              case 6:
                l = _context601.sent;
                return _context601.abrupt("return", this.remapper.remapToPostByIdBasic(l.data));

              case 8:
              case "end":
                return _context601.stop();
            }
          }
        }, _callee600, this);
      }));
    });
    s(_assertThisInitialized(_this193), "reactToPost", function (e, i) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee601() {
        var n, r, a, o, l;
        return _regeneratorRuntime.wrap(function _callee601$(_context602) {
          while (1) {
            switch (_context602.prev = _context602.next) {
              case 0:
                n = "/posts/".concat(e, "/reaction") + this.apiSignInUrl;
                r = "There was a problem reacting to post in discussion";
                a = "PUT";
                o = {
                  reaction: i.toLocaleLowerCase()
                };
                _context602.next = 6;
                return this.fetchWithAuth(n, r, a, o);

              case 6:
                l = _context602.sent;
                return _context602.abrupt("return", this.remapper.remapToPostByIdBasic(l.data));

              case 8:
              case "end":
                return _context602.stop();
            }
          }
        }, _callee601, this);
      }));
    });
    s(_assertThisInitialized(_this193), "deletePost", function (e) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee602() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee602$(_context603) {
          while (1) {
            switch (_context603.prev = _context603.next) {
              case 0:
                i = "/posts/".concat(e) + this.apiSignInUrl, n = "There was a problem deleting post in discussion", r = "DELETE";
                _context603.next = 3;
                return this.fetchWithAuth(i, n, r);

              case 3:
                return _context603.abrupt("return", !0);

              case 4:
              case "end":
                return _context603.stop();
            }
          }
        }, _callee602, this);
      }));
    });
    s(_assertThisInitialized(_this193), "getPosts", function (e, i) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee603() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee603$(_context604) {
          while (1) {
            switch (_context604.prev = _context604.next) {
              case 0:
                n = "/discussions/".concat(e, "/posts") + this.apiSignInUrl;
                i && (n += "".concat(i.constructMainFiltersUrl()));
                r = "There was a problem getting posts in discussion";
                _context604.next = 5;
                return this.fetchWithoutAuth(n, r);

              case 5:
                a = _context604.sent;
                return _context604.abrupt("return", this.remapper.remapToPostsForDiscussion(a, "full"));

              case 7:
              case "end":
                return _context604.stop();
            }
          }
        }, _callee603, this);
      }));
    });
    s(_assertThisInitialized(_this193), "getPostReplies", function (e, i) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee604() {
        var n, r, a;
        return _regeneratorRuntime.wrap(function _callee604$(_context605) {
          while (1) {
            switch (_context605.prev = _context605.next) {
              case 0:
                n = "/posts/".concat(e, "/replies") + this.apiSignInUrl;
                i && (n += "".concat(i.constructMainFiltersUrl()));
                r = "There was a problem getting post's replies in discussion";
                _context605.next = 5;
                return this.fetchWithoutAuth(n, r);

              case 5:
                a = _context605.sent;
                return _context605.abrupt("return", this.remapper.remapToPostsForDiscussion(a, "full"));

              case 7:
              case "end":
                return _context605.stop();
            }
          }
        }, _callee604, this);
      }));
    });
    s(_assertThisInitialized(_this193), "reportPost", function (e, i, n) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee605() {
        var r, a, o, l, c;
        return _regeneratorRuntime.wrap(function _callee605$(_context606) {
          while (1) {
            switch (_context606.prev = _context606.next) {
              case 0:
                r = "/posts/".concat(e, "/report") + this.apiSignInUrl;
                a = "There was a problem reporting post in discussion";
                o = "POST";
                l = {
                  reason: i.toLocaleUpperCase(),
                  reason_details: n || null
                };
                _context606.next = 6;
                return this.fetchWithAuth(r, a, o, l);

              case 6:
                c = _context606.sent;
                return _context606.abrupt("return", this.remapper.remapToPostByIdBasic(c.data));

              case 8:
              case "end":
                return _context606.stop();
            }
          }
        }, _callee605, this);
      }));
    });
    s(_assertThisInitialized(_this193), "getOwnPosts", function (e) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee606() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee606$(_context607) {
          while (1) {
            switch (_context607.prev = _context607.next) {
              case 0:
                i = "/posts" + this.apiSignInUrl;
                e && (i += "".concat(e.constructMainFiltersUrl()));
                n = "There was a problem getting own posts";
                _context607.next = 5;
                return this.fetchWithAuth(i, n);

              case 5:
                r = _context607.sent;
                return _context607.abrupt("return", this.remapper.remapToPosts(r));

              case 7:
              case "end":
                return _context607.stop();
            }
          }
        }, _callee606, this);
      }));
    });
    s(_assertThisInitialized(_this193), "getUserPosts", function (e, i, n) {
      return u(_assertThisInitialized(_this193), null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee607() {
        var r, a, o;
        return _regeneratorRuntime.wrap(function _callee607$(_context608) {
          while (1) {
            switch (_context608.prev = _context608.next) {
              case 0:
                r = "/posts/users/".concat(e) + this.apiSignInUrl;
                i && (r += "".concat(i.constructMainFiltersUrl())), Ee(n) && (r += Ce());
                a = "There was a problem getting user's posts";
                _context608.next = 5;
                return this.fetchWithoutAuth(r, a);

              case 5:
                o = _context608.sent;
                return _context608.abrupt("return", this.remapper.remapToPosts(o));

              case 7:
              case "end":
                return _context608.stop();
            }
          }
        }, _callee607, this);
      }));
    });
    _this193.remapper = new MP();
    return _this193;
  }

  return FP;
}(St),
    kP = function kP() {
  _classCallCheck(this, kP);

  s(this, "content", "");
  s(this, "reply_id", "");
  s(this, "context", null);
},
    xP = function xP() {
  _classCallCheck(this, xP);

  s(this, "createRequestBodyFromParam", function (t) {
    var e = new kP();
    return e.content = t.content, e.reply_id = t.replyId, e.context = t.context, e;
  });
},
    Hn =
/*#__PURE__*/
function (_ms3) {
  _inherits(Hn, _ms3);

  function Hn(e) {
    var _this194;

    _classCallCheck(this, Hn);

    _this194 = _possibleConstructorReturn(this, _getPrototypeOf(Hn).call(this, e));
    s(_assertThisInitialized(_this194), "skipDeleted");
    s(_assertThisInitialized(_this194), "sort");
    _this194.skipDeleted = e && e.skipDeleted !== void 0 ? e.skipDeleted : null, _this194.sort = e && e.sort ? e.sort.toLocaleLowerCase() : null;
    return _this194;
  }

  _createClass(Hn, [{
    key: "constructMainFiltersUrl",
    value: function constructMainFiltersUrl() {
      var e = _get2(_getPrototypeOf(Hn.prototype), "constructMainFiltersUrl", this).call(this);

      return this.skipDeleted !== null && (e += "&skip_deleted=".concat(this.skipDeleted)), this.sort && (e += "&sort=".concat(this.sort)), e;
    }
  }]);

  return Hn;
}(ms),
    DP = function DP(t) {
  var _this195 = this;

  _classCallCheck(this, DP);

  s(this, "profile", null);
  s(this, "finalizePostFullModel", function (t) {
    return u(_this195, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee608() {
      var _this196 = this;

      var e, i;
      return _regeneratorRuntime.wrap(function _callee608$(_context609) {
        while (1) {
          switch (_context609.prev = _context609.next) {
            case 0:
              e = t.map(function (n) {
                return n.userId;
              });
              _context609.next = 3;
              return this.profile.getByIds(e);

            case 3:
              i = _context609.sent;
              return _context609.abrupt("return", t.map(function (n) {
                return n.userModel = _this196.extractModelById(i, n.userId), n;
              }));

            case 5:
            case "end":
              return _context609.stop();
          }
        }
      }, _callee608, this);
    }));
  });
  s(this, "extractModelById", function (t, e) {
    if (t.length) {
      var i = t.find(function (n) {
        return n.id === e;
      });
      return i ? (delete i.interests, i) : null;
    }

    return null;
  });
  this.profile = new hs(t);
},
    NP = function NP(t) {
  var _this197 = this;

  _classCallCheck(this, NP);

  s(this, "idSchema", null);
  s(this, "https", null);
  s(this, "clientHttps", null);
  s(this, "activityService", null);
  s(this, "service", null);
  s(this, "factory", null);
  s(this, "getById", function (t) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee609() {
      var e;
      return _regeneratorRuntime.wrap(function _callee609$(_context610) {
        while (1) {
          switch (_context610.prev = _context610.next) {
            case 0:
              _context610.next = 2;
              return this.https.getById(t);

            case 2:
              e = _context610.sent;
              _context610.next = 5;
              return this.remapTags(e, "native", this.idSchema);

            case 5:
              return _context610.abrupt("return", e);

            case 6:
            case "end":
              return _context610.stop();
          }
        }
      }, _callee609, this);
    }));
  });
  s(this, "createPost", function (t, e) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee610() {
      var i, n;
      return _regeneratorRuntime.wrap(function _callee610$(_context611) {
        while (1) {
          switch (_context611.prev = _context611.next) {
            case 0:
              i = JSON.parse(JSON.stringify(e));
              _context611.next = 3;
              return this.remapTags(i, this.idSchema, "native");

            case 3:
              n = this.factory.createRequestBodyFromParam(i);
              _context611.next = 6;
              return this.https.createPost(t, n);

            case 6:
              return _context611.abrupt("return", _context611.sent);

            case 7:
            case "end":
              return _context611.stop();
          }
        }
      }, _callee610, this);
    }));
  });
  s(this, "getPostById", function (t) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee611() {
      var e;
      return _regeneratorRuntime.wrap(function _callee611$(_context612) {
        while (1) {
          switch (_context612.prev = _context612.next) {
            case 0:
              _context612.next = 2;
              return this.https.getPostById(t);

            case 2:
              e = _context612.sent;
              _context612.next = 5;
              return this.service.finalizePostFullModel([e]);

            case 5:
              return _context612.abrupt("return", _context612.sent[0]);

            case 6:
            case "end":
              return _context612.stop();
          }
        }
      }, _callee611, this);
    }));
  });
  s(this, "updatePost", function (t, e) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee612() {
      return _regeneratorRuntime.wrap(function _callee612$(_context613) {
        while (1) {
          switch (_context613.prev = _context613.next) {
            case 0:
              _context613.next = 2;
              return this.https.updatePost(t, e);

            case 2:
              return _context613.abrupt("return", _context613.sent);

            case 3:
            case "end":
              return _context613.stop();
          }
        }
      }, _callee612, this);
    }));
  });
  s(this, "deletePost", function (t) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee613() {
      return _regeneratorRuntime.wrap(function _callee613$(_context614) {
        while (1) {
          switch (_context614.prev = _context614.next) {
            case 0:
              _context614.next = 2;
              return this.https.deletePost(t);

            case 2:
              return _context614.abrupt("return", _context614.sent);

            case 3:
            case "end":
              return _context614.stop();
          }
        }
      }, _callee613, this);
    }));
  });
  s(this, "getPosts", function (t, e) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee614() {
      var i;
      return _regeneratorRuntime.wrap(function _callee614$(_context615) {
        while (1) {
          switch (_context615.prev = _context615.next) {
            case 0:
              e && (e = new Hn(e));
              _context615.next = 3;
              return this.https.getPosts(t, e);

            case 3:
              i = _context615.sent;
              _context615.next = 6;
              return this.service.finalizePostFullModel(i.data);

            case 6:
              i.data = _context615.sent;
              return _context615.abrupt("return", i);

            case 8:
            case "end":
              return _context615.stop();
          }
        }
      }, _callee614, this);
    }));
  });
  s(this, "getPostReplies", function (t, e) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee615() {
      var i;
      return _regeneratorRuntime.wrap(function _callee615$(_context616) {
        while (1) {
          switch (_context616.prev = _context616.next) {
            case 0:
              e && (e = new Hn(e));
              _context616.next = 3;
              return this.https.getPostReplies(t, e);

            case 3:
              i = _context616.sent;
              _context616.next = 6;
              return this.service.finalizePostFullModel(i.data);

            case 6:
              i.data = _context616.sent;
              return _context616.abrupt("return", i);

            case 8:
            case "end":
              return _context616.stop();
          }
        }
      }, _callee615, this);
    }));
  });
  s(this, "reactToPost", function (t, e) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee616() {
      return _regeneratorRuntime.wrap(function _callee616$(_context617) {
        while (1) {
          switch (_context617.prev = _context617.next) {
            case 0:
              _context617.next = 2;
              return this.https.reactToPost(t, e);

            case 2:
              return _context617.abrupt("return", _context617.sent);

            case 3:
            case "end":
              return _context617.stop();
          }
        }
      }, _callee616, this);
    }));
  });
  s(this, "reportPost", function (t, e, i) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee617() {
      return _regeneratorRuntime.wrap(function _callee617$(_context618) {
        while (1) {
          switch (_context618.prev = _context618.next) {
            case 0:
              _context618.next = 2;
              return this.https.reportPost(t, e, i);

            case 2:
              return _context618.abrupt("return", _context618.sent);

            case 3:
            case "end":
              return _context618.stop();
          }
        }
      }, _callee617, this);
    }));
  });
  s(this, "getOwnPosts", function (t) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee618() {
      return _regeneratorRuntime.wrap(function _callee618$(_context619) {
        while (1) {
          switch (_context619.prev = _context619.next) {
            case 0:
              t && (t = new Hn(t));
              _context619.next = 3;
              return this.https.getOwnPosts(t);

            case 3:
              return _context619.abrupt("return", _context619.sent);

            case 4:
            case "end":
              return _context619.stop();
          }
        }
      }, _callee618, this);
    }));
  });
  s(this, "getUserPosts", function (t, e, i) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee619() {
      return _regeneratorRuntime.wrap(function _callee619$(_context620) {
        while (1) {
          switch (_context620.prev = _context620.next) {
            case 0:
              e && (e = new Hn(e));
              _context620.next = 3;
              return this.https.getUserPosts(t, e, i);

            case 3:
              return _context620.abrupt("return", _context620.sent);

            case 4:
            case "end":
              return _context620.stop();
          }
        }
      }, _callee619, this);
    }));
  });
  s(this, "getConfig", function () {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee620() {
      return _regeneratorRuntime.wrap(function _callee620$(_context621) {
        while (1) {
          switch (_context621.prev = _context621.next) {
            case 0:
              _context621.next = 2;
              return this.clientHttps.getConfig("discussions");

            case 2:
              return _context621.abrupt("return", _context621.sent);

            case 3:
            case "end":
              return _context621.stop();
          }
        }
      }, _callee620, this);
    }));
  });
  s(this, "remapTags", function (t, e, i) {
    return u(_this197, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee621() {
      var n, _r50;

      return _regeneratorRuntime.wrap(function _callee621$(_context622) {
        while (1) {
          switch (_context622.prev = _context622.next) {
            case 0:
              if (!(this.idSchema != "native" && t.context.tags && t.context.tags.length)) {
                _context622.next = 6;
                break;
              }

              n = JSON.parse(JSON.stringify(t.context.tags));
              _context622.next = 4;
              return this.activityService.remapTagsIds(n, e, i);

            case 4:
              _r50 = _context622.sent;
              t.context.tags = _r50;

            case 6:
            case "end":
              return _context622.stop();
          }
        }
      }, _callee621, this);
    }));
  });
  this.idSchema = t.idSchema, this.https = new FP(t), this.clientHttps = new Ni(t), this.activityService = new Pp(t), this.service = new DP(t), this.factory = new xP();
},
    LP = function LP(t) {
  var _this198 = this;

  _classCallCheck(this, LP);

  s(this, "facade", null);
  s(this, "getById", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee622() {
      return _regeneratorRuntime.wrap(function _callee622$(_context623) {
        while (1) {
          switch (_context623.prev = _context623.next) {
            case 0:
              _context623.next = 2;
              return this.facade.getById(t);

            case 2:
              return _context623.abrupt("return", _context623.sent);

            case 3:
            case "end":
              return _context623.stop();
          }
        }
      }, _callee622, this);
    }));
  });
  s(this, "createPost", function (t, e) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee623() {
      return _regeneratorRuntime.wrap(function _callee623$(_context624) {
        while (1) {
          switch (_context624.prev = _context624.next) {
            case 0:
              _context624.next = 2;
              return this.facade.createPost(t, e);

            case 2:
              return _context624.abrupt("return", _context624.sent);

            case 3:
            case "end":
              return _context624.stop();
          }
        }
      }, _callee623, this);
    }));
  });
  s(this, "getPostById", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee624() {
      return _regeneratorRuntime.wrap(function _callee624$(_context625) {
        while (1) {
          switch (_context625.prev = _context625.next) {
            case 0:
              _context625.next = 2;
              return this.facade.getPostById(t);

            case 2:
              return _context625.abrupt("return", _context625.sent);

            case 3:
            case "end":
              return _context625.stop();
          }
        }
      }, _callee624, this);
    }));
  });
  s(this, "updatePost", function (t, e) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee625() {
      return _regeneratorRuntime.wrap(function _callee625$(_context626) {
        while (1) {
          switch (_context626.prev = _context626.next) {
            case 0:
              _context626.next = 2;
              return this.facade.updatePost(t, e);

            case 2:
              return _context626.abrupt("return", _context626.sent);

            case 3:
            case "end":
              return _context626.stop();
          }
        }
      }, _callee625, this);
    }));
  });
  s(this, "deletePost", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee626() {
      return _regeneratorRuntime.wrap(function _callee626$(_context627) {
        while (1) {
          switch (_context627.prev = _context627.next) {
            case 0:
              _context627.next = 2;
              return this.facade.deletePost(t);

            case 2:
              return _context627.abrupt("return", _context627.sent);

            case 3:
            case "end":
              return _context627.stop();
          }
        }
      }, _callee626, this);
    }));
  });
  s(this, "getPosts", function (t, e) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee627() {
      return _regeneratorRuntime.wrap(function _callee627$(_context628) {
        while (1) {
          switch (_context628.prev = _context628.next) {
            case 0:
              _context628.next = 2;
              return this.facade.getPosts(t, e);

            case 2:
              return _context628.abrupt("return", _context628.sent);

            case 3:
            case "end":
              return _context628.stop();
          }
        }
      }, _callee627, this);
    }));
  });
  s(this, "getPostReplies", function (t, e) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee628() {
      return _regeneratorRuntime.wrap(function _callee628$(_context629) {
        while (1) {
          switch (_context629.prev = _context629.next) {
            case 0:
              _context629.next = 2;
              return this.facade.getPostReplies(t, e);

            case 2:
              return _context629.abrupt("return", _context629.sent);

            case 3:
            case "end":
              return _context629.stop();
          }
        }
      }, _callee628, this);
    }));
  });
  s(this, "reactLike", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee629() {
      return _regeneratorRuntime.wrap(function _callee629$(_context630) {
        while (1) {
          switch (_context630.prev = _context630.next) {
            case 0:
              _context630.next = 2;
              return this.facade.reactToPost(t, "LIKE");

            case 2:
              return _context630.abrupt("return", _context630.sent);

            case 3:
            case "end":
              return _context630.stop();
          }
        }
      }, _callee629, this);
    }));
  });
  s(this, "reactDislike", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee630() {
      return _regeneratorRuntime.wrap(function _callee630$(_context631) {
        while (1) {
          switch (_context631.prev = _context631.next) {
            case 0:
              _context631.next = 2;
              return this.facade.reactToPost(t, "DISLIKE");

            case 2:
              return _context631.abrupt("return", _context631.sent);

            case 3:
            case "end":
              return _context631.stop();
          }
        }
      }, _callee630, this);
    }));
  });
  s(this, "reactLove", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee631() {
      return _regeneratorRuntime.wrap(function _callee631$(_context632) {
        while (1) {
          switch (_context632.prev = _context632.next) {
            case 0:
              _context632.next = 2;
              return this.facade.reactToPost(t, "LOVE");

            case 2:
              return _context632.abrupt("return", _context632.sent);

            case 3:
            case "end":
              return _context632.stop();
          }
        }
      }, _callee631, this);
    }));
  });
  s(this, "reactLaugh", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee632() {
      return _regeneratorRuntime.wrap(function _callee632$(_context633) {
        while (1) {
          switch (_context633.prev = _context633.next) {
            case 0:
              _context633.next = 2;
              return this.facade.reactToPost(t, "LAUGH");

            case 2:
              return _context633.abrupt("return", _context633.sent);

            case 3:
            case "end":
              return _context633.stop();
          }
        }
      }, _callee632, this);
    }));
  });
  s(this, "reactCare", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee633() {
      return _regeneratorRuntime.wrap(function _callee633$(_context634) {
        while (1) {
          switch (_context634.prev = _context634.next) {
            case 0:
              _context634.next = 2;
              return this.facade.reactToPost(t, "CARE");

            case 2:
              return _context634.abrupt("return", _context634.sent);

            case 3:
            case "end":
              return _context634.stop();
          }
        }
      }, _callee633, this);
    }));
  });
  s(this, "reactWow", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee634() {
      return _regeneratorRuntime.wrap(function _callee634$(_context635) {
        while (1) {
          switch (_context635.prev = _context635.next) {
            case 0:
              _context635.next = 2;
              return this.facade.reactToPost(t, "WOW");

            case 2:
              return _context635.abrupt("return", _context635.sent);

            case 3:
            case "end":
              return _context635.stop();
          }
        }
      }, _callee634, this);
    }));
  });
  s(this, "reactSad", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee635() {
      return _regeneratorRuntime.wrap(function _callee635$(_context636) {
        while (1) {
          switch (_context636.prev = _context636.next) {
            case 0:
              _context636.next = 2;
              return this.facade.reactToPost(t, "SAD");

            case 2:
              return _context636.abrupt("return", _context636.sent);

            case 3:
            case "end":
              return _context636.stop();
          }
        }
      }, _callee635, this);
    }));
  });
  s(this, "reactAngry", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee636() {
      return _regeneratorRuntime.wrap(function _callee636$(_context637) {
        while (1) {
          switch (_context637.prev = _context637.next) {
            case 0:
              _context637.next = 2;
              return this.facade.reactToPost(t, "ANGRY");

            case 2:
              return _context637.abrupt("return", _context637.sent);

            case 3:
            case "end":
              return _context637.stop();
          }
        }
      }, _callee636, this);
    }));
  });
  s(this, "reportPost", function (t, e, i) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee637() {
      return _regeneratorRuntime.wrap(function _callee637$(_context638) {
        while (1) {
          switch (_context638.prev = _context638.next) {
            case 0:
              _context638.next = 2;
              return this.facade.reportPost(t, e, i);

            case 2:
              return _context638.abrupt("return", _context638.sent);

            case 3:
            case "end":
              return _context638.stop();
          }
        }
      }, _callee637, this);
    }));
  });
  s(this, "getOwnPosts", function (t) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee638() {
      return _regeneratorRuntime.wrap(function _callee638$(_context639) {
        while (1) {
          switch (_context639.prev = _context639.next) {
            case 0:
              _context639.next = 2;
              return this.facade.getOwnPosts(t);

            case 2:
              return _context639.abrupt("return", _context639.sent);

            case 3:
            case "end":
              return _context639.stop();
          }
        }
      }, _callee638, this);
    }));
  });
  s(this, "getUserPosts", function (t, e, i) {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee639() {
      return _regeneratorRuntime.wrap(function _callee639$(_context640) {
        while (1) {
          switch (_context640.prev = _context640.next) {
            case 0:
              _context640.next = 2;
              return this.facade.getUserPosts(t, e, i);

            case 2:
              return _context640.abrupt("return", _context640.sent);

            case 3:
            case "end":
              return _context640.stop();
          }
        }
      }, _callee639, this);
    }));
  });
  s(this, "getConfig", function () {
    return u(_this198, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee640() {
      return _regeneratorRuntime.wrap(function _callee640$(_context641) {
        while (1) {
          switch (_context641.prev = _context641.next) {
            case 0:
              _context641.next = 2;
              return this.facade.getConfig();

            case 2:
              return _context641.abrupt("return", _context641.sent);

            case 3:
            case "end":
              return _context641.stop();
          }
        }
      }, _callee640, this);
    }));
  });
  this.facade = new NP(t);
},
    er = null,
    Pa = null;

function $P(t) {
  if (UP(t)) {
    var e = BP(t);
    if (e.isValid) return er = {
      profile: new hs(t),
      football: new lp(t),
      predictor: new HR(t),
      loyalty: new aP(t),
      topX: new oP(t),
      matchQuiz: new lP(t),
      activity: new hP(t),
      miniGames: new _P(t),
      discussions: new LP(t)
    }, Pa = O({}, t), er;
    HP(e);
  }

  return er;
}

var UP = function UP(t) {
  return !er || JSON.stringify(t) !== JSON.stringify(Pa) || t.authProvider.getIdToken() !== Pa.authProvider.getIdToken();
},
    BP = function BP(t) {
  var e = new uR().validate(t);
  return (e.idSchema.validation === "missing" || e.idSchema.validation === "invalid") && (console.warn(e.idSchema.message.text), t.idSchema = "native"), (e.environment.validation === "missing" || e.environment.validation === "invalid") && (console.warn(e.environment.message.text), t.environment = "prod"), (e.lang.validation === "missing" || e.lang.validation === "invalid") && (console.warn(e.lang.message.text), t.lang = "en"), (e.errorHandlingMode.validation === "missing" || e.errorHandlingMode.validation === "invalid") && (console.warn(e.errorHandlingMode.message.text), t.errorHandlingMode = "default"), e.authProvider.validation === "invalid" && console.warn(e.authProvider.message.text), e;
},
    HP = function HP(t) {
  var e = "authProvider",
      i = "isValid";
  Object.keys(t).forEach(function (n) {
    var r = t[n];

    if (n !== i && n !== e) {
      if (r.message.type === "error") throw new Error(r.message.text);
    } else n !== i && n === e && Object.keys(new Ta()).forEach(function (a) {
      if (r[a].message.type === "error") throw new Error(r[a].message.text);
    });
  });
};

var Pt = Rr(null),
    VP = function VP(_ref78) {
  var t = _ref78.config,
      e = _ref78.children;
  var i = mt(function () {
    return $P(t);
  }, [t]),
      n = mt(function () {
    return new lT(t);
  }, [t]);
  return (
    /* @__PURE__ */
    _(Pt.Provider, {
      value: {
        sdk: i,
        https: n
      },
      children: e
    })
  );
};

function jP(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}

var Fp = jP,
    WP = ph,
    GP = function GP() {
  return WP.Date.now();
},
    zP = GP,
    qP = /\s/;

function QP(t) {
  for (var e = t.length; e-- && qP.test(t.charAt(e));) {
    ;
  }

  return e;
}

var YP = QP,
    KP = YP,
    JP = /^\s+/;

function XP(t) {
  return t && t.slice(0, KP(t) + 1).replace(JP, "");
}

var ZP = XP,
    eO = ZP,
    Sc = Fp,
    tO = mh,
    Tc = 0 / 0,
    iO = /^[-+]0x[0-9a-f]+$/i,
    nO = /^0b[01]+$/i,
    rO = /^0o[0-7]+$/i,
    sO = parseInt;

function aO(t) {
  if (typeof t == "number") return t;
  if (tO(t)) return Tc;

  if (Sc(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Sc(e) ? e + "" : e;
  }

  if (typeof t != "string") return t === 0 ? t : +t;
  t = eO(t);
  var i = nO.test(t);
  return i || rO.test(t) ? sO(t.slice(2), i ? 2 : 8) : iO.test(t) ? Tc : +t;
}

var oO = aO,
    lO = Fp,
    Js = zP,
    Rc = oO,
    cO = "Expected a function",
    uO = Math.max,
    dO = Math.min;

function hO(t, e, i) {
  var n,
      r,
      a,
      o,
      l,
      c,
      d = 0,
      h = !1,
      p = !1,
      g = !0;
  if (typeof t != "function") throw new TypeError(cO);
  e = Rc(e) || 0, lO(i) && (h = !!i.leading, p = "maxWait" in i, a = p ? uO(Rc(i.maxWait) || 0, e) : a, g = "trailing" in i ? !!i.trailing : g);

  function f(m) {
    var I = n,
        w = r;
    return n = r = void 0, d = m, o = t.apply(w, I), o;
  }

  function v(m) {
    return d = m, l = setTimeout(b, e), h ? f(m) : o;
  }

  function E(m) {
    var I = m - c,
        w = m - d,
        P = e - I;
    return p ? dO(P, a - w) : P;
  }

  function y(m) {
    var I = m - c,
        w = m - d;
    return c === void 0 || I >= e || I < 0 || p && w >= a;
  }

  function b() {
    var m = Js();
    if (y(m)) return C(m);
    l = setTimeout(b, E(m));
  }

  function C(m) {
    return l = void 0, g && n ? f(m) : (n = r = void 0, o);
  }

  function R() {
    l !== void 0 && clearTimeout(l), d = 0, n = c = r = l = void 0;
  }

  function M() {
    return l === void 0 ? o : C(Js());
  }

  function F() {
    var m = Js(),
        I = y(m);

    if (n = arguments, r = this, c = m, I) {
      if (l === void 0) return v(c);
      if (p) return clearTimeout(l), l = setTimeout(b, e), f(c);
    }

    return l === void 0 && (l = setTimeout(b, e)), o;
  }

  return F.cancel = R, F.flush = M, F;
}

var kp = hO;

var pO = function pO(t) {
  return t.map(function (e) {
    return {
      id: e.id,
      value: e.nickname ? e.nickname : e.name,
      label: e.nickname ? e.nickname : e.name,
      avatar: e.avatar
    };
  });
},
    fO = function fO(t) {
  return t.map(function (e) {
    return {
      id: e.id,
      value: e.label,
      label: e.label
    };
  });
},
    xp = {
  control: function control(t) {
    return $(O({}, t), {
      fontSize: "14px",
      borderRadius: "0.25em",
      padding: "6px 1px",
      "&:hover": {
        borderColor: "gray"
      },
      border: "1px solid lightgray",
      boxShadow: "none"
    });
  },
  clearIndicator: function clearIndicator(t) {
    return $(O({}, t), {
      "&:hover": {
        backGroundColor: "gray"
      },
      cursor: "pointer"
    });
  },
  input: function input(t) {
    return $(O({}, t), {
      "input:focus": {
        boxShadow: "none"
      }
    });
  }
},
    mO = 3,
    gO = 10,
    Pc = function Pc(_ref79) {
  var t = _ref79.filterType,
      e = _ref79.setFilters,
      i = _ref79.setFilteredDiscussions,
      n = _ref79.handleResetPosts;

  var _de2 = de(Ie),
      r = _de2.profileIdsSelectPlaceholder,
      a = _de2.discussionsSelectPlaceholder,
      o = _de2.loading,
      l = _de2.noOptionsMessage,
      c = _de2.getProfilesErrorMessage,
      d = _de2.getDiscussionsErrorMessage,
      _de3 = de(Pt),
      h = _de3.sdk,
      p = _de3.https,
      _K15 = K([]),
      _K16 = _slicedToArray(_K15, 2),
      g = _K16[0],
      f = _K16[1],
      v = function v(b) {
    if (t === "profileIds") {
      var C = b.map(function (R) {
        return R.id;
      });
      e(function (R) {
        return $(O({}, R), {
          profileIds: C
        });
      });
    } else if (t === "discussionIds") {
      var _C2 = b.map(function (R) {
        return R.id;
      });

      e(function (R) {
        return $(O({}, R), {
          discussionIds: _C2
        });
      }), i(b);
    }

    f(b), n();
  },
      y = kp(function (b, C) {
    if (b.length < mO) return C([]);
    t === "profileIds" ? h.profile.getByIds([], b, !0).then(function (M) {
      C(pO(M));
    }).catch(function (M) {
      X.error(c), console.error(M), C([]);
    }) : t === "discussionIds" && p.getDiscussions(b).then(function (R) {
      C(fO(R.data));
    }).catch(function (R) {
      X.error(d), console.error(R), C([]);
    });
  }, 300);

  return (
    /* @__PURE__ */
    _("div", {
      className: "dw-w-full dw-py-2",
      children:
      /* @__PURE__ */
      _(hh, {
        components: {
          DropdownIndicator: null
        },
        getOptionValue: function getOptionValue(b) {
          return b.id;
        },
        styles: xp,
        isMulti: !0,
        onChange: v,
        noOptionsMessage: function noOptionsMessage() {
          return l;
        },
        loadingMessage: function loadingMessage() {
          return o;
        },
        value: g,
        isDisabled: g.length === gO,
        loadOptions: y,
        placeholder: t === "profileIds" ? r : a,
        formatOptionLabel: function formatOptionLabel(b) {
          return (
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-flex-justify-start",
              children: [t === "profileIds" ?
              /* @__PURE__ */
              _("img", {
                src: b.avatar ? b.avatar : assetsPlaceholder.avatar,
                alt: "profile-logo",
                className: "dw-rounded-full dw-object-cover dw-h-6 dw-w-6 dw-mr-1"
              }) : null,
              /* @__PURE__ */
              _("span", {
                children: b.label
              })]
            })
          );
        }
      })
    })
  );
},
    yO = Object.values(uh),
    vO = Object.values(dh),
    Oc = function Oc(_ref80) {
  var t = _ref80.filters,
      e = _ref80.setFilters,
      i = _ref80.setFilteredDiscussions,
      n = _ref80.handleResetPosts;

  var _de4 = de(Ie),
      r = _de4.filterBy,
      a = _de4.sortBy;

  return (
    /* @__PURE__ */
    j("div", {
      className: "dw-grid md:dw-grid-cols-2 dw-gap-4 dw-grid-cols-1 dw-mb-6",
      children: [
      /* @__PURE__ */
      j("div", {
        className: "dw-border dw-border-gray-100 dw-rounded dw-p-4 dw-w-full",
        children: [
        /* @__PURE__ */
        _("h3", {
          className: "dw-font-bold dw-mb-2",
          children: r
        }),
        /* @__PURE__ */
        _(Kl, {
          filterType: "type",
          filterValues: vO,
          setFilters: e,
          defaultValue: t.type,
          handleResetPosts: n
        }),
        /* @__PURE__ */
        _(Jl, {
          filterType: "isModerated",
          value: t.moderated,
          setFilters: e,
          handleResetPosts: n
        }),
        /* @__PURE__ */
        _(Jl, {
          filterType: "isDeleted",
          value: t.deleted,
          setFilters: e,
          handleResetPosts: n
        }),
        /* @__PURE__ */
        _(Pc, {
          filterType: "profileIds",
          setFilters: e,
          handleResetPosts: n
        }),
        /* @__PURE__ */
        _(Pc, {
          filterType: "discussionIds",
          setFilters: e,
          handleResetPosts: n,
          setFilteredDiscussions: i
        })]
      }),
      /* @__PURE__ */
      j("div", {
        className: "dw-border dw-border-gray-100 dw-rounded dw-p-4 dw-w-full",
        children: [
        /* @__PURE__ */
        _("h3", {
          className: "dw-font-bold dw-mb-2",
          children: a
        }),
        /* @__PURE__ */
        _(Kl, {
          filterType: "sort",
          filterValues: yO,
          setFilters: e,
          handleResetPosts: n,
          defaultValue: t.sort
        })]
      })]
    })
  );
};

var Dp = {
  exports: {}
};

(function (t, e) {
  (function (i, n) {
    t.exports = n();
  })(Ki, function () {
    var i = 1e3,
        n = 6e4,
        r = 36e5,
        a = "millisecond",
        o = "second",
        l = "minute",
        c = "hour",
        d = "day",
        h = "week",
        _p2 = "month",
        g = "quarter",
        f = "year",
        v = "date",
        E = "Invalid Date",
        y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        C = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      ordinal: function ordinal(W) {
        var x = ["th", "st", "nd", "rd"],
            N = W % 100;
        return "[" + W + (x[(N - 20) % 10] || x[N] || x[0]) + "]";
      }
    },
        R = function R(W, x, N) {
      var U = String(W);
      return !U || U.length >= x ? W : "" + Array(x + 1 - U.length).join(N) + W;
    },
        M = {
      s: R,
      z: function z(W) {
        var x = -W.utcOffset(),
            N = Math.abs(x),
            U = Math.floor(N / 60),
            L = N % 60;
        return (x <= 0 ? "+" : "-") + R(U, 2, "0") + ":" + R(L, 2, "0");
      },
      m: function W(x, N) {
        if (x.date() < N.date()) return -W(N, x);
        var U = 12 * (N.year() - x.year()) + (N.month() - x.month()),
            L = x.clone().add(U, _p2),
            T = N - L < 0,
            S = x.clone().add(U + (T ? -1 : 1), _p2);
        return +(-(U + (N - L) / (T ? L - S : S - L)) || 0);
      },
      a: function a(W) {
        return W < 0 ? Math.ceil(W) || 0 : Math.floor(W);
      },
      p: function p(W) {
        return {
          M: _p2,
          y: f,
          w: h,
          d: d,
          D: v,
          h: c,
          m: l,
          s: o,
          ms: a,
          Q: g
        }[W] || String(W || "").toLowerCase().replace(/s$/, "");
      },
      u: function u(W) {
        return W === void 0;
      }
    },
        F = "en",
        m = {};

    m[F] = C;

    var I = "$isDayjsObject",
        w = function w(W) {
      return W instanceof G || !(!W || !W[I]);
    },
        P = function W(x, N, U) {
      var L;
      if (!x) return F;

      if (typeof x == "string") {
        var T = x.toLowerCase();
        m[T] && (L = T), N && (m[T] = N, L = T);
        var S = x.split("-");
        if (!L && S.length > 1) return W(S[0]);
      } else {
        var D = x.name;
        m[D] = x, L = D;
      }

      return !U && L && (F = L), L || !U && F;
    },
        k = function k(W, x) {
      if (w(W)) return W.clone();
      var N = typeof x == "object" ? x : {};
      return N.date = W, N.args = arguments, new G(N);
    },
        A = M;

    A.l = P, A.i = w, A.w = function (W, x) {
      return k(W, {
        locale: x.$L,
        utc: x.$u,
        x: x.$x,
        $offset: x.$offset
      });
    };

    var G = function () {
      function W(N) {
        this.$L = P(N.locale, null, !0), this.parse(N), this.$x = this.$x || N.x || {}, this[I] = !0;
      }

      var x = W.prototype;
      return x.parse = function (N) {
        this.$d = function (U) {
          var L = U.date,
              T = U.utc;
          if (L === null) return new Date(NaN);
          if (A.u(L)) return new Date();
          if (L instanceof Date) return new Date(L);

          if (typeof L == "string" && !/Z$/i.test(L)) {
            var S = L.match(y);

            if (S) {
              var D = S[2] - 1 || 0,
                  H = (S[7] || "0").substring(0, 3);
              return T ? new Date(Date.UTC(S[1], D, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, H)) : new Date(S[1], D, S[3] || 1, S[4] || 0, S[5] || 0, S[6] || 0, H);
            }
          }

          return new Date(L);
        }(N), this.init();
      }, x.init = function () {
        var N = this.$d;
        this.$y = N.getFullYear(), this.$M = N.getMonth(), this.$D = N.getDate(), this.$W = N.getDay(), this.$H = N.getHours(), this.$m = N.getMinutes(), this.$s = N.getSeconds(), this.$ms = N.getMilliseconds();
      }, x.$utils = function () {
        return A;
      }, x.isValid = function () {
        return this.$d.toString() !== E;
      }, x.isSame = function (N, U) {
        var L = k(N);
        return this.startOf(U) <= L && L <= this.endOf(U);
      }, x.isAfter = function (N, U) {
        return k(N) < this.startOf(U);
      }, x.isBefore = function (N, U) {
        return this.endOf(U) < k(N);
      }, x.$g = function (N, U, L) {
        return A.u(N) ? this[U] : this.set(L, N);
      }, x.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, x.valueOf = function () {
        return this.$d.getTime();
      }, x.startOf = function (N, U) {
        var L = this,
            T = !!A.u(U) || U,
            S = A.p(N),
            D = function D(Pe, ce) {
          var pe = A.w(L.$u ? Date.UTC(L.$y, ce, Pe) : new Date(L.$y, ce, Pe), L);
          return T ? pe : pe.endOf(d);
        },
            H = function H(Pe, ce) {
          return A.w(L.toDate()[Pe].apply(L.toDate("s"), (T ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ce)), L);
        },
            V = this.$W,
            z = this.$M,
            J = this.$D,
            Z = "set" + (this.$u ? "UTC" : "");

        switch (S) {
          case f:
            return T ? D(1, 0) : D(31, 11);

          case _p2:
            return T ? D(1, z) : D(0, z + 1);

          case h:
            var ne = this.$locale().weekStart || 0,
                ie = (V < ne ? V + 7 : V) - ne;
            return D(T ? J - ie : J + (6 - ie), z);

          case d:
          case v:
            return H(Z + "Hours", 0);

          case c:
            return H(Z + "Minutes", 1);

          case l:
            return H(Z + "Seconds", 2);

          case o:
            return H(Z + "Milliseconds", 3);

          default:
            return this.clone();
        }
      }, x.endOf = function (N) {
        return this.startOf(N, !1);
      }, x.$set = function (N, U) {
        var L,
            T = A.p(N),
            S = "set" + (this.$u ? "UTC" : ""),
            D = (L = {}, L[d] = S + "Date", L[v] = S + "Date", L[_p2] = S + "Month", L[f] = S + "FullYear", L[c] = S + "Hours", L[l] = S + "Minutes", L[o] = S + "Seconds", L[a] = S + "Milliseconds", L)[T],
            H = T === d ? this.$D + (U - this.$W) : U;

        if (T === _p2 || T === f) {
          var V = this.clone().set(v, 1);
          V.$d[D](H), V.init(), this.$d = V.set(v, Math.min(this.$D, V.daysInMonth())).$d;
        } else D && this.$d[D](H);

        return this.init(), this;
      }, x.set = function (N, U) {
        return this.clone().$set(N, U);
      }, x.get = function (N) {
        return this[A.p(N)]();
      }, x.add = function (N, U) {
        var L,
            T = this;
        N = Number(N);

        var S = A.p(U),
            D = function D(z) {
          var J = k(T);
          return A.w(J.date(J.date() + Math.round(z * N)), T);
        };

        if (S === _p2) return this.set(_p2, this.$M + N);
        if (S === f) return this.set(f, this.$y + N);
        if (S === d) return D(1);
        if (S === h) return D(7);
        var H = (L = {}, L[l] = n, L[c] = r, L[o] = i, L)[S] || 1,
            V = this.$d.getTime() + N * H;
        return A.w(V, this);
      }, x.subtract = function (N, U) {
        return this.add(-1 * N, U);
      }, x.format = function (N) {
        var U = this,
            L = this.$locale();
        if (!this.isValid()) return L.invalidDate || E;

        var T = N || "YYYY-MM-DDTHH:mm:ssZ",
            S = A.z(this),
            D = this.$H,
            H = this.$m,
            V = this.$M,
            z = L.weekdays,
            J = L.months,
            Z = L.meridiem,
            ne = function ne(ce, pe, Ze, Ot) {
          return ce && (ce[pe] || ce(U, T)) || Ze[pe].slice(0, Ot);
        },
            ie = function ie(ce) {
          return A.s(D % 12 || 12, ce, "0");
        },
            Pe = Z || function (ce, pe, Ze) {
          var Ot = ce < 12 ? "AM" : "PM";
          return Ze ? Ot.toLowerCase() : Ot;
        };

        return T.replace(b, function (ce, pe) {
          return pe || function (Ze) {
            switch (Ze) {
              case "YY":
                return String(U.$y).slice(-2);

              case "YYYY":
                return A.s(U.$y, 4, "0");

              case "M":
                return V + 1;

              case "MM":
                return A.s(V + 1, 2, "0");

              case "MMM":
                return ne(L.monthsShort, V, J, 3);

              case "MMMM":
                return ne(J, V);

              case "D":
                return U.$D;

              case "DD":
                return A.s(U.$D, 2, "0");

              case "d":
                return String(U.$W);

              case "dd":
                return ne(L.weekdaysMin, U.$W, z, 2);

              case "ddd":
                return ne(L.weekdaysShort, U.$W, z, 3);

              case "dddd":
                return z[U.$W];

              case "H":
                return String(D);

              case "HH":
                return A.s(D, 2, "0");

              case "h":
                return ie(1);

              case "hh":
                return ie(2);

              case "a":
                return Pe(D, H, !0);

              case "A":
                return Pe(D, H, !1);

              case "m":
                return String(H);

              case "mm":
                return A.s(H, 2, "0");

              case "s":
                return String(U.$s);

              case "ss":
                return A.s(U.$s, 2, "0");

              case "SSS":
                return A.s(U.$ms, 3, "0");

              case "Z":
                return S;
            }

            return null;
          }(ce) || S.replace(":", "");
        });
      }, x.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, x.diff = function (N, U, L) {
        var T,
            S = this,
            D = A.p(U),
            H = k(N),
            V = (H.utcOffset() - this.utcOffset()) * n,
            z = this - H,
            J = function J() {
          return A.m(S, H);
        };

        switch (D) {
          case f:
            T = J() / 12;
            break;

          case _p2:
            T = J();
            break;

          case g:
            T = J() / 3;
            break;

          case h:
            T = (z - V) / 6048e5;
            break;

          case d:
            T = (z - V) / 864e5;
            break;

          case c:
            T = z / r;
            break;

          case l:
            T = z / n;
            break;

          case o:
            T = z / i;
            break;

          default:
            T = z;
        }

        return L ? T : A.a(T);
      }, x.daysInMonth = function () {
        return this.endOf(_p2).$D;
      }, x.$locale = function () {
        return m[this.$L];
      }, x.locale = function (N, U) {
        if (!N) return this.$L;
        var L = this.clone(),
            T = P(N, U, !0);
        return T && (L.$L = T), L;
      }, x.clone = function () {
        return A.w(this.$d, this);
      }, x.toDate = function () {
        return new Date(this.valueOf());
      }, x.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, x.toISOString = function () {
        return this.$d.toISOString();
      }, x.toString = function () {
        return this.$d.toUTCString();
      }, W;
    }(),
        Y = G.prototype;

    return k.prototype = Y, [["$ms", a], ["$s", o], ["$m", l], ["$H", c], ["$W", d], ["$M", _p2], ["$y", f], ["$D", v]].forEach(function (W) {
      Y[W[1]] = function (x) {
        return this.$g(x, W[0], W[1]);
      };
    }), k.extend = function (W, x) {
      return W.$i || (W(x, G, k), W.$i = !0), k;
    }, k.locale = P, k.isDayjs = w, k.unix = function (W) {
      return k(1e3 * W);
    }, k.en = m[F], k.Ls = m, k.p = {}, k;
  });
})(Dp);

var Xs = Dp.exports,
    Er = {
  avatar: "data:image/png;base64,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",
  downArrow: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3klEQVR4nO3YSwrCMBRG4eMOVQwZ6OoVQfGxgQqVQgsiSe0zucX/QGdJuR+hgxSUUkoppZTqmQPuwBlYY68NcAGegI8tWgE3oKyfom1xhnw9UzPfo5452PVjoSWM/0KU9azRtoENuTE+MlM1a2u7wMYXcCDPN1sEZtl3fYEFjBuLsIBxUyFyYtzUiBwYNxciJWZ2RApMMsScmOSIOTDZEFNisiOmwJhBjMGYQwzBmEX0wZhHdMEsBvHr7mDtjjP4ZBZzEl0xi0LEMItENFW/lE7A0ejvJaWUUkop9U+9AdnJ7S7GX9jsAAAAAElFTkSuQmCC",
  upArrow: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAz0lEQVR4nO3YywrCMBBG4fOE1oWDC/vsCiq+RAuVQLpzvDVtJvAfCJSki/nIqgWllFJKKaUqtwfuwDU/N5kBAzDlNQI9jSOmFjHmIJrCHF8gBmcvvdvMTYzACTg4Z31LiLnwGPsCER5jPyDCYuwPRDiMLUCEwVgBRHWMFURUw9gKiM0xtiJiM4xtgFgdYxsi5opjaiCKY2oiimEiIBZjuoDfDkdnpjSr2y0Y4h0m/dBwewREeJg0q1uXpedPV1epDrjkGXe1h1FKKaWUUrTVE5bz7NyN3sYLAAAAAElFTkSuQmCC"
},
    wO = function wO(t) {
  return t ? t.nickname ? t.nickname : t.name : "---------";
},
    bO = function bO(_ref81) {
  var t = _ref81.post,
      e = _ref81.selectedPosts,
      i = _ref81.filteredDiscussions,
      n = _ref81.handleSelectPost,
      r = _ref81.onModerate;

  var _K17 = K(!1),
      _K18 = _slicedToArray(_K17, 2),
      a = _K18[0],
      o = _K18[1],
      _de5 = de(Ie),
      l = _de5.moderate,
      c = _de5.moderated,
      d = _de5.deletedAt,
      h = _de5.timeFormat,
      p = _de5.onDate,
      g = _de5.inDiscussion,
      f = _de5.reason,
      v = _de5.showOlderVersions,
      E = _de5.user,
      y = _de5.byStaffMemberWithId,
      b = _de5.at,
      C = _de5.na,
      R = _de5.moderationInfo,
      M = e.includes(t.id),
      F = i.length ? i.find(function (P) {
    return P.id === t.discussion_id;
  }).label : "",
      m = function m(P) {
    P.stopPropagation(), r(t.id);
  },
      I = function I(P) {
    P.stopPropagation(), o(!a);
  };

  return (
    /* @__PURE__ */
    j(Ne, {
      children: [
      /* @__PURE__ */
      j("div", {
        className: "dw-flex dw-items-center dw-cursor-pointer",
        onClick: function onClick(P) {
          P.stopPropagation(), n(t.id);
        },
        children: [
        /* @__PURE__ */
        _("input", {
          type: "checkbox",
          checked: M,
          className: "dw-mr-4 focus:dw-outline-none dw-outline-none dw-cursor-pointer dw-h-8 dw-w-8",
          readOnly: !0
        }),
        /* @__PURE__ */
        j("div", {
          className: "dw-bg-gray-100 dw-p-4 dw-rounded-lg ".concat(t.moderated ? "dw-border dw-border-yellow-600" : "", " ").concat(t.deleted ? "dw-border dw-border-red-600" : "", " dw-w-full dw-cursor-pointer"),
          children: [
          /* @__PURE__ */
          j("div", {
            className: "dw-flex dw-justify-between dw-border-b dw-border-gray-200 dw-pb-2 dw-mb-2 dw-text-gray-600 dw-text-xs",
            children: [
            /* @__PURE__ */
            j("p", {
              children: [E, " ",
              /* @__PURE__ */
              _("span", {
                className: "dw-font-bold",
                children: wO(t.user_model)
              }), " ", p, " ",
              /* @__PURE__ */
              _("span", {
                className: "dw-font-bold",
                children: Xs(t.created_at).format(h)
              }), " ", g, " ",
              /* @__PURE__ */
              _("span", {
                className: "dw-font-bold",
                children: F
              }), " (ID: ",
              /* @__PURE__ */
              _("span", {
                className: "dw-font-bold",
                children: t.discussion_id
              }), ")"]
            }),
            /* @__PURE__ */
            _("p", {
              className: "dw-text-xs dw-font-bold dw-mr-2",
              children: t.private_post ? "PRIVATE" : "PUBLIC"
            })]
          }),
          /* @__PURE__ */
          _("p", {
            className: "dw-mb-2 dw-border-b dw-border-gray-200 dw-pb-2",
            children: t.content
          }),
          /* @__PURE__ */
          _("p", {
            className: "dw-mb-1 dw-text-gray-600 dw-text-xs",
            children: R
          }),
          /* @__PURE__ */
          j("div", {
            className: "dw-flex dw-justify-between dw-text-gray-600 dw-text-xs",
            children: [t.moderated ?
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-flex-col dw-items-start",
              children: [
              /* @__PURE__ */
              _("p", {
                className: "dw-text-yellow-600 dw-font-bold dw-text-xs dw-mb-2",
                children: c
              }),
              /* @__PURE__ */
              j("p", {
                className: "dw-text-gray-600 dw-mb-2",
                children: [y, " ",
                /* @__PURE__ */
                _("span", {
                  className: "dw-font-bold",
                  children: t.moderated_by
                }), " ", b, " ",
                /* @__PURE__ */
                _("span", {
                  className: "dw-font-bold",
                  children: Xs(t.moderated_at).format(h)
                })]
              }),
              /* @__PURE__ */
              j("span", {
                className: "dw-text-gray-600",
                children: [f, ": ", t.moderated_reason]
              })]
            }) :
            /* @__PURE__ */
            _("p", {
              children: C
            }),
            /* @__PURE__ */
            _("div", {
              className: "dw-justify-end",
              children:
              /* @__PURE__ */
              _("button", {
                onClick: m,
                className: "dw-mr-2 ".concat(t.moderated || e.includes(t.id) ? "dw-bg-gray-600" : "dw-bg-brandColor hover:dw-bg-blue-700", " dw-text-white dw-font-bold dw-py-2 dw-px-4 dw-rounded focus:dw-outline-none focus:dw-shadow-outline dw-select-none"),
                disabled: t.moderated || e.includes(t.id),
                children: l
              })
            })]
          }), t.deleted ?
          /* @__PURE__ */
          _("div", {
            className: "dw-flex dw-flex-col dw-items-start dw-text-xs dw-text-gray-600",
            children:
            /* @__PURE__ */
            j("p", {
              className: "dw-text-red-600 dw-mb-2",
              children: [d, " ",
              /* @__PURE__ */
              _("span", {
                className: "dw-font-bold",
                children: Xs(t.deleted_at).format(h)
              })]
            })
          }) :
          /* @__PURE__ */
          _(Ne, {}), t.versions && t.versions.length > 0 ?
          /* @__PURE__ */
          j("div", {
            className: "dw-flex dw-items-center dw-cursor-pointer dw-text-gray-600 dw-text-xs",
            onClick: I,
            children: [
            /* @__PURE__ */
            _("img", {
              src: a ? Er.upArrow : Er.downArrow,
              className: "dw-w-4 dw-h-4 dw-mr-2"
            }),
            /* @__PURE__ */
            j("span", {
              className: "dw-select-none",
              children: [v, " (", t.versions.length, ")"]
            })]
          }) :
          /* @__PURE__ */
          _("div", {})]
        })]
      }), a && t.versions && t.versions.length ? t.versions.map(function (P) {
        return (
          /* @__PURE__ */
          _("div", {
            className: "dw-mx-16 dw-bg-gray-100 dw-p-4 dw-rounded-lg dw-w-full dw-text-gray-600",
            children: P.content
          })
        );
      }) : null]
    })
  );
},
    IO = function IO(_ref82) {
  var t = _ref82.selectedPosts,
      e = _ref82.posts,
      i = _ref82.filteredDiscussions,
      n = _ref82.handleSelectPost,
      r = _ref82.onModeratePost;
  return (
    /* @__PURE__ */
    _("div", {
      className: "dw-grid dw-gap-4 dw-mb-6",
      children: e.map(function (a) {
        return (
          /* @__PURE__ */
          _(bO, {
            post: a,
            selectedPosts: t,
            filteredDiscussions: i,
            handleSelectPost: n,
            onModerate: r
          }, a.id)
        );
      })
    })
  );
},
    Np = function Np(_ref83) {
  var t = _ref83.onModeratePosts,
      e = _ref83.isActiveModerateButton;

  var _de6 = de(Ie),
      i = _de6.moderatePosts;

  return (
    /* @__PURE__ */
    _("div", {
      className: "dw-flex dw-justify-end",
      children:
      /* @__PURE__ */
      _("button", {
        onClick: t,
        className: "".concat(e ? "dw-bg-brandColor hover:dw-bg-blue-700" : "dw-bg-gray-600", " dw-mr-2 dw-text-white dw-font-bold dw-py-2 dw-px-4 dw-rounded focus:dw-outline-none focus:dw-shadow-outline dw-select-none"),
        disabled: !e,
        children: i
      })
    })
  );
},
    _O = function _O(_ref84) {
  var t = _ref84.pageCount,
      e = _ref84.getPreviousPage,
      i = _ref84.getNextPage,
      n = _ref84.onModeratePosts,
      r = _ref84.pagePosts,
      a = _ref84.isActiveModerateButton;

  var _de7 = de(Ie),
      o = _de7.previous,
      l = _de7.next;

  return (
    /* @__PURE__ */
    j("div", {
      className: "dw-flex dw-items-baseline dw-flex-wrap dw-justify-between",
      children: [
      /* @__PURE__ */
      j("div", {
        className: "dw-flex",
        children: [t !== 1 ?
        /* @__PURE__ */
        _("button", {
          className: "dw-text-base dw-rounded-r-none  focus:dw-outline-none dw-flex dw-justify-center dw-px-4 dw-py-2 dw-rounded dw-font-bold dw-cursor-pointer hover:dw-bg-gray-200 dw-bg-gray-100 dw-text-gray-700 dw-border dw-duration-200 dw-ease-in-out dw-border-gray-300 dw-transition",
          onClick: e,
          children:
          /* @__PURE__ */
          j("div", {
            className: "dw-flex dw-leading-5 dw-text-xs dw-items-center",
            children: [
            /* @__PURE__ */
            _("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "100%",
              height: "100%",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "dw-feather dw-feather-chevron-left dw-w-4 dw-h-4",
              children:
              /* @__PURE__ */
              _("polyline", {
                points: "15 18 9 12 15 6"
              })
            }), o]
          })
        }) : null, r.get(t) && r.get(t).length === 10 ?
        /* @__PURE__ */
        _("button", {
          className: "dw-text-base ".concat(t !== 1 ? "dw-text-xs dw-rounded-l-none dw-border-l-0" : "", " focus:dw-outline-none dw-flex dw-justify-center dw-px-4 dw-py-2 dw-rounded dw-font-bold dw-cursor-pointer hover:dw-bg-gray-200 dw-bg-gray-100 dw-text-gray-700 dw-border dw-duration-200 dw-ease-in-out dw-border-gray-300 dw-transition"),
          onClick: i,
          children:
          /* @__PURE__ */
          j("div", {
            className: "dw-text-xs dw-flex dw-leading-5 dw-items-center",
            children: [l,
            /* @__PURE__ */
            _("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "100%",
              height: "100%",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "dw-feather dw-feather-chevron-right dw-w-4 dw-h-4 dw-ml-1",
              children:
              /* @__PURE__ */
              _("polyline", {
                points: "9 18 15 12 9 6"
              })
            })]
          })
        }) : null]
      }),
      /* @__PURE__ */
      _(Np, {
        onModeratePosts: n,
        isActiveModerateButton: a
      })]
    })
  );
};

var Rn =
/*#__PURE__*/
function () {
  function Rn() {
    _classCallCheck(this, Rn);

    this.listeners =
    /* @__PURE__ */
    new Set(), this.subscribe = this.subscribe.bind(this);
  }

  _createClass(Rn, [{
    key: "subscribe",
    value: function subscribe(e) {
      var _this199 = this;

      var i = {
        listener: e
      };
      return this.listeners.add(i), this.onSubscribe(), function () {
        _this199.listeners.delete(i), _this199.onUnsubscribe();
      };
    }
  }, {
    key: "hasListeners",
    value: function hasListeners() {
      return this.listeners.size > 0;
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe() {}
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {}
  }]);

  return Rn;
}();

var gn = typeof window == "undefined" || "Deno" in window;

function Ke() {}

function EO(t, e) {
  return typeof t == "function" ? t(e) : t;
}

function Oa(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}

function Lp(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}

function Zi(t, e, i) {
  return vs(t) ? typeof e == "function" ? $(O({}, i), {
    queryKey: t,
    queryFn: e
  }) : $(O({}, e), {
    queryKey: t
  }) : t;
}

function Mt(t, e, i) {
  return vs(t) ? [$(O({}, e), {
    queryKey: t
  }), i] : [t || {}, e];
}

function Ac(t, e) {
  var _t$type2 = t.type,
      i = _t$type2 === void 0 ? "all" : _t$type2,
      n = t.exact,
      r = t.fetchStatus,
      a = t.predicate,
      o = t.queryKey,
      l = t.stale;

  if (vs(o)) {
    if (n) {
      if (e.queryHash !== ko(o, e.options)) return !1;
    } else if (!Cr(e.queryKey, o)) return !1;
  }

  if (i !== "all") {
    var c = e.isActive();
    if (i === "active" && !c || i === "inactive" && c) return !1;
  }

  return !(typeof l == "boolean" && e.isStale() !== l || typeof r != "undefined" && r !== e.state.fetchStatus || a && !a(e));
}

function Mc(t, e) {
  var i = t.exact,
      n = t.fetching,
      r = t.predicate,
      a = t.mutationKey;

  if (vs(a)) {
    if (!e.options.mutationKey) return !1;

    if (i) {
      if (Yt(e.options.mutationKey) !== Yt(a)) return !1;
    } else if (!Cr(e.options.mutationKey, a)) return !1;
  }

  return !(typeof n == "boolean" && e.state.status === "loading" !== n || r && !r(e));
}

function ko(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Yt)(t);
}

function Yt(t) {
  return JSON.stringify(t, function (e, i) {
    return Ma(i) ? Object.keys(i).sort().reduce(function (n, r) {
      return n[r] = i[r], n;
    }, {}) : i;
  });
}

function Cr(t, e) {
  return $p(t, e);
}

function $p(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some(function (i) {
    return !$p(t[i], e[i]);
  }) : !1;
}

function Up(t, e) {
  if (t === e) return t;
  var i = Fc(t) && Fc(e);

  if (i || Ma(t) && Ma(e)) {
    var n = i ? t.length : Object.keys(t).length,
        _r51 = i ? e : Object.keys(e),
        _a26 = _r51.length,
        _o24 = i ? [] : {};

    var _l22 = 0;

    for (var c = 0; c < _a26; c++) {
      var _d12 = i ? c : _r51[c];

      _o24[_d12] = Up(t[_d12], e[_d12]), _o24[_d12] === t[_d12] && _l22++;
    }

    return n === _a26 && _l22 === n ? t : _o24;
  }

  return e;
}

function Aa(t, e) {
  if (t && !e || e && !t) return !1;

  for (var i in t) {
    if (t[i] !== e[i]) return !1;
  }

  return !0;
}

function Fc(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}

function Ma(t) {
  if (!kc(t)) return !1;
  var e = t.constructor;
  if (typeof e == "undefined") return !0;
  var i = e.prototype;
  return !(!kc(i) || !i.hasOwnProperty("isPrototypeOf"));
}

function kc(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}

function vs(t) {
  return Array.isArray(t);
}

function Bp(t) {
  return new Promise(function (e) {
    setTimeout(e, t);
  });
}

function xc(t) {
  Bp(0).then(t);
}

function CO() {
  if (typeof AbortController == "function") return new AbortController();
}

function Fa(t, e, i) {
  return i.isDataEqual != null && i.isDataEqual(t, e) ? t : typeof i.structuralSharing == "function" ? i.structuralSharing(t, e) : i.structuralSharing !== !1 ? Up(t, e) : e;
}

var SO =
/*#__PURE__*/
function (_Rn) {
  _inherits(SO, _Rn);

  function SO() {
    var _this200;

    _classCallCheck(this, SO);

    _this200 = _possibleConstructorReturn(this, _getPrototypeOf(SO).call(this)), _this200.setup = function (e) {
      if (!gn && window.addEventListener) {
        var i = function i() {
          return e();
        };

        return window.addEventListener("visibilitychange", i, !1), window.addEventListener("focus", i, !1), function () {
          window.removeEventListener("visibilitychange", i), window.removeEventListener("focus", i);
        };
      }
    };
    return _this200;
  }

  _createClass(SO, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      this.cleanup || this.setEventListener(this.setup);
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.hasListeners()) {
        var e;
        (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
      }
    }
  }, {
    key: "setEventListener",
    value: function setEventListener(e) {
      var _this201 = this;

      var i;
      this.setup = e, (i = this.cleanup) == null || i.call(this), this.cleanup = e(function (n) {
        typeof n == "boolean" ? _this201.setFocused(n) : _this201.onFocus();
      });
    }
  }, {
    key: "setFocused",
    value: function setFocused(e) {
      this.focused !== e && (this.focused = e, this.onFocus());
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.listeners.forEach(function (_ref85) {
        var e = _ref85.listener;
        e();
      });
    }
  }, {
    key: "isFocused",
    value: function isFocused() {
      return typeof this.focused == "boolean" ? this.focused : typeof document == "undefined" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
    }
  }]);

  return SO;
}(Rn);

var Sr = new SO(),
    Dc = ["online", "offline"];

var TO =
/*#__PURE__*/
function (_Rn2) {
  _inherits(TO, _Rn2);

  function TO() {
    var _this202;

    _classCallCheck(this, TO);

    _this202 = _possibleConstructorReturn(this, _getPrototypeOf(TO).call(this)), _this202.setup = function (e) {
      if (!gn && window.addEventListener) {
        var i = function i() {
          return e();
        };

        return Dc.forEach(function (n) {
          window.addEventListener(n, i, !1);
        }), function () {
          Dc.forEach(function (n) {
            window.removeEventListener(n, i);
          });
        };
      }
    };
    return _this202;
  }

  _createClass(TO, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      this.cleanup || this.setEventListener(this.setup);
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.hasListeners()) {
        var e;
        (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
      }
    }
  }, {
    key: "setEventListener",
    value: function setEventListener(e) {
      var _this203 = this;

      var i;
      this.setup = e, (i = this.cleanup) == null || i.call(this), this.cleanup = e(function (n) {
        typeof n == "boolean" ? _this203.setOnline(n) : _this203.onOnline();
      });
    }
  }, {
    key: "setOnline",
    value: function setOnline(e) {
      this.online !== e && (this.online = e, this.onOnline());
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      this.listeners.forEach(function (_ref86) {
        var e = _ref86.listener;
        e();
      });
    }
  }, {
    key: "isOnline",
    value: function isOnline() {
      return typeof this.online == "boolean" ? this.online : typeof navigator == "undefined" || typeof navigator.onLine == "undefined" ? !0 : navigator.onLine;
    }
  }]);

  return TO;
}(Rn);

var Tr = new TO();

function RO(t) {
  return Math.min(1e3 * Uo(2, t), 3e4);
}

function ws(t) {
  return (t != null ? t : "online") === "online" ? Tr.isOnline() : !0;
}

var Hp = function Hp(e) {
  _classCallCheck(this, Hp);

  this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
};

function tr(t) {
  return t instanceof Hp;
}

function Vp(t) {
  var e = !1,
      i = 0,
      n = !1,
      r,
      a,
      o;

  var l = new Promise(function (y, b) {
    a = y, o = b;
  }),
      c = function c(y) {
    n || (f(new Hp(y)), t.abort == null || t.abort());
  },
      d = function d() {
    e = !0;
  },
      h = function h() {
    e = !1;
  },
      p = function p() {
    return !Sr.isFocused() || t.networkMode !== "always" && !Tr.isOnline();
  },
      g = function g(y) {
    n || (n = !0, t.onSuccess == null || t.onSuccess(y), r == null || r(), a(y));
  },
      f = function f(y) {
    n || (n = !0, t.onError == null || t.onError(y), r == null || r(), o(y));
  },
      v = function v() {
    return new Promise(function (y) {
      r = function r(b) {
        var C = n || !p();
        return C && y(b), C;
      }, t.onPause == null || t.onPause();
    }).then(function () {
      r = void 0, n || t.onContinue == null || t.onContinue();
    });
  },
      E = function E() {
    if (n) return;
    var y;

    try {
      y = t.fn();
    } catch (b) {
      y = Promise.reject(b);
    }

    Promise.resolve(y).then(g).catch(function (b) {
      var C, R;
      if (n) return;
      var M = (C = t.retry) != null ? C : 3,
          F = (R = t.retryDelay) != null ? R : RO,
          m = typeof F == "function" ? F(i, b) : F,
          I = M === !0 || typeof M == "number" && i < M || typeof M == "function" && M(i, b);

      if (e || !I) {
        f(b);
        return;
      }

      i++, t.onFail == null || t.onFail(i, b), Bp(m).then(function () {
        if (p()) return v();
      }).then(function () {
        e ? f(b) : E();
      });
    });
  };

  return ws(t.networkMode) ? E() : v().then(E), {
    promise: l,
    cancel: c,
    continue: function _continue() {
      return (r == null ? void 0 : r()) ? l : Promise.resolve();
    },
    cancelRetry: d,
    continueRetry: h
  };
}

var xo = console;

function PO() {
  var t = [],
      e = 0,
      i = function i(h) {
    h();
  },
      n = function n(h) {
    h();
  };

  var r = function r(h) {
    var p;
    e++;

    try {
      p = h();
    } finally {
      e--, e || l();
    }

    return p;
  },
      a = function a(h) {
    e ? t.push(h) : xc(function () {
      i(h);
    });
  },
      o = function o(h) {
    return function () {
      for (var _len20 = arguments.length, p = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
        p[_key20] = arguments[_key20];
      }

      a(function () {
        h.apply(void 0, p);
      });
    };
  },
      l = function l() {
    var h = t;
    t = [], h.length && xc(function () {
      n(function () {
        h.forEach(function (p) {
          i(p);
        });
      });
    });
  };

  return {
    batch: r,
    batchCalls: o,
    schedule: a,
    setNotifyFunction: function setNotifyFunction(h) {
      i = h;
    },
    setBatchNotifyFunction: function setBatchNotifyFunction(h) {
      n = h;
    }
  };
}

var ye = PO();

var jp =
/*#__PURE__*/
function () {
  function jp() {
    _classCallCheck(this, jp);
  }

  _createClass(jp, [{
    key: "destroy",
    value: function destroy() {
      this.clearGcTimeout();
    }
  }, {
    key: "scheduleGc",
    value: function scheduleGc() {
      var _this204 = this;

      this.clearGcTimeout(), Oa(this.cacheTime) && (this.gcTimeout = setTimeout(function () {
        _this204.optionalRemove();
      }, this.cacheTime));
    }
  }, {
    key: "updateCacheTime",
    value: function updateCacheTime(e) {
      this.cacheTime = Math.max(this.cacheTime || 0, e != null ? e : gn ? 1 / 0 : 5 * 60 * 1e3);
    }
  }, {
    key: "clearGcTimeout",
    value: function clearGcTimeout() {
      this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
    }
  }]);

  return jp;
}();

var OO =
/*#__PURE__*/
function (_jp) {
  _inherits(OO, _jp);

  function OO(e) {
    var _this205;

    _classCallCheck(this, OO);

    _this205 = _possibleConstructorReturn(this, _getPrototypeOf(OO).call(this)), _this205.abortSignalConsumed = !1, _this205.defaultOptions = e.defaultOptions, _this205.setOptions(e.options), _this205.observers = [], _this205.cache = e.cache, _this205.logger = e.logger || xo, _this205.queryKey = e.queryKey, _this205.queryHash = e.queryHash, _this205.initialState = e.state || AO(_this205.options), _this205.state = _this205.initialState, _this205.scheduleGc();
    return _this205;
  }

  _createClass(OO, [{
    key: "setOptions",
    value: function setOptions(e) {
      this.options = O(O({}, this.defaultOptions), e), this.updateCacheTime(this.options.cacheTime);
    }
  }, {
    key: "optionalRemove",
    value: function optionalRemove() {
      !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
    }
  }, {
    key: "setData",
    value: function setData(e, i) {
      var n = Fa(this.state.data, e, this.options);
      return this.dispatch({
        data: n,
        type: "success",
        dataUpdatedAt: i == null ? void 0 : i.updatedAt,
        manual: i == null ? void 0 : i.manual
      }), n;
    }
  }, {
    key: "setState",
    value: function setState(e, i) {
      this.dispatch({
        type: "setState",
        state: e,
        setStateOptions: i
      });
    }
  }, {
    key: "cancel",
    value: function cancel(e) {
      var i;
      var n = this.promise;
      return (i = this.retryer) == null || i.cancel(e), n ? n.then(Ke).catch(Ke) : Promise.resolve();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get2(_getPrototypeOf(OO.prototype), "destroy", this).call(this), this.cancel({
        silent: !0
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.destroy(), this.setState(this.initialState);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.observers.some(function (e) {
        return e.options.enabled !== !1;
      });
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.getObserversCount() > 0 && !this.isActive();
    }
  }, {
    key: "isStale",
    value: function isStale() {
      return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (e) {
        return e.getCurrentResult().isStale;
      });
    }
  }, {
    key: "isStaleByTime",
    value: function isStaleByTime() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return this.state.isInvalidated || !this.state.dataUpdatedAt || !Lp(this.state.dataUpdatedAt, e);
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var e;
      var i = this.observers.find(function (n) {
        return n.shouldFetchOnWindowFocus();
      });
      i && i.refetch({
        cancelRefetch: !1
      }), (e = this.retryer) == null || e.continue();
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var e;
      var i = this.observers.find(function (n) {
        return n.shouldFetchOnReconnect();
      });
      i && i.refetch({
        cancelRefetch: !1
      }), (e = this.retryer) == null || e.continue();
    }
  }, {
    key: "addObserver",
    value: function addObserver(e) {
      this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
        type: "observerAdded",
        query: this,
        observer: e
      }));
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(e) {
      this.observers.includes(e) && (this.observers = this.observers.filter(function (i) {
        return i !== e;
      }), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
        revert: !0
      }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
        type: "observerRemoved",
        query: this,
        observer: e
      }));
    }
  }, {
    key: "getObserversCount",
    value: function getObserversCount() {
      return this.observers.length;
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      this.state.isInvalidated || this.dispatch({
        type: "invalidate"
      });
    }
  }, {
    key: "fetch",
    value: function fetch(e, i) {
      var _this206 = this;

      var n, r;

      if (this.state.fetchStatus !== "idle") {
        if (this.state.dataUpdatedAt && i != null && i.cancelRefetch) this.cancel({
          silent: !0
        });else if (this.promise) {
          var a;
          return (a = this.retryer) == null || a.continueRetry(), this.promise;
        }
      }

      if (e && this.setOptions(e), !this.options.queryFn) {
        var f = this.observers.find(function (v) {
          return v.options.queryFn;
        });
        f && this.setOptions(f.options);
      }

      var o = CO(),
          l = {
        queryKey: this.queryKey,
        pageParam: void 0,
        meta: this.meta
      },
          c = function c(f) {
        Object.defineProperty(f, "signal", {
          enumerable: !0,
          get: function get() {
            if (o) return _this206.abortSignalConsumed = !0, o.signal;
          }
        });
      };

      c(l);

      var d = function d() {
        return _this206.options.queryFn ? (_this206.abortSignalConsumed = !1, _this206.options.queryFn(l)) : Promise.reject("Missing queryFn for queryKey '" + _this206.options.queryHash + "'");
      },
          h = {
        fetchOptions: i,
        options: this.options,
        queryKey: this.queryKey,
        state: this.state,
        fetchFn: d
      };

      if (c(h), (n = this.options.behavior) == null || n.onFetch(h), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((r = h.fetchOptions) == null ? void 0 : r.meta)) {
        var p;
        this.dispatch({
          type: "fetch",
          meta: (p = h.fetchOptions) == null ? void 0 : p.meta
        });
      }

      var g = function g(f) {
        if (tr(f) && f.silent || _this206.dispatch({
          type: "error",
          error: f
        }), !tr(f)) {
          var v, E, y, b;
          (v = (E = _this206.cache.config).onError) == null || v.call(E, f, _this206), (y = (b = _this206.cache.config).onSettled) == null || y.call(b, _this206.state.data, f, _this206);
        }

        _this206.isFetchingOptimistic || _this206.scheduleGc(), _this206.isFetchingOptimistic = !1;
      };

      return this.retryer = Vp({
        fn: h.fetchFn,
        abort: o == null ? void 0 : o.abort.bind(o),
        onSuccess: function onSuccess(f) {
          var v, E, y, b;

          if (typeof f == "undefined") {
            g(new Error(_this206.queryHash + " data is undefined"));
            return;
          }

          _this206.setData(f), (v = (E = _this206.cache.config).onSuccess) == null || v.call(E, f, _this206), (y = (b = _this206.cache.config).onSettled) == null || y.call(b, f, _this206.state.error, _this206), _this206.isFetchingOptimistic || _this206.scheduleGc(), _this206.isFetchingOptimistic = !1;
        },
        onError: g,
        onFail: function onFail(f, v) {
          _this206.dispatch({
            type: "failed",
            failureCount: f,
            error: v
          });
        },
        onPause: function onPause() {
          _this206.dispatch({
            type: "pause"
          });
        },
        onContinue: function onContinue() {
          _this206.dispatch({
            type: "continue"
          });
        },
        retry: h.options.retry,
        retryDelay: h.options.retryDelay,
        networkMode: h.options.networkMode
      }), this.promise = this.retryer.promise, this.promise;
    }
  }, {
    key: "dispatch",
    value: function dispatch(e) {
      var _this207 = this;

      var i = function i(n) {
        var r, a;

        switch (e.type) {
          case "failed":
            return $(O({}, n), {
              fetchFailureCount: e.failureCount,
              fetchFailureReason: e.error
            });

          case "pause":
            return $(O({}, n), {
              fetchStatus: "paused"
            });

          case "continue":
            return $(O({}, n), {
              fetchStatus: "fetching"
            });

          case "fetch":
            return O($(O({}, n), {
              fetchFailureCount: 0,
              fetchFailureReason: null,
              fetchMeta: (r = e.meta) != null ? r : null,
              fetchStatus: ws(_this207.options.networkMode) ? "fetching" : "paused"
            }), !n.dataUpdatedAt && {
              error: null,
              status: "loading"
            });

          case "success":
            return O($(O({}, n), {
              data: e.data,
              dataUpdateCount: n.dataUpdateCount + 1,
              dataUpdatedAt: (a = e.dataUpdatedAt) != null ? a : Date.now(),
              error: null,
              isInvalidated: !1,
              status: "success"
            }), !e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            });

          case "error":
            var _o25 = e.error;
            return tr(_o25) && _o25.revert && _this207.revertState ? $(O({}, _this207.revertState), {
              fetchStatus: "idle"
            }) : $(O({}, n), {
              error: _o25,
              errorUpdateCount: n.errorUpdateCount + 1,
              errorUpdatedAt: Date.now(),
              fetchFailureCount: n.fetchFailureCount + 1,
              fetchFailureReason: _o25,
              fetchStatus: "idle",
              status: "error"
            });

          case "invalidate":
            return $(O({}, n), {
              isInvalidated: !0
            });

          case "setState":
            return O(O({}, n), e.state);
        }
      };

      this.state = i(this.state), ye.batch(function () {
        _this207.observers.forEach(function (n) {
          n.onQueryUpdate(e);
        }), _this207.cache.notify({
          query: _this207,
          type: "updated",
          action: e
        });
      });
    }
  }, {
    key: "meta",
    get: function get() {
      return this.options.meta;
    }
  }]);

  return OO;
}(jp);

function AO(t) {
  var e = typeof t.initialData == "function" ? t.initialData() : t.initialData,
      i = typeof e != "undefined",
      n = i ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: i ? n != null ? n : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: i ? "success" : "loading",
    fetchStatus: "idle"
  };
}

var MO =
/*#__PURE__*/
function (_Rn3) {
  _inherits(MO, _Rn3);

  function MO(e) {
    var _this208;

    _classCallCheck(this, MO);

    _this208 = _possibleConstructorReturn(this, _getPrototypeOf(MO).call(this)), _this208.config = e || {}, _this208.queries = [], _this208.queriesMap = {};
    return _this208;
  }

  _createClass(MO, [{
    key: "build",
    value: function build(e, i, n) {
      var r;
      var a = i.queryKey,
          o = (r = i.queryHash) != null ? r : ko(a, i);
      var l = this.get(o);
      return l || (l = new OO({
        cache: this,
        logger: e.getLogger(),
        queryKey: a,
        queryHash: o,
        options: e.defaultQueryOptions(i),
        state: n,
        defaultOptions: e.getQueryDefaults(a)
      }), this.add(l)), l;
    }
  }, {
    key: "add",
    value: function add(e) {
      this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
        type: "added",
        query: e
      }));
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var i = this.queriesMap[e.queryHash];
      i && (e.destroy(), this.queries = this.queries.filter(function (n) {
        return n !== e;
      }), i === e && delete this.queriesMap[e.queryHash], this.notify({
        type: "removed",
        query: e
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this209 = this;

      ye.batch(function () {
        _this209.queries.forEach(function (e) {
          _this209.remove(e);
        });
      });
    }
  }, {
    key: "get",
    value: function get(e) {
      return this.queriesMap[e];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.queries;
    }
  }, {
    key: "find",
    value: function find(e, i) {
      var _Mt = Mt(e, i),
          _Mt2 = _slicedToArray(_Mt, 1),
          n = _Mt2[0];

      return typeof n.exact == "undefined" && (n.exact = !0), this.queries.find(function (r) {
        return Ac(n, r);
      });
    }
  }, {
    key: "findAll",
    value: function findAll(e, i) {
      var _Mt3 = Mt(e, i),
          _Mt4 = _slicedToArray(_Mt3, 1),
          n = _Mt4[0];

      return Object.keys(n).length > 0 ? this.queries.filter(function (r) {
        return Ac(n, r);
      }) : this.queries;
    }
  }, {
    key: "notify",
    value: function notify(e) {
      var _this210 = this;

      ye.batch(function () {
        _this210.listeners.forEach(function (_ref87) {
          var i = _ref87.listener;
          i(e);
        });
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this211 = this;

      ye.batch(function () {
        _this211.queries.forEach(function (e) {
          e.onFocus();
        });
      });
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var _this212 = this;

      ye.batch(function () {
        _this212.queries.forEach(function (e) {
          e.onOnline();
        });
      });
    }
  }]);

  return MO;
}(Rn);

var FO =
/*#__PURE__*/
function (_jp2) {
  _inherits(FO, _jp2);

  function FO(e) {
    var _this213;

    _classCallCheck(this, FO);

    _this213 = _possibleConstructorReturn(this, _getPrototypeOf(FO).call(this)), _this213.defaultOptions = e.defaultOptions, _this213.mutationId = e.mutationId, _this213.mutationCache = e.mutationCache, _this213.logger = e.logger || xo, _this213.observers = [], _this213.state = e.state || kO(), _this213.setOptions(e.options), _this213.scheduleGc();
    return _this213;
  }

  _createClass(FO, [{
    key: "setOptions",
    value: function setOptions(e) {
      this.options = O(O({}, this.defaultOptions), e), this.updateCacheTime(this.options.cacheTime);
    }
  }, {
    key: "setState",
    value: function setState(e) {
      this.dispatch({
        type: "setState",
        state: e
      });
    }
  }, {
    key: "addObserver",
    value: function addObserver(e) {
      this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
        type: "observerAdded",
        mutation: this,
        observer: e
      }));
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(e) {
      this.observers = this.observers.filter(function (i) {
        return i !== e;
      }), this.scheduleGc(), this.mutationCache.notify({
        type: "observerRemoved",
        mutation: this,
        observer: e
      });
    }
  }, {
    key: "optionalRemove",
    value: function optionalRemove() {
      this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
    }
  }, {
    key: "continue",
    value: function _continue() {
      var e, i;
      return (e = (i = this.retryer) == null ? void 0 : i.continue()) != null ? e : this.execute();
    }
  }, {
    key: "execute",
    value: function execute() {
      return u(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee641() {
        var _this214 = this;

        var e, i, n, r, a, o, l, c, d, h, p, g, f, v, w, I, E, y, b, C, R, M, F, m;
        return _regeneratorRuntime.wrap(function _callee641$(_context642) {
          while (1) {
            switch (_context642.prev = _context642.next) {
              case 0:
                e = function e() {
                  var I;
                  return _this214.retryer = Vp({
                    fn: function fn() {
                      return _this214.options.mutationFn ? _this214.options.mutationFn(_this214.state.variables) : Promise.reject("No mutationFn found");
                    },
                    onFail: function onFail(w, P) {
                      _this214.dispatch({
                        type: "failed",
                        failureCount: w,
                        error: P
                      });
                    },
                    onPause: function onPause() {
                      _this214.dispatch({
                        type: "pause"
                      });
                    },
                    onContinue: function onContinue() {
                      _this214.dispatch({
                        type: "continue"
                      });
                    },
                    retry: (I = _this214.options.retry) != null ? I : 0,
                    retryDelay: _this214.options.retryDelay,
                    networkMode: _this214.options.networkMode
                  }), _this214.retryer.promise;
                }, i = this.state.status === "loading";
                _context642.prev = 1;

                if (i) {
                  _context642.next = 10;
                  break;
                }

                this.dispatch({
                  type: "loading",
                  variables: this.options.variables
                });
                _context642.next = 6;
                return (p = (g = this.mutationCache.config).onMutate) == null ? void 0 : p.call(g, this.state.variables, this);

              case 6:
                _context642.next = 8;
                return (f = (v = this.options).onMutate) == null ? void 0 : f.call(v, this.state.variables);

              case 8:
                w = _context642.sent;
                w !== this.state.context && this.dispatch({
                  type: "loading",
                  context: w,
                  variables: this.state.variables
                });

              case 10:
                _context642.next = 12;
                return e();

              case 12:
                I = _context642.sent;
                _context642.next = 15;
                return (n = (r = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(r, I, this.state.variables, this.state.context, this);

              case 15:
                _context642.next = 17;
                return (a = (o = this.options).onSuccess) == null ? void 0 : a.call(o, I, this.state.variables, this.state.context);

              case 17:
                _context642.next = 19;
                return (l = (c = this.mutationCache.config).onSettled) == null ? void 0 : l.call(c, I, null, this.state.variables, this.state.context, this);

              case 19:
                _context642.next = 21;
                return (d = (h = this.options).onSettled) == null ? void 0 : d.call(h, I, null, this.state.variables, this.state.context);

              case 21:
                this.dispatch({
                  type: "success",
                  data: I
                });
                return _context642.abrupt("return", I);

              case 25:
                _context642.prev = 25;
                _context642.t0 = _context642["catch"](1);
                _context642.prev = 27;
                _context642.next = 30;
                return (E = (y = this.mutationCache.config).onError) == null ? void 0 : E.call(y, _context642.t0, this.state.variables, this.state.context, this);

              case 30:
                _context642.next = 32;
                return (b = (C = this.options).onError) == null ? void 0 : b.call(C, _context642.t0, this.state.variables, this.state.context);

              case 32:
                _context642.next = 34;
                return (R = (M = this.mutationCache.config).onSettled) == null ? void 0 : R.call(M, void 0, _context642.t0, this.state.variables, this.state.context, this);

              case 34:
                _context642.next = 36;
                return (F = (m = this.options).onSettled) == null ? void 0 : F.call(m, void 0, _context642.t0, this.state.variables, this.state.context);

              case 36:
                throw _context642.t0;

              case 37:
                _context642.prev = 37;
                this.dispatch({
                  type: "error",
                  error: _context642.t0
                });
                return _context642.finish(37);

              case 40:
              case "end":
                return _context642.stop();
            }
          }
        }, _callee641, this, [[1, 25], [27,, 37, 40]]);
      }));
    }
  }, {
    key: "dispatch",
    value: function dispatch(e) {
      var _this215 = this;

      var i = function i(n) {
        switch (e.type) {
          case "failed":
            return $(O({}, n), {
              failureCount: e.failureCount,
              failureReason: e.error
            });

          case "pause":
            return $(O({}, n), {
              isPaused: !0
            });

          case "continue":
            return $(O({}, n), {
              isPaused: !1
            });

          case "loading":
            return $(O({}, n), {
              context: e.context,
              data: void 0,
              failureCount: 0,
              failureReason: null,
              error: null,
              isPaused: !ws(_this215.options.networkMode),
              status: "loading",
              variables: e.variables
            });

          case "success":
            return $(O({}, n), {
              data: e.data,
              failureCount: 0,
              failureReason: null,
              error: null,
              status: "success",
              isPaused: !1
            });

          case "error":
            return $(O({}, n), {
              data: void 0,
              error: e.error,
              failureCount: n.failureCount + 1,
              failureReason: e.error,
              isPaused: !1,
              status: "error"
            });

          case "setState":
            return O(O({}, n), e.state);
        }
      };

      this.state = i(this.state), ye.batch(function () {
        _this215.observers.forEach(function (n) {
          n.onMutationUpdate(e);
        }), _this215.mutationCache.notify({
          mutation: _this215,
          type: "updated",
          action: e
        });
      });
    }
  }, {
    key: "meta",
    get: function get() {
      return this.options.meta;
    }
  }]);

  return FO;
}(jp);

function kO() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}

var xO =
/*#__PURE__*/
function (_Rn4) {
  _inherits(xO, _Rn4);

  function xO(e) {
    var _this216;

    _classCallCheck(this, xO);

    _this216 = _possibleConstructorReturn(this, _getPrototypeOf(xO).call(this)), _this216.config = e || {}, _this216.mutations = [], _this216.mutationId = 0;
    return _this216;
  }

  _createClass(xO, [{
    key: "build",
    value: function build(e, i, n) {
      var r = new FO({
        mutationCache: this,
        logger: e.getLogger(),
        mutationId: ++this.mutationId,
        options: e.defaultMutationOptions(i),
        state: n,
        defaultOptions: i.mutationKey ? e.getMutationDefaults(i.mutationKey) : void 0
      });
      return this.add(r), r;
    }
  }, {
    key: "add",
    value: function add(e) {
      this.mutations.push(e), this.notify({
        type: "added",
        mutation: e
      });
    }
  }, {
    key: "remove",
    value: function remove(e) {
      this.mutations = this.mutations.filter(function (i) {
        return i !== e;
      }), this.notify({
        type: "removed",
        mutation: e
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this217 = this;

      ye.batch(function () {
        _this217.mutations.forEach(function (e) {
          _this217.remove(e);
        });
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.mutations;
    }
  }, {
    key: "find",
    value: function find(e) {
      return typeof e.exact == "undefined" && (e.exact = !0), this.mutations.find(function (i) {
        return Mc(e, i);
      });
    }
  }, {
    key: "findAll",
    value: function findAll(e) {
      return this.mutations.filter(function (i) {
        return Mc(e, i);
      });
    }
  }, {
    key: "notify",
    value: function notify(e) {
      var _this218 = this;

      ye.batch(function () {
        _this218.listeners.forEach(function (_ref88) {
          var i = _ref88.listener;
          i(e);
        });
      });
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      var _this219 = this;

      var e;
      return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(function () {
        var i = _this219.mutations.filter(function (n) {
          return n.state.isPaused;
        });

        return ye.batch(function () {
          return i.reduce(function (n, r) {
            return n.then(function () {
              return r.continue().catch(Ke);
            });
          }, Promise.resolve());
        });
      }).then(function () {
        _this219.resuming = void 0;
      }), this.resuming;
    }
  }]);

  return xO;
}(Rn);

function DO() {
  return {
    onFetch: function onFetch(t) {
      t.fetchFn = function () {
        var e, i, n, r, a, o;
        var l = (e = t.fetchOptions) == null || (i = e.meta) == null ? void 0 : i.refetchPage,
            c = (n = t.fetchOptions) == null || (r = n.meta) == null ? void 0 : r.fetchMore,
            d = c == null ? void 0 : c.pageParam,
            h = (c == null ? void 0 : c.direction) === "forward",
            p = (c == null ? void 0 : c.direction) === "backward",
            g = ((a = t.state.data) == null ? void 0 : a.pages) || [],
            f = ((o = t.state.data) == null ? void 0 : o.pageParams) || [];
        var v = f,
            E = !1;

        var y = function y(m) {
          Object.defineProperty(m, "signal", {
            enumerable: !0,
            get: function get() {
              var I;
              if ((I = t.signal) != null && I.aborted) E = !0;else {
                var w;
                (w = t.signal) == null || w.addEventListener("abort", function () {
                  E = !0;
                });
              }
              return t.signal;
            }
          });
        },
            b = t.options.queryFn || function () {
          return Promise.reject("Missing queryFn for queryKey '" + t.options.queryHash + "'");
        },
            C = function C(m, I, w, P) {
          return v = P ? [I].concat(_toConsumableArray(v)) : [].concat(_toConsumableArray(v), [I]), P ? [w].concat(_toConsumableArray(m)) : [].concat(_toConsumableArray(m), [w]);
        },
            R = function R(m, I, w, P) {
          if (E) return Promise.reject("Cancelled");
          if (typeof w == "undefined" && !I && m.length) return Promise.resolve(m);
          var k = {
            queryKey: t.queryKey,
            pageParam: w,
            meta: t.options.meta
          };
          y(k);
          var A = b(k);
          return Promise.resolve(A).then(function (Y) {
            return C(m, w, Y, P);
          });
        };

        var M;
        if (!g.length) M = R([]);else if (h) {
          var m = typeof d != "undefined",
              I = m ? d : Nc(t.options, g);
          M = R(g, m, I);
        } else if (p) {
          var _m2 = typeof d != "undefined",
              _I2 = _m2 ? d : NO(t.options, g);

          M = R(g, _m2, _I2, !0);
        } else {
          (function () {
            v = [];
            var m = typeof t.options.getNextPageParam == "undefined";
            M = (l && g[0] ? l(g[0], 0, g) : !0) ? R([], m, f[0]) : Promise.resolve(C([], f[0], g[0]));

            var _loop8 = function _loop8(w) {
              M = M.then(function (P) {
                if (l && g[w] ? l(g[w], w, g) : !0) {
                  var A = m ? f[w] : Nc(t.options, P);
                  return R(P, m, A);
                }

                return Promise.resolve(C(P, f[w], g[w]));
              });
            };

            for (var w = 1; w < g.length; w++) {
              _loop8(w);
            }
          })();
        }
        return M.then(function (m) {
          return {
            pages: m,
            pageParams: v
          };
        });
      };
    }
  };
}

function Nc(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}

function NO(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}

var LO =
/*#__PURE__*/
function () {
  function LO() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LO);

    this.queryCache = e.queryCache || new MO(), this.mutationCache = e.mutationCache || new xO(), this.logger = e.logger || xo, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0;
  }

  _createClass(LO, [{
    key: "mount",
    value: function mount() {
      var _this220 = this;

      this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = Sr.subscribe(function () {
        Sr.isFocused() && (_this220.resumePausedMutations(), _this220.queryCache.onFocus());
      }), this.unsubscribeOnline = Tr.subscribe(function () {
        Tr.isOnline() && (_this220.resumePausedMutations(), _this220.queryCache.onOnline());
      }));
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var e, i;
      this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (i = this.unsubscribeOnline) == null || i.call(this), this.unsubscribeOnline = void 0);
    }
  }, {
    key: "isFetching",
    value: function isFetching(e, i) {
      var _Mt5 = Mt(e, i),
          _Mt6 = _slicedToArray(_Mt5, 1),
          n = _Mt6[0];

      return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
    }
  }, {
    key: "isMutating",
    value: function isMutating(e) {
      return this.mutationCache.findAll($(O({}, e), {
        fetching: !0
      })).length;
    }
  }, {
    key: "getQueryData",
    value: function getQueryData(e, i) {
      var n;
      return (n = this.queryCache.find(e, i)) == null ? void 0 : n.state.data;
    }
  }, {
    key: "ensureQueryData",
    value: function ensureQueryData(e, i, n) {
      var r = Zi(e, i, n),
          a = this.getQueryData(r.queryKey);
      return a ? Promise.resolve(a) : this.fetchQuery(r);
    }
  }, {
    key: "getQueriesData",
    value: function getQueriesData(e) {
      return this.getQueryCache().findAll(e).map(function (_ref89) {
        var i = _ref89.queryKey,
            n = _ref89.state;
        var r = n.data;
        return [i, r];
      });
    }
  }, {
    key: "setQueryData",
    value: function setQueryData(e, i, n) {
      var r = this.queryCache.find(e),
          a = r == null ? void 0 : r.state.data,
          o = EO(i, a);
      if (typeof o == "undefined") return;
      var l = Zi(e),
          c = this.defaultQueryOptions(l);
      return this.queryCache.build(this, c).setData(o, $(O({}, n), {
        manual: !0
      }));
    }
  }, {
    key: "setQueriesData",
    value: function setQueriesData(e, i, n) {
      var _this221 = this;

      return ye.batch(function () {
        return _this221.getQueryCache().findAll(e).map(function (_ref90) {
          var r = _ref90.queryKey;
          return [r, _this221.setQueryData(r, i, n)];
        });
      });
    }
  }, {
    key: "getQueryState",
    value: function getQueryState(e, i) {
      var n;
      return (n = this.queryCache.find(e, i)) == null ? void 0 : n.state;
    }
  }, {
    key: "removeQueries",
    value: function removeQueries(e, i) {
      var _Mt7 = Mt(e, i),
          _Mt8 = _slicedToArray(_Mt7, 1),
          n = _Mt8[0],
          r = this.queryCache;

      ye.batch(function () {
        r.findAll(n).forEach(function (a) {
          r.remove(a);
        });
      });
    }
  }, {
    key: "resetQueries",
    value: function resetQueries(e, i, n) {
      var _this222 = this;

      var _Mt9 = Mt(e, i, n),
          _Mt10 = _slicedToArray(_Mt9, 2),
          r = _Mt10[0],
          a = _Mt10[1],
          o = this.queryCache,
          l = O({
        type: "active"
      }, r);

      return ye.batch(function () {
        return o.findAll(r).forEach(function (c) {
          c.reset();
        }), _this222.refetchQueries(l, a);
      });
    }
  }, {
    key: "cancelQueries",
    value: function cancelQueries(e, i, n) {
      var _this223 = this;

      var _Mt11 = Mt(e, i, n),
          _Mt12 = _slicedToArray(_Mt11, 2),
          r = _Mt12[0],
          _Mt12$ = _Mt12[1],
          a = _Mt12$ === void 0 ? {} : _Mt12$;

      typeof a.revert == "undefined" && (a.revert = !0);
      var o = ye.batch(function () {
        return _this223.queryCache.findAll(r).map(function (l) {
          return l.cancel(a);
        });
      });
      return Promise.all(o).then(Ke).catch(Ke);
    }
  }, {
    key: "invalidateQueries",
    value: function invalidateQueries(e, i, n) {
      var _this224 = this;

      var _Mt13 = Mt(e, i, n),
          _Mt14 = _slicedToArray(_Mt13, 2),
          r = _Mt14[0],
          a = _Mt14[1];

      return ye.batch(function () {
        var o, l;
        if (_this224.queryCache.findAll(r).forEach(function (d) {
          d.invalidate();
        }), r.refetchType === "none") return Promise.resolve();
        var c = $(O({}, r), {
          type: (o = (l = r.refetchType) != null ? l : r.type) != null ? o : "active"
        });
        return _this224.refetchQueries(c, a);
      });
    }
  }, {
    key: "refetchQueries",
    value: function refetchQueries(e, i, n) {
      var _this225 = this;

      var _Mt15 = Mt(e, i, n),
          _Mt16 = _slicedToArray(_Mt15, 2),
          r = _Mt16[0],
          a = _Mt16[1],
          o = ye.batch(function () {
        return _this225.queryCache.findAll(r).filter(function (c) {
          return !c.isDisabled();
        }).map(function (c) {
          var d;
          return c.fetch(void 0, $(O({}, a), {
            cancelRefetch: (d = a == null ? void 0 : a.cancelRefetch) != null ? d : !0,
            meta: {
              refetchPage: r.refetchPage
            }
          }));
        });
      });

      var l = Promise.all(o).then(Ke);
      return a != null && a.throwOnError || (l = l.catch(Ke)), l;
    }
  }, {
    key: "fetchQuery",
    value: function fetchQuery(e, i, n) {
      var r = Zi(e, i, n),
          a = this.defaultQueryOptions(r);
      typeof a.retry == "undefined" && (a.retry = !1);
      var o = this.queryCache.build(this, a);
      return o.isStaleByTime(a.staleTime) ? o.fetch(a) : Promise.resolve(o.state.data);
    }
  }, {
    key: "prefetchQuery",
    value: function prefetchQuery(e, i, n) {
      return this.fetchQuery(e, i, n).then(Ke).catch(Ke);
    }
  }, {
    key: "fetchInfiniteQuery",
    value: function fetchInfiniteQuery(e, i, n) {
      var r = Zi(e, i, n);
      return r.behavior = DO(), this.fetchQuery(r);
    }
  }, {
    key: "prefetchInfiniteQuery",
    value: function prefetchInfiniteQuery(e, i, n) {
      return this.fetchInfiniteQuery(e, i, n).then(Ke).catch(Ke);
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      return this.mutationCache.resumePausedMutations();
    }
  }, {
    key: "getQueryCache",
    value: function getQueryCache() {
      return this.queryCache;
    }
  }, {
    key: "getMutationCache",
    value: function getMutationCache() {
      return this.mutationCache;
    }
  }, {
    key: "getLogger",
    value: function getLogger() {
      return this.logger;
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return this.defaultOptions;
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions(e) {
      this.defaultOptions = e;
    }
  }, {
    key: "setQueryDefaults",
    value: function setQueryDefaults(e, i) {
      var n = this.queryDefaults.find(function (r) {
        return Yt(e) === Yt(r.queryKey);
      });
      n ? n.defaultOptions = i : this.queryDefaults.push({
        queryKey: e,
        defaultOptions: i
      });
    }
  }, {
    key: "getQueryDefaults",
    value: function getQueryDefaults(e) {
      if (!e) return;
      var i = this.queryDefaults.find(function (n) {
        return Cr(e, n.queryKey);
      });
      return i == null ? void 0 : i.defaultOptions;
    }
  }, {
    key: "setMutationDefaults",
    value: function setMutationDefaults(e, i) {
      var n = this.mutationDefaults.find(function (r) {
        return Yt(e) === Yt(r.mutationKey);
      });
      n ? n.defaultOptions = i : this.mutationDefaults.push({
        mutationKey: e,
        defaultOptions: i
      });
    }
  }, {
    key: "getMutationDefaults",
    value: function getMutationDefaults(e) {
      if (!e) return;
      var i = this.mutationDefaults.find(function (n) {
        return Cr(e, n.mutationKey);
      });
      return i == null ? void 0 : i.defaultOptions;
    }
  }, {
    key: "defaultQueryOptions",
    value: function defaultQueryOptions(e) {
      if (e != null && e._defaulted) return e;
      var i = $(O(O(O({}, this.defaultOptions.queries), this.getQueryDefaults(e == null ? void 0 : e.queryKey)), e), {
        _defaulted: !0
      });
      return !i.queryHash && i.queryKey && (i.queryHash = ko(i.queryKey, i)), typeof i.refetchOnReconnect == "undefined" && (i.refetchOnReconnect = i.networkMode !== "always"), typeof i.useErrorBoundary == "undefined" && (i.useErrorBoundary = !!i.suspense), i;
    }
  }, {
    key: "defaultMutationOptions",
    value: function defaultMutationOptions(e) {
      return e != null && e._defaulted ? e : $(O(O(O({}, this.defaultOptions.mutations), this.getMutationDefaults(e == null ? void 0 : e.mutationKey)), e), {
        _defaulted: !0
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.queryCache.clear(), this.mutationCache.clear();
    }
  }]);

  return LO;
}();

var $O =
/*#__PURE__*/
function (_Rn5) {
  _inherits($O, _Rn5);

  function $O(e, i) {
    var _this226;

    _classCallCheck(this, $O);

    _this226 = _possibleConstructorReturn(this, _getPrototypeOf($O).call(this)), _this226.client = e, _this226.options = i, _this226.trackedProps =
    /* @__PURE__ */
    new Set(), _this226.selectError = null, _this226.bindMethods(), _this226.setOptions(i);
    return _this226;
  }

  _createClass($O, [{
    key: "bindMethods",
    value: function bindMethods() {
      this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe() {
      this.listeners.size === 1 && (this.currentQuery.addObserver(this), Lc(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      this.hasListeners() || this.destroy();
    }
  }, {
    key: "shouldFetchOnReconnect",
    value: function shouldFetchOnReconnect() {
      return ka(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
  }, {
    key: "shouldFetchOnWindowFocus",
    value: function shouldFetchOnWindowFocus() {
      return ka(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.listeners =
      /* @__PURE__ */
      new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(e, i) {
      var n = this.options,
          r = this.currentQuery;
      if (this.options = this.client.defaultQueryOptions(e), Aa(n, this.options) || this.client.getQueryCache().notify({
        type: "observerOptionsUpdated",
        query: this.currentQuery,
        observer: this
      }), typeof this.options.enabled != "undefined" && typeof this.options.enabled != "boolean") throw new Error("Expected enabled to be a boolean");
      this.options.queryKey || (this.options.queryKey = n.queryKey), this.updateQuery();
      var a = this.hasListeners();
      a && $c(this.currentQuery, r, this.options, n) && this.executeFetch(), this.updateResult(i), a && (this.currentQuery !== r || this.options.enabled !== n.enabled || this.options.staleTime !== n.staleTime) && this.updateStaleTimeout();
      var o = this.computeRefetchInterval();
      a && (this.currentQuery !== r || this.options.enabled !== n.enabled || o !== this.currentRefetchInterval) && this.updateRefetchInterval(o);
    }
  }, {
    key: "getOptimisticResult",
    value: function getOptimisticResult(e) {
      var i = this.client.getQueryCache().build(this.client, e),
          n = this.createResult(i, e);
      return BO(this, n, e) && (this.currentResult = n, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), n;
    }
  }, {
    key: "getCurrentResult",
    value: function getCurrentResult() {
      return this.currentResult;
    }
  }, {
    key: "trackResult",
    value: function trackResult(e) {
      var _this227 = this;

      var i = {};
      return Object.keys(e).forEach(function (n) {
        Object.defineProperty(i, n, {
          configurable: !1,
          enumerable: !0,
          get: function get() {
            return _this227.trackedProps.add(n), e[n];
          }
        });
      }), i;
    }
  }, {
    key: "getCurrentQuery",
    value: function getCurrentQuery() {
      return this.currentQuery;
    }
  }, {
    key: "remove",
    value: function remove() {
      this.client.getQueryCache().remove(this.currentQuery);
    }
  }, {
    key: "refetch",
    value: function refetch() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var r = n,
          e = r.refetchPage,
          i = An(r, ["refetchPage"]);
      return this.fetch($(O({}, i), {
        meta: {
          refetchPage: e
        }
      }));
    }
  }, {
    key: "fetchOptimistic",
    value: function fetchOptimistic(e) {
      var _this228 = this;

      var i = this.client.defaultQueryOptions(e),
          n = this.client.getQueryCache().build(this.client, i);
      return n.isFetchingOptimistic = !0, n.fetch().then(function () {
        return _this228.createResult(n, i);
      });
    }
  }, {
    key: "fetch",
    value: function fetch(e) {
      var _this229 = this;

      var i;
      return this.executeFetch($(O({}, e), {
        cancelRefetch: (i = e.cancelRefetch) != null ? i : !0
      })).then(function () {
        return _this229.updateResult(), _this229.currentResult;
      });
    }
  }, {
    key: "executeFetch",
    value: function executeFetch(e) {
      this.updateQuery();
      var i = this.currentQuery.fetch(this.options, e);
      return e != null && e.throwOnError || (i = i.catch(Ke)), i;
    }
  }, {
    key: "updateStaleTimeout",
    value: function updateStaleTimeout() {
      var _this230 = this;

      if (this.clearStaleTimeout(), gn || this.currentResult.isStale || !Oa(this.options.staleTime)) return;
      var i = Lp(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
      this.staleTimeoutId = setTimeout(function () {
        _this230.currentResult.isStale || _this230.updateResult();
      }, i);
    }
  }, {
    key: "computeRefetchInterval",
    value: function computeRefetchInterval() {
      var e;
      return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (e = this.options.refetchInterval) != null ? e : !1;
    }
  }, {
    key: "updateRefetchInterval",
    value: function updateRefetchInterval(e) {
      var _this231 = this;

      this.clearRefetchInterval(), this.currentRefetchInterval = e, !(gn || this.options.enabled === !1 || !Oa(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(function () {
        (_this231.options.refetchIntervalInBackground || Sr.isFocused()) && _this231.executeFetch();
      }, this.currentRefetchInterval));
    }
  }, {
    key: "updateTimers",
    value: function updateTimers() {
      this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
    }
  }, {
    key: "clearStaleTimeout",
    value: function clearStaleTimeout() {
      this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
    }
  }, {
    key: "clearRefetchInterval",
    value: function clearRefetchInterval() {
      this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
    }
  }, {
    key: "createResult",
    value: function createResult(e, i) {
      var n = this.currentQuery,
          r = this.options,
          a = this.currentResult,
          o = this.currentResultState,
          l = this.currentResultOptions,
          c = e !== n,
          d = c ? e.state : this.currentQueryInitialState,
          h = c ? this.currentResult : this.previousQueryResult,
          p = e.state;
      var g = p.dataUpdatedAt,
          f = p.error,
          v = p.errorUpdatedAt,
          E = p.fetchStatus,
          y = p.status,
          b = !1,
          C = !1,
          R;

      if (i._optimisticResults) {
        var w = this.hasListeners(),
            P = !w && Lc(e, i),
            k = w && $c(e, n, i, r);
        (P || k) && (E = ws(e.options.networkMode) ? "fetching" : "paused", g || (y = "loading")), i._optimisticResults === "isRestoring" && (E = "idle");
      }

      if (i.keepPreviousData && !p.dataUpdatedAt && h != null && h.isSuccess && y !== "error") R = h.data, g = h.dataUpdatedAt, y = h.status, b = !0;else if (i.select && typeof p.data != "undefined") {
        if (a && p.data === (o == null ? void 0 : o.data) && i.select === this.selectFn) R = this.selectResult;else try {
          this.selectFn = i.select, R = i.select(p.data), R = Fa(a == null ? void 0 : a.data, R, i), this.selectResult = R, this.selectError = null;
        } catch (w) {
          this.selectError = w;
        }
      } else R = p.data;

      if (typeof i.placeholderData != "undefined" && typeof R == "undefined" && y === "loading") {
        var _w2;

        if (a != null && a.isPlaceholderData && i.placeholderData === (l == null ? void 0 : l.placeholderData)) _w2 = a.data;else if (_w2 = typeof i.placeholderData == "function" ? i.placeholderData() : i.placeholderData, i.select && typeof _w2 != "undefined") try {
          _w2 = i.select(_w2), this.selectError = null;
        } catch (P) {
          this.selectError = P;
        }
        typeof _w2 != "undefined" && (y = "success", R = Fa(a == null ? void 0 : a.data, _w2, i), C = !0);
      }

      this.selectError && (f = this.selectError, R = this.selectResult, v = Date.now(), y = "error");
      var M = E === "fetching",
          F = y === "loading",
          m = y === "error";
      return {
        status: y,
        fetchStatus: E,
        isLoading: F,
        isSuccess: y === "success",
        isError: m,
        isInitialLoading: F && M,
        data: R,
        dataUpdatedAt: g,
        error: f,
        errorUpdatedAt: v,
        failureCount: p.fetchFailureCount,
        failureReason: p.fetchFailureReason,
        errorUpdateCount: p.errorUpdateCount,
        isFetched: p.dataUpdateCount > 0 || p.errorUpdateCount > 0,
        isFetchedAfterMount: p.dataUpdateCount > d.dataUpdateCount || p.errorUpdateCount > d.errorUpdateCount,
        isFetching: M,
        isRefetching: M && !F,
        isLoadingError: m && p.dataUpdatedAt === 0,
        isPaused: E === "paused",
        isPlaceholderData: C,
        isPreviousData: b,
        isRefetchError: m && p.dataUpdatedAt !== 0,
        isStale: Do(e, i),
        refetch: this.refetch,
        remove: this.remove
      };
    }
  }, {
    key: "updateResult",
    value: function updateResult(e) {
      var _this232 = this;

      var i = this.currentResult,
          n = this.createResult(this.currentQuery, this.options);
      if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, Aa(n, i)) return;
      this.currentResult = n;

      var r = {
        cache: !0
      },
          a = function a() {
        if (!i) return !0;
        var o = _this232.options.notifyOnChangeProps,
            l = typeof o == "function" ? o() : o;
        if (l === "all" || !l && !_this232.trackedProps.size) return !0;
        var c = new Set(l != null ? l : _this232.trackedProps);
        return _this232.options.useErrorBoundary && c.add("error"), Object.keys(_this232.currentResult).some(function (d) {
          var h = d;
          return _this232.currentResult[h] !== i[h] && c.has(h);
        });
      };

      (e == null ? void 0 : e.listeners) !== !1 && a() && (r.listeners = !0), this.notify(O(O({}, r), e));
    }
  }, {
    key: "updateQuery",
    value: function updateQuery() {
      var e = this.client.getQueryCache().build(this.client, this.options);
      if (e === this.currentQuery) return;
      var i = this.currentQuery;
      this.currentQuery = e, this.currentQueryInitialState = e.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (i == null || i.removeObserver(this), e.addObserver(this));
    }
  }, {
    key: "onQueryUpdate",
    value: function onQueryUpdate(e) {
      var i = {};
      e.type === "success" ? i.onSuccess = !e.manual : e.type === "error" && !tr(e.error) && (i.onError = !0), this.updateResult(i), this.hasListeners() && this.updateTimers();
    }
  }, {
    key: "notify",
    value: function notify(e) {
      var _this233 = this;

      ye.batch(function () {
        if (e.onSuccess) {
          var i, n, r, a;
          (i = (n = _this233.options).onSuccess) == null || i.call(n, _this233.currentResult.data), (r = (a = _this233.options).onSettled) == null || r.call(a, _this233.currentResult.data, null);
        } else if (e.onError) {
          var o, l, c, d;
          (o = (l = _this233.options).onError) == null || o.call(l, _this233.currentResult.error), (c = (d = _this233.options).onSettled) == null || c.call(d, void 0, _this233.currentResult.error);
        }

        e.listeners && _this233.listeners.forEach(function (_ref91) {
          var h = _ref91.listener;
          h(_this233.currentResult);
        }), e.cache && _this233.client.getQueryCache().notify({
          query: _this233.currentQuery,
          type: "observerResultsUpdated"
        });
      });
    }
  }]);

  return $O;
}(Rn);

function UO(t, e) {
  return e.enabled !== !1 && !t.state.dataUpdatedAt && !(t.state.status === "error" && e.retryOnMount === !1);
}

function Lc(t, e) {
  return UO(t, e) || t.state.dataUpdatedAt > 0 && ka(t, e, e.refetchOnMount);
}

function ka(t, e, i) {
  if (e.enabled !== !1) {
    var n = typeof i == "function" ? i(t) : i;
    return n === "always" || n !== !1 && Do(t, e);
  }

  return !1;
}

function $c(t, e, i, n) {
  return i.enabled !== !1 && (t !== e || n.enabled === !1) && (!i.suspense || t.state.status !== "error") && Do(t, i);
}

function Do(t, e) {
  return t.isStaleByTime(e.staleTime);
}

function BO(t, e, i) {
  return i.keepPreviousData ? !1 : i.placeholderData !== void 0 ? e.isPlaceholderData : !Aa(t.getCurrentResult(), e);
}

var Wp = {
  exports: {}
},
    Gp = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var Pi = Zt;

function HO(t, e) {
  return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
}

var VO = typeof Object.is == "function" ? Object.is : HO,
    jO = Pi.useState,
    WO = Pi.useEffect,
    GO = Pi.useLayoutEffect,
    zO = Pi.useDebugValue;

function qO(t, e) {
  var i = e(),
      n = jO({
    inst: {
      value: i,
      getSnapshot: e
    }
  }),
      r = n[0].inst,
      a = n[1];
  return GO(function () {
    r.value = i, r.getSnapshot = e, Zs(r) && a({
      inst: r
    });
  }, [t, i, e]), WO(function () {
    return Zs(r) && a({
      inst: r
    }), t(function () {
      Zs(r) && a({
        inst: r
      });
    });
  }, [t]), zO(i), i;
}

function Zs(t) {
  var e = t.getSnapshot;
  t = t.value;

  try {
    var i = e();
    return !VO(t, i);
  } catch (n) {
    return !0;
  }
}

function QO(t, e) {
  return e();
}

var YO = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? QO : qO;
Gp.useSyncExternalStore = Pi.useSyncExternalStore !== void 0 ? Pi.useSyncExternalStore : YO;

(function (t) {
  t.exports = Gp;
})(Wp);

var KO = Wp.exports.useSyncExternalStore,
    Uc =
/* @__PURE__ */
ve.createContext(void 0),
    zp =
/* @__PURE__ */
ve.createContext(!1);

function qp(t, e) {
  return t || (e && typeof window != "undefined" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = Uc), window.ReactQueryClientContext) : Uc);
}

var JO = function JO() {
  var _ref92 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      t = _ref92.context;

  var e = ve.useContext(qp(t, ve.useContext(zp)));
  if (!e) throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
},
    XO = function XO(_ref93) {
  var t = _ref93.client,
      e = _ref93.children,
      i = _ref93.context,
      _ref93$contextSharing = _ref93.contextSharing,
      n = _ref93$contextSharing === void 0 ? !1 : _ref93$contextSharing;
  ve.useEffect(function () {
    return t.mount(), function () {
      t.unmount();
    };
  }, [t]);
  var r = qp(i, n);
  return (
    /* @__PURE__ */
    _(zp.Provider, {
      value: !i && n,
      children:
      /* @__PURE__ */
      _(r.Provider, {
        value: t,
        children: e
      })
    })
  );
},
    Qp =
/* @__PURE__ */
ve.createContext(!1),
    ZO = function ZO() {
  return ve.useContext(Qp);
};

Qp.Provider;

function eA() {
  var t = !1;
  return {
    clearReset: function clearReset() {
      t = !1;
    },
    reset: function reset() {
      t = !0;
    },
    isReset: function isReset() {
      return t;
    }
  };
}

var tA =
/* @__PURE__ */
ve.createContext(eA()),
    iA = function iA() {
  return ve.useContext(tA);
};

function nA(t, e) {
  return typeof t == "function" ? t.apply(void 0, _toConsumableArray(e)) : !!t;
}

var rA = function rA(t, e) {
  (t.suspense || t.useErrorBoundary) && (e.isReset() || (t.retryOnMount = !1));
},
    sA = function sA(t) {
  ve.useEffect(function () {
    t.clearReset();
  }, [t]);
},
    aA = function aA(_ref94) {
  var t = _ref94.result,
      e = _ref94.errorResetBoundary,
      i = _ref94.useErrorBoundary,
      n = _ref94.query;
  return t.isError && !e.isReset() && !t.isFetching && nA(i, [t.error, n]);
},
    oA = function oA(t) {
  t.suspense && typeof t.staleTime != "number" && (t.staleTime = 1e3);
},
    lA = function lA(t, e) {
  return t.isLoading && t.isFetching && !e;
},
    cA = function cA(t, e, i) {
  return (t == null ? void 0 : t.suspense) && lA(e, i);
},
    uA = function uA(t, e, i) {
  return e.fetchOptimistic(t).then(function (_ref95) {
    var n = _ref95.data;
    t.onSuccess == null || t.onSuccess(n), t.onSettled == null || t.onSettled(n, null);
  }).catch(function (n) {
    i.clearReset(), t.onError == null || t.onError(n), t.onSettled == null || t.onSettled(void 0, n);
  });
};

function dA(t, e) {
  var i = JO({
    context: t.context
  }),
      n = ZO(),
      r = iA(),
      a = i.defaultQueryOptions(t);
  a._optimisticResults = n ? "isRestoring" : "optimistic", a.onError && (a.onError = ye.batchCalls(a.onError)), a.onSuccess && (a.onSuccess = ye.batchCalls(a.onSuccess)), a.onSettled && (a.onSettled = ye.batchCalls(a.onSettled)), oA(a), rA(a, r), sA(r);

  var _ve$useState = ve.useState(function () {
    return new e(i, a);
  }),
      _ve$useState2 = _slicedToArray(_ve$useState, 1),
      o = _ve$useState2[0],
      l = o.getOptimisticResult(a);

  if (KO(ve.useCallback(function (c) {
    var d = n ? function () {} : o.subscribe(ye.batchCalls(c));
    return o.updateResult(), d;
  }, [o, n]), function () {
    return o.getCurrentResult();
  }, function () {
    return o.getCurrentResult();
  }), ve.useEffect(function () {
    o.setOptions(a, {
      listeners: !1
    });
  }, [a, o]), cA(a, l, n)) throw uA(a, o, r);
  if (aA({
    result: l,
    errorResetBoundary: r,
    useErrorBoundary: a.useErrorBoundary,
    query: o.getCurrentQuery()
  })) throw l.error;
  return a.notifyOnChangeProps ? l : o.trackResult(l);
}

function Yp(t, e, i) {
  var n = Zi(t, e, i);
  return dA(n, $O);
}

var hA = function hA(t, e, i) {
  var _de8 = de(Pt),
      n = _de8.https,
      r = mt(function () {
    return JSON.stringify(t);
  }, [t, e, i]),
      _Yp = Yp({
    queryKey: ["discussionsPosts", r],
    queryFn: function queryFn() {
      return n.getAllPosts(t, e);
    }
  }),
      a = _Yp.isLoading,
      o = _Yp.isError,
      l = _Yp.data,
      c = _Yp.error;

  return {
    isLoading: a,
    isError: o,
    error: c,
    data: l
  };
},
    Kp = function Kp() {
  return (
    /* @__PURE__ */
    _("div", {
      "data-testid": "spinner",
      className: "dw-flex dw-justify-center dw-my-80",
      children:
      /* @__PURE__ */
      j("svg", {
        className: "dw-mr-2 dw-w-16 dw-h-16 dw-text-gray-200 dw-animate-spin dw-dark:text-gray-600 dw-fill-gray-600 dw-dark:fill-gray-300",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
        /* @__PURE__ */
        _("path", {
          d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
          fill: "currentColor"
        }),
        /* @__PURE__ */
        _("path", {
          d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
          fill: "currentFill"
        })]
      })
    })
  );
},
    pA = function pA(t) {
  var e = document.createElement("div");
  return e.setAttribute("id", t), document.body.appendChild(e), e;
},
    No = function No(_ref96) {
  var t = _ref96.children,
      e = _ref96.wrapperId;

  var _K19 = K(null),
      _K20 = _slicedToArray(_K19, 2),
      i = _K20[0],
      n = _K20[1];

  return Oi(function () {
    var r = document.getElementById(e),
        a = !1;
    return r || (a = !0, r = pA(e)), n(r), function () {
      a && r.parentNode && r.parentNode.removeChild(r);
    };
  }, [e]), i === null ? null : lf.createPortal(t, i);
},
    bs = function bs() {
  return (
    /* @__PURE__ */
    j("svg", {
      className: "dw-h-4 dw-w-4 dw-animate-spin dw-mr-2",
      viewBox: "3 3 18 18",
      children: [
      /* @__PURE__ */
      _("path", {
        d: "M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */
      _("path", {
        d: "M16.9497 7.05015C14.2161 4.31648 9.78392 4.31648 7.05025 7.05015C6.65973 7.44067 6.02656 7.44067 5.63604 7.05015C5.24551 6.65962 5.24551 6.02646 5.63604 5.63593C9.15076 2.12121 14.8492 2.12121 18.364 5.63593C18.7545 6.02646 18.7545 6.65962 18.364 7.05015C17.9734 7.44067 17.3403 7.44067 16.9497 7.05015Z",
        fill: "currentFill"
      })]
    })
  );
},
    fA = function fA(_ref97) {
  var t = _ref97.postIds,
      e = _ref97.refetchPosts,
      i = _ref97.isOpen,
      n = _ref97.handleClose,
      r = _ref97.setSelectedPosts;

  var _K21 = K(""),
      _K22 = _slicedToArray(_K21, 2),
      a = _K22[0],
      o = _K22[1],
      _K23 = K(!1),
      _K24 = _slicedToArray(_K23, 2),
      l = _K24[0],
      c = _K24[1],
      _de9 = de(Ie),
      d = _de9.validationModerateReasonErrorMessage,
      h = _de9.moderatePostsMessage,
      p = _de9.moderatePostsErrorMessage,
      g = _de9.reason,
      f = _de9.moderate,
      v = _de9.cancel,
      E = _de9.posts,
      _de10 = de(Pt),
      y = _de10.https;

  Oi(function () {
    return i && document.body.addEventListener("keydown", b), function () {
      document.body.removeEventListener("keydown", b);
    };
  }, [n]);

  var b = function b(M) {
    return M.key === "Escape" && !l ? n() : null;
  },
      C = function C(M) {
    return o(M.target.value);
  },
      R = function R() {
    return u(void 0, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee642() {
      return _regeneratorRuntime.wrap(function _callee642$(_context643) {
        while (1) {
          switch (_context643.prev = _context643.next) {
            case 0:
              if (!(c(!0), !a)) {
                _context643.next = 3;
                break;
              }

              X.error(d), c(!1);
              return _context643.abrupt("return");

            case 3:
              _context643.prev = 3;
              _context643.next = 6;
              return y.moderatePosts(t, a);

            case 6:
              X.success(h);
              r([]);
              e.current = !e.current;
              n();
              _context643.next = 15;
              break;

            case 12:
              _context643.prev = 12;
              _context643.t0 = _context643["catch"](3);
              console.error(_context643.t0), X.error(p);

            case 15:
              c(!1);

            case 16:
            case "end":
              return _context643.stop();
          }
        }
      }, _callee642, null, [[3, 12]]);
    }));
  };

  return i ?
  /* @__PURE__ */
  _(No, {
    wrapperId: "moderate-posts-modal",
    children:
    /* @__PURE__ */
    j(Ne, {
      children: [
      /* @__PURE__ */
      _("div", {
        className: "dw-justify-center dw-items-center dw-flex dw-overflow-x-hidden dw-overflow-y-hidden dw-absolute dw-inset-0 dw-z-50 dw-top-0 dw-right-0 dw-bottom-0 dw-left-0 dw-outline-none focus:dw-outline-none",
        children:
        /* @__PURE__ */
        _("div", {
          className: "dw-relative dw-w-full dw-my-6 dw-mx-auto dw-max-w-lg",
          children:
          /* @__PURE__ */
          j("div", {
            className: "dw-border-0 dw-rounded-lg dw-shadow-lg dw-relative dw-flex dw-flex-col dw-w-full dw-bg-white dw-outline-none focus:dw-outline-none",
            children: [
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-justify-items-center dw-p-4 dw-border-b dw-border-solid dw-border-gray-200",
              children: [
              /* @__PURE__ */
              j("h3", {
                className: "dw-text-2xl dw-font-semibold dw-mr-2",
                children: [f, " ", E]
              }),
              /* @__PURE__ */
              _("button", {
                className: "dw-flex dw-justify-items-center dw-ml-auto dw-bg-transparent dw-border-0 dw-leading-none dw-font-semibold dw-outline-none focus:dw-outline-none",
                onClick: n,
                children:
                /* @__PURE__ */
                _("span", {
                  className: "dw-bg-transparent dw-h-6 dw-w-6 dw-text-2xl dw-block dw-outline-none focus:dw-outline-none dw-text-red-500 hover:dw-text-red-600",
                  children: "x"
                })
              })]
            }),
            /* @__PURE__ */
            j("div", {
              className: "dw-relative dw-whitespace-nowrap dw-p-4 dw-text-gray-500 dw-text-lg dw-mb-4",
              children: [
              /* @__PURE__ */
              _("p", {
                className: "dw-mb-2",
                children: g
              }),
              /* @__PURE__ */
              _("textarea", {
                className: "dw-rounded dw-border dw-border-gray-200 focus:dw-outline-none dw-px-3 dw-py-2 dw-w-full",
                rows: 8,
                onChange: C
              })]
            }),
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-items-center dw-justify-end dw-p-3 dw-border-t dw-border-solid dw-border-gray-200 dw-rounded-b",
              children: [
              /* @__PURE__ */
              j("button", {
                className: "".concat(l ? "dw-bg-gray-600" : "dw-bg-brandColor hover:dw-bg-blue-700", " dw-text-white dw-font-bold dw-px-4 dw-py-2 dw-text-sm dw-rounded dw-outline-none focus:dw-outline-none dw-mr-2 dw-mb-1 dw-ease-linear dw-transition-all dw-duration-150"),
                onClick: R,
                disabled: l,
                children: [l ?
                /* @__PURE__ */
                _(bs, {}) :
                /* @__PURE__ */
                _(Ne, {}), f]
              }),
              /* @__PURE__ */
              _("button", {
                className: "".concat(l ? "dw-bg-gray-600" : "dw-bg-red-500 hover:dw-bg-red-700", " dw-text-white dw-font-bold dw-text-sm dw-px-4 dw-py-2 dw-rounded dw-outline-none focus:dw-outline-none dw-mr-2 dw-mb-1 dw-ease-linear dw-transition-all dw-duration-150"),
                onClick: n,
                disabled: l,
                children: v
              })]
            })]
          })
        })
      }),
      /* @__PURE__ */
      _("div", {
        className: "dw-opacity-80 dw-fixed dw-inset-0 dw-z-40 dw-bg-black dw-top-0 dw-right-0 dw-bottom-0 dw-left-0"
      })]
    })
  }) : null;
},
    mA = function mA() {
  var _K25 = K(new aE()),
      _K26 = _slicedToArray(_K25, 2),
      t = _K26[0],
      e = _K26[1],
      _K27 = K(1),
      _K28 = _slicedToArray(_K27, 2),
      i = _K28[0],
      n = _K28[1],
      _K29 = K(""),
      _K30 = _slicedToArray(_K29, 2),
      r = _K30[0],
      a = _K30[1],
      _K31 = K(
  /* @__PURE__ */
  new Map()),
      _K32 = _slicedToArray(_K31, 2),
      o = _K32[0],
      l = _K32[1],
      _K33 = K([]),
      _K34 = _slicedToArray(_K33, 2),
      c = _K34[0],
      d = _K34[1],
      _K35 = K(!1),
      _K36 = _slicedToArray(_K35, 2),
      h = _K36[0],
      p = _K36[1],
      _K37 = K([]),
      _K38 = _slicedToArray(_K37, 2),
      g = _K38[0],
      f = _K38[1],
      v = Te(!1),
      _hA = hA(t, r, v.current),
      E = _hA.isLoading,
      y = _hA.isError,
      b = _hA.error,
      C = _hA.data,
      _de11 = de(Ie),
      R = _de11.getPostsErrorMessage,
      M = _de11.noPostsFound;

  He(function () {
    if (C) {
      var A = new Map(o).set(i, C.data);
      l(A);
    }
  }, [C, r]), He(function () {
    if (C && C.data && C.data.length > 0 && !Array.from(o.keys()).includes(i)) {
      var A = C.data[C.data.length - 1].id;
      a(A);
    }
  }, [i]);

  var F = function F() {
    return n(function (A) {
      return A - 1;
    });
  },
      m = function m() {
    return n(function (A) {
      return A + 1;
    });
  },
      I = function I(A) {
    return d(function (G) {
      return G.includes(A) ? G.filter(function (Y) {
        return Y !== A;
      }) : [].concat(_toConsumableArray(G), [A]);
    });
  },
      w = function w() {
    return p(!h);
  },
      P = function P(A) {
    I(A), p(!h);
  },
      k = function k() {
    n(1), l(
    /* @__PURE__ */
    new Map());
  };

  return y ? (X.error(R), console.error(b),
  /* @__PURE__ */
  _(Oc, {
    filters: t,
    setFilters: e,
    handleResetPosts: k,
    setFilteredDiscussions: f
  })) :
  /* @__PURE__ */
  j(Ne, {
    children: [
    /* @__PURE__ */
    _(Oc, {
      filters: t,
      setFilters: e,
      handleResetPosts: k,
      setFilteredDiscussions: f
    }),
    /* @__PURE__ */
    _("div", {
      className: "dw-mb-6",
      children:
      /* @__PURE__ */
      _(Np, {
        onModeratePosts: w,
        isActiveModerateButton: c.length > 0
      })
    }), E ?
    /* @__PURE__ */
    _(Kp, {}) :
    /* @__PURE__ */
    _(Ne, {
      children: o.get(i) && o.get(i).length > 0 ?
      /* @__PURE__ */
      j(Ne, {
        children: [
        /* @__PURE__ */
        _(IO, {
          posts: o.get(i),
          selectedPosts: c,
          handleSelectPost: I,
          onModeratePost: P,
          filteredDiscussions: g
        }),
        /* @__PURE__ */
        _(_O, {
          pageCount: i,
          getPreviousPage: F,
          getNextPage: m,
          onModeratePosts: w,
          pagePosts: o,
          isActiveModerateButton: c.length > 0
        })]
      }) :
      /* @__PURE__ */
      _("h2", {
        className: "dw-text-center dw-font-bold dw-text-xl dw-my-60",
        children: M
      })
    }),
    /* @__PURE__ */
    _(fA, {
      isOpen: h,
      handleClose: w,
      postIds: c,
      setSelectedPosts: d,
      refetchPosts: v
    })]
  });
},
    gA = function gA(t) {
  return t.map(function (e) {
    return {
      id: e.id,
      value: e.nickname ? e.nickname : e.name,
      label: e.nickname ? e.nickname : e.name,
      avatar: e.avatar
    };
  });
},
    yA = function yA(_ref98) {
  var t = _ref98.profileOption,
      e = _ref98.setProfileOption;

  var _de12 = de(Ie),
      i = _de12.profileIdsSelectPlaceholder,
      n = _de12.loading,
      r = _de12.noOptionsMessage,
      a = _de12.getProfilesErrorMessage,
      _de13 = de(Pt),
      o = _de13.sdk,
      l = function l(p) {
    e(p);
  },
      c = 3,
      h = kp(function (p, g) {
    if (p.length < c) return g([]);
    var f = !0;
    o.profile.getByIds([], p, f).then(function (v) {
      g(gA(v));
    }).catch(function (v) {
      X.error(a), console.error(v), g([]);
    });
  }, 300);

  return (
    /* @__PURE__ */
    _("div", {
      className: "dw-w-1/2 dw-mb-6",
      children:
      /* @__PURE__ */
      _(hh, {
        components: {
          DropdownIndicator: null
        },
        isClearable: !0,
        getOptionValue: function getOptionValue(p) {
          return p.id;
        },
        styles: xp,
        onChange: l,
        noOptionsMessage: function noOptionsMessage() {
          return r;
        },
        loadingMessage: function loadingMessage() {
          return n;
        },
        value: t,
        loadOptions: h,
        placeholder: i,
        formatOptionLabel: function formatOptionLabel(p) {
          return (
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-flex-justify-start",
              children: [
              /* @__PURE__ */
              _("img", {
                src: p.avatar ? p.avatar : Er.avatar,
                alt: "profile-logo",
                className: "dw-rounded-full dw-object-cover dw-h-6 dw-w-6 dw-mr-1"
              }),
              /* @__PURE__ */
              _("span", {
                children: p.label
              })]
            })
          );
        }
      })
    })
  );
},
    vA = function vA(_ref99) {
  var t = _ref99.profileId,
      e = _ref99.profileName,
      i = _ref99.isOpen,
      n = _ref99.handleClose;

  var _K39 = K(""),
      _K40 = _slicedToArray(_K39, 2),
      r = _K40[0],
      a = _K40[1],
      _K41 = K(!1),
      _K42 = _slicedToArray(_K41, 2),
      o = _K42[0],
      l = _K42[1],
      _de14 = de(Ie),
      c = _de14.validationModerateReasonErrorMessage,
      d = _de14.moderateProfileMessage,
      h = _de14.moderateProfileErrorMessage,
      p = _de14.moderateProfileModalDescription,
      g = _de14.reason,
      f = _de14.moderate,
      v = _de14.cancel,
      _de15 = de(Pt),
      E = _de15.https;

  Oi(function () {
    return i && document.body.addEventListener("keydown", y), function () {
      document.body.removeEventListener("keydown", y);
    };
  }, [n]);

  var y = function y(R) {
    return R.key === "Escape" && !o ? n() : null;
  },
      b = function b(R) {
    return a(R.target.value);
  },
      C = function C() {
    return u(void 0, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee643() {
      return _regeneratorRuntime.wrap(function _callee643$(_context644) {
        while (1) {
          switch (_context644.prev = _context644.next) {
            case 0:
              if (!(l(!0), !r)) {
                _context644.next = 3;
                break;
              }

              X.error(c), l(!1);
              return _context644.abrupt("return");

            case 3:
              _context644.prev = 3;
              _context644.next = 6;
              return E.moderateUser(t, r);

            case 6:
              X.success(d);
              n();
              _context644.next = 13;
              break;

            case 10:
              _context644.prev = 10;
              _context644.t0 = _context644["catch"](3);
              console.error(_context644.t0), X.error(h);

            case 13:
              l(!1);

            case 14:
            case "end":
              return _context644.stop();
          }
        }
      }, _callee643, null, [[3, 10]]);
    }));
  };

  return i ?
  /* @__PURE__ */
  _(No, {
    wrapperId: "moderate-user-modal",
    children:
    /* @__PURE__ */
    j(Ne, {
      children: [
      /* @__PURE__ */
      _("div", {
        className: "dw-justify-center dw-items-center dw-flex dw-overflow-x-hidden dw-overflow-y-hidden dw-absolute dw-inset-0 dw-z-50 dw-top-0 dw-right-0 dw-bottom-0 dw-left-0 dw-outline-none focus:dw-outline-none",
        children:
        /* @__PURE__ */
        _("div", {
          className: "dw-relative dw-w-full dw-my-6 dw-mx-auto dw-max-w-lg",
          children:
          /* @__PURE__ */
          j("div", {
            className: "dw-border-0 dw-rounded-lg dw-shadow-lg dw-relative dw-flex dw-flex-col dw-w-full dw-bg-white dw-outline-none focus:dw-outline-none",
            children: [
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-justify-items-center dw-p-4 dw-border-b dw-border-solid dw-border-gray-200",
              children: [
              /* @__PURE__ */
              j("h3", {
                className: "dw-text-2xl dw-font-semibold dw-mr-2",
                children: [f, " ", e]
              }),
              /* @__PURE__ */
              _("button", {
                className: "dw-flex dw-justify-items-center dw-ml-auto dw-bg-transparent dw-border-0 dw-leading-none dw-font-semibold dw-outline-none focus:dw-outline-none",
                onClick: n,
                children:
                /* @__PURE__ */
                _("span", {
                  className: "dw-bg-transparent dw-h-6 dw-w-6 dw-text-2xl dw-block dw-outline-none focus:dw-outline-none dw-text-red-500 hover:dw-text-red-600",
                  children: "x"
                })
              })]
            }),
            /* @__PURE__ */
            j("div", {
              className: "dw-relative dw-whitespace-nowrap dw-p-4 dw-text-gray-500 dw-text-lg dw-mb-4",
              children: [
              /* @__PURE__ */
              _("p", {
                className: "dw-whitespace-normal dw-mb-2",
                children: p
              }),
              /* @__PURE__ */
              _("p", {
                className: "dw-mb-2",
                children: g
              }),
              /* @__PURE__ */
              _("textarea", {
                rows: 8,
                className: "dw-rounded dw-border dw-border-gray-200 focus:dw-outline-none dw-px-3 dw-py-2 dw-w-full",
                onChange: b
              })]
            }),
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-items-center dw-justify-end dw-p-3 dw-border-t dw-border-solid dw-border-gray-200 dw-rounded-b",
              children: [
              /* @__PURE__ */
              j("button", {
                className: "".concat(o ? "dw-bg-gray-600" : "dw-bg-brandColor hover:dw-bg-blue-700", " dw-text-white dw-font-bold dw-px-4 dw-py-2 dw-text-sm dw-rounded dw-outline-none focus:dw-outline-none dw-mr-2 dw-mb-1 dw-ease-linear dw-transition-all dw-duration-150"),
                onClick: C,
                disabled: o,
                children: [o ?
                /* @__PURE__ */
                _(bs, {}) : null, f]
              }),
              /* @__PURE__ */
              _("button", {
                className: "".concat(o ? "dw-bg-gray-600" : "dw-bg-red-500 hover:dw-bg-red-700", " dw-text-white dw-font-bold dw-text-sm dw-px-4 dw-py-2 dw-rounded dw-outline-none focus:dw-outline-none dw-mr-2 dw-mb-1 dw-ease-linear dw-transition-all dw-duration-150"),
                onClick: n,
                disabled: o,
                children: v
              })]
            })]
          })
        })
      }),
      /* @__PURE__ */
      _("div", {
        className: "dw-opacity-80 dw-absolute dw-inset-0 dw-z-40 dw-bg-black dw-top-0 dw-right-0 dw-bottom-0 dw-left-0"
      })]
    })
  }) : null;
};

var wA = function wA() {
  _classCallCheck(this, wA);

  s(this, "banned_period_in_days", 0);
  s(this, "banned_reason", "");
};

var bA = function bA(t) {
  var e = /^[0-9]+$/;
  t = t || window.event;
  var i = 8,
      n = typeof t.which == "undefined" ? t.keyCode : t.which,
      a = !String.fromCharCode(n).match(e);
  n !== i && a && t.preventDefault();
},
    IA = function IA(_ref100) {
  var t = _ref100.profileId,
      e = _ref100.profileName,
      i = _ref100.isOpen,
      n = _ref100.handleClose;

  var _K43 = K(new wA()),
      _K44 = _slicedToArray(_K43, 2),
      r = _K44[0],
      a = _K44[1],
      _K45 = K(!1),
      _K46 = _slicedToArray(_K45, 2),
      o = _K46[0],
      l = _K46[1],
      _K47 = K(!1),
      _K48 = _slicedToArray(_K47, 2),
      c = _K48[0],
      d = _K48[1],
      _de16 = de(Ie),
      h = _de16.ban,
      p = _de16.cancel,
      g = _de16.banPeriodLabel,
      f = _de16.banReasonLabel,
      v = _de16.validationBanProfileErrorMessage,
      E = _de16.banProfileMessage,
      y = _de16.banProfileErrorMessage,
      b = _de16.day,
      C = _de16.days,
      R = _de16.indefinite,
      M = _de16.customPeriod,
      _de17 = de(Pt),
      F = _de17.https;

  Oi(function () {
    return i && document.body.addEventListener("keydown", m), function () {
      document.body.removeEventListener("keydown", m);
    };
  }, [n]);

  var m = function m(A) {
    return A.key === "Escape" && !o ? n() : null;
  },
      I = function I(A) {
    A.persist();
    var G = Number(A.target.value);
    G !== 0 ? (d(!1), w(G)) : d(!0);
  },
      w = function w(A) {
    a(function (G) {
      return $(O({}, G), {
        banned_period_in_days: A
      });
    });
  },
      P = function P(A) {
    a(function (G) {
      return $(O({}, G), {
        banned_reason: A.target.value
      });
    });
  },
      k = function k() {
    return u(void 0, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee644() {
      return _regeneratorRuntime.wrap(function _callee644$(_context645) {
        while (1) {
          switch (_context645.prev = _context645.next) {
            case 0:
              if (!(l(!0), !r.banned_period_in_days || !r.banned_reason)) {
                _context645.next = 3;
                break;
              }

              X.error(v), l(!1);
              return _context645.abrupt("return");

            case 3:
              _context645.prev = 3;
              _context645.next = 6;
              return F.banUser(t, r);

            case 6:
              X.success(E);
              n();
              _context645.next = 13;
              break;

            case 10:
              _context645.prev = 10;
              _context645.t0 = _context645["catch"](3);
              console.error(_context645.t0), X.error(y);

            case 13:
              l(!1);

            case 14:
            case "end":
              return _context645.stop();
          }
        }
      }, _callee644, null, [[3, 10]]);
    }));
  };

  return i ?
  /* @__PURE__ */
  _(No, {
    wrapperId: "ban-user-modal",
    children:
    /* @__PURE__ */
    j(Ne, {
      children: [
      /* @__PURE__ */
      _("div", {
        className: "dw-justify-center dw-items-center dw-flex dw-overflow-x-hidden dw-overflow-y-hidden dw-absolute dw-inset-0 dw-z-50 dw-top-0 dw-right-0 dw-bottom-0 dw-left-0 dw-outline-none focus:dw-outline-none",
        children:
        /* @__PURE__ */
        _("div", {
          className: "dw-relative dw-w-full dw-my-6 dw-mx-auto dw-max-w-xl",
          children:
          /* @__PURE__ */
          j("div", {
            className: "dw-border-0 dw-rounded-lg dw-shadow-lg dw-relative dw-flex dw-flex-col dw-w-full dw-bg-white dw-outline-none focus:dw-outline-none",
            children: [
            /* @__PURE__ */
            j("div", {
              className: "dw-flex dw-justify-items-center dw-p-4 dw-border-b dw-border-solid dw-border-gray-200 dw-rounded",
              children: [
              /* @__PURE__ */
              j("h3", {
                className: "dw-text-2xl dw-font-semibold dw-mr-2",
                children: [h, " ", e]
              }),
              /* @__PURE__ */
              _("button", {
                className: "dw-flex dw-justify-items-center dw-ml-auto dw-bg-transparent dw-border-0 dw-leading-none dw-font-semibold dw-outline-none focus:dw-outline-none",
                children:
                /* @__PURE__ */
                _("span", {
                  className: "dw-bg-transparent dw-h-6 dw-w-6 dw-text-2xl dw-block dw-outline-none focus:dw-outline-none dw-text-red-500 hover:dw-text-red-600",
                  onClick: n,
                  children: "x"
                })
              })]
            }),
            /* @__PURE__ */
            j("div", {
              className: "dw-relative dw-p-4 dw-text-gray-500 dw-text-lg dw-mb-4",
              children: [
              /* @__PURE__ */
              _("p", {
                className: "dw-leading-relaxed dw-mb-2",
                children: g
              }),
              /* @__PURE__ */
              j("select", {
                className: "dw-rounded dw-border dw-border-gray-200 dw-w-full focus:dw-outline-none dw-px-3 dw-py-2 dw-mb-2",
                onChange: I,
                children: [
                /* @__PURE__ */
                j("option", {
                  value: "1",
                  children: ["1 ", b]
                }),
                /* @__PURE__ */
                j("option", {
                  value: "7",
                  children: ["7 ", C]
                }),
                /* @__PURE__ */
                j("option", {
                  value: "14",
                  children: ["14 ", C]
                }),
                /* @__PURE__ */
                j("option", {
                  value: "30",
                  children: ["30 ", C]
                }),
                /* @__PURE__ */
                _("option", {
                  value: "-1",
                  children: R
                }),
                /* @__PURE__ */
                _("option", {
                  value: "0",
                  children: M
                })]
              }), c ?
              /* @__PURE__ */
              j(Ne, {
                children: [
                /* @__PURE__ */
                _("p", {
                  className: "dw-leading-relaxed dw-mb-2",
                  children: M
                }),
                /* @__PURE__ */
                _("input", {
                  type: "number",
                  className: "dw-border dw-border-gray-200 dw-rounded dw-w-full focus:dw-outline-none dw-px-3 dw-py-2 dw-mb-2",
                  onKeyDown: bA,
                  onChange: function onChange(A) {
                    return w(Number(A.target.value));
                  }
                })]
              }) :
              /* @__PURE__ */
              _(Ne, {}),
              /* @__PURE__ */
              _("p", {
                className: "dw-leading-relaxed dw-mb-2",
                children: f
              }),
              /* @__PURE__ */
              _("input", {
                type: "text",
                className: "dw-rounded dw-border dw-border-gray-200 dw-w-full focus:dw-outline-none dw-px-3 dw-py-2 dw-mb-2",
                onChange: P
              })]
            }),
            /* @__PURE__ */
            _("div", {
              className: "dw-flex dw-items-center dw-justify-end dw-p-3 dw-border-t dw-border-solid dw-border-gray-200 dw-rounded-b",
              children:
              /* @__PURE__ */
              j(Ne, {
                children: [
                /* @__PURE__ */
                j("button", {
                  className: "".concat(o ? "dw-bg-gray-600" : "dw-bg-brandColor hover:dw-bg-blue-700", " dw-text-white dw-font-bold dw-px-4 dw-py-2 dw-text-sm dw-rounded dw-outline-none focus:dw-outline-none dw-mr-2 dw-mb-1 dw-ease-linear dw-transition-all dw-duration-150"),
                  onClick: k,
                  disabled: o,
                  children: [o ?
                  /* @__PURE__ */
                  _(bs, {}) : null, h]
                }),
                /* @__PURE__ */
                _("button", {
                  className: "".concat(o ? "dw-bg-gray-600" : "dw-bg-red-500 hover:dw-bg-red-700", " dw-text-white dw-font-bold dw-text-sm dw-px-4 dw-py-2 dw-rounded dw-outline-none focus:dw-outline-none dw-mr-2 dw-mb-1 dw-ease-linear dw-transition-all dw-duration-150"),
                  onClick: n,
                  disabled: o,
                  children: p
                })]
              })
            })]
          })
        })
      }),
      /* @__PURE__ */
      _("div", {
        className: "dw-opacity-80 dw-absolute dw-inset-0 dw-z-40 dw-bg-black dw-top-0 dw-right-0 dw-bottom-0 dw-left-0"
      })]
    })
  }) : null;
},
    Bc = "dw-border-t-0 dw-px-6 dw-align-middle dw-border-l-0 dw-border-r-0 dw-text-xs dw-whitespace-nowrap dw-p-4",
    _A = function _A(t) {
  if (t) try {
    var e = new URL(t);
    return e.protocol === "http:" || e.protocol === "https:";
  } catch (e) {
    return !1;
  }
  return !1;
},
    EA = function EA(_ref101) {
  var t = _ref101.profile;

  var _K49 = K({
    moderate: !1,
    ban: !1
  }),
      _K50 = _slicedToArray(_K49, 2),
      e = _K50[0],
      i = _K50[1],
      _de18 = de(Ie),
      n = _de18.moderate,
      r = _de18.ban,
      a = function a() {
    return i(function (l) {
      return $(O({}, l), {
        moderate: !e.moderate
      });
    });
  },
      o = function o() {
    return i(function (l) {
      return $(O({}, l), {
        ban: !e.ban
      });
    });
  };

  return (
    /* @__PURE__ */
    j(Ne, {
      children: [
      /* @__PURE__ */
      j("tr", {
        className: "dw-px-4 dw-border dw-border-b dw-border-gray-100",
        children: [
        /* @__PURE__ */
        j("th", {
          className: "".concat(Bc, " dw-text-left dw-flex dw-items-center"),
          children: [
          /* @__PURE__ */
          _("div", {
            className: "dw-bg-white dw-rounded-full dw-h-12 dw-w-12 dw-overflow-hidden dw-mr-2",
            children:
            /* @__PURE__ */
            _("img", {
              referrerPolicy: "no-referrer",
              src: _A(t.avatar) ? t.avatar : Er.avatar,
              alt: "User avatar",
              className: "dw-h-full dw-w-full dw-object-cover"
            })
          }),
          /* @__PURE__ */
          _("span", {
            className: "dw-font-semibold dw-text-lg",
            children: t.label
          })]
        }),
        /* @__PURE__ */
        _("td", {
          className: "".concat(Bc),
          children:
          /* @__PURE__ */
          j("div", {
            className: "dw-flex dw-justify-end dw-space-x-2",
            children: [
            /* @__PURE__ */
            _("button", {
              className: "dw-bg-brandColor hover:dw-bg-blue-700 dw-text-white dw-font-bold dw-py-2 dw-px-4 dw-rounded dw-ease-linear dw-transition-all dw-duration-150",
              onClick: a,
              children: n
            }),
            /* @__PURE__ */
            _("button", {
              className: "dw-bg-red-500 hover:dw-bg-red-700 dw-text-white dw-font-bold dw-py-2 dw-px-4 dw-rounded dw-ease-linear dw-transition-all dw-duration-150",
              onClick: function onClick() {
                return i({
                  moderate: e.moderate,
                  ban: !e.ban
                });
              },
              children: r
            })]
          })
        })]
      }),
      /* @__PURE__ */
      _(vA, {
        profileId: t.id,
        isOpen: e.moderate,
        handleClose: a,
        profileName: t.value
      }),
      /* @__PURE__ */
      _(IA, {
        profileId: t.id,
        isOpen: e.ban,
        handleClose: o,
        profileName: t.value
      })]
    })
  );
},
    Hc = "dw-px-6 dw-align-middle dw-border dw-border-solid dw-py-3 dw-text-xs dw-uppercase dw-border-l-0 dw-border-r-0 dw-whitespace-nowrap dw-font-semibold dw-text-left dw-bg-blueGray-50 dw-text-blueGray-500 dw-border-gray-100",
    CA = function CA() {
  var _K51 = K(null),
      _K52 = _slicedToArray(_K51, 2),
      t = _K52[0],
      e = _K52[1],
      _de19 = de(Ie),
      i = _de19.name;

  return (
    /* @__PURE__ */
    j(Ne, {
      children: [
      /* @__PURE__ */
      _(yA, {
        profileOption: t,
        setProfileOption: e
      }), t ?
      /* @__PURE__ */
      _("div", {
        className: "dw-block dw-w-full dw-overflow-x-auto",
        children:
        /* @__PURE__ */
        j("table", {
          className: "dw-items-center dw-w-full dw-bg-transparent dw-border-collapse",
          children: [
          /* @__PURE__ */
          _("thead", {
            children:
            /* @__PURE__ */
            j("tr", {
              children: [
              /* @__PURE__ */
              _("th", {
                className: Hc,
                children: i
              }),
              /* @__PURE__ */
              _("th", {
                className: Hc
              })]
            })
          }),
          /* @__PURE__ */
          _("tbody", {
            children:
            /* @__PURE__ */
            _(EA, {
              profile: t
            })
          })]
        })
      }) : null]
    })
  );
};

var SA = function SA() {
  _classCallCheck(this, SA);

  s(this, "reason", "");
  s(this, "words", []);
};

var xa = function xa() {
  _classCallCheck(this, xa);

  s(this, "moderate_links", !1);
  s(this, "links_whitelist", null);
  s(this, "moderator_profile_id", null);
  s(this, "dictionary", new SA());
};

var Vc = function Vc(t) {
  if (!t.automatic_moderation) return new xa();
  var e = new xa();
  return e.moderate_links = t.automatic_moderation.moderate_links, e.links_whitelist = t.automatic_moderation.links_whitelist, e.moderator_profile_id = t.automatic_moderation.moderator_profile_id, e.dictionary.reason = t.automatic_moderation.dictionary.reason, e.dictionary.words = t.automatic_moderation.dictionary.words, e;
},
    jc = function jc(t) {
  return t.split(/\n+/).map(function (e) {
    return e.trim();
  }).filter(function (e) {
    return e;
  });
},
    Wc = function Wc(t) {
  return t ? t.join("\n") : "";
},
    Gc = function Gc(_ref102) {
  var t = _ref102.data;

  var _K53 = K(Vc(t)),
      _K54 = _slicedToArray(_K53, 2),
      e = _K54[0],
      i = _K54[1],
      _K55 = K(Vc(t).dictionary),
      _K56 = _slicedToArray(_K55, 2),
      n = _K56[0],
      r = _K56[1],
      _K57 = K(!1),
      _K58 = _slicedToArray(_K57, 2),
      a = _K58[0],
      o = _K58[1],
      _de20 = de(Ie),
      l = _de20.moderateLinks,
      c = _de20.linksWhitelistDescription,
      d = _de20.moderatorId,
      h = _de20.moderatorIdDescription,
      p = _de20.forbiddenWordsDescription,
      g = _de20.moderationReason,
      f = _de20.save,
      v = _de20.savingStaffIdErrorMessage,
      E = _de20.updateDiscussionsFeatureMessage,
      y = _de20.updateDiscussionsFeatureErrorMessage,
      _de21 = de(Pt),
      b = _de21.https,
      C = n.reason && n.words.length > 0,
      R = function R(P) {
    P.persist(), i(function (k) {
      return $(O({}, k), {
        moderate_links: !k.moderate_links
      });
    });
  },
      M = function M(P) {
    P.persist(), i(function (k) {
      return $(O({}, k), {
        links_whitelist: jc(P.target.value)
      });
    });
  },
      F = function F(P) {
    P.persist(), i(function (k) {
      return $(O({}, k), {
        moderator_profile_id: P.target.value
      });
    });
  },
      m = function m(P) {
    P.persist(), r(function (k) {
      return $(O({}, k), {
        reason: P.target.value
      });
    });
  },
      I = function I(P) {
    P.persist(), r(function (k) {
      return $(O({}, k), {
        words: jc(P.target.value)
      });
    });
  },
      w = function w() {
    return u(void 0, null,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee645() {
      var P, k;
      return _regeneratorRuntime.wrap(function _callee645$(_context646) {
        while (1) {
          switch (_context646.prev = _context646.next) {
            case 0:
              if (e.moderator_profile_id) {
                _context646.next = 18;
                break;
              }

              _context646.prev = 1;
              _context646.next = 4;
              return hi();

            case 4:
              P = _context646.sent;
              k = rT(P);

              if (!k.user_id) {
                _context646.next = 10;
                break;
              }

              e.moderator_profile_id = k.user_id;
              _context646.next = 12;
              break;

            case 10:
              X.error(v);
              return _context646.abrupt("return");

            case 12:
              _context646.next = 18;
              break;

            case 14:
              _context646.prev = 14;
              _context646.t0 = _context646["catch"](1);
              console.error(_context646.t0), X.error(v);
              return _context646.abrupt("return");

            case 18:
              o(!0);
              _context646.prev = 19;
              e.dictionary = O({}, n);
              _context646.next = 23;
              return b.updateDiscussionsFeature({
                automatic_moderation: e
              });

            case 23:
              X.success(E);
              _context646.next = 29;
              break;

            case 26:
              _context646.prev = 26;
              _context646.t1 = _context646["catch"](19);
              console.error(_context646.t1), X.error(y);

            case 29:
              o(!1);

            case 30:
            case "end":
              return _context646.stop();
          }
        }
      }, _callee645, null, [[1, 14], [19, 26]]);
    }));
  };

  return (
    /* @__PURE__ */
    j("div", {
      className: "dw-mb-6",
      children: [
      /* @__PURE__ */
      j("div", {
        className: "dw-border dw-border-gray-100 dw-p-4 dw-rounded dw-mb-6",
        children: [
        /* @__PURE__ */
        j("button", {
          className: "dw-bg-transparent dw-flex dw-items-center dw-cursor-pointer",
          onClick: R,
          children: [
          /* @__PURE__ */
          _("input", {
            type: "checkbox",
            className: "dw-cursor-pointer dw-mr-1",
            checked: e.moderate_links,
            readOnly: !0
          }),
          /* @__PURE__ */
          _("span", {
            children: l
          })]
        }),
        /* @__PURE__ */
        _("p", {
          className: "dw-text-xs dw-text-gray-600 dw-mb-4",
          children: "When enabled, all links will be replaced with 'https://***'"
        }),
        /* @__PURE__ */
        _("p", {
          className: "dw-mb-2 dw-font-bold",
          children: "Allowed URLs:"
        }),
        /* @__PURE__ */
        _("textarea", {
          rows: 8,
          onChange: M,
          className: "dw-border dw-border-gray-200 dw-rounded dw-w-full focus:dw-outline-none dw-p-2",
          defaultValue: Wc(e.links_whitelist)
        }),
        /* @__PURE__ */
        _("p", {
          className: "dw-text-xs dw-text-gray-600",
          children: c
        })]
      }),
      /* @__PURE__ */
      j("div", {
        className: "dw-border dw-border-gray-100 dw-p-4 dw-rounded dw-mb-6",
        children: [
        /* @__PURE__ */
        j("p", {
          className: "dw-mb-2 dw-font-bold",
          children: [d, ":"]
        }),
        /* @__PURE__ */
        _("input", {
          type: "text",
          className: "dw-rounded dw-border dw-border-gray-200 dw-w-full focus:dw-outline-none dw-px-3 dw-py-2 dw-mb-1",
          onChange: F,
          defaultValue: e.moderator_profile_id
        }),
        /* @__PURE__ */
        _("p", {
          className: "dw-mb-4 dw-text-xs dw-text-gray-600",
          children: h
        }),
        /* @__PURE__ */
        j("p", {
          className: "dw-mb-2 dw-font-bold",
          children: [g, ":"]
        }),
        /* @__PURE__ */
        _("input", {
          type: "text",
          className: "dw-rounded dw-border dw-border-gray-200 dw-w-full focus:dw-outline-none dw-px-3 dw-py-2 dw-mb-4",
          onChange: m,
          defaultValue: e.dictionary.reason
        }),
        /* @__PURE__ */
        _("p", {
          className: "dw-font-bold dw-mb-2",
          children: "Forbidden words:"
        }),
        /* @__PURE__ */
        _("textarea", {
          rows: 8,
          onChange: I,
          className: "dw-border dw-border-gray-200 dw-rounded dw-w-full focus:dw-outline-none dw-p-2",
          defaultValue: Wc(e.dictionary.words)
        }),
        /* @__PURE__ */
        _("p", {
          className: "dw-text-xs dw-text-gray-600",
          children: p
        })]
      }),
      /* @__PURE__ */
      j("button", {
        onClick: w,
        className: "".concat(C ? "dw-bg-brandColor hover:dw-bg-blue-700" : "dw-bg-gray-600", " dw-mr-2 dw-text-white dw-font-bold dw-py-2 dw-px-4 dw-rounded focus:dw-outline-none focus:dw-shadow-outline dw-select-none"),
        disabled: !C || a,
        children: [a ?
        /* @__PURE__ */
        _(bs, {}) : null, f]
      })]
    })
  );
};

var TA = function TA() {
  _classCallCheck(this, TA);

  s(this, "enabled", !1);
  s(this, "client_id", null);
  s(this, "automatic_moderation", new xa());
};

var RA = function RA() {
  var _de22 = de(Pt),
      t = _de22.https,
      _de23 = de(Ie),
      e = _de23.getDiscussionsFeatureErrorMessage,
      _Yp2 = Yp({
    queryKey: ["discussionsFeature"],
    queryFn: t.getDiscussionsFeature
  }),
      i = _Yp2.isLoading,
      n = _Yp2.isError,
      r = _Yp2.data,
      a = _Yp2.error;

  return n ? (console.error(a), X.error(e),
  /* @__PURE__ */
  _(Gc, {
    data: new TA()
  })) : i ?
  /* @__PURE__ */
  _(Kp, {}) :
  /* @__PURE__ */
  _(Gc, {
    data: r.data
  });
},
    PA = function PA(_ref103) {
  var t = _ref103.fansUnitedEnvironment;

  var e = Lt(md),
      _Lt4 = Lt(Ie),
      i = _Lt4.posts,
      n = _Lt4.users,
      r = _Lt4.dictionary,
      _K59 = K(i),
      _K60 = _slicedToArray(_K59, 2),
      a = _K60[0],
      o = _K60[1];

  return e ?
  /* @__PURE__ */
  j(ub, {
    children: [
    /* @__PURE__ */
    _(db, {
      tabValue: a,
      setTabValue: o
    }), a === i ?
    /* @__PURE__ */
    _(mA, {}) : null, a === n ?
    /* @__PURE__ */
    _(CA, {}) : null, a === r ?
    /* @__PURE__ */
    _(RA, {}) : null]
  }) :
  /* @__PURE__ */
  _(cb, {
    fansUnitedEnvironment: t
  });
},
    OA = new LO({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !1
    }
  }
}),
    kA = function kA(t) {
  var e = nT(t.fansUnitedApiKey, t.fansUnitedClientId, t.fansUnitedLanguage, t.fansUnitedEnvironment);
  return (
    /* @__PURE__ */
    _(Zt.StrictMode, {
      children:
      /* @__PURE__ */
      _(Xw, {
        fansUnitedEnvironment: t.fansUnitedEnvironment,
        children:
        /* @__PURE__ */
        _(lb, {
          labels: t.labels,
          children:
          /* @__PURE__ */
          _(VP, {
            config: e,
            children:
            /* @__PURE__ */
            j(XO, {
              client: OA,
              children: [
              /* @__PURE__ */
              _(ha, {
                position: "top-right",
                autoClose: 5e3,
                hideProgressBar: !1,
                limit: 3,
                newestOnTop: !1,
                closeOnClick: !0,
                rtl: !1,
                pauseOnFocusLoss: !1,
                draggable: !0,
                pauseOnHover: !0
              }),
              /* @__PURE__ */
              _(PA, {
                fansUnitedEnvironment: t.fansUnitedEnvironment
              })]
            })
          })
        })
      })
    })
  );
};

export { kA as DiscussionsManager };